
const MODAL_WIDTH = {
    XSMALL: 'ah-modal-xs',
    SMALL: 'ah-modal-sm',
    MEDIUM: 'ah-modal-md',
    SEMI_LARGE: 'ah-modal-sem-lg',
    LARGE_FIXED: 'ah-modal-lg-fixed',
    LARGE: 'ah-modal-lg'
};
var carePlanSelectedViewType = "";
var isToggled = false;
//1.CommonVariable.js
var preftimecallRowCount = 0;
var mycalendarExpandVar = 1;
var myOpenAuthorization = 1;
var requestReferTypeGlobal = "";
var requestModuleNameGlobal = "";
var isRequestSearch = false;
var patientForViewSummary = null;
var globalAlertFilter = "";
var globalAlertFilterText = "";
var globalRiskFilter = "";
var globalRiskFilterText = "";
var globalQIndSelSrsText = "";
var globalDiseaseFilter = "";
var globalDiseaseFilterText = "";
var globalQIndicatorFilterNum = "";
var globalQIndicatorFilterDNum = "";
var globalQIndicatorFilterTextNum = "";
var globalQIndicatorFilterDenom = "";
var globalQIndicatorFilterTextDenom = "";
var globalCaseLoadFilter = "";
var globalCaseLoadFilterText = "";
var calPatientId = 0;
var calAuthnum = 0;
var requestNavigation = 1;
var UMNavigation = 1;
var glMMFilOperPrgms = "", glMMFilOperOprts = "", glMMFilOperIndtrs = "";
var globalindcatros = "", globalprograms = "", globaloppertunities = "", globalIndicatorsText = "", globalprogramsText = "", globaloppertunitiesText = "";
var AlterCountResult = 0; var VarExternalAddressId = "";
var chkMaxMinHghtMyAlertsPartialViewContainer = 0;
var chkMaxMinHghtmyMemberPartialViewContainer = 0;
var chkMaxMinHghtReqRejPartialViewContainer = 0;
var chkMaxMinHghtMyCalenderPartialViewContainer = 0;
var AppoinmentIdVar = ""; var AppointmentDateVar = ""; var AppointmentNotesVar = "";
var VarCurrentRiskTypeId = ""; var VarInterventions = "";
var CareTeamHistoryId = ""; var CrTmHstryPatientPhysicianId = ""; var CrTmHstryPhysicianId = ""; var CrTmHstryProviderTypeId = ""; var CrTmHstryProviderType = "";
var ProgramType = ""; var ProgramOprType = "";
var MemberPlanPrintData = "";
var globalLOBList = "";
var CommonCarePlanId = "";
var Guidlines = ""; var VarAddressId = "";
var globalGuidlines = "";
var LOBTemplatePath = "";
var globalServicePlanStatus = "";
var globalModifierData = "";
var globalServicePlanGrid = "";
var globalMemberIDSP = "";
var calComplaintnum = 0; //AGCODE
var scriptPerformActivityData = undefined;
var searchPatientId = '';
var globalTeamCPStatus = "";
var $addnewrow = "";
var golbalExrCrTmProvMulAdrsIncId = 1;
var $addMulAdrsDivExtCrTm = "";
var golbalExrCrTmMulAdrsIncId = 1;
//letters
var LOBTemplatePath = "";
var iswithoutheaderandfooter = "";
var MemberAccessedCheck = "";
var MsgsearchPatientId = 0;
var childctrlname = "";
//To maintain provider LOB configuration
var isProvider = false;
var ExtCrTmPid = "";
//functions used globally SP
var dataforcompleteactivity = "";
var VarPatientIdGlobal = "";
var CurrentPatientIdGlobal = false;
var VarPatientIdGlobalInADT = ""; var VarPHIsValid = false;
var timeZone = null;
var PHNavID = "";
var roleKey = 0;
var ExtOpptTextAreaNotes = "";
var EventBasedTextAreaNotes = "";
var PhoneandFaxformat = /^\d{3}-\d{3}-\d{4}$/;///^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;  UHG-1629
var VarQMClientID = "";
var VarQualityMeasureGroupID = "";
var VarQMCaseLoadID = "";
var VarVersion = "";
var isRefresh = false;
var careStaffViewSensitive = false;
var receiveCareTransitionNotification = false;
var receiveMailNotification = false;
var primarymailid = "";
var currentDateByTimeZone = null;
var MIChildTabName = ""; var HLChildTabName = ""; var CPChildTabName = ""; var ACTChildTabName = ""; var AUTHChildTabName = ""; var COMPChildTabName = ""; var MTMChildTabName = "";
var IsAddressPrimary = false;
//functions used globally SP
var ScriptName = "";
//For Select All checkbox
var globalChkBoxLength = "";
//QM-271
var dataSearchString = "";
var selectedIncentive = "-1";
var selectedmeasureGroupId = "-1";
var selectedVersion;
//var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/; //Kaseempeera // We replaced this line with below code because this regex accepts onnly "00/00/0000" format 
var date_regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/    // but this accepts both "0/0/0000" and "00/00/0000"
var ISPHMembers = false;
var MyCareMemberDefaultfilter = true;
var isFilterApplied = false;
var profileVal = "";
var PhoneNumberBefore = "";
var varFileUpload = "";
var showCareStaffCal = false;
var dataPHDBSearchString = "";
var IsMemberPage = '';
var DetaultSearchObj = "";
var MyMemDefault = "";
var IsActivityOutcomeMandatory = "";
var IsActualDurationMandatory = "";
/*PROD-162*/
var WorkZipExp = /^((\d{5}\-\d{4})|(\d{5})|(\d{9}))$/;
/*PROD-162*/
function Unveil() { loader(0); }
var ActionView = true;
var ViewAuthSummRefreshFlag = false;
var defaultValidationDashBoard = 'Please select at least one Search Parameter to view the values in Dashboard.';
var defaultValidation = 'Select at least one Search Parameter to view member(s).';
var customValidation = 'No records found.';
// Flags to check the one time load dropdowns in PH START
// These Flages are used to know that dropdown is already loaded or not. If, dropdown is loaded we will not load it again
var isMyMembersLoaded = false;
var isReuestsLoaded = false;
var isServiceLocationLoaded = false;
var isLOBLoaded = false;
var isRiskLoaded = false;
var isProgramLoaded = false;
var isAgAccessed = false;
var isUmAccessed = false;
var isSpAccessed = false;
var isFromUmScriptActivity = false;
var isFromAgScriptActivity = false;
var lockedAGInterval = null;
var tempAGInterval = null;
var lockedUMInterval = null;
var tempUMInterval = null;
var lockedSPInterval = null;
var tempSPInterval = null;
var MemberPopDB = "";
// Flags to check the one time load dropdowns in PH END
var FilterType = '';
var isFromQMBackButton = false; // regarding the back button to QMP from QM
var isFromADTBackButton = false;//for back button to Caretransition from ADT
var NextContactReplaceProgramId = "";
var globalCplCategory = "";
//for Health Notes Care Plan details get
var NotesIdforViewHealthNotes = "";
var cplNotesGroupId = null;
var assignOwnercareStaffFullNameWithRole = "";
var assignOwnermemberidval = "";
var isGenderLoaded = false;
var isRaceLoaded = false;
var isMAL = false;
var reqRecAndRejMAL = false;

var showSSN = false;
var showAttributeDate = false;
var isViewActiveOnlyMembers = false;
var ActiveInactiveMemberFilter = 2;
var tdMALBulkActionsRR = '';
var divMALContextMenusRR = '';
var requestReferTypeMALGlobal = '';
var requestModuleNameMALGlobal = "";
var hasAccessForMemberService = "";
var selectedGraphVal = '';
var SignOffPercentageObjectList = [];
var arrIndexIds = [];
var indicatorView = "";
var isEndDateMandatory = false;
var isQualityMeasureBulkAction = false; //For checking the action performed from popup (In progress  measure list).
var arrSignature = [];
var PHModuleId = 0;
var IsSlevel1 = false;
var isLoadDynamicColumns = true;
var reconciledNotNeededVal = "not needed";//constant value to check for editable condition in Reconciliation config tab
var MTMPopDB = "";
var isFromViewSummaryCBD = false;
var arrNotRegistredIds = [];
var selectedRCPAck = '';//used for when selects careplan review popup it holds patientid and patient followupid
var CPRPatients = [];
var isFromMySchedule = false;
var phDashboardMTMType = 0;
var authAccess = false;
var complaintAccess = false;
var servicePlanAccess = false;
var autoMCG = false;
var PHAuthType = "";
var IPSelectedConfigColumns = "";
var ADTSelectedConfigColumns = "";
var SelectedOppDetailIds = [];
var SelectedCareOppEventMeasureId = 0;
var SelectedQualityActionStatusId = 0;
var SelectedQualityMeasureStatusId = 0;
//Aunt Bertha related Variables.
var arrCategory = [];
var arrProgram = [];
var arrSubProgram = [];
var closedActivitySelected = [];
var closedActivitySelectedText = [];
var isADTOptionAvilable = true;
var isIPOptionAvilable = true;
var IsFromAppointment = false;
var IsAuntBerthaReferral = false;
var isPlanLoaded = false;
var actionTypeEnum = {
    FileExport: 'FileExport',
    Print: 'Print',
    Email: 'Email',
    Download: 'Download',
    SaveAndPrint: 'SaveAndPrint'
};
var GuidelineTypesEnum = {
    MCG: '1',
    Interqual: '2'

};
var AdvanceSearchTypeEnum = {
    MemberSearch: '1',
    ProviderSearch: '2',
    PayorSearch: '3'
};
var CareGiverTypeEnum = {
    Informal: 'Informal',
    Formal: 'Formal',
    FormalAndSupport: 'Formal Caregiver & Natural Support'
};
var isMiles = false;
var tempAuthID = null;
var addnewActivity = ""; var addRowReqAct = 1;
var ScrollPosition = 0;
var IsConfirm = false;
var isCountClicked = false;
var isNavigateToUnReadMessages = false;
var isNavigateToUnReadFaxes = false;
var selectedFaxModuleName = "";
var acknowledgedAlertIds = [];
var isFromPHTile = false;
var assessmentProviderReviewId = 0;
var careActivityTypeId = 0;
var timeZoneVal = null;
var placeHolderControlTypes = ['ddlAuthTemplatePlan', 'ddlAPAuthType', 'ddlAPLobs', 'ddlAPPlans'];
var systemTimeZone = null;
var isRedirectToAuthActivity = 0;
var isFromCompleteandaddActivity = false;
var ExternalProviderActivityId = "";
var isPHBulkActivity = false;
var isPHSensitiveMember = false;
var AGCusFields = [];
var PHautoMCG = false;
var GlobalPacketIds = [];
var isCallintiated = false;
var zoomvar = $(document.body).css('zoom');
//Flag to display alert in agpacket selection or summary page
var isAgPacketAlertDisplay = false;
var prevmemval, prevauthval, prevpenval, prevalertval, prevreqrecval, prevreqrejval;
//End

var jsGuid = '';
/*PROD-162*/
var IconsCount = 0;
var IconsIds = '';
var multiSelectctrlId = "";
var isRedirectToComplaintActivity = 0;
var isUmAutoDraftAlertDisplay = false;
var AgComplaintLogFilterSearchString = "";
var filterJsonparams = "";
var complaintFilterJson = "";
var AgComplaintLogFilterGlobal = {};
var agPacketNavigateAway = { Selectionpage: null, Summarypage: null };

var meetingWindow = null;
var meetingWindowTimer = null;
var pfIdForMeetingWindow = null;
var meetingGuid = "";
var btnMVRunMouseOverId = "";
var btnMVRunMouseOverTable = "";
var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var myCalendarMemberName = "";
//PROD-88723
var isMeetingGenerated = false;
var joinURL = "";
var selectedMemberIdForActivityAddEdit = "";
var meetingValidationMsg = "";
var isEditTeleHealthActivity = false;
var isRedirectToDecision = {};
//End
var showFaxMsg = false;
//PROD-35989
var isFromSmartCOMMAddLetter = false;
var letterModuleName = "";
//GCPROD-9788
var eodTimeMismatchMsg = 'Time provided for end of day time needs to be in 24 hour format.';
var eodTimeRegEx = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
//END
var memberAgeBP = "";
var pcpPhysicianIdBP = 0;
var memberGenderBP = "";
var eligibilityHierarchyBP = "";
var clientPatientIdBP = "";
var configuredTelehealthContactType = "";
var intialAltGridHeight = "";
var intialReqGridHeight = "";
var MyMembersGrids = ['MyMembersGridNew', 'OpenAuthorization', 'OpenComplaints', 'PendingActivityGrid', 'PendingComplaintActivities'];
var MyAlertsAndRiskGrids = ['DiseasechartNew', 'QualityIndicatorNew', 'RiskProfilechartNew', 'AlertsGridNew'];
var memberAgeYrs = 0;
var isFromEPSDTBack = false;
var epsdtActionFrom = '';
var isEpsdtTile = false;
var epsdtDataString = "";
var isEpsdtFilterApplied = false;
var isEpsdtSaveFilterApplied = false;
var isEpsdtDescriptionOnlySelected = false;
var isPhEpsdtDrillDownFilterReset = false;
var selectedSaveFilterValue = "";
var epsdtPanelDataString = "";
var epsdtPayorAndStatus = "";
var clearEpsdtPopDbDescription = false;
var populateEpsdtFilters = false;
var isClearFilterFromLeftPanel = false;
var dashBoardEpsdtSelectedTypeId = '1';
var reloadDesc = false;
var isFromDashBoardPopulationOnly = false;
const timeInterval30 = 30;
const timeInterval10 = 10;
var eligibilityPopups = ['popUpDialog1', 'popUpDialog2', 'popUpDialog3', 'popUpDialog4', 'popUpDialog5', 'popUpDialog6', 'Grid_PatientEligibility', 'divViewMemberEligibilityInfoGrid', 'divEligibilityData', 'divEligibilityselection', 'Grid_AuthPatientEligibility'];
var eligibilityNetworkPopups = ['popUpDialog1', 'popUpDialog2', 'popUpDialog3', 'popUpDialog4', 'popUpDialog5', 'popUpDialog6'];
var providerNetworkMaxCount = 25;
var memberNetworkMaxCount = 50;
var benefitCheckNavID = "";
var selectedProvObj = "";
var pHAccessedPatientId = "";
var isFieldRemoved = false;
//CommunityReferral
var sdohTypeValues =
{
    Auntbertha: 'AUNTBERTHA',
    Healthify: 'HEALTHIFY',
    UniteUs: 'UNITEUS'
};
var isLoadWellframeAlerts = false;
var clientPatientIdFromWellframe = "";
var isMDReviewCalendar = false;
var IsFromAdditionalInfoReq = false;
var calendarUmMDRActivityLogId = 0;
var isPerformMDRActivity = 0;
var blacklistedExtensions = ".exe|.jsp |.php |.php5 |.pht |.phtml |.shtml |.asa |.cer |.asax |.swf |.xap |.asp |.py |.lua |.ps1 |.dll |.ascx |.aspx ";
var phAdditionalSearchParamSelected = '';
var exportSectionKeys = ["My Members", "Quality Measures", "ADT or IP"];
var currentExportSection = null;
var moduleTypeCm = "CM";
var noteConfidentialTypeId = 0;
var internalUserNoteConfidentialTypeId = 0;
var noteInProviderUser = "";
var preAuthPatientDob = "";
var actSummarySavedSearchFilters = '{}'
var activitySummarySectionName = 'ACTIVITY SUMMARY';
var actSummarySearchFilterId = 0;
var activitySummarySavedFiltersCacheKey = 'ACTIVITY_SUMMARY_FILTERS';
var faxReceivedDate;

var faxSearchFlag = false;
var sourceTrackingNumber = null;
var preAuthProviderDisplayName = "";
var DocumentColumnName = (isDocumentUrlConfigured === 'True') ? "Document Name/URL" : "Document Name";

var memberSumClientSuffix = "";
var memberAdditionalDetails = "";

var OcrJsonToFaxSearchMapping = [
    { field: "AuthId", value: "AUTH_ID" },
    { field: "ComplaintId", value: "COMPLAINT_ID" },
    { field: "MemberIdString", value: "Member ID" },
    { field: "AltruistaId", value: "CLIENT_PATIENT_ID" },
    { field: "MedicaidNumber", value: "MEDICAID_NO" },
    { field: "MedicareNumber", value: "MEDICARE_NO" },
    { field: "CarrierMemberId", value: "CARRIER MEMBER ID" },
    { field: "FamilyLinkId", value: "FAMILY_LINK_ID" },
    { field: "MedicaidSubscriberId", value: "Medicaid Subscriber ID" },
    { field: "SubscriberSSN", value: "SUBSCRIBER_SSN" }
];

$(document).ajaxSend(function (_ev, xhr, _settings) {
    var tokens = document.getElementsByName("__RequestVerificationToken");
    if (tokens.length > 0) {
        xhr.setRequestHeader('__RequestVerificationToken', tokens[0].value);
    }
});
function clearPreAuthCache(trackingNumber) {
    try {
        var trackingNo = trackingNumber || sourceTrackingNumber;
        if (typeof trackingNo !== "undefined" && trackingNo) {
            cacheData({ key: "PreAuthJsonData_" + trackingNo, value: null, maxage: -1 }, true);

            // Only clear global sourceTrackingNumber if we're clearing it
            if (!trackingNumber || trackingNumber === sourceTrackingNumber) {
                sourceTrackingNumber = "";
            }

            // Clear provider display name mapping
            if (typeof preAuthProviderDisplayName !== "undefined") {
                preAuthProviderDisplayName = "";
            }
        }
    } catch (e) {
        if (window.console && console.log) {
            console.log("clearPreAuthCache error:", e);
        }
    }
}

const VIEW_MODE = { NONE: 'NONE', DETAILS_VIEW: 'DETAILS_VIEW', LIST_VIEW: 'LIST_VIEW' };//LOOK_UP_VALUES:ENUMS
function ActiveInactiveEnrolledParam() {
    var ActiveInactiveParam = '';
    if (PHNavID == 1 || isProviderUser)
        ActiveInactiveParam = $("#selectActiveInactiveMember").val();
    else
        ActiveInactiveParam = isViewActiveOnlyMembers == "True" ? 1 : $('#selectActiveInactiveCMMem').val()
    return ActiveInactiveParam;
}

function CareStaffSelectPopupPHBulk() {
    $('#divPHBulkCareStaffSelect').CMNPopup({
        popUpHeader: "Assign Care Staff",
        closeButton: '#btnPABulkReferCancel',
        onClose: function () {
            A11yForms.clearFormFieldValidation();
            $("#ddlCareStaffPHBulk").val('');
            $("#hdnPABulkReferTo").val('');
            $("#hdnstaffIdBulkPH").val('');
            $("#hdnChkBulkPatientIds").val('');
            $("#txtCMPHBulkAssignNotes").val('');
            $("#chkIsActTransferACPhBulk").prop('checked', false);
            $("#rdIsSecondaryCareStaffBulk").prop('checked', false);
        },
        popLevel: 0,
        modalWidth: MODAL_WIDTH.SMALL
    });
}

function AjaxAssignMemberToCareStaffSync(dataInput) {
    var result = null;
    var AUrl = baseURL + "/AssignCareStaff/AssignMemberToCareStaff";

    $.ajax({
        type: "POST",
        url: AUrl,
        data: dataInput,
        dataType: "json",
        async: false,
        success: function (data) {
            result = data;
        },
        error: function (xhr, status, err) {
            // Return null to let callers handle a generic error path
            if (typeof DevUtils !== "undefined" && DevUtils.logError) {
                DevUtils.logError("AjaxAssignMemberToCareStaffSync failed", { status: status, error: err });
            }
            result = null;
        }
    });

    return result;
}
function ServiceInterruptionAndDeceasedCheck(patientIds) {
    var result = null;
    $.ajax({
        type: "GET",
        async: false, // must remain synchronous
        data: { patientIds: patientIds },
        url: baseURL + '/AssignCareStaff/ServiceInteruptionandDeceased',
        dataType: "json",
        success: function (data) {
            result = data;
        },
        error: function () {
            loader(0);
        }
    });
    return result;
}
function safeFind(selector, context) {
    try {
        return context ? $(document).find(context).find(selector) : $(document).find(selector);
    } catch (e) {
        return $();
    }
}
function AjaxCheckPrimaryCMExists(patientIds) {
    var result = null;
    $.ajax({
        type: "POST",
        url: baseURL + "/CareTeam/CheckPrimaryCMExists",
        data: { patientIds: patientIds },
        dataType: "json",
        async: false, // stay synchronous
        success: function (data) {
            result = data;
        },
        error: function () {
            loader(0);
        }
    });
    return result;
}
function bulkAssignCareStaffFn() {
    var lstPatientIds = $('#hdnChkBulkPatientIds').val();
    var data = ServiceInterruptionAndDeceasedCheck(lstPatientIds);
    if (data && data.success) {
        if (data.serviceInterruptionPatientsList.length == 0) {
            CareStaffSelectPopupPHBulk();
        } else {
            /* if yes showing the same details in popup */
            var serviceInteruptionPatientIds = $.map(data.serviceInterruptionPatientsList, function (ele) { return ele.PatientId }).join(',');
            $('#popUpDialog3').html('');
            $('#popUpDialog3').CMNPopup({
                data: { section: 'ASSIGNCARESTAFF_ASSIGN_PH_BULK', siPatientIds: serviceInteruptionPatientIds },
                pvUrl: baseURL + '/AssignCareStaff/BulkReferServiceInterruptionDetails',
                popUpHeader: "Care Member Details",
                onLoad: function () {
                    $('#divPHAssignCareStaffServInterMessage').show();
                    $('#divServiceInterruptionMsg').hide();
                    $('#BulkReferServiceInteruptionandDeceased').data('kendoGrid').hideColumn(0);
                },
                popLevel: 2,
                top: 30,
                closeButton: '#btnBulkReferSerIntCancel'
            });
        }
    }
}

function CheckPrimaryCMExistsPHBulk() {
    $("#hdnIsFromIAPCM").val('AC');
    var patientIds = $('#hdnChkBulkPatientIds').val();
    var data = AjaxCheckPrimaryCMExists(patientIds);
    if (data && data.isPCMExists && !$("#rdIsSecondaryCareStaffBulk").is(":checked")) {
        var popUphtml = '';
        popUphtml = $("#divInactCMConfACBulkPh").html();
        $("#popUpDialog1").html('').append(popUphtml);
        $('#popUpDialog1').CMNPopup({
            popUpHeader: "Confirmation",
            popLevel: 3,
            closeButton: "#btnInactCMConfCancelACBulkPh",
            modalWidth: MODAL_WIDTH.SMALL
        });
        if ($("#popUpDialog1").find('#unassignPCMToolTip').length > 0) {
            new A11yTooltipInstance('unassignPCMToolTip', 'unassign primary care manager tooltip', {
                tooltipText: '<div class="ItemMB5 TextLeft"><div class="bold">Yes:</div> Sets End Date to today and removes the Primary Care Manager from the member and the member\'s Care Team.</div><div class="ItemMB5 TextLeft"><div class="bold">No:</div> Removes the Primary Care Manager but keeps the care manager assigned to the member\'s Care Team and sets the End Date as N/A.</div><div class="ItemMB5 TextLeft"><div class="bold">Cancel:</div> No changes will be made. The current Primary Care Manager remains assigned.</div>',
                width: TOOLTIP_WIDTH.MEDIUM,
                pointerDirection: TOOLTIP_POINTER_DIRECTION.LEFT
            });
            // To avoid scrolling in the pop-up.
            $('#popUpDialog1').css({
                'overflow': 'visible',
                'max-height': 'none',
                'height': 'auto'
            });
        }
        loader(0);
    } else {
        AssignMemberToCareStaffPHBulk(true);
    }
}
function checkForMeetingValidation(isTrue) {
    isMeetingGenerated = isTrue;
}
function CallAtcmntNewWindow(evt) {
    var atmt = $(evt).next().val();
    if (atmt) {
        atmt = atmt.replace("\\\\G7APPQA\\G7_SambaShare\\\\COMMUNITYPORTAL\\\\", "");
        var ur = baseURL + atmt;
        var win = window.open(ur, (window.browserPopUpName || window.top.browserPopUpName));
        win.focus();
        var ext = atmt.substr((atmt.lastIndexOf('.') + 1));
        if ($('#lnkConsentFormsTab').hasClass('select')) {
            AuditLog(1, actionTypeEnum.Download, 'Consent Forms', $('#selectPatientAccessed').val(), memberidval, evt.text + '.' + ext);
        }
    }
    else { CustomAlert('Attachment Not Found.'); }
}
function downloadFileHandler(fileId, isAdvDirective, evt) {
    if ($(evt).attr('title') === "You do not have access to Export.") {
        return;
    }
    var _entityType = $(evt).data('entitytype');
    var _downloadAction = $(evt).data('downloadaction');
    var payload = {
        fileId: fileId,
        entityType: _entityType,
        isAdvDirective: isAdvDirective
    };
    SecureBrowserFileDownload.Download(baseURL, _downloadAction, payload);
}
function downloadDocumentFileHandler(fileId, isAdvDirective, evt) {
    if ($(evt).attr('title') === "You do not have access to Export.") {
        return;
    }
    var _entityType = $(evt).data('entitytype');
    var _downloadAction = $(evt).data('downloadaction');
    let _downloadActionUM = $(evt).data('downloadactionum');
    let _downloadActionAG = $(evt).data('downloadactionag');
    if (!$.fn.isNullOrEmpty(_downloadActionUM) && window.top.$(".InAuthPage").is(":visible")) {
        _downloadAction = _downloadActionUM
    }
    if (!$.fn.isNullOrEmpty(_downloadActionAG) && window.top.$(".InComplaintPage").is(":visible")) {
        _downloadAction = _downloadActionAG
    }
    var _patientId = $(evt).data('patientid');
    var payload = {
        fileId: fileId,
        entityType: _entityType,
        isAdvDirective: isAdvDirective,
        patientId: _patientId
    };
    SecureBrowserFileDownload.DownloadDocument(baseURL, _downloadAction, payload);
}
function downloadFileHandlerByToken(token, isDeleteFromPatientDoc, evt) {
    if ($(evt).attr('title') === "You do not have access to Export.") {
        return;
    }
    var _entityType = $(evt).data('entitytype');
    var _downloadAction = $(evt).data('downloadaction');
    let _downloadActionUM = $(evt).data('downloadactionum');
    let _downloadActionAG = $(evt).data('downloadactionag');
    if (!$.fn.isNullOrEmpty(_downloadActionUM) && window.top.$(".InAuthPage").is(":visible")) {
        _downloadAction = _downloadActionUM
    }
    if (!$.fn.isNullOrEmpty(_downloadActionAG) && window.top.$(".InComplaintPage").is(":visible")) {
        _downloadAction = _downloadActionAG
    }
    var payload = {
        entityType: _entityType,
        isDeleteFromPatientDoc: isDeleteFromPatientDoc
    };
    SecureBrowserFileDownload.DownloadFile(baseURL, payload, _downloadAction, token);
}
function CmnStatusMessageDisp(ctrlId, msg, msgType, module) {   // NOSONAR (unconventional function name, but there are too many usages to fix)
    DevUtils.logDebug('ctrlId[' + ctrlId + '], module[' + module + ']', 'GCHomeCommon.CmnStatusMessageDisp()');

    ctrlId = typeof ctrlId === 'string' ? ctrlId.replace('#', '') : $(ctrlId).attr('id');
    var keepOpen = ctrlId === "epsdtFiltermessage" ? true : false;
    DevUtils.logDebug('Making call to A11yAlerts with containerSelector[' + ctrlId + '], alertMessage[' + msg + '], alertType[' + msgType + ']', 'GCHomeCommon.CmnStatusMessageDisp()');

    switch (msgType) {
        case 'Success':
            A11yAlerts.createSuccessAlert('#' + ctrlId, msg, null, keepOpen);
            break;
        case 'Warning':
            A11yAlerts.createWarningAlert('#' + ctrlId, msg);
            break;
        default:
            A11yAlerts.createErrorAlert('#' + ctrlId, msg);
            break;
    }
    $('#' + ctrlId).show();
}

//service plan
var GlobalPatientId = "";
var GlobalPatientFirstName = "";
var GlobalPatientLastName = "";
var editServicePlanGridData = [];
var editServicePlanFieldsData = [];
var prevmemval, prevauthval, prevpenval, prevalertval, prevreqrecval, prevreqrejval;
//2.CMNPopup.js

function HideScroll() {
    ScrollPosition = $(window).scrollTop();
    $("body, html").animate({ scrollTop: 0 }, 'slow');
    $('body').css('overflow', 'hidden');
}

function ResetScroll() {
    if (ScrollPosition > 0)
        $("body, html").animate({ scrollTop: ScrollPosition }, 'fast');
    $('body').css('overflow', '');
    ScrollPosition = 0;
}

function resetOverlayScroll() {
    const overlayArr = Array.from(document.querySelectorAll(`[id^="lean_overlay_"]`)).filter(s => window.getComputedStyle(s).getPropertyValue('display') !== 'none');
    const maskArr = Array.from(document.querySelectorAll(`[id^="ModalPopupMask"]`)).filter(s => window.getComputedStyle(s).getPropertyValue('display') !== 'none');
    if (!$("#AuthProviderSearch").is(":visible") && (overlayArr.length === 0 && maskArr.length === 0)) {
        ResetScroll();
    }
}

function setDashboardGrids(Control, Expand) {
    var mainDivHeight = document.getElementById('mainTblForVisibleScreenSize').clientHeight;
    var mainHeaderHeight = document.getElementsByClassName('headerMin')[0].clientHeight;
    var mainTopMenuHeight = document.getElementsByClassName('topMenuBar')[0].clientHeight;
    var dashboardHeight = mainDivHeight - (mainHeaderHeight + mainTopMenuHeight + 60);
    let bufferHeight = 10;
    let mainFooterHeight = document.getElementsByClassName('mainFooter')[0].offsetHeight;

    $("#_PartialViewtableContainer").css("min-height", (dashboardHeight - 5) + "px");
    var cellHeightValue = dashboardHeight / 2;
    var isCollapse = false;
    $(".DbImgPopIn").each(function () { if ($(this).is(":visible")) return isCollapse = true; });
    if (typeof isFullDashBoard !== 'undefined' && !isFullDashBoard && ($.inArray(Control, MyMembersGrids) !== -1 || $.inArray(Control, MyAlertsAndRiskGrids) !== -1 || Control === "ReqRecGrid" || Control === "ReqRejGrid")) {
        isCollapse = true;
    }
    $(".cellHeight").css("height", cellHeightValue + "px");

    var gridFilterHeight = 0, headerHeight = 0, Height;

    if (Control == "ReqRecGrid" || Control == "ReqRejGrid") {
        gridFilterHeight = document.getElementById('gridFilterRequestWidget') ? document.getElementById('gridFilterRequestWidget').offsetHeight : 0;
        headerHeight = document.getElementById('requestsHeader') !== null ? document.getElementById('requestsHeader').offsetHeight : 0;
        Height = cellHeightValue - gridFilterHeight - 20;
        if ($("#_requestReceivedPartialViewContainer").hasClass("clsMyCalendarPartialViewContainerExapnd"))
            $('#' + Control).css("height", (dashboardHeight - 35) + "px");
        else
            $("#" + Control).css("height", Height + "px");
    } else if (Control === "PendingActivityGrid" || Control === "OpenComplaints" || Control === "PendingComplaintActivities") {
        Height = cellHeightValue - 35;
    } else if (Control === "MyMembersGridNew") {
        gridFilterHeight = document.getElementById('divFilterCntrls') ? document.getElementById('divFilterCntrls').offsetHeight : 0;
        if (document.getElementById('myMembersHeader')) {
            headerHeight = document.getElementById('myMembersHeader').offsetHeight;
        }
        Height = cellHeightValue - gridFilterHeight - 35;
        $('#' + Control).css("height", "");
    } else if (Control === "OpenAuthorization") {
        gridFilterHeight = document.getElementById('DivOpenAuthorization') ? document.getElementById('DivOpenAuthorization').offsetHeight : 0;
        if (document.getElementById('myMembersHeader')) {
            headerHeight = document.getElementById('myMembersHeader').offsetHeight;
        }
        Height = cellHeightValue - gridFilterHeight - 35;
        $('#' + Control).css("height", "");
    } else if (Control === "AlertsGridNew") {
        Height = cellHeightValue - 31;
        if (document.getElementById('myAletsHeader')) {
            headerHeight = document.getElementById('myAletsHeader').offsetHeight;
        }
        $("#_myAlertsPartialViewContainer").css("height", (Height + 13) + "px");
        $("#" + Control).css("height", (Height - 52) + "px");
        let gridRefresh = $('#ReqRecGrid').data("kendoGrid");
        if ($("#dvLoadReqRecGridData .ah-k-pager-info .k-pager-refresh").length && gridRefresh !== undefined) {
            gridRefresh.refresh();
        }
    } else if (Control === "QualityIndicatorNew" || Control === "DiseasechartNew" || Control === "RiskProfilechartNew") {
        Height = cellHeightValue - 17;
        headerHeight = document.getElementById('myAletsHeader').offsetHeight;
        $("#_myAlertsPartialViewContainer").css("height", Height + "px");
        $("#_myAlertsPartialViewContainer #" + Control).css("height", (Height - 5) + "px");
        $("#_myAlertsPartialViewContainer #DiseasechartNewContainer").css("height", (Height - 11) + "px");
    } else if (Control === "scheduler") {
        if (Expand == true) {
            $('#divMainMyCalendarContainer').append("<style type='text/css'>#scheduler{height:" + dashboardHeight + "px !important;}</style>");
        }
        else {
            Height = cellHeightValue - 23;
            $('#divMainMyCalendarContainer').append("<style type='text/css'>#scheduler{height:" + Height + "px !important;}</style>");
            $(".k-scheduler-content").css("height", (Height - 98) + "px");
        }
        return;
    } else if (Control === "dbaComplaintsumset" || Control === "dbaAuthsumset") {
        if ($("#_myAlertsPartialViewContainer").hasClass("clsMyCalendarPartialViewContainerExapnd")) {
            $('#_myAlertsPartialViewContainer #' + Control).css("height", (dashboardHeight) + "px");
        } else {
            Height = cellHeightValue - 20;
            $('#_myAlertsPartialViewContainer #' + Control).css("height", Height + "px");
        }
        return;
    } else {
        // do nothing (this is here for Sonar)
    }

    if (!Expand && Expand !== undefined && Expand !== "") {
        isCollapse = false;
    }
    // isCollapse = true means the opposite of what you'd think (means a widget is expanded)
    if (isCollapse) {
        if (Control === "QualityIndicatorNew" || Control === "DiseasechartNew" || Control === "RiskProfilechartNew" || Control == "AlertsGridNew") {
            $('.clsMyCalendarPartialViewContainerExapnd #' + Control).css("height", (dashboardHeight - 10) + "px");
            $('.clsMyCalendarPartialViewContainerExapnd #DiseasechartNewContainer').css("height", (dashboardHeight - 10) + "px");
        }
        //} else if (Control === "AlertsGridNew") {
        //    let gridHeight;

        //    setTimeout(function () {
        //        headerHeight = document.getElementById('myAletsHeader').offsetHeight;
        //        if ($('#btnMyAlertsecCollapse').is(':visible') || Expand) {
        //            gridHeight = window.innerHeight - mainHeaderHeight - mainTopMenuHeight - headerHeight - gridFilterHeight - mainFooterHeight - bufferHeight;
        //        } else {
        //            gridHeight = (window.innerHeight - mainHeaderHeight - mainTopMenuHeight - headerHeight - gridFilterHeight - mainFooterHeight - bufferHeight - 44) / 2;
        //        }
        //        $('#' + Control).css("height", gridHeight + "px");
        //    }, 0);
        //}
        else if (Control === "OpenAuthorization" || Control === "ReqRecGrid" || Control === "ReqRejGrid") {
            let gridHeight = window.innerHeight - mainHeaderHeight - mainTopMenuHeight - headerHeight - gridFilterHeight - mainFooterHeight - bufferHeight;
            if (window.innerHeight === 607) {
                $('#' + Control).css("height", (gridHeight + 34) + "px");
            } else {
                $('#' + Control).css("height", gridHeight + "px");
            }
        } else if (Control === "MyMembersGridNew") {
            let gridHeight = window.innerHeight - mainHeaderHeight - mainTopMenuHeight - headerHeight - gridFilterHeight - mainFooterHeight - bufferHeight;
            $('#' + Control).css("height", gridHeight + "px");
        } else {
            if (Control === "PendingActivityGrid" || Control === "OpenComplaints" || Control === "PendingComplaintActivities") {
                $('#' + Control).css("height", (dashboardHeight) + "px");
            }
        }
    } else {
        // this controls the height of the a11y-enhanced grids inside the collapsed widget, to keep it from "spilling over"

        if (Control === 'MyMembersGridNew') {
            $('#' + Control).css('height', (Height + 9) + "px");   // NOSONAR
        }
        else
            if (Control === 'PendingActivityGrid' || Control === 'OpenAuthorization' || Control === 'PendingComplaintActivities' || Control === 'OpenComplaints') {
                $('#' + Control).css('height', (Height + 11) + "px");   // NOSONAR
            }
    }

    if (Control === "OpenAuthorization") {
        $('#' + Control + ' .k-grid-content').css("height", (cellHeightValue - 137) + "px");
    } else {
        $('#' + Control + ' .k-grid-content').css("height", (Height - 55) + "px");
    }
}

/*To Relod Control*/
function MVCDBControlLoad(Container, Control, url, OuterLayer, IsPh) {
    let data = { referType: requestReferTypeGlobal, ReqIsPh: IsPh };
    if (Control === "OpenAuthorization" || Control === "OpenComplaints") {
        data = { isBtnExpandOnDashboardLoad: $('#btnMymebersecExpand').is(":hidden") };
    }

    $("#" + Container).load(url, data, function () {

        // $("#ReqRecGrid").data("kendoGrid").dataSource.read();//Converting Kendo
        //setTimeout(function () {
        //    $('#' + Control + ' .k-pager-refresh').trigger('click');
        //}, 1000);    
        if (Control == "MyMembersGridNew" && PHNavID != "1" && !isProviderUser) {
            readDatasourcefromGrid(Control, true);
        }
        else {
            if (gridPagerMode && !((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) && !(Control == "ReqRejGrid" || Control == "ReqRecGrid")) {
                gridPagination.fetchGridData(Control);
            }
        }
        if (!(Control == "ReqRejGrid" || Control == "ReqRecGrid")) {
            setDashboardGrids(Control);
            if (typeof isFullDashBoard !== 'undefined' && !isFullDashBoard && $.inArray(Control, MyMembersGrids) !== -1) {
                $('#btnMymebersecCollapse').hide();
            }
        }
    });


}

function loadAddProgramsDropdown() {
    $(document).off('change', '.clsDdlClinicalProgramStatus').on('change', '.clsDdlClinicalProgramStatus', function () {
        var clinicalProgramStatusDD = $(this);
        var arrOfIdAfterSplit = clinicalProgramStatusDD.attr('id').split('_');
        var ddlClinicalProgDesc = 'ddlClinicalPrgmStatusDescrp_' + arrOfIdAfterSplit[1];
        var ClinicalProgramStatusDesc = 'ClinicalStatusDescription_' + arrOfIdAfterSplit[1];
        if (clinicalProgramStatusDD.val() === '-1') {
            $('#' + ddlClinicalProgDesc).html('<option value="-1"> Select </option>');
        }
        else {
            loadDropDownSyncWithClass(baseURL + '/Master/BindReasons?sourcetype=' + clinicalProgramStatusDD.val(), ClinicalProgramStatusDesc, null, null, null, 'ProgramReasonId', 'ReasonDescription');
        }
    });
}

/*Dashboard Memebrdetails Control*/
function DBMemberDetailsLoad(Ctrl, OuterLayer, IsPh) {
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myMemberPartialViewContainer", "MyMembersGridNew", baseURL + "/Dashboard/MyMembers/", OuterLayer, IsPh);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'MyMembersGridNew', baseURL + "/Dashboard/MyMembers/", OuterLayer, IsPh);
}

/*Dashboard OpenAuthorization Control*/
function DBOpenAuthLoad(Ctrl, OuterLayer) {
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myMemberPartialViewContainer", "OpenAuthorization", baseURL + "/Authorization/OpenAuthorization/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'OpenAuthorization', baseURL + "/Authorization/OpenAuthorization/", OuterLayer);
}

/*Dashboard OpenAuthorization Control*/
function DBPendingActivitiesLoad(Ctrl, OuterLayer) {
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myMemberPartialViewContainer", "PendingActivityGrid", baseURL + "/Dashboard/PendingActivities/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'PendingActivityGrid', baseURL + "/Dashboard/PendingActivities/", OuterLayer);
}

/*Dashboard Alerts Control*/
function DBAlertsLoad(Ctrl, OuterLayer) {
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myAlertsPartialViewContainer", "AlertsGridNew", baseURL + "/Alert/MyAlerts/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'AlertsGridNew', baseURL + "/Alert/MyAlerts/", OuterLayer);
}

/*Dashboard RequestReceived Control*/
function DBReqRecLoad(Ctrl, OuterLayer) {
    $('#ancNavRec').addClass("headerNavOnchange");
    $('#ancNavRej').removeClass("headerNavOnchange");
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_requestReceivedPartialViewContainer", "ReqRecGrid", baseURL + "/RequestReceivedDashboard/RequestReceived/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'ReqRecGrid', baseURL + "/RequestReceivedDashboard/RequestReceived/", OuterLayer);
}

/*Dashboard RequestRejected Control*/
function DBReqRejLoad(Ctrl, OuterLayer) {
    $('#ancNavRej').addClass("headerNavOnchange");
    $('#ancNavRec').removeClass("headerNavOnchange");
    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_requestReceivedPartialViewContainer", "ReqRejGrid", baseURL + "/RequestRejectedDashboard/RequestRejected/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'ReqRejGrid', baseURL + "/RequestRejectedDashboard/RequestRejected/", OuterLayer);
}

//AGCODE
/*Dashboard OpenComplaints Control*/
function DBOpenComplaintsLoad(Ctrl, OuterLayer) {

    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myMemberPartialViewContainer", "OpenComplaints", baseURL + "/Complaint/OpenComplaints/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'OpenComplaints', baseURL + "/Complaint/OpenComplaints/", OuterLayer);
}
//Gcode
function DBPendingComplaintActivitiesLoad(Ctrl, OuterLayer) {

    if (Ctrl == 1)
        MVCLoadControl(Ctrl, "_myMemberPartialViewContainer", "PendingComplaintActivities", baseURL + "/Dashboard/PendingComplaintActivities/", OuterLayer);
    else
        MVCLoadControl(Ctrl, "memberGrid", 'PendingComplaintActivities', baseURL + "/Dashboard/PendingComplaintActivities/", OuterLayer);
}
//4.DropDownCommon.js
//Request Received
function getReferreceId(gridId) {
    let mALGridId = gridId === "ReqRecGridMAL" ? "#ReqRecGridMAL " : "";
    var CheckedCheckBox = $(mALGridId + 'input[type="checkbox"]:checked.clsRefralChkMember');
    if (CheckedCheckBox.length > 0) {
        var id = $(CheckedCheckBox[0]).attr('id').split('_')[1]
        var checkAllCheckBox = $('[id="ReferelChkAll"]');
        if (CheckedCheckBox.length === 1 && checkAllCheckBox.length > 0) {
            checkAllCheckBox.prop('checked', false);
        }
        $(CheckedCheckBox[0]).prop('checked', false);
        return id;
    }
}

function onLoadUpdateAppointment(slcId) {
    slcId = slcId != 6 ? slcStaId : slcId;
    loadDropDownSync(baseURL + '/Master/LoadAppointmentStatus/', 'selectAppointmentStatus', slcId, null, null, null, 'AppointmentStatusId', 'AppointmentStatusName');
    $(document).off('click', '#btnUpdateAppointmentUpdatePopup').on('click', '#btnUpdateAppointmentUpdatePopup', function () {
        SubUpdAppForm()
    });
    $('#AppointmentStatus').val(slcId);
    if (slcId == 6) {
        $('#selectAppointmentStatus').prop("disabled", true).change();
        $('#btnUpdateAppointmentUpdatePopup').val('Reject');
    }
    if (slcId == 4)
        $('#btnUpdateAppointmentUpdatePopup').val('Perform');
}

function SgnOffOrRejCarePlan(crPlnId, crPlnTmId, sgnOffFlag) {
    $.ajax({
        type: "GET",
        url: baseURL + "/RequestReceivedDashboard/SignOffOrRejectCarePlan",
        data: {
            'carePlanId': crPlnId,
            'carePlanTeamId': crPlnTmId,
            'signOffFlag': sgnOffFlag
        },
        dataType: "json",
        success: function (data) {
            if (data.success) {
                if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))
                    CmnStatusMessageDisp('divReqRecMessage', data.msg, 'Success');
                else
                    CustomAlert(data.msg);
                if (isMAL) {
                    $('#ReqRecGridMAL').data("kendoGrid").dataSource.read();
                }
                else {
                    readDatasourcefromGrid("ReqRecGrid", false);
                }
                if ($('#btnRejectRRecCarePlanClose').attr('id'))
                    $('#btnRejectRRecCarePlanClose').trigger('click');
                if ($('#ReceivedAppoinmentCount').attr('id'))
                    FillRequestCountFreek();
            }
        }
    });
}

function AttchChildToParentOnScroll(childId, pos) {
    $('#' + childId).show().css('left', (pos.left + 15) + "px").css('top', (pos.top - $(window).scrollTop()) + "px"); //kuhg-1525    
    //$(document).scroll(function () {
    //    $('#' + childId).show().css('left', (pos.left + 15) + "px").css('top', pos.top - $(window).scrollTop() + "px");
    //});
}

function CheckPrimaryCMExists(patientIds, isFrom) {
    $("#hdnIsFromIAPCM").val(isFrom);
    var dataInp = {
        patientIds: patientIds
    }
    $.ajax({
        type: "POST",
        url: baseURL + "/CareTeam/CheckPrimaryCMExists",
        data: dataInp,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.isPCMExists) {
                var popUphtml = '';
                if (isFrom == "AC") { popUphtml = $("#divInactCMConfAC").html(); } else if (isFrom == "RR" || isFrom == "SR" || isFrom == "WLM") { popUphtml = $("#divInactCMConfRR").html(); }
                //AC Means Assign Care Member, RR Means Request Received, SR Means Self Referral and SRFRR means Self Referral From Request Rejected
                if (isFrom == "AC" || isFrom == "RR" || isFrom == "SR" || isFrom == "WLM") {
                    $("#popUpDialog1").html('').append(popUphtml);
                    $('#popUpDialog1').CMNPopup({
                        popUpHeader: "Confirmation",
                        closeButton: "#btnInactCMConfCancelAC"
                    });
                    if (isFrom == "AC") {
                        if ($("#popUpDialog1").find('#unassignPCMToolTip').length > 0) {
                            new A11yTooltipInstance('unassignPCMToolTip', 'unassign primary care manager tooltip', {
                                tooltipText: '<div class="ItemMB5"><div class="bold">Yes:</div> Sets End Date to today and removes the Primary Care Manager from the member and the member\'s Care Team.</div><div class="ItemMB5"><div class="bold">No:</div> Removes the Primary Care Manager but keeps the care manager assigned to the member\'s Care Team and sets the End Date as N/A.</div><div class="ItemMB5"><div class="bold">Cancel:</div> No changes will be made. The current Primary Care Manager remains assigned.</div>',
                                width: TOOLTIP_WIDTH.MEDIUM,
                                pointerDirection: TOOLTIP_POINTER_DIRECTION.LEFT
                            });
                            // To avoid scrolling in the pop-up.
                            $('#popUpDialog1').css({
                                'overflow': 'visible',
                                'max-height': 'none',
                                'height': 'auto'
                            });
                        }
                    }
                }
                else if (isFrom == "SRFRR") { $("#popUpDialog3").html('').append($("#divInactCMConfRR").html()); $('#popUpDialog3').CMNPopup({ popUpHeader: "Confirmation", popLevel: 2 }); }
                loader(0);
            }
            else {
                if (isFrom == "AC") { AssignOrUnassignMemberToCareStaff(true); }
                else if (isFrom == "RR" || isFrom == "WLM") { AcceptMember(true); }
                else if (isFrom == "SR" || isFrom == "SRFRR") { SubmitSelfReferMember(true); }
            }
        },
        error: function () {
            loader(0);
        }
    });
}

function DashBoardRefresh(requestFrom) {
    if (isDashBoardRefresh && requestFrom == "UM") {
        if ($.trim(($('#MyMemberHeaderName').html() || '').toUpperCase()) == 'OPEN AUTHORIZATION' && $("#OpenAuthorization").data("kendoGrid") != null) {
            $("#OpenAuthorization").data("kendoGrid").dataSource.read();
        }
        else if ($.trim(($('#MyMemberHeaderName').html() || '').toUpperCase()) == 'PENDING AUTH ACTIVITIES' && $("#PendingActivityGrid").data("kendoGrid") != null) {
            $("#PendingActivityGrid").data("kendoGrid").dataSource.read();
        }
        if ($('#selectRequestReceivedModule').data("kendoDropDownList") != null && $.trim($('#selectRequestReceivedModule').data("kendoDropDownList").text() || '').toUpperCase() == 'UM' && $('#selectRequestReceivedReferType').data("kendoDropDownList") != null && $.trim($('#selectRequestReceivedReferType').data("kendoDropDownList").text() || '').toUpperCase() == 'UM AUTH' && $("#ReqRecGrid").data("kendoGrid") != null) {
            var grid = $("#ReqRecGrid").data("kendoGrid").dataSource;
            var sortingField = grid.sort();
            var isDueDateFilter = sortingField.filter(function (item) {
                return item.field == 'DUE_DATE';
            });
            if (!isbtnExpandOnDashboardLoad && isDueDateFilter) {
                grid.sort({});
            }
            grid.read();
        }
    }
    else {
        if ($.trim(($('#MyMemberHeaderName').html() || '').toUpperCase()) == 'OPEN COMPLAINTS' && $("#OpenComplaints").data("kendoGrid") != null) {
            $("#OpenComplaints").data("kendoGrid").dataSource.read();
        }
        else if ($.trim(($('#MyMemberHeaderName').html() || '').toUpperCase()) == 'PENDING COMPLAINT ACTIVITIES' && $("#PendingComplaintActivities").data("kendoGrid") != null) {
            $("#PendingComplaintActivities").data("kendoGrid").dataSource.read();
        }
        else {
            //No action required
        }
        if ($('#selectRequestReceivedModule').data("kendoDropDownList") != null && $.trim($('#selectRequestReceivedModule').data("kendoDropDownList").text() || '').toUpperCase() == 'AG' && $('#selectRequestReceivedReferType').data("kendoDropDownList") != null && $.trim($('#selectRequestReceivedReferType').data("kendoDropDownList").text() || '').toUpperCase() == 'AG COMPLAINT' && $("#ReqRecGrid").data("kendoGrid") != null) {
            var grid = $("#ReqRecGrid").data("kendoGrid").dataSource;
            var sortingField = grid.sort();
            var isDueDateFilter = sortingField.filter(function (item) {
                return item.field == 'DUE_DATE';
            });
            if (!isbtnExpandOnDashboardLoad && isDueDateFilter) {
                grid.sort({});
            }
            grid.read();
        }
        else {
            //No action required
        }
    }
}

function CheckBrowser() {
    var browser = ""; var useragent = navigator.userAgent;
    if (useragent.indexOf("Firefox") > 0)
        browser = "FF"
    else if (useragent.indexOf("MSIE ") > 0 || useragent.indexOf("Trident/") > 0 || useragent.indexOf("Edge/") > 0)
        browser = "IE"
    else if (useragent.indexOf("Chrome") > 0)
        browser = "GC"
    return browser;
}

function ResizeMyCalendarPopup(obj, isExpand) {
    showCareStaffCal = true;
    var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
    var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
    var calPopId = isGlobalCalShown ? "popUpGlobalCalendar" : "popUpGlobalMySchedule";
    $('#' + calPopId).CMNPopup({
        pvUrl: baseURL + "/Dashboard/MyCalendar",
        popLevel: isGlobalCalShown ? 1 : -1,
        popUpHeader: "My Schedule",
        onLoad: function () {
            onLoadMyCalendar();
            if (isExpand == 0) {
                $('#' + calPopId).append("<input type='hidden' id='hdnIsExpandCal' value='0' />");
                $('#' + calPopId).find("#anchExpand").show();
                $('#' + calPopId).find("#anchCollapse").hide();
            }
            else {
                $('#' + calPopId).append("<input type='hidden' id='hdnIsExpandCal' value='1' />");
                $('#' + calPopId).find("#anchExpand").hide();
                $('#' + calPopId).find("#anchCollapse").show();

                var browser = CheckBrowser(); var style = "<style>";
                if (browser == "IE" || browser == "GC") {
                    style += " #" + calPopId + " .k-scheduler-dayview .k-scheduler-table td, #" + calPopId + " .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
                }
                else {
                    style += "#" + calPopId + "  .k-scheduler-dayview .k-scheduler-table td, #" + calPopId + "  .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
                }
                style += "</style>";
                $('#' + calPopId).append(style);
            }

            if (isGlobalCalShown) {
                if ($("#" + calPopId).find("#hdnIsExpandCal").length > 0 && $("#" + calPopId).find("#hdnIsExpandCal").val() == "1") {
                    $("#" + calPopId).css('height', '660px').css('width', '1000px').css('top', '0px').css('margin-left', '-490px').css("left", "50%");
                }
                else {
                    $("#" + calPopId).css('width', '800px').css('top', '0px').css("left", "50%");
                    $("#" + calPopId).height(535);
                }
            }
            else {
                if ($("#" + calPopId).find("#hdnIsExpandCal").length > 0 && $("#" + calPopId).find("#hdnIsExpandCal").val() == "1") {
                    $("#" + calPopId).css('height', '660px').css('width', '1200px').css('top', '0px').css('margin-left', '-590px').css("left", "50%");
                }
                else if ($("#" + calPopId).find("#hdnIsExpandCal").length > 0 && $("#" + calPopId).find("#hdnIsExpandCal").val() == "0") {
                    $("#" + calPopId).css('height', '535px').css('width', '810px').css('top', '0px').css("left", "50%");
                }
            }
        },
        onClose: function () {
            $("#popUpGlobalCalendar").empty(); $("#popUpGlobalMySchedule").empty(); showCareStaffCal = false; isFromMySchedule = false;
            if ($('#_myCalendarPartialViewContainer').is(':visible')) {
                $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                    onLoadMyCalendar();
                });
            }
        },
    });
}

function loadGlobalMySchedule() {
    showCareStaffCal = true;
    $('#popUpGlobalMySchedule').CMNPopup({
        pvUrl: baseURL + "/Dashboard/MyCalendar",
        onLoad: function () {
            $("#popUpGlobalMySchedule").find("#portletHeadHand").find("#anchCollapse").show();
            $('#popUpGlobalMySchedule').append('<input type="button" style="width: 120px; display: none;" id="btnPopUpGlobalMyScheduleClose" value="Cancel" class="btn btn-default" />');
            onLoadMyCalendar();
            var browser = CheckBrowser(); var style = "<style>";
            if (browser == "IE" || browser == "GC") {
                style += " #popUpGlobalMySchedule .k-scheduler-dayview .k-scheduler-table td, #popUpGlobalMySchedule .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
            }
            else {
                style += "#popUpGlobalMySchedule .k-scheduler-dayview .k-scheduler-table td, #popUpGlobalMySchedule .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
            }
            style += "</style>";
            $('#popUpGlobalMySchedule').append(style);
            $('#popUpGlobalMySchedule').append("<input type='hidden' id='hdnIsExpandCal' value='1' />");
            //$('#anchCollapse').show();
            $('#btnMyCalRfsh').trigger('click');
        },
        popUpHeader: "My Schedule",
        closeButton: '#btnPopUpGlobalMyScheduleClose',
        onClose: function () {
            isFromMySchedule = false;
            $('#popUpGlobalMySchedule').empty();
            showCareStaffCal = false;
            if ($('#_myCalendarPartialViewContainer').is(':visible')) {
                $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                    onLoadMyCalendar();
                });
            }
            else if ($("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#pnlCareActivityheader').is(':visible')) {
                $("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#imgbtnSearch').trigger('click');
            }
            else if ($('#grdPendingActivities').is(':visible')) {
                LoadPendingActivityGrid();
            }
            else if ($('#outstandingActivitesGrid').is(':visible')) {
                $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read();
            }
            else if ($('#outstandingExternalActivitesGrid').is(':visible')) {
                $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read();
            }
            else if ($('#CMPendingActivitiesGrid').is(':visible')) {
                LoadWorkLogMgrCmActivities();
            }
        },
        popLevel: -1,
        top: 50,
    });
}

function loadGlobalCalendar(isFrom, rowVal) {
    showCareStaffCal = true;
    $('#popUpGlobalCalendar').CMNPopup({
        pvUrl: baseURL + "/Dashboard/MyCalendar",
        onLoad: function () {
            onLoadMyCalendar();
            $('#popUpGlobalCalendar').css('overflow-y', 'initial').css('max-height', 'initial');
            $('#popUpGlobalCalendar').append('<input type="button" style="width: 120px; display: none;" id="btnPopUpGlobalCalendarClose" value="Cancel" class="btn btn-default" />');
            $("#popUpGlobalCalendar").find("#portletHeadHand").find("#anchCollapse").show();
            if (isFrom == 'actlog') {
                $('#popUpGlobalCalendar').append('<input type="hidden" id="hdnIsFromMyACTlog" value="actlog" />');
            }
            if (isFrom == 'reqrec') {
                $('#popUpGlobalCalendar').append('<input type="hidden" id="hdnIsFromMyACTlog" value=' + rowVal + ' />');
            }
            if (isFrom == 'actlogrr') {
                var hdnRowVal = $(rowVal).closest('tr').index();
                $('#popUpGlobalCalendar').append('<input type="hidden" id="hdnIsFromMyACTlog" value="actlogrr" /><input type="hidden" id="hdnACTrrRowNum" value=' + hdnRowVal + ' />');
            }

            var browser = CheckBrowser(); var style = "<style>";
            if (browser == "IE" || browser == "GC") {
                style += "#popUpGlobalCalendar .k-scheduler-dayview .k-scheduler-table td, #popUpGlobalCalendar .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
            }
            else {
                style += "#popUpGlobalCalendar .k-scheduler-dayview .k-scheduler-table td { height: 60px !important; }";
            }
            style += "</style>";
            $('#popUpGlobalCalendar').append(style);
            $('#popUpGlobalCalendar').append("<input type='hidden' id='hdnIsExpandCal' value='1' />");
            $('#btnMyCalRfsh').trigger('click');
        },
        popUpHeader: "Scheduling Assistant",
        onClose: function () {
            $('#popUpGlobalCalendar').empty();
            showCareStaffCal = false;
            A11yModal.trapFocusInModal('popUpDialog1');
            if ($("#divMyMembersEngOutreachActivity").is(":visible")) {
                A11yForms.addRequiredIndicatorNote("#divMyMembersEngOutreachActivity");
            }
        },
        closebutton: '#btnPopUpGlobalCalendarClose',
        top: 50,
        popLevel: nextPopupLevel(),
    });
}

//Request Rejected
function getReferalId(gridId) {
    var CheckedCheckBox = $('input[type="checkbox"]:checked.clsRejectedChkMember');
    if (CheckedCheckBox.length > 0) {
        var id = $(CheckedCheckBox[0]).attr('id').split('_')[1];
        $(CheckedCheckBox[0]).prop('checked', false);
        return id;
    }
}

function DeleteAgRequest(listReferralId) {
    $.ajax({
        type: "GET",
        url: baseURL + "/Home/DeleteAGActivity?listReferenceId=" + listReferralId,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                $('#closePopUp').trigger('click');
                // $("#_requestReceivedPartialViewContainer").load(baseURL + "/RequestController/DataSourceResult/", function () { });

                readDatasourcefromGrid("ReqRecGrid", false);
            }
            else
                CustomAlert('Error Encountered.');
        }
    });
}

function loadDropDownSyncWithClass(url, elementClass, selectedValue, isShowFullText, ConditionalCallback, Value, Text, isasyncCall, isCache) {
    let isasync = isasyncCall !== undefined ? isasyncCall : false;
    let isSetCache = isCache || false;
    var $select = $('.' + elementClass);
    var dataValue = Value || 'Value';
    var dataText = Text || 'Text';
    var _cachekey = url.replace(baseURL + "/", "");
    var _data = (isSetCache && cacheData(_cachekey)) || null;
    if (_data === null) {
        $.ajax({
            type: "GET",
            url: url,
            async: isasync,
            success: function (data) {
                buildloadDropDownHtml(url, data, null, dataValue, dataText, $select, selectedValue, null, null, ConditionalCallback);
                if (isSetCache) {
                    cacheData({ key: _cachekey, value: data, maxage: 120 }, true);
                }
            }
        });
    }
    else {
        buildloadDropDownHtml(url, _data, null, dataValue, dataText, $select, selectedValue, null, null, ConditionalCallback);
    }
}

function loadDropDown(url, elementId, selectedValue, ConditionalCallback, dataValue, dataText, DdlTextLenght, KendoDropDown, selectedText, isasyncCall, isSetCache) {   // NOSONAR (complaint about number of function args)
    DevUtils.logDebug('loading dropdown...', 'GCHomeCommon.loadDropDown()', { url: url, elementId: elementId, selectedValue: selectedValue, ConditionalCallback: ConditionalCallback, dataValue: dataValue, dataText: dataText, DdlTextLenght: DdlTextLenght, KendoDropDown: KendoDropDown, selectedText: selectedText, isasyncCall: isasyncCall });

    let isasync = isasyncCall !== undefined ? isasyncCall : false;
    dataValue = dataValue || 'Value';
    dataText = dataText || 'Text';

    //request the JSON data and parse into the select element
    isSetCache = isSetCache || false;
    var _cachekey = url.replace(baseURL + "/", "");
    var _data = (isSetCache && cacheData(_cachekey)) || null;
    if (_data === null) {
        return $.ajax({
            type: "GET",
            url: url,
            async: isasync,
            success: function (data) {
                buildloadDropDownHtml(url, data, DdlTextLenght, dataValue, dataText, elementId, selectedValue, selectedText, KendoDropDown, ConditionalCallback);
                if (isSetCache) {
                    cacheData({ key: _cachekey, value: data, maxage: 120 }, true);
                }
            }
        });
    }
    else {
        buildloadDropDownHtml(url, _data, DdlTextLenght, dataValue, dataText, elementId, selectedValue, selectedText, KendoDropDown, ConditionalCallback);
    }
}

function buildloadDropDownHtml(url, data, DdlTextLenght, dataValue, dataText, elementId, selectedValue, selectedText, KendoDropDown, ConditionalCallback) {
    let $select = typeof elementId === 'object' ? elementId : $('#' + elementId);
    if ($select && $select.length > 0) {
        //clear the current content of the select
        var optionsHtmlString = "";
        $select.html('');
        optionsHtmlString += '<option value="-1"> Select </option>';
        optionsHtmlString = $select.attr('multiple') || $select.data('select') ? '' : optionsHtmlString;
        optionsHtmlString = $select.data('all') === 'ALL' ? '<option value="-1"> ALL </option>' : optionsHtmlString;
        optionsHtmlString = $select.selector === '#ddlAlert' ? '<option value="0">Enrollment</option>' : optionsHtmlString;

        //iterate over the data and append a select option
        var lengthToShortenTo = (DdlTextLenght == undefined || DdlTextLenght == null) ? 50 : DdlTextLenght;
        var selectedValueexists = false;
        var isAuthTypeDropdown = (typeof elementId === 'string' && elementId === 'ddlDefaultDataAuthType') ||
            (typeof elementId === 'object' && elementId.attr && elementId.attr('id') === 'ddlDefaultDataAuthType');

        $.each(data, function (key, val) {
            var title = val[dataText];
            var dataval = val[dataValue];
            if (typeof dataval === 'string' || dataval instanceof String) {
                dataval = escapeHtml(dataval);
            }

            if (val[dataText] && val[dataText].length > lengthToShortenTo && elementId != 'selectActivityOutcome') {

                val[dataText] = val[dataText].substring(0, lengthToShortenTo) + '...';
            }

            var optionHtml = '';
            if (selectedValue) {

                if (selectedValue == val[dataValue]) {
                    selectedValueexists = true;
                    optionHtml = '<option value="' + val[dataValue] + '" selected="selected" title="' + escapeHtml(title) + '"';
                    if (isAuthTypeDropdown && val.IsServicePlan !== undefined) {
                        optionHtml += ' data-isserviceplan="' + (val.IsServicePlan || false) + '"';
                    }
                    optionHtml += '>' + escapeHtml(val[dataText]) + '</option>';
                    optionsHtmlString += optionHtml;
                }
                else {
                    optionHtml = '<option value="' + dataval + '" title="' + escapeHtml(title) + '"';
                    if (isAuthTypeDropdown && val.IsServicePlan !== undefined) {
                        optionHtml += ' data-isserviceplan="' + (val.IsServicePlan || false) + '"';
                    }
                    optionHtml += '>' + escapeHtml(val[dataText]) + '</option>';
                    optionsHtmlString += optionHtml;
                }
            }
            else {
                if (val.Selected || val.IsDefaultSelect || val.IsPrimary) {
                    optionHtml = '<option value="' + val[dataValue] + '" selected="selected" title="' + escapeHtml(title) + '"';
                    if (isAuthTypeDropdown && val.IsServicePlan !== undefined) {
                        optionHtml += ' data-isserviceplan="' + (val.IsServicePlan || false) + '"';
                    }
                    optionHtml += '>' + escapeHtml(val[dataText]) + '</option>';
                    optionsHtmlString += optionHtml;
                }
                else {
                    if (val.CnstCheckListId) {
                        title = val["CheckListName"];
                        if (val["IsDisclosed"] || val["IsBold"]) {
                            title = "This checklist item is marked as a consent to disclose sensitive information.Using this item on a member's consent form shall enable respective provider(s) and caregiver(s) to access health information of a member.\n \n" + title;
                            optionsHtmlString += '<option style="font-weight:bold" value="' + val["CnstCheckListId"] + '"  title="' + escapeHtml(title) + '">' + $.fn.replaceAndEscapeHtmlExt(val["CheckListName"]) + '</option>';
                        }
                        else {
                            optionsHtmlString += '<option value="' + val["CnstCheckListId"] + '"  title="' + escapeHtml(title) + '">' + $.fn.replaceAndEscapeHtmlExt(val["CheckListName"]) + '</option>';
                        }
                    }
                    else {
                        optionHtml = '<option value="' + dataval + '" title="' + escapeHtml(title) + '"';
                        if (isAuthTypeDropdown && val.IsServicePlan !== undefined) {
                            optionHtml += ' data-isserviceplan="' + (val.IsServicePlan || false) + '"';
                        }
                        optionHtml += '>' + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + '</option>';
                        optionsHtmlString += optionHtml;
                    }
                }
            }
            if (isAuthTypeDropdown && val.IsServicePlan !== undefined) {
                var optionValue = val[dataValue];
                if (typeof authTypeServicePlanCache !== 'undefined') {
                    authTypeServicePlanCache[optionValue] = val.IsServicePlan || false;
                }
            }
        });
        if (!selectedValueexists && selectedValue != undefined && selectedValue != null && selectedValue.toString().length > 0 && selectedText != undefined && selectedText.length > 0) {
            var selectedOptionHtml = '<option value="' + selectedValue + '" selected="selected" title="' + escapeHtml(selectedText) + '"';
            if (isAuthTypeDropdown) {
                selectedOptionHtml += ' data-isserviceplan="false"';
                if (typeof authTypeServicePlanCache !== 'undefined') {
                    authTypeServicePlanCache[selectedValue] = false;
                }
            }
            selectedOptionHtml += '>' + escapeHtml(selectedText) + '</option>';
            optionsHtmlString += selectedOptionHtml;
        }

        var values = new Array();
        $select.append(optionsHtmlString);
        if (KendoDropDown != undefined && KendoDropDown == true) {
            $($select).kendoDropDownList({
                filter: "contains",
                animation: false
            });
        }
        if (ConditionalCallback && typeof (ConditionalCallback) === "function") {
            ConditionalCallback(true, elementId, dataValue, dataText, data);
        }
        if (elementId === 'ddlRequiredActivities' && $('#trReqAct') !== undefined && data.length > 0) {
            $('#trReqAct').show();
        }
        else {
            if (elementId === 'ddlRequiredActivities' && $('#trReqAct') !== undefined) {
                $('#trReqAct').hide();
            }
        }
    } else {
        DevUtils.logDebug('no <select> element provided, loading dropdown data only', 'GCHomeCommon.loadDropDown()');
    }

    DevUtils.logDebug('API RESPONSE: url: [' + url + ']', 'GCHomeCommon.loadDropDown()', data, 'blue');
}

function loadDropDownSync(remote_url, elementId, selectedValue, isShowFullText, ConditionalCallback, KendoDropDown, Value, Text) {
    var $select = $('#' + elementId);
    var isControlDisabled = false;
    var isElementDisabled = $select.prop('disabled');
    Value = Value || 'Value';
    Text = Text || 'Text';

    //request the JSON data and parse into the select element
    $.ajax({
        type: "GET",
        url: remote_url,
        async: false,
        success: function (data) {
            //to load selected value for filter dropdown - EPSDT filters
            if (elementId === "ddlSelectFilter") {
                var epsdtFilterString = $("#divPHEPSDTDashBoard").is(":visible") ? epsdtDataString : epsdtPanelDataString;
                if (selectedValue === "" && epsdtFilterString === "") {
                    var arr = jQuery.grep(data, function (a) {
                        return a.IsDefault;
                    });
                    selectedValue = arr.length > 0 ? arr[0].FilterId.toString() : "";
                    defaultFilterId = selectedValue;
                }
            }
            //clear the current content of the select
            var optionsHtmlString = "";
            $select.html('');
            optionsHtmlString += '<option value="-1"> Select </option>';
            if ($select.attr('multiple'))
                optionsHtmlString = "";
            if ($select.data('select'))
                optionsHtmlString = "";
            if ($select.data('all') == "ALL")
                optionsHtmlString = '<option value="-1"> ALL </option>';
            //iterate over the data and append a select option
            var selectedVal;
            var lengthToShortenTo = 50;
            $.each(data, function (key, val) {
                if (val) {
                    let title = $.fn.replaceAndEscapeHtmlExt(val[Text]);

                    if (isShowFullText != true) {
                        if (val[Text] && val[Text].length > lengthToShortenTo) {
                            val[Text] = val[Text].substring(0, lengthToShortenTo) + '...';
                        }
                    }
                    val[Text] = $.fn.replaceAndEscapeHtmlExt(val[Text]);
                    if (selectedValue) {
                        if (selectedValue == val[Value]) {
                            optionsHtmlString += '<option value="' + val[Value] + '" selected="selected" title="' + title + '">' + val[Text] + '</option>';
                        }
                        else {
                            optionsHtmlString += '<option value="' + val[Value] + '" title="' + title + '">' + val[Text] + '</option>';

                        }
                    }
                    else {
                        if (val.Selected) {
                            optionsHtmlString += '<option value="' + val[Value] + '" selected="selected" title="' + title + '">' + val[Text] + '</option>';
                        }
                        else {
                            optionsHtmlString += '<option value="' + val[Value] + '" title="' + title + '">' + val[Text] + '</option>';

                        }
                    }
                    if (val.Disabled) {
                        isControlDisabled = true;
                    }
                }
            });
            var values = new Array();
            $select.append(optionsHtmlString);
            if (isControlDisabled || isElementDisabled) {
                $select.attr("disabled", "disabled");
            }
            else {
                $select.removeAttr("disabled");
            }
            if (KendoDropDown !== undefined && KendoDropDown === true) {
                $($select).kendoDropDownList({
                    filter: "contains",
                    animation: false
                });
            }
            if (ConditionalCallback && typeof (ConditionalCallback) === "function") {
                ConditionalCallback(true);
            }
        }
    });
}

function setDeletedDropDownValue(dropdownId, id, text) {
    if ($('#' + dropdownId).val() == -1 && !$.fn.isNullOrEmpty(id)) {

        var newOption = document.createElement("option");
        newOption.text = text;
        newOption.value = id;
        newOption.title = text;

        var dropdown = document.getElementById(dropdownId);
        dropdown.add(newOption);

        $('#' + dropdownId).val(id);
    }
}

function GetPatientId() {
    return { patientId: $('#patientForViewSummary').val() == '' || $('#patientForViewSummary').val() == undefined ? VarPatientIdGlobal : $('#patientForViewSummary').val() };
}

function FilterCriteriaShow() {
    let htmlStr = getMyMembersFilterCriteriaHtml();
    $('#divContentFiltercriteriaMyMembers').html(htmlStr);
    if (htmlStr === "No Filters Applied") {
        $('#divContentFiltercriteriaMyMembers').html('No Filters Applied').css('color', '#666');
    }
}


// This function populates the My Members widget filter tooltip
function getMyMembersFilterCriteriaHtml() {
    let htmlStr = "";

    if (globalAlertFilterText !== "") {
        var AlertFilterText = globalAlertFilterText.split(',');
        var altFil = GetUnique(globalAlertFilter.toString().split(','));
        AlertFilterText = GetUnique(AlertFilterText);
        if (AlertFilterText.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td >Alert Description: </td><td>'
            $.each(AlertFilterText, function (key, item) {
                htmlStr += '<span class="member-filter-name" style="width:79%;">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Alert_' + escapeHtml(altFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });
            htmlStr += '</td></tr></table>';
        }
    }

    if (globalDiseaseFilterText !== "") {

        var DiseaseFilterText = globalDiseaseFilterText.split(',');
        var disFil = GetUnique(globalDiseaseFilter.toString().split(','));
        DiseaseFilterText = GetUnique(DiseaseFilterText);
        if (DiseaseFilterText.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td><div>Condition Name: </td><td>'
            $.each(DiseaseFilterText, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Disease_' + escapeHtml(disFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globalIndicatorsText !== "") {
        var indicatorsText = globalIndicatorsText.split(',');
        var indFil = GetUnique(globalindcatros.toString().split(','));
        indicatorsText = GetUnique(indicatorsText);
        if (indicatorsText.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Indicators: </td><td>'
            $.each(indicatorsText, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Indicators_' + escapeHtml(indFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globalRiskFilterText !== "") {

        var RiskFilterText = globalRiskFilterText.split(',');
        var rskFil = GetUnique(globalRiskFilter.toString().split(','));
        RiskFilterText = GetUnique(RiskFilterText);
        if (RiskFilterText.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Risk Category Name: </td><td>'
            $.each(RiskFilterText, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Risk_' + escapeHtml(rskFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globalprogramsText !== "") {
        var pgmsdroptxt = globalprogramsText.split(',');
        var pgmFil = GetUnique(globalprograms.toString().split(','));
        pgmsdroptxt = GetUnique(pgmsdroptxt);
        if (pgmsdroptxt.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Programs: </td><td>'
            $.each(pgmsdroptxt, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Programs_' + escapeHtml(pgmFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globaloppertunitiesText !== "") {
        var optsdroptxt = globaloppertunitiesText.split(',');
        var optFil = GetUnique(globaloppertunities.toString().split(','));
        optsdroptxt = GetUnique(optsdroptxt);
        if (optsdroptxt.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Opportunities: </td><td>'
            $.each(optsdroptxt, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Opportunities_' + escapeHtml(optFil[key]) + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globalQIndicatorFilterTextDenom !== "") {
        var Denomtext = globalQIndicatorFilterTextDenom.split(',');
        var dnmFil = (globalQIndicatorFilterDenom.toString().split(','));
        if (Denomtext.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Denominator: </td><td>'
            $.each(Denomtext, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Denom_' + escapeHtml(dnmFil[key]) + '" data-keyvalue="' + key + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (globalQIndicatorFilterTextNum !== "") {
        var nomtext = globalQIndicatorFilterTextNum.split(',');
        var nomFil = (globalQIndicatorFilterNum.toString().split(','));
        if (nomtext.length > 0) {
            htmlStr += '<div class="clsFieldFiltercriteriaMyMembers"><table style="width:100%;"><tr><td>Numerator: </td><td>'
            $.each(nomtext, function (key, item) {
                htmlStr += '<span class="member-filter-name">' + escapeHtml(item) + '</span><button class="ah-btn-link small member-filter-clear" id="Num_' + escapeHtml(nomFil[key]) + '" data-keyvalue="' + key + '" aria-label="remove ' + escapeHtml(item) + ' filter">Clear</button><br/>';
            });

            htmlStr += '</td></tr></table>';
        }
    }

    if (htmlStr === "") {
        htmlStr = 'No Filters Applied';
    }

    return htmlStr;
}

function GetUnique(inputArray) {
    var outputArray = [];

    for (var i = 0; i < inputArray.length; i++) {
        if ((jQuery.inArray(inputArray[i], outputArray)) == -1) {
            outputArray.push(inputArray[i]);
        }
    }

    return outputArray;
}

function setPstnCntxtMenu(chkdChkBx) {
    var $chkBxOS = $(chkdChkBx).offset();
    var $grdCnt = $(chkdChkBx).closest('.k-grid-content');
    if ($grdCnt.length === 0) {
        // handle case for a11y-enhanced grids
        $grdCnt = $(chkdChkBx).closest('.k-grid');
    }
    var $grdOS = $($grdCnt).offset();
    var $grdHt = $($grdCnt).height();
    var topPs = ($grdOS.top + $grdHt);
    if ($grdOS.top > $chkBxOS.top)
        return $grdOS.top;
    if (topPs <= $chkBxOS.top)
        return topPs - 30;
    return $chkBxOS.top;

}

function GetReferId(val) {
    return ($('#selectRequestReceivedReferType').find('option')
        .filter(function (index) { return $(this).text() === val; })
        .filter(function (index) { return index === 0 })).attr('value');

}
function formatDate(d) {
    function addZero(n) {
        return n < 10 ? '0' + n : '' + n;
    }

    return new Date(addZero(d.getMonth() + 1) + "/" + addZero(d.getDate()) + "/" + d.getFullYear() + " " +
        addZero(d.getHours()) + ":" + addZero(d.getMinutes()) + ":" + addZero(d.getMinutes()));
}
function formatDateWithoutTime(d) {
    function addZero(n) {
        return n < 10 ? '0' + n : '' + n;
    }

    return addZero(d.getMonth() + 1) + "/" + addZero(d.getDate()) + "/" + d.getFullYear();
}
function formatDateTime(d) {
    function addZero(n) {
        return n < 10 ? '0' + n : '' + n;
    }
    return addZero(d.getMonth() + 1) + "/" + addZero(d.getDate()) + "/" + d.getFullYear() + " " +
        addZero(d.getHours()) + ":" + addZero(d.getMinutes()) + ":" + addZero(d.getSeconds());
}

function isLeapYear(_date) {
    let year1 = _date.getFullYear();
    var result = false;
    if (!(year1 % 4) && (year1 % 100) || !(year1 % 400)) {
        result = true;
    }
    return result;
}
function validateGapBetweenDates(objfrom, objto) {
    var errorMsg = '';

    var fromVal = $('#' + objfrom).val();
    var toVal = $('#' + objto).val();

    if (fromVal && toVal) {
        var from = new Date(fromVal);
        var to = new Date(toVal);

        // Normalize to UTC (removes DST/time issues)
        var fromUTC = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
        var toUTC = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());

        var daysDifference = (toUTC - fromUTC) / (1000 * 60 * 60 * 24) + 1;

        var isLeapYearVal = false;
        if ((isLeapYear(from) && from.getMonth() < 2) || (isLeapYear(to) && from.getMonth() > 1)) {
            isLeapYearVal = true;
        }

        if ((isLeapYearVal && daysDifference > 366) || (!isLeapYearVal && daysDifference > 365)) {
            errorMsg = "Valid To date should not be more than 1 year from Valid From date.";
        }
    }
    return errorMsg;
}
function ValidateEmail(email) {
    var Result = false;
    if ($.trim(email) != "") {
        var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (reg.test(email)) { Result = true; }
    }
    return Result;
}

function PrintPanelMVC(obj, moduleID, patientID, sectionName, AuthID, ComplaintID) {
    $('#ViewScriptActivitySummaryPrint').hide();
    $('#ViewGeneralActivitySummaryPrint').hide();
    var jqueryDOM = obj;
    var windowUrl = '';
    var uniqueName = new Date();
    var windowName = uniqueName.getTime();
    var keepColors = '<style> .srpt-tile-container {padding: 10px;} .srpt-inside-tile {display: flex; margin-bottom:8px; flex-wrap: wrap;border: 1px solid #cccccc;border-radius: 4px;padding: 4px;} .is_flex {display:flex; width:100%;} .srpt-tile {display: flex; flex-direction: column; margin-bottom:10px; border: 1px solid #cccccc;border-radius: 4px;padding: 5px;} .srpt-field-container { display: flex; flex-direction: column; width: 29%; padding: 5px; margin-right: 15px; margin-bottom: 5px; } .srpt-field-data .tbl {word-break: normal;} table.tbl th, table.tbl tr, table.tbl td {border:1px solid #cccccc; page-break-inside: avoid;} table.tbl td.thead {word-break: normal;} .srpt-field-container label { font-weight: bold; margin-bottom: 5px; width: 100%; page-break-inside: avoid;} .srpt-field-data{word-break: break-word; -ms-word-break: break-all; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto; white-space: pre-wrap; padding-bottom:10px;} body {-webkit-print-color-adjust: exact !important; } table td div {word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: pre-wrap;} @media print{ table { page-break-after:auto } tr{ page-break-after:auto } td { page-break-after:auto } thead { display:table-header-group }  tfoot { display:table-footer-group } table.scriptTbl td {page-break-inside:avoid} } a {pointer-events:none; text-decoration:none; color: #000;}</style>';
    var printWindow = window.open(windowUrl, windowName, 'height=400,width=800,location=0,scrollbars=yes, resizable=yes');
    printWindow.document.write("<html><head><title>&nbsp;&nbsp;</title>" + keepColors + "</head><body></body></html>");
    printWindow.document.close();
    // Use jQuery to parse and append the content safely
    var parsedContent = $.parseHTML(jqueryDOM);
    $(printWindow.document.body).append(parsedContent);
    //printWindow.document.write(jqueryDOM);
    setTimeout(function () {
        printWindow.focus();
        printWindow.print();
    }, 500);
    if (moduleID != null && moduleID != undefined && moduleID != "") {
        AuditLog(moduleID, actionTypeEnum.Print, sectionName, patientID, window.top.memberidval, '', AuthID, ComplaintID, '');
    }

    return false;
}

// font size increase / decrease

function fnSearchableDropDownMethod(id) {
    $(id).kendoDropDownList({
        filter: "contains",
        dataTextField: "text",
        dataValueField: "value",
        autoBind: false,
        animation: false
    });
}

function dateStEdValidation(stDt, edDt) {

    if (!stDt || stDt == "")
        return false;
    if (!edDt || edDt == "")
        return false;
    var StartDate = new Date(stDt);
    var EndDate = new Date(edDt);
    if (StartDate > EndDate) {
        CustomAlert('Start Date should be less than or equal to End Date');
        return false;
    }
    return true;
}

function ToolTipData(className, header, separator, dataTag) {
    var tl = $('.' + className);
    if (tl) {
        $.each(tl, function (key, itm) {
            if ($(itm).data(dataTag)) {
                var tlDt = $(itm).data(dataTag).split(separator);
                var htmlStr = "";
                htmlStr += '<span style=font-weight:bold;>' + header + '</span><br/><br/>';
                $.each(tlDt, function (key, item) {
                    htmlStr += '<div>' + (key + 1) + '.' + item + '</div>';
                });
                $(itm).attr('title', htmlStr);
            }
        });
        $('.' + className).aToolTip();
    }
}

function BindRequestRecievedData(ReqType) {
    if (!$('#popUpDialog1').is(":visible") && !$('#OpenAddAuthactivityForm').is(":visible") && !$('#faxAlertMsg').is(":visible")) {
        A11yAlerts.remove();
    }
    loader(1);
    $('.clsRRProviderSearch').hide();
    $('.divUmReqRecAuthStatus').hide();
    $('.risk-filter-fields').hide();
    $('#selMessageTypeFields').hide();
    $('#divTreatmentTypeReqRecUmFaxes').hide();
    $('#divSaveTreatmentTypeReqRecUmFaxes').hide();
    var referType = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
    var modName = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
    if (referType === "Activity") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMActivities/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "Member") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMMembers/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "Appointment") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMAppointments/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "Care Plan") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMCarePlan/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "Messages") {
        $('#selMessageTypeFields').show();
        if ($("#selMessageType").val() === '2') {
            $("#selMessageType").val('false');
        }
        $("#opt_I_FaxArchive").hide();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMMessages/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0); setDashboardGrids("ReqRecGrid");
        });

    }
    else if (referType === "Faxes") {
        $('#selMessageTypeFields').show();
        $("#opt_I_FaxArchive").show();
        var currentValue = $('#selMessageType').val();
        REQ_REC_UM_FAX_TT.showHideDdl('ddlTreatmentTypeReqRecUmFaxes', 'divSaveTreatmentTypeReqRecUmFaxes', modName, referType);
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestReceivedCMFax/', { moduleName: modName }, function () {
            $("#moveFaxToArchive").ApplyRoleConfig({ UniqueName: getUniqueFaxName(), Id: "moveFaxToArchive", IsFrom: "Edit", IsRemoveElement: true });
            $("#moveArchiveToUnArchive").ApplyRoleConfig({ UniqueName: getUniqueFaxName(), Id: "moveArchiveToUnArchive", IsFrom: "Edit", IsRemoveElement: true });
            if ($(".clsMoveFaxToArchive").prop("id") === "") {
                if (currentValue === 'true') {
                    $('#selMessageType').val('true');
                } else {
                    $('#selMessageType').val('false');
                }
                $("#opt_I_FaxArchive").hide();
                $(".clsMoveFaxToArchive").hide();
                $(".clsArchiveToUnArchive").hide();
            }
            $(".clsMoveFaxToArchive").attr('id', 'moveFaxToArchive');
            $("#moveFaxToArchive").on('click').removeAttr('title').attr('onclick', "fnMoveFaxToArchive('Archive', 'clsRefralChkMember', 'Class', 'Please select at least one record to archive', '');").css('opacity', '');
            $(".clsArchiveToUnArchive").attr('id', 'moveArchiveToUnArchive');
            $("#moveArchiveToUnArchive").on('click').removeAttr('title').attr('onclick', "fnMoveFaxToArchive('UnArchive', 'clsRefralChkMember', 'Class', 'Please select at least one record to restore', '');").css('opacity', '');

            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "UM Activity") {
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedUMActivities/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType == "UM Auth") {
        $('.clsRRProviderSearch').show();
        $('.divUmReqRecAuthStatus').show();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedUMAuth/', { ReqRecIsPh: ReqType, isBtnExpandOnDashboardLoad: isbtnExpandOnDashboardLoad }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType == "AG Complaint") {
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedAGComplaints/', { ReqRecIsPh: ReqType, isBtnExpandOnDashboardLoad: isbtnExpandOnDashboardLoad }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "AG Activity") {
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedAGActivities/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "MS Activity") {
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedMSActivities/', { ReqRecIsPh: ReqType }, function () {
            loadGridOnPagerMode('ReqRecGrid');
            loader(0);
            setDashboardGrids("ReqRecGrid");
        });
    }
    else if (referType === "Care Plan Review") {
        //Closed status
        if ($("#ddlCPRStatus option[value='3']").length == 0)
            $('#ddlCPRStatus').append('<option value="3">Closed</option>');
        if ($("#ddlCPRStatus option[value='4']").length > 0)
            $("#ddlCPRStatus option[value='4']").remove();
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedReviewCarePlan/', { ReqRecIsPh: ReqType }, function () {
            loader(0);
        });
    }
    else if (referType === "Assessments") {
        //Canceled status
        if ($("#ddlCPRStatus option[value='3']").length > 0)
            $("#ddlCPRStatus option[value='3']").remove();
        if ($("#ddlCPRStatus option[value='4']").length == 0)
            $('#ddlCPRStatus').append('<option value="4">Canceled</option>');
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedReviewAssessments/', { ReqRecIsPh: ReqType }, function () {
            loader(0);
        });
    }
    else {
        $("#dvLoadReqRecGridData").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMActivities/', { ReqRecIsPh: ReqType }, function () {
            loader(0);
        });
    }
    setTimeout(function () {
        loader(0);
        intialReqGridHeight = $('#_requestReceivedPartialViewContainer').find('.k-grid:visible').css('height');
    }, 5000);
}

function BindRequestRejectedData() {
    loader(1);
    $('.clsRRProviderSearch').hide();
    $('.divUmReqRecAuthStatus').hide();
    $('.risk-filter-fields').hide();
    $('#divTreatmentTypeReqRecUmFaxes').hide();
    $('#divSaveTreatmentTypeReqRecUmFaxes').hide();
    var referType = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
    if (referType === "Member") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMMembers/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "Appointment") {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMAppointments/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "UM Activity") {
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedUMActivities/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "UM Auth") {
        $('.clsRRProviderSearch').show();
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedUMAuth/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "AG Complaint") {
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedAGComplaints/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "AG Activity") {
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedAGActivities/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else if (referType === "MS Activity") {
        $("#dvLoadReqRejGridData").load(baseURL + '/MemberService/RequestRejectedMSActivities/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    else {
        $('.risk-filter-fields').show();
        $("#dvLoadReqRejGridData").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMActivities/', function () {
            loadGridOnPagerMode("ReqRejGrid");
            loader(0);
            setDashboardGrids("ReqRejGrid");
        });
    }
    setTimeout(function () {
        loader(0);
        intialReqGridHeight = $('#_requestReceivedPartialViewContainer').find('.k-grid:visible').css('height');
    }, 5000);
}

function loadMemberEmail(memberId) {
    var selectMemberEmail = document.getElementById('selectMemberEmail');
    var optionsLegth = $('#selectMemberEmail').children('option').length;
    var primaryEmail = "";
    var prefferedEmail = "";
    if (optionsLegth > 1) {
        for (i = optionsLegth - 1; i > 0; i--) {
            selectMemberEmail.options[i] = null;
        }
    }
    getMemberInformation(memberId, function (data) {
        if (data.Data.success) {
            var memberDetails = data.Data.memberInfo;
            if (memberDetails != null) {
                primaryEmail = memberDetails.PrimaryEmail;
                prefferedEmail = memberDetails.PreferredEmail;
            }
        }
        if (primaryEmail !== "" && primaryEmail !== null) {
            $('#selectMemberEmail').AhsAppendChild("<option id='1' value='" + primaryEmail + "'>" + primaryEmail + "</option>");
        }
        if (prefferedEmail !== "" && prefferedEmail !== null) {
            $('#selectMemberEmail').AhsAppendChild("<option id='1' value='" + prefferedEmail + "'>" + prefferedEmail + "</option>");
        }
    });
}

function contactTypeChange() {
    if ($('#selectContactType option:selected').text() === configuredTelehealthContactType && $('#selectContactType option:selected').val() !== "-1" && $('#selectScheduledType').val() === "0" && $("#rdoEAInternal").is(":checked") === true) {

        var memberId = $.fn.setValueOnUndefinedOrNull(selectedMemberIdForActivityAddEdit, "");
        if (memberId !== "") {
            loadMemberEmail(memberId);
        }
        $('#divTelehealthSection').show();
        $('#divWarningSection').show();
        $('#divJoinMeetingDetails').html('');
        $('#divMeetingDetails').hide();
        selectedMemberIdForActivityAddEdit = "";
    }
    else if (($('#selectScheduledType').val() === "1" || $('#selectScheduledType').val() === "2" || $('#selectScheduledType').val() === "3" || $('#selectScheduledType').val() === "4") && $('#selectContactType option:selected').text() === configuredTelehealthContactType) {
        $('#divWarningSection').show();
        $('#divTelehealthSection').hide();
    }
    else if ((($("#rdoEAExternal").is(":visible") && $("#rdoEAExternal").is(":checked")) || ($("#rdoPharmacist").is(":visible") && $("#rdoPharmacist").is(":checked"))) && $('#selectContactType option:selected').text() === configuredTelehealthContactType) {
        $('#divWarningSection').show();
        $('#divTelehealthSection').hide();
    }

    else {
        $('#divTelehealthSection').hide();
        $('#divWarningSection').hide();
    }
}

function memberEmailChange() {
    if ($('#selectMemberEmail').val() !== "-1") {
        $('#txtAddOrChangeEmail').val('');
        $('#txtAddOrChangeEmail').attr('disabled', 'disabled');
        $('#emailErrorMsg').hide();
        $('#validationMessageForEmail').hide();
    }
    else if ($('#txtAddOrChangeEmail').val() !== "" && $('#selectMemberEmail').val() === "-1") {
        $('#selectMemberEmail').attr('disabled', 'disabled');
        $('#validationMessageForEmail').hide();
        $('#emailErrorMsg').hide();
    }
    else {
        $('#txtAddOrChangeEmail').removeAttr('disabled');
        $('#selectMemberEmail').removeAttr('disabled');
    }
}
function isValidGuid(guid) {
    if (guid === '' || guid === null || guid === 'undefined' || guid === 'N/A' || guid === '0' || guid === 'null') {
        return false;
    }
    return true;
}
function contactTypeChangeOnEdit() {
    if (($('#selectContactType option:selected').text() === configuredTelehealthContactType || isEditTeleHealthActivity === true) && $('#selectContactType option:selected').val() !== "-1" && $('#selectScheduledType').val() === "0" && $("#rdoEAInternal").is(":checked") === true) {
        var memberId = $.fn.setValueOnUndefinedOrNull(selectedMemberIdForActivityAddEdit, "");
        if (memberId !== "") {
            loadMemberEmail(memberId);
        }
        $('#divTelehealthSection').show();
        $('#divWarningSection').show();
        selectedMemberIdForActivityAddEdit = "";
    }
    else if (($('#selectScheduledType').val() === "1" || $('#selectScheduledType').val() === "2" || $('#selectScheduledType').val() === "3" || $('#selectScheduledType').val() === "4") && $('#selectContactType option:selected').text() === configuredTelehealthContactType) {
        $('#divWarningSection').show();
        $('#divTelehealthSection').hide();
    }
    else if ((($("#rdoEAExternal").is(":visible") && $("#rdoEAExternal").is(":checked")) || ($("#rdoPharmacist").is(":visible") && $("#rdoPharmacist").is(":checked"))) && $('#selectContactType option:selected').text() === configuredTelehealthContactType) {
        $('#divWarningSection').show();
        $('#divTelehealthSection').hide();
    }
    else {
        $('#divTelehealthSection').hide();
        $('#divWarningSection').hide();
    }
}
function onScheduleDateTimeChange() {
    isMeetingGenerated = false;
}
//5.JsCMN_Par.js
var preStartDate = new Date();
var preEndDate = new Date();
var preDuration = new Date();
function onLoadEditActivity() {
    //if ($("#rdoEAExternal").is(":visible") && $("#rdoEAExternal").is(":checked")) {
    //    $("#rdoEAExternal").attr('disabled',false).trigger('clicked').attr('disabled',true);
    //}
    if ($('#activityForm #FollowupDate').val() !== null && $('#activityForm #FollowupDate').val() !== "") {
        $('#activityForm #FollowupDate').kendoDateTimePicker({ value: new Date($('#activityForm #FollowupDate').val()), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 30 });
    }
    if ($('#activityForm #DueDate').val() != null && $('#activityForm #DueDate').val() != "")
        $('#activityForm #DueDate').kendoDateTimePicker({ value: new Date($('#activityForm #DueDate').val()), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 30 });

    preStartDate = $('#activityForm #FollowupDate').val();
    preEndDate = $('#activityForm #DueDate').val();
    preDuration = $('#activityForm #FollowupDuration').val();

    $('.schdtcls').find('span').find('.k-select').find('span').eq(0).attr('title', 'Open the calendar popup.');
    $('.schdtcls').find('span').find('.k-select').find('span').eq(1).attr('title', 'Open the time view popup.');

    $('#hdnRecurringType').val('Daily');
    $('#RecurrenceValues_EndAfterDate').kendoDatePicker({ format: "MM/dd/yyyy" });
    $("#tabstrip").kendoTabStrip({
        activate: onActivate,
        animation: {
            open: {
                effects: "fadeIn"
            }
        }
    });

    if (isMTMval === false || isMTMval.toLowerCase() === 'false') {
        if (careStaffFullNameRole == '') {
            $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameWithRole));
        }
        else {
            $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameRole));
        }
        if (referTo != null && referTo > 0 && referTo != "") {
            $('#hdnCareStaffAddActivity').val(referTo);
        }
        else {
            $('#hdnCareStaffAddActivity').val(memberidval);
        }
    }
    loadDropDown(baseURL + '/Master/LoadContactTypeDDL?isEditTeleHealthActivity=' + isEditTeleHealthActivity, 'selectContactType', venueId, null, 'VenueId', 'VenueName', null, null);
    loadDropDown(baseURL + '/Master/LoadPriorityDDL/', 'selectPriority', priority, null, 'PriorityName', 'PriorityName');

    contactTypeChangeOnEdit();
    memberEmailChange();
    loadDropDown(baseURL + '/Master/LoadAllScriptsForActivity?careActivityTypeId=' + careActivityTypeId + '&memberId=' + $('#activityForm #PatientId').val(), 'selectScript', editActscriptId, null, 'ScriptId', 'ScriptName');
    $('#ScheduleTypeText').val($("#selectScheduledType option:selected").text());

    //uhc-69 - to load if the screen opens default with completed type
    if ($('#selectScheduledType :selected').text().toLowerCase() == "completed") {
        if ($('#IsFromBulkActivity').val() == 'true') {
            $("#selectActivityType").closest(".k-widget").show();
            $('#ddlActTypeCompleted').hide();
        }
        else {
            $("#selectActivityType").closest(".k-widget").hide();
            $('#ddlActTypeCompleted').show();
        }
    }
    //uhc-69

    if ($("#outstandingActivitesGrid").is(':visible') && !showCareStaffCal) {
        var isPrgmActAdd = $('#hdnIsPrgmActivity').length > 0 && $('#hdnIsPrgmActivity').val() === '1';
        if (isFromCompleteandaddActivity == false && !isPrgmActAdd) {
            if ($("#selectActivityType").data("kendoDropDownList") != null) { $("#selectActivityType").data("kendoDropDownList").enable(false); }//kuhg-925//error comming need to  check no go ahed       
        }
        isFromCompleteandaddActivity = false;
        if (referTo != '' && referTo != null) {
            $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameRole));
            $('#hdnCareStaffAddActivity').val(referTo);
        }

    }

    $('.form-horizontal').off('change', '#selectActivityType').on('change', '#selectActivityType', function () {
        loader(1);
        loadDropDown(baseURL + '/Master/LoadAllScriptsForActivity?careActivityTypeId=' + $('#selectActivityType').val() + '&memberId=' + $('#activityForm #PatientId').val(), 'selectScript', null, null, 'ScriptId', 'ScriptName');
        CheckReviewActivityNotification($(this).val(), 0, memberidval, '');

        loader(0);
    });

    $(document).off('click', '#chkIsRecurringActivity').on('click', '#chkIsRecurringActivity', function () {
        if ($(this).is(':checked')) {
            $('#divRecurringActivitySchedule, .recurringType').show();
            $('#chkGroupActivity').attr('checked', false);
            $("#btnCheckActivityForm").prop('disabled', false);
            $('.groupActivityType,#activityForm #divGroupActivity').hide();
            if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
                $('#divIdCareStaff').hide();
                $('#divIdExCareStaff').show();
            }
            else {
                $('#divIdCareStaff').show();
                $('#divIdExCareStaff').hide();
            }

            $("#tabstrip").find('.clsEditActTabDailyRecurring').trigger('click');
            $('#RecurrenceValues_EndAfterDate').val('');
            $('#RecurrenceValues_EndAfterNoOfOccurrences').val('');
        }
        else {
            $('#divRecurringActivitySchedule,.recurringType').hide();
            if ($("#rdoEAInternal").is(":checked")) {
                $('#divGroupActivity').show();
            }
        }
        if (($('#IsFromBulkActivity').val() === 'true' && ($('#bulkPatientIdAddActivity').val() || '').indexOf(',') > 0) || ($("#rdoEAExternal").is(":visible") && $("#rdoEAExternal").is(":checked"))) {
            $('#divProgramActivity, #divCliProgramActivity').hide();
        }
        else {
            $('#divProgramActivity, #divCliProgramActivity').show();
        }

        ShowHideActivityCntrlsForMTMUser($(".EACareStaffType:checked").val());
    });

    $(document).off('click', '#btnSubmitActivityForm,#btnCloseActivityForm').on('click', '#btnSubmitActivityForm,#btnCloseActivityForm', function (e) {

        $('#btnSubmitActivityForm,#btnCloseActivityForm').prop('disabled', 'true');//uhg-3798    
        if ($(this).attr('id') == "btnCloseActivityForm" && $('#activityForm #PatientFollowupId').val() == "" && $('#activityForm #ProviderFollowupId').val() == "") {
            var programWorkFlowId = $('#activityForm #WorkFlowId').val(), reqActPatientId = $('#activityForm #PatientId').val();
            var self = this;
            var url = baseURL + "/Config/CheckIfActivityPerformed?progWorkflowId=" + programWorkFlowId + "&reqActPatientId=" + reqActPatientId + "&initiateCheck=1";
            if ($("#rdoEAExternal").is(":visible") && $("#rdoEAExternal").is(":checked"))
                url = baseURL + "/Config/CheckIfExtActivityPerformed?progWorkflowId=" + programWorkFlowId + "&reqActPatientId=" + reqActPatientId + "&initiateCheck=1";
            $.ajax({
                type: "GET",
                url: url,
                dataType: "json",
                success: function (data) {
                    if (data.result == 1) {
                        loader(0);
                        CustomAlert("Activity already been scheduled.");
                        $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
                        closeEditActivityForm();
                    }
                    else { SubmitActivityForm(self); }
                }
            });
        }
        else {
            SubmitActivityForm(this);
        }
    });

    $(document).off('change', '#selectScheduledType').on('change', '#selectScheduledType', function () {
        clearAddOrEditValidation();
        $("#divcustomfields, #divOutComeCustomField").html("");
        contactTypeChange();
        $('#txtAddOrChangeEmail').removeAttr('disabled');
        $('#selectMemberEmail').val('')
        if ($(this).val() == 3) {
            $('#ddlDepartment').hide();
            $('#ddlMsDepartment').show();
            $('#divMSActivitySection').show();
            $('#divActivitySection').hide();
            $('#divScriptSection').hide();
            $('#divPrioritySection').hide();
            $('#divDueDateSection').hide();
            $('#divContactTypeSection').hide();
            $('#divScheduledDuration').hide();
            $('#divcplgoal').hide();
            $('.scheduledType,.recurringType,.groupActivityType').hide();
            $('#divProgramActLob, #divClinicalProg').hide();
            $('#divGroupActivity').show();
            $("#divIdAddActCareTeam").hide();
            $('#ActivityOutcome').hide();
            $('#ActivityOutcomeType').hide();
            $('#ActualDuration').hide();
            $('#ActivityPlaceOfService').hide();
            $('#ActivityOutcomeNotes').hide();
            $('#HCPCCode').hide();
            $('#divContainerCanPerform').hide();
            $('#lblLoginCareStaff').text('');
            $('#divMSCareStaff').show();
            $('#divIdCareStaff').hide();
            $('#lblLoginCareStaff').hide();
            $('#divWarningSection').hide();
            $('#ddlMSCareStaffAddActivity').val(careStaffFullNameWithRole);
            if (isMTMval === false || isMTMval.toLowerCase() === 'false') {
                $('#hdnCareStaffAddActivity').val(memberidval);
            }
            if ($("#PatientId").val() == "0") {
                $("#ddlMSCareStaffAddActivity").prop('disabled', true);
                $("#ddlMSCareStaffAddActivity").prop('title', 'Please select a member to edit care staff');
            }
            else {
                $("#ddlMSCareStaffAddActivity").prop('disabled', false);
                $("#ddlMSCareStaffAddActivity").removeAttr('title');
            }
            $('#chkGroupActivity').prop('checked', false);
            $("#btnCheckActivityForm").prop('disabled', false);
            $("#divContainerMemberPortalActivity").hide(); //PROD-10989
            return;
        }
        else {
            $('#divScheduledDuration').show();
            $('#ddlDepartment').show();
            $('#ddlMsDepartment').hide();
            $('#divMSActivitySection').hide();
            $('#divActivitySection').show();
            $('#divScriptSection').show();
            $('#divPrioritySection').show();
            $('#divDueDateSection').show();
            $('#divContactTypeSection').show();
            $('#divMSCareStaff').hide();
            if (isMTMval === false || isMTMval.toLowerCase() === 'false') {
                $('#hdnCareStaffAddActivity').val(memberidval);
            }
            $('#chkGroupActivity').prop('checked', false);
            $('#divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
            $('#chkIsRecurringActivity').prop('checked', false);
            $('#divRecurringActivitySchedule,.recurringType').hide();
            $("#btnCheckActivityForm").prop('disabled', false);
            $("#divContainerMemberPortalActivity").show(); //PROD-10989
            $("#ddlActTypeCompleted").find('.k-input').html('Select');
            closedActivitySelected = [];
            closedActivitySelectedText = [];
        }
        if ($(this).val() == 0) {
            if ($("#selectActivityType").data("kendoDropDownList") != null) {
                if ($("#AppointmentId").length > 0 && $('#selectActivityType').prop('disabled')) {
                    $("#selectActivityType").data("kendoDropDownList").text('Appointment Reminder');
                }
                else {
                    $("#selectActivityType").data("kendoDropDownList").value("-1");
                }
                resetScriptDropdownForAddActivity();
            }
            //uhc-69
            $("#selectActivityType").closest(".k-widget").show();
            $('#ddlActTypeCompleted').hide();
            //uhc-69
            $('.scheduledType').show();
            if ($('#chkIsRecurringActivity').is(':checked'))
                $('.recurringType').show();
            else
                $('.recurringType').hide();

            if ($('#chkGroupActivity').is(':checked'))
                $('.groupActivityType').show();
            else
                $('.groupActivityType').hide();
            //To hide from required activities on change
            if ($('#hdnIsFromToDolist').val() == "True") {
                $('#divGroupActivity, #divProgramActivity, #divCliProgramActivity, #divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
            }
            else {
                if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() === "EXTERNAL") {
                    $('#divGroupActivity, #divProgramActivity, #divCliProgramActivity, #divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
                    $('#selectScheduledType').attr('disabled', true);
                }
                else {
                    if ($('#hdnIsPrgmActivity').length > 0 && $('#hdnIsPrgmActivity').val() === '1') {
                        $('#divGroupActivity').hide();
                    }
                    else {
                        $('#divGroupActivity').show();
                    }

                    $('#divProgramActivity, #divCliProgramActivity, #divGroupActivity').show();
                    $('#divWarningSection').hide();
                    //$('#divProgramActivity').show();
                }
                if ($('#hdnWorkFlowSwitch').val() === '0') {
                    $('#divGroupActivity').hide();
                }

            }
            ShowHideHasNotification($('#hdnReturnActivityNotification').val());
        }
        else {
            $('.scheduledType,.recurringType').hide();
            $('#divReturnActivityNotification').hide();
        }

        if ($(this).val() != 2) {
            $("#divIdAddActCareTeam").hide();
            if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
                $('#divIdCareStaff').hide();
                $('#divIdExCareStaff').show();
                $('#divWarningSection').hide();
            }
            else {
                $('#divIdCareStaff').show();
                $('#divIdExCareStaff').hide();
            }
            $('#CanPerform').show();

        }
        else {
            $("#divIdAddActCareTeam").show();
            $('#divIdCareStaff').hide();
        }
        if ($(this).val() == 1) {
            if ($('#IsFromBulkActivity').val() == 'true') { //uhc-69
                $("#selectActivityType").closest(".k-widget").show();
                $("#selectActivityType").data("kendoDropDownList").dataSource.read()
                $('#ddlActTypeCompleted').hide();
                $('#divWarningSection').hide();
            }
            else {
                $("#selectActivityType").closest(".k-widget").hide();
                $('#ddlActTypeCompleted').show();
            }
            $(".cbCareActTypeComp").attr('checked', false);
            $('#AddActTypeCompletedhdn').val('');
            var kendoDropdown = $("#ddlActTypeCompletedKD").data("kendoDropDownList");
            if (kendoDropdown != null) {
                if (kendoDropdown.dataSource._total == undefined) {
                    loader(1);
                    kendoDropdown.dataSource.read();
                }
            }
            //uhc-69
            if (isMTMval === false || isMTMval.toLowerCase() === 'false') {
                $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameWithRole));
                $('#hdnCareStaffAddActivity').val(memberidval);
            }

            if ($("#PatientId").val() == "0") {
                $("#ddlCareStaffAddActivity").prop('disabled', true);
                $("#ddlCareStaffAddActivity").prop('title', 'Please select a member to edit care staff');
            }
            else {
                $("#ddlCareStaffAddActivity").prop('disabled', false);
                $("#ddlCareStaffAddActivity").removeAttr('title');
            }
            //$('#ddlCareStaffAddActivity').attr('disabled', 'disabled');
            $('#dvCareStaff').hide();


            //uhg-2924
            $('#lblLoginCareStaff').show();
            // $('#lblLoginCareStaff').text(careStaffFullName + ' : ' + rolenameval);
            $('#lblLoginCareStaff').text(careStaffFullNameWithRole);
            //uhg-2924
            //$('#selectCareStaff').hide();
            $('#divContainerCanPerform').hide();
            $('#ActivityOutcome').show();
            $('#ActivityOutcomeType').show();
            $('#ActualDuration').show();
            $('#ActivityPlaceOfService').show();
            $('#ActivityOutcomeNotes').show();
            $('#HCPCCode').show();
            $('.groupActivityType').hide();
            $('#divGroupActivity').hide();
            $('#divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
            if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
                $('#divIdCareStaff').hide();
                $('#divIdExCareStaff').show();
            }
            else {
                $('#divIdCareStaff').show();
                $('#divIdExCareStaff').hide();
            }
            if ($('#hdnIsFromToDolist').val() == "True") { $('#divProgramActivity, #divCliProgramActivity').hide(); }//Show Program Activites checkbox for completed activities
            else {
                $('#divProgramActivity, #divCliProgramActivity').show();
            }
            loadDropDown(baseURL + '/Master/BindActivityOutcomeType/', 'ddlActivityOutcomeType', null, null, 'ActivityOutComeTypeId', 'ActivityOutComeType');
            // loadDropDownSync(baseURL + '/Home/BindActivityOutcome/', 'ddlActivityOutcome');
            //uhc-2801
            $("#ddlActivityOutcomeType").off('change').on('change', function () {
                var selectedActOutcomeType = $('#ddlActivityOutcomeType').val();
                var activityTypeId = '';
                if ($('#hdnIsReSchedueled').val() == 1)
                    activityTypeId = $('#CareActivityTypeId').val();
                else
                    activityTypeId = $('#AddActTypeCompletedhdn').val();
                //if ($(this).val() != '-1')
                if ($('#selectScheduledType').val() == "1") {
                    //loadDropDown(baseURL + '/Home/BindActivityOutcome?careActivityTypeId=' + $('#AddActTypeCompletedhdn').val() + '&activityoutcomeTypeId=' + $(this).val(), 'ddlActivityOutcome', undefined, undefined, undefined, undefined, undefined, true);
                    loadDropDown(baseURL + '/Master/BindActivityOutcome?careActivityTypeId=' + activityTypeId + '&activityoutcomeTypeId=' + $("#ddlActivityOutcomeType").val(), 'ddlActivityOutcome', undefined, undefined, 'ActivityOutcomeId', 'ActivityOutcome', undefined, true);
                }
                else {
                    loadDropDown(baseURL + '/Master/BindActivityOutcome?activityoutcomeTypeId=' + $(this).val(), 'ddlActivityOutcome', null, null, 'ActivityOutcomeId', 'ActivityOutcome')
                    $("#ddlActivityOutcome").kendoDropDownList({
                        filter: "contains",
                        dataTextField: "Text",
                        dataValueField: "Value",
                        animation: false
                    });
                }
            });
            $("#ddlActivityOutcomeType option").map(function () { this.selected = (this.text == "Successful") });
            $('#ddlActivityOutcomeType').trigger('change');
            loadDropDownSync(baseURL + '/Master/BindHCPCCodes/', 'ddlHCPCCode', null, null, null, null, 'HCPCCodeId', 'HCPCCode');
            loadDropDownSync(baseURL + '/Master/BindPlaceOfService/', 'ddlActivityPlaceOfService', null, null, null, null, 'PlaceOfServiceId', 'PlaceOfService');
            if (isPlaceofServiceMandatory === "True" && $('#ddlActivityPlaceOfService').is(':visible')) {
                $('#lblddlActivityPlaceOfService').addClass('ah-required');
            }
        } else {
            //uhc-69
            $("#selectActivityType").closest(".k-widget").show();
            if ($("#selectActivityType").data("kendoDropDownList") != null)
                $("#selectActivityType").data("kendoDropDownList").dataSource.read()
            $('#ddlActTypeCompleted').hide();
            //uhc-69
            $('#divContainerCanPerform').show();
            //uhg-2924
            $('#lblLoginCareStaff').text('');
            //$('#selectCareStaff').show();
            $('#dvCareStaff').show();
            $('#lblLoginCareStaff').hide();
            //uhg-2924
            //$('#selectCareStaff').removeAttr('disabled');
            if ($("#PatientId").val() == "0") {
                $("#ddlCareStaffAddActivity").prop('disabled', true);
                $("#ddlCareStaffAddActivity").prop('title', 'Please select a member to edit care staff');
            }
            else {
                $("#ddlCareStaffAddActivity").prop('disabled', false);
                $("#ddlCareStaffAddActivity").removeAttr('title');
            }
            $('#ActivityOutcome').hide();
            $('#ActivityOutcomeType').hide();
            $('#ActualDuration').hide();
            $('#ActivityPlaceOfService').hide();
            $('#ActivityOutcomeNotes').hide();
            $('#HCPCCode').hide();
        }
        //$('#CareActivityTypeId').val($(this).val()); //KUHG-1297
        $('#ScheduleTypeText').val($("#selectScheduledType option:selected").text());

        // PROD-6681
        //to pre-populate lob-plan-program when adding activity from programs section
        if (!(($('#hdnIsPrgmActivity').length > 0 && $('#hdnIsPrgmActivity').val() == '1') && ($(this).val() == 0 || $(this).val() == 1))) {
            $('#chkProgramActivity, #chkCliProgramActivity').attr('checked', false).attr('disabled', false);
            $('#ddlPrgmActPrgm, #ddlClinicalProg').val(-1);
            $('#divProgramActLob, #divClinicalProg').hide();
        }
        PharmacistCntrls();

        if (!$.fn.isNullOrEmpty($('#bulkPatientIdAddActivity').val()) && $('#bulkPatientIdAddActivity').val().indexOf(',') > 0) {
            $('#divProgramActivity, #divCliProgramActivity').hide();
        }
    });
    if ($('#IsFromBulkActivity').val() === 'true' && ($('#bulkPatientIdAddActivity').val() || '').indexOf(',') > 0) {// to hide Program activity from assigncaremember bulk section
        $('#divProgramActivity, #divCliProgramActivity').hide();
    }
    var patId = $('#PatientId').val();
    if (patId > 0) {
        var scheduledType = $("#selectScheduledType").val();
        CreateDropCheck('divAddActCareTeam', baseURL + '/PatientCareTeam/LoadCareTeamDdl?activityPatientID=' + patId + '&careTeamIds=' + careTeamIds + '&ScheduledType=' + scheduledType, 'AddActCareTeam', 0, careTeamIds, null, null, 'FullName', 'PhysicianId');
    }
    if ($('#divPatientNameForActivity').is(':visible') && $('#activityForm #PatientId').val() == 0 && $('#bulkPatientIdAddActivity').val() == '') {   //calendar double click add activity

        $("#divGroupActivity #chkGroupActivity").prop('disabled', true);
        $("#ddlCareStaffAddActivity").prop('disabled', true);

    }
    var selectedActivityTypeId = $('#CareActivityTypeId').val();
    if (selectedActivityTypeId != '' && selectedActivityTypeId != undefined &&
        (($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "INTER") ||
            ($('#hdnActivityTypeFor').val() == '' && !$(".EACareStaffType").is(":visible")))) {
        fnLoadCustomField("divcustomfields", 1, parseInt($("#selectScheduledType").val()) + 1, $("#CareActivityTypeId").val(), $("#PatientFollowupId").val());
    }
    PharmacistCntrls();
}

function resetScriptDropdownForAddActivity() {
    if ($("#selectScript").length > 0 && ($('#selectActivityType').val() === "-1" || $('#selectActivityType').val() === "" || $('#selectActivityType').val() === null)) {
        $("#selectScript option:not(:first)").remove();
    }
}

function CheckReviewActivityNotification(ActivityTypeId, PfId, CareStaffId, ActivityTypeName) {
    loader(1);
    $('#chkReturnActivityNotification').prop("checked", false);
    var Url = baseURL + "/Home/CheckReviewActivityNotification?careActivityTypeId=" + ActivityTypeId + '&Pfid=' + PfId + '&CareStaffId=' + CareStaffId + '&activityTypeName=' + ActivityTypeName;
    $.ajax({
        type: "POST",
        url: Url,
        dataType: "json",
        asyns: false,
        success: function (data) {
            if (data.success) {
                var result = data.result;
                var finalResult = result.split('|');
                $('#hdnReturnActivityNotification').val(finalResult[0]);
                if ($('#selectScheduledType').val() == 0) {
                    ShowHideHasNotification(finalResult[0]);
                    if (finalResult.length > 1) {
                        if (finalResult[1] > 0) { $('#chkReturnActivityNotification').prop("checked", true); }
                        if (finalResult[2] == 0) { $('#chkReturnActivityNotification').attr("disabled", "disabled"); }
                    }
                }
            } else {
                $('#hdnReturnActivityNotification').val('0');
                $('#divReturnActivityNotification').hide();
            }

            loader(0);
        },
        error: function () {
        }
    });

}

function ShowHideHasNotification(Obj) {
    var activityTypeDdl = $("#selectActivityType").data("kendoDropDownList");
    var actTypeVal = activityTypeDdl ? activityTypeDdl.value() : ($('#CareActivityTypeId').val() ?? '');
    var isActTypeSelected = actTypeVal !== '-1' && actTypeVal !== '' && actTypeVal != null && actTypeVal !== '0';
    if ($.trim(Obj) === '1' && $(".EACareStaffType:checked").val() !== "EXTERNAL" && isActTypeSelected) {
        $('#divReturnActivityNotification').show();
    } else {
        $('#divReturnActivityNotification').hide();
    }
}

function onActivate(e) {
    $('#hdnRecurringType').val($.trim($(e.item).find("> .k-link").text()));
}

function clearFields() {
    //CF-2144
    //var ddl = $("#selectSearch").data("kendoDropDownList");
    //ddl.select(0);
    $('#txtSearch').val('');
    $("#quickSearchdate").val("");
    if ($('#closePopUp').is(':visible')) {
        $('#closePopUp').trigger('click');
    }
    else if ($('#closePopUpUM').is(':visible')) {
        $('#closePopUpUM').trigger('click');
    }
    else {
        //Do nothing
    }
    CurrentPatientIdGlobal = false;
}

function loadShowSign(signatureType) {
    if ($('#hdnProjectType').val() != undefined && $('#hdnProjectType').val() != null && $('#hdnProjectType').val() != '') {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/ActivityRecord/FormSignature?signatureType=" + signatureType,
            onLoad: function () {
            },
            popUpHeader: "Signature"
        });
    }
    else {
        loadSignDetails(signatureType);
        $find('behCNSTSignature').show();
        return false;
    }
}

function loadSignDetails(signatureType) {
    $('#hdnSignImageId').val(signatureType);
    ShowSign('', signatureType, 'behCNSTSignature');
    DrawSignOnCanvas(signatureType);
}

function clearValidationMessages() {
    $('#spFirstName').html('');
    $('#spLastName').html('');
    $('#spPrimaryPhone').html('');
    $('#spPrimaryEmail').html('');
    $('#spAlternateEmail').html('');
    $('#spFax').html('');
    $('#spZip').html('');
    $('#spAlternatePhone').html('');
    $('#spCellPhone').html('');
    $('#sptimezone').html('');
    $('#spHintId').html('');
    $('#spHintAnswer').html('');
    $('#divUpdateMessageForLogin').html('');

}

function setCareStaffAddress(completeAddress) { //UHC-3380
    carestaffAddress = completeAddress;
}
function scrollToStatusMessage() {
    if ($('#validationMessageActivity').is(':visible')) {
        $(".ah-modal-content", "#activityForm").animate({ scrollTop: 0 }, 500);
    }
}
function SubmitActivityForm(obj) {
    var isValidForm = false;
    var isOutcomeMandatory = false;
    var isDurationMandatory = false;
    if ($('#selectScheduledType').val() != "3") {
        if ($('#selectScheduledType').val() == "1" && $('#AddActTypeCompletedhdn').val() != '') {
            var activityTypes = '';
            if ($('#hdnIsReSchedueled').val() == 1)
                activityTypes = $('#CareActivityTypeId').val();
            else
                activityTypes = $('#AddActTypeCompletedhdn').val();
            $.ajax({
                type: "POST",
                url: baseURL + "/ActivityRecord/CheckOutcomeMandate?ActivityTypeIds=" + activityTypes,
                dataType: "json",
                async: false,
                success: function (data) {
                    isOutcomeMandatory = data.IsOutcomeMandatory;
                    isDurationMandatory = data.IsDurationMandatory;


                    isValidForm = ValidationForAddOrEditActivity(obj, isOutcomeMandatory, isDurationMandatory);
                    if (isValidForm) {
                        isMeetingGenerated = false;
                        if ($('#selectScheduledType').val() == '1') { AddUpdateActvt(obj); }
                        else { CheckAvailability(obj); }
                    }
                    else {
                        $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                        scrollTopForCloseActivityForm(obj);
                    }
                }
            });
        }
        else {
            isValidForm = ValidationForAddOrEditActivity(obj, true);
            if (isValidForm) {
                isMeetingGenerated = false;
                if ($('#selectScheduledType').val() == '1') { AddUpdateActvt(obj); }
                else { CheckAvailability(obj); }
            }
            else {
                $('#btnSubmitActivityForm,#btnCloseActivityForm').removeAttr('disabled');
                scrollTopForCloseActivityForm(obj);
            }
        }
    }
    else {
        $('#btnCloseActivityForm').prop('disabled', 'true');
        var isValidForm = ValidationForMSAddActivity();
        if (isValidForm) {
            AddMSActivity(obj);
        } else {
            scrollTopForCloseActivityForm(obj);
        }
        $('#btnCloseActivityForm').removeAttr('disabled');
        $('#btnSubmitActivityForm').removeAttr('disabled');
    }
}


function scrollTopForCloseActivityForm(obj) {
    if ($(obj).attr('id') === 'btnCloseActivityForm') {
        scrollTopForvalidations();
    }
}

function scrollTopForvalidations() {
    $("#activityForm").animate({ scrollTop: 0 }, 500);
}

function onAdditionalData() {
    return {
        patientName: $("#PatientName").val(),
        careStaffViewSensitive: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? careStaffViewSensitiveforPH : careStaffViewSensitive,
        ActiveInactiveMemberFilter: ActiveInactiveMemberFilter
    };
}

function onActChange() {
    if ($(this)[0]._old != '') {
        $("#ddlCareStaffAddActivity").prop('disabled', false);
        $("#divGroupActivity #chkGroupActivity").prop('disabled', false);
    } else {
        $('#divPatientNameField').hide();
        $('#divPatientName').html('');
        $('#activityForm #PatientId').val('');
        $('#ddlCareStaffAddActivity').val('');
        $('#hdnCareStaffAddActivity').val('');
        if ($("#divGroupActivity #chkGroupActivity").prop('checked')) {
            $("#divGroupActivity #chkGroupActivity").trigger('click');
        }
        $("#divGroupActivity #chkGroupActivity").prop('disabled', true);
        $("#ddlCareStaffAddActivity").prop('disabled', true);
    }

}

function onChangePatientName(e) {
    if ($.trim(e.sender.value()) === "") {
        $('#activityForm #PatientId').val("0");
    }
}

function onSelect(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    selectedMemberIdForActivityAddEdit = DataItem.PatientId;
    $('#divPatientName').html('');
    $('#divPatientName').html(DataItem.PatientFullName)
    $('#activityForm #PatientId').val(DataItem.PatientId);
    isPHSensitiveMember = DataItem.IsSensitiveDiagnosis.toString();
    if (isPHSensitiveMember == "true" && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
        $("#selectScheduledType").val(1);
        $('#selectScheduledType').attr('disabled', true);
        $("#selectScheduledType").trigger('change');
    }
    else {
        $("#selectScheduledType").val(0);
        $('#selectScheduledType').attr('disabled', false);
        $("#selectScheduledType").trigger('change');
    }
    $('#divPatientNameField').show();
    if (!$('#selectScript').is(':hidden'))
        loadDropDown(baseURL + '/Home/LoadScriptDDL?careActivityTypeId=' + $('#selectActivityType').val() + '&patId=' + DataItem.PatientId, 'selectScript', editActscriptId);
    else {
        CreateDropCheck('divAddActCareTeam', baseURL + '/PatientCareTeam/LoadCareTeamDdl?activityPatientID=' + DataItem.PatientId + '&careTeamIds=' + careTeamIds, 'AddActCareTeam', 0, careTeamIds, null, null, 'FullName', 'PhysicianId');
    }
    $('#chkProgramActivity, #chkCliProgramActivity').removeAttr('disabled');
    if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
        loadDropDown(baseURL + '/Master/BindCarePlanProviders?PatientId=' + (DataItem.PatientId)//$("#PatientName").length == 0 ? $('#selectPatientAccessed').val() :
            , "ddlExCareStaff", null, null, 'ProviderId', 'ProviderName');
        fnSearchableDropDownMethod("#ddlExCareStaff");
        $("#ddlExCareStaff").data("kendoDropDownList").enable(true);
    }
    $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameWithRole));
    $('#hdnCareStaffAddActivity').val(memberidval);
    if ($('#activityForm #PatientId').val() == 0) {//calendar double click add activity

        $("#divGroupActivity #chkGroupActivity").prop('disabled', true);
        $("#ddlCareStaffAddActivity").prop('disabled', true);

    } else {
        $("#ddlCareStaffAddActivity").prop('disabled', false);
        $("#chkGroupActivity").prop('disabled', false);
    }

}

function ClearAddAppointment() {
    $('#PhysicianCode').val('');
    $('#ProviderName').val('');
    $('#ProviderType').val('');
    $('#CellPhone').val('');
    $('#City').val('');
    $('#ProviderEmail').val('');
}

function FunFetchCareProviderDetails(PhysicianID) {
    $.ajax({
        type: "POST",
        url: baseURL + "/Dashboard/FetchCareProviderDetails?PhysicianID=" + PhysicianID,
        dataType: "json",
        success: function (data) {
            if (data != null && data.success && data.success == true) {
                var DataItemVal = data.val;
                if (DataItemVal != null && DataItemVal.length > 0) {
                    $('#PhysicianCode').val(DataItemVal[0].PhysicianCode);
                    if (DataItemVal[0].ProviderName != null)
                        $('#ProviderName').val(DataItemVal[0].ProviderName);
                    else
                        $('#ProviderName').val(DataItemVal[0].FirstName + ' ' + DataItemVal[0].LastName);
                    $('#ProviderType').val(DataItemVal[0].ProviderType);
                    $('#hdnISduplicateMail').val(DataItemVal[0].IsDuplicateEmail);
                    $('#CellPhone').val(DataItemVal[0].CellPhone);
                    var Address = DataItemVal[0].Address == null ? "" : DataItemVal[0].Address;
                    $('#City').val(Address);  //PROD-10714 Binding only Address, since we are already combining Address text,City,State,Country and zip as address in SP.
                    $('#ProviderEmail').val(DataItemVal[0].Email);
                    $('#HealthifyId').val(DataItemVal[0].HealthifyId);
                    $('#IsPreferredProvider').val('');
                    $('#IsPreferredProvider').val(DataItemVal[0].IsPreferredProvider == null ? "" : DataItemVal[0].IsPreferredProvider);
                    $('#chkIsSentEmail').attr('disabled', 'disabled'); $('#chkIsSentEmail').prop('checked', true);
                    if (DataItemVal[0].HealthifyId == null || DataItemVal[0].HealthifyId == '') { $('#chkIsSentEmail').removeAttr('disabled'); }
                    else if (!DataItemVal[0].IsPreferredProvider) { $('#chkIsSentEmail').prop('checked', false); }
                    if (clientName != 'UHC') {
                        $('#chkIsSentEmail').attr('disabled', false); $('#chkIsSentEmail').prop('checked', true);
                    }
                }
            }
        },
        error: function () {
            //alert('error handling here');
        }
    });
}

//UM Related-Service Plan
function validateStartEndDates(startVal, endVal, msg) {
    var startDate = new Date(startVal);
    var endDate = new Date(endVal);
    if (!isValidDate(startVal) || !isValidDate(endVal)) {
        CustomAlert("Invalid date format");
        return false;
    }
    if (startDate > endDate) {
        if (msg == undefined) {
            CustomAlert('End date should be greater than start date.');
            return false;
        }
        if (msg == 0) {
            CustomAlert('Valid from date should not be greater than valid to date');
            return false;
        }
    }
    else
        return true;
}
//UM -Service Plan

function ClearAddActivity() {
    resetActivityCntrlsReqActClinicalPrograms();
    //uhc-69
    if ($("#selectScheduledType").val() == "1") {
        if ($('#IsFromBulkActivity').val() == 'true') { //uhc-69
            $("#selectActivityType").closest(".k-widget").show();
            $('#ddlActTypeCompleted').hide();
        }
        else {
            $("#selectActivityType").closest(".k-widget").hide();
            $('#ddlActTypeCompleted').show();
        }
        //  $('#ddlActTypeCompleted :checkbox').attr('checked', false);
        $('.cbCareActTypeComp').attr('checked', false);
        var kendoDropdown = $("#ddlActTypeCompletedKD").data("kendoDropDownList");
        if (kendoDropdown) {
            kendoDropdown.value("-1");
        }
        $("#ddlActTypeCompleted").find('.k-input').html('Select');
        $("#AddActTypeCompletedhdn").val("");
        $('#AddActTypeCompletedval').val('');
        $('#AddActTypeCompletedhdntxt').val('');
        closedActivitySelected = [];
        closedActivitySelectedText = [];
    }
    else {
        $("#selectActivityType").closest(".k-widget").show();
        $('#ddlActTypeCompleted').hide();
    }
    $('#divJoinMeetingDetails').html('');
    $('#divTelehealthSection').hide();
    $('#divWarningSection').hide();
    $('#txtAddOrChangeEmail').val('');
    $('#selectMemberEmail').val('-1');
    $('#txtAddOrChangeEmail').removeAttr('disabled');
    $('#selectMemberEmail').removeAttr('disabled');

    //uhc-69
    $('#ddlStaffIds').html('');
    $('#activityForm').scrollTop(0)
    //$('#selectActivityType').val(-1);
    // if ($("#selectActivityType").is(':visible')) { $("#selectActivityType").data("kendoDropDownList").value(-1); }
    $('#chkGroupActivity').prop('checked', false);
    $('#ddlDepartmentIdhdn').val('');
    var dropdown = $("#selectActivityType").data("kendoDropDownList");
    if (dropdown) {
        dropdown.value("");
        dropdown.dataSource.read();
    }
    $('#selectScript').val(-1);
    resetScriptDropdownForAddActivity();
    $('#selectPriority').val(-1);
    loadDropDown(baseURL + '/Master/LoadContactTypeDDL/', 'selectContactType', venueId, null, 'VenueId', 'VenueName', null, null);
    $('#FollowupHrs').val('00');
    $('#FollowupMins').val('30');
    $('#FollowupDate').kendoDateTimePicker({ value: new Date(currentFollowupdate), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat(), interval: 30 });
    //uhc-2019
    $('#DueDate').val('');
    //$('#chkIsRecurringActivity').checked = false;
    //$('#selectCareStaff').val(CurrentUserId);
    if ((isMTMval === false || isMTMval.toLowerCase() === 'false')) {
        $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameWithRole));
        $('#hdnCareStaffAddActivity').val(memberidval);
    }
    else {
        ClearAddActivityCSFields();
    }

    $('#Comments').val('');
    $('#CanPerform').checked = true;
    $('#divDepartment').hide();
    $('#divCareStaffBydept').hide();
    $('#AddActProfileNotMatchInfoMsg').hide();
    if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
        $('#divIdCareStaff').hide();
        $('#divIdExCareStaff').show();
        $('#divProgramActivity, #divCliProgramActivity').hide();
        $("#btnCheckActivityForm").hide();
    }
    else {
        $('#divIdCareStaff').show();
        $('#divIdExCareStaff').hide();
        $("#btnCheckActivityForm").show();
        $("#btnCheckActivityForm").prop('disabled', false);
        if ($('#rdoEAInternal').attr('data-fromSchedulerIconPH') === "1" || ($('#IsFromBulkActivity').val() === 'true' && ($('#bulkPatientIdAddActivity').val() || '').indexOf(',') > 0)) {
            $('#divProgramActivity, #divCliProgramActivity').hide();
        } else {
            $('#divProgramActivity, #divCliProgramActivity').show();
        }
    }

    $('#chkIsRecurringActivity').attr('checked', false);
    $('#divRecurringActivitySchedule,.recurringType').hide();
    $('#divRecurringActivity').show();


    $("#lstDeptIds").val(-1);
    $("#selOpenAuthStaffIds").val(-1);
    $('#chkGroupActivity').attr('checked', false);
    if ($("#selectScheduledType").val() == "2") {
        $('#divIdCareStaff').hide();
        /*PROD-857--- Clearing  Care Team Multi select*/
        if ($("#AddActCareTeamhdnurl").val() != null && $("#AddActCareTeamhdnurl").val() != '')
            CreateDropCheck('divAddActCareTeam', $("#AddActCareTeamhdnurl").val(), 'AddActCareTeam', 0, null, null, null, 'FullName', 'PhysicianId');
    }
    else {
        if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") {
            $('#divIdCareStaff').hide();
            $('#divIdExCareStaff').show();
        }
        else {
            $('#divIdCareStaff').show();
            $('#divIdExCareStaff').hide();
        }
    }
    $('#ddlActivityOutcomeType').val(-1);
    $('#ddlActivityOutcome').val(-1);
    $('#ddlActivityPlaceOfService').val(-1);
    $('#OutComeComments').val('');
    ShowHideHasNotification(0);
    $('#chkReturnActivityNotification').attr("checked", false);


    if ($('#selectScheduledType').val() == 1) {
        $('#ActualFollowupHrs').val('');
        $('#ActualFollowupMins').val('');
        $('#ddlHCPCCode').val(-1);
        if ($("#ddlActivityOutcome").data("kendoDropDownList") != undefined) {
            $("#ddlActivityOutcome").data("kendoDropDownList").value(-1);
        }
        else {
            $("#ddlActivityOutcome").val(-1);
        }
        $("#ddlActivityOutcomeType").val(1);
    }
    //Program Activities//
    $('#chkProgramActivity, #chkCliProgramActivity').attr('checked', false).attr('disabled', false);
    $('#divProgramActLob, #divClinicalProg').hide();
    $('#divCareStaffBydept').hide();
    if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL")
        $('#divIdCareStaff').hide();
    else
        $('#divGroupActivity').show();
    //Program Activities//
    if ($('#selectScheduledType').val() == 1) {
        $('#divGroupActivity').hide();
        $('#divRecurringActivity').hide();
    }
    if ($('#selectScheduledType').val() == 2) {
        $('#divGroupActivity').hide();
        $('#divRecurringActivity').hide();
        $('#divProgramActivity, #divCliProgramActivity').hide();
    } else {
        $('#divIdAddActCareTeam').hide();
    }
    if ($(".EACareStaffType:checked").val() == "PHARMACIST") {
        ShowHidePharmacistFields();
    }
    $('#divcustomfields, #divOutComeCustomField').html("");
    ShowHideActivityCntrlsForMTMUser($(".EACareStaffType:checked").val());

}

function ShowHidePharmacistFields() {
    $("#divIdPharmacyCareStaff,#divAHNIsConfidential").show();
    $("#divGroupActivity, #divContainerMemberPortalActivity,#divIdCareStaff,#divIdExCareStaff,#divContainerCanPerform,#divProgramActivity,#divCliProgramActivity,#divEditProgramActLob").hide();
    $('#divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
    ShowHideActivityCntrlsForMTMUser($(".EACareStaffType:checked").val());
}

function ShowHideActivityCntrlsForMTMUser(val) {
    if (isMTMval === true || isMTMval.toLowerCase() === 'true') {
        $('#ddlCareStaffAddActivity').val(unescapeHtml(careStaffFullNameWithRole));
        $('#hdnCareStaffAddActivity').val(memberidval);
        $('#divProgramActivity, #divCliProgramActivity, #divGroupActivity').hide();
        $('#divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
        if (val == "PHARMACIST") {
            $('#divProgramActivity, #divCliProgramActivity').show();
        }
    }
    else if ((isMTMval === false || isMTMval.toLowerCase() === 'false') && val == "PHARMACIST") {
        $('#divProgramActivity, #divCliProgramActivity, #divGroupActivity').hide();
        $('#divDepartment, #divCareStaffBydept, #AddActProfileNotMatchInfoMsg').hide();
    }
    ShowHideCareStaffToMTM();
}

function ClearAddActivityCSFields() {
    $('#hdnCareStaffAddActivity,#hdnExCareStaffAddActivity,#hdnPharmacyCareStaffAddActivity').val('');
    $('#divTelehealthSection').hide();
    $('#ddlCareStaffAddActivity,#ddlPharmacyCareStaffAddActivity').val('');
    if ($("#ddlExCareStaff").data("kendoDropDownList") != undefined && $("#ddlExCareStaff").data("kendoDropDownList") != null)
        $("#ddlExCareStaff").data("kendoDropDownList").value(-1);
}

function onLoadMyAlerts() {
    $(document).off('click', '.clsanchorAlertCount').on('click', '.clsanchorAlertCount', function () {
        if (iscmval === 'True' || isPHval === 'True') {
            clientPatientIdFromWellframe = !$.fn.isNullOrEmpty($(this).attr('data-clientPatientId')) ? $(this).attr('data-clientPatientId') : "";
            globalAlertFilter = $(this).attr('Id').split('_')[1];
            setTopLeftCurrentVal();
            globalAlertFilterText = $(this).data('alertdesc');
            LoadMemberDtl();
            if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))//added condition to hide primary care members dropdown in PH section only
                $('#MymemCareDropList').hide();
            SetArrowsMembers();
            if (chkMaxMinHghtMyAlertsPartialViewContainer == 0) {
                $('#btnMyAlertsecCollapse').trigger('click');
            }
            $('#popClose').trigger('click');
        }
        $('#resetMymembersGrid').show();
        $('#memberGrid .divClsMemberMenu').hide();
        myMembersFilterTooltip.refreshTooltipContent();
    });
}

function ValidateActivity(obj, isEdit) {
    if (ISPHMembers && isProvider) {
        var IsProfile = $(obj).attr('data-IsProfile');
        if (IsProfile == "0") {
            isEdit = isEdit || false;
            if (isEdit)
                CmnStatusMessageDisp('spanAlertActivity', 'Activity cannot be edited as member is inactive', 'Error');
            else
                CmnStatusMessageDisp('spanAlertActivity', 'Activity cannot be performed as member is inactive', 'Error');
            return false;
        }
        else
            return true;
    }
    else {
        return true;
    }
}

function closeGlobalCalenderPopup() {
    if ($('#popUpGlobalMySchedule').is(':visible')) {
        $('#popUpGlobalMySchedule #closePopUp').trigger('click');
    }
}
function onLoadMyCalendar() {
    //$(document).off('mouseover', '.ActActive,.MSActActive,.ActActiveUM').on('mouseover', '.ActActive,.MSActActive,.ActActiveUM', function () {
    //    $(this).find('.anchorDeleteActivity').css("visibility", "visible");
    //});
    //$(document).off('mouseout', '.ActActive,.MSActActive,.ActActiveUM').on('mouseout', '.ActActive,.MSActActive,.ActActiveUM', function () {
    //    $(this).find('.anchorDeleteActivity').css("visibility", "hidden");
    //});
    $("body").off("click", ".REdit").on("click", ".REdit", function () {
        if (!ValidateActivity($(this), true))
            return;
        var groupId = $(this).data('groupid');
        var meetingId = $(this).data('meetingguid');
        meetingGuid = meetingId;
        var QueueId = $(this).data('queueid');
        var WorkQueue = $(this).data('workqueue');
        var StaffIds = $(this).data('staffids');
        var DepId = $(this).data('depid');
        var x = $(this).attr("id").split('_')[1];
        var url = "";
        var patientId = $(this).data('patientid');
        var isCaseConference = false;
        selectedMemberIdForActivityAddEdit = patientId;
        //here tab value has to take - Srujan J
        if (($("#spnInternalActivity").is(":visible") && $("#spnInternalActivity").hasClass("divClsToDoListAct")) || $(this).data('isexternalactivity') != 'External') {
            url = baseURL + "/Home/EditActivity?ActId=" + x + "&DisableWorkQueue=" + true + "&isProvider=" + isProviderUser;
        }
        else
            url = baseURL + "/Home/EditActivity?ActId=" + x + "&type=External";

        let rowRecordId = $(this).attr("id");
        if (patientId > 0) {
            url = url + '&patientId=' + patientId;
        }

        $('#popUpDialog1').CMNPopup({
            pvUrl: url,
            onLoad: function () {
                if (meetingId !== '' && meetingId !== null) {
                    getMeetingDetails(meetingId, function (data) {
                        if (data.success) {
                            var meetingObj;
                            if (data.data.MeetingResponse) {
                                $("#btnGenerateMeeting").val('Update & Send Meeting Details');
                                meetingObj = data.data.MeetingResponse;
                                joinURL = meetingObj.JoinWebUrl;
                                $('#divJoinMeetingDetails').AhsSetHtml(unescape(meetingObj.Content).replace(/\+/g, ' ').replace('data:text/html,', ''));
                                $('#divJoinMeetingDetails').show();
                                checkForMeetingValidation(true);
                                $('#divMeetingDetails').show();
                            }
                        };
                    });
                }
                if (groupId && groupId > 0) {
                    $('#selectScheduledType').val(2);
                    isCaseConference = true;
                }
                onLoadEditActivity();
                $('#selectScheduledType').attr('disabled', 'disabled');
                if (isCaseConference) {
                    $('#ScheduleTypeText').val('Case Conference');
                    A11yDropcheck.setDisabled('divAddActCareTeam');
                    $('#btnCrTmReset').hide();
                    $("#divIdAddActCareTeam").show();
                    $('#divIdCareStaff').hide();
                    $('.scheduledType').hide();
                    contactTypeChangeOnEdit();
                }
                $("#rdoEAInternal").attr("disabled", true);
                $("#rdoEAExternal").attr("disabled", true);
                $("#rdoPharmacist").attr("disabled", true);
                //else if (QueueId != 'undefined' && QueueId != null && QueueId != '' && QueueId > 0) {

                if (!$("#spnInternalActivity").hasClass("divClsToDoListAct")) {
                    if ($("#ddlExCareStaff").data("kendoDropDownList") != undefined && $("#ddlExCareStaff").data("kendoDropDownList") != null)
                        $("#ddlExCareStaff").data("kendoDropDownList").enable(false);
                }
                if ($("#chkGroupActivity").is(":checked") == false && $('#selectScheduledType :selected').text().toLowerCase() == "scheduled") {
                    $('#divRecurringActivity').show();
                }
                else
                    $('#divRecurringActivity').hide();


                //    $('#divGroupActivity').show();
                //    $('#chkGroupActivity').prop('checked', true);
                //    $('#chkGroupActivity').trigger("click");
                //    //$('#ddlDepartment').val(DepId);
                //    CreateDropCheck('ddlDepartment', baseURL + '/Home/BindWorkQueues/', 'ddlDepartmentId', 0, DepId);
                //    CreateDropCheck('ddlStaffIds', baseURL + '/Home/GetCmStaffIdsEditGropActivity?deptId=' + DepId, 'ddlStaffIdsId', 0, StaffIds);
                //}
                if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() === "EXTERNAL") {
                    $('#divGroupActivity, #divProgramActivity, #divCliProgramActivity').hide();
                }
                else if ($('#selectScheduledType').val() === "2") {//Case Conference
                    $('#divGroupActivity, #divProgramActivity, #divCliProgramActivity').hide();
                }
                else if ($('#chkProgramActivity').is(':checked') || $('#chkCliProgramActivity').is(':checked')) {
                    $('#divProgramActivity, #divCliProgramActivity').show();
                }
                else if (!isNaN(parseInt(wqQueueId)) && parseInt(wqQueueId) > 0) {
                    $('#divGroupActivity').show();
                }
                $(document).off('click', '.EACareStaffType');
                ShowHideActivityCntrlsForMTMUser($(".EACareStaffType:checked").val());
                // hiding the Update button and making the Update and Close button the primary
                $('#btnSubmitActivityForm').hide();
                $('#btnCloseActivityForm').removeClass('ah-btn-secondary').addClass('ah-btn-primary');
                A11yModal.trapFocusInModal('popUpDialog1');
            },
            onClose: function () {
                ClearActivityHdnCntrls();
                if ($("#scheduler").length > 0 && $("#scheduler").is(":visible") && $("#scheduler").data("kendoScheduler").view().title.toLowerCase() === "day") {
                    $('#btnMyCalRfsh').trigger('click');
                    setTimeout(function () {
                        // have to put this in a timeout due to the call to refresh the calendar abov (the button actually goes away until the refresh is complete)
                        A11yUtil.setFocus(rowRecordId);
                    }, 500);
                }
                $('#popUpDialog1').html('');
            },
            popUpHeader: "Edit Activity",
            modalWidth: MODAL_WIDTH.MEDIUM,
            triggerBtnId: rowRecordId,
            closeButton: "#btnCloseEditActivityForm"
        });
    });
    // CODE FOR EDIT ACTIVITY UM ............... START...............
    $("body").off("click", ".UEdit").on("click", ".UEdit", function () {
        if ($(this).attr("id") != undefined) {
            if (!ValidateActivity($(this), true))
                return;
            var patientId = $(this).data('patientid');
            loader(1);
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Home/OpenAuthAddActivity?ActId=" + $(this).attr("id").split('_')[1] + "&PatientId=" + patientId,
                onLoad: function () {
                    onLoadOpenAuthAddAct();
                    $('#loaderImg').hide();
                    $('#btnSubmitActivityForm').css('display', 'none');
                    $('#btnSubmitCloseActivityForm').css('display', 'none');
                    $('#btnUpdateActivityForm').css('display', 'inline');
                    $('#btnUpdateCloseActivityForm').css('display', 'inline');

                },
                popUpHeader: "Edit Activity",
                closeButton: '#closebutton'
            });
            loader(0);
        }
    });

    $("body").off("click", ".AEdit").on("click", ".AEdit", function () {
        if (!ValidateActivity($(this), true))
            return;
        var slcId = 0;
        appId = $(this).attr('id').split('_')[1];
        var patientid = $(this).data('patientid');

        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/RequestReceivedDashboard/UpdateAppointment?appointmentId=" + appId + "&timeDictionaryObj=" + escape(timeZone) + "&patientid=" + patientid,
            onLoad: function () {
                onLoadUpdateAppointment(slcId);
            },
            closeButton: '#btnCloseAppointmentUpdatePopup',
            popUpHeader: "Update Appointment",
        });
    });
    $("body").off("click", ".ARun").on("click", ".ARun", function () {
        if (!ValidateActivity($(this)))
            return;
        var slcId = 4;
        appId = $(this).attr('id').split('_')[1];
        var patientid = $(this).data('patientid');
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/RequestReceivedDashboard/UpdateAppointment?appointmentId=" + appId + "&timeDictionaryObj=" + escape(timeZone) + "&patientid=" + patientid,
            onLoad: function () {
                onLoadUpdateAppointment(slcId);
            },
            popUpHeader: "Update Appointment"
        });
    });
    //........................END.......................................

    // CODE FOR PERFORM ACTIVITY UM ............... START...............

    $("body").off("click", ".URun").on("click", ".URun", function () {
        if (!ValidateActivity($(this)))
            return;
        var ActivityId = $(this).attr("id").split('_')[1];
        var data = $(this).attr("id").split('_')[2]
        var AuthId = data.split('|')[1];
        var PatientId = data.split('|')[0];
        var AuthNo = data.split('|')[3]
        loader(1);
        if (isNewMdrReview) {
            closeGlobalCalenderPopup();
            ClickFireAuthId(AuthId, PatientId, ActivityId);
        }
        else {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/CommonDefaultSessionState/OpenAuthPerformActivityUM?AuthNo=" + AuthNo + "&ActID=" + $(this).attr("id").split('_')[1] + "&TimeDictionaryobj=" + timeZone + "&patientId=" + PatientId,
                onLoad: function () {
                    onLoadOpenAuthPerformActivityUM(); // OpenMilliman(AuthNo);                
                    $("#btnAddPenActAuth").ApplyRoleConfig({ UniqueName: "AHS_DASHBOARD_CALENDAR_UM_ACTIVITIES", Id: "btnAddPenActAuth", IsFrom: "Add", IsRemoveElement: true });
                },
                popUpHeader: "Medical Director Review For UM",
                popLevel: 0,
                closeButton: '#btnUmclosebutton'
            });
            loader(0);
        }

    });



    //........................END.......................................

    // CODE FOR Redirect ACTIVITY UM ............... START...............

    //Pending Activities
    //function perform(AuthNo, Actid) {
    //    $('#popUpDialog1').CMNPopup({
    //        pvUrl: baseURL + "/Home/OpenAuthPerformActivityUM?AuthNo=" + AuthNo + "&ActID=" + Actid,
    //        onLoad: function () {
    //            onLoadOpenAuthPerformActivityUM(); //OpenMilliman(AuthNo);
    //            ShowGuidLines(AuthNo);
    //        },
    //        popUpHeader: "UM Activity",
    //        popLevel: 0,
    //        closeButton: '#btnUmclosebutton'
    //    });
    //    return false;
    //}


    function ShowGuidLines(AuthNo) {
        $(document).off('click', '#btnGuidelines').on('click', '#btnGuidelines', function () {

            $('#popUpDialog2').CMNPopup({
                pvUrl: baseURL + "/Authorizations/AuthGuideLineSummary?AuthNo=" + AuthNo,
                popUpHeader: "Show Guidelines",
                popLevel: 1
            });

        });
    }


    function OpenMillimanExternalLink(params) {

        try {
            var paramsMiliman = $(params).attr('data-details');
            var varlist = paramsMiliman.split('|');
            var Params = "authNO=" + varlist[0] + "&episodeID=" + varlist[1] + "&requestTYPE=" + 'EpisodeSummary' + "&staffID=" + memberidval + "&patientID=" + varlist[2] + "&decisionID=" + varlist[3];

            $.ajax({
                type: "POST",
                url: baseURL + "/Home/OpenMillimanURL?AuthNO=" + varlist[0],
                dataType: "json",
                success: function (data) {
                    if (data.success && data.success == true) {
                        var MURL = "";
                        if (data.val.split(',')[5] != null && data.val.split(',')[5] != "") {
                            window.open(data.val.split(',')[5] + "?" + Params, (window.browserPopUpName || window.top.browserPopUpName), 'height=750,width=1200,status=no,toolbar=no,menubar=no,location=no, scrollbar=yes');
                        }
                        else {
                            window.open('App_Pages/UM/MillimanGuidelines/MillimanGuidelines.aspx?' + Params, (window.browserPopUpName || window.top.browserPopUpName), 'height=650,width=800,status=yes,toolbar=no,menubar=no,location=no, scrollbar=yes');
                        }

                    }

                },
                error: function () {
                    //alert('error handling here');
                }
            });
        } catch (ex) {
            console.log(ex.message);
        }
    }


    function OpenMilliman(AuthNo) {
        $.ajax({
            type: "POST",
            url: baseURL + "/Home/OpenMillimanURL?AuthNO=" + AuthNo,
            dataType: "json",
            success: function (data) {
                if (data.success && data.success == true) {
                    var MURL = "";
                    if (data.val.split(',')[5] != null && data.val.split(',')[5] != "") {
                        MURL = "window.open('" + data.val.split(',')[5] + "?decisionID=" + data.val.split(',')[2] + "&authNO=" + data.val.split(',')[0] + "&requestTYPE=EpisodeSummary&staffID=" + data.val.split(',')[6] + "&patientID=" + data.val.split(',')[3] + "&episodeID=" + data.val.split(',')[1] + "'," + (window.browserPopUpName || window.top.browserPopUpName) + ",'height=750,width=1200,status=no,toolbar=no,menubar=no,location=no, scrollbar=yes');";
                    }
                    else {
                        MURL = "window.open('App_Pages/UM/MillimanGuidelines/MillimanGuidelines.aspx?decisionID=" + data.val.split(',')[2] + "&authID=" + data.val.split(',')[0] + "&patID=" + data.val.split(',')[3] + "&reviewID=" + data.val.split(',')[1] + "'," + (window.browserPopUpName || window.top.browserPopUpName) + ",'height=650,width=800,status=yes,toolbar=no,menubar=no,location=no, scrollbar=yes');";
                    }
                    $('#btnGuidelines').AhsSetAttr('onclick', MURL);
                }
                else {
                    $('#btnGuidelines').css('cursor', 'auto');
                }
            },
            error: function () {
                //alert('error handling here');
            }
        });
    }
    function UmAuthNo(obj) {
        var AuthNo = '';
        if (obj == 0) { AuthNo = $("#AuthNo").val(); }
        else { AuthNo = $("#hdnAuthtnAuthNo").val(); }
        return {
            AuthNo: AuthNo,
            MemberId: memberidval
        }
    }

    function ViewAuth(authid) {

        //$(document).ready(function () {
        //    
        //    //if (grdName == "PendingAuthActvtsMAL") {
        //    //    $('#popUpDialog1').CMNPopup({
        //    //        pvUrl: baseURL + "/Home/ViewAuthSummary?AuthId=" + authid,
        //    //        popUpHeader: "AUTH SUMMARY",
        //    //    });
        //    //}
        //    //else {
        //    $("#_myAlertsPartialViewContainer").html('');
        //    $("#_myAlertsPartialViewContainer").load(baseURL + "/Home/ViewAuthSummary?AuthId=" + authid);
        //    $('#spanMyAlertsHeaderName').html('').html('Auth Summary');
        //    //}
        //});
    }


    //end UM activity

    $("body").off("click", ".URed").on("click", ".URed", function () {
        redirectUmActivity(this);
    });

    //........................END.......................................

    $("#scheduler").off("dblclick", "td[role='gridcell']").on("dblclick", "td[role='gridcell']", function () {
        var isActvtPopupShown = $('#popUpDialog1').is(':visible');
        var isAcceptPopupShown = $('#divRequestAcceptCommentsPopup,#divMSRequestAcceptCommentsPopup,#divUMRequestAcceptCommentsPopup').is(':visible');


        var isGlobalCalShown = $('#popUpGlobalCalendar').is(':visible');
        var hdnGCval = $('#hdnIsFromMyACTlog').val();
        var gridCell = $(this);
        var date = $(gridCell).find('.divDayTemplate').attr('title');
        if (isActvtPopupShown) {
            $('#popUpGlobalCalendar #closePopUp').click();
            $("#FollowupDate").kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
            return false;
        }
        if (isAcceptPopupShown) {
            $('#popUpGlobalCalendar #closePopUp').click();
            $("#txtAcceptCommentsFolloUpdate_" + hdnGCval).kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat() });
            $("#txtMSAcceptCommentsFolloUpdate_" + hdnGCval).kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
            $("#txtUMAcceptCommentsFolloUpdate_" + hdnGCval).kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
            return false;
        }
        if (hdnGCval == 'actlog') {
            $('#popUpGlobalCalendar #closePopUp').click();
            var elemDate = $("#id1frame").contents().find(".riTextBox")[0];
            if (date.charAt(0) === '0') date = date.slice(1);
            $(elemDate).val(date); $(elemDate).focus();
            return false;
        }
        if (hdnGCval == 'actlogrr') {
            var rowNum = $('#hdnACTrrRowNum').val();
            $('#popUpGlobalCalendar #closePopUp').click();
            var table = $("#id1frame").contents().find("#gvBulkAccept");
            $(table).find(">tbody > tr").each(function (index, row) {
                if (index == rowNum) { //escape header with row[0]
                    var elemDate = $(this).find(".riTextBox")[0];
                    if (date.charAt(0) === '0') date = date.slice(1);
                    $(elemDate).val(date); $(elemDate).focus();
                }
            });
            return false;
        }
        var patid = showCareStaffCal ? 0 : calPatientId;
        if (!isGlobalCalShown) {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Home/EditActivity?patientId=" + patid,
                onLoad: function () {
                    onLoadEditActivity();
                    $('#loaderImg').hide();
                    $("#FollowupDate").kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
                    $('#FollowupHrs').val("00");
                    $('#FollowupMins').val(30);
                    if ($('#divPatientNameForActivity').is(':visible') && $('#activityForm #PatientId').val() == "0") {
                        $('#chkProgramActivity, #chkCliProgramActivity').attr('disabled', 'disabled');
                    }
                    if (isPHSensitiveMember == "true" && patid != 0 && ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1'))) {
                        $("#selectScheduledType").val(1);
                        $('#selectScheduledType').attr('disabled', true);
                        $("#selectScheduledType").trigger('change');
                    }
                    A11yModal.trapFocusInModal('popUpDialog1');
                },
                onClose: function () {
                    ClearActivityHdnCntrls();
                    if ($("#scheduler").length > 0 && $("#scheduler").is(":visible") && $("#scheduler").data("kendoScheduler").view().title.toLowerCase() == "day")
                        $('#btnMyCalRfsh').trigger('click');
                },
                popUpHeader: "Add Activity",
                closeButton: "#btnCloseEditActivityForm",
                modalWidth: MODAL_WIDTH.MEDIUM
            });
        }
        else {
            $('#popUpGlobalCalendar #closePopUp').click();
            $("#FollowupDate").kendoDateTimePicker({ value: new Date(date), format: getDateWithoutSecondFormat(), timeFormat: getTimeWithOutSecondFormat() });
        }
        return false;
    });

    $("body").off("click", ".AGRed").on("click", ".AGRed", function () {
        isRedirectToComplaintActivity = 1;
        var complaintId = $(this).attr("id").split('_')[1];
        var data = getComplaintDetailsByComplaintId(complaintId);
        if (data.success !== undefined && data.success === true) {
            if (IsAlertAcknowledgementRequired === 'True' && $('#selectPatientAccessed').val() !== data.val[0].PatientId.toString()) {
                GetAGPatientAlertsAndAcknowledge(data.val[0].PatientId, data.val[0].ComplaintRecordId, 0, 'complaint');
            } else {
                GetComplaintData(complaintId, data);
            }
        }
    });

    /*AGCODE FOR EDIT ACTIVITY*/
    completeActivity();
    deleteActivity();
    CaseConfPerformActivity();
    GetTemplateContentForSelectedEmail();

    var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
    var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
    if (isGlobalCalShown || isGlobalMySchedule) {
        var calDivId = isGlobalCalShown ? "popUpGlobalCalendar" : "popUpGlobalMySchedule";
        var sch = $("#" + calDivId).find("#scheduler");

        $("#" + calDivId).find("#scheduler").data("kendoScheduler").bind("dataBound", function () {
            if (isGlobalCalShown) {
                $(sch).find('.RRun, .REdit, .AGRun, .AGEdit, .AGRed, .MSEdit, .MSRun, .AEdit, .ARun, .UEdit, .URed, .URun ').prop('disabled', true);
                $(sch).find('a.lnkMemInfo').prop("onclick", null);
                $(sch).find('.CMActDelete, .AGActDelete, .MSActDelete, .UMActDelete ').hide();
            }
            var style = "<style> ";
            if ($("#" + calDivId).find("#hdnIsExpandCal").length > 0 && $("#" + calDivId).find("#hdnIsExpandCal").val() == "1") {
                if (!isFromMySchedule) {
                    style += "#" + calDivId + " .k-scheduler-content { height:500px !important; } ";
                    $("#" + calDivId).find("#scheduler").find(".k-scheduler-times").eq(1).height(500);
                } else {
                    style += "#" + calDivId + " .k-scheduler-content { height:450px !important; } ";
                    $("#" + calDivId).find("#scheduler").find(".k-scheduler-times").eq(1).height(450);
                }
                var browser = CheckBrowser();
                if (browser == "IE" || browser == "GC") {
                    style += "#" + calDivId + "  .k-scheduler-dayview .k-scheduler-table td, #" + calDivId + " .k-scheduler-weekview .k-scheduler-table td { height: 60px !important; }";
                }
                else {
                    style += "#" + calDivId + "  .k-scheduler-dayview .k-scheduler-table td { height: 60px !important; }";
                }
            }
            else if ($("#" + calDivId).find("#hdnIsExpandCal").length > 0 && $("#" + calDivId).find("#hdnIsExpandCal").val() == "0") {
                $("#" + calDivId).find(".k-scheduler-times").eq(1).height(425);
                style += " #" + calDivId + " .k-scheduler-content { height:425px !important; } ";
            }
            style += "</style>";
            $("#" + calDivId).append(style);
            if (isGlobalCalShown) {
                if ($("#" + calDivId).find("#hdnIsExpandCal").length > 0 && $("#" + calDivId).find("#hdnIsExpandCal").val() == "1") {
                    $("#" + calDivId).css('height', '640px').css('width', '1000px').css('top', '0px').css('margin-left', '-490px').css("left", "50%");
                }
                else {
                    $("#" + calDivId).css('height', '530px !important').css('width', '800px').css('top', '0px').css("left", "50%");
                }
            }
            else {
                if ($("#" + calDivId).find("#hdnIsExpandCal").length > 0 && $("#" + calDivId).find("#hdnIsExpandCal").val() == "1") {
                    if (!isFromMySchedule)
                        $("#" + calDivId).css('height', '640px').css('width', '1200px').css('top', '0px').css('margin-left', '-590px').css("left", "50%");
                    else
                        $("#" + calDivId).css('height', '590px').css('width', '1000px').css('top', '50px').css('margin-left', '-513px').css("left", "45%");
                }
                else if ($("#" + calDivId).find("#hdnIsExpandCal").length > 0 && $("#" + calDivId).find("#hdnIsExpandCal").val() == "0") {
                    $("#" + calDivId).css('height', '530px').css('width', '810px').css('top', '0px').css("left", "50%");
                }
            }

            //$(".lnkMemInfo").aToolTip();
        });
        loader(0);
    }

    $(document).off('mouseover', '.MVRun').on('mouseover', '.MVRun', function () {
        var pfid = $(this).attr('id').split('_')[1];
        var actId = $(this).attr('id');
        var title = "";
        btnMVRunMouseOverId = $(this).attr('id');
        var meetingId = $('#btnMVRun_' + pfid).data('meetingguid');
        getMeetingDetails(meetingId, function (data) {
            if (data.success) {
                var meetingInfo = data.data.MeetingResponse;
                if (meetingInfo != null) {
                    var meetingStartDateTime = new Date(meetingInfo.StartDateTime);
                    var meetingEndDateTime = new Date(meetingInfo.EndDateTime);
                    var meetingStartDateHour = ("0" + ((meetingStartDateTime.getHours() % 12) || 12)).slice(-2);
                    var meetingEndDateHour = ("0" + ((meetingEndDateTime.getHours() % 12) || 12)).slice(-2);
                    var startTime = meetingStartDateHour + ':' + ("0" + meetingStartDateTime.getMinutes()).slice(-2) + ' ' + (meetingStartDateTime.getHours() < 12 ? 'AM' : 'PM');
                    var endTime = meetingEndDateHour + ':' + ("0" + meetingEndDateTime.getMinutes()).slice(-2) + ' ' + (meetingEndDateTime.getHours() < 12 ? 'AM' : 'PM');
                    var name = meetingInfo.Participants.Organizer.upn;
                    var duration = Math.round(((meetingEndDateTime - meetingStartDateTime) / 1000) / 60);
                    title = '<table>';
                    title += '<tr><td class=MVName></td><td style="text-align:left"><b> ' + meetingInfo.Subject + ' </b></td></tr> <tr> <td>&nbsp;</td> </tr>';
                    title += '<tr><td class=MVClock></td><td style="text-align:left"><b> ' + weekdays[meetingStartDateTime.getDay()] + ' ' + meetingStartDateTime.getDate() + 'th, ' + month[meetingStartDateTime.getMonth()] + ' ' + meetingStartDateTime.getFullYear() + ' <br> ' + startTime + ' to ' + endTime + ' (' + duration + ' Minutes) </b></td></tr> <tr> <td>&nbsp;</td> </tr>';
                    title += '<tr><td class=MVOwner></td><td style="text-align:left"><b> ' + careStaffFullName + '</b></td></tr> <tr> <td>&nbsp;</td> </tr>';
                    title += '<tr><td class=MVLocation></td><td style="text-align:left" ><b> Teams </b></td></tr> <tr> <td>&nbsp;</td> </tr>';
                    title += '</table>';
                    btnMVRunMouseOverTable = title;
                }
            };
        })
        $(this).aToolTip({ tipContent: btnMVRunMouseOverTable, toolTipClass: 'clsMVRunCalEvent' });

    });
}

function redirectUmActivity(ele) {
    if (!ValidateActivity($(ele)))
        return;
    var ScriptId = $(ele).attr('Id').split('_')[1];
    var PatientId = ScriptId.split('|')[0];
    $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
    if (isWfChatOpen && parseInt(PatientId) !== parseInt($('#selectPatientAccessed').val())) {
        postUnsentMessageState('postCalenderFlagUmAuthClick', { ScriptId: ScriptId });
    } else {
        postCalenderFlagUmAuthClick(ScriptId);
    }
}

//AGCODE INTEGRATED
function SchedulerAdditionalData() {
    var scheduler = $("#scheduler").data("kendoScheduler");
    var view = scheduler.view();
    var strdate = view.startDate();
    var enddate = view.endDate();
    var endddate = new Date(enddate.getFullYear(), enddate.getMonth(), (enddate.getDate() + 2));
    var isViewCalender = true;
    var calendarCareStaffId = memberidval; // default carestaff id as calendarCareStaffId
    var timeFormatCheck = timeFormat;
    var careStaffAddActivity = 0;
    //Updating CareStaffId to view Scheduler for Add/Edit activity
    if ($("#hdnCareStaffAddActivity").val() !== undefined && $("#hdnCareStaffAddActivity").val() !== "") {
        careStaffAddActivity = $("#hdnCareStaffAddActivity").val();
    }
    var DashboardCalender = getSpecRoleItem("AHS_DASHBOARD_CALENDAR");
    if ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) {
        ISPHMembers = true;
    }
    if (DashboardCalender != undefined && DashboardCalender != null && DashboardCalender.length > 0 && !ISPHMembers) {
        if (DashboardCalender[0].IsView == false) {
            isViewCalender = false;
        }
    }
    if (calAuthnum > 0) {
        var authDetails = $("#chkAuthRow_" + calAuthnum).data('details');
        if (!$.fn.isNullOrEmpty(authDetails) && authDetails.split('|').length > 3) {
            calPatientId = authDetails.split('|')[3];
        }
    }
    if (calComplaintnum > 0) {
        calPatientId = $("#chkComplaintRow_" + calComplaintnum).data('patientid');
    }
    return {
        startDate: strdate, endDate: endddate, patientId: calPatientId, showCareStaffCal: showCareStaffCal, AUTHNO: calAuthnum, MemberId: calendarCareStaffId, ComplaintId: calComplaintnum, TimeDictionaryobj: timeZone,
        careStaffViewSensitive: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? careStaffViewSensitiveforPH : careStaffViewSensitive,
        IsPh: ISPHMembers,
        ActiveInactiveMemberFilter: ActiveInactiveMemberFilter,
        IsViewCalender: isViewCalender,
        isProvider: isProviderUser,
        PhSensitiveApplicable: careStaffViewSensitiveforPH,
        AllowNonPcpUserToViewMembers: allowNonPcpUserToViewMembers,
        DisplayProviderActivities: isDisplayProviderActivities,
        TimeFormat: timeFormatCheck,
        CareStaffAddActivity: careStaffAddActivity
    };
}

function deleteActivity() {
    $(document).off('click', '.anchorDeleteActivity').on('click', '.anchorDeleteActivity', function () {
        //Refactored the code for readability
        var patientFollowUpId = $(this).attr('Id').split('_')[1];
        var patientId = $(this).attr('data-patientid');
        var mdl = "";
        var isScheduleVisibleDel = $('#popUpGlobalMySchedule').is(':visible');
        var ispopUpGlobalCalendarVisible = $('#popUpGlobalCalendar').is(':visible');
        if ($.trim($(this).attr('Id').split('_')[2]) !== "" || $.trim($(this).attr('Id').split('_')[2]) !== undefined) {
            var clsMdl = $.trim($(this).attr('Id').split('_')[2]);
            if (clsMdl === "ActActive") {
                mdl = "CM";
            }
            else if (clsMdl === "ActActiveUM" || clsMdl === "ActActivePhysician") {
                mdl = "UM";
            }
            else if (clsMdl === "MSActActive") {
                mdl = "MS";
            }
            else if (clsMdl.indexOf("ActActiveAG") !== -1) {
                mdl = "AG";
            }
            else {
                mdl = "";
            }
        }

        var dataParams = { actId: patientFollowUpId, patientId: patientId, module: mdl };
        var flag = CustomConfirm('Are you sure you want to delete this activity?');
        if (flag) {
            $.ajax({
                type: "POST",
                url: baseURL + "/Dashboard/DeleteActivity",
                data: dataParams,
                dataType: "json",
                success: function (data) {
                    if (data.success) {
                        CustomAlert('Activity has been deleted successfully');
                        if (ispopUpGlobalCalendarVisible) {
                            var currentView = $('#popUpGlobalCalendar').find("#scheduler").data("kendoScheduler").view().title;
                            if (currentView == "Week") {
                                $("#popUpGlobalCalendar").find("#closePopUp").trigger('click');
                                loadGlobalCalendar();
                            }
                            else {
                                $('#popUpGlobalCalendar').find("#scheduler").data("kendoScheduler").dataSource.read();
                            }
                            if ($("#_myCalendarPartialViewContainer #scheduler").is(":visible")) {
                                $('.k-scheduler-views .k-view-day', "#_myCalendarPartialViewContainer #scheduler").click();
                            }
                        }

                        if (isScheduleVisibleDel) {
                            var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                            if (currentView == "Week") {
                                $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                                loadGlobalMySchedule();
                            }
                            else {
                                $("#scheduler").data("kendoScheduler").dataSource.read();
                            }
                        }
                        if (!isScheduleVisibleDel && !ispopUpGlobalCalendarVisible && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103 
                            $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                                onLoadMyCalendar();
                            });
                        }
                    }
                    else
                        CustomAlert('Error Encountered.');
                }
            });
        }
    });
}

function showInactiveScriptValidation(selector, patientFollowupId) {
    A11yAlerts.create(selector, 'The script associated to this activity is no longer active. Do you want to close this activity?', { alertType: A11yAlerts.ALERT_TYPE.WARNING, isModal: true, keepOpen: false, btnObject: [{ btnId: 'btnYes', btnText: 'Yes' }, { btnId: 'btnNo', btnText: 'No' }] });
    $("#btnYes").off("click").on("click", function () {
        pendingActivityComplete(patientFollowupId, true);
    });
    $("#btnNo").off("click").on("click", function () {
        A11yAlerts.remove();
    });
}

function onPerformActivity() {
    A11yAlerts.remove();
    var _activityPerf = $(this);
    var _patientFollowupId = _activityPerf.attr('id').split('_')[1];
    var scriptId = _activityPerf.attr('data-scriptid');
    var pardata = { scriptId: scriptId };
    $.ajax({
        url: baseURL + "/Assessment/GetActiveInactiveScriptDetails",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            if (data === "False") {
                if (!ValidateActivity(_activityPerf))
                    return;
                var pfid = _activityPerf.attr('id').split('_')[1];
                var patientId = $('#btnRRun_' + pfid).data('patientid');
                loader(1);
                var scriptCompletedCheck = "", reqActPatientId = "";
                if (_activityPerf.data("ignoreactperformcheck") !== undefined) {
                    scriptCompletedCheck = "1";
                    reqActPatientId = patientId;
                }

                var url = '';
                ExternalProviderActivityId = _activityPerf.data('isexternalactivity');
                if (_activityPerf.data('isexternalactivity') === 'External') {
                    url = baseURL + "/Config/CheckIfExtActivityPerformed?moduleId=1" + "&providerFollowupId=" + pfid;
                }
                else {
                    url = baseURL + "/Config/CheckIfActivityPerformed?moduleId=1" + "&refId=" + pfid + "&reqActPatientId=" + reqActPatientId + "&scriptCompleteCheck=" + scriptCompletedCheck;
                }

                $.ajax({
                    type: "GET",
                    url: url,//baseURL + "/Config/CheckIfActivityPerformed?moduleId=1" + "&refId=" + pfid + "&reqActPatientId=" + reqActPatientId + "&scriptCompleteCheck=" + scriptCompletedCheck,
                    dataType: "json",
                    success: function (data) {
                        if (data.result == 1) {
                            CustomAlert("Activity already been performed/ deleted.");
                            refreshGridsBasedOnVisibility();
                            loader(0);
                        }
                        else {
                            completesetactivity(pfid);
                            loader(0);
                        }
                    },
                    error: function () { loader(0); }
                });

            }
            else if (isFromMySchedule) {
                showInactiveScriptValidation('#spanSptSelectMsg', _patientFollowupId);
            } else {
                showInactiveScriptValidation('#divMySchScptActiveInfo', _patientFollowupId);
            }
        },
        error: function () { }
    });
}

//To Make ActivityOutcome as mandatory

function completeActivity() {
    $(document).off('click', '.RRun').on('click', '.RRun', onPerformActivity);

    $(document).off('click', '.MVRun').on('click', '.MVRun', function () {
        pfIdForMeetingWindow = $(this).attr('id').split('_')[1];
        if (!ValidateActivity($(this))) {
            return;
        }
        var patientId = $('#btnMVRun_' + pfIdForMeetingWindow).data('patientid');
        var meetingId = $('#btnMVRun_' + pfIdForMeetingWindow).data('meetingguid');
        var scriptCompletedCheck = "", reqActPatientId = "";
        if ($(this).data("ignoreactperformcheck") !== undefined) { scriptCompletedCheck = "1"; reqActPatientId = patientId; }

        var url = '';
        ExternalProviderActivityId = $(this).data('isexternalactivity');
        if ($(this).data('isexternalactivity') === 'External') {
            url = baseURL + "/Config/CheckIfExtActivityPerformed?moduleId=1" + "&providerFollowupId=" + pfIdForMeetingWindow;
        }
        else {
            url = baseURL + "/Config/CheckIfActivityPerformed?moduleId=1" + "&refId=" + pfIdForMeetingWindow + "&reqActPatientId=" + reqActPatientId + "&scriptCompleteCheck=" + scriptCompletedCheck;
        }

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            success: function (data) {
                if (data.result === 1) {
                    CustomAlert("Activity already been performed/ deleted.");
                    refreshGridsBasedOnVisibility();
                }
                else {
                    var isScriptActivity = false;
                    if ($('#btnMVRun_' + pfIdForMeetingWindow).data('scriptid') > 0) { isScriptActivity = true; }
                    startMeeting(meetingId, isScriptActivity);
                }
            },
            error: function () { loader(0); }
        });
    });
}
function startMeeting(meetingId, isScriptActivity) {
    if (meetingWindow == null || meetingWindow.closed) {
        getMeetingDetails(meetingId, function (data) {
            if (data.success) {
                var meetingInfo = data.data.MeetingResponse;
                if (meetingInfo != null) {
                    var meetingUrl = meetingInfo.JoinWebUrl;
                    meetingWindow = window.open(meetingUrl);
                    if (!isScriptActivity) {
                        meetingWindowTimer = setInterval(checkMeetingWindow, 1000);
                    }
                    else {
                        scriptActivityRun();
                    }
                }
            }
            else {
                CustomAlert("Error Occurred!");
            }
        })
    }
    else {
        meetingWindow.focus();
    }
}
function checkMeetingWindow() {
    if (meetingWindow.closed) {
        completesetactivity(pfIdForMeetingWindow, null, null, 1);
        clearInterval(meetingWindowTimer);
    }
}

function scriptActivityRun() {
    completesetactivity(pfIdForMeetingWindow, null, null, 1);
}

function getMeetingDetails(meetingId, callback) {
    var url = baseURL + "/Activity/GetMeetingDetails?meetingId=" + meetingId
    $.ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success: callback,
        async: false
    });
}

function getMemberInformation(memberId, callback) {
    var url = baseURL + "Member/GetMemberInformation?memberId=" + memberId;
    $.ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success: callback,
        async: false
    });
}

function OpenAcceptMSActivityFrmActivityLog(listReferenceId) {
    $('#divMSRequestAcceptCommentsPopup').CMNPopup({ popUpHeader: "Accept Comments", closeButton: '#btnCloseMSRequestReceivedAcceptComments' });
    $('#divMSRequestAcceptCommentsPopup textarea').val('');
    $('#btnAcceptMSRequestReceivedAcceptComments').prop('disabled', '');
    $('#hdnRequestReceivedAcceptCommentReferenceIds').val(listReferenceId);
    $('#hdnMSRequestReceivedAcceptCrmQueueIds').val('');
    PrepareAcceptMSActivityGrid(listReferenceId);
}

function ViewMSActivityFrmActivityLog(referenceId, viewReject) {
    var parameters = { activityLogId: referenceId, TimeDictionaryobj: timeZone };
    $.ajax({
        type: "GET",
        url: baseURL + "/Activity/ViewMsActivityLog",
        data: parameters,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                $('#divRequestReceivedViewPopup').CMNPopup({ popUpHeader: "Activity Details" });
                $('#divRequestReceivedViewPopup textarea').val('');
                $('#tblRRActivityDetails').show();
                $('#tblRRUMAuthdetails').hide();
                $('#tblRRMemberDetails').hide();
                $('#tblRRAGComplaintdetails').hide();
                $('#tblRRAGActivitydetails').hide();
                $('#lblRRRActivityType').text(data.activityDtls.CareActivityTypeName == null || data.activityDtls.CareActivityTypeName == '' || data.activityDtls.CareActivityTypeName == 'null' ? 'N/A' : data.activityDtls.CareActivityTypeName);
                $('#lblRRRActivityNotes').text(data.activityDtls.Comments == null || data.activityDtls.Comments == '' || data.activityDtls.Comments == 'null' ? 'N/A' : replaceNewLine(unescapeHtml(data.activityDtls.Comments)));
                $('#lblRRRScheduledDateTime').text(data.activityDtls.FollowupDateString === null || data.activityDtls.FollowupDateString === '' || data.activityDtls.FollowupDateString === 'null' ? 'N/A' : $.fn.apply12To24hrFormat(data.activityDtls.FollowupDateString));
                $('#lblRRRMemberName').text(data.activityDtls.PatientFullName == null || data.activityDtls.PatientFullName == '' || data.activityDtls.PatientFullName == 'null' ? 'N/A' : data.activityDtls.PatientFullName);
                $('#lblRRRHealthCoach').text(data.activityDtls.AssignedTo == null || data.activityDtls.AssignedTo == '' || data.activityDtls.AssignedTo == 'null' ? 'N/A' : data.activityDtls.AssignedTo);
                $('#lblRRRPriority').text(data.activityDtls.Priority == null || data.activityDtls.Priority == '' || data.activityDtls.Priority == 'null' || data.activityDtls.Priority == '-1' ? 'N/A' : data.activityDtls.Priority);
                $('#lblRRRScriptName').text(data.activityDtls.ScriptName == null || data.activityDtls.ScriptName == '' || data.activityDtls.ScriptName == 'null' ? 'N/A' : data.activityDtls.ScriptName);
                $('#lblRRRReferBy').text(data.activityDtls.AssignedBy == null || data.activityDtls.AssignedBy == '' || data.activityDtls.AssignedBy == 'null' ? 'N/A' : data.activityDtls.AssignedBy);
                $('#lblRRRStatus').text(data.activityDtls.Venue == null || data.activityDtls.Venue == '' || data.activityDtls.Venue == 'null' ? 'N/A' : data.activityDtls.Venue);
                if (viewReject != null && viewReject != undefined && viewReject) {
                    $('#trReaonForRejection').show();
                    $('#lblReasonForRejection').text(data.activityDtls.RejectionComments == null || data.activityDtls.RejectionComments == '' || data.activityDtls.RejectionComments == 'null' ? 'N/A' : data.activityDtls.RejectionComments);
                }
            }
            else
                CustomAlert(data.msg);
        }
    });
}

function EditMSActivityFrmActivityLog(patientFollowUpId, rerefer) {
    loader(1);
    var rerefervalue = 0;
    if (rerefer != null && rerefer != undefined)
        rerefervalue = rerefer;
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/MemberService/EditMSActivity?ActId=" + patientFollowUpId + '&rerefer=' + rerefervalue,
        onLoad: function () {
            if (enableDomLogs) {
                DomUtils.logDomData('Member Info >> Activity Record >> Call Log Registry >> Edit Activity');
            }
        },
        popUpHeader: "Edit Activity",
        closeButton: '#btnCloseEditActivityForm'
    });
    loader(0);
}

function completeActivityFrmActivityLog(pfid, ModuleId, patientID, scriptId, GroupId, isReview, createdBy, formId, scriptFormId) {
    var value = pfid + "," + ModuleId + "," + patientID + "," + scriptId + "," + GroupId + "," + isReview + "," + createdBy + "," + formId + "," + scriptFormId;
    $('#hdnIsActivityLog').val(value);
    completesetactivity(pfid, 1);
    //fireMethod(1, 1, '', patientID, '800', '', pfid, 1);//To Implement Activity outcome functionality in Activity Log Section
}

function LoadPendingActivityGrid() {
    if ($("#grdPendingActivities").data("kendoGrid") != null)
        $("#grdPendingActivities").data("kendoGrid").dataSource.read();
}

function refreshGridsBasedOnVisibility(isRefresh) {
    if ($("#hdnProgramWorkflowId").val() != "" || $("#GridToDoList").is(":visible"))
        $('#tabToDoList_' + $('#HiddenToDoListTabId').val()).trigger('click');
    else if ($('#TodayActivityLogGrid').length > 0 && isRefresh == undefined) {
        RefreshMyActLogGrid("btnTCALSearchMAL", "divTodayActivityLogGridHeader", "CM", "selectTCALModuleMAL");
    }
    else if ($('#CMPendingActivitiesGrid').is(':visible')) { LoadWorkLogMgrCmActivities(); }
    else if ($('#scheduler').is(':visible') && isRefresh == undefined) { $("#scheduler").data("kendoScheduler").dataSource.read(); }
    else if ($("#outstandingActivitesGrid").is(":visible")) { $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read(); }
    else if ($("#outstandingExternalActivitesGrid").is(":visible")) { $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read(); }
    else if ($('#grdPendingActivities').is(':visible')) { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
    else if ($('#programAdditionalActivitesGrid').is(':visible')) { $("#programAdditionalActivitesGrid").data("kendoGrid").dataSource.read(); }
    if ($("#hdnClinicalRequiredActId").val() != "" || $("#GridClinicalRequiredActivities").is(":visible"))
        $('#tabClinicalRequiredActivityList_' + $('#hdnClinicalRequiredActId').val()).trigger('click');
    if ($('#ADTrackingGridDiv').is(':visible'))
        $("#ADTrackingGrid").data("kendoGrid").dataSource.read();
    if ($('#PHIPNotificationsGridDiv').is(':visible'))
        $("#PHIPNotificationsGrid").data("kendoGrid").dataSource.read();
}

function completesetactivity(pfid, isActivityLog, IsCompletePendingActivity, isMemberVideoActivity, isScriptInactive) {  // NOSONAR
    //Added isActivityLog Parameter To Implement Activity outcome functionality in Activity Log Section
    var strHtml = "";
    var patientFollowUpId = "";
    var patientId = "", scriptId = "", module = "", createdBy = "", meetingId = "";
    var isCompletePendingActivity = false, isReview = false;
    var groupId = 0, scriptFormId = 0, formId = 0;
    if ((isMTMval == undefined || isMTMval == 'False') && pfid.indexOf("_") == -1) {//in case of MTM and CM required activities where user has to directly click on thumb to perform activity
        patientFollowUpId = pfid;
        var ele;
        // when trying to perfrom from TodayActivitylog and worklogManager, because of calender in the
        //background we are unable to read exact button values becuase claender has the same button names
        if ($("#TodayActivityLogGrid").is(":visible")) {
            ele = "#TodayActivityLogGrid ";
        }
        else if ($("#CMPendingActivitiesGrid").is(":visible")) {
            // when trying to perfrom from worklogManager, because of calender in the
            //background we are unable to read exact button values becuase claender has the same button names
            ele = "#CMPendingActivitiesGrid ";
        }
        else {
            ele = "";
        }
        patientId = $(ele + '#btnRRun_' + patientFollowUpId).data('patientid');
        scriptId = $(ele + '#btnRRun_' + patientFollowUpId).data('scriptid');
        groupId = $(ele + '#btnRRun_' + patientFollowUpId).data('groupid');
        module = $(ele + '#btnRRun_' + patientFollowUpId).data('module');
        isReview = $(ele + '#btnRRun_' + patientFollowUpId).data('isreview');
        createdBy = $(ele + '#btnRRun_' + patientFollowUpId).data('createdby');
        formId = $(ele + '#btnRRun_' + patientFollowUpId).data('formid');
        if (formId == null) { formId = 0; }
        if (IsCompletePendingActivity === true) {
            isCompletePendingActivity = true;
        }
        scriptFormId = $(ele + '#btnRRun_' + patientFollowUpId).data('scriptformid');
    }
    else {
        var pfValues = pfid.split('_');
        if (pfValues[4] == "CM Thumb") {//to identify cm direct thumb click
            patientFollowUpId = pfValues.length > 0 ? pfValues[0] : 0;
            patientId = pfValues.length > 3 ? pfValues[3] : 0;
            scriptId = pfValues.length > 1 ? pfValues[1] : 0;
            module = 'CM';
            createdBy = memberidval;
            scriptFormId = pfValues.length > 2 ? pfValues[2] : 0;
            isCompletePendingActivity = false;
        }
        else {// for MTM module
            patientFollowUpId = pfValues.length > 0 ? pfValues[0] : 0;
            patientId = $('#selectPatientAccessed').val();
            scriptId = pfValues.length > 1 ? pfValues[1] : 0;
            module = 'MTM';
            createdBy = memberidval;
            scriptFormId = pfValues.length > 2 ? pfValues[2] : 0;
            isCompletePendingActivity = false;
        }
    }
    if (isMemberVideoActivity === 1) {
        patientFollowUpId = pfid;
        patientId = $('#btnMVRun_' + patientFollowUpId).data('patientid');
        scriptId = $('#btnMVRun_' + patientFollowUpId).data('scriptid');
        groupId = $('#btnMVRun_' + patientFollowUpId).data('groupid');
        module = $('#btnMVRun_' + patientFollowUpId).data('module');
        isReview = $('#btnMVRun_' + patientFollowUpId).data('isreview');
        createdBy = $('#btnMVRun_' + patientFollowUpId).data('createdby');
        formId = $('#btnMVRun_' + patientFollowUpId).data('formid');
        meetingId = $('#btnMVRun_' + patientFollowUpId).data('meetingguid');
        if (formId == null) { formId = 0; }
        isCompletePendingActivity = IsCompletePendingActivity === true ? true : false;
        scriptFormId = $('#btnMVRun_' + patientFollowUpId).data('scriptformid');
    }
    if (isActivityLog == 1) { //To Implement Activity outcome functionality in Activity Log Section

        var activityInfo = $('#hdnIsActivityLog').val().split(',');

        patientFollowUpId = activityInfo[0];
        patientId = activityInfo[2];
        scriptId = activityInfo[3];
        groupId = activityInfo[4];
        module = activityInfo[1];
        isReview = activityInfo[5];
        createdBy = activityInfo[6];
        formId = activityInfo[7];//UHG-2343 -To get Form Id
        scriptFormId = activityInfo[8];
    }
    if (isReview === 0) {
        isReview = false;
    }
    datastring = { patientFollowUpId: patientFollowUpId, patientId: patientId, scriptId: scriptId, groupId: groupId, createdBy: createdBy, isReview: isReview, module: module, IsCompletePendingActivity: isCompletePendingActivity, MeetingGuid: meetingId };
    //argStr = patientFollowUpId + '#' + patientId + '#' + scriptId + '#' + groupId + '#' + isReview + '#' + careActivityTypeName + '#' + createdBy + '#' + comments;
    $('#hdnCaseConfPerformPatientId').val(patientId);
    if (groupId == 0 || groupId == null) {//Not Case Conference Activity
        if (scriptId && Number(scriptId) > 0 && !isScriptInactive) {//For Script Activities
            scriptPerformActivityData = datastring;
            $.ajax({
                url: baseURL + "/Assessment/CheckMemberPortalScriptResponseCheck?ScriptId=" + scriptId + "&patientId=" + patientId,
                type: "GET",
                datatype: "JSON",
                success: function (data) {
                    if (data == "True") {
                        $('#popUpDialog1').hide();
                        AlertShowWithCallBack('The following assessment may contain more than one or more  answers completed by the Member or Caregiver, validate with the Member/Caregiver prior to changing responses', 1, function () {
                            loader(1);
                            checkScriptProviderReview(scriptId, patientId, patientFollowUpId, formId, isCompletePendingActivity, scriptFormId);
                            $('#divAlert' + objPopLevel).off('click', '#btnAlertYes' + objPopLevel).on('click', '#btnAlertYes' + objPopLevel, function () {
                                $('#divAlert' + objPopLevel + ' #closePopUp').trigger('click');
                            });
                        });
                    }
                    else {
                        checkScriptProviderReview(scriptId, patientId, patientFollowUpId, formId, isCompletePendingActivity, scriptFormId);
                    }
                },
                error: function () {
                    scriptPerformActivityData = undefined;
                    CustomAlert('Error occurred!');
                }
            });
        }
        else {
            //For Normal Activity Need to display Activity OutCome POP Up
            if (isMTMval == 'True' || pfid.indexOf("_") > 0) {
                pfid = pfid.split('_').length > 0 ? pfid.split('_')[0] : 0;
            }
            captureActivityOutcome(pfid, isCompletePendingActivity, isScriptInactive);
        }

        $(document).off('click', '#btnsingleworkflow').on('click', '#btnsingleworkflow', function () {
            if (validateGeneralActivityOutcome()) {
                var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                if (isGlobalMySchedule) {
                    $().ConfirmationBox({
                        Title: 'WARNING!', Top: 200, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                        Content: "You will be redirected to Run Script page. Are you sure you want to continue?"
                    }, function (response) {
                        if (response) {
                            $('#tblSrMode').show();
                            $("#activityoutcomeForm").animate({ scrollTop: $("#divSrMode").offset().top + 100 }, 500);
                        }
                    });
                } else {
                    $('#tblSrMode').show();
                    $("#activityoutcomeForm").animate({ scrollTop: $("#divSrMode").offset().top + 100 }, 500);
                }
            }
        });
        $(document).off('click', '#btnworkflow').on('click', '#btnworkflow', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            var sid = $('#ddlScriptsmvc').val();
            DevUtils.logDebug('btnworkflow click', 'GCHomeCommon', { 'sid': sid });
            if (validateGeneralActivityOutcome()) {
                var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
                if (isGlobalMySchedule) {
                    $().ConfirmationBox({
                        Title: 'WARNING!', Top: 200, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                        Content: "You will be redirected to Run Script page. Are you sure you want to continue?"
                    }, function (response) {
                        if (response) {
                            if (scriptPerformActivityData) {
                                setpatinfo(patientId);
                                //To Allow '#' in Notes
                                scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                                scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                                scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                                scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                                scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                                CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                            }
                            scriptPerformActivityData = undefined;
                            var sid = $('#ddlScriptsmvc').val();
                            $('#closePopUp').trigger('click');
                            $('#popUpGlobalMySchedule #closePopUp').trigger('click');
                            CallAllCtrls(2, 5, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', sid, '800');
                        }
                    });
                } else {
                    if (scriptPerformActivityData) {
                        patientFollowupId = scriptPerformActivityData["patientFollowUpId"];
                        $.ajax({
                            type: "GET",
                            url: baseURL + "/Config/CheckIfActivityPerformed?reqActPatientId=" + patientId + "&refId=" + patientFollowupId + "&moduleId=1",
                            dataType: "json",
                            success: function (data) {
                                if (data.result == 1) {
                                    CustomAlert("Activity already been performed/ deleted.");
                                    refreshGridsBasedOnVisibility();
                                }
                                else {
                                    setpatinfo(patientId);
                                    //To Allow '#' in Notes
                                    scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                                    scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                                    scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                                    scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                                    scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                                    scriptPerformActivityData["CustomFiledDetailsXmlData"] = fnCreateCustomFieldstoXML("divperfcustomfields", 2, 1);
                                    if (isReview === 0) {
                                        scriptPerformActivityData["isReview"] = false;
                                    }
                                    CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                                    scriptPerformActivityData = undefined;
                                    $('#closePopUp').trigger('click');
                                    CallAllCtrls(2, 5, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', sid, '800');
                                }
                            }
                        });
                    }
                }
            }
        });
        $(document).off('click', '.SrMode').on('click', '.SrMode', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            let srMode = $(this).attr('data-value');
            DevUtils.logDebug('SrMode click', 'GCHomeCommon', { 'srMode': srMode, 'scriptPerformActivityData': scriptPerformActivityData });
            if (validateGeneralActivityOutcome() && scriptPerformActivityData) {
                var programWorkflowIds = $("#ddlRequiredActivitiesIdhdn").length > 0 && $("#ddlRequiredActivitiesIdhdn").val() != "" ? $("#ddlRequiredActivitiesIdhdn").val() : "";
                var reqActPatientId = "", patientFollowupId = "";
                if (programWorkflowIds != "") { reqActPatientId = patientId; }
                patientFollowupId = scriptPerformActivityData["patientFollowUpId"];
                $.ajax({
                    type: "GET",
                    url: baseURL + "/Config/CheckIfActivityPerformed?progWorkflowId=" + programWorkflowIds + "&reqActPatientId=" + reqActPatientId + "&refId=" + patientFollowupId + "&moduleId=1",
                    dataType: "json",
                    success: function (data) {
                        if (data.result == 1) {
                            CustomAlert("Activity already been performed/ deleted.");
                            refreshGridsBasedOnVisibility();
                        }
                        else if (data.reqActResult != "0" && data.reqActResult != "0,0" && data.reqActResult != "") {
                            var splittedValues = data.reqActResult.split(",");
                            if (splittedValues.length > 1 && splittedValues[1] == "1") {
                                CustomAlert("Activity already been performed/ deleted.");
                                refreshGridsBasedOnVisibility();
                                return false;
                            }
                            if (splittedValues.length > 0 && splittedValues[0] == "1") {
                                CustomAlert("Selected Required Activity/Activities already been performed/ deleted.");
                                refreshGridsBasedOnVisibility();
                                return false;
                            }
                        }
                        else {
                            //PROD-144224 - to display "Quick access menu" and "Member Info" icons
                            if (patientId !== null && patientId !== '' && patientId > 0) {
                                setpatinfo(patientId);
                                setactionitems();
                                $('#lnkMemberInfo, #memberInfoMenu').show();
                            }
                            //To Allow '#' in Notes
                            scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                            scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                            scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                            var actualHrs = parseInt($('#ActualFollowupHrs').val());
                            var actualMins = parseInt($('#ActualFollowupMins').val());
                            scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                            scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                            scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                            scriptPerformActivityData["CustomFiledDetailsXmlData"] = fnCreateCustomFieldstoXML("divperfcustomfields", 2, 1);
                            if (isReview === 0) {
                                scriptPerformActivityData["isReview"] = false;
                            }
                            CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                            scriptPerformActivityData = undefined;
                            $('#btnCancelActivityOC').trigger('click');
                            $("#btnPopUpGlobalMyScheduleClose").trigger('click');
                            if (!$('#popUpDialog1').is(':visible') && $('#popUpDialog1 #activityoutcomeForm').length > 0) {
                                $('#popUpDialog1').html('');
                            }
                            CallAllCtrls(2, 4, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', scriptId, '800', '', srMode);
                        }
                    }
                });
            }
        });
        //UHG-2343
        $(document).off('click', '#btnRunForm').on('click', '#btnRunForm', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            DevUtils.logDebug('btnRunForm click', 'GCHomeCommon', { 'scriptPerformActivityData': scriptPerformActivityData });
            if (validateGeneralActivityOutcome()) {
                if (scriptPerformActivityData) {
                    setpatinfo(patientId);
                    //To Allow '#' in Notes
                    scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                    scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                    scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                    var actualHrs = parseInt($('#ActualFollowupHrs').val());
                    var actualMins = parseInt($('#ActualFollowupMins').val());
                    scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                    scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                    scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                    CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                }
                scriptPerformActivityData = undefined;
                $('#closePopUp').trigger('click');
                CallAllCtrls(2, 3, "~/App_Pages/CM/Manage/DocumentsAndForms.ascx", formId, '1170');
                LoadMemberSummaryMenu(null, null); if (formId != 0 && isCompletePendingActivity) { $("#MvcMainBody").html(''); }
            }
        });

        $(document).off('change', "#ActualFollowupHrs,#ActualFollowupMins").on('change', "#ActualFollowupHrs,#ActualFollowupMins", function () {
            $('#tblSfPerform').hide();
        });

        $(document).off('click', '#btnRunScriptForm').on('click', '#btnRunScriptForm', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            DevUtils.logDebug('btnRunScriptForm click', 'GCHomeCommon');
            if (validateGeneralActivityOutcome()) {
                $.ajax({
                    type: "GET",
                    url: baseURL + "/Home/CheckScptFormStatus?ScptFormId=" + scriptFormId + "&patientId=" + patientId,
                    dataType: "json",
                    success: function (data) {
                        if (data.success == true) {
                            // if (CheckActivityOutcomeddl()) {
                            if (scriptPerformActivityData) {
                                setpatinfo(patientId);
                                //To Allow '#' in Notes
                                scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                                scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                                scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                                var actualHrs = parseInt($('#ActualFollowupHrs').val());
                                var actualMins = parseInt($('#ActualFollowupMins').val());
                                scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                                scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                                scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                                if (scriptPerformActivityData.isReview === 0) {
                                    scriptPerformActivityData["isReview"] = false;
                                }
                                CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                            }
                            scriptPerformActivityData = undefined;
                            $('#closePopUp').trigger('click');
                            CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|");
                            LoadMemberSummaryMenu(null, null);
                            // }
                        }
                        else { $('#tblSfPerform').show(); }
                    }
                });
            }

        });
        $(document).off('click', '.SfPerform').on('click', '.SfPerform', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            let sfmode = $(this).attr('data-value');
            DevUtils.logDebug('SfPerform click', 'GCHomeCommon', { 'sfmode': sfmode, 'scriptPerformActivityData': scriptPerformActivityData });
            if (validateGeneralActivityOutcome()) {
                if (scriptPerformActivityData) {
                    setpatinfo(patientId);
                    //To Allow '#' in Notes
                    scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                    scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                    scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                    var actualHrs = parseInt($('#ActualFollowupHrs').val());
                    var actualMins = parseInt($('#ActualFollowupMins').val());
                    scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                    scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                    scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                    if (scriptPerformActivityData.isReview === 0) {
                        scriptPerformActivityData["isReview"] = false;
                    }
                    CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                }
                scriptPerformActivityData = undefined;
                LoadMemberSummaryMenu(null, null);
            }
            $('#closePopUp').trigger('click');
            $('#btnPopUpGlobalMyScheduleClose').trigger('click');
            CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|" + "|" + sfmode);
        });
        $(document).off('click', '#btnRunScript').on('click', '#btnRunScript', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            DevUtils.logDebug('btnRunScript click', 'GCHomeCommon', { 'scriptPerformActivityData': scriptPerformActivityData });
            if (validateGeneralActivityOutcome()) {
                if (scriptPerformActivityData) {
                    setpatinfo(patientId);
                    //To Allow '#' in Notes
                    scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                    scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                    scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                    var actualHrs = parseInt($('#ActualFollowupHrs').val());
                    var actualMins = parseInt($('#ActualFollowupMins').val());
                    scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                    scriptPerformActivityData["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                    scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                    if (isReview === 0) {
                        scriptPerformActivityData["isReview"] = false;
                    }
                    CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory);
                }
                scriptPerformActivityData = undefined;
                $('#closePopUp').trigger('click');
                CallAllCtrls(2, 5, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', scriptId, '800');
            }
        });

        function addOutcomeActivity(memberId, activityFrom) {
            var url = '';
            if (activityFrom != 'MTM') {
                url = baseURL + "/Home/EditActivity?patientId=" + memberId;
            }
            else {
                url = baseURL + "/Home/EditActivity?patientId=" + memberId + '&type=Pharmacist';
            }

            $('#popUpDialog1').CMNPopup({
                pvUrl: url,
                onLoad: function () {
                    onLoadEditActivity();
                    if ($("#rdoEAExternal").is(":visible")) {
                        $("#rdoEAExternal").attr("disabled", true);
                    }
                    if ($("#selectActivityType").data("kendoDropDownList") != null) { $("#selectActivityType").data("kendoDropDownList").enable(true) };
                    if (activityFrom === 'MTM') {
                        if ($("#rdoEAInternal").is(":visible")) {
                            $("#rdoEAInternal").attr("disabled", true);
                        }
                    }
                    A11yModal.trapFocusInModal('popUpDialog1');
                },
                onClose: function () {
                    ClearActivityHdnCntrls();
                },
                popUpHeader: "Add Activity",
                popLevel: 0,
                closeButton: "#btnCloseEditActivityForm",
                modalWidth: MODAL_WIDTH.MEDIUM
            });
        }

        $(document).off('click', '#btnCompleteActivityOC').on('click', '#btnCompleteActivityOC', function () {
            var IsActOutcomeMandatory = $('#IsActivityOutcomeMandatory').val() === 'False';
            $('#btnCompleteActivityOC, #btnCompleteandaddActivityOC').prop('disabled', true);
            var programWorkFlowId = "";
            var actvityTypeName = $(this).data('activitytype');
            var memberId = $(this).data('patientid');
            var activityFrom = $(this).data('activityfrom');
            if ($("#hdnProgramWorkflowId").val() != "") { programWorkFlowId = $("#hdnProgramWorkflowId").val(); }
            else if ($("#ddlRequiredActivitiesIdhdn").length > 0 && $("#ddlRequiredActivitiesIdhdn").val() != "") { programWorkFlowId = $("#ddlRequiredActivitiesIdhdn").val(); }
            var reqActPatientId = ""; var moduleId = 0;
            if (programWorkFlowId != "") { reqActPatientId = $(this).attr('data-patientid'); }
            else { moduleId = 1; }
            if (validateGeneralActivityOutcome()) {
                $.ajax({
                    type: "GET",
                    url: baseURL + "/Config/CheckIfActivityPerformed?moduleId=" + moduleId + "&refId=" + pfid + "&progWorkflowId=" + programWorkFlowId + "&reqActPatientId=" + reqActPatientId,
                    dataType: "json",
                    success: function (data) {
                        $("#hdnProgramWorkflowId").val("");
                        if ($('#selectActivityOutcomeType option:selected').text().trim().toLowerCase() === 'unsuccessful'
                            && $("#btnCompleteActivityOC").val().trim().toLowerCase() === 'reschedule') {
                            data.reqActResult = '';
                        }
                        if (data.result == 1) {
                            CustomAlert("Activity already been performed/ deleted.");
                            $('#btnCancelActivityOC').trigger('click');
                            refreshGridsBasedOnVisibility();
                        }
                        else if (data.reqActResult != "0" && data.reqActResult != "0,0" && data.reqActResult != "") {
                            var splittedValues = data.reqActResult.split(",");
                            if (splittedValues.length > 1 && splittedValues[1] == "1") {
                                CustomAlert("Activity already been performed/ deleted.");
                                $('#btnCancelActivityOC').trigger('click');
                                refreshGridsBasedOnVisibility();
                                return false;
                            }
                            if (splittedValues.length > 0 && splittedValues[0] == "1") {
                                CustomAlert("Selected Required Activity/Activities already been performed/ deleted.");
                                $('#btnCompleteActivityOC, #btnCompleteandaddActivityOC').removeAttr('disabled');
                                refreshGridsBasedOnVisibility();
                                return false;
                            }
                        }
                        else {
                            $("#btnCompleteActivityOC").prop('disabled', true);
                            if ($('#hdnSucessActivity').val() == 'true')
                                $("#btnCompleteandaddActivityOC").prop('disabled', true);
                            var activityOutCome = $('#selectActivityOutcome option:selected').text();
                            var outcometype = $('#selectActivityOutcomeType option:selected').text();
                            //if (!isCompletePendingActivity) {
                            //    if (outcometype[0].trim() != "Unsuccessful") {
                            //        setpatinfo(patientId);
                            //    }
                            //}
                            if (scriptId && Number(scriptId) > 0 && !isScriptInactive) {//For Script Activities
                                //If Activity OutCome type is UnSuccessful
                                if (scriptPerformActivityData) {
                                    //To Allow '#' in Notes
                                    scriptPerformActivityData["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                                    scriptPerformActivityData["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                                    scriptPerformActivityData["outComeNotes"] = $('#OutComeComments').val();
                                    var actualHrs = parseInt($('#ActualFollowupHrs').val());
                                    var actualMins = parseInt($('#ActualFollowupMins').val());
                                    scriptPerformActivityData["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                                    if (isReview === 0) {
                                        scriptPerformActivityData["isReview"] = false;
                                    }
                                    scriptPerformActivityData["patientselectedinfo"] = "1";// Added for skipping patient usersession..//

                                    datastring["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016
                                    scriptPerformActivityData["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                                    scriptPerformActivityData["IsReschedule"] = true;
                                    CompleteActivityAS(scriptPerformActivityData, IsActOutcomeMandatory); //if (isCompletePendingActivity) { LoadPendingActivityGrid(); }
                                }
                                scriptPerformActivityData = undefined;
                            }
                            else {
                                //For Normal Activity
                                //To Allow '#' in Notes
                                datastring["activityOutcomeId"] = $('#selectActivityOutcome option:selected').val();
                                datastring["placeOfServiceId"] = $('#selectActivityPlaceOfService option:selected').val();
                                datastring["outComeNotes"] = $('#OutComeComments').val();
                                var actualHrs = parseInt($('#ActualFollowupHrs').val());
                                var actualMins = parseInt($('#ActualFollowupMins').val());
                                datastring["actualDuration"] = DurationFormat(actualHrs) + ':' + DurationFormat(actualMins) + ':00';
                                datastring["patientselectedinfo"] = "1";
                                datastring["venueId"] = $('#ddlOutComeContactType option:selected').val();  //KP@16052016  
                                datastring["HCPCCodeId"] = $('#selectHCPCCode option:selected').val();
                                datastring["CareActivityTypeId"] = $('#CareActivityTypeId').val();
                                datastring["WorkFlowIds"] = $('#ddlRequiredActivitiesIdhdn').val();
                                datastring["OutcomeNoteConfidentialTypeId"] = $('input[name=rdoAOIsConfidential]:checked').val();
                                datastring["NoteConfidentialTypeId"] = $('#NoteConfidentialTypeId').val();
                                datastring["CustomFiledDetailsXmlData"] = fnCreateCustomFieldstoXML("divperfcustomfields", 1, 2);
                                datastring["scriptId"] = 0;
                                if (isReview === 0) {
                                    isReview = false;
                                    datastring["isReview"] = isReview;
                                }

                                CompleteActivityAS(datastring, IsActOutcomeMandatory); //if (isCompletePendingActivity) { LoadPendingActivityGrid(); }
                                if (outcometype.trim() != "Unsuccessful") {//If OutCome Type is Unsuccessful No need to redirect to Member Details Section.
                                    var ficoPostActivtiyObject = { eventSource: "CMACTIVITYPERFORM", parentConrolId: "", moduleName: "CM", eventType: "POST", patientFollowupId: pfid, patientId: memberId };
                                    var responsePostActivtiy = ficoRealTimeValidation(ficoPostActivtiyObject);
                                    CheckValidationMessages(responsePostActivtiy);
                                    if ($('#outstandingActivitesGrid') != null && $('#outstandingActivitesGrid').is(':visible')) {
                                        $('#outstandingActivitesGrid').data('kendoGrid').dataSource.read();
                                    }
                                    if (VarPHIsValid)
                                        $('#closePopUp').trigger('click');
                                    else {
                                        var isFromOutstandingActivitesGrid = false;
                                        if (isCompletePendingActivity) {
                                            $('#closePopUp').trigger('click');
                                            if ($("#outstandingActivitesGrid").is(":visible")) { $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read(); isFromOutstandingActivitesGrid = true }
                                            else if ($("#outstandingExternalActivitesGrid").is(":visible")) { $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read(); isFromOutstandingActivitesGrid = true }
                                            else if ($('#CMPendingActivitiesGrid').is(':visible')) { LoadWorkLogMgrCmActivities(); }
                                            else { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                                        }
                                        else {
                                            $('#closePopUp').trigger('click'); //window.top.ClickFire(patientId);
                                            if (isMTMval === 'True' && $("#gvMtmRequiredActivities").is(":visible")) {
                                                $("#gvMtmRequiredActivities").data("kendoGrid").dataSource.page(1);
                                            }
                                        }
                                        if (isReview) {    // Navigate to CM >> Activity Record >> Documents 
                                            let uniqeName = "AHS_CM_DOCUMENT";
                                            if (window.top.$(".InAuthPage").is(":visible")) {
                                                uniqeName = "AHS_UM_QUICK_LINKS_DOCUMENTS";
                                            }
                                            if (window.top.$(".InComplaintPage").is(":visible")) {
                                                uniqeName = "AHS_AG_QUICK_LINKS_DOCUMENTS";
                                            }
                                            var item = getSpecRoleItem(uniqeName);
                                            if (item !== undefined && item !== null && item.length > 0 && item[0].IsView) {
                                                isFromOutstandingActivitesGrid ? $('#lnkDocumentsTab').trigger('click') : ClickFire(patientId, 'Documents');
                                            }
                                        }
                                    }
                                }
                            }
                            refreshGridsBasedOnVisibility(false);
                            if (outcometype.trim() == "Unsuccessful") {//If outCome type is UnSuccessful
                                var activityTypesArray = ["HRA INITIAL", "HRA REASSESSMENT", "HRA/HFA INITIAL", "HRA/HFA REASSESSMENT"]; // GAC-349, GAC-350
                                var activityOutcomesArray = ["CALL ATTEMPT 1", "CALL ATTEMPT 2"]; // GAC-349, GAC-350
                                var lobsArray = ["MEDICAID", "MEDICARE"]; // GAC-349, GAC-350
                                var memberLobs = $('#membsummarylob').html() != undefined ? $('#membsummarylob').html().trim() : '';
                                var memberLobsArray = memberLobs.toUpperCase().split(',');
                                var memberLobsArray = $.map(memberLobsArray, $.trim);
                                var lobFound = findNeedleInHaystack(lobsArray, memberLobsArray);
                                $('#btnCancelActivityOC').trigger('click');
                                var ficoPostObject = { eventSource: "CMRESHEDULEACTIVITY", parentConrolId: "", moduleName: "CM", eventType: "POST", patientFollowupId: pfid, patientId: memberId };
                                var response = ficoRealTimeValidation(ficoPostObject);
                                if (response != null && response != "" && response != false && response.isRescheduleFromRule) {
                                    if (isCompletePendingActivity) { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                                    else if ($('#CMPendingActivitiesGrid').is(':visible')) { LoadWorkLogMgrCmActivities(); }
                                }
                                else if (!isScriptInactive) {
                                    if (CustomConfirm('Do you want reschedule the activity ?')) {
                                        if (pfid.indexOf("_") > 0) {
                                            pfid = pfid.split('_')[0]
                                        }
                                        $('#hdnIsReSchedueled').val('1');//To Check Condition At the time of Rec
                                        $('#popUpDialog1').CMNPopup({
                                            pvUrl: baseURL + "/Home/EditActivity?ActId=" + pfid + "&isFromReschedule=" + true,
                                            onLoad: function () {
                                                onLoadEditActivity();
                                                $('#btnSubmitActivityForm').hide();
                                                $('#btnCloseActivityForm').text('Add and Close').removeClass('ah-btn-secondary').addClass('ah-btn-primary');
                                                $('#btnCloseActivityForm').show();
                                                if (groupId && groupId > 0) {//For Case Conference Activity
                                                    $('#selectScheduledType').val(2);
                                                    $("#divIdAddActCareTeam").show();
                                                    $('#divIdCareStaff').hide();
                                                    $('.scheduledType').hide();
                                                }
                                                if ($("#rdoEAExternal").is(":visible")) {
                                                    $("#rdoEAExternal").attr("disabled", true);
                                                }
                                                A11yModal.trapFocusInModal('popUpDialog1');
                                            },
                                            onClose: function () {
                                                if (isCompletePendingActivity) {
                                                    if ($("#outstandingActivitesGrid").is(":visible")) { $("#outstandingActivitesGrid").data("kendoGrid").dataSource.read(); }
                                                    else if ($("#outstandingExternalActivitesGrid").is(":visible")) { $("#outstandingExternalActivitesGrid").data("kendoGrid").dataSource.read(); }
                                                    else if ($('#CMPendingActivitiesGrid').is(':visible')) { LoadWorkLogMgrCmActivities(); }
                                                    else { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                                                }
                                                if ($('#hdnIsReSchedueled').length > 0) { $('#hdnIsReSchedueled').val(0); }
                                                ClearActivityHdnCntrls();
                                                $('#popUpDialog1').html('');
                                            },
                                            popUpHeader: "Reschedule Activity",
                                            popLevel: 0,
                                            closeButton: "#btnCloseEditActivityForm",
                                            modalWidth: MODAL_WIDTH.MEDIUM
                                        });
                                    }
                                    else {
                                        if (isCompletePendingActivity) { LoadPendingActivityGrid(); isCompletePendingActivity = false; }
                                        else if ($('#CMPendingActivitiesGrid').is(':visible')) { LoadWorkLogMgrCmActivities(); }
                                    }
                                }
                                else {
                                    // empty block to resolve sonar issue
                                }
                            }
                            if (isFromCompleteandaddActivity == true) {
                                isFromCompleteandaddActivity = false;
                                addOutcomeActivity(memberId, activityFrom);
                            }
                            VarPHIsValid = false;
                        }
                    },
                    error: function (data) {
                        isFromCompleteandaddActivity = false;
                        $('#btnCompleteActivityOC, #btnCompleteandaddActivityOC').removeAttr('disabled');
                        CustomAlert("Error Encountered");
                    }
                });
            }
            else {  // validation fail case - enabling the buttons
                isFromCompleteandaddActivity = false;
                $('#btnCompleteActivityOC, #btnCompleteandaddActivityOC').removeAttr('disabled');
            }
        });

        $(document).off('change', '#selectActivityOutcomeType').on('change', '#selectActivityOutcomeType', function () {
            var activityOutComeType = $('#selectActivityOutcomeType option:selected').text();
            if ($('#selectActivityOutcomeType option:selected').val() == '-1') {
                $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').val('Complete');
                $('.clsCompleteandaddActivityOC').hide();
            }
            else if (activityOutComeType.trim() == "Unsuccessful") {//Show Single Screen and Work Flow buttons and Hide Complete Button
                $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').val('Reschedule');
                $('.clsCompleteandaddActivityOC').hide();
            }
            else {
                $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').val('Complete');
                $('.clsCompleteandaddActivityOC').show();
            }
            $("#btnCompleteandaddActivityOC").ApplyRoleConfig({ Id: "btnCompleteandaddActivityOC", UniqueName: "AHS_CM_ACTION_ADD_ACTIVITY", IsFrom: "Add", IsRemoveElement: false });
        });
        $(document).off('change', '#selectActivityOutcome').on('change', '#selectActivityOutcome', function () {
            $('#tblSrMode').hide();
            $('#tblSfPerform').hide();
            var outcometype = $('#selectActivityOutcomeType option:selected').text();
            //var outcometype = activityOutCome.split(':');

            if (scriptId && Number(scriptId) > 0 && !isScriptInactive) {
                if (outcometype.trim() == "Unsuccessful") {//Show Single Screen and Work Flow buttons and Hide Complete Button
                    $('#divSriptmodeContainer').hide();
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').show();
                    // $('#btnCompleteActivityOC').val('Reschedule');
                }
                else {
                    if ($('#ScriptRunTypeId').val() == 1) {
                        $('#tblSrMode').show();
                    }

                    $('#divSriptmodeContainer').show();
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').hide();
                    // $('#btnCompleteActivityOC').val('Complete');
                }
            }
            else {
                if (outcometype.trim() == "Unsuccessful") {
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').show();
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').val('Reschedule');
                }
                else {
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').show();
                    $('#btnCompleteActivityOC, #btnCompleteExtActivityOC').val('Complete');
                }
            }

        });

    }
    else if (groupId > 0) {
        var careActivityTypeId = '';
        $.ajax({
            type: "POST",
            url: baseURL + "/Home/CheckCaseConferenceActivity?groupId=" + groupId,
            async: false,
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    CustomAlert('This activity has been already completed');
                    $("#scheduler").data("kendoScheduler").dataSource.read();
                    loader(0);
                }
                else {
                    $(document).off('change', '#selectCaseConfActivityOutcome').on('change', '#selectCaseConfActivityOutcome', function () {
                        var outcometype = $('#selectCaseConfActivityOutcomeType option:selected').text();
                        // var outcometype = activityOutCome.split(':');

                        if (outcometype.trim() == "Unsuccessful") {
                            $('#btnCaseConfComplete').val('Reschedule');
                        }
                        else {
                            $('#btnCaseConfComplete').val('Complete');
                        }
                    });
                    var CaseConfActivitynote = '';
                    var chkActiveLOB = '';
                    var patientFollowupId = '';
                    var Is_Lock = false;
                    var notesConTypeId = 1;
                    $.ajax({
                        type: "POST",
                        url: baseURL + "/ActivityRecord/CaseConferenceActivityOutcome?ActId=" + pfid + "&IsProvider=" + isProviderUser,
                        async: false,
                        dataType: "json",
                        success: function (data) {
                            //$("#selectPatientAccessed").data("kendoDropDownList").value($("#hdnPrvActivityId").val());
                            //$("#hdnPrvActivityId").val('');
                            chkActiveLOB = data.val.Eligibility;
                            Is_Lock = data.val.IsLockNote;
                            notesConTypeId = data.val.NoteConfidentialTypeId;
                            patientFollowupId = data.val.PatientFollowupId;
                            patientId = data.val.PatientId;
                            strHtml += '<div id="ActivityOutComeCaseConfr" style="max-height: 530px; overflow-y: auto; width: 900px;"><table width="100%" cellpadding="10">';
                            strHtml += '<tr><td style="padding:5px 0px 0px 0px;"><input type="button" title="Summary" class="Imgmbrviewbg mbrsummaryviewicon" style="margin-bottom:0px !important;" value="Summary" onclick="loadMemberSummaryDetails(' + data.val.PatientId + ')"> </td></tr>';
                            strHtml += '<tr><td><table width="100%">';
                            strHtml += '<tr><td style="padding-top:0px;" class="alignL">Member Name : </td>';
                            strHtml += '<td class="alignL">DOB: </td>';
                            strHtml += '<td class="alignL">Address: </td>';
                            strHtml += '<td class="alignL">City: </td>';
                            strHtml += '<td class="alignL">Zip: </td></tr>';

                            strHtml += '<tr><td style="padding-top:0px;" class="bold alignL" valign="top" height="30"><a onclick="ClickFire(' + data.val.PatientId + ')">' + $.fn.replaceAndEscapeHtmlExt(data.val.MemberName) + '</a></td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.DOB + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.Address + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.City + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.Zip + '</td></tr>';

                            strHtml += '<tr><td class="alignL">Primary Phone: </td>';
                            strHtml += '<td class="alignL">Alternate Phone: </td>';
                            strHtml += '<td class="alignL">Cell Phone: </td>';
                            strHtml += '<td class="alignL">Language: </td></tr>';

                            strHtml += '<tr><td class="bold alignL" valign="top" height="30">' + data.val.PrimaryPhone + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.AlternatePhone + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.MobilePhone + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.PrimaryLanguageName + '</td></tr>';

                            strHtml += '<tr><td class="alignL">Eligibility: </td>';
                            strHtml += '<td class="alignL">Priority: </td>';
                            strHtml += '<td class="alignL">Activity Type: </td>';
                            strHtml += '<td class="alignL">Contact Type: </td>';
                            strHtml += '<td class="alignL">Activity Duration: </td>';
                            strHtml += '<td class="alignL">Scheduled Date: </td></tr>';

                            strHtml += '<tr>';
                            if (chkActiveLOB == "Active") {
                                strHtml += '<td class="bold alignL" valign="top"><a title="Click to see active eligibilities" onclick="MemberEligibleInfo(true, ' + data.val.PatientId + ')">Active</a></td>';
                            }
                            else {
                                strHtml += '<td class="bold alignL" valign="top"><a title="Click to see inactive eligibilities" onclick ="MemberEligibleInfo(false, ' + data.val.PatientId + ')" style="color:red;">Inactive</a></td>';
                            }
                            strHtml += '<td class="bold alignL" valign="top">' + $.fn.replaceAndEscapeHtmlExt(data.val.Priority) + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + $.fn.replaceAndEscapeHtmlExt(data.val.CareActivityTypeName) + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.VenueName + '</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + data.val.FollowupHrs + '  Hrs :' + data.val.FollowupMins + 'Mins</td>';
                            strHtml += '<td class="bold alignL" valign="top">' + $.fn.apply12To24hrFormat(formatDateWithTime(new Date(data.val.FollowupDate))) + '</td></tr></table></td></tr>';


                            CaseConfActivitynote = data.val.Comments;
                            careActivityTypeId = data.val.CareActivityTypeId;
                            IsActivityOutcomeMandatory = data.val.IsActivityOutcomeMandatory;
                            IsActualDurationMandatory = data.val.IsActualDurationMandatory;
                        }
                    });
                    strHtml += '<tr><td><div style="height:2px; border-bottom:1px solid #ccc; margin-bottom:20px;"></div><table width="100%">';
                    strHtml += '<tr><td valign="top">Participants:</td><td id="tdParticipants" valign="top"><div style="border:1px solid #ccc;display: inline-block;padding: 2px;width: 230px; min-height:18px; max-height:80px; overflow-y:auto; overflow-x:hidden;">';
                    $.ajax({
                        type: "GET",
                        url: baseURL + "/PatientCareTeam/GetCareTeamByPatientId?activityPatientID=" + patientId,
                        async: false,
                        dataType: "json",
                        success: function (data) {
                            $.each(data, function (key, val) {
                                if (unescapeHtml(careStaffFullName) === val.CareStaffName) {
                                    strHtml += '<input class="clsCaseConfComplete"  data-emailid="' + val.Email + '" data-isduplicate="' + val.IsDuplicateEmail + '" checked="checked" type="checkbox" id="caseConfCareTeam_' + val.MemberCareTeamId + '"/>' + $.fn.replaceAndEscapeHtmlExt(val.FullName) + '<br/>';
                                }
                                else {
                                    strHtml += '<input class="clsCaseConfComplete"  data-emailid="' + val.Email + '" data-isduplicate="' + val.IsDuplicateEmail + '" type="checkbox" id="caseConfCareTeam_' + val.MemberCareTeamId + '"/>' + $.fn.replaceAndEscapeHtmlExt(val.FullName) + '<br/>';
                                }
                            });
                        }
                    });
                    strHtml += '</div id="caseCnfrenceActivity"></td><td valign="top">Notes:</td><td valign="top">'
                    strHtml += '<div class="notesAccess float-left "  ';
                    if (Is_Lock) {
                        strHtml += ' style="display: none;" ';
                    }
                    strHtml += 'id="divAHConfNts" style="width: 98% !important;"><textarea id="CaseConfCompleteNotes" class="k-textbox" data-trim-unsupportedchars style="width: 99% !important; height: 85px;" rows="2">' + CaseConfActivitynote + '</textarea>';
                    strHtml += '<div class="accessContainer alignL" id="divAHNIsCaseConfidential"><span class="nowrap ItemMR10">Notes viewable by:</span><span id="AHNIsCaseConfidential" class="clsdivCrplConfidential clsCplConfidentialType is_flex ItemMT10"></span>';
                    strHtml += '</div></div> <span class="fa fa-lock lightGrey"';
                    if (!Is_Lock) {
                        strHtml += ' style="display: none;" ';
                    }

                    strHtml += ' id="spnConfNote" > Confidential notes</span></td></tr>';
                    //uhc-2801
                    strHtml += '<tr><td>Outcome Type:</td><td id="tdActivityOutComeType"><select id="selectCaseConfActivityOutcomeType" class="selectHeight" style="width: 230px !important;"></select></td>';

                    strHtml += '<td>Activity Outcome:</td><td id="tdActivityOutCome" class="custDrop"><select id="selectCaseConfActivityOutcome" class="selectHeight" style="width: 230px !important; height:40px; padding:0px;"><option selected="selected" value="-1">Select</option></select></td></tr>';
                    strHtml += '<tr><td>Actual Duration:</td> <td align="left" id="tdActivityOutComeDuration">';
                    strHtml += '<input class="fieldHeight" style="width: 35px !important;" id="tdActualFollowupHrs" maxlength="2" name="ActualFollowupHrs" placeholder="HH" onkeyup="return CheckNumeric(this);" type="text" value=""> Hrs';
                    strHtml += '<input class="fieldHeight" style="width: 35px !important;" id="tdActualFollowupMins" maxlength="2" name="ActualFollowupMins" placeholder="MM" onkeyup="return CheckNumeric(this);" type="text" value=""> Mins</td>';
                    strHtml += '<td>Place of Service:</td><td id="tdActivityPlaceOfService"><select id="selectCaseConfActivityPlaceOfService" class="selectHeight" style="width: 230px;"></select></td></tr>';
                    strHtml += '<tr><td valign="top" style="padding-top:10px;">Service Code:</td><td id="tdHCPCCode" valign="top"><select id="selectHCPCCode" class="selectHeight" style="width: 230px;"></select></td>';
                    strHtml += '<td valign="top" style="padding-top:10px;">Outcome Notes:</td><td valign="top">';
                    strHtml += '<div class="notesAccess float-left " id="divAOConfNts" style="width: 98% !important;"><textarea id="CaseConfOutcomeNotes" class="ah-input" data-trim-unsupportedchars style="width: 99% !important; height: 80px;"/>';
                    strHtml += '<div class="accessContainer alignL" id="divAOIsConfidential"><span class="nowrap ItemMR10">Notes viewable by:</span><span id="AOIsConfidential" class="clsdivCrplConfidential clsCplConfidentialType is_flex ItemMT10"></span>';
                    strHtml += '</div></div> </td></tr>';

                    strHtml += '<tr><td colspan=4 style="text-align:center" > <input type="button" class="BtnSave" id="btnCaseConfComplete" value="Complete"/><input type="button" class="btn btn-default" id="btnCaseConfPopupClose" style="display:none;" value="Close"/></td></tr></table></td></tr>';
                    strHtml += '<tr><td>Notes';
                    strHtml += '<div id="ViewCaseConfNotesgrid"></div></td></tr></table></div>'
                    $('#popUpDialog1').html('').AhsAppend(strHtml);
                    $('#popUpDialog1').CMNPopup({
                        popUpHeader: "Case Conference Complete",
                        popLevel: 1,
                        closeButton: "#btnCaseConfPopupClose"
                    });
                    gridNotAvailableCustomColor('ActivityOutComeCaseConfr');
                    $('#hdnCaseConfCompGroupId').val(groupId);
                    $('#hdnActivityId').val(pfid);
                    bindConfidentialTypeRadioButton('AHNIsCaseConfidential', baseURL + '/Master/BindConfidentialType', null, true);
                    bindConfidentialTypeRadioButton('AOIsConfidential', baseURL + '/Master/BindConfidentialType', null, true);
                    $('#AHNIsCaseConfidential').val(2);
                    $('#AOIsConfidential').val(2);
                    if (isProviderUser) {
                        $('#divAOIsConfidential').hide();
                        $('#AHNIsCaseConfidential').hide();
                    }
                    else {
                        $('#divAOIsConfidential').show();
                        $('#AHNIsCaseConfidential').show();
                    }
                    if (Is_Lock) {
                        $('#divAHConfNts').hide(); $('#spnConfNote').show();
                    } else {
                        $('#divAHConfNts').show(); $('#spnConfNote').hide();
                    }


                    //uhc-2801
                    loadDropDown(baseURL + '/Master/BindActivityOutcomeType/', 'selectCaseConfActivityOutcomeType', null, null, 'ActivityOutComeTypeId', 'ActivityOutComeType');
                    $(document).off('change', '#selectCaseConfActivityOutcomeType').on('change', '#selectCaseConfActivityOutcomeType', function () {
                        loadDropDown(baseURL + '/Master/BindActivityOutcome?careActivityTypeId=' + careActivityTypeId + '&activityoutcomeTypeId=' + $(this).val(), 'selectCaseConfActivityOutcome', null, null, 'ActivityOutcomeId', 'ActivityOutcome');//kuhg-762 at 27_07_16
                        $("#selectCaseConfActivityOutcome").kendoDropDownList({
                            filter: "contains",
                            dataTextField: "text",
                            dataValueField: "value",
                            animation: false

                        });
                        $('#selectCaseConfActivityOutcome-list .k-textbox').attr('style', 'width:224px !important');
                    });
                    $("#selectCaseConfActivityOutcomeType option").map(function () { this.selected = (this.text == "Successful") });
                    $('#selectCaseConfActivityOutcomeType').trigger('change');
                    $(document).off('change', '#selectCaseConfActivityOutcome').on('change', '#selectCaseConfActivityOutcome', function () {
                        var outcometype = $('#selectCaseConfActivityOutcomeType option:selected').text();
                        if (outcometype.trim() == "Unsuccessful") {
                            $('#btnCaseConfComplete').val('Reschedule');
                        }
                        else {
                            $('#btnCaseConfComplete').val('Complete');
                        }
                    });
                    var dataSource = '';

                    $.ajax({
                        type: "GET",
                        url: baseURL + "/ActivityRecord/ViewActivityNotes?patientFollowupId=" + patientFollowupId + "&IsProvider=" + isProviderUser,
                        async: false,
                        dataType: "json",
                        success: function (data) {
                            if (data.length != 0) {
                                if (data.Data.length > 0) {
                                    dataSource = JSON.parse(JSON.stringify(data.Data));
                                }
                            }
                        }
                    });
                    var dataSource1 = new kendo.data.DataSource({
                        data: dataSource,
                        pageSize: 5,
                    });

                    $("#ViewCaseConfNotesgrid").kendoGrid({
                        dataSource: dataSource1,
                        height: 150,
                        pageable: {
                            refresh: true,
                            pageSizes: true,
                            buttonCount: 5
                        },
                        columns: [{
                            field: "NoteType",
                            title: "Note Type",
                            template: "#= (NoteType == null || NoteType == '') ? 'N/A' : NoteType #"
                        }, {
                            field: "HealthNotes",
                            title: "Notes",
                            template: "#if(IsLockNote){#" + "<span class='fa fa-lock lightGrey'> Confidential notes</span>" +
                                "#} else {#" + " #= (HealthNotes == null || HealthNotes == '') ? 'N/A' : $.fn.replaceAndEscapeHtmlExt(HealthNotes) #" + "#} #"
                        }, {
                            field: "CareStaffName",
                            title: "Entered By",
                            template: "#= (CareStaffName == null || CareStaffName == '') ? 'N/A' : CareStaffName #"
                        }, {
                            field: "CreatedDate",
                            title: "Created On",
                            template: "#= (CreatedDate == null || CreatedDate == '') ? 'N/A' : kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"
                        }]
                    });
                    loadDropDownSync(baseURL + '/Master/BindHCPCCodes/', 'selectHCPCCode', null, null, null, null, 'HCPCCodeId', 'HCPCCode');
                    loadDropDownSync(baseURL + '/Master/BindPlaceOfService/', 'selectCaseConfActivityPlaceOfService', null, null, null, null, 'PlaceOfServiceId', 'PlaceOfService');
                }
            }
        });

    }
}
/*uhc-2047*/
function MemberEligibleInfo(status, pid) {
    ShowActiveInactiveMemberEligilibility(status, pid, 'none', 'Eligibility,Attributes,UDTDetails');
}
/*uhc-2047*/
function CheckActivityOutcomeddl() {
    DevUtils.logDebug('CheckActivityOutcomeddl', 'GCHomeCommon', { 'IsActualDurationMandatory': IsActualDurationMandatory, 'IsActivityOutcomeMandatory': IsActivityOutcomeMandatory });

    $('span.validationMessage').remove();
    var msgcount = 0
    if (IsActualDurationMandatory == 'True') {
        if ($('#ActualFollowupMins').val() == "" && $('#ActualFollowupHrs').val() == "") {
            $('#divActivityActualDuration').append('<span class="validationMessage" style="color:red">*</span>');
            msgcount = 1;
        }
    }
    if (parseInt($.trim($('#ActualFollowupHrs').val())) > 23) {
        $('#divActivityActualDuration').append('<span class="validationMessage" style="color:red">Enter maximum 23 Hrs. </span>');
        // return false;
        msgcount = 1;
    }
    if (parseInt($.trim($('#ActualFollowupMins').val())) > 59) {
        $('#divActivityActualDuration').append('<span class="validationMessage" style="color:red">Enter valid Mins</span>');
        // return false;
        msgcount = 1;
    }
    if ($('#ddlOutComeContactType').val() == -1) {
        $('#divOutComeContactType').append('<span class="validationMessage" style="color:red">*</span>');
        msgcount = 1;
    }
    if (!fnValidateCustomFields("divperfcustomfields")) {
        msgcount = 1;
    }
    //GFID-231
    if (IsActivityOutcomeMandatory === 'False') {
        if ($('#selectActivityOutcomeType').val() == -1) {
            $('#divActivityOutcomeType').append('<span class="validationMessage" style="color:red">*</span>');
            msgcount = 1;
        }
        if ($('#selectActivityOutcome').val() == -1) {
            $('#divActivityOutcome').append('<span class="validationMessage" style="color:red">*</span>');
            // return false;
            msgcount = 1;
        }
    }
    $('.cstfield.phone').each(function (index, obj) {
        if ($(this).val() != "" && !$(this).val().match(PhoneandFaxformat)) {
            $('#txtLabelPhone_' + $(this).data('id')).append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    });

    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}

function validateGeneralActivityOutcome() {
    DevUtils.logDebug('validateGeneralActivityOutcome', 'GCHomeCommon', { 'IsActualDurationMandatory': IsActualDurationMandatory, 'IsActivityOutcomeMandatory': IsActivityOutcomeMandatory });
    A11yForms.clearFormFieldValidation();
    A11yAlerts.remove();

    let isValid = true;

    isValid &= validateDuration((IsActualDurationMandatory === 'True'), 'ActualFollowupHrs', 'ActualFollowupMins', 'divActualDuration', 'actualDurationLabel');    // Actual Duration
    isValid &= A11yForms.validateFormField('ddlOutComeContactType', null, [A11yForms.VALIDATIONS.REQUIRED]);
    if (IsActivityOutcomeMandatory === 'False') {
        isValid &= A11yForms.validateFormField('selectActivityOutcomeType', null, [A11yForms.VALIDATIONS.REQUIRED]);
        var activityoutCome = $('#selectActivityOutcome').val();
        if (activityoutCome === '-1' || activityoutCome === null || activityoutCome === undefined) {
            A11yForms.showFormFieldError('selectActivityOutcome', A11yForms.ERROR_MESSAGES.REQUIRED);
            isValid = false;
        }
    }

    isValid &= fnValidateCustomFields("divperfcustomfields");

    if (!isValid) {
        A11yAlerts.createErrorAlert('#divActivityOutcomeAlert');
    }

    return isValid;
}

function CompleteActivityAS(datastring, IsActOutcomeMandatory) {
    var url = baseURL + "/Home/CompleteActivity?IsActOutcomeMandatory=" + IsActOutcomeMandatory;
    if ($('#dBADT.TabbedPanelsTab.TabbedPanelsTabSelected').length > 0 && ($('#refIdAndTypeOfAdtorIpGrid').length > 0 && $('#refIdAndTypeOfAdtorIpGrid').val())) {
        url = url + '&refValuesofAdtIp=' + $('#refIdAndTypeOfAdtorIpGrid').val();
    }
    $.ajax({
        type: "POST",
        url: url,
        data: datastring,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.success) {
                var isMyScheduleVisible = $('#popUpGlobalMySchedule').is(':visible');
                if (isMyScheduleVisible) {
                    var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
                    if (currentView == "Week") {
                        $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
                        if (datastring.scriptId == 0) { loadGlobalMySchedule(); }
                    }
                    else {
                        $("#scheduler").data("kendoScheduler").dataSource.read();        //PROD-1103           
                    }
                }
                else if ($("#id1frame").contents().find('#imgbtnRestActLog').length > 0) {
                    $("#id1frame").contents().find('#imgbtnSearch').trigger('click');
                }
                else if (!isMyScheduleVisible && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103
                    $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
                        onLoadMyCalendar();
                    });
                }
                else if (isMAL)
                    RefreshGridOnActionPerformed("TCAL", "CM");

                if ((datastring.WorkFlowIds != "" && datastring.WorkFlowIds != undefined) && (datastring.scriptId == 0 || datastring.scriptId == null))
                    CompleteRequiredActivities(datastring);
            }
            else {
                CustomAlert(data.msg);
            }
        },
        error: function (data) {
            $('#btnCompleteActivityOC, #btnCompleteExtActivityOC, #btnCompleteandaddActivityOC').removeAttr('disabled');
            CustomAlert("Error Encountered");
        }
    });
}

function CompleteRequiredActivities(datastring) {
    var isClinicalActivity = ($("#IsClinicalActivity").length > 0 && ($("#IsClinicalActivity").val() || "").toLowerCase() === "true");
    var pardata = { workFlowIds: datastring.WorkFlowIds, patientId: datastring.patientId, careActivityTypeId: datastring.CareActivityTypeId, activityOutcomeId: datastring.activityOutcomeId, outcomeNotes: datastring.outComeNotes, CustomFiledDetailsXmlData: datastring.CustomFiledDetailsXmlData, isClinicalActivity: isClinicalActivity };

    var url = baseURL + "/ScriptForm/SaveGeneralRequiredActivities";
    $.ajax({
        type: "POST",
        url: url,
        data: pardata,
        dataType: "JSON",
        async: false,
        success: function (data) {
        }
    });
}

function checkWorkQueueByActivityType(element, fromAddActivity = false) {
    var isWorkQueueChecked = element.is(':checked');
    var validationSuccess = true;
    if (isWorkQueueChecked) {
        var deptId = parseInt(element.val());
        var activityTypeId = fromAddActivity ? parseInt($("#selectActivityType").val()) : parseInt($("#CareActivityTypeId").val());
        $.ajax({
            type: "GET",
            async: false,
            url: baseURL + "Activity/CheckWorkQueueByActivityType",
            data: {
                "deptId": deptId,
                "activityTypeId": activityTypeId
            },
            dataType: "JSON",
            success: function (data) {
                if (data.success) {
                    if (!data.isMapped) {
                        validationSuccess = false;
                    }
                }
                else {
                    loader(0);
                    CustomAlert("Error Occurred!");
                    validationSuccess = false;
                }
            }
        });
    }
    return validationSuccess;
}

function onLoadOpenAuthAddAct() {
    $('#ActivityLogFollowupDate').kendoDateTimePicker({ format: getDateFormat(), timeFormat: getTimeFormat(), interval: 10 });
    $('#ActivityLogDueDate').kendoDateTimePicker({ format: getDateFormat(), timeFormat: getTimeFormat(), interval: 10 });
    loadDropDown(baseURL + '/Master/BindActivityType/', 'selectActivityType', slcActTypeId, undefined, 'ActivityTypeId', 'ActivityTypeName', undefined, true);
    loadDropDown(baseURL + '/Common/BindActivityPriority/', 'selectPriority', slcPriority, undefined, undefined, undefined, undefined, true);
    loadDropDown(baseURL + '/Master/BindProviderType?AuthNo=' + $('#AuthNo').val(), 'selectProviderType', slcAuthProvId, undefined, 'PhysicianId', 'ProviderName', undefined, true);
    $("#selectPriority").val(slcPriority);
    $('#btnSubmitActivityForm, #btnSubmitCloseActivityForm').click(function () {
        SubmitOpenAuthAddActivityForm(this);
    });
    $('#btnUpdateActivityForm,#btnUpdateCloseActivityForm').click(function () {
        SubmitUpdateAuthAddActivityForm(this);
    });
}

function RedirecttoUmActivity(AuthNo, PatientId) {
    //KP    
    $('#hdnMdrActivity').val("");
    if (isWfChatOpen) {
        postUnsentMessageState('postRedirecttoUmActivity', { AuthNo: AuthNo, PatientId: PatientId });
    } else {
        postRedirecttoUmActivity(AuthNo, PatientId);
    }
}

function postRedirecttoUmActivity(AuthNo, PatientId) {
    if (checkUnsentMsgWfChatBox()) {
        if (IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != PatientId) {
            GetPatientAlertsAndAcknowledge(PatientId, 0, AuthNo, 'umact', '');
        }
        else {
            isRedirectToAuthActivity = 1;
            PerformActivityAuthDetails(AuthNo, PatientId);
        }
    }
}

function PerformActivityAuthDetails(AuthNo, PatientId) {
    $.ajax({
        type: "POST",
        url: baseURL + "/Authorization/PerformActivityAuthDetails?AuthNO=" + AuthNo + "&PatientId=" + PatientId,
        dataType: "json",
        success: function (data) {
            if (data.success && data.success == true) {
                isMAL = false;
                SetAuthDatanew(data.val.split(',')[0], data.val.split(',')[1], data.val.split(',')[2], data.val.split(',')[3], data.val.split(',')[4], data.val.split(',')[5])
            }
        },
        error: function () {
            //alert('error handling here');
        }
    });


}

function loadMemberSummaryDetails(pid, isMemberSummaryFromUM) {
    loader(1);
    patientID = pid;
    VarPatientIdGlobal = patientID;
    $('#patientForViewSummary').val(patientID);
    if ($('#grdPendingActivities').is(":visible")) {
        $("#lean_overlay_1").css({ "display": "none" });
    }
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/PopulationHealth/OnDemandMemberSummary?isFromUM=" + isMemberSummaryFromUM,
        onLoad: function () {
            onLoadOnDemandView(patientID, 'popUpDialog2');
        },
        popUpHeader: "View Summary",
        popLevel: 2,
        onClose: function () {
            $('#popUpDialog2').html('');
            const $popup = $("#popUpDialog1");
            if ($popup.children().length > 0 && $popup.is(":visible")) {
                $("#lean_overlay_1").css({ "display": "block" });
            }
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        modalWidth: MODAL_WIDTH.LARGE,
        closeButton: '#btnOnDemandSummaryClose'
    });
    // ClearTableMenu('_myMemberPartialViewContainer', 'divMemberMenu');
}

function IsEmail(email) {
    var regex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return regex.test(email);
}

//AGCODE

function onLoadActivityStatus() {
    var comptype = $.trim($('#AgActdivCompType').text());
    var complaintRecordId = $('#ComplaintRecordId').val();
    var actionDetailsId = ($('#ActionDetailsId').val() || "");
    var careStaffId = ToValue($("#hdnSelectCareStaffTCAL").val(), memberidval);
    loadDropDown(baseURL + '/Master/BindAgActivityStatus/', 'selectActivityStatusDDL', 1, null, 'ActionStatusId', 'ActionStatus');
    loadDropDown(baseURL + '/Complaint/BindComplaintAssignedTo?ComplaintType=' + comptype + '&ComplaintId=' + complaintRecordId + '&ModuleName=AG&ActionDetailsId=' + actionDetailsId + '&IncludeCarestaff=true', 'selectAssignToAgDDL', careStaffId, null, 'CareStaffId', 'CareStaffName');
    $('#selectActivityStatusDDL').attr('disabled', 'disabled');
    $('#btnUpdateAgActivity').click(function () {
        UpdateAgActivity();
    });
}

//END AGCODE

//6.UploadHealthArticle.js
var knowLibSearchVar = "";

function onSuccess(e) {
    var fileName = e.XMLHttpRequest.responseText;
    fileName = fileName.substr(1, fileName.length - 2);
    e.files[0].name = fileName;
    $('#HealthFile').val(fileName);
}

function ValidationForAddHealthArticle() {
    $('span.validationMessage').remove();

    if ($('#selectHealthArticleType').val() == 0) {
        $('#selectHealthArticleType').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }
    if ($('#selectCategoryId').val() < 0) {
        $('#selectCategoryId').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }
    //else if ($('#selectSubcategoryId').val() <0) {
    //    $('#selectSubcategoryId').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
    //    return false;
    //}
    if ($.trim($('#HealthShortDesc').val()) == "") {
        $('#HealthShortDesc').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }
    if ($.trim($('#HealthArticleHeading').val()) == "") {
        $('#HealthArticleHeading').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }
    if ($.trim($('#ReadabilityLevel').val()) == "") {
        $('#ReadabilityLevel').closest('td').append('<span class="validationMessage" style="color:red">*</span>');
        return false;
    }
    if ($('#HealthFile').val() == "") {
        CmnStatusMessageDisp('divAddArticleValidationMessage', 'Please upload a File', 'Error');
        return false;
    }
    if ($('#HealthArticleImage').val() == "") {
        CmnStatusMessageDisp('divAddArticleValidationMessage', 'Please upload an Image', 'Error');
        return false;
    }
    return true;
}
//7.DropDownCheckBox.js
function createDropCheckSmartSearch(selectid, url, ddlid, tbid, placeHolder) {
    var controlType = "checkbox";
    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    if (url != null) {
        var urll = url.replace('/', '_');
    }
    if (placeHolder == null || placeHolder == undefined)
        placeHolder = "Select";
    var htm = "<input id='" + ddlid + "val' type='text' data-id='" + ddlid + "' data-ph='" + placeHolder + "' class='droptexthide'  autocomplete='off' onclick='showdropSmart(this)' style='padding:1px 0px !important;width:" + width + "px;'  placeHolder='" + placeHolder + "' onkeyup='textChangedSmart(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    if (url == null) {
        htm = htm + "</div>";
        $("#" + selectid).html('').append($.parseHTML(htm));
    }
    $.getJSON(url, function (data) {
        if (data.length > 0) {
            $.each(data, function (key, val) {
                let displayText = (val.EncodedText === undefined) ? $.fn.replaceAndEscapeHtmlExt(val.Text) : val.EncodedText;
                htm = htm + "<input type='" + controlType + "' class='" + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + SecurityUtils.escapeHtml(val.Value) + "' onchange=\"clickedSmart(this,'" + controlType + "')\" /><div id='" + ddlid + "spn' title='" + EscapeSingleQuote(val.Text) + "' onclick=\"spnclickedSmart(this,'" + controlType + "')\" style='curosr:pointer;'>" + displayText + "</div><br/>";
            });
        }
        htm = htm + "</div>";
        $("#" + selectid).html('').append($.parseHTML(htm));
        // clickedbyprg(ddlid, 0, controlType);
    });
    jQuery.ajaxSetup({ async: true, cache: false });

    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        $(".dropcheck").hide();
    });
}

function clearDropCheckSmartSearch(selectid, ddlid) {
    $("input[type='checkbox']", "#" + selectid).prop("checked", false);
    $("#" + ddlid + "hdn").val("");
    $("#" + ddlid + "hdntxt").val("");
    $("#" + ddlid + "val").attr("placeholder", $("#" + ddlid + "val").data("ph"));
    $("#" + ddlid + "val").val("");
}

function BindEmptyDropDownListSmart(selectid, ddlid, tbid) {
    var width = $('#' + selectid).width();
    var htm = "<input id='" + ddlid + "val' type='text' data-id='" + ddlid + "' class='droptexthide' onclick='showdropSmart(this)' style='padding:1px 0px !important;width:" + width + "px;' placeHolder='Select' />";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    htm = htm + "</div>";
    $("#" + selectid).html('');
    $("#" + selectid).append(htm);
}

//End Drop Check With Smart Search

var cacheData = (function () {
    var _cacheData = {}
    return function (data, setCache) {
        if (setCache === true) {
            //maxage in minutes will convert to milliseconds
            data.maxage = (((data.maxage || 120) / 0.0167) * 1002)
            _cacheData[data.key] = {
                data: data.value,
                clear: setTimeout(function (key) { delete _cacheData[key] }, data.maxage, data.key)
            }
            return true
        }
        else {
            var _tempGet = _cacheData[data]
            return _tempGet ? _tempGet.data : null
        }
    }
})();

function addIsCheckedForDropcheck(data, ValueField) {
    //selectid is not defined, so replacing with undefined.
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.addIsCheckedForDropcheck()', { selectid: undefined }, 'red');

    if (data.length > 0) {
        var valuefieldarray = [];
        valuefieldarray = ValueField.split(',');
        $.each(data, function (key, val) {
            if (valuefieldarray.indexOf(val.Value) >= 0) {
                val.isChecked = true;
            }
        });
    }
    return data;
}

function CreateDropCheckWithData(selectid, data, ddlid, ValueField, TextField) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.CreateDropCheckWithData()', { selectid: selectid }, 'red');

    var controlType = "checkbox";
    var checkedStyle = "";
    var widthList = $('#' + selectid).attr('data-CtrlListWidth');
    var width = $('#' + selectid).width();
    if (widthList != undefined)
        width = widthList;
    $('#' + selectid).attr('data-ddlId', ddlid);
    $('#' + selectid).attr('data-CtrlType', controlType);
    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + ValueField + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + ValueField + "'></div>";
    if (data.length > 0) {
        $.each(data, function (key, val) {
            if (val.isChecked) {
                htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "' " + checkedStyle + "  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"clicked(this,0,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + escapeHtml(val.Text) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val.Text) + "</div><br/>";
            }
            else {
                htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "' " + checkedStyle + "  id='" + ddlid + "' value='" + val.Value + "' onchange=\"clicked(this,0,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + escapeHtml(val.Text) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val.Text) + "</div><br/>";
            }
        });
    }
    else {
        htm = htm + "No Records";
    }
    htm = htm + "</div>";
    $("#" + selectid).html('').append($.parseHTML(htm));
    clickedbyprg(ddlid, 0, controlType);
}

function CreateDropCheckAllPost(selectid, url, ddlid, tbid, cvalues, onkeyupValue, configvalue, textField, textValue, isAsync, params, isCheckAll) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.CreateDropCheckAllPost()', { selectid: selectid }, 'red');

    var controlType = "checkbox";
    var checkedStyle = "";
    if (isCheckAll == true) { checkedStyle = "checked =\'checked'"; }
    if (configvalue == 'S') { controlType = 'radio'; }
    if (!isAsync) {
        jQuery.ajaxSetup({ async: false, cache: false });
    }

    var widthList = $('#' + selectid).attr('data-CtrlListWidth');
    var width = $('#' + selectid).width();
    if (widthList != undefined)
        width = widthList;
    $('#' + selectid).attr('data-ddlId', ddlid);
    $('#' + selectid).attr('data-CtrlType', controlType);
    //if (url != null) {
    //    var urll = url.replace('/', '_');
    //}
    var TextField = "Text";
    var ValueField = "Value";
    if (textField != undefined && textField != null) {
        TextField = textField;
        ValueField = textValue;
    }

    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this, \"#" + selectid + "\")' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0, k = 0;
    var cval = "";
    if (cvalues != null && cvalues !== "") {
        cval = cvalues.toString().split(',');
    }
    var cvalInt = [];
    $.each(cval, function (i) { cvalInt[i] = parseInt(cval[i]); });
    var resData = '';

    $.ajax({
        url: url,
        type: "POST",
        datatype: "html",
        data: params,
        success: function (data) {
            resData = data.d;
            // there are times when the data is a string, and it throws exception on the $.each() statement, so check for typeof object before trying this
            if (data.length > 0 && typeof data === 'object') {
                $.each(data, function (key, val) {
                    if (key == 0) {
                        htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + 'selectallid' + "' name='" + ddlid + "' " + checkedStyle + "  id='" + ddlid + "' value='" + "-1" + "' onchange=\"checkall(this,0,'" + controlType + "','" + ddlid + "')\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + "Select All" + "' onclick=\"checkall(this,0,'" + controlType + "','" + ddlid + "')\" style='curosr:pointer;'>" + "Select All" + "</div><br/>";
                    }
                    if (jQuery.inArray(val[ValueField], cval) != '-1' || jQuery.inArray(val[ValueField], cvalInt) != '-1') {

                        if (ddlid == "ddlDynaColumnId") {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val[ValueField] + "' checked='checked' onchange=\"clicked(this,0,'" + controlType + "');unSelectCheckBox(this)\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + escapeHtml(val[TextField]) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val[TextField]) + "</div><br/>";
                        }
                        else {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "' " + checkedStyle + " id='" + ddlid + "' value='" + val[ValueField] + "' checked='checked' onchange=\"clicked(this,0,'" + controlType + "')\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + escapeHtml(val[TextField]) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val[TextField]) + "</div><br/>";
                        }
                    }
                    else {
                        if (ddlid == "ddlDynaColumnId") {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "' " + checkedStyle + " id='" + ddlid + "' value='" + val[ValueField] + "' onchange=\"clicked(this,0,'" + controlType + "');unSelectCheckBox(this)\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + escapeHtml(val[TextField]) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val[TextField]) + "</div><br/>";
                        }
                        else {
                            //if (jQuery.inArray(val.Value,IndicatorIdschecked)!=-1)
                            if (val.Selected == true || val.IsChecked == true || isCheckAll == true)
                                htm = htm + "<input type='" + controlType + "' checked=\'checked' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val[ValueField] + "' onchange=\"clicked(this,0,'" + controlType + "')\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + escapeHtml(val[TextField]) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val[TextField]) + "</div><br/>";
                            else {
                                k++;
                                htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val[ValueField] + "' onchange=\"clicked(this,0,'" + controlType + "')\" /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + escapeHtml(val[TextField]) + "' onclick=\"spnclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + escapeHtml(val[TextField]) + "</div><br/>";
                            }
                        }
                    }
                });
            }
            else {
                htm = htm + "No Records";
            }
            htm = htm + "</div>";
            $("#" + selectid).html('');
            $("#" + selectid).AhsAppend(htm);
            clickedbyprg(ddlid, 0, controlType);
        },
        error: function (error) { }
    });

    if (k == 0)
        $(".selectallid", "#" + selectid).prop("checked", true);
    if (resData == 'undefined' || resData == '') {
        $("#" + selectid).html('');
        $("#" + selectid).append("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");
    }
    if (!isAsync) {
        jQuery.ajaxSetup({ async: true, cache: false });
    }
    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        if ($(this).attr('type') !== 'checkbox') {
            $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
            var ctrlId = $(this).attr('data-ddlId');
            var ctrlType = $(this).attr('data-CtrlType');
            ddlcolumnselectedshow(ctrlId, 0, ctrlType);
            $(".dropcheck").hide();
        }
    });
}

//created to escape special characters in the dropdown which is causing data issue while displaying - UHG-3079
function CreateDropChecktoescapespclChars(selectid, url, ddlid, tbid, cvalues, onkeyupValue) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.CreateDropChecktoescapespclChars()', { selectid: selectid }, 'red');

    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    var urll = url.replace('/', '_');
    var htm = "<input id='" + ddlid + "val' type='text' class='droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var cval = "";
    if (cvalues != null && cvalues !== "")
        cval = cvalues.toString().split(',');
    var resData = '';
    $.getJSON(url, function (data) {
        resData = data.d;
        //uhg-2928
        if ((ddlid == "ddlProfileValues" || ddlid == "ddlProfileValuesCS") && data.length > 0) {
            var selValues = data[0].SelectedValue;
            if (selValues != null)
                cval = selValues.split(',');
        }
        //uhg-2928
        if (data.length > 0) {
            $.each(data, function (key, val) {
                val.Text = $.fn.replaceAndEscapeHtmlExt(val.Text);
                if (jQuery.inArray(val.Value, cval) != '-1') {
                    if (ddlid == "ddlDynaColumnId") {
                        htm = htm + "<input type='checkbox' class='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange='clicked(this,0);unSelectCheckBox(this)' /><div id='" + ddlid + "spn' title='" + ReplaceSpecialChars(val.Text) + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + ReplaceSpecialChars(val.Text) + "</div><br/>";
                    }
                    else if (ddlid == "ddlProfileValues" || ddlid == "ddlProfileValuesCS") {
                        htm = htm + "<input type='checkbox' class='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' disabled='disabled' /><div id='" + ddlid + "spn' title='" + val.Text + "' style='curosr:pointer;'>" + val.Text + "</div><br/>";
                    }
                    else {
                        htm = htm + "<input type='checkbox' class='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + ReplaceSpecialChars(val.Text) + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + ReplaceSpecialChars(val.Text) + "</div><br/>";
                    }
                }
                else {
                    if (ddlid == "ddlDynaColumnId") {
                        htm = htm + "<input type='checkbox' class='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange='clicked(this,0);unSelectCheckBox(this)' /><div id='" + ddlid + "spn' title='" + ReplaceSpecialChars(val.Text) + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + ReplaceSpecialChars(val.Text) + "</div><br/>";
                    }
                    else {
                        htm = htm + "<input type='checkbox' class='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + ReplaceSpecialChars(val.Text) + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + ReplaceSpecialChars(val.Text) + "</div><br/>";
                    }
                }
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append($.parseHTML(htm));
        clickedbyprg(ddlid, 0);
    });
    if (resData == 'undefined' || resData == '')
        $("#" + selectid).append($.parseHTML("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/></div>"));
    jQuery.ajaxSetup({ async: true, cache: false });
}

/**
 * @deprecated - instead, call A11yDropcheck.createDropcheck() with isCheckAll = true
 */
function CreateDropAllCheck(selectid, url, ddlid, tbid, ischeckall, dataValue, dataText) {
    DevUtils.logWarn('This function is deprecated. Call A11yDropcheck.createDropcheck() with isCheckAll=true instead');

    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    var urll = url.replace('/', '_');
    var htm = "<input id='" + ddlid + "val' data-id='" + ddlid + "' type='text' class='droptexthide TabHtmlMultiDropDown' onclick='showdrop(this)' style='color:darkgrey;' value='Select' placeHolder='Select' onkeyup='textChanged(this)' />";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var acval = "";
    if (ischeckall != null)
        acval = ischeckall;
    dataValue = dataValue || 'Value';
    dataText = dataText || 'Text';

    $.getJSON(url, function (data) {
        if (data.length > 0) {
            $.each(data, function (key, val) {
                if (acval == "1") {
                    htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[dataValue] + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "'  checked='checked' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + val[dataText] + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + val[dataText] + "</div><br/>";
                }
                else {
                    htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[dataValue] + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' class='divTabHtmlMultiDropDown' title='" + val[dataText] + "' onclick='spnclicked(this,0)' style='curosr:pointer;'>" + val[dataText] + "</div><br/>";
                }
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
        clickedbyprg(ddlid, 0);
        $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
            if ($(this).attr('type') != 'checkbox') {
                $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
                $(".dropcheck").hide();
            }
        });
    });
    jQuery.ajaxSetup({ async: true, cache: false });
}
//kuhg-452
function CreateDropAllCheckWtProperties(selectid, url, ddlid, tbid, ischeckall, dataValue, dataText, cvalues) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.CreateDropAllCheckWtProperties()', { selectid: selectid }, 'red');

    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    var urll = url.replace('/', '_');
    var htm = "<input id='" + ddlid + "val' type='text' class='droptexthide' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' />";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var acval = "";
    if (ischeckall != null)
        acval = ischeckall;
    var cval = "";
    if (cvalues != null && cvalues !== "") {
        cval = cvalues.toString().split(',');
    }

    $.getJSON(url, function (data) {
        if (data.length > 0) {
            $.each(data, function (key, val) {
                if (acval == "1") {
                    htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[dataValue] + "' checked='checked' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "' onclick='spnclicked(this,0)' style='cursor:pointer;'>" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "</div><br/>";
                }
                else {
                    if (jQuery.inArray(val[dataValue].toString(), cval) != '-1') {
                        htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[dataValue] + "' checked='checked' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "' onclick='spnclicked(this,0)' style='cursor:pointer;'>" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "</div><br/>";
                    }
                    else {
                        htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[dataValue] + "' onchange='clicked(this,0)' /><div id='" + ddlid + "spn' title='" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "' onclick='spnclicked(this,0)' style='cursor:pointer;'>" + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + "</div><br/>";
                    }
                }
            });
            if ($('#trReqAct') != undefined)
                $('#trReqAct').show();
        }
        else {
            if ($('#trReqAct') != undefined)
                $('#trReqAct').hide();
            htm = htm + "<div style='text-align:left;'>No Records</div>";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
        clickedbyprg(ddlid, 0);
    });
    jQuery.ajaxSetup({ async: true, cache: false });
}

function getlist(textval, url, eleid) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.getlist()', { textval: textval, url: url, eleid: eleid }, 'red');

    var items = "", len = 0;
    var num;
    len = textval.length;
    $.getJSON(url, function (data) {
        if (data.length > 0) {
            $.each(data, function (key, val) {
                var et = val.Text.substring(0, len);
                if (et.toLowerCase() == textval.toLowerCase())
                    items = items + ',' + val.Value;
            });
            if (items.length > 0) {
                var array = items.split(',');
                $("#" + eleid + "chk").find("input:checkbox:checked").each(function () {
                    $(this).hide();
                    $(this).next("div").hide();
                    $(this).next().next("br").hide();
                });
                var elhval = $("#" + eleid + "hdn").val();
                if (elhval.length > 0) { showcheckeditem(url, eleid, elhval); }
                else {
                    $("#" + eleid + "chkchk").html('');
                    $("#" + eleid + "chkchk").hide();
                }
                $("#" + eleid + "chk").find("input:checkbox:not(:checked)").each(function () {
                    var vala = jQuery.inArray($(this).val(), array, num);
                    if (vala == -1) {
                        $(this).hide();
                        $(this).next("div").hide();
                        $(this).next().next("br").hide();
                    }
                    else {
                        $(this).show();
                        $(this).next("div").show();
                        $(this).next().next("br").show();
                    }
                });
            }
            else {
                $("#" + eleid + "chk").find("input").hide();
                $("#" + eleid + "chk").find("div").hide();
                $("#" + eleid + "chk").find("br").hide();
            }
            $("#" + eleid + "chk").show();
        }
    });
}

function hidedrop(ctrl) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.hidedrop()', { ctrl: ctrl }, 'red');

    var eleid = ctrl.id;
    eleid = eleid.replace("val1", "");
    $("#" + eleid + "val").show();
    $("#" + ctrl.id).hide()
    $("#" + eleid + "chk").hide();
}

function ddlcheckAll(eleid) {
    DevUtils.logDebug('consider moving this to A11yDropcheck.js', 'GCHomeCommon.ddlcheckAll()', { eleid: eleid }, 'red');

    var itm = "";
    var itmtxt = "";

    if ($("#" + eleid + "CheckAll").prop("checked") == true) {

        if (eleid == "ddlCareorganization") {
            //$('#btnGoCareOrg').attr('disabled', false);
            if ($('#ddlSearchBy option:selected').text() != "TIN") {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').show();
            } else {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').hide();
            }
        }
    }

    $("#" + eleid + "chk").find('input[type="checkbox"]').each(function () {
        if ($("#" + eleid + "CheckAll").prop("checked") == true) {
            $(this).prop('checked', true);
            var arry = itm.split(',');
            var nummm;
            var valaaa = jQuery.inArray($(this).val(), arry, nummm);
            if (valaaa == -1) {
                if (itm.length > 0) {
                    //selectedItems.push({ Text: $(this).next("#" + eleid + "spn").html(), Value: $(this).val(),Selected:true });
                    itm = itm + "," + $(this).val();
                    itmtxt = itmtxt + "," + unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
                else {
                    itm = $(this).val();
                    itmtxt = unescapeHtml($(this).next("#" + eleid + "spn").html());
                }
            }
        }
        else {

            $(this).prop('checked', false);
        }
    });
    var chkboxes = $("#" + eleid + "chk").find('input[type="checkbox"]:checked');
    if (chkboxes.length > 0) {
        if (chkboxes.length >= 1 && chkboxes.length <= 3) {
            // $("#" + eleid + "val").attr("placeholder",chkboxes.length + " Item Selected");
            $("#" + eleid + "val").val(itmtxt);
        }
        else {
            //$("#" + eleid + "val").attr("placeholder", chkboxes.length + " Items Selected");
            $("#" + eleid + "val").val(chkboxes.length + " items Checked");
        }
        $("#" + eleid + "hdn").val(itm);
        $("#" + eleid + "hdntxt").val(itmtxt);
    }
    else {
        //PH-GlobalSearch 
        if (eleid == "ddlCareorganization") {
            if ($('#ddlSearchBy option:selected').text() != "TIN") {
                $('#btnHideCareOrg').show();
                $('#btnGoCareOrg').hide();
            }
            else {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').hide();
            }
            if ($('#dvServiceLoc').is(":visible") && $('#ddlSearchBy option:selected').text() != "TIN") {
                CreateDropCheck('ddlServiceLocations', baseURL + '/PopulationHealth/BindServiceLocations?OrgFilterIdval=', 'ddlServiceLocations', 0);
            }
            if ($('#dvNPI').is(":visible") && $('#ddlSearchBy option:selected').text() != "TIN") {
                CreateDropCheck('ddlGlobalSearchNpi', baseURL + '/PopulationHealth/BindNpi?OrgFilterIdval=', 'ddlGlobalSearchNpi', 0);
            }
        }

        $("#" + eleid + "val").val("");
        $("#" + eleid + "hdn").val('');
        $("#" + eleid + "hdntxt").val('');
        $("#" + eleid + "val").attr('placeholder', 'Select');
    }
}

function CallCshtmlCtrls(path) {
    SetControlDisplay(4);
    ShowWelcomeMessage(1);
    $("#MvcMainBody").html('');
    $("#MvcMainBody").load(baseURL + path, function () {
        ShowWelcomeMessage(0);
    });
    loader(0);
}

function callmeminfo(val) {
    if ($.trim($("#MvcMainBody").html()) != "" && mainctrl == '0') {
        LoadMemberSummaryMenu(1, MemberAccessedCheck);
        setTimeout(function () {
            selectTab(val);
            loader(0);
        }, 1000);
    }
    else {
        mainctrl = '0';
        loadMemberdetails();
        setTimeout(function () {
            if (val !== 'MemberInfo') {
                selectTab(val);
            }
            loader(0);
        }, 1000);
    }

}

//Code for Converting string date format to date MM-dd-yyyy
function convert(str) {
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
}
//Code for Converting string date format to date MM/dd/yyyy
function Dateconvert(str) {
    var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join("/");
}
function funAddAppointment(AppoinmentIdVar, isConfrimCompletedStatus) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CommonDefaultSessionState/AddAppointment?appointmentID=" + AppoinmentIdVar + "&ConfirmCompletedStatus=" + isConfrimCompletedStatus,// + "&TimeDictionaryobj=" + timeZone,
        popUpHeader: (AppoinmentIdVar == "") ? 'Add Appointment' : 'Edit Appointment',
        closeButton: '#closebutton1',
        triggerBtnId: 'actionsMenuBtn',
        popLevel: 1,
        onLoad: function () {
            if (enableDomLogs) {
                let actionItem = AppoinmentIdVar === "" ? 'Add Appointment' : 'Edit Appointment';
                DomUtils.logDomData('Member Info >> Health >> Appointment >> ' + actionItem);
            }
        },
        onClose: function () {
            $('#hAppGrid').hide();
            $("input[id *= 'chkHealthApp']").removeAttr("checked");
            isMiles = false;
            if ($("#fromAppointment").length == 1)
                $("#fromAppointment").remove();
        },
        modalWidth: MODAL_WIDTH.LARGE
    });
}

function ShowWelcomeMessage(val) {

    if (val === 1) {
        $("#WelcomeMessage").show();
    } else if (val === 0) {
        setTimeout(function () {
            $("#WelcomeMessage").hide();
        }, 1000);
    } else {
        // do nothing (this is here for Sonar)
    }
}

function selectTab(tabname, btnName, patientId) {
    DevUtils.logDebug('GCHomeCommon.selectTab()', 'MEMBER_ACCESSED_DROPDOWN', { tabname: tabname, btnName: btnName, patientId: patientId }, 'purple');

    $("#memberMenuItems").hide();
    SetControlDisplay(4);
    $('#liMemberInfo,#liHealth,#liCarePlan,#liActivity,#liAuthorization,#liComplaints,#liMTM,#liPacketLog').attr('class', 'TabbedPanelsTab');
    $('#memberLeftTab,#healthLeftTab,#carePlanLeftTab,#activityLeftTab,#authorizationLeftTab,#complaintsLeftTab,#MTMLeftTab,#packetLogLeftTab').hide();
    $('#divContentMemSession').html('');
    $('#divAgComplaintFilterFormView_0').hide();
    $("#genratePacketSection").show();
    $('#btnPacketDesign').prop('disabled', true);
    switch (tabname) {
        case 'MemberInfo':
            IsMemberPage = 1;
            $('#liMemberInfo').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected').attr('aria-current', 'true');
            $('#memberLeftTab').show();
            if (!btnName) btnName = 'MemberDetailsTab';
            $('#' + btnName).trigger('click', patientId);
            IsMemberPage = '';
            $('.CMMenu').show();
            $('.UmAgMenu').hide();
            break;
        case 'Health':
            $('#liHealth').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#healthLeftTab').show();
            if (!btnName) btnName = 'HealthMemMedicalInfoTab';
            $('#' + btnName).trigger('click');
            break;
        case 'CarePlan':
            $('#liCarePlan').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#carePlanLeftTab').show();
            if (!btnName) btnName = 'lnkCarePlanTab';
            $('#' + btnName).trigger('click');
            break;
        case 'ServicePlan':
            $('#liCarePlan').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#carePlanLeftTab').show();
            $("#lnkServicePlanTab").trigger("click");
            break;
        case 'Activity':
            $('#liActivity').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#activityLeftTab').show();
            if (!btnName) btnName = 'lnkNotesTab';
            $('#' + btnName).trigger('click');
            break;
        case 'MTM':
            $('#liMTM').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#MTMLeftTab').show();
            GetMemberOptStatus();//to get opt status and store in global variable
            if (!btnName) btnName = 'lnkSumaryTimeLineTab';
            $('#' + btnName).trigger('click');
            break;
        case 'Authorization':
            $('#liAuthorization').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#authorizationLeftTab').show();
            $('#lnkAuthorizationsTab').trigger('click');
            break;
        case 'Complaints':

            $('#liComplaints').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#complaintsLeftTab').show();
            $('#ComplaintsTab').trigger('click');
            break;

        case 'ActivitySummary':
            $('#liActivity').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#activityLeftTab').show();
            $("#lnkActivitySummaryTab").trigger("click");
            break;

        case 'Documents':
            $('#liActivity').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#activityLeftTab').show();
            $("#lnkDocumentsTab").trigger("click");
            break;
        case 'Medications':
            $('#liHealth').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#healthLeftTab').show();
            $('#ExpandManualMedicationsTab').val("ExpandMBMC");
            $("#HealthMedicationsTab").trigger("click");
            break;
        case 'Programs':
            $('#liMemberInfo').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#memberLeftTab').show();
            $("#lnkPrograms").trigger("click");
            break;
        case 'CMPacketEligibility':
            $('#liPacketLog').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $("#genratePacketSection").hide();
            break;
        case 'CMPacketLog':
            $('#liPacketLog').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#liPacketLog').trigger('click');
            break;
        case 'CMPacketLogLeftMenu':
            $('#liPacketLog').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            break;
        case 'MemberAlerts':
            $('#liActivity').attr('class', 'TabbedPanelsTab TabbedPanelsTabSelected');
            $('#activityLeftTab').show();
            $('#lnkMemberAlertsTab').trigger('click');
            break;
    }
}

function waitfire(val, level) {
    if (level == 0) {
        if (val == 1) {
            $("#id1frame").load(function () {
                setTimeout(function () { $("#id1frame").contents().find("#btnClickCarePlan").trigger('click') }, 50);
            })
        }
        else if (val == 2) {
            $("#id1frame").load(function () {
                setTimeout(function () { $("#id1frame").contents().find("#btnClickActivityRecord").trigger('click') }, 50);
            })
        }
    }
    else if (level == 1) {
        if (val == 1)
            $("#id1frame").contents().find("#btnClickCarePlan").trigger('click')
        else if (val == 2)
            $("#id1frame").contents().find("#btnClickActivityRecord").trigger('click')
    }
}

//Gcode
function LoadMemberSummaryMenu(ctrlstat, access) {
    var isGlobalCalShown = $("#popUpGlobalCalendar").is(':visible');
    var isAcceptPopupShown = $('#divRequestAcceptCommentsPopup,#divMSRequestAcceptCommentsPopup,#divUMRequestAcceptCommentsPopup,#divRequestAGAcceptCommentsPopup').is(':visible');
    if (isGlobalCalShown) {
        $('#popUpGlobalCalendar #closePopUp').click();
        clearFieldsText(2);
    }
    if (isAcceptPopupShown) {
        $('#divRequestAcceptCommentsPopup #closePopUp,#divMSRequestAcceptCommentsPopup #closePopUp,#divUMRequestAcceptCommentsPopup #closePopUp,#divRequestAGAcceptCommentsPopup #closePopUp').click();
    }
    var objpval = $("#gcSummaryBanner #hdnServiceIntBannerPatientId").val() && !$('#memberAccessedContainer').is(':visible')
        ? $("#gcSummaryBanner #hdnServiceIntBannerPatientId").val()
        : $("#selectPatientAccessed").val();
    DevUtils.logDebug('GCHomeCommon.LoadMemberSummaryMenu()', 'MEMBER_ACCESSED_DROPDOWN', { objpval: objpval }, 'purple');

    var item = getSpecRoleItem("AHS_CM_MEMBER_DETAILS");
    if (item != undefined && item != null && item.length > 0) {
        if (item[0].IsView == false) { $("#DivMemberSummaryMenu").hide(); }
        else { $("#DivMemberSummaryMenu").show(); }
    }
    else { $("#DivMemberSummaryMenu").show(); }
    if ($("#DivMemberSummaryMenu").is(":visible")) {
        $("#DivMemberSummaryMenu").html('').load(baseURL + "/Home/MemberSummaryMenu/", { pid: objpval, pname: $("#selectPatientAccessed option:selected").text(), isFromMemIcon: $("#hdnIsFromMemIcon").val() }, function () {
            if (ctrlstat != null) {
                if (ctrlstat == 1) {
                    $("#DivMemberSummaryMenu").show();
                }
                else { $("#DivMemberSummaryMenu").hide(); }
            }
            else { $("#DivMemberSummaryMenu").show(); }
            setTimeout(function () { setactionitems(); }, 1000);
            $('.btnPatientCount').val(AlterCountResult);
            let authNo = UmPatient_AuthInfo("", "").AuthNo;
            if (isAuthBannerEnabled === "1" && authNo > 0) {
                authBannerData(authNo);
            }
            if (access != null || MemberAccessedCheck != null) {
                if (access === "2" || MemberAccessedCheck === "2") {
                    $(".Glb_MemAccessed,.Glb_MemAccessDevide").show();
                }
                else {
                    $(".Glb_MemAccessed,.Glb_MemAccessDevide").hide();
                }
            } else {
                $(".Glb_MemAccessed,.Glb_MemAccessDevide").hide();
            }
            $("#hdnIsFromMemIcon").val("0");
        });
    }
}
//Gcode
function setactionitems(isUmValueRepeat = true) {
    var PAccddl = $("#selectPatientAccessed").data("kendoDropDownList");
    var textpsel = PAccddl.value();
    if ($.trim(textpsel) != "") {
        if ((((isumval === 'True' || loggedInUserModuleId === '3') && rolenameval.toUpperCase() !== 'VIEW ONLY') || ((isagval === 'True' || loggedInUserModuleId === '5') && rolenameval.toUpperCase() !== 'AG VIEW ONLY')) && isUmValueRepeat) {
            if (!$('#UmIcons').is(':visible')) {
                $('#DivAddAuthorizationMenu').show();
            }
        }
        else { $('#DivAddAuthorizationMenu').hide(); }

        Access_CMMenu_BasedOn_Modules();

    }
    else {
        $('#DivAddAuthorizationMenu').hide();
        DevUtils.logDebug('Hiding memberInfoMenu 4');
        $('#lnkMemberInfo, #memberInfoMenu').hide();
        $('#divAction').hide();
        $('#divCarePlan').hide();
        $('#divCareNotes').hide();
    }
}

function getProfileConfiguredToPatient(patientData, successCallback, errorCallback) {
    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: patientData,
        success: function (config) {
            if (successCallback) {
                successCallback(config);
            }
        },
        error: function (err) {
            if (errorCallback) {
                errorCallback(err);
            }
        }
    });
}

function loadMemberInfoWithoutAckAlert(parameters) {
    var patientData = { patientVal: parameters.patientId, isPh: ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) };
    getProfileConfiguredToPatient(patientData, function (config) {
        if (config) {
            fireMethodNavigateToPatient(parameters.fid
                , parameters.appId
                , parameters.path
                , parameters.patientId
                , parameters.height
                , parameters.ctrltoclc
                , parameters.pfid
                , parameters.isActivityLog);
        } else {
            CustomAlert("You Can't Access this Patient");
            loader(0);
        }
    });
}

function initiateGCPatientQuickSearch(context, onCloseCallBack) {
    try {

        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/CommonDefaultSessionState/PatientQuickSearch?SearchVal=" + encodeURIComponent(context.SearchValue) + "&SearchOptionVal=" + encodeURIComponent(context.SearchName),
            popUpHeader: "Select Member (Displaying top 10 records)",
            onLoad: function () {
                loader(0);
                $('#popUpDialog1').css({ "width": "96%", "left": "2%" });
            },
            popLevel: 1,
            onClose: function () {
                $('#popUpDialog1').css("width", "");
                if (onCloseCallBack) {
                    onCloseCallBack();
                }
            }
        });
    } catch (e) { }
}

function initiateRouting(context, loadDashboardCallback) {
    if (!context) {
        return;
    }

    if (!context.Exists || context.HasDuplicates || context.IsSensitive) {
        initiateGCPatientQuickSearch(context, loadDashboardCallback);
    }
    else {
        clearFields();
        loadMemberInfoWithoutAckAlert({
            fid: 1,
            appId: Appid,
            path: '~/App_Pages/CM/Manage/MemberDetailsNew.ascx',
            patientId: context.PatientId,
            height: '800',
            ctrltoclc: null,
            pfid: null,
            isActivityLog: false
        });
    }
}

function fireMethod(fid, objid, path, objval, setheight, ctrltoclc, pfid, isActivityLog) {
    var patientData = { patientVal: objval, isPh: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? true : false };
    DevUtils.logDebug('GCHomeCommon.fireMethod()', 'MEMBER_ACCESSED_DROPDOWN', { patientData: patientData }, 'purple');

    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: patientData,
        success: function (dataProfileConfig) {
            if (dataProfileConfig) {
                //to check role permission to acknowledge the alerts or not and also check alert count when member is accessed based on which we redirct to member info
                if ((IsAlertAcknowledgementRequired == 'True' && ($('#selectPatientAccessed').val() != objval || $('#hdnIsDropdownChange').val() == '1')) && $("#hdnUmAGGotoCareMember").val() != '1') {
                    $.ajax({
                        type: "POST",
                        url: baseURL + "/Common/IndicatorAlertCountUpdate?patientId=" + objval,
                        dataType: "json",
                        success: function (data) {
                            if (data.success > 0) {
                                $("#hdnTotalAlertsCount").val(data.success);
                                $('#DivPatientAlerts').html('');//if alerts pop up is opened at member level and after if clicked on any member alerts grid is not binding
                                $('#popUpDialog3').CMNPopup({
                                    pvUrl: baseURL + "/CommonDefaultSessionState/PatientAlerts?patientId=" + objval,
                                    popUpHeader: "Alerts",
                                    modalWidth: MODAL_WIDTH.MEDIUM,
                                    popLevel: ($('#popUpGlobalCalendar').is(':visible')) ? nextPopupLevel() : 1,
                                    onClose: function () {
                                        if ($('#hdnIsPatientAlertsPopup').length > 0) {
                                            if (($("#hdnAcknowledgedAlertCount").val() != '' && $("#hdnAcknowledgedAlertCount").val() == 0) || $("#hdnTotalAlertsCount").val() == '0') {//to handle remove alerts condition
                                                fireMethodNavigateToPatient(fid, objid, path, objval, setheight, ctrltoclc, pfid, isActivityLog);
                                            }
                                            else {
                                                A11yAlerts.createWarningAlert('#GCHomeAlertAckMandatory', 'Alert acknowledgement is mandatory to access a member.');
                                                //to handle navigating back to search page in Global member search
                                                if ($("#lbShowCriteria").is(':visible') && $("#lbShowCriteria").val() == 'Show') {
                                                    $("#lbShowCriteria").trigger('click');
                                                }
                                                //if authid or complaint id is accessed and from global search if we try to access CM variables to handle in alert close without acknowledge
                                                if ((window.top.$(".ClsAgTab").is(":visible") && $('.CMMenu').is(':visible'))) {
                                                    RemoveLocalStorage(3);
                                                }//AG
                                                if ((window.top.$(".ClsAuthTab").is(":visible") && $('.CMMenu').is(':visible'))) {
                                                    RemoveLocalStorage(2);
                                                }//UM

                                                var patientAccessedDdl = $("#selectPatientAccessed").data("kendoDropDownList");
                                                var patientNameWithClntId = $('.MemSumMenuPtName').html() + ',' + $('.MemSumMenuPtClientPatientId').html();
                                                //within member summary and on dashboard with patient accessed, if member accessed is selected and from dropdwn choose different member and close with out acknowledging
                                                if (($('#lnkMemberInfo').is(':visible') && $('.MemSumMenuPtName').length > 0 && $('.MemSumMenuPtName').html() !== undefined && patientAccessedDdl.text() !== patientNameWithClntId)) {
                                                    var text = $.trim($('.MemSumMenuPtClientPatientId').html());
                                                    patientAccessedDdl.select(function (dataItem) {
                                                        return dataItem.ClientPatientId === text;
                                                    });
                                                }
                                                else {
                                                    if ($("#MvcMainBody .InAuthPage").length <= 0 && $("#MvcMainBody .InComplaintPage").length <= 0 && $('.MemSumMenuPtName').html() === undefined) // Added third condition so that Member Accessed should be shown in the drop down only when member is not yet accessed
                                                    {
                                                        patientAccessedDdl.text('Member Accessed');
                                                    }
                                                }
                                                if ($('.btnPatientCount').val() !== AlterCountResult) {
                                                    $('.btnPatientCount').val(AlterCountResult);
                                                }
                                            }
                                            $("#hdnTotalAlertsCount").val(''); $("#hdnAcknowledgedAlertCount").val('');
                                            acknowledgedAlertIds = [];
                                            $('#popUpDialog3').html('');
                                        }
                                    }
                                });
                            }
                            else {
                                fireMethodNavigateToPatient(fid, objid, path, objval, setheight, ctrltoclc, pfid, isActivityLog);
                            }
                        },
                        error: function () {
                            CustomAlert("Error Encountered");
                        }
                    });
                    $('#hdnIsDropdownChange').val('');
                }
                else {
                    fireMethodNavigateToPatient(fid, objid, path, objval, setheight, ctrltoclc, pfid, isActivityLog);
                }

                $("#hdnUmAGGotoCareMember").val('');
            }
            else {
                CustomAlert("You Can't Access this Patient");
                loader(0);
            }
        },
        error: function (err) {
            console.log(err);
        }
    });
}

/*END*/
/*Alerts Acknowledgement*/

let globalSelectedPatientId = -1;

function setpatinfo(objval) {
    DevUtils.logDebug('GCHomeCommon.setpatinfo() objval:', 'MEMBER_ACCESSED_DROPDOWN', objval, 'purple');
    var eleid = objval;
    globalSelectedPatientId = eleid;
    var patvalobj = { patId: objval }
    var PAccddl = $("#selectPatientAccessed").data("kendoDropDownList");
    $("#selectPatientAccessed").val(eleid);
    PAccddl.dataSource.read(patvalobj).then(function () {
        PAccddl.value(eleid);
    });
    runScriptButtonVisibility({ text: 'Run Script' });
}

function SetMvcVisibility(loc, childloc) {
    setTimeout(function () { setactionitems(); }, 1000);
    if ($.trim($("#MvcMainBody").html()) == "") {
        loadMemberdetails(loc, MemberAccessedCheck, childloc);
    }
    else {
        LoadMemberSummaryMenu(1, MemberAccessedCheck);
        SetControlDisplay(4);
        if (childloc != null && childloc != '' && childloc != undefined) {
            childctrlname = childloc;
            //if (childloc == "Form") {
            //    $("#lnkActivitySummaryTab").trigger("click");
            //} else { childctrlname = ""; }
        }
        if (loc == 'MTM') { fromScptForm = true; }
        selectTab(loc, childloc);
    }

}

function SetFireMethodRes(objval) {
    var pardata = { objval: objval };
    $.ajax({
        url: baseURL + "/Home/GetSetFireMethodRes",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            var res = data.split('|');
            if (res[0] == "true") {
                setpatinfo(objval);
            }
        },
        error: function (error) { }
    });
}

function MemberSumAddAuth() {
    var PatientAccessedText = $("#selectPatientAccessed").data("kendoDropDownList").text();
    var PatientAccessedValue = $("#selectPatientAccessed").val();

    if (PatientAccessedText == "Member Accessed" || PatientAccessedText == "Patients Not Available,") {
        if (isWfChatOpen) {
            postUnsentMessageState('fireNopatMethod', { pid: 0, pval: PatientAccessedText });
        }
        else {
            fireNopatMethod(0, PatientAccessedText);
        }
    }
    else if (PatientAccessedValue > 0) {
        loader(1);
        ClickFire(PatientAccessedValue);
    }
    else {
        if (isWfChatOpen) {
            postUnsentMessageState('memberSumAddAuthExtn');
        }
        else {
            memberSumAddAuthExtn();
        }
    }
}
function memberSumAddAuthExtn() {
    if (checkUnsentMsgWfChatBox(true)) {
        if (typeof hideHaven === 'function') { hideHaven(); }
        var ddlel = $("#selectPatientAccessed").data("kendoDropDownList");
        loader(1);
        ddlel.text("Member Accessed");
        $("#DivMemberSummaryMenu").hide();
        $('#DivAddAuthorizationMenu').hide();
        DevUtils.logDebug('Hiding memberInfoMenu 5');
        $('#lnkMemberInfo, #memberInfoMenu').hide();
        $('#divAction').hide();
        $('#divCarePlan').hide();
        $('#divCareNotes').hide();
        $('#MvcMainBody').hide();
        $('#MvcMainBodyBre').hide();
        loader(0);
        CallAllCtrls(1);
    }
}
function showBgBlanketLoader() {
    $("#BgBlanketLoader").show();
}

function hideBgBlanketLoader() {
    $("#BgBlanketLoader").hide();
}

function loader(val) {
    if (val === 0) {
        setTimeout(function () {
            hideBgBlanketLoader();
        }, 15);
    } else if (val === 1) {
        setTimeout(function () {
            showBgBlanketLoader();
        }, 15);
    } else if (val === 2) {
        hideBgBlanketLoader();
    } else {
        // do nothing (this is here for sonar)
    }
}

function BgBlanket(val) {
    if (val === 0) {
        $("#TotalBgBlanket").hide();
    } else if (val === 1) {
        $("#TotalBgBlanket").show();
    } else {
        // do nothing (this here for Sonar)
    }
}

function CallAllCtrls(ctrl, url, path, val, setheight, info, srMode, PHPatientId, RefId, RefType, isFromPH) {
    $('#closePopUp').trigger('click');
    PHPatientId = (PHPatientId == 'undefined' || PHPatientId == '') ? 0 : PHPatientId;
    RefId = (RefId == 'undefined' || RefId == '') ? 0 : RefId;
    RefType = (RefType == 'undefined' || RefType == '') ? 0 : RefType;
    if ($('#dBADT.TabbedPanelsTab.TabbedPanelsTabSelected').length > 0 && (RefId === undefined || RefId === 0) && (RefType === undefined || RefType === 0) && ($('#refIdAndTypeOfAdtorIpGrid').length > 0 && $('#refIdAndTypeOfAdtorIpGrid').val())) {
        if ($('#refIdAndTypeOfAdtorIpGrid').val().indexOf(',') > -1) {
            var refValues = $('#refIdAndTypeOfAdtorIpGrid').val().split(',');
            RefId = refValues[0]; RefType = refValues[1]; PHPatientId = refValues[2];
        }
        $('#refIdAndTypeOfAdtorIpGrid').val('');
    }
    //if (path == '~/App_Pages/CM/Manage/Configuration.ascx' && rolenameval != 'Admin' && rolenameval != 'Super Admin' && rolenameval != 'CO_Admin') {
    //    loader(0);
    //    alert('Please contact your administrator to create / manage profiles');
    //    return false;
    //}
    loader(1);
    if (ctrl == 1) {
        SetControlDisplay(1);
        loader(0);
    }
    else if (ctrl == 2) {
        if (url == '21') { $('#MvcMainBody').html(''); }
        SetControlDisplay(3);
        $("#ctrlval").val(path);
        if (setheight == '' || setheight == null)
            setheight = '800';
        setpathforctrl(url, path, val, info, setheight, ctrl, srMode, PHPatientId, RefId, RefType, isFromPH);
    }
    else if (ctrl == 3) {
        $("#DivMemberSummaryMenu").show();
        $('#DivAddAuthorizationMenu').show();
        SetControlDisplay(2);
        loader(0);
    }
    else if (ctrl == 4) {
        setpathforctrl(url, path, val, null, null, ctrl);
        $("#DivMemberSummaryMenu").show();
        $('#DivAddAuthorizationMenu').show();
        SetControlDisplay(2);
        loader(0);
    }

}

function SetControlDisplay(item) {
    if (item == 1) {
        $("#MvcDbLoadCtrl").show();
        $("#MvcAllLoadCtrl").hide();
        $("#id1frame").hide();
        $("#dummybackdiv").hide();
        $("#TotalBgBlanket").hide();
        $("#MvcMainBody").html('').hide();
        $("#MvcMainBodyBre").html('').hide();
        $('#MvcMainBodyConfig').html('').hide();
    }
    else if (item == 2) {
        $("#MvcAllLoadCtrl").show();
        $("#id1frame").show();
        $("#MvcDbLoadCtrl").hide();
        $("#dummybackdiv").hide();
        $("#TotalBgBlanket").hide();
        $("#MvcMainBody").html('').hide();
        $("#MvcMainBodyBre").html('').hide();
        $('#MvcMainBodyConfig').html('').hide();
    }
    else if (item == 3) {
        loader(2);
        $("#dummybackdiv").show();
        $("#TotalBgBlanket").show();
        $("#MvcDbLoadCtrl").hide();
        $("#MvcAllLoadCtrl").hide();
        $("#id1frame").hide();
        $("#MvcMainBody").html('').hide();
        $("#MvcMainBodyBre").html('').hide();
        $('#MvcMainBodyConfig').html('').hide();
    }
    else if (item == 4) {
        $("#MvcMainBody").show();
        $("#MvcDbLoadCtrl").hide();
        $("#MvcAllLoadCtrl").hide();
        $("#id1frame").hide();
        $("#dummybackdiv").hide();
        $("#TotalBgBlanket").hide();
        $("#MvcMainBodyBre").html('').hide();
        $('#MvcMainBodyConfig').html('').hide();
    }
    else if (item == 5) {
        $("#MvcMainBodyBre").show();
        $("#MvcDbLoadCtrl").hide();
        $("#MvcAllLoadCtrl").hide();
        $("#id1frame").hide();
        $("#dummybackdiv").hide();
        $("#TotalBgBlanket").hide();
        $("#MvcMainBody").html('').hide();
        $('#MvcMainBodyConfig').html('').hide();
    } else if (item == 6) {
        $('#MvcDbLoadCtrl').hide();
        $('#MvcAllLoadCtrl').hide();
        $('#dummybackdiv').hide();
        $("#TotalBgBlanket").hide();
        $('#MvcMainBody').html('').hide();
        $('#MvcMainBodyBre').html('').hide();
        $('#MvcMainBodyConfig').show();
        $('#id1frame').hide();
    }
}

function faxSearchHighlight(faxOCRData) {
    for (let i = 0; i < OcrJsonToFaxSearchMapping.length; i++) {
        var value = OcrJsonToFaxSearchMapping[i].value;
        var field = OcrJsonToFaxSearchMapping[i].field;
        if ($('#selectFaxSearchtype option[value="' + value + '"]').length > 0 && faxOCRData[field] && faxOCRData[field].toString().trim() !== "") {
            $('#selectFaxSearchtype').val(value);
            appendSearchFieldLabel();
            $('#txtFaxSearch').val(faxOCRData[field]);
            faxSearchFlag = true;
            break;
        }
    }

    if (faxSearchFlag === false && ($.fn.notUndefinedNullEmpty(faxOCRData.PatientName) || $.fn.notUndefinedNullEmpty(faxOCRData.DateOfBirth)) ) {
        $('#txtFaxSearch').val(faxOCRData.PatientName);
        let dateOfBirth = kendo.toString(kendo.parseDate(faxOCRData.DateOfBirth), "MM/dd/yyyy");
        $('#txtFaxDateSearch').val(dateOfBirth);
        faxSearchFlag = true;
    }

    if (faxSearchFlag === true) {
        SearchFaxMembers();
    } else {
        $('#FaxGridQuickSearch').data('kendoGrid').dataSource.fetch();
    }

    if ($.fn.notUndefinedNullEmpty(faxOCRData.ValidationMessage)) {
        A11yAlerts.create('#divFaxValidationMessage', faxOCRData.ValidationMessage, { alertType: A11yAlerts.ALERT_TYPE.WARNING });
    }
}

function openAddActivityFromCompleteAndAdd() {
    window.top.loader(1);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/EditActivity?patientId=" + $("#selectPatientAccessed").val(),
        onLoad: function () {
            onLoadEditActivity();
            if ($("#selectActivityType").data("kendoDropDownList") != null) { $("#selectActivityType").data("kendoDropDownList").enable(true) };//uhg-925
            $('#selectScript').removeAttr('disabled');
            window.top.loader(0);
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        onClose: function () {
            ClearActivityHdnCntrls();
        },
        popUpHeader: "Add Activity",
        popLevel: 1,
        modalWidth: MODAL_WIDTH.MEDIUM,
        closeButton: "#btnCloseEditActivityForm"
    });
}

function clickfireNopat(isChecked, OutComeId, OutComeNotes, FollowUpId, actualDuration, placeOfServiceId, hdnPHPatientId, contactType, HCPCCodeId, isActivity, scriptName, activityOutcomeName, activityOutcomeType, isMemPortalProvReview) {
    var PatientAccessedValue = $("#selectPatientAccessed").val();
    var val = $("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#CustomFieldDetailsXmlData').val(fnCreateCustomFieldstoXML("ActivityOutcomeCustomFieldUnique", 2, 2));

    if (PatientAccessedValue > 0 || hdnPHPatientId != "0") {
        if (isChecked && hdnPHPatientId == "0") {
            ClickFirePlan(PatientAccessedValue);
            if (isActivity == 'true') {
                isFromCompleteandaddActivity = true;
            }
        }
        else {
            if (isActivity == 'true') {
                openAddActivityFromCompleteAndAdd();
            }
        }
        isMemPortalProvReview = typeof (isMemPortalProvReview) !== 'undefined' ? isMemPortalProvReview : false;
        var dataStr = {
            patientFollowUpId: FollowUpId,
            activityOutComeId: OutComeId,
            activityOutComeNotes: OutComeNotes,
            actualDuration: actualDuration,
            placeOfServiceId: placeOfServiceId,
            contactType: contactType,
            HCPCCodeId: HCPCCodeId,
            CustomFieldDetailsXmlData: val.serialize(),
            IsMemberReview: isMemPortalProvReview
        };
        $.ajax({
            type: "POST",
            url: baseURL + "/ActivityRecord/ActivityOutComeUpdate",
            dataType: "json",
            data: dataStr,
            async: false,
            success: function (data) {
                var ficoObject = { eventSource: "CMSCRIPTACTIVITYPERFORM", parentConrolId: dataStr, moduleName: "CM", eventType: "POST", patientFollowupId: FollowUpId };
                var responseScriptActivity = ficoRealTimeValidation(ficoObject);
                CheckValidationMessages(responseScriptActivity);
            }
        });
    }
    else {
        CustomAlert("Error Occured in accessing Patient. Please Coordinate Application Team.");
    }
}

function CommaSeperatedStringToList(name, id, isExceeded, FirstName) {
    var htmlContacts = "", namesArray = [];
    if (name != null)
        namesArray = name.split(',');

    if (namesArray.length >= 1 && namesArray[0] != "") {
        htmlContacts += "<table id='tblOppts' style='border:1px solid lightgrey !important;'>";
        for (var i = 0; i < namesArray.length; i++) {
            if (i < 2) {
                htmlContacts += "<tr style='border-bottom:1px solid black;'><td style='width: 13px;vertical-align: top;'><img src='" + baseURL + "/StaticContents/images/bullet.png' /></td><td>" + namesArray[i] + "</td></tr>";
            }
            else {
                if (namesArray.length > 2 && i == 2 && isExceeded == true) {
                    htmlContacts += "<tr style='border-bottom:1px solid black;'><td style='width: 13px;vertical-align: top;'><img src='" + baseURL + "/StaticContents/images/bullet.png' /></td><td>" + namesArray[i] + "&nbsp;&nbsp;<i><a id='lbtnCareOrganisations' onclick='callShowCareOrganisations(this);' data-firstname='" + FirstName + "' data-id='" + id + "' href='javascript:;' data-isexceeded='" + isExceeded + "' style='color: #1378a3; display:#=" + isExceeded + "?'block':'none' #'>..more</a></i></td></tr>";
                }
                else if (i == 2) {
                    htmlContacts += "<tr style='border-bottom:1px solid black;'><td style='width: 13px;vertical-align: top;'><img src='" + baseURL + "/StaticContents/images/bullet.png' /></td><td>" + namesArray[i] + "</td></tr>";
                }
            }
        }
        htmlContacts += "</table>";
    } else {
        htmlContacts = 'N/A';
    }

    return htmlContacts;
}

function PrepareHyperlink(name, lobBenId) {
    if ((lobBenId || '0') == '0') {
        return name;
    } else {
        return "<a data-lobbenid='" + lobBenId + "' class='clsViewHierarchyData' title='View Eligibility' style='cursor: pointer;' role='button'>" + name + "</a>";
    }
}
function ClickFire(pid, ctrlname, IsProfile, obj) {
    if (pid !== parseInt($("#selectPatientAccessed").data("kendoDropDownList").value()) && isWfChatOpen) {
        postUnsentMessageState('postClickFire', { pid: pid, ctrlname: ctrlname, IsProfile: IsProfile, obj: obj }); //to alert the user if chat popup is opend and any unsent message.
    }
    else {
        postClickFire(pid, ctrlname, IsProfile, obj);
    }
}
function postClickFire(pid, ctrlname, IsProfile, obj) {
    if (checkUnsentMsgWfChatBox()) {
        DevUtils.logDebug('GCHomeCommon.ClickFire()', 'MEMBER_ACCESSED_DROPDOWN', { pid: pid, ctrlname: ctrlname, IsProfile: IsProfile, obj: obj }, 'purple');

        $('#MyCalenderDiv_tt_active.k-tooltip-closable:visible').hide();
        $('#MyCalenderDiv_tt_active').parent('div.k-animation-container').removeAttr('style');
        $(".k-animation-container").css("display", "none");
        var isGlobalMySchedule = $("#popUpGlobalMySchedule").is(':visible');
        var inMemberDetails = ($('#MvcMainBody #MemberSummaryInPage').length > 0);
        var diffPatient = $("#selectPatientAccessed").val() != pid;
        var newPatient = $("#selectPatientAccessed").val() == '';
        var isGlobalCalendar = $("#popUpGlobalCalendar").is(':visible');
        if ((isGlobalMySchedule && inMemberDetails && diffPatient) || (isGlobalMySchedule && newPatient)) {
            var member = $(obj).text().split(',')[0].trim();
            $().ConfirmationBox({
                Title: 'WARNING!', Top: 200, ButtonAlign: 'center', Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }],
                Content: "You will be redirected to <b class='primaryColor'>" + member + "</b>'s Member Details. Are you sure you want to continue?"
            }, function (response) {
                if (response) {
                    var str = pid;
                    if (!isGlobalCalendar) {
                        clearFieldsText();
                    }
                    fireMethod(1, Appid, '~/App_Pages/CM/Manage/MemberDetailsNew.ascx', pid, '800', ctrlname);
                }
            });
        }
        else {
            var str = pid;
            if (!isGlobalCalendar) {
                clearFieldsText(2);
            }
            fireMethod(1, Appid, '~/App_Pages/CM/Manage/MemberDetailsNew.ascx', pid, '800', ctrlname);
        }

        if ($("#divBulkActPer").hasClass('ui-dialog-content')) {
            $("#divBulkActPer").dialog("close");
        }
    }
}

function clearFieldsText(popupCloseCount = 1) {
    $('#txtSearch').val('');
    $("#quickSearchdate").val("");
    for (let i = 0; i < popupCloseCount; i++) {
        if ($('#closePopUp').is(':visible')) {
            $('#closePopUp').trigger('click');
        }
        else if ($('#closePopUpUM').is(':visible')) {
            $('#closePopUpUM').trigger('click');
            if ($.fn.isNullOrEmpty($("#selectPatientAccessed").val()) && globalSelectedPatientId !== -1) {
                $("#selectPatientAccessed").val(globalSelectedPatientId);
            }
        }
        else {
            break;
        }
    }
    CurrentPatientIdGlobal = false;
}

function ClickFireRRMsgs(pid, ctrlname, IsProfile) {
    if (IsProfile == "0" && ISPHMembers && isProvider) {
        CmnStatusMessageDisp('spanAlertActivity', 'Activity cannot be performed as member is inactive', 'Error');
        return;
    }
    if (pid == 0) {
        CustomAlert('Member details are not available.');
        return;
    }
    var str = pid;
    clearFields();
    fireMethod(1, Appid, '~/App_Pages/CM/Manage/MemberDetailsNew.ascx', pid, '800', ctrlname);

}

function callscriptfunction() {
    var PAccddl = $("#selectPatientAccessed").data("kendoDropDownList");
    var textpsel = PAccddl.text();
    if (textpsel != "Member Accessed") {
        var memsumpname = $.trim($(".MemSumMenuPtName").html());
        var memSumCliPatID = $.trim($(".MemSumMenuPtClientPatientId").html());
        var [ddlspname, ddlCliPatID] = textpsel.split(',');
        if (ddlspname == memsumpname && memSumCliPatID === ddlCliPatID) {
            $("#DivMemberSummaryMenu").show();
        }
        else {
            setTimeout(function () {
                LoadMemberSummaryMenu(1, MemberAccessedCheck);
            }, 1000);
        }
    }
}

function Closepopup(ctrlid) { $("#" + ctrlid + "div").remove(); BgBlanket(0) }

function ModuleParam() {
    return {
        RoleId: RoleIdVal,
        IS_PHCP_FLAG: false,
        source: "MAL"
    }
}

function LoadReferParam() {
    //var value = $('#hdnModeType').val();
    //mval=
    return {
        moduleID: $('#selectRequestReceivedModule').data("kendoDropDownList").value(),
        modeType: $('#hdnModeType').val(),
        roleId: RoleIdVal
    }
}

function validateAddEditPhoneNumber() {
    var flag = true;
    var type = $('#selectType').val();
    if (type == -1) {
        $('#trType').find('.requiredfields').show(); flag = false;
    } else {
        $('#trType').find('.requiredfields').hide();
    }
    var phone = $('#txtPhoneNumber').val();
    if (!phone) {
        $('#trPhone').find('.requiredfields').show(); flag = false;
    } else {
        if (!$('#txtPhoneNumber').val().match(PhoneandFaxformat)) {
            CustomAlert('Please enter the phone number in xxx-xxx-xxxx format');
            flag = false;
        }
        else
            $('#trPhone').find('.requiredfields').hide();
    }
    return flag;
}

function ChkShowHidePhoneNumberDtls() {
    var chkdChBxs = $('#PhoneNumberDetailsGrid .clsPhoneNumberDetails:checked');
    var prefrdPhoneNo = [];
    if (roleConfig != null && roleConfig.length != 0) {
        prefrdPhoneNo = $.greproleext(roleConfig, function (ele, _ind) {
            return ele.UniqueName === "AHS_CM_MEMBER_MEMBER_DETAILS_PHONENUMBERS";
        });
    }
    if (chkdChBxs.length == 1) {
        var type = $(chkdChBxs[0]).data('type');
        //if(type !='HomePhone' && type !='CellPhone' && type !='AlternateEmail')
        if (type != 'PRIMARY PHONE' && type != 'ALTERNATE PHONE' && type != 'CELL PHONE') {
            $('#imgbtnAddPhoneNumberDetails').hide();
            $('#imgbtnPatientPhoneNumberEdit').show();
            $('#imgbtnphoneNumberPreferred').show();
            $('#imgbtnDeletePhoneNumberDetails').show();
        }
        else {
            $('#imgbtnAddPhoneNumberDetails').hide();
            $('#imgbtnPatientPhoneNumberEdit').hide();
            $('#imgbtnphoneNumberPreferred').show();
            $('#imgbtnDeletePhoneNumberDetails').hide();
        }
    }
    else if (chkdChBxs.length == 0) {
        $('#imgbtnAddPhoneNumberDetails').show();
        $('#imgbtnPatientPhoneNumberEdit').show();
        $('#imgbtnphoneNumberPreferred').show();
        $('#imgbtnDeletePhoneNumberDetails').show();
    }
    else if (chkdChBxs.length > 1) {
        $('#imgbtnAddPhoneNumberDetails').hide();
        $('#imgbtnPatientPhoneNumberEdit').hide();
        $('#imgbtnphoneNumberPreferred').hide();
        $('#imgbtnDeletePhoneNumberDetails').show();
    }
    //PROD-4974
    if ($(chkdChBxs).length > 0 && $(chkdChBxs).data('ispref')) {
        $('#MemberPhoneNumberGridDiv #imgbtnphoneNumberPreferred').attr('disabled', 'true');
    }
    else {
        if (prefrdPhoneNo.length > 0 && prefrdPhoneNo[0].IsEdit == true) {
            $('#MemberPhoneNumberGridDiv #imgbtnphoneNumberPreferred').removeAttr('disabled');
        }
    }
}

function SubmitSelfReferMember(inactivateCM) {
    var patientIdSR = null;
    if ($("#hdnIsFromIAPCM").val() == "SRFRR")
        patientIdSR = $('#hdnUmAuthReqRejReferReferCommentsPatientId').val();
    else
        patientIdSR = $('#selectPatientAccessed').val();
    $.ajax({
        type: "GET",
        url: baseURL + "/Home/SelfReferAgain?patientId=" + patientIdSR + "&inactivateCM=" + inactivateCM + "&isActTransfer=" + $("#hdnIsActTransfer").val(),
        dataType: "json",
        success: function (data) {
            $("#hdnIsActTransfer").val('');
            if (data.success) {
                // $("#Message").html('Self Referred successfully.!');                
                if ($(".ExpandedCareManager").length > 0) {
                    $(".ExpandedCareManager").AhsSetHtml(data.careStaffName);
                }
                if ($("#hdnIsFromIAPCM").val() != "SRFRR") {
                    $('#popUpDialog1').CMNPopup({
                        pvUrl: baseURL + "/Home/ReferMember",
                        popUpHeader: "Refer Member",
                        onLoad: function () {
                            $('#hdnCareStaffReferMember').val(''); $('#selectReasonForreference').val('-1'); $("#ReferNotes").val('');//kuhg-881
                            //CmnStatusMessageDisp('Message', 'Self Referred successfully.!', 'Success');
                        }
                    });
                }
                else {
                    $('#popUpDialog3').find("#closePopUp").trigger('click');
                    CustomAlert('Self Referred successfully.');
                }
                loader(0);
            }
            else {
                loader(0);
                CustomAlert(data.msg);
            }
        }
    });
}

function resetFilter() {
    globalAlertFilter = "";
    globalAlertFilterText = "";
    globalRiskFilter = "";
    globalRiskFilterText = "";
    globalDiseaseFilter = "";
    globalDiseaseFilterText = "";
    globalQIndicatorFilterNum = ""; globalQIndicatorFilterDNum = "";
    globalQIndicatorFilterTextNum = "";
    globalQIndicatorFilterDenom = "";
    globalQIndicatorFilterTextDenom = "";
    globalindcatros = "", globalprograms = "", globaloppertunities = ""; globalprogramsText = ""; globaloppertunitiesText = ""; globalIndicatorsText = "";

}

function setMembercomplaintpage(params, value, ComplaintRecordId, ComplaintTypeId, isFromAddEdit) {
    if (enableDomLogs && value === 0) {
        DomUtils.logDomData("AccessComplaint>> Member Complaint Log>>Add Complaint");
    }
    $('#divContentMemSession').html('');
    if (ToValue(viewbagPatientInfo, null) === null) {
        var PI = AgPatient_ComplaintInfo("", "");
        var PatientName = PI.PatientName.split(' ');
        viewbagPatientInfo = PI.PatientId + ',' + PatientName[0] + ',' + PatientName[1];
    }
    var str = viewbagPatientInfo.split(',');
    var patId;
    if ($("#MvcMainBody .InComplaintPage").length > 0) {
        patId = str[0];
    }
    else { patId = ToValue($("#selectPatientAccessed").val(), '') !== '' ? $("#selectPatientAccessed").val() : str[0]; }
    if (isFromAddEdit) {
        isFromOpenComplaintEdit = true;
    }
    if (value == 1) {
        var ComplaintData = $(params).attr('data-details');
        var varlist = ComplaintData.split('|');
        SetComplaintData(varlist[0], varlist[4], varlist[3], null, null, null);
    }
    else if (value === 2) {
        agComplaintMenuHide();
        loader(1);
        SetComplaintData(patId, ComplaintRecordId, ComplaintTypeId, null, null, null);
    }
    else {
        loader(1);
        SetComplaintData(patId, 0, 1, null, null, null);
    }
}

function ValidationForExCrTmAddressForm() {
    var msgcount = 0;
    $('#statusUpdMsgAddPr').html('');
    $('#lblStatusExCrTmMsg').html('');
    $('span.validationMessage').remove();
    if ($('#ddlExtCrTmStates').val() == -1) {
        $('#ddlExtCrTmStates').closest('td').find('.requiredfields').show();
        msgcount = 1;
    } else {
        $('#ddlExtCrTmStates').closest('td').find('.requiredfields').hide();
    }
    if ($.trim($('#txtExtCrTmAddAddress').val()) == "") {
        $('#txtExtCrTmAddAddress').closest('td').find('.requiredfields').show();
        msgcount = 1;
    } else {
        $('#txtExtCrTmAddAddress').closest('td').find('.requiredfields').hide();
    }
    /*prod-162*/
    if ($('#txtExtCrTmAddZip').val() == "") {
        $('#txtExtCrTmAddZip').closest('td').find('.requiredfields').show();
        msgcount = 1;
    } else {
        $('#txtExtCrTmAddZip').closest('td').find('.requiredfields').hide();
        if (!$('#txtExtCrTmAddZip').val().match(WorkZipExp)) {
            $('#ZipMsg').append('<span class="validationMessage" style="color:red;Font-weight:Bold;font-size: 10px;"><br/>Please enter a valid zip code of 5 or 9 digits.</span>');
            msgcount = 1;
        }
    }
    /*prod-162*/
    if ($('#txtExtCrTmAddPhone').val() != "") {
        if (!$('#txtExtCrTmAddPhone').val().match(PhoneandFaxformat)) {
            $('#txtExtCrTmAddPhoneMsg').append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    }
    if ($('#txtExtCrTmAddFax').val() != "") {
        if (!$('#txtExtCrTmAddFax').val().match(PhoneandFaxformat)) {
            $('#txtExtCrTmAddFaxMsg').append('<span class="validationMessage" style="color:red;Font-weight:Bold;">Invalid Format</span>');
            msgcount = 1;
        }
    }

    if (msgcount == 1) {
        return false;
    }
    else {
        return true;
    }
}

function CarePlanMultipleAddressChkFun() {
    ChkShowHideCrTmAddress();
}

function ChkShowHideCrTmAddress() {
    var chkdChBxCrTm = $('#ProviderMultipleAddress .clschkCareTeamAddress:checked');
    if (chkdChBxCrTm.length == 1) {
        $('#btnProviderAddressAdd').hide();
        $('#btnProviderAddressEdit').show();
    }
    else if (chkdChBxCrTm.length == 0) {
        $('#btnProviderAddressAdd').show();
        $('#btnProviderAddressEdit').show();
        $('#ProviderMultipleAddress .clschkCareTeamAddressHead').prop('checked', false);
    }
    else if (chkdChBxCrTm.length > 1) {
        $('#btnProviderAddressAdd').hide();
        $('#btnProviderAddressEdit').hide();
    }
}

function onCareStaffDropdownPHChangeBulk(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var internalCareStaffId = DataItem.Value;
    $("#hdnstaffIdBulkPH").val(internalCareStaffId);
}
function onCareStaffDDLDataPHBulkBound(e) {
    var noItems = this.list.find(".noDataMessage");

    if (!this.dataSource.view()[0]) {
        noItems.show();
        this.popup.open();
    } else {
        noItems.hide();
    }
}

function onCareStaffDetailsParamPHBulk() {
    $('#hdnstaffIdBulkPH').val("");
    var patID = '';
    return {
        staffName: $('#ddlCareStaffPHBulk').val(),
        patientId: patID,
        isMTM: (isMTMval === true || isMTMval.toLowerCase() === 'true')
    }
}
function ProviderMultiAddressClear() {
    $('#txtExtCrTmAddAddress').val('');
    $('#txtExtCrTmAddCity').val('');
    $('#ddlExtCrTmStates').val('-1');
    $('#ddlExCrTmAdrsType').val('-1');
    $('#txtExtCrTmAddZip').val('');
    $('#ddlExCrTmBoroughs').val('-1');
    $('#txtExtCrTmAddFax').val(''); $('#txtExtCrTmAddPhone').val('');
    $('#chkPABAddIsPrimary').prop('checked', false);
    $('#statusUpdMsgAddPr').html('');
}

function CarePlanMultipleAddressParameters() {
    return {
        ProviderId: $('#AddProviderForm #PhysicianId').val()
    }
}

//AddEditCareGiver
function AddCareGiver() {
    if (AddOrEditCareGiver1("/CareGiver/SaveCareGiver")) {
        $.ajaxSetup({ async: false });
        // $('#lnkCareGivers').trigger('click');
        $('#dvgrdCareGivers').show();
        $('#dvBtnCareGivers').show();
        $('#dvCareGiversAddEdit').hide();
        Resetfields();
        $("#memeberCaregiverTbl").show();
        $('.ah-required-note.is-visible').removeClass('is-visible');
        $('#CareGivers').data("kendoGrid").dataSource.read();
        $.ajaxSetup({ async: true });
        loader(0);
        CmnStatusMessageDisp('spmsg', 'Record added successfully.', 'Success');
    }
    else {
        loader(0);
    }
}

function bulkAddActivityPopup(bulkPatientId) {
    $('#bulkPatientIdAddActivity').val(bulkPatientId);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/EditActivity?IsFromBulkActivity=true",
        onLoad: function () {
            onLoadEditActivity();
            $('#FollowupHrs').val('00');
            $('#FollowupMins').val('30');
            $('.addActivityPatientName, #AddActFor').hide();
            if (($('#bulkPatientIdAddActivity').val() || '').indexOf(',') > 0) {
                $('#divProgramActivity, #divCliProgramActivity').hide();
            }
            $('#selectScheduledType option[value="2"], #selectScheduledType option[value="3"]').remove();
            $('#rdoEAExternal').prop('disabled', true);
            A11yModal.trapFocusInModal('popUpDialog1');
            $("#divGroupActivity").hide();
        },
        onClose: function () {
            var $hdnCareStaff = $("#hdnCareStaffAddActivity");
            $('#hdnWorkFlowSwitch').val('');
            if ($hdnCareStaff.length) {
                $hdnCareStaff.val('');
            }
            $('#rdoEAExternal').prop('disabled', false);
            $('#AddActFor').show();
            $('#bulkPatientIdAddActivity').val('');
        },
        popUpHeader: "Add Activity",
        popLevel: 0,
        modalWidth: MODAL_WIDTH.MEDIUM,
        closeButton: "#btnCloseEditActivityForm"
    });
}
function UpdateCareGiver() {
    if (AddOrEditCareGiver1("/CareGiver/UpdateCareGiver")) {
        $.ajaxSetup({ async: false });
        // $('#lnkCareGivers').trigger('click');
        $('#dvgrdCareGivers').show();
        $('#dvBtnCareGivers').show();
        $('#dvCareGiversAddEdit').hide();
        Resetfields();
        $("#memeberCaregiverTbl").show();
        $('.ah-required-note.is-visible').removeClass('is-visible');
        $('#CareGivers').data("kendoGrid").dataSource.read();
        $.ajaxSetup({ async: true });
        loader(0);
        CmnStatusMessageDisp('spmsg', 'Record updated successfully.', 'Success');
    }
    else {
        loader(0);
    }
}

function Resetfields() {
    $('#popUpDialog1 #portletHeadHand').find('#closePopUp_1').attr('id', 'closePopUp');
    $('#txtEditDtaPCPFirstName1').val('');
    $('#txtEditDtaPCPLastName1').val('');
    $('#txtEditDtaPCGMName1').val('');
    $('#txtEditDtaPCGDOB1').val('');
    $('#ddlEditDtaPCGGender1').val(-1);
    $('#ddlEditDtaPCGPrimLang1').val(-1);
    $('#ddlEditDtaPCGPreferredLang1').val(-1);
    $('#ddlEditDtaPCGEtnicity1').val(-1);
    $('#txtEditDtaPCGCellPh1').val('');
    $('#txtEditDtaPCGHomePh1').val('');
    $('#txtEditDtaPCGAltPhone1').val('');
    $('#txtEditDtaPCGEmail1').val('');
    $('#txtEditDtaPCGAltEmail1').val('');
    $('#txtEditDtaPCGAddress1').val('');
    $('#txtEditDtaPCGCity1').val('');
    $('#txtEditDtaPCGZIP1').val('');
    $('#ddlEditDtaPCGstate1').val(-1);
    $('#txtEditDtaPCGCountry1').val('');
    $('#ddlEditDtaCGMaritalStat1').val(-1);
    $('#ddlEditDtaCGResidenceStatus1').val(-1);
    $('#txtEditDtaCGFax1').val('');
    $('#ddlCGCounty1').val(-1);
    $('#ddlEditDtaPCGRelationship1').val(-1);
    $('#ddlEditCGDataBorough1').val(-1);
    $('#txtPCGRelationship1').val('');
    $('#chkIsPrimary1').prop("checked", false);
    $('#chkHealthProxy1').prop("checked", false);
    $('#chkMemberPortalAccessCareGiver').prop("checked", false);
    $('#txtCrGvrStartDate').val('');
    $('#txtCrGvrEndDate').val('');
    $('#rdo_Formal').prop("checked", false);
    $('#rdo_Informal').prop("checked", false);
    $('#rdo_FormalNatural').prop("checked", false);
}

function onChangeClickHisp(myDdl) {

    var id1 = myDdl.id;
    if (id1 == "selectCareteamHisp") {

        $('#selectCareStaffHisp')[0].selectedIndex = 0;

        if ($('#selectCareteamHisp').val() == "-1")
            $('#txtMsgSentTo').val("");
        else
            $('#txtMsgSentTo').val($('#selectCareteamHisp').val());
    }
    else {
        $('#selectCareteamHisp')[0].selectedIndex = 0;
        if ($('#selectCareStaffHisp').val() == "-1")
            $('#txtMsgSentTo').val("");
        else
            $('#txtMsgSentTo').val($('#selectCareStaffHisp').val());
    }
}

function validateEmail() {
    var sEmail = $('#txtMsgSentTo').val();
    var regex = /^[a-z0-9\.\_%+-]+@[a-z0-9\.\-]+\.[a-z]{2,4}$/i;
    if (sEmail.search(regex)) {
        return true;
    }
    else {
        return false;
    }
}
//EditUserProfile

function validateCareStaffProfileForm() {
    var result = ValidateCareStaffDetails();

    if (result == true) {
        UpdateCareStaffDetails();
    }
}

//Full Care Plan Grid
function onTmCrPlFullCrPlDataBound() {
    $('div.hOverConditionNameCls').aToolTip();
    $('div.hOverActualStartDateCls').aToolTip();
    $('div.hOverActualEndDateCls').aToolTip();
    uncheckCarePlanCheckBoxItems();
    gridNotAvailableCustomColor('GridFullCarePlan');
    A11yGrid.enhanceKendoGridForA11y('GridFullCarePlan', 8, 0);
}

//Letters

function GetLetter(ltrid) {
    var retVal, desc;
    var pardata = { letter: ltrid };
    $.ajax({
        type: "POST",
        url: baseURL + '/Home/GetLetter/',
        data: pardata,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.success) {
                retVal = data.val;
                desc = data.desc;
                $('#descriptionID').AhsSetHtml(desc);
            }
        }
    });
    return retVal;
}

function onProgramsDataBound() {
    $('#hMenGdCP').hide();
    $('.hOverProgEligibilityCls').aToolTip();
    $('.hOverLobNameCls').aToolTip();
    $('.hOverPlanNameCls').aToolTip();
    $('.hOverProgNameCls').aToolTip();
    $('.hOverStatusNameCls').aToolTip();
    //Mahesh Podalakuru QM-Family Members
    if ($("#gridQM").is(':visible')) {
        var grid = $("#gridQM").data("kendoGrid");
        if ($('#spnGlobalSearchSuccss').is(':visible')) {
            $('#spnGlobalSearchSuccss').hide();
        }
        $('#gridQMOverlay').hide();
        var childMemberIds = [];

        //Show only parent records in QM GRID---HIDE CHILD RECORDS
        var gridDataItem = grid.dataSource.data().filter(function (item) {
            return item.IS_PARENT === 0;
        });
        $.each(gridDataItem, function (i) {
            grid.tbody.find("tr[data-uid='" + gridDataItem[i].uid + "']").hide();
            $('.k-grid-content-locked').find("tr[data-uid='" + gridDataItem[i].uid + "']").hide();
            childMemberIds.push(gridDataItem[i].FAMILY_ID);

        });
        //To Remove Expand Icon For no child Records
        var gridParentRows = grid.dataSource.data().filter(function (item) {
            return item.IS_PARENT === 1;
        });
        $.each(gridParentRows, function (i) {
            if ($.inArray(gridParentRows[i].FAMILY_ID, childMemberIds) === -1) {
                $("#" + gridParentRows[i].PATIENT_ID + '_' + gridParentRows[i].AUTO_INCREMENT).removeClass('Qm_Plus');
            }
        });

        //Retain Expanding Rows
        if (QmVisibleRows.length > 0) {
            $.each(QmVisibleRows, function (i) {
                var id = QmVisibleRows[i];
                showChildRows(id.split('$')[0], id.split('$')[1], id.split('$')[2]);
            });
        }

    }
    if ($('.BoxNSYmn').length > 0) {
        $('#btnIndictorRejectionHstry').show();
    }
    gridNotAvailableCustomColor('ProgramsGrid');
    A11yGrid.enhanceKendoGridForA11y('ProgramsGrid', 'ProgramName', 0);
}

function autoFormatPhoneNumer(x) {
    x = x.replace(/[^\d]+/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    return x;
}

//Menu
function JsRunScript(scriptId, patId, servicePlanId, authNo, sectionName) {
    servicePlanId = servicePlanId == undefined ? 0 : servicePlanId;
    var pardata = {}; CallingIframeJsFunction(null);
    $("#hdnScptCareActivityTypeId").val('');
    var url = baseURL + "/Home/Checkscript?IsUM=false&servicePlanId=" + servicePlanId + "&AuthNo=" + authNo + "&PatientId=" + patId;
    if ($("#hdnPHRunScriptSection").val() !== undefined && $("#hdnPHRunScriptSection").val() !== null && $('#hdnPHRunScriptSection').val() === "PH_MyMembers") {
        url = baseURL + "/Home/Checkscript?IsUM=false&servicePlanId=" + servicePlanId + "&AuthNo=" + authNo + "&IsPH=true" + "&PatientId=" + patId;
        if (patId !== null && patId !== '' && patId > 0) {
            $("#hdnPHRunScriptMemberId").val(patId);
        }
        $('#hdnPHRunScriptSection').val('');
    }
    $.ajax({
        url: url,
        type: "POST",
        datatype: "JSON",
        data: pardata,
        success: function (data) {
            if (data == "true") {
                if (scriptPerformActivityData) {
                    CompleteActivityAS(scriptPerformActivityData);
                    scriptPerformActivityData = undefined;
                }
                if ($("#hdnPHRunScriptMemberId").val() !== undefined && $("#hdnPHRunScriptMemberId").val() !== null && $("#hdnPHRunScriptMemberId").val().length > 0) {
                    var patID = $("#hdnPHRunScriptMemberId").val();
                    setpatinfo(patID);
                    setactionitems();
                    $('#lnkMemberInfo, #memberInfoMenu').show();
                }
                CallAllCtrls(2, 0, '~/App_Pages/CM/Operational/RunScriptContainer.ascx', '', '800');
            }
            else if (data == "false") {
                if ($('#popUpDialog1').html() != "" && $('#ddlScriptsmvc,#tblSrMode', $('#popUpDialog1')).length > 0) {
                    $('#popUpDialog1').html('');
                }
                var RSUrl;
                if (scriptId && scriptId > 0) {
                    RSUrl = baseURL + "/Home/RunScript?patientId=" + patId + "&scriptId=" + scriptId + "&memberId=" + memberidval + "&ServicePlanId=" + servicePlanId + "&AuthNo=" + authNo + "&RunScriptSection=" + sectionName;
                } else {
                    RSUrl = baseURL + "/Home/RunScript?ServicePlanId=" + servicePlanId + "&AuthNo=" + authNo + "&RunScriptSection=" + sectionName;
                }
                $('#popUpDialog1').CMNPopup({
                    pvUrl: RSUrl,
                    onLoad: function () {
                        if (scriptId) {
                            var x = $('#ddlScriptsmvc').find('option').map(function () { return $(this).attr("value"); });

                            if ($.inArray(String(scriptId), x) != -1) {
                                $('select[name=ddlScriptsmvc] option').filter(function () {
                                    return ($(this).val() == scriptId);
                                }).prop('selected', true);
                                $('#ddlScriptsmvc').trigger('change').prop('disabled', true);
                            }
                        }
                    },
                    onClose: function () {
                        scriptPerformActivityData = undefined;
                        if ($("#hdnPHRunScriptMemberId").val() !== undefined) {
                            $("#hdnPHRunScriptMemberId").val('');
                        }
                    },
                    popUpHeader: "Run Script",
                    triggerBtnId: 'actionsMenuBtn',
                    popLevel: 0
                });
            }
        }
    });
}

/*
1. Val to ContextGearListID
2. cntId to ContextGearID
ContextGearMenuCallBack
*/
function hideContextMenuCallBack(val, cntId) {//val--context menu id,cntId--gearIcon custom id
    setTimeout(function () {
        if ($('#' + val + ':hover').length == 0 && $('#' + cntId + ':hover').length == 0) {
            $('#' + val).fadeOut("linear");
            $('#' + cntId).removeClass('GearIconClshover');
        }
    }, 500);
}

/*
1. ContextGearMenu
2.

*/

function GearIconMseOut(menuButtonId, menuContainerId) {    // NOSONAR - sonar complaining about the name of this function, but there are too many usages to fix
    setTimeout(function () {
        if ($('#' + menuContainerId + ':hover').length === 0) {
            $('#' + menuContainerId).fadeOut("linear");
            $('#' + menuButtonId).removeClass('GearIconClshover');
        }
    }, 1);
}

//Open Complaints
function OpenComplaintsParameters() {
    //Prod-1988
    $('#divOpenComplaintsMenu').hide();
    $('.GearIconClshover').removeClass('GearIconClshover');
    //
    return {
        careStaffViewSensitive: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? careStaffViewSensitiveforPH : careStaffViewSensitive,
        IsView: $('#HdnIsViewOC').val(),
        //G8CAL-102
        refType: $("#selectOpenComplaintsTypeMAL").val(),
        searchTxtVal: $.trim($("#txtSearchTextOpenComplaint").val()),
        dateFrom: isMAL ? $("#txtOPCMPLSearchStartDate").val() : "",
        dateTo: isMAL ? $("#txtOPCMPLSearchEndDate").val() : "",
        TimeDictionaryobj: timeZone,
        isFromDashboard: (isMAL || !gridPagerMode) ? false : true,
        isDashboardExpandMode: $('#btnMymebersecExpand').is(":hidden")
    }
}
//Gcode

function ViewComplaintSummary(ComplaintId, PatientId, name, isFrom) {
    var isExpanded = $('.ah-widget-expanded:visible').length > 0;
    if (name == 2 || isExpanded) {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/Complaint/ViewComplaintSummary?ComplaintId=" + ComplaintId + "&isFrom=" + isFrom + "&PatientId=" + PatientId,
            popUpHeader: "Complaint Summary",
        });
    }
    else {
        $("#_myAlertsPartialViewContainer").html('');
        $("#_myAlertsPartialViewContainer").load(baseURL + "/Complaint/ViewComplaintSummary?ComplaintId=" + ComplaintId + "&isFrom=" + isFrom + "&PatientId=" + PatientId, function () {
            setDashboardGrids('dbaComplaintsumset');
        });
        $('#spanMyAlertsHeaderName').html('').html('Complaint Summary');
        $('#btnManageMyAlerts').hide();
        $('#ancNavAlerts').removeClass("headerNavOnchange");
        $('#ancNavRisks').removeClass("headerNavOnchange");
        $('#ancNavDiseases').removeClass("headerNavOnchange");
        $('#ancNavIndicators').removeClass("headerNavOnchange");
    }
}

function performComplaintActivity(Actid, Obj) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/AGComplaint/OpenComplaintPerformActivityAG?MemberId=" + memberidval + "&ActID=" + Actid,
        onLoad: function () {
            HANDLER_URL = "api/Route/GetAGResult";
            loadDropDownSync(baseURL + '/Master/BindResolutionCategory?complaintType=' + $("#ComplaintTypeId").val() + '&lobId=' + $("#LobBenId").val() + '&complaintId=' + $("#ComplaintRecordId").val() + '&patientid=' + model.PatientId, 'selectResolutionCategory', undefined, true, undefined, true, 'OutcomeCategoryId', 'OutcomeCategory');
            loadDropDownSync(baseURL + '/Master/BindResolutionSubCategory?complaintType=' + $("#ComplaintTypeId").val() + '&lobId=' + $("#LobBenId").val() + '&outcomeCategoryId=' + $("#selectResolutionCategory").val() + '&complaintId=' + $("#ComplaintRecordId").val() + '&patientid=' + model.PatientId, 'selectResolutionSubcategory', undefined, undefined, undefined, true, 'OutcomeSubcategoryId', 'OutcomeSubcategory');
            onLoadOpenComplaintPerformActivityAG();
            if (Obj == 1) { $("#btnAddPenActComplaint").ApplyRoleConfig({ UniqueName: "AHS_DASHBOARD_CALENDAR_AG_ACTIVITIES", Id: "btnAddPenActComplaint", IsFrom: "Add", IsRemoveElement: false }); }
            else if (Obj == 2) { $("#btnAddPenActComplaint").ApplyRoleConfig({ UniqueName: "WorkLog_Manager", Id: "btnAddPenActComplaint", IsFrom: "Add", IsRemoveElement: false }); }
            else { $("#btnAddPenActComplaint").ApplyRoleConfig({ UniqueName: "DASH_BOARD_PENDING_COMPLAINT_ACTIVITIES", Id: "btnAddPenActComplaint", IsFrom: "Add", IsRemoveElement: false }); }
        },
        popUpHeader: "Medical Director Review For AG",
        popLevel: 0,
        closeButton: '#btnAgclosebutton'
    });
    return false;
}

function replaceString(value) {
    if (value != null)
        return value.replace(/\*/g, "(Mandatory)");
}
//Patient Indicators
function RiskInfo() {
    return {
        PatientId: getCurrentPatientId(),
        refreshClick: $("#hdnRefreshMemberAdditionalInformationView").val() != '' ? $("#hdnRefreshMemberAdditionalInformationView").val() : false,
        inActiveRecords: $('#btnRiskActiveAndInactive').text() === "Show Current Records",
        TimeDictionaryobj: timeZone
    }
}
//Patient Quick Search

function showAddAuthWindow() {
    $("#divSearch").hide();
    $("#divAddAuth").show();
    $("#divViewAuth").hide();
}

function showViewAuthWindow() {
    $("#GridAuthorizations").data("kendoGrid").dataSource.read({ patientId: $('#hdnPatientId').val() });
    $("#divSearch").hide();
    $("#divAddAuth").hide();
    $("#divViewAuth").show();
}

function showViewComplaintWindow() {
    $("#GridComplaints").data("kendoGrid").dataSource.read({ PatientId: $('#hdnPatientId').val() });
    $("#divSearch").hide();
    $("#divViewComplaint").show();
}
function showComplaintData() {
    $("#providertaxdetails").hide();
    $("#complaintFormResult").show();
    $("#GridComplaintsDetails").data("kendoGrid").dataSource.read({
        SearchName: $.trim($('#hdnSearchName').val()), SearchValue: unescapeHtml($('#hdnSearchval').val()),
        PatientId: $('#hdnProPatientId').val()
    });
    A11yModal.trapFocusInModal('popUpDialog1');
}

//Pending Activities
function perform(AuthNo, Actid, PatientId) {

    var careStaffViewSensitiveData = ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1')) ? careStaffViewSensitiveforPH : careStaffViewSensitive;
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CommonDefaultSessionState/OpenAuthPerformActivityUM?AuthNo=" + AuthNo + "&ActID=" + Actid + "&CareStaffViewSensitiveData=" + careStaffViewSensitiveData + "&patientId=" + PatientId,
        onLoad: function () {
            onLoadOpenAuthPerformActivityUM();

            $("#btnAddPenActAuth").ApplyRoleConfig({ UniqueName: "DASH_BOARD_PENDING_AUTH_ACTIVITIES", Id: "btnAddPenActAuth", IsFrom: "Add", IsRemoveElement: true });
        },
        popUpHeader: "Medical Director Review For UM",
        popLevel: 0,
        closeButton: '#btnUmclosebutton',
        onClose: function () {
            $('#divPendingAuthSecGuideine').html('');
        }
    });
    return false;
}

function UmAuthNo(obj) {
    var AuthNo = '';
    if (obj == 0) { AuthNo = $("#AuthNo").val(); }
    else { AuthNo = $("#hdnAuthtnAuthNo").val(); }
    return {
        AuthNo: AuthNo,
        MemberId: memberidval
    }
}

function ViewAuth(authid, name, isPrint, patId) {
    $(document).ready(function () {
        var isExpanded = $('.ah-widget-expanded:visible').length > 0;
        if (name == 2 || isExpanded) {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Authorization/ViewAuthSummary",
                data: { AuthId: authid, isFrom: 'TodaysCareActivityLog', TimeDictionaryobj: timeZone, PatientId: patId },
                popUpHeader: "Auth Summary",
                onClose: function () {
                    $('#popUpDialog1').html('');
                }
            });
        }
        else {
            $("#_myAlertsPartialViewContainer").html('');
            $("#_myAlertsPartialViewContainer").load(baseURL + "/Authorization/ViewAuthSummary", { AuthId: authid, isPrint: isPrint, isFrom: 'PendingAuthActivities', TimeDictionaryobj: timeZone, PatientId: patId });
            tempAuthID = authid;
            $('#spanMyAlertsHeaderName').html('').html('Auth Summary');
            $('#btnManageMyAlerts').hide();
            $('#ancNavAlerts').removeClass("headerNavOnchange");
            $('#ancNavRisks').removeClass("headerNavOnchange");
            $('#ancNavDiseases').removeClass("headerNavOnchange");
            $('#ancNavIndicators').removeClass("headerNavOnchange");
        }
    });
}

//UHG-3345
function onAuthInternalGuidelinesDataBound() {
    $('.hOverCodeDescription').aToolTip();
    if ($('#hdnAuthGdlnSoruce').val() == 'PH') {
        $("#AuthInternalGuidelines").data("kendoGrid").hideColumn("InternalGuidelineSummary");
    }
}
//Request Received
function ReqRecGridParams() {
    var ReqFrom = '';
    var phActStatus = ''; var providerId = 0;
    var reft = "";
    var modt = "";
    var treatmentTypeIds = "";
    if (isMAL) {
        if (ToValue($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList"), "") !== "") {
            reft = $('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text();
        }
        if (ToValue($('#selectRequestReceivedModuleMAL').data("kendoDropDownList"), "") !== "") {
            modt = $('#selectRequestReceivedModuleMAL').data("kendoDropDownList").text();
        }
        var RiskTypeIdfrom = $('#hdnRiskTypeIdMAL').val() != "" ? $('#hdnRiskTypeIdMAL').val() : 0;
        var RiskLevelIdfrom = $('#hdnRiskLevelIdMAL').val() != "" ? $('#hdnRiskLevelIdMAL').val() : 0;
        if (buildctrl == 'CPIndex' && reft == 'Activity') {
            phActStatus = $('#ddlActivityStatus').val();
        }
        if (buildctrl == 'Index' && reft == 'Messages') {
            ReqFrom = false;
            RiskTypeIdfrom = 0;
            RiskLevelIdfrom = 0;
        }
        else if (buildctrl == 'CPIndex' && reft == 'Messages') {
            ReqFrom = true;
            RiskTypeIdfrom = 0;
            RiskLevelIdfrom = 0;
        }
        if (modt == "UM" && reft == "UM Auth" && $('#hdnRRProviderIdMAL').val() != '') {
            providerId = $('#hdnRRProviderIdMAL').val();
        }
        if (reqRecUmFaxTreatmentType.isEnabled && modt === 'UM' && reft === 'Faxes') {
            treatmentTypeIds = $('#ddlTreatmentTypeReqRecUmFaxesMAL .ah-dropcheck-input-hdn').val();
        }
        return {
            dateFrom: $("#txtRequestReceivedFromDateMAL").val(),
            dateTo: $("#txtRequestReceivedToDateMAL").val(),
            txt_Member: ToValue($('#txtRequestReceivedRRMemberMAL').val(), "").trim(),
            referType: reft,
            moduleName: modt,
            isRead: $('#selMessageTypeRRcMAL').val(),
            isProv: providercnf == 'True' ? true : false,
            isSearch: $('#hdnIsSearch').val(),
            TimeDictionaryobj: timeZone,
            careStaffViewSensitive: careStaffViewSensitive,
            ReqRecIsPh: ReqFrom,
            WorkQueue: $('#ddlRequestReceivedWorkQueueMAL').val(),
            IsView: GetViewPermissions_FromReqRec(),
            IsArchive: $('#selMessageTypeRRcMAL').val(),
            TreatmentTypeIds: treatmentTypeIds,
            RiskTypeId: RiskTypeIdfrom,
            RiskLevelId: RiskLevelIdfrom,
            phActivityStatus: phActStatus,
            providerId: providerId
        }
    } else {
        if (ToValue($('#selectRequestReceivedReferType').data("kendoDropDownList"), "") !== "") {
            reft = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
        }
        if (ToValue($('#selectRequestReceivedModule').data("kendoDropDownList"), "") !== "") {
            modt = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
        }
        $('#divMemberMenuRefral_').hide();
        $('#divAppointmentMenuRefral_').hide();
        $('#divCarePlanMenuRefral_').hide();
        $('#divMessageMenuRefral_').hide();
        var ReqFrom = '';
        var RiskTypeIdfrom = $('#hdnRiskTypeId').val() != "" ? $('#hdnRiskTypeId').val() : 0;
        var RiskLevelIdfrom = $('#hdnRiskLevelId').val() != "" ? $('#hdnRiskLevelId').val() : 0;
        var fromDate = $("#txtRequestReceivedFormDate").val();
        var toDate = $("#txtRequestReceivedToDate").val();
        var isCPR = (reft == "Care Plan Review" || reft == "Assessments") ? true : false;
        var authStatusIds = "";
        if (isCPR) { CPRPatients = []; }
        if (isCPR && $('#ddlCPRStatus').val() == 2 && $("#txtRequestReceivedFormDate").val() == '' && $("#txtRequestReceivedToDate").val() == '') {
            var last30DaysDate = new Date();
            last30DaysDate.setDate(last30DaysDate.getDate() - 29);
            fromDate = last30DaysDate;
            toDate = new Date();
        }
        if (modt == 'PH/CP' && reft == 'Activity') {
            phActStatus = $('#ddlActivityStatus').val();
        }
        if (buildctrl === 'Index' && reft === 'Messages' || reft === 'Faxes') {
            ReqFrom = false;
            RiskTypeIdfrom = 0;
            RiskLevelIdfrom = 0;
        }
        else if (buildctrl === 'CPIndex' && reft === 'Messages' || reft === 'Faxes') {
            ReqFrom = true;
            RiskTypeIdfrom = 0;
            RiskLevelIdfrom = 0;
        }
        else {
            //sonar
        }
        if (modt === "UM" && reft === "UM Auth") {
            if ($('#hdnRRProviderId').val() !== '') {
                providerId = $('#hdnRRProviderId').val();
            }
            authStatusIds = $("#UmReqRecAuthStatusIdhdn").val();
        }
        if (reqRecUmFaxTreatmentType.isEnabled && modt === 'UM' && reft === 'Faxes') {
            treatmentTypeIds = $('#ddlTreatmentTypeReqRecUmFaxes .ah-dropcheck-input-hdn').val();
        }
        return {
            dateFrom: fromDate,
            dateTo: toDate,
            txt_Member: $('#txtRequestReceivedRRMember').val(),
            referType: reft,
            moduleName: modt,
            isRead: $('#selMessageType').val(),
            isProv: providercnf == 'True' ? true : false,
            isSearch: $('#hdnIsSearch').val(),
            TimeDictionaryobj: timeZone,
            careStaffViewSensitive: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) && modt == 'PH/CP' ? careStaffViewSensitiveforPH : careStaffViewSensitive,
            ReqRecIsPh: ReqFrom,
            ActiveInactiveMemberFilter: (isProvider || PHNavID == "1") ? ActiveInactiveMemberFilter : 2,
            IsView: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) && modt == 'PH/CP' ? true : GetViewPermissions_FromReqRec(),
            WorkQueue: $('#ddlRequestReceivedWorkQueue').val(),
            PhSensitiveApplicable: careStaffViewSensitiveforPH,
            //calledFrom: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) && modt == 'PH/CP' ? 'PH' : ''
            CPRSearchBy: (isCPR) ? $('#ddlCPRSearchByDates').val() : "",
            CPRStatus: (isCPR) ? $('#ddlCPRStatus').val() : 0,
            AllowNonPcpUserToViewMembers: allowNonPcpUserToViewMembers,
            InPH: ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? true : false,
            RiskTypeId: RiskTypeIdfrom,
            RiskLevelId: RiskLevelIdfrom,
            isFromPHTile: isFromPHTile,
            DisplayProviderActivities: isDisplayProviderActivities,
            phActivityStatus: phActStatus,
            IsArchive: $('#selMessageType').val(),
            TreatmentTypeIds: treatmentTypeIds,
            providerId: providerId,
            isFromDashboard: ((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1') || !gridPagerMode) ? false : true,
            isDashboardExpandMode: isbtnExpandOnDashboardLoad,
            authStatusIds: authStatusIds
        }
    }
}

const REQ_REC_UM_FAX_TT = {
    loadDropdown: function (ddlDivId, withSavedFilter = false) {
        let configObj = {
            url: baseURL + '/UMConfig/BindAuthTypeTreatmentTypes',
            ddlId: ddlDivId + 'Id',
            textField: 'TreatmentTypeName',
            textValue: 'TreatmentTypeId',
            ddlCacheCtrlID: 'UMConfig/BindAuthTypeTreatmentTypes',
            callbackFunction: () => {
                if (!withSavedFilter) {
                    return;
                }

                this.useSavedFilter(ddlDivId, 'UM', 'Faxes');
            }
        };

        A11yDropcheck.createDropcheck(ddlDivId, configObj);
    },

    showHideDdl: function (ddlDivId, saveDivId, moduleName, referType) {
        if (!reqRecUmFaxTreatmentType.isEnabled || $.fn.isNullOrEmpty(moduleName) || moduleName.toUpperCase() !== 'UM' || $.fn.isNullOrEmpty(referType) || referType.toUpperCase() !== 'FAXES') {
            return;
        }

        $('#' + ddlDivId).parent().show();
        this.showHideSave(ddlDivId, saveDivId);
    },

    useSavedFilter: function (ddlDivId, moduleName, referType) {
        if (!reqRecUmFaxTreatmentType.isEnabled || $.fn.isNullOrEmpty(moduleName) || moduleName.toUpperCase() !== 'UM' || $.fn.isNullOrEmpty(referType) || referType.toUpperCase() !== 'FAXES') {
            return;
        }

        A11yDropcheck.deselectAll(ddlDivId, 'checkbox');

        let savedValues = reqRecUmFaxTreatmentType.savedFilter;
        if (!savedValues) {
            return;
        }

        let keys = savedValues.split(',');
        keys.forEach(key => {
            let liElem = $('#' + ddlDivId + ' #' + ddlDivId + 'Id_' + key);
            if (liElem.length && liElem.find('#' + ddlDivId + 'Id').prop('checked') === false) {
                liElem.find('#' + ddlDivId + 'Idspn').trigger('click');
            }
        });
        reqRecUmFaxTreatmentType.savedFilter = $('#' + ddlDivId + ' .ah-dropcheck-input-hdn').val();
    },

    saveFilter: function (ddlDivId, event) {
        var filter = $('#' + ddlDivId + ' .ah-dropcheck-input-hdn').val();

        var postData = {
            FilterName: 'REQ_REC_UM_FAX',
            acsFilterJson: filter,
            sectionId: reqRecUmFaxTreatmentType.sectionId
        };

        $.ajax({
            data: postData,
            type: "POST",
            url: baseURL + "/SearchFilter/SaveSearchParameters",
            success: function (data) {
                if (data == "2") {
                    $(event.target).parent().hide();
                    reqRecUmFaxTreatmentType.savedFilter = filter;
                }
                else {
                    console.error('Failed to save REQ_REC_UM_FAX filter');
                }
            },
            error: function (err) {
                console.error('Error in saving REQ_REC_UM_FAX filter: ', err);
            }
        });
    },

    showHideSave: function (ddlDivId, saveDivId) {
        let selectedValues = $('#' + ddlDivId + ' .ah-dropcheck-input-hdn').val();
        let savedValues = reqRecUmFaxTreatmentType.savedFilter;

        if (selectedValues === savedValues) {
            $('#' + saveDivId).hide();
        } else {
            $('#' + saveDivId).show();
        }
    }
}

function onDataBoundReqRec() {

    if ($('#aToolTip').is(':visible')) {
        $('#aToolTip').remove();
    }

    $('input[type="checkbox"].clsRefralChkMembercol').prop('checked', false);
    try {
        var $obj = $('td.reqRecGoalGrpCls');
        if ($obj && $obj.length > 0) {
            $('td.reqRecGoalGrpCls').aToolTip();
            ToolTipData('reqRecOppNameCls', 'Opportunity', '@@', 'oppname');
        }
        SetReqRecHeightAndWidth();
        $('#hdnIsSearch').val('0');
        //if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() != "Activity")
        //    $("#ReqRecGrid").data("kendoGrid").hideColumn(2);
        if ($('#selectRequestReceivedModule').data("kendoDropDownList") !== undefined) {
            var modSel = $('#selectRequestReceivedModule').data("kendoDropDownList").value();
            if (modSel == 4 || modSel == 6 || modSel == 7) {
                $("#ReqRecGrid").data("kendoGrid").hideColumn(3);
                $("#ReqRecGrid").data("kendoGrid").hideColumn(6);
            }
        }
    } catch (ex) {
        console.log(ex.message);
    }
    $('#divMemberMenuRefral_').hide();
    $('#divAppointmentMenuRefral_').hide();
    $('#divCarePlanMenuRefral_').hide();
    $('#divMessageMenuRefral_').hide();

    $('#divMemberMenuRefralMAL_').hide();
    $('#divAppointmentMenuRefralMAL_').hide();
    $('#divCarePlanMenuRefralMAL_').hide();
    $('#divMessageMenuRefralMAL_').hide();
    var requestRecievedGridName = "";
    if (isMAL == false) {
        //if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() != "Activity")
        //    $("#ReqRecGrid").data("kendoGrid").hideColumn(2);
        $(".divClsMemberMenuView").html('View');
        if (($('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "Messages") || ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() === "Appointment") || ($('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "Faxes"))
            $("#ReferelChkAll.clsRefralChkMembercol").hide();
        else $("#ReferelChkAll.clsRefralChkMembercol").show();

        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "AG Activity") {
            $('.hOverAGreferralsCls').aToolTip();
        }
        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "AG Activity" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "AG Complaint" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Activity" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Auth") {
            $("#ReqRecGrid").data("kendoGrid").showColumn(2);
        }

        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "UM Auth" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "UM Activity") {
            $(".divClsMemberMenuView").html('View Auth Summary');
            $(".anchAuthRedirect", "#ReqRecGrid").ApplyRoleConfig({ UniqueName: "AHS_UM_AUTH_ENTRY", Id: "anchAuthRedirect", IsFrom: "View" });
            $('.ReferredByName').aToolTip();
        }
        let requestRecivedReferType = $("#selectRequestReceivedReferType").data("kendoDropDownList").text().trim();
        let reqRecGrid = $("#ReqRecGrid").data("kendoGrid");
        if (isFullDashBoard && !isbtnExpandOnDashboardLoad) {
            if (requestRecivedReferType === "UM Activity") {
                reqRecGrid.hideColumn("AuthDueDate");
                reqRecGrid.hideColumn("AuthStatus");
                reqRecGrid.hideColumn("StatusReason");
                reqRecGrid.hideColumn("TreatmentType");
            }
            if (requestRecivedReferType === "UM Auth") {
                reqRecGrid.hideColumn("AuthStatus");
                reqRecGrid.hideColumn("StatusReason");
                reqRecGrid.hideColumn("TreatmentType");
            }
            if (requestRecivedReferType === "AG Activity") {
                reqRecGrid.hideColumn("ComplaintDueDate");
            }
        }
        else {
            if (requestRecivedReferType === "UM Activity") {
                reqRecGrid.showColumn("AuthStatus");
                reqRecGrid.showColumn("StatusReason");
                reqRecGrid.showColumn("TreatmentType");
            }
            if (requestRecivedReferType === "UM Auth") {
                reqRecGrid.showColumn("AuthStatus");
                reqRecGrid.showColumn("StatusReason");
                reqRecGrid.showColumn("TreatmentType");
            }
        }

        /*N/A grey color logic */
        requestRecievedGridName = $('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim();
        switch (requestRecievedGridName) {
            case "Activity":
            case "Member":
            case "Appointment":
            case "Care Plan":
            case "Care Plan Review":
            case "Assessments":
                gridNotAvailableCustomColor('ReqRecGrid');
                break;
        }
        if ($("#btnReqsecCollapse").is(":visible")) {
            $("#ReqRecGrid").data("kendoGrid").showColumn("DataRootPath");
            $("#ReqRecGrid").data("kendoGrid").showColumn("ProgramName");
            $("#ReqRecGrid").data("kendoGrid").showColumn("ReassignedBy");
        }
        else {
            $("#ReqRecGrid").data("kendoGrid").hideColumn("DataRootPath");
            $("#ReqRecGrid").data("kendoGrid").hideColumn("ProgramName");
            $("#ReqRecGrid").data("kendoGrid").hideColumn("ReassignedBy");
        }
        if (modSel == 8 || $("#popHealthNavBar").is(":visible")) {
            $("#ReqRecGrid").data("kendoGrid").showColumn("ReassignedBy");
        }
    }
    else {
        $(".divClsMemberMenuViewMAL").html('View');
        if (ToValue($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList"), "") !== "") {
            if (($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "AG Activity")) {
                $('.hOverAGreferralsCls').aToolTip();
            }

            //TODO //KP
            if (($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "Messages") || ($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "Appointment") || ($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "Faxes")) {
                $("#ReferelChkAll.clsRefralChkMembercol").hide();
            }
            else {
                $("#ReferelChkAll.clsRefralChkMembercol").show();
            }

            if (($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "UM Auth" || $('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim() === "UM Activity")) {
                $(".divClsMemberMenuViewMAL").html('View Auth Summary');
                $(".anchAuthRedirect", "#ReqRecGridMAL").ApplyRoleConfig({ UniqueName: "AHS_UM_AUTH_ENTRY", Id: "anchAuthRedirect", IsFrom: "View" });
            }
            /*N/A grey color logic */
            requestRecievedGridName = (ToValue($('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text().trim(), ""));
        }
        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "UM Auth" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim() === "UM Activity") {
            $(".ReferredByName", "#ReqRecGridMAL").attr("title", "");
        }

        switch (requestRecievedGridName) {
            case "Activity":
            case "Member":
            case "Appointment":
            case "Care Plan":
                gridNotAvailableCustomColor('ReqRecGridMAL');
                break;
        }
    }

}

//Request Rejected -- UM
function ReqRejGridParams() {
    var providerId = 0;
    if (isMAL) {
        var refType = $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text();
        var moduleName = $('#selectRequestRejectedModuleMAL').data("kendoDropDownList").text();
        if (moduleName == "UM" && refType == "UM Auth" && $('#hdnRequestRejectedProviderIdMAL').val() != '') {
            providerId = $('#hdnRequestRejectedProviderIdMAL').val();
        }
        return {
            careStaffId: memberidval,
            dateFrom: $("#txtRequestRejectedFromDateMAL").val(),
            dateTo: $("#txtRequestRejectedToDateMAL").val(),
            txt_Member: $('#txtRequestRejectedRRMemberMAL').val().trim(),
            referType: refType,
            moduleName: moduleName,
            isRead: $('#selMessageTypeRRjMAL').val(),
            careStaffViewSensitive: careStaffViewSensitive,
            IsView: GetViewPermissions_FromReqRej(),
            WorkQueue: $('#ddlRequestRejectedWorkQueueMAL').val(),
            TimeDictionaryobj: timeZone,
            providerId: providerId
        }
    } else {
        var refType = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
        var moduleName = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
        if (moduleName == "UM" && refType == "UM Auth" && $('#hdnRRProviderId').val() != '') {
            providerId = $('#hdnRRProviderId').val();
        }
        return {
            careStaffId: memberidval,
            dateFrom: $("#txtRequestReceivedFormDate").val(),
            dateTo: $("#txtRequestReceivedToDate").val(),
            txt_Member: $('#txtRequestReceivedRRMember').val(),
            referType: refType,
            moduleName: moduleName,
            isRead: $('#selMessageType').val(),
            TimeDictionaryobj: timeZone,
            careStaffViewSensitive: careStaffViewSensitive,
            IsView: GetViewPermissions_FromReqRej(),
            WorkQueue: $('#ddlRequestReceivedWorkQueue').val(),
            DisplayProviderActivities: isDisplayProviderActivities,
            providerId: providerId,
            isFromDashboard: gridPagerMode
        }
    }
}

function onDataBoundReqRej() {
    $('input[type="checkbox"].clsRejectedChkMembercol').prop('checked', false);
    $('.divClsRejectedMemberMenu').hide();
    if (isMAL) {
        $(".divClsMemberMenuRejectView").html('View');
        if ($('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() == "Member") {
            $("#ReqRejGridMAL").data("kendoGrid").hideColumn(3);
        }
        if ($('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() != "Appointment") $("#ReferelChkAll.clsRejectedChkMembercol").hide();
        else $("#ReferelChkAll.clsRejectedChkMembercol").show();
        if ($('#ReqRejGridMAL .dmyCHKReqRejGrid') && $('.dmyCHKReqRejGrid').length > 0)
            $('#ReqRejGridMAL .dmyCHKReqRejGrid').off("click change").on("click change", false).css({ '-ms-filter': "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)", 'filter': 'alpha(opacity = 40)', 'opacity': '0.4' });

        if ($('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() == "UM Auth" || $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() == "UM Activity") {
            $(".divClsMemberMenuRejectView").html('View Auth Summary');
            $(".anchAuthRedirect", "#ReqRejGridMAL").ApplyRoleConfig({ UniqueName: "AHS_UM_AUTH_ENTRY", Id: "anchAuthRedirect", IsFrom: "View" });
        }
        //if ($('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() == "AG Complaint" || $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text() == "AG Activity") {
        //    $(".anchComplRedirect", "#ReqRejGridMAL").ApplyRoleConfig({ uniqueName: "AHS_AG_ADD_EDIT_COMPLAINT", id: "anchComplRedirect", IsFrom: "View" });
        //}

        /*N/A grey color logic */
        var requestRejectedGridNameMAL = $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text().trim();
        switch (requestRejectedGridNameMAL) {
            case "Activity":
            case "Appointment":
                gridNotAvailableCustomColor('ReqRejGridMAL');
                break;
        }

    } else {
        $(".divClsMemberMenuRejectView").html('View');
        if ($('#btnReqsecExpand').is(":visible") == false) {
            //$('#ReqRejGrid').css({ "height": "430px" });
            // $('#ReqRejGrid').find(".k-grid-content").css({ "height": "380px" });
        }
        else {
            //$('#ReqRejGrid').css({ "height": "166px" });
        }
        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() != "Activity")
            $("#ReqRejGrid").data("kendoGrid").hideColumn(2);
        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "Member")
            $("#ReqRejGrid").data("kendoGrid").hideColumn(4);
        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() != "Appointment") $("#ReferelChkAll.clsRejectedChkMembercol").hide();
        else $("#ReferelChkAll.clsRejectedChkMembercol").show();
        if ($('#ReqRejGrid .dmyCHKReqRejGrid') && $('.dmyCHKReqRejGrid').length > 0)
            $('#ReqRejGrid .dmyCHKReqRejGrid').off("click change").on("click change", false).css({ '-ms-filter': "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)", 'filter': 'alpha(opacity = 40)', 'opacity': '0.4' });

        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "AG Activity" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "AG Complaint") {
            $("#ReqRejGrid").data("kendoGrid").showColumn(2);
        }

        if ($('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Auth" || $('#selectRequestReceivedReferType').data("kendoDropDownList").text() == "UM Activity") {
            $(".divClsMemberMenuRejectView").html('View Auth Summary');
            $(".anchAuthRedirect", "#ReqRejGrid").ApplyRoleConfig({ UniqueName: "AHS_UM_AUTH_ENTRY", Id: "anchAuthRedirect", IsFrom: "View" });
        }

        /*N/A grey color logic */
        var requestRecievedGridName = $('#selectRequestReceivedReferType').data("kendoDropDownList").text().trim();
        switch (requestRecievedGridName) {
            case "Activity":
            case "Appointment":
                gridNotAvailableCustomColor('ReqRejGrid');
                break;
        }
    }
}

//Search Control

function LoadAccessModules() {
    return {
        isCM: iscmval,
        isUM: isumval,
        isAG: isagval,
        isPrimary: isprimaryval,
        RoleId: RoleIdVal
    }
}

var searchTypeOptions = [];
function getSearchTypeOptions() {
    var deferred = $.Deferred();

    if (searchTypeOptions.length === 0) {
        return $.ajax({
            type: "GET",
            url: baseURL + "api/DropDown/GetddlSearchControl?isCM=" + iscmval + "&isUM=" + isumval + "&isAG=" + isagval + "&isPrimary=" + isprimaryval,
            dataType: "json",
            success: function (data) {
                if (data !== null && data !== undefined && data !== "") {
                    searchTypeOptions = data;
                }
            },
            error: function () {
                searchTypeOptions = [];
            }
        })
            .done(function () {
                deferred.resolve(searchTypeOptions);
            });
    } else {
        deferred.resolve(searchTypeOptions);
    }

    return deferred.promise;
}

var qckSchCfgAutoSaveValues = [];
function getQuickSearchConfigValues() {
    if (qckSchCfgAutoSaveValues.length == 0) {
        $.ajax({
            type: "GET",
            url: baseURL + "Home/QuickSearchConfigValue",
            dataType: "json",
            async: false,
            success: function (data) {
                qckSchCfgAutoSaveValues = [];
                if (data != null && data != undefined && data != "") {
                    qckSchCfgAutoSaveValues = data.split(',');
                }
            }
        })
        qckSchCfgAutoSaveValues.push('AUTH_ID');
    }
}

const SEARCH_TYPE_DEFAULT_TEXT = 'Search Filter Type';

function getSelectedSearchType() {
    var selectedType = SEARCH_TYPE_DEFAULT_TEXT,
        searchTypeBtn = $('#searchTypeBtnText').attr('data-selected-search-type'),
        selectSearchDdl = $('#selectSearch').val();

    if (searchTypeBtn && searchTypeBtn !== SEARCH_TYPE_DEFAULT_TEXT) {
        selectedType = searchTypeBtn;
    } else if (selectSearchDdl && selectSearchDdl !== 'Select') {
        selectedType = selectSearchDdl;
    } else {
        // do nothing (this is for Sonar)
    }

    return selectedType;
}
function searchMembers(isGlobalsearchWindow, isUmpage) {
    if (isWfChatOpen) {
        postUnsentMessageState('postSearchMembers', { isGlobalsearchWindow: isGlobalsearchWindow, isUmpage: isUmpage }); //to alert the user if chat popup is opend and any unsent message.
    }
    else {
        postSearchMembers(isGlobalsearchWindow, isUmpage);
    }
}
function postSearchMembers(isGlobalsearchWindow, isUmpage) {
    if (checkUnsentMsgWfChatBox()) {
        getQuickSearchConfigValues();

        // Added the below lines of code as per PROD-79023 feature request.
        var pagename = "GlobalsearchWindow";
        if (typeof isGlobalsearchWindow == "undefined") {
            var isshown = AGpacketshowwarninghomejs(pagename);
            if (isshown) {
                return;
            }
        }
        //End
        // get search type
        var SearchOptionValue = getSelectedSearchType();
        var SearchVal = SearchOptionValue !== "BIRTH DATE" ? $.trim($('#txtSearch').val()) : $.trim($('#quickSearchdate').val());
        //Gobhi-60
        var SearchOption = SearchOptionValue;
        SearchOption = SearchOption === "" ? SEARCH_TYPE_DEFAULT_TEXT : SearchOption;

        SearchVal = escapeHtml(SearchVal);
        SearchOptionValue = escapeHtml(SearchOptionValue);
        draftTabsWithOutMouse();
        //Gobhi-60
        if (ValidateChangesExistsInAccordions() || ValidateChangesByEditLabel() || ValidateNonAccordionChanges()) {
            DraftAsPerAccordionChange();
        }
        let changesExist = ValidateChangesExistsInAccordions() || ValidateChangesByEditLabel() || ValidateNonAccordionChanges() || ValidateAnyEditedAuthExists();
        if (typeof isUmpage === "undefined" && changesExist && isUmAccessed && (SearchOption !== SEARCH_TYPE_DEFAULT_TEXT && SearchVal !== 'Enter Text' && SearchVal !== '') && !qckSchCfgAutoSaveValues.includes(SearchOptionValue)) {
            var IsVisible = ConfirmOnAutoDraftWhileExit(pagename);
            if (IsVisible) {
                return;
            }
        }
        var ISAgCus = false;
        ISAgCus = (AGCusFields.indexOf(SearchOptionValue) > -1) ? true : false;     // NOSONAR

        if (SearchOption !== SEARCH_TYPE_DEFAULT_TEXT && SearchVal !== 'Enter Text' && SearchVal !== '') {
            if (ConfirmUserNavigationOnFaxLinking()) {
                if (SearchOptionValue === 'COMPLAINT_ID') {
                    if (IsAlertAcknowledgementRequired === 'True') { //BCBSKC-2828 - Inconsistent behaviour on search - Commented && $('#selectPatientAccessed').val() != ''
                        GetAGUMAlertSearchDetails(SearchOptionValue, SearchVal, $('#selectPatientAccessed').val(), 'AG');
                    }
                    else {
                        GetComplaintDataByNumber(SearchVal);
                    }
                }
                else if (SearchOptionValue === 'AUTH_ID' || SearchOptionValue === 'ALTERNATE_SERVICE_ID' || SearchOptionValue === 'AUTH_DOCUMENT_ID' || SearchOptionValue === 'SCA_ID') {

                    if (SearchOptionValue === 'SCA_ID' && !getSCAConfiguration()) {
                        CustomAlert("No records found");
                        return false;
                    }
                    if (IsAlertAcknowledgementRequired === 'True') { //BCBSKC-2828 - Inconsistent behaviour on search - Commented && $('#selectPatientAccessed').val() != ''
                        GetAGUMAlertSearchDetails(SearchOptionValue, SearchVal, $('#selectPatientAccessed').val(), 'UM');
                    }
                    else if (SearchOptionValue === 'AUTH_DOCUMENT_ID') {
                        validateAuthDocId(SearchOptionValue, SearchVal);
                    }
                    else {
                        clearPreAuthCache();
                        GetAuthDetails(SearchOptionValue, SearchVal);
                    }
                }
                else if (SearchOptionValue === 'PROVIDER_TAX_ID' || SearchOptionValue === 'PROVIDER_NPI') {
                    $('#popUpDialog1').CMNPopup({
                        pvUrl: baseURL + "/CommonDefaultSessionState/PatientProviderTaxIdSearch?SearchVal=" + encodeURIComponent(SearchVal) + "&SearchOptionVal=" + encodeURIComponent(SearchOptionValue),
                        popUpHeader: "Select Record",
                        popLevel: 1,
                        onLoad: function () {
                            $("#GridQuickSearchProvider").data("kendoGrid").dataSource.page(1);
                            A11yModal.trapFocusInModal('popUpDialog1');
                            if (enableDomLogs) {
                                DomUtils.logDomData('Provider Info >> Provider Details >> Provider ');
                            }
                        },
                        modalWidth: MODAL_WIDTH.LARGE
                    });
                }
                else if (SearchOptionValue === 'INTERNAL_CLAIM_ID') {
                    $.ajax({
                        type: "GET",
                        url: baseURL + "Home/GetQuickSearchResultForProvider?SearchName=" + encodeURIComponent(SearchOptionValue) + "&SearchValue=" + encodeURIComponent(SearchVal),
                        success: function (data) {
                            if (data !== undefined && data !== null && data.Data.length > 0) {
                                var patientIdInternalClaim = data.Data[0].PatientId;
                                if (IsAlertAcknowledgementRequired === 'True') {
                                    GetAGUMAlertSearchDetails(SearchOptionValue, SearchVal, patientIdInternalClaim, 'AG');
                                }
                                else {
                                    loadComplaintPopUp(SearchVal, SearchOptionValue, patientIdInternalClaim);
                                }
                            }
                            else {
                                CustomAlert('No records found');
                            }
                        },
                        error: function () {
                            CustomAlert('Error Encountered');
                        }
                    });
                }
                else if (ISAgCus) {
                    $('#popUpDialog1').CMNPopup({
                        pvUrl: baseURL + "/Common/ComplaintQuickSearchByCusField/",
                        popUpHeader: "Select Complaint (Displaying top 10 records)"
                    });
                }
                else {
                    if (SearchOptionValue === "PHONE_NUMBER") {
                        if (SearchVal.length === 12) {
                            if (!SearchVal.match(PhoneandFaxformat)) {
                                CustomAlert('Please Enter Valid Phone Number in xxx-xxx-xxxx Format');
                                return false;
                            }
                        }
                        else {
                            CustomAlert('Please Enter Valid Phone Number in xxx-xxx-xxxx Format');
                            return false;
                        }
                    }
                    if (SearchOptionValue === "BIRTH DATE" && $('#quickSearchdate').val() !== "" && !isValidDate($('#quickSearchdate').val())) {
                        CustomAlert('Birth Date is invalid');
                        return false;
                    }
                    var searchTxt = unescapeHtml(SearchVal);
                    if (searchTxt !== '') {
                        $('#popUpDialog1').CMNPopup({
                            pvUrl: baseURL + "/CommonDefaultSessionState/PatientQuickSearch?SearchVal=" + encodeURIComponent(searchTxt) + "&SearchOptionVal=" + encodeURIComponent(SearchOptionValue),
                            popUpHeader: "Select Member (Displaying top 10 records)",
                            onLoad: function () {
                                loader(0);
                                $('#popUpDialog1').css({ "width": "96%", "left": "2%" });
                            },
                            popLevel: 1,
                            onClose: function () {
                                $('#popUpDialog1').css("width", "");
                            }
                        });
                    }
                    else {
                        CustomAlert('Please enter search value');
                    }

                }
            }
        }
        else if (SearchOption !== SEARCH_TYPE_DEFAULT_TEXT && SearchVal === '') {
            CustomAlert('Please enter search value');
        }
        else {
            CustomAlert('Please select a search option');
            return false;
        }
    }
}

//load the complaint popUp for internal claim
function loadComplaintPopUp(SearchVal, SearchOptionValue, patientIdInternalClaim) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CommonDefaultSessionState/PatientProviderTaxIdSearch?SearchVal=" + encodeURIComponent(SearchVal) + "&SearchOptionVal=" + encodeURIComponent(SearchOptionValue) + "&PatientId=" + encodeURIComponent(patientIdInternalClaim),
        popUpHeader: "Select Record",
        popLevel: 1,
        onLoad: function () {
            $("#GridComplaintsDetails").data("kendoGrid").dataSource.page(1);
            A11yModal.trapFocusInModal('popUpDialog1');
            if (enableDomLogs) {
                DomUtils.logDomData('InternalClaim QuickSearch >> Complaint Details >> Complaint ');
            }
        },
        modalWidth: MODAL_WIDTH.LARGE
    });
}
//Gcode
function GetComplaintData(ComplaintId, complaintDetails, activityLogId, activityTypeName) {
    var data = complaintDetails || getComplaintDetailsByComplaintId(ComplaintId);
    if (data.success && data.success == true) {
        var DataItemVal = data.val;
        if (DataItemVal[0].Flag == 1) {
            isMAL = false;
            if ($("#MvcMainBody .InComplaintPage").length <= 0) {
                $('#MvcMainBody').html('');
            }
            SetComplaintData(DataItemVal[0].PatientId, DataItemVal[0].ComplaintRecordId, DataItemVal[0].ComplaintTypeId, null, null, null, activityLogId, activityTypeName);
        }
        else {
            CustomAlert("You can not access this Complaint");
        }
    }
    else { CustomAlert("No records found"); }
}

//Common complaint details call
function getComplaintDetailsByComplaintId(complaintId) {
    var retData = {};
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/GetComplaintDetails?ComplaintId=" + complaintId,
        dataType: "json",
        async: false,
        success: function (data) {
            loader(0);
            retData = data;
        },
        error: function () {
        }
    });
    return retData;
}


function GoToAdvanceSearch(isAdvancesearchWindow, isUmpage) {
    // Added the below lines of code as per PROD-79023 request.
    var pagename = "AdvancesearchWindow";
    if (typeof isAdvancesearchWindow == "undefined") {
        var isshown = AGpacketshowwarninghomejs(pagename);
        if (isshown) {
            return;
        }
    }
    //End
    //if (ValidateChangesExistsInAccordions() || ValidateChangesByEditLabel() || ValidateNonAccordionChanges()) { DraftAsPerAccordionChange(); }
    draftTabsWithOutMouse();
    if (typeof isUmpage === "undefined" && (ValidateChangesExistsInAccordions() || ValidateChangesByEditLabel() || ValidateNonAccordionChanges() || ValidateAnyEditedAuthExists()) && isUmAccessed) {
        DraftAsPerAccordionChange();
        var IsVisible = ConfirmOnAutoDraftWhileExit(pagename);
        if (IsVisible) {
            return;
        }
    }
    if (ConfirmUserNavigationOnFaxLinking()) {
        displayCMMenu(AdvanceSearchTypeEnum.MemberSearch, function () {
            CallCshtmlCtrls("/AssignCareStaff/FindCareMemberBasic");
        });
    }
}

//User Profile Menu
function ShowProfileWindow(isProfileWindow) {
    // Added the below lines of code as per PROD-79023 request.
    if (typeof isProfileWindow == "undefined") {
        var pagename = "ProfileWindow";
        var isshown = AGpacketshowwarninghomejs(pagename);
        if (isshown) {
            return;
        }
    }
    //End
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/EditUserProfile/",
        popUpHeader: "Edit User Profile",
        triggerBtnId: 'userProfileMenuBtn',
        modalWidth: MODAL_WIDTH.LARGE,
        onLoad: function () {
            A11yModal.trapFocusInModal('popUpDialog1');
        },
    });
}

function ShowChangePassword(isPasswordWindow) {
    // Added the below lines of code as per PROD-79023 request.
    if (typeof isPasswordWindow == "undefined") {
        var pagename = "PasswordWindow";
        var isshown = AGpacketshowwarninghomejs(pagename);
        if (isshown) {
            return;
        }
    }
    //End
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Account/ChangePassword/",
        triggerBtnId: 'userProfileMenuBtn',
        popUpHeader: "Change Password",
        modalWidth: MODAL_WIDTH.MEDIUM,
        onLoad: function () {
            $("#ChangePasswordDiv .box").css('top', '0');
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        closeButton: '#closePopUp'
    });
}

function mergeKendoGrid(gridId) {
    var $gridId = $(gridId);
    var tContent = $gridId.find('.k-grid-content table tbody tr');
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 2; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.textContent;
            });

            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {

                if ($prevArray[0] == $currentArray[0] && $prevArray[7] == $currentArray[7] && $prevArray[9] == $currentArray[9]) {
                    $.each($currentArray, function (index2, value) {
                        if ($prevArray[index2] == $currentArray[index2]) {
                            $($prevTd[index2]).remove();
                            $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                            if (gridId == '#gvManageRole')
                                $($currentTd[index2]).addClass('');
                            else
                                $($currentTd[index2]).addClass('brdAll');
                        } else {
                            $prevArray[index2] = value;
                        }
                    });
                } else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
        }
    }
}
//Activity Summary
function mergeCaseConferenceGrid() {
    mergeKendoGrid('#caseConferenceGrid');
    $("#caseConferenceGrid").data("kendoGrid").hideColumn(9);
    $('.hOverCaseConferenceActivityCls').aToolTip();
    $('.caseConferenceOutcomeNotesTT').aToolTip();
    gridNotAvailableCustomColor('caseConferenceGrid');
    A11yGrid.enhanceKendoGridForA11y('caseConferenceGrid', 0);
}

function mergeProfilesGrid() {
    mergeKendoGrid('#ProfileDetails');
}


function mergeGroupActivityGrid() {
    // mergeKendoGrid('#groupActivityGrid');
    $('.hOverWorkQueueActivityCls').aToolTip();
    gridNotAvailableCustomColor('groupActivityGrid');
}

//US226440 - Show button click in Activity summary section
function onActivityCheckboxChange(isMTMModule, searchFilters) {
    var checkedValues = $('#selectActivityTypeIdhdn').val();
    if (searchFilters != null) {
        checkedValues = searchFilters;
    }
    $('#selectActivityTypeIdval').prop("readonly", true);
    if (checkedValues && checkedValues !== '') {
        var selectedOptions = checkedValues.split(',');

        if (selectedOptions.indexOf('2') === -1 && $("#divScriptSummary").css('display') === 'block') {
            $("#divScriptSummary").hide();
        }
        if (selectedOptions.indexOf('3') === -1 && $("#divCaseConference").css('display') === 'block') {
            $("#divCaseConference").hide();
        }
        if (selectedOptions.indexOf('4') === -1 && $("#divFormActivity").css('display') === 'block') {
            $("#divFormActivity").hide();
        }
        if (selectedOptions.indexOf('5') === -1 && $("#divGeneralActivity").css('display') === 'block') {
            $("#divGeneralActivity").hide();
        }
        if (selectedOptions.indexOf('6') === -1 && $("#divGroupActivity").css('display') === 'block') {
            $("#divGroupActivity").hide();
        }
        if (selectedOptions.indexOf('7') === -1 && $("#divHISPSummary").css('display') === 'block') {
            $("#divHISPSummary").hide();
        }
        if (selectedOptions.indexOf('21') === -1 && $("#divScriptFormActivity").css('display') === 'block') {
            $("#divScriptFormActivity").hide();
        }
        if (selectedOptions.indexOf('22') === -1 && $("#divExternalCareTeam").css('display') === 'block') {
            $("#divExternalCareTeam").hide();
        }
        if (selectedOptions.indexOf('8') === -1 && $("#divCCDASummary").css('display') === 'block') {
            $("#divCCDASummary").hide();
        }

        for (var selectedOption of selectedOptions) {
            switch (selectedOption.trim()) {
                case "2":
                    if ($("#divScriptSummary").css('display') !== 'block' && !isMTMModule) {
                        $("#scriptSummaryGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divScriptSummary").show();
                    break;
                case "3":
                    if ($("#divCaseConference").css('display') !== 'block') {
                        $("#caseConferenceGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divCaseConference").show();
                    break;
                case "4":
                    if ($("#divFormActivity").css('display') !== 'block') {
                        $("#formActivityGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divFormActivity").show();
                    loadDropDown(baseURL + '/ActivityRecord/BindFormNames?patientId=' + $('#selectPatientAccessed').val(), 'ddlActSumFormName', null, null, 'FormId', 'FormName');
                    break;
                case "5":
                    if ($("#divGeneralActivity").css('display') !== 'block' && !isMTMModule) {
                        $("#generalActivityGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divGeneralActivity").show();
                    break;
                case "6":
                    if ($("#divGroupActivity").css('display') !== 'block') {
                        $("#groupActivityGrid").data("kendoGrid").dataSource.read();
                    }
                    if ($(".EACareStaffType").is(":visible") && $(".EACareStaffType:checked").val() == "EXTERNAL") { $('#divIdCareStaff').hide(); }
                    else { $("#divGroupActivity").show(); }

                    PharmacistCntrls();
                    break;
                case "7":
                    if ($("#divHISPSummary").css('display') !== 'block') {
                        $("#divHISPSummary").show();
                        loadMsgDetSearchFilters();
                        $("#HISPSummGrid").data("kendoGrid").dataSource.read();
                    }
                    break;
                case "21":
                    if ($("#divScriptFormActivity").css('display') !== 'block') {
                        $("#scriptFormActivityGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divScriptFormActivity").show();
                    break;
                case "22":
                    if (isDisplayProviderActivities !== "True") {
                        break;
                    }
                    if ($("#divExternalCareTeam").css('display') !== 'block' && !isMTMModule) {
                        $("#generalExtActivityGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divExternalCareTeam").show();
                    break;
                case "8":
                    if ($("#divCCDASummary").css('display') !== 'block') {
                        $("#XDRCCDAGrid").data("kendoGrid").dataSource.read();
                    }
                    $("#divCCDASummary").show();
                    break;
                default:
                    $("#divScriptSummary").show();
                    $("#scriptSummaryGrid").data("kendoGrid").dataSource.read();
            }
        }
    }
    else {
        $("#divScriptSummary,#divCaseConference,#divFormActivity,#divGeneralActivity,#divGroupActivity,#divHISPSummary,#divScriptFormActivity,#divCCDASummary,#divExternalCareTeam").hide();
        var isMTM = getModuleName() == "MTM" ? true : false;
        CreateDropCheck('selectActivityTypeChkbox', baseURL + '/ActivityRecord/BindActivitySummaryDrpdwn?isMTM=' + isMTM, 'selectActivityTypeId', 0, '2,5,22');
        $("#divScriptSummary").show();
        $("#scriptSummaryGrid").data("kendoGrid").dataSource.read();
        $("#divGeneralActivity").show();
        $("#generalActivityGrid").data("kendoGrid").dataSource.read();
        if (isDisplayProviderActivities === "True") {
            $("#divExternalCareTeam").show();
            $("#generalExtActivityGrid").data("kendoGrid").dataSource.read();
        }
    }
}

function ExternalActiviesParameters() {
    var ddlCompletedActivityType = $('#ddlCompletedProviderActivityType').val();
    return {
        patientId: $('#selectPatientAccessed').val(),
        scptActivityType: $('#ddlASScript').val() == "-1" ? "" : $('#ddlASScript').val(),
        careActivityTypeId: ddlCompletedActivityType == "-1" ? "" : ddlCompletedActivityType,
        TimeDictionaryobj: timeZone,
        FormId: $('#ddlActSumFormName').val(),
        FromDate: $('#txtActRcrdFormFromDate').val(),
        ToDate: $('#txtActRcrdFormToDate').val()
    }
}

//Add Health Notes
function HealthNotesCreatedDate(healthNotesDate) {
    var healthNotesDateFormat;
    if (healthNotesDate == "") {
        healthNotesDateFormat = new Date($('#txtCurrentDate').val());
    }
    else {
        healthNotesDateFormat = new Date(healthNotesDate);
    }
    var hh = healthNotesDateFormat.getHours();
    var min = healthNotesDateFormat.getMinutes();
    var day = healthNotesDateFormat.getDate();
    var month = healthNotesDateFormat.getMonth() + 1;

    var ampm = (hh >= 12) ? 'PM' : 'AM';
    hh = hh % 12;
    hh = hh ? hh : 12;
    hh = hh < 10 ? '0' + hh : hh;
    min = min < 10 ? '0' + min : min;
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return (month + "/" + day + "/" + healthNotesDateFormat.getFullYear() + " " + hh + ":" + min + " " + ampm);
}

function CheckPDFDownload(data, value) {
    var result = false;
    var dataSplit = data.split(',');
    for (var RI = 0; RI < dataSplit.length; RI++) {
        if (value == dataSplit[RI]) { result = true; break; }
    }
    return result;
}
//Health Notes
function HealthNotesParameters() {
    var patientId = $('#selectPatientAccessed').val();
    if (window.top.$(".InAuthPage").is(":visible")) {
        patientId = window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    var $noteType = $('#dllHealthNotesTypesIdhdn').val();
    var $goalName = $('#GoalIdAuto').val();
    $noteType = $noteType == undefined ? "" : $noteType;
    $goalName = $goalName == undefined ? "" : $goalName;
    return {
        patientId: patientId,
        healthNoteType: $noteType,
        searchFromDate: $('#txtHealthNotesStartDate').val(),
        searchToDate: $('#txtHealthNotesEndDate').val(),
        goalName: $goalName,
        MemberId: memberidval,
        searchField: $('#ddlHealthNotesSearchField option:selected').text(),
        searchValue: $.trim($('#txtHealthNotesSearchValue').val()),
        TimeDictionaryobj: timeZone,
        isAllActivityOutcomeNotes: $('#hdnIsAllActivityOutcomeNotes').val(),
        isProvider: isProviderUser
    }
}

//uhc-2803
function HealthNotesHistoryParameter() {
    var patientId = $('#selectPatientAccessed').val();
    return {
        patientId: patientId,
        timeDictionaryObj: timeZone,
        referenceId: $('#hdnScript').val(),
        healthNotesId: $('#hdnNotesData').val().split('_')[0],
        noteType: $('#hdnNotesData').val().split('_')[1],
        activityType: $('#hdnActivityType').val().toUpperCase()
    }
}

//uhc-2804
function GeneralActivitySummaryHistoryParameter() {
    var patientFollowUpId = $('#hdnFollowUpId').val();
    patientFollowUpId = patientFollowUpId ? patientFollowUpId : $('#hdnPatientFollowupIdOfScriptGuidelines').val();
    return {
        patientFollowUpId: patientFollowUpId,
        timeDictionaryObj: timeZone,
        isProvider: isProviderUser,
        patientId: $('#selectPatientAccessedDdl').val()
    }
}

function EscapeSingleQuote(obj) {
    return obj.replace(/'/g, "");
}

function consentFormStatusCheck(status) {
    if (status == 'Declined') {
        return true;
    }
    else {
        return false;
    }
}

function onConsentFormSuccess(e) {
    $('#hdnFileName').val(e.response.ConsentFormFileName);
}

function onConsentFormError(_e) {
    documentCount = 0;
}

function ConsentFormParameters(isROI) {
    return {
        patientId: $('#selectPatientAccessed').val(),
        TimeDictionaryobj: timeZone,
        FormTypeID: isROI
    }
}

function onFileSelect(e) {
    var ddlDocType = $("#ddlEDocDocumentType option:selected").text();
    $("#ddlEDocDocumentType").closest('td').find('.requiredfields').hide();
    if (ddlDocType == 'Select') {
        var lblEDocMessage = $("#lblEDocMessage");
        lblEDocMessage.html('Select type');
        e.preventDefault();
    }
    else if (ddlDocType == 'Patient Image') {
        var fileExtension = e.files[0].name.split('.').pop();
        if (fileExtension != 'jpg' && fileExtension != 'jpeg' && fileExtension != 'png') {
            CustomAlert("Please upload jpg files only");
            e.preventDefault();
        }
        else if (e.files[0].size > 1024 * 1024) {
            CustomAlert("Please select file which is less than 1 MB");
            e.preventDefault();
        }
        else {
            documentCount = documentCount + 1;
            if (documentCount > 1) {
                CustomAlert("Please select only one file to upload.");
                e.preventDefault();
            }
        }
    }
    else {
        documentCount = documentCount + 1;
        if (documentCount > 1) {
            CustomAlert("Please select only one file to upload.");
            e.preventDefault();
        }
        documentCount = 0;
    }
}

function onAdvDirectiveUploadSuccess(e) {
    var fileName = e.response.ElectronicDocFileName;
    var origName = $('#hdnAdvUploadPath').val();
    if (origName.length > 0)
        fileName = origName + '§' + fileName;
    $('#hdnAdvUploadPath').val(fileName);
}
function onUploadSuccess(e, array) {
    if (e.operation === "upload") {
        var docFileName = e.response.ElectronicDocFileName;
        const [fileName, tempFileName] = docFileName.split('|');
        const formattedFile = {
            fileName: fileName || null,
            tempFileName: tempFileName || null
        };
        array.push(formattedFile);
    }
}
function addEditUploadFileMsg(AccId, docId) {
    $(AccId + " .messageAdd").text('');
    if (docId !== null) {
        $(AccId + " .messageAdd").append(isManageTotalSizeForMultipleUpload === true ? "Total File size allowed is " + manageTotalSizeForMultipleUploadFile + " MB." : "File size allowed is " + manageTotalSizeForMultipleUploadFile + "MB.");
    } else {
        $(AccId + " .messageAdd").append(isManageTotalSizeForMultipleUpload === true ? "Total File size allowed is " + manageTotalSizeForMultipleUploadFile + " MB and a maximum of " + NoOfFilesUploadLimit + " files can be uploaded at a time." : "File size allowed per file is " + manageTotalSizeForMultipleUploadFile + "MB and maximum of " + NoOfFilesUploadLimit + " files can be uploaded at a time.");
    }
}

function srplCalculations(onbject, isFromToDate) {
    var Hours = 0;
    var Days = 0;
    var Weeks = 0;
    var AddDays = 0;
    var WeeklyHours = 0;
    var ReqUnits = 0;
    var ValidAdditionalDays = 0;
    var CalWeeks = 0;
    var CalAdldays = 0;

    var parEle = onbject;
    Hours = $(parEle).find('#txtSrPlHours').val();
    Days = $(parEle).find('#ddlDaysval').val();
    Weeks = $(parEle).find('#txtSrPlWeeks').val();
    AddDays = $(parEle).find('#txtSrPlADays').val();

    CalWeeks = (Days == "W" && AddDays != "" && AddDays != 0) ? (Weeks != "" && Weeks != 0) ? parseInt(Weeks) + 1 : 1 : Weeks;
    CalAdldays = (Days == "W" && AddDays != "" && AddDays != 0) ? 0 : AddDays;
    Days = Days == "W" ? 1 : Days;//PROD-3735 : This piece of code is for,As per the new request if we select weekly option in days field then we are displaying 'W' in Days DropDown.

    var isHDCal = true;
    var unitType = $(parEle).find('.clsddlCrPlAddSrPlMembNewUnitType').val();
    var daysName = $(parEle).find('#ddlDayNameshdn').val();
    if (daysName != undefined) {
        if (daysName.toLowerCase() == 'week' && (unitType == 4 || unitType == 7)) { isHDCal = false; }
    }
    if (isHDCal) {
        if ((Hours != "" && Hours != 0) && (Days != "" && Days != 0)) {
            WeeklyHours = Hours * Days;
            if (WeeklyHours.toString().split('.').length > 1)
                WeeklyHours = parseFloat(WeeklyHours).toFixed(2);
        }
        else {
            WeeklyHours = 0;
        }
    }
    if (unitType == 1) {
        $(parEle).find('#txtSrPlADays').attr('disabled', 'disabled');
        $(parEle).find('#txtSrPlADays').val('');
    }
    if ($(parEle).find('.clsddlCrPlAddSrPlMembNewUnitType').val() == 1) {
        var fromDate = $($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val();
        var toDate = $($(parEle).find('.txtCrPlAddSrPlTNewSPToDateCls')[1]).val();
        if (fromDate != "" && isValidDate(fromDate) == true && toDate != "" && isValidDate(toDate) == true) {
            var formattedFromDate = new Date(fromDate);
            var formattedToDate = new Date(toDate);
            ReqUnits = DateDiff(formattedFromDate, formattedToDate);
            ReqUnits = parseInt(ReqUnits) + 1;
        }
    }
    else if ((Hours != "" && Hours != 0) && (Days != "" && Days != 0)) {

        if ((CalWeeks != "" && CalWeeks != 0) && (CalAdldays != "" && CalAdldays != 0)) {
            ValidAdditionalDays = selectedDaysInAdlDays(parEle, 1);//Additional Days calculation should happen the number of days those are in selected days.
            ReqUnits = (Hours * Days * CalWeeks) + (Hours * ValidAdditionalDays);
        }
        else if ((CalWeeks != "" && CalWeeks != 0)) {
            ReqUnits = Hours * Days * CalWeeks;
        }
        else if (CalAdldays != "" && CalAdldays != 0) {
            ValidAdditionalDays = selectedDaysInAdlDays(parEle, 0);
            ReqUnits = Hours * ValidAdditionalDays;
        }

        var decValues = ReqUnits.toString().split('.');
        if (decValues.length > 1) {
            ReqUnits = parseInt(decValues[0]) + 1;
        }
    }
    else {
        ReqUnits = 0;
    }

    if (WeeklyHours != 0) {
        $(parEle).find('#txtSrPlWHours').val(WeeklyHours);
    }
    else {
        $(parEle).find('#txtSrPlWHours').val('');
    }

    if (ReqUnits != 0) {
        $(parEle).find('#txtCrPlAddSrPlMembGNewRUnits').val(ReqUnits);
    }
    else {
        $(parEle).find('#txtCrPlAddSrPlMembGNewRUnits').val('');
    }
    var unFormattedFromDate = $($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val();
    if (isFromToDate != true) {
        if ((Weeks != "" && Weeks != "0") && (AddDays != "" && AddDays != "0") && $($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val() != "") {
            var TotalDays = (Weeks * 7) + parseInt(AddDays);
            TotalDays = TotalDays - 1;
            var fromDate = new Date($($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val());
            var toDateUnFormatted = new Date(fromDate.setDate(fromDate.getDate() + TotalDays));

            var month = toDateUnFormatted.getMonth() + 1; var day = toDateUnFormatted.getDate();
            var toDateFormatted = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + toDateUnFormatted.getFullYear();
            if ($(parEle).find('#ddlDaysval').val() != "W") {
                $($(parEle).find('.txtCrPlAddSrPlTNewSPToDateCls')[1]).val(toDateFormatted);
            }
        }
        else if ((Weeks != "" && Weeks != "0") && (unFormattedFromDate != "" && isValidDate(unFormattedFromDate))) {
            var TotalDays = (Weeks * 7);
            TotalDays = TotalDays - 1;
            var fromDate = new Date($($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val());
            var toDateUnFormatted = new Date(fromDate.setDate(fromDate.getDate() + TotalDays));

            var month = toDateUnFormatted.getMonth() + 1; var day = toDateUnFormatted.getDate();
            var toDateFormatted = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + toDateUnFormatted.getFullYear();
            if ($(parEle).find('#ddlDaysval').val() != "W") {
                $($(parEle).find('.txtCrPlAddSrPlTNewSPToDateCls')[1]).val(toDateFormatted);
            }
        }
        else if ((AddDays != "" && AddDays != "0") && (unFormattedFromDate != "" && isValidDate(unFormattedFromDate))) {
            var TotalDays = parseInt(AddDays);
            TotalDays = TotalDays - 1;
            var fromDate = new Date($($(parEle).find('.txtCrPlAddSrPlNewSPFromDateCls')[1]).val());
            var toDateUnFormatted = new Date(fromDate.setDate(fromDate.getDate() + TotalDays));

            var month = toDateUnFormatted.getMonth() + 1; var day = toDateUnFormatted.getDate();
            var toDateFormatted = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + toDateUnFormatted.getFullYear();
            if ($(parEle).find('#ddlDaysval').val() != "W") {
                $($(parEle).find('.txtCrPlAddSrPlTNewSPToDateCls')[1]).val(toDateFormatted);
            }
        }
        //else if ((AddDays == "" || AddDays == "0") && (Weeks == "" || Weeks == "0")) {
        //    $($(parEle).find('.txtCrPlAddSrPlTNewSPToDateCls')[1]).val('');
        //}
    }
}

/*function to validate sequential start and end dates in an array by sroting based on start date*/
function ValidateCMSeqDates(InpDates, SortBy) {
    var RetVal = true;
    $().SortMe({ DataArray: InpDates, SortKey: SortBy }, function (e) {
        for (var RI = 0; RI < e.length; RI++) {
            var CurToDate = e[RI].ToDate; var NeStartDate = null;
            if ((RI + 1) < e.length) {
                NeStartDate = e[RI + 1].StartDate; CurToDate = new Date(CurToDate.setDate(CurToDate.getDate() + 1));
                if (CurToDate.toLocaleDateString() != NeStartDate.toLocaleDateString()) { RetVal = false; break; }
            }
        }
    });
    return RetVal;
}

function validateMemberPlan() {
    A11yForms.clearFormFieldValidation();
    let parentPopupId = $("#ViewMyPlanEdit").is(":visible") ? "#ViewMyPlanEdit" : "#popUpDialog3";
    let popUpMsgId = $("#ViewMyPlanEdit").is(":visible") ? " #MemberCarePlanStatus" : " #TmCPLMemberCarePlanStatus";
    let isValid = true;

    isValid &= A11yForms.validateFormField('txtAliasIntervention', null, [A11yForms.VALIDATIONS.REQUIRED], null, parentPopupId);
    isValid &= A11yForms.validateFormField('txtMemberGoal', null, [A11yForms.VALIDATIONS.REQUIRED], null, parentPopupId);

    let startDateStr = $(parentPopupId + ' #txtMemberPlanStartDate').val();
    let endDateStr = $(parentPopupId + ' #txtMemberPlanEndDate').val();

    let isValidStartDate = A11yForms.validateFormField('txtMemberPlanStartDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATE], null, parentPopupId);
    let isValidEndDate = A11yForms.validateFormField('txtMemberPlanEndDate', null, [A11yForms.VALIDATIONS.REQUIRED, A11yForms.VALIDATIONS.DATE], null, parentPopupId);
    isValid &= isValidStartDate;
    isValid &= isValidEndDate;

    if (isValidStartDate && isValidEndDate) {
        let startDate = new Date(startDateStr);
        let endDate = new Date(endDateStr);
        if (startDate > endDate) {
            A11yForms.showFormFieldError('txtMemberPlanStartDate', 'Start date should precede target date', null, null, parentPopupId);
            isValid = false;
        }
    }

    if (!isValid) {
        A11yAlerts.createErrorAlert(parentPopupId + popUpMsgId);
    }
    return isValid;

}

function ServicePlanbuttonShow() {
    $('.clsbtnSpSaveAuth').show();
    $('.clsbtnSpSave').show();
    $('.clstbtnSpDelete').show();
    $('.clsbtnSpAddNew').show();
    $('.clsbtnSpEdit').show();

};

function ChkShowHideCrTmBut(careTeamType) {
    var chkdChBxCrTm = $('#careTeamGrid .clschkCareTeam:checked');
    $('.clsCrTmButShHd').show();
    if ($('#dllCTActive option:selected').text() == "Active") {
        if (chkdChBxCrTm.length == 1) {
            $('.crtmAdd').hide();
            $(".crtmEdit").show();
            $('#btnCareTeamHistory').show();
            if (careTeamType == 4) //4: Care Givers
                $('#btnCareGiverView').show();
            else
                $('#btnCareGiverView').hide();
        }
        else if (chkdChBxCrTm.length == 0) {
            $('.crtmAdd').show();
            $(".crtmEdit").show();
            $('#btnCareTeamHistory').show();
            if (careTeamType == 4) //4: Care Givers
                $('#btnCareGiverView').show();
            else
                $('#btnCareGiverView').hide();
        }
        else if (chkdChBxCrTm.length > 1) {
            $('.crtmAdd').hide();
            $(".crtmEdit").hide();
            $('#btnCareTeamHistory').hide();
            $('#btnCareGiverView').hide();
        }
        if ($.trim($('#ddlSearchCareTeamType option:selected').text()) == "ALL") {
            $('.crtmAdd').hide();
            $('.crtmDelete').hide();
            if (chkdChBxCrTm.length > 1)
                $(".crtmEdit").hide();
        }
        else if ($.trim($('#ddlSearchCareTeamType option:selected').text()) == "PCP History")
            $('.clsCrTmButShHd').hide();
    }
    //g8cal-18
    else {
        if (chkdChBxCrTm.length > 1) {
            $('.crtmEdit').hide();
            $('#btnCareGiverView').hide();
        }
        else {
            $('.crtmEdit').show();
            if (careTeamType == 4) //4: Care Givers
                $('#btnCareGiverView').show();
            else
                $('#btnCareGiverView').hide();
        }
        
        if (careTeamType !== "1" && careTeamType !== "4") {
            $('.crtmEdit').hide();
        }
        $('.crtmAdd').hide();
        $('#btnCareTeamHistory').hide();
        $('.crtmDelete').hide();
    }
    //
}

function onProvDetailsParam() {
    return {
        // provName: $('#ExCrTmFormId #ProviderName').val()
        provName: $('#hdnAutoComplete').val()
    }
}

function ValidationForExCrTmMulAdrs() {
    var tblExtmulAd = $('.tblCrTmExtCrTmMulAdrs');
    var msgcount = 0;
    $.each(tblExtmulAd, function (ind, item) {
        $(item).find('span.validationMessage').remove();
        if ($.trim($(item).find('#txtExtCrTmAddress').val()) == "") {
            $(item).find('#txtExtCrTmAddress').closest('td').append('<span class="validationMessage" style="color:red;font-size:Large;">*</span>');
            msgcount = 1;
        }

        if ($(item).find('#txtExtCrTmZip').val() != "") {
            /*PROD-162*/ if (!$('#txtExtCrTmZip').val().match(WorkZipExp)) {
                $(item).find('#txtExtCrTmZip').closest('td').append('<span class="validationMessage" style="color:red;">Please enter a valid zip code of 5 or 9 digits</span>');
                msgcount = 1;
            }
        }
        else {
            $(item).find('#txtExtCrTmZip').closest('td').append('<span class="validationMessage" style="color:red;font-size:Large;">*</span>');
            msgcount = 1;
        }
        /*PROD-162*/
        if ($(item).find('#ddlExtCrTmState').val() == -1) {
            $(item).find('#ddlExtCrTmState').closest('td').append('<span class="validationMessage" style="color:red;font-size:Large;">*</span>');
            msgcount = 1;
        }
        if ($(item).find('#txtExtCrTmPhone').val() != "") {
            if (!$(item).find('#txtExtCrTmPhone').val().match(PhoneandFaxformat)) {
                $(item).find('#txtExtCrTmPhone').closest('td').append('<span class="validationMessage" style="color:red;font-size:Large;">Invalid Format</span>');
                msgcount = 1;
            }
        }
        if ($(item).find('#txtExtCrTmFax').val() != "") {
            if (!$(item).find('#txtExtCrTmFax').val().match(PhoneandFaxformat)) {
                $(item).find('#txtExtCrTmFax').closest('td').append('<span class="validationMessage" style="color:red">Invalid Format</span>');
                msgcount = 1;
            }
        }
        if ($("#hdnIsPrimaryAddressMandatory").val() === "True" && $(item).find('#ddlExCrTmAddressType').val() === "-1") {
            $(item).find('#ddlExCrTmAddressType').closest('td').append('<span class="validationMessage" style="color:red;font-size:Large;">*</span>');
            msgcount = 1;
        }
    });
    if (msgcount == 1) {
        $('#btnExCrTmSave').removeAttr('disabled');
        return false;
    }
    else {
        return true;
    }

}

function valForCrTmIntCrTm() {
    var flag = true; var dateValidation = true;
    $('.valMsg').text('');
    $('.requiredfields').show()
    if ($('#intCrTmTbl #hdnSelectIntCrTmName').val().length == 0) {
        $('.requiredfields.reqFldIntCrTmName').text('Please enter carestaff name');
        flag = false;
    } else {
        $('#intCrTmTbl #hdnSelectIntCrTmName').closest('td').find('.requiredfields.reqFldIntCrTmName').hide();
    }
    var Startdate = $('#txtIntCrTmFromDate').val();
    var EndDate = $('#txtIntCrTmToDate').val();
    if (!$.trim(Startdate)) {
        $('.requiredfields.clsReqFldFrmDate').text('please enter the date');
        flag = false; dateValidation = false;
    }
    else if (!funisValidDate(Startdate, '1')) {
        $('.requiredfields.clsReqFldFrmDate').text('Invalid date');
        flag = false; dateValidation = false;
    }
    else if (!date_regex.test(Startdate)) {
        $('.requiredfields.clsReqFldFrmDate').text('Invalid format');
        flag = false; dateValidation = false;
    }
    else {
        $('.requiredfields.clsReqFldFrmDate').hide();
    }
    if (($.trim(EndDate))) {
        if (!funisValidDate(EndDate, '1')) {
            $('.requiredfields.clsReqFldToDate').text('Invalid date');
            flag = false; dateValidation = false;
        }
        else if (!date_regex.test(EndDate)) {
            $('.requiredfields.clsReqFldToDate').text('Invalid format');
            flag = false; dateValidation = false;
        }
        else {
            $('.requiredfields.clsReqFldToDate').hide();
        }
    }
    else {
        $('.requiredfields.clsReqFldToDate').hide();
    }
    if (dateValidation == true && (new Date(Startdate).getTime() > new Date(EndDate).getTime())) {
        $('#intCrTmTbl #txtIntCrTmToDate').closest('td').append('<span class="valMsg" style="color:red;font-wieght:bold;">Start date should precede end date</span>');
        flag = false;
    }
    if (flag == false)
        return false;
    else
        return flag;
}

//Add Edit Health Param
function valForAddParamHeaInd() {
    var flag = true;
    var paramdate = $('#txtHeaIndValEtrdDate').val();
    $('span.valMsg').remove();
    $('span.validationMessage').remove();
    $('span.requiredfields').remove();

    if ($.trim($('#txtHeaIndValEtrdDate').val()) == "") {
        CustomAlert('Please enter date')
        return flag = false;
    } else {
        $('#txtHeaIndValEtrdDate').closest('td').find('.requiredfields').hide();
    }
    if (!funisValidDate(paramdate, 1)) {
        CustomAlert('Invalid date format');
        $('#txtHeaIndValEtrdDate').val('');
        return flag = false;
    }
    if ($('#ValueEntered').val() == "Yes" || $('#ValueEntered').val() == "No") {
        return flag = true;
    }
    $('.trAddheaIndParamVals .indicatorParamVal').each(function (i, e) {
        if ($.trim($(e).val()) == "") {
            CustomAlert('All parameter values are mandatory');
            flag = false;
        }
    });
    return flag;
}
function valForEditParamHeaInd() {
    var flag = true;
    var paramdate = $('#txtHeaIndEdRecDate').val();
    $('span.validationMessage').remove();
    $('span.requiredfields').remove();

    if ($.trim($('#txtHeaIndEdRecDate').val()) == "") {
        $('#txtHeaIndEdRecDate').closest('td').append('<span class="requiredfields" style="color:red">*</span>');
        return flag = false;
    } else {
        $('#txtHeaIndEdRecDate').closest('td').find('.requiredfields').hide();
    }
    if (!funisValidDate(paramdate, 0)) {

        CustomAlert('Invalid date format');
        $('#txtHeaIndValEtrdDate').val('');
        return flag = false;
    }
    if ($('#txtHeaIndEdRecVal').is(':visible') && $('#txtHeaIndEdRecVal').val() == "") {
        $('#txtHeaIndEdRecVal').closest('td').append('<span class="requiredfields" style="color:red">*</span>');
        return flag = false;
    }

    return flag;
}
function HeaIndPramsGraphParams() {
    return {
        MemberId: memberidval,
        indId: $('#sltdHeaIndIdForAddPrm').val(),
        patientId: $('#selectPatientAccessed').val(),
    }
}
//Add Edit Health Visits
function HealthVisitsValidation() {
    $('#spnvisitAddStatus').html('');
    var msgcount = 0;
    var versionBasedOnDate = 0;
    var IcdDate = $('#hdnIcdDateFromWeb').val();
    var Startdate = $('#txtDateOfService').val();
    var EndDate = $('#txtServiceToDate').val();
    if (EndDate != null || EndDate != '' || EndDate != 'Undefined') {
        if (new Date(Startdate).getTime() > new Date(EndDate).getTime()) {
            $('#spnvisitAddStatus').html('Service from date should be less the service to date');
            msgcount = 1;
        }
    }
    if ($('#txtDateOfService').val() != "") {
        var DateExp = /^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d$/;
        if (!$('#txtDateOfService').val().match(DateExp)) {
            $('#txtDateOfServiceSpan').html("Invalid format");
            msgcount = 1;
        }
        else
            $('#txtDateOfServiceSpan').html('');
    }
    if ($('#txtServiceToDate').val() != "") {
        var DateExp = /^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d$/;
        if (!$('#txtServiceToDate').val().match(DateExp)) {
            $('#txtServiceToDateSpan').html("Invalid format");
            msgcount = 1;
        }
        else
            $('#txtServiceToDateSpan').html('');
    }
    if ($('#ddlTypeOfVisit').val() == -1) {
        msgcount = 1;
        $('#VisitTypeValidation').show();
    }
    else {
        $('#VisitTypeValidation').hide();
    }
    if ($('#txtICDCode').val() == "") {
        msgcount = 1;
        $('#ICDCodeValidation').show();
    }
    else {
        $('#ICDCodeValidation').hide();
    }
    if ($('#txtDateOfService').val() == "") {
        msgcount = 1;
        $('#DateOfServiceValidation').show();
        $('#txtDateOfServiceSpan').html('');
    }
    else {
        $('#DateOfServiceValidation').hide();
    }
    if ($('#txtCPTCode').val() == "") {
        msgcount = 1; $('#CPTCodeValidation').show();
    }
    else {
        $('#CPTCodeValidation').hide();
    }
    if ($('#txtTotalCharge').val() == "") {
        msgcount = 1; $('#TotChargeValidation').show();
    }
    else {
        $('#TotChargeValidation').hide();
    }
    if ($("#ddlVisitLOB").is(":visible") && $('#ddlVisitLOB .clsRdoMemEligMini:checked').length == 0) {
        msgcount = 1; $('#VisitLOBValidation').show();
    }
    else {
        $('#VisitLOBValidation').hide();
    }
    if (new Date(Startdate) <= new Date(IcdDate) && EndDate.length > 0 && new Date(EndDate) > new Date(IcdDate)) {

        $('#spnvisitAddStatus').html('Please create separate visit records as the selected service dates do not accommodate ICD compliance.');
        msgcount = 1;
    }

    if (new Date(Startdate) > new Date(IcdDate)) {
        versionBasedOnDate = 10;
    }
    else {
        versionBasedOnDate = 9;
    }
    if (msgcount == 1) {
        return false;
    }
    else {
        var sss = getIcdVersion(Startdate, IcdDate, $('#txtICDCode').val(), "hdnIcdVersion", "spnvisitAddStatus", "Visits", versionBasedOnDate);
        return sss;
    }
}
function HealthVisitsServiceDatesValidate() {

    var Startdate = $('#txtDateOfService').val();
    var EndDate = $('#txtServiceToDate').val();
    if (EndDate != null || EndDate != '' || EndDate != 'Undefined') {
        if (new Date(Startdate).getTime() > new Date(EndDate).getTime()) {
            $('#spnvisitAddStatus').html('Service from date should be less the service to date');
            return false;
        }
    }
    return true;
}
//CPT Code Grid
function FindCPTParameters() {
    return {
        cptcode: $('#txtSCptCode').val(),
        cptdesc: $('#txtCptPatientVisitDesc').val()
    }
}
//Diagnosis
function onDataBoundHeaDiaCodeGrid() {
    ChkShowHideButHeaDiaCode();
    gridNotAvailableCustomColor('HeaDiaCodeGrid');
}
function onDataBoundHeaDiaCondGrid() {
    ChkShowHideButHeaDiaCond();
    $('#HeaDiaCondGrid .clschkAllHeaDiaCond').prop('checked', false);
    gridNotAvailableCustomColor('HeaDiaCondGrid');
}
function HeaDiaCodeParameters() {
    var varDiagnosisCodeType = "0";
    var ddlStatusFromViewSummary = "1";
    var viewSummaryPatientId = GetPatientId().patientId;
    var searchBy = "";
    var searchField = "";
    if (isFromViewSummaryCBD) {
        varDiagnosisCodeType = "1";
        searchBy = "START_DATE";
        searchField = "LOB_NAME";
        ddlStatusFromViewSummary = "1";
    } else {
        varDiagnosisCodeType = $('#ddlDiagnosisCodeType').val();
        ddlStatusFromViewSummary = $('#ddlStatus').val();
        searchBy = $('#selSearchBy').val();
        searchField = $('#selHeaDiaSearch').val();
        viewSummaryPatientId = $('#selectPatientAccessed').val();
    }
    if (window.top.$(".InAuthPage").is(":visible")) {
        viewSummaryPatientId = window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    return {
        MemberId: memberidval,
        careTeamId: $('#ddlSearchCareTeamType').val(),
        patientId: viewSummaryPatientId,
        diaSrchFld: searchField,
        diaSrchTxt: $('#txtHeaDiaSrch').val(),
        diaStDt: $('#txtHeaDiaStDt').val(),
        diaEnDt: $('#txtHeaDiaEnDt').val(),
        searchBy: searchBy,
        diagCodeType: varDiagnosisCodeType,
        isActive: ddlStatusFromViewSummary,
        lobBenId: $('#DiagnosisCLob .clsRdoMemEligMini:checked').data('lobbenid'),
        uniqueEligibilityId: $('#DiagnosisCLob .clsRdoMemEligMini:checked').data('uniqeligibilityid'),
        TimeDictionaryobj: timeZone
    };
}

function HeaDiaCondParameters() {
    var patientID = $('#selectPatientAccessed').val();
    if (window.top.$(".InAuthPage").is(":visible")) {
        patientID = window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    return {
        patientId: patientID,
        status: $('#ddlDiagCondStatus').val(),
        TimeDictionaryobj: timeZone
    }
}

function ChkShowHideButHeaDiaCode() {

    if ($('#ddlDiagnosisCodeType').val() === "0" || $('#ddlDiagnosisCodeType').val() === "1" || isFromViewSummaryCBD) {
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(3);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(4);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(5);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(6);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(7);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(8);
    }
    else if ($('#ddlDiagnosisCodeType').val() === "2") {
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(3);
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(4);
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(5);
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(6);
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(7);
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(8);
    }
    //gfid-102
    else if ($('#ddlDiagnosisCodeType').val() === "3") {
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(3);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(4);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(5);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(6);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(7);
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(8);
    }
    else {
        //SONAR
    }
    //UHC-2802
    if (isFromViewSummaryCBD) {
        $("#HeaDiaCodeGrid").data("kendoGrid").hideColumn(0);
    }
    else {
        $("#HeaDiaCodeGrid").data("kendoGrid").showColumn(0);
    }
}
function ChkShowHideButHeaDiaCond() {
    var chkdChBxCrTm = $('#HeaDiaCondGrid .clschkHeaDiaCond:checked');
    var isSecondary = false;
    $.each(chkdChBxCrTm, function (key, value) {
        if ($(value).data('leveldescription') === "Secondary") {
            isSecondary = true;
            return false;
        }
        return true;
    });
    if (chkdChBxCrTm.length == 1) {
        $('#brnHeaDiaAddCndtn').hide();
        $('#brnHeaDiaAddDesc').hide();
        if ($('#ddlDiagCondStatus').val() == 1) {
            if (isSecondary) {
                $('#brnHeaDiaSetPrmy').show();
            } else {
                $('#brnHeaDiaSetScdry').show();
            }
        } else {
            $('#brnHeaDiaSetPrmy').hide();
            $('#brnHeaDiaSetScdry').hide();
        }
        $('#btnHeaDiaCondEdit').show();
        $('#brnHeaDiaDel').show();
    }
    else if (chkdChBxCrTm.length == 0) {
        $('#brnHeaDiaAddCndtn').show();
        $('#brnHeaDiaAddDesc').show();
        if ($('#ddlDiagCondStatus').val() == 1) {
            $('#brnHeaDiaSetPrmy,#brnHeaDiaSetScdry,#btnHeaDiaCondEdit,#brnHeaDiaDel').hide();
        } else {
            $('#brnHeaDiaSetPrmy').hide();
            $('#brnHeaDiaSetScdry').hide();
        }
        $('#btnHeaDiaCndtnHistory').show();
    }
    else if (chkdChBxCrTm.length > 1) {
        if (isSecondary) {
            $('#brnHeaDiaSetScdry').hide();
        } else {
            $('#brnHeaDiaSetScdry').show();
        }
        $('#brnHeaDiaAddCndtn').hide();
        $('#brnHeaDiaAddDesc').hide();
        $('#brnHeaDiaSetPrmy').hide();
        $('#btnHeaDiaCondEdit').hide();
        $('#btnHeaDiaCndtnHistory').hide();
        $('#brnHeaDiaDel').show();
    }
}

//Doctor Appointment Details
function AppointmentStatusDetailsParameters() {
    return {
        isProvider: isProviderUser,
        AppoinmentId: AppoinmentIdVar,
        TimeDictionaryobj: timeZone
    }
}
//Find ICD Code Grid
function FindICDParameters() {
    var ConfigDateIcd = $('#hdnIcdDateFromWeb').val();
    var ServiceFromDate = $('#txtDateOfService').val();
    var Version;
    if (new Date(ServiceFromDate) <= new Date(ConfigDateIcd)) {
        Version = 9;
    }
    else {
        Version = 10;

    }
    return {
        dcode: escapeHtml($('#txtDPatientVisitCode').val()),
        ddesc: escapeHtml($('#txtPatientVisitPartialCode').val()),
        dVersion: Version
    }
}
//Get Appointment Grid
function HealthAppointmentParameters() {
    return {
        txtAppointmentID: $('#txtAppointmentID').val(),
        txtFirstName: $('#txtFirstName').val(),
        txtLastName: $('#txtLastName').val(),
        ddlSearchStatus: $('#ddlSearchStatus').val(),
        ddlProviderType: $('#ddlProviderType').val(),
        PatientId: VarPatientIdGlobalInADT != "" ? VarPatientIdGlobalInADT : $('#selectPatientAccessed').val(),
        TimeDictionaryobj: UserTimeZoneDescription
    };
}
function ResetControls() {
    $('#txtAppointmentID').val('');
    $('#ddlAppointmentType').val("-1");
    $('#txtFirstName').val('');
    $('#txtLastName').val('');
    $('#ddlSearchStatus').val("-1");
    $('#ddlProviderType').val("-1");
    $("#HealthAppointment").data("kendoGrid").dataSource.read();
    $('#hAppGrid').hide();
}
function DisableAppointmentButtons(DivObj, AppointmentStatusName) {
    var $Trs = $(DivObj).find(".btnstyle"); $($Trs).attr("disabled", false);
    var ChkStatus = AppointmentStatusName;
    var EnaClass = "." + AppointmentStatusName;
    var $TrsEna = $(DivObj).find(EnaClass);
    if ($Trs.length > 0 && $TrsEna.length > 0) {
        $($TrsEna[0]).attr("disabled", false);
    }
    if (ChkStatus == "Pending") {
        $($Trs[4]).attr("disabled", true);
    }
    else if (ChkStatus == "Scheduled") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
    }
    else if (ChkStatus == "Confirmed") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
    }
    else if (ChkStatus == "Completed") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
    }
    else if (ChkStatus == "Rescheduled") {
        //$($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        //$($Trs[2]).attr("disabled", true);
        //$($Trs[4]).attr("disabled", true);
    }
    else if (ChkStatus == "Cancelled") {
        $($Trs[0]).attr("disabled", true);
        $($Trs[1]).attr("disabled", true);
        $($Trs[2]).attr("disabled", true);
        $($Trs[3]).attr("disabled", true);
        $($Trs[4]).attr("disabled", true);
        $($Trs[5]).attr("disabled", true);
        $($Trs[6]).attr("disabled", true);
    }
}
//ICD Code
var heaDiaIcdCodeAutComSel = 0

function onHeaDiaAdtlParam() {
    var Version;
    var visitDate = $('#txtHeaDiaIcdVisitDate').val();
    var icdDateConfig = $('#hdnIcdVersionDateWeb').val();
    if (visitDate.length > 0 && new Date(visitDate) <= new Date(icdDateConfig)) {
        Version = 9
        $('#hdnIcdVersionIns').val(Version);
    }
    else {
        Version = 10
        $('#hdnIcdVersionIns').val(Version);

    }
    return {
        prefixText: $("#AutHeaDiaIcdCode").val(),
        icdVersion: Version
    };
}
function onHeaDiaIcdCodeSelect(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    $("#hdnHeaDiaIcdCodeOnSel").val(DataItem.DiagnosisCode);
    heaDiaIcdCodeAutComSel = 1;
}
function onHeaDiaIcdCodeChange() {
    if ($("#hdnHeaDiaIcdCodeOnSel").val() != "") $("#tblIcdCode  #AutHeaDiaIcdCode").val($('#hdnHeaDiaIcdCodeOnSel').val());
    $("#hdnHeaDiaIcdCodeOnSel").val('');
}
//Medical Visit Details
function onDataBoundVisitsView() {

    var chkdChkBx = $(".visitpopupchildcheckbox");
    if (chkdChkBx.length > 0) {
        $('#btnPopUpVisitView').show();
    }
    else {
        $('#btnPopUpVisitView').hide();
    }
}

function GetDetailsParameters() {
    return {
        Pid: $('#selectPatientAccessed').val(),
        AdmissionDate: $('#admdate').val(),
        DischargeDate: $('#discharge').val(),
        VisitIsManual: $('#ismanual').val(),
        PatientVisitId: $('#PVstId').val(),
        ClaimNumber: $('#visitsClaimNumber').val()

    }
}

function GetVisitLinesParameters() {
    return {
        Pid: $('#selectPatientAccessed').val(),
        ClaimNumber: $('#visitsClaimNumber').val(),
        VisitIsManual: $('#ismanual').val(),
        PatientVisitId: $('#PVstId').val()

    }
}

function MVPParameters() {
    return {
        PhysicianId: $('#PhysicianId').val(),
        VendorId: $('#VendorId').val()
    }
}
//Medical Visit Profile
function onCPTTTP() {
    var tl = $('.hOverServiceCodeDESCVProfileCls');
    $.each(tl, function (key, itm) {
        var htmlStr = "";
        htmlStr += '<p><span style=font-weight:bold>Procedure Code Description</span></p>';
        if ($(itm).data('code') != null && $(itm).data('code') != '') {
            var y = $(itm).data('code');
            var x = y.split('$');
            $.each(x, function (key, item) {
                htmlStr += '<div >' + (key + 1) + '. ' + item + '</div>';
            });
        } else { htmlStr += '<div >N/A</div>'; }
        var pos1 = $(itm).offset();
        $(itm).aToolTip({ tipContent: htmlStr });
    });
}
function onclsCrPlSrPlDataBoundMedVisit() {
    onCPTTTP();
    onICDTTP();
    $("#aToolTip").hide();

    var visibleVisitsGridId = $('.visitsGrids:visible').attr('id');
    var rowHeaderIdx = 1;
    var checkBoxIdx = 0;

    if (visibleVisitsGridId === 'VisitProfile') {
        var sectionName = "CLAIMS";
        dynamicColumnsShowHide(sectionName);
    }

    if ($('.visitsGrids:visible').length > 0 && visibleVisitsGridId !== undefined) {
        if (visibleVisitsGridId === 'IPNotificationsGrid' || visibleVisitsGridId === 'UASGrid') {
            rowHeaderIdx = 0;
            checkBoxIdx = null;
        }
        gridNotAvailableCustomColor(visibleVisitsGridId);
        A11yGrid.enhanceKendoGridForA11y(visibleVisitsGridId, rowHeaderIdx, checkBoxIdx);
    }

    //Applying gray class when data is empty
    if ($('#VisitProfilePH').is(':visible')) {
        gridNotAvailableCustomColor('VisitProfilePH');
    }
}
function onclsCrPlSrPlDataBoundEPSDTVisit() {
    var epsdtVisitGridId = $('.EpsdtVisits:visible').attr('id');

    if ($('.EpsdtVisits:visible').length > 0 && epsdtVisitGridId != undefined) {
        gridNotAvailableCustomColor(epsdtVisitGridId);
        A11yGrid.enhanceKendoGridForA11y(epsdtVisitGridId, 0);
    }

}
function EPSDTVisitParameters() {
    return {
        PatientId: $('#selectPatientAccessed').val()
    }
}
function MedicalVisitParameters() {
    return {
        MemberId: memberidval,
        PatientId: $('#selectPatientAccessed').val(),
        searchtype: $('#ddlSearchVisit').val(),
        searchtext: $('#txtSearchTextVisit').val(),
        Emrdata: $('#ddlEMR').val(),
        startdate: $('#txtVisitSearchStartDate').val(),
        enddate: $('#txtVisitSearchEndDate').val(),
        lobBenId: $('#MedicalVisitsCLob .clsRdoMemEligMini:checked').data('lobbenid'),
        uniqueEligibilityId: $('#MedicalVisitsCLob .clsRdoMemEligMini:checked').data('uniqeligibilityid')
    }
}
//Medication Details
function FunForAllInteractions(res) {
    var htmForDrugDrugInterActions = '';
    var isDrugDrugInteractionExist = 0;
    var isDrugDrugOrDrugDiseaseExist = 0;

    if (res.IsDrugDiseaseInteracting) {
        isDrugDrugOrDrugDiseaseExist = 1;
        var actIntList = res.DrugDiseaseInteractionCollection
        var htm = DrugDiseaseInteractionCollection(actIntList);
        $('#drugDiseaseInteractionsBody').AhsSetHtml(htm);
    }
    if (res.IsDuplicateInteracting) {
        var actIntList = res.DuplicateInteractionCollection
        var htm = DuplicateInteractionCollection(actIntList);
        $('#DuplicateInteractionCollection').show().AhsSetHtml(htm);
    }
    if (res.IsactiveInactiveInteracting) {
        var actIntList = res.ActiveInactiveInteractionCollection
        var htm = ActiveInactiveInteractionCollection(actIntList);
        htmForDrugDrugInterActions = htmForDrugDrugInterActions + htm;
        isDrugDrugInteractionExist = 1;
        isDrugDrugOrDrugDiseaseExist = 1;
    }
    if (res.IsInactiveInteracting) {
        var actIntList = res.InactiveInteractionCollection
        var htm = InactiveInteractionCollection(actIntList);
        htmForDrugDrugInterActions = htmForDrugDrugInterActions + htm;
        isDrugDrugInteractionExist = 1;
        isDrugDrugOrDrugDiseaseExist = 1;
    }
    if (res.IsactiveInteracting) {
        var actIntList = res.ActiveInteractionCollection
        var htm = ActiveInteractionCollection(actIntList);
        htmForDrugDrugInterActions = htmForDrugDrugInterActions + htm;
        isDrugDrugInteractionExist = 1;
        isDrugDrugOrDrugDiseaseExist = 1;
    }

    if (isDrugDrugOrDrugDiseaseExist == 1) {
        $("#interactionDivForDrugDrugAndDrugDiease").show();
        if (isDrugDrugInteractionExist == 1)
            $("#drugDrugInteractionsBody").AhsSetHtml(htmForDrugDrugInterActions);
    }
    else {
        $("#interactionDivForDrugDrugAndDrugDiease").hide();
    }

    if (!res.IsDrugDiseaseInteracting && !res.IsDuplicateInteracting
        && !res.IsactiveInteracting && !res.IsactiveInactiveInteracting && !res.IsInactiveInteracting) {
        $("#InterractionMsg").html("No Interactions Found");
    }
}

function onHeaMedClmBsdMedDataBound() {
    if (($('#ddlHeaMedClmBsdEMR').val() == '-1' || $('#btnShowPCR').is(':visible') == false)) {
        if (isLoadDynColClmBsdMedClm) {
            dynamicColumnsShowHide('CLAIM BASED MEDICATIONS CLAIMS');
        }
        A11yGrid.enhanceKendoGridForA11y('HeaMedClmBsdMedGrid', 1, 0);
        A11yUtil.fixKendoItemsPerPageBug('HeaMedClmBsdMedGrid');
    }
    else if ($('#ddlHeaMedClmBsdEMR').val() == '4' && isLoadDynColClmBsdMedPayor) {
        dynamicColumnsShowHide('CLAIM BASED MEDICATIONS PAYOR BASED');
    }
    else if ($('#ddlHeaMedClmBsdEMR').val() == '3' && isLoadDynColClmBsdMedUas) {
        dynamicColumnsShowHide('CLAIM BASED MEDICATIONS UAS');
    }
    if (this.dataSource.total() > 0) {
        var $select = $('.ddlHeaMedCBMedReconCls');
        $.ajax({
            type: "GET",
            url: baseURL + '/Home/BindHeaMedReconciled/',
            async: true,
            success: function (data) {
                var optionsHtmlString = "";
                $select.html('');
                optionsHtmlString += '<option value="-1"> Select </option>';
                $.each(data, function (_key, val) { optionsHtmlString += '<option value="' + val.Value + '">' + $.fn.replaceAndEscapeHtmlExt(val.Text) + '</option>'; });
                $select.append(optionsHtmlString);
                $select.each(function (ind, item) {
                    $(item).val($(item).data('selectedval'));
                });
            }
        });
    }

    var claimBasedMedGridId = $('.claimBasedMedGrids:visible').attr('id');
    if (claimBasedMedGridId != undefined) {
        gridNotAvailableCustomColor('claimBasedMedGridId');
    }

    if ($('#PCRHeaMedClmBsdMedGrid').is(':visible')) {
        gridNotAvailableCustomColor('PCRHeaMedClmBsdMedGrid');
        $.each($("#PCRHeaMedClmBsdMedGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#PCRHeaMedClmBsdMedGrid'));
    }
    if ($("#HeaMedClmBsdMedGrid").is(":visible")) {
        $.each($("#HeaMedClmBsdMedGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        setTimeout(function () {
            kendo.resize($('#HeaMedClmBsdMedGrid'));
            $('#HeaMedClmBsdMedGrid').find('div[data-role="pager"]').removeClass('k-pager-sm');
        });
    }
    if ($("#HeaMedMainFramesMedGrid").is(":visible")) {
        $.each($("#HeaMedMainFramesMedGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#HeaMedMainFramesMedGrid'));
    }
    if ($("#HeaMedUASBsdMedGrid").is(":visible")) {
        $.each($("#HeaMedUASBsdMedGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#HeaMedUASBsdMedGrid'));
    }
    if ($("#HeaMedClmBsdMedPayorGrid").is(":visible")) {
        $.each($("#HeaMedClmBsdMedPayorGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#HeaMedClmBsdMedPayorGrid'));
    }

    if ($("#HeaMedClmBsdMedEmrGrid").is(":visible")) {
        $.each($("#HeaMedClmBsdMedEmrGrid .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#HeaMedClmBsdMedEmrGrid'));
    }
    A11yUtil.fixA11yViolationsOnScreenLoad('#divClaimBasedMedicationsGrid');
}

function onHeaMedManualBsdMedDataBound() {
    var uniqueName = "AHS_CM_MEDICATIONS";
    var status = "";
    if (window.top.$(".InAuthPage").is(":visible") && UmPatient_AuthInfo("", "").AuthNo > 0) {
        status = $("#LblAuthStatus", UmPatient_AuthInfo("", "").AuthDivId).html().toLowerCase();
        if (!(status == "closed" || status == "close" || status == "closed and adjusted" || status == "cancelled"))
            $("#ManuallyEnteredMedications").data("kendoGrid").showColumn(1);
        uniqueName = "AHS_UM_QUICK_LINKS_MEDICATION";
    }
    if (window.top.$(".InComplaintPage").is(":visible") && AgData.complaintInfo().complaintNo > 0) {
        status = AgData.complaintInfo().complaintStatus;
        if (!(status === "closed" || status === "close" || status === "closed and adjusted" || status === "cancelled")) {
            $("#ManuallyEnteredMedications").data("kendoGrid").showColumn(0);
        }
        uniqueName = "AHS_AG_QUICK_LINKS_MEDICATION";
    }
    if (isLoadDynColManBsdMed) {
        dynamicColumnsShowHide('MANUAL MEDICATIONS');
    }
    if ($('#btnShowPCR').is(':visible') && this.dataSource.total() > 0) {
        var $select = $('.ddlHeaMedManualMedReconCls');
        $.ajax({
            type: "GET",
            url: baseURL + '/Home/BindHeaMedReconciled/',
            async: true,
            success: function (data) {
                var optionsHtmlString = "";
                $select.html('');
                optionsHtmlString += '<option value="-1"> Select </option>';
                $.each(data, function (key, val) {
                    let displayText = (val.EncodedText === undefined) ? $.fn.replaceAndEscapeHtmlExt(val.Text) : val.EncodedText;
                    optionsHtmlString += '<option value="' + val.Value + '">' + displayText + '</option>';
                });
                $select.append(optionsHtmlString);
                $select.each(function (ind, item) {
                    $(item).val($(item).data('selectedval'));
                });
            }
        });

        //var item = this.dataSource.getByUid($(row).data("uid"));
        var data = this.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var sdd = $("#ManuallyEnteredMedications").find("[data-uid='" + dataItem.uid + "']")[0];

            // use the table row (tr) and data item (dataItem)
        }
        if (roleConfig != null && roleConfig.length != 0) {
            var medicationAccess = $.greproleext(roleConfig, function (ele) {
                return ele.UniqueName === uniqueName;
            });
            if (medicationAccess != undefined && medicationAccess.length > 0) {
                if (medicationAccess[0].IsEdit != true) {
                    $(".ddlHeaMedManualMedReconCls").prop("disabled", true);
                }
            }
        }
    }

    if ($('#ManuallyEnteredMedications').is(':visible')) {
        if (window.top.$('.InAuthPage').is(':visible')) {
            $("#ManuallyEnteredMedications").data("kendoGrid").hideColumn("AuthIds");
        }
        gridNotAvailableCustomColor('ManuallyEnteredMedications');
        $.each($("#ManuallyEnteredMedications .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        A11yGrid.enhanceKendoGridForA11y('ManuallyEnteredMedications', 1, 0);
    }

    if ($('#PCRManuallyEnteredMedications').is(':visible')) {
        if (window.top.$('.InAuthPage').is(':visible')) {
            $("#PCRManuallyEnteredMedications").data("kendoGrid").hideColumn("AuthIds");
        }
        gridNotAvailableCustomColor('PCRManuallyEnteredMedications');

        $.each($("#PCRManuallyEnteredMedications .clsMemEligClick"), function (e) {
            $(this).attr("data-patientid", $('#selectPatientAccessed').val());
        });
        kendo.resize($('#PCRManuallyEnteredMedications'));
    }
    $.each($("#HeaMedClmBsdMedGrid .clsMemEligClick"), function (e) {
        $(this).attr("data-patientid", $('#selectPatientAccessed').val());
    });
    setTimeout(function () {
        kendo.resize($('#HeaMedClmBsdMedGrid'));
    });
    A11yUtil.fixA11yViolationsOnScreenLoad('#divManualBasedMedicationsGrid');
}

//uhc-2568 passing parameter
function ManualBasedPharmacyParam() {
    $('#chkAllPharmacy').prop('checked', false);
    return {
        PatientId: $('#selectPatientAccessed').val(),
        TimeDictionaryobj: timeZone
    }
}

function onDataBoundPharmacyDetailsGrid() {
    $('#ManuallyEnteredPharmacy .clschkAllPharmacy').prop('checked', false);
    ChkShowHidePharmacyButtons();
    gridNotAvailableCustomColor('ManuallyEnteredPharmacy');
    kendo.resize($('#ManuallyEnteredPharmacy'));
}

//show/hide Pharmacy buttons
function ChkShowHidePharmacyButtons() {
    let count = $('#ManuallyEnteredPharmacy .clschkPharmacy').length;
    let chkdPhrmcyChBx = $('#ManuallyEnteredPharmacy .clschkPharmacy:checked').length;

    if (chkdPhrmcyChBx === 1) {
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsAdd').hide();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsEdit').show();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsDelete').show();
    }
    else if (chkdPhrmcyChBx === 0) {
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsAdd').show();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsEdit').hide();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsDelete').hide();
        $('#divPharmacyDetailsGrid #divChooseColumnManaulPharmacy').show();
    }
    else {
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsAdd').hide();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsEdit').hide();
        $('#divPharmacyDetailsGrid #btnPharmacyDetailsDelete').show();
    }
    if (count === 0 || chkdPhrmcyChBx < count) {
        $('#chkAllPharmacy').prop('checked', false);
    }
    else if (chkdPhrmcyChBx === count) {
        $('#chkAllPharmacy').prop('checked', true);
    }
    else { /*sonar*/ }

}

function resetMeditationControls() {
    $('#ddlStatusFilter').val("1");
    $('#ddlMedicationType').val("-1");
    $('#txtMedicationName').val('');
    $('#MedicationStartDate').val('');
    $('#MedicationEndDate').val('');
    $('#ManualMedicationCLob .clsRdoMemEligMini').prop('checked', false);
}
function ClearAllMedicationControls() {
    $('#btnFldSave').prop('disabled', false);
    $('#chkAllMedications').prop('checked', false);
    $('#hdnAcMedicationCodeName').val('');
    $('#hdnAcMedicationCode').val('');
    $('#ACMedicationCodeName').val('');
    $('span.validationMessage').remove();
    $('#txtDtaMEMMedCode').val('');
    $('#txtDtaDosage').val('');
    $('#AutHeaDiaIcdCode').val('');
    $('#txtDtaQnty').val('');
    $('#txtDtaDays').val('');
    $('#txtDtaStartDate').data("kendoDatePicker").value('');
    $('#txtDtaEndDate').data("kendoDatePicker").value('');
    $('#txtManualMedicationRoute').val('');
    $('#txtDtaComments').val('');
    $('#ProviderNameMedications').val('');
    $('#InterractionMsg').html('');
    $('#drugDiseaseInteractionsBody').html('<tr><td>No Drug-Disease Interactions</td></tr>');
    $('#drugDrugInteractionsBody').html('<tr><td>No Drug-Drug Interactions</td></tr>');
    $('#DuplicateInteractionCollection').html('');
    $("#interactionDivForDrugDrugAndDrugDiease").hide();
    $("#btnSearchMedCodes").removeAttr("disabled");
    $("#txtDtaMEMMedCode").prop("disabled", false);
    $('#MedicationId').val('');
    $('#PhysicianId').val('');
    $('#MedicationCodeId').val('');
    $('#txtResnForMedctn').val('');
    getCharacterCountsForMedicationFields($('#txtResnForMedctn'), 100, $('#spnChrctrCont'));
    getCharacterCountsForMedicationFields($('#txtDtaComments'), 500, $('#spnCommentsChrctrCont'));
    getCharacterCountsForMedicationFields($('#txtTakeNeeded'), 50, $('#spnTakeNeededChrCont'));
    $('#ddlManualMedicationType').data("kendoDropDownList").value('-1');
    $('#ddlManualMedicationType').parent().find('.k-input').html('Select');
    $('#ddlManualMedicationRoute').data("kendoDropDownList").value('-1');
    $('#ddlManualMedicationRoute').parent().find('.k-input').html('Select');
    $('#ddlDosage').data("kendoDropDownList").value('-1');
    $('#ddlDosage').parent().find('.k-input').html('Select');
    $('#ddlFrequency').data("kendoDropDownList").value('-1');
    $('#ddlFrequency').parent().find('.k-input').html('Select');
    $('#ddlReconciled').data("kendoDropDownList").value('-1');
    $('#ddlReconciled').parent().find('.k-input').html('Select');
    resetDropDownList('ddlDosageForm', 'Select');
    if (viewUnifiedMedications) {
        $('#ddlClass').data("kendoDropDownList").value('-1');
        $('#ddlClass').parent().find('.k-input').html('Select');
    };
    removeDisableSaveUpdateButtonsForMedication();
    $("#ddlMedicationLob .clsRdoMemEligMini").prop('checked', false);
    clearMedicationValidation();

    // scroll to the top of the dialog
    $('#MedicationForm .ah-modal-content').animate({ scrollTop: 0 }, 'slow');
}

//uhc-2656 - check the charactercount and update the span text for Reason for Medication.
//GCPROD - 34104 check characterCount for Notes field
function getCharacterCountsForMedicationFields(textBoxId, maxValue, spanIdForMessage) {
    spanIdForMessage.text('');
    var chrctCont = (textBoxId.val() !== undefined) ? textBoxId.val().length : 0;
    if (chrctCont === 0) {
        spanIdForMessage.text(maxValue + ' characters remaining');
    }
    else {
        spanIdForMessage.text(maxValue - chrctCont + ' characters remaining');
    }
}
function getCharacterCountsForTextField(textBoxId, maxValue, spanIdForMessage) {
    var chrctCont = !$.fn.isNullOrEmpty(textBoxId.val()) ? textBoxId.val().length : 0;

    if (chrctCont === 0) {
        spanIdForMessage.text(maxValue + ' characters remaining');
    }
    else {
        spanIdForMessage.text(maxValue - chrctCont + ' characters remaining');
    }
}
function InteractionCount() {
    $('#btnALLFID').show();
    $.ajax({
        type: "POST",
        url: baseURL + "/Health/GetCurrentInteractionCount",
        dataType: "json",
        success: function (data) {
            if (data.success) {
                var obj = data.responseData;
                $('#drugDrugInteractionCount').text(obj.DrugDrugInteractionCount === 0 ? 'N' : 'Y');
                $('#duplicateTherapyCount').text(obj.DuplicateTherapyCount === 0 ? 'N' : 'Y');
                $('#drugDiseaseInteractionCount').text(obj.DrugDiseaseInteractionCount === 0 ? 'N' : 'Y');
                if (obj.DrugDiseaseInteractionCount === 0) {
                    applyDisableStyle('#btnFldDDI', '#drugDiseaseInteractionCount');
                }
                else {
                    applyEnableStyle('#btnFldDDI', '#drugDiseaseInteractionCount');
                }
                if (obj.DuplicateTherapyCount === 0) {
                    applyDisableStyle('#btnFldDT', '#duplicateTherapyCount');
                }
                else {
                    applyEnableStyle('#btnFldDT', '#duplicateTherapyCount');
                }
                if (obj.DrugDrugInteractionCount === 0) {
                    applyDisableStyle('#btnFldAI', '#drugDrugInteractionCount');
                }
                else {
                    applyEnableStyle('#btnFldAI', '#drugDrugInteractionCount');
                }
            }
        }
    });
}

function applyDisableStyle(cntrlId, cntCntrlId) {
    $(cntrlId).prop('disabled', true).css({ 'opacity': '0.4', 'cursor': 'default', 'color': '#1378a3 !important' });
    $(cntCntrlId).text('N');
}
function applyEnableStyle(cntrlId, cntCntrlId) {
    $(cntrlId).prop('disabled', false).css({ 'opacity': '0.9', 'cursor': 'hand', 'color': 'black' });
    $(cntCntrlId).text('Y');
}

function HeaMedClmBsdGridParams() {
    return {
        MemberId: memberidval,
        patientId: $('#selectPatientAccessed').val(),
        statusFilter: $('#ddlCMFilterStatus').val(), //246
        selEmr: $('#btnShowPCR').is(':visible') ? $('#ddlHeaMedClmBsdEMR').val() : '-1',//to handle claim based medications while navigating to pharamcy report
        fldName: $('#ddlHeaMedClmBsdFldType').val(),
        srchTxt: $('#txtHeaMedClmBsdSrch').val(),
        stDt: $('#txtHeaMedClmBsdStartDate').val(),
        enDt: $('#txtHeaMedClmBsdEndDate').val(),
        lobBenId: $('#ClaimMedicationCLob .clsRdoMemEligMini:checked').data('lobbenid'),
        uniqueEligibilityId: $('#ClaimMedicationCLob .clsRdoMemEligMini:checked').data('uniqeligibilityid'),
        TimeDictionaryobj: timeZone
    }
}
function PharmacyAuditTrailGridParams() {
    return {
        careStaffId: memberidval,
        MemberId: $('#selectPatientAccessed').val(),
        TimeDictionaryobj: timeZone
    }
}
function MedClmBsdGridParams() {
    return {
        MemberId: memberidval,
        patientId: $('#selectPatientAccessed').val(),
        statusFilter: $('#PCRddlMedClmBsdFldStatusFilter').val(), //246
        selEmr: $('#btnShowPCR').is(':visible') ? $('#ddlHeaMedClmBsdEMR').val() : '-1',//to handle claim based medications while navigating to pharamcy report
        fldName: $('#PCRddlHeaMedClmBsdFldType').val(),
        srchTxt: $('#PCRtxtHeaMedClmBsdSrch').val(),
        stDt: $('#PCRtxtHeaMedClmBsdStartDate').val(),
        enDt: $('#PCRtxtHeaMedClmBsdEndDate').val(),
        isReconciled: $('#ddlFldCBMReconciled').val(),
        lobBenId: $('#ClaimMedicationCLob .clsRdoMemEligMini:checked').data('lobbenid'),
        TimeDictionaryobj: timeZone
    }
}
//Search Medications
function SearchMedicationsParam() {
    return {
        txtMedName: $('#txtMedName').val(), //g8cal-57 || $('#ACMedicationName').val(),
        txtMedCode: $('#txtMedCode').val(),//g8cal-57 || $('#ACMedicationCode').val(),//g8cal-57 replace with new value
        ddlSearchType: $('#ddlSearchCriteria').val(),
    }
}
//View Dia Code
function HeaDiaViewCodeParameters() {
    return {
        diagnosisCode: $('#hdnHeaDiaCodeForView').val(),
        patientId: $('#selectPatientAccessed').val(),
        diagnosisType: $('#ddlDiagnosisCodeType').val()
    }
}
//View Provider Address
function ViewAddressParameters() {
    return {
        ProviderId: $('#hdnProviderId').val()
    }
}

function MemberFiles() {

    return {
        //planId: prgplanid,
        progId: prgprgid,
        memClinicalPrgmId: memClinicalPrgmId,
        PatientId: $('#selectPatientAccessed').val()
    }
}
//View Script Activity Summary
function ViewResponseParameters() {
    return {
        patientId: $('#selectPatientAccessed').val(),
        scriptId: scriptId,
        scriptRunLogId: scriptRunLogId,
        TimeDictionaryobj: timeZone
    }
}
//Health Indicators
function HealthHeaIndParameters() {
    var patientID = $('#selectPatientAccessed').val();
    if (window.top.$(".InAuthPage").is(":visible")) {
        patientID = window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    return {
        MemberId: memberidval,
        careTeamId: $('#ddlSearchCareTeamType').val(),
        patientId: patientID,
        catId: $('#selectHeaIndCategory').val(),
        indId: $('#selectHeaIndicators').val(),
        patClientId: elepatClientId
    }
}
//10.CarePlanControl.js
//$(document).ready(function () {

///**** Team Care Plan Scripts start ****///

function AddActivityOnCarePlan(careplanIdAdd) {
    $('#hdnCrPlTmCrPlHisCrPlId').val('');
    var $obj = chkChecked();
    var chkBxChd = $obj.checkBox;
    var carePlanId = [];
    if (chkBxChd.length >= 1) {

        $.each(chkBxChd, function (key, item) {
            if ($(item).is(':checked')) {
                carePlanId.push($(item).attr('Id').split('_')[1]);
            }
        });
        $('#hdnCrPlTmCrPlHisCrPlId').val(carePlanId.join(','));
    }
    else {
        $('#hdnCrPlTmCrPlHisCrPlId').val(careplanIdAdd);
    }
    if ($.trim($('#popUpDialog1 #portletHeadHand').text().toUpperCase()) == "ADD ACTIVITY") {
        $('#popUpDialog1').html('');
    }
    $('#popUpDialog2').CMNPopup({
        popUpHeader: "Add Activity",
        pvUrl: baseURL + "/Home/EditActivity?patientId=" + $('#selectPatientAccessed').val() + "&CarePlanId=" + $('#hdnCrPlTmCrPlHisCrPlId').val() + "&carePlanActivity=1",
        onLoad: function () {
            onLoadEditActivity();
            $('#selectScheduledType').prop('disabled', true);
            $('#chkGroupActivity').prop('disabled', true);
            $('#ddlCareStaffAddActivity').val(unescapeHtml(assignOwnercareStaffFullNameWithRole));
            $('#hdnCareStaffAddActivity').val(assignOwnermemberidval);
            var ddl = $('#selectActivityType').data('kendoDropDownList');
            ddl.enable(false);
            $('#AddActFor').on('change', function () {
                ddl.text('Care Plan Assigned');
                var activityFor = $('#AddActFor input[type="radio"]:checked').val();
                if (activityFor === 'INTER') {
                    $('#selectScheduledType').prop('disabled', true);
                    ddl.enable(false);
                }
                else {
                    ddl.enable(true);
                }
            });
            //$('#CareActivityTypeId').val(ddl.value());
            $('#btnSubmitActivityForm').hide();
            A11yModal.trapFocusInModal('popUpDialog2');
        },
        onClose: function () {
            ClearActivityHdnCntrls();
        },
        popLevel: 1,
        modalWidth: MODAL_WIDTH.MEDIUM,
        closeButton: "#btnCloseEditActivityForm"
    });



}

function CpGoalsInterventionParamsByNoteId() {
    return {
        patientId: $('#selectPatientAccessed').val(),
        NoteId: NotesIdforViewHealthNotes,
        cplNotesGroupId: cplNotesGroupId,
        timeDictionaryObj: timeZone
    }
}

/*Care Plan Grouping Grid Show hover menu in dropdown check Start - used in MemberPrograms*/
function ShowCPGroupHoverMenu(tableid, menuid, ctrlid, isParent) {
    var mentop;
    var menleft;
    var $menu = $('#' + menuid);
    var $table = tableid;
    var pos = ctrlid.offset();
    mentop = pos.top;
    menleft = pos.left;
    $menu.hide();
    mentop = mentop - $(document).scrollTop();
    var menheight = $menu.height();
    var menwidth = $menu.width();
    var tabheight = $table.height();
    var tabtop = $table.offset().top;
    if ((mentop + menheight) > (tabtop + tabheight))
        mentop = ((mentop + 10) - menheight);
    $menu.show().css('left', (menleft + (ctrlid.width() + 5)) + "px").css('top', mentop + "px");

}
/*Care Plan Grouping Grid Show hover menu in dropdown check End*/

/*Context menu visibility*/

function CarePlanParams(pagefilter) {
    cpPageFilter = pagefilter;
    var $cateId = globalTeamCPStatus == '' ? $('#selCrPlTmCrPlCat').val() : globalTeamCPStatus;
    if ($("#hdnIsMTMIntervention").val() !== "1") {
        createCarePlanOverviewFiltersDiv($cateId);
    }
    let dateRange = getDateRangeBetween1to180andCustomDays($('#cpDateRange').val(),
        $('#txtCrPlTmCrPlStDt').val(),
        $('#txtCrPlTmCrPlEdDt').val());
    let sort = pagefilter.sort;

    return {
        patientId: $('#selectPatientAccessed').val(),
        CategoryID: $cateId === "" ? "-1" : $cateId,
        DateCriteria: $('#cpDateType').val(),
        StartDate: dateRange.fromDate,
        EndDate: dateRange.toDate,
        TimeDictionaryobj: timeZone,
        SearchName: ($('#ddlSearchCpl').val() === "Script Name") ? "Script" : $('#ddlSearchCpl').val(),
        SearchText: encodeURIComponent($('#txtSearchCpl').val()),
        StatusId: $('#loadStatushdn').val(),
        AssignOwner: $('#selectAssignOwnerReferSearchIdhdn').val(),
        sortfield: sort ? sort[0].field : $('#hdnTCPSortfield').val(),
        sortdir: sort ? sort[0].dir : $('#hdnTCPSortdir').val()
    }
}

function CarePlanMessage(isEdit) {

    var msg = '';
    $.ajax({
        type: "Get",
        async: true,
        url: baseURL + '/CarePlan/GetCarePlanMessage?PatientId=' + $('#selectPatientAccessed').val(),
        dataType: "json",
        success: function (data) {
            msg = data.val;
            if (msg == 'null' || msg == '' || msg == 'undefined') {
                msg = '';
            }
            if (isEdit) {
                $('#popUpDialog2').CMNPopup({
                    pvUrl: baseURL + "/CarePlan/GeneralConsideration",
                    popUpHeader: "General Consideration",
                    onLoad: function () {
                        if (msg != '')
                            $('#txtcplgencon').val(msg);
                    },
                    popLevel: 2,
                    closeButton: '#btnTmCrPlnConsiderationClose'
                });

            }
            else {
                $('#spngenConsideration').AhsSetHtml(escapeHtml(msg));
            }
        }
    });
}
function unescapeHtml(text) {
    if (text != null) {
        return text.replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#39;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&#10;/g, "\n")
            .replace(/&amp;/g, '&');
    }
    else return "";
}
function replaceEncodedApos(input) {
    if (typeof input === "string") {
        return input.replaceAll("&#39;", "'");
    }
    else {
        return input;
    }
}

/*Refresh grid view according to selected category*/
function gridRefresh(gridId, isClear, isResetPage) {
    ClearGrid(gridId, isClear);
    var $grid = $(gridId);
    if (isResetPage) {
        $grid.data("kendoGrid").dataSource.page(1); //KUHG-1427
    }
    else {
        $grid.data("kendoGrid").dataSource.page(1);
    }

    $grid.find('.clsChkCrPlTmCrPlHead').prop('checked', false);
    var selectedCategory = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    TmCrPlShHdBtn(selectedCategory, 0);
    $('#hMenGdCP,.clsTmCrPlInlineContextMenu').hide();
    $('#hdnCrPlTmCrPlHisCrPlId').val('');
}

/*Row databound function for tooltips of all categories except UAS*/
function onTeamCarePlanDataBound() {
    var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; }
    A11yGrid.enhanceKendoGridForA11y('TmCrPlCarePlanGrid', 0, 0);
    $('.hOverStatusCls').aToolTip();
    $('.hOverStDateCls').aToolTip();
    $('.hOverEndDateCls').aToolTip();
    $('#TmCrPlCarePlanGrid div.hoverInterventRec').aToolTip();
    $('#TmCrPlRecAndCurGroupGrid div.hovRecCPGoalName').aToolTip();
    $('#TmCrPlRecAndCurGroupGrid div.hovCurrCPOppName').aToolTip({});
    $('#TmCrPlRecAndCurGroupGrid div.hoverInterventRec').aToolTip();
    $('#TmCrPlRecAndCurGroupGrid div.hoverIsRoleCls').aToolTip();
    $('#hMenGdCP').hide();
    $('.clsChkCrPlTmCrPlHead').prop('checked', false);
    var item = getSpecRoleItem("AHS_CM_TEAM_CARE_PLAN");//TNCARE-207
    if (item != undefined && item != null && item.length > 0) {
        if (item[0].IsEdit == false) {
            $(".cplPrioritychild", "#TmCrPlCarePlanGrid").removeAttr("class").attr("disabled", "disabled").attr('title', 'You do not have access to Edit a record.');
        }
    }
    item = getSpecRoleItem("AHS_CM_TEAM_CARE_PLAN"); //TNCARE - 272
    if (item != undefined && item != null && item.length > 0) {
        if (item[0].IsAdd == false) {
            $(".lnkbtncplIntrTypeClass").removeAttr("class").attr("disabled", "disabled").attr('title', 'You do not have access to Add a record.').attr("id", "lnkbtncplIntrTypeDisabled").css({ "opacity": "0.5", "cursor": "default" });
        }
    }
    if (isMtmIntervention) { isLoadDynamicColumns = false; };
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase();
    var gridName = GetCRPLGrid($catName.trim());

    if (gridName !== 'TmCrPlCarePlanGrid' && isMtmIntervention) {
        interventionsGridMerge();
    }

    if (!isMtmIntervention) {
        //Binding Priority dropdown
        if (gridName === "TmCrPlRecAndCurGroupGrid" || gridName === "TmCrPlRecAndCurGroupListView") {
            var items = $('#' + gridName).find('.cpPriorityStatus');            
            items.each(function () {
                var priorityDtls = ($(this).data('details') || '').split('§');
                if (priorityDtls.length === 3) {
                    var carePlanId = priorityDtls[0];
                    var priorityId = priorityDtls[1];
                    var priorityName = priorityDtls[2];
                    priorityStatusTemplate(carePlanId, priorityName, priorityId);
                }
            });
            //Disable SignOff button when logincarestaff not in member careteam
            enableDisableSignOffStatusChangeBtn();
        }
        //Show Hide Pager
        showHidePager(gridName);
    }

    gridNotAvailableCustomColor(gridName);
    resetCntrlStateScroll();
    if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
        gridNotAvailableCustomColor(gridName);
        A11yGrid.enhanceKendoGridForA11y(gridName, 1, 0);
        updateCarePlanGridLayout();
    }
    else {
        kendo.resize($("#TmCrPlRecAndCurGroupGrid"));
    }
    if (isToggled === true && carePlanSelectedViewType === VIEW_MODE.DETAILS_VIEW) {
        jumpToSelectedItemInDetailView();
    }
}

function closeWarning(windowId) {
    $('#' + windowId).hide();
}

function dynamicColumnsShowHide(sectionName) {
    return $.ajax({
        type: "POST",
        url: baseURL + '/CarePlan/GetDynamicColumns?section=' + sectionName,
        dataType: "json",
        success: function (data) {
            if (data.success) {
                isLoadDynamicColumns = false;
                if (sectionName == 'MANUAL MEDICATIONS') {
                    isLoadDynColManBsdMed = false;
                }
                else if (sectionName == 'CLAIM BASED MEDICATIONS CLAIMS') {
                    isLoadDynColClmBsdMedClm = false;
                }
                else if (sectionName == 'CLAIM BASED MEDICATIONS PAYOR BASED') {
                    isLoadDynColClmBsdMedPayor = false;
                }
                else if (sectionName == 'CLAIM BASED MEDICATIONS UAS') {
                    isLoadDynColClmBsdMedUas = false;
                }
                var visibleColumnsList = data.visibleColumns.split('|');
                var hiddenColumnsList = data.hiddenColumns.split('|');
                var GridColumns = "";
                var gridId = "";

                $.each(visibleColumnsList, function (key, item) {
                    switch (sectionName) {
                        case 'PENDING ACTIVITIES':
                            GridColumns = $("#grdPendingActivities").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#grdPendingActivities").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER ACTIVITIES':
                            GridColumns = $("#CMPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#CMPendingActivitiesGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER MEMBERS':
                            GridColumns = $("#CMMyMembersGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#CMMyMembersGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER AG ACTIVITIES':
                            GridColumns = $("#AGPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if ($.inArray(item1.title, hiddenColumnsList) > -1) {
                                    $("#AGPendingActivitiesGrid").data("kendoGrid").hideColumn(key1);
                                }
                                else if ($.inArray(item1.title, visibleColumnsList) > -1) {
                                    $("#AGPendingActivitiesGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER COMPLAINTS':
                            GridColumns = $("#AGPendingComplaintsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if ($.inArray(item1.title, hiddenColumnsList) > -1) {
                                    $("#AGPendingComplaintsGrid").data("kendoGrid").hideColumn(key1);
                                }
                                else if ($.inArray(item1.title, visibleColumnsList) > -1) {
                                    $("#AGPendingComplaintsGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER UM ACTIVITIES':
                            GridColumns = $("#UMPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UMPendingActivitiesGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER AUTHS':
                            GridColumns = $("#UMPendingAuthorizationsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UMPendingAuthorizationsGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'MANUAL MEDICATIONS':

                            if ($('#trHeaMedManualBsdGrid').is(':visible')) {
                                gridId = '#ManuallyEnteredMedications';  // Medication Screen
                            }
                            else {
                                gridId = '#PCRManuallyEnteredMedications'; // Pharmacy Report Screen

                            }
                            if ($(gridId).length > 0) {
                                GridColumns = $(gridId).data("kendoGrid").columns;
                                $.each(GridColumns, function (key1, item1) {
                                    if (item1.title == item) {
                                        if (key1 == RootLevel) {
                                            $(gridId).data("kendoGrid").showColumn("LobName");
                                        } else {
                                            $(gridId).data("kendoGrid").showColumn(key1);
                                        }
                                    }
                                });
                            }
                            if (window.top.$(".InAuthPage").is(":visible")) {
                                $(gridId).data("kendoGrid").hideColumn("AuthIds");
                            }
                            break;
                        case 'GENERAL ACTIVITY':
                            GridColumns = $("#generalActivityGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalActivityGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'MTM GENERAL ACTIVITY':
                            GridColumns = $("#generalActivityGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalActivityGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'PROVIDER ACTIVITY':
                            ExtGridColumns = $("#generalExtActivityGrid").data("kendoGrid").columns;
                            $.each(ExtGridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalExtActivityGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'MTM PROVIDER ACTIVITY':
                            ExtGridColumns = $("#generalExtActivityGrid").data("kendoGrid").columns;
                            $.each(ExtGridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalExtActivityGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'SCRIPT ACTIVITY':
                            GridColumns = $("#scriptSummaryGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#scriptSummaryGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'MTM SCRIPT ACTIVITY':
                            GridColumns = $("#scriptSummaryGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#scriptSummaryGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'CARE TEAM':
                            GridColumns = $("#careTeamGrid").data("kendoGrid").columns;
                            var careTeamType = $('#ddlSearchCareTeamType option:selected').text();
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#careTeamGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'MEMBER DOCUMENTS': //UHC-4157
                            GridColumns = $("#electronicDocsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#electronicDocsGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'ADVANCE PROVIDER SEARCH':
                            GridColumns = $("#gvFindProvider").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#gvFindProvider").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIMS':
                            GridColumns = $("#VisitProfile").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#VisitProfile").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM LINE DETAILS':
                            GridColumns = $("#GetVisitLines").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#GetVisitLines").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM BASED MEDICATIONS CLAIMS':
                            if ($('#trHeaMedClmBsdGrid').is(':visible')) {
                                gridId = '#HeaMedClmBsdMedGrid';  // Medication Screen
                            }
                            else {
                                gridId = '#PCRHeaMedClmBsdMedGrid'; // Pharmacy Report Screen

                            }
                            if ($(gridId).length > 0) {
                                GridColumns = $(gridId).data('kendoGrid').columns;
                                $.each(GridColumns, function (key1, item1) {
                                    if (item1.title == item) {
                                        $(gridId).data('kendoGrid').showColumn(key1);
                                    }
                                });
                            }
                            break;
                        case 'CLAIM BASED MEDICATIONS PAYOR BASED':
                            GridColumns = $("#HeaMedClmBsdMedPayorGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#HeaMedClmBsdMedPayorGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM BASED MEDICATIONS UAS':
                            GridColumns = $("#HeaMedUASBsdMedGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#HeaMedUASBsdMedGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'PH AUTHORIZATIONS':
                            GridColumns = $("#AuthSummaryPH").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#AuthSummaryPH").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'PATIENT AUTHORIZATIONS':
                            GridColumns = $("#AuthSummary").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#AuthSummary").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'UM AUTH SUMMARY':
                            var PI = UmPatient_AuthInfo("", "");
                            GridColumns = $("#UmAuthSummary_" + PI.AuthNoId).data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UmAuthSummary_" + PI.AuthNoId).data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'PRINT ARCHIVE':
                            GridColumns = $("#PrintArchive").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#PrintArchive").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;
                        case 'PREGNANCY':
                            GridColumns = $("#PregnancyDetailsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#PregnancyDetailsGrid").data("kendoGrid").showColumn(key1);
                                }
                            });
                            break;

                        case 'UM DOCUMENTS':

                            if (visibleColumnsList[0].length > 0) {
                                var UM_PI = UmPatient_AuthInfo('');
                                var AccId = UM_PI.AuthDivId + " #Accordion_Group_5 #AuthInit_5_1";
                                var index = $(AccId + " #AuthDocumentsGrid").find("th:contains(" + item + ")").index();
                                $("#AuthDocumentsGrid", AccId).find("th:eq(" + index + ")").show();

                                $(AccId + " #AuthDocumentsGrid").find("table").find(".DataRow").each(function () {
                                    $(this).find("td:eq(" + index + ")").show();
                                });

                            }

                            break;
                        case 'AG DOCUMENTS':
                            if (visibleColumnsList[0].length > 0) {
                                var AGPI = AgData.complaintInfo();
                                var AGAccId = AGPI.complaintDivId;
                                var AGindex = $(AGAccId + " #Grid_ComplaintDocument").find("th:contains(" + item + ")").index();
                                $("#Grid_ComplaintDocument", AGAccId).find("th:eq(" + AGindex + ")").show();

                                $(AGAccId + " #Grid_ComplaintDocument").find("table").find(".DataRow").each(function () {
                                    $(this).find("td:eq(" + AGindex + ")").show();
                                });
                            }
                            break;

                        default:
                            break;
                    }
                });
                if (sectionName == "CARE TEAM") {
                    careTeamVisibleCols = data.visibleColumns;
                    isDynColsDataExists = data.isDataExists;
                    CareTeamShowHideCol();
                }
                $.each(hiddenColumnsList, function (key, item) {
                    switch (sectionName) {
                        case 'PENDING ACTIVITIES':
                            GridColumns = $("#grdPendingActivities").data("kendoGrid").columns;
                            GridColumns = $("#grdPendingActivities").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#grdPendingActivities").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER ACTIVITIES':
                            GridColumns = $("#CMPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#CMPendingActivitiesGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER MEMBERS':
                            GridColumns = $("#CMMyMembersGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#CMMyMembersGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER AG ACTIVITIES':
                            GridColumns = $("#AGPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#AGPendingActivitiesGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER UM ACTIVITIES':
                            GridColumns = $("#UMPendingActivitiesGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UMPendingActivitiesGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'WORKLOG MANAGER AUTHS':
                            GridColumns = $("#UMPendingAuthorizationsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UMPendingAuthorizationsGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'MANUAL MEDICATIONS':
                            if ($('#trHeaMedManualBsdGrid').is(':visible')) {
                                gridId = '#ManuallyEnteredMedications';  // Medication Screen
                            }
                            else {
                                gridId = '#PCRManuallyEnteredMedications'; // Pharmacy Report Screen

                            }
                            if ($(gridId).length > 0) {
                                GridColumns = $(gridId).data("kendoGrid").columns;
                                $.each(GridColumns, function (key1, item1) {
                                    if (item1.title == item) {
                                        if (key1 == RootLevel) {
                                            $(gridId).data("kendoGrid").hideColumn("LobName");
                                        } else {
                                            $(gridId).data("kendoGrid").hideColumn(key1);
                                        }
                                    }
                                });
                            }
                            break;
                        case 'GENERAL ACTIVITY':
                            GridColumns = $("#generalActivityGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalActivityGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'MTM GENERAL ACTIVITY':
                            GridColumns = $("#generalActivityGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalActivityGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'PROVIDER ACTIVITY':
                            ExtGridColumns = $("#generalExtActivityGrid").data("kendoGrid").columns;
                            $.each(ExtGridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalExtActivityGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'MTM PROVIDER ACTIVITY':
                            ExtGridColumns = $("#generalExtActivityGrid").data("kendoGrid").columns;
                            $.each(ExtGridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#generalExtActivityGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'SCRIPT ACTIVITY':
                            GridColumns = $("#scriptSummaryGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#scriptSummaryGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'MTM SCRIPT ACTIVITY':
                            GridColumns = $("#scriptSummaryGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#scriptSummaryGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'CARE TEAM':
                            if (isDynColsDataExists == true) {
                                GridColumns = $("#careTeamGrid").data("kendoGrid").columns;
                                $.each(GridColumns, function (key1, item1) {
                                    if (item1.title == item && key1 != 1) {
                                        $("#careTeamGrid").data("kendoGrid").hideColumn(key1);
                                    }
                                });
                            }
                            break;
                        case 'MEMBER DOCUMENTS': //UHC-4157
                            GridColumns = $("#electronicDocsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#electronicDocsGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'ADVANCE PROVIDER SEARCH':
                            GridColumns = $("#gvFindProvider").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#gvFindProvider").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIMS':
                            GridColumns = $("#VisitProfile").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#VisitProfile").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM LINE DETAILS':
                            GridColumns = $("#GetVisitLines").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#GetVisitLines").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM BASED MEDICATIONS CLAIMS':
                            if ($('#trHeaMedClmBsdGrid').is(':visible')) {
                                gridId = '#HeaMedClmBsdMedGrid'; // Medication Screen
                            }
                            else {
                                gridId = '#PCRHeaMedClmBsdMedGrid';  // Pharmacy Report Screen
                            }
                            if ($(gridId).length > 0) {
                                GridColumns = $(gridId).data('kendoGrid').columns;
                                $.each(GridColumns, function (key1, item1) {
                                    if (item1.title == item) {
                                        $(gridId).data('kendoGrid').hideColumn(key1);
                                    }
                                });
                            }
                            break;
                        case 'CLAIM BASED MEDICATIONS PAYOR BASED':
                            GridColumns = $("#HeaMedClmBsdMedPayorGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#HeaMedClmBsdMedPayorGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'CLAIM BASED MEDICATIONS UAS':
                            GridColumns = $("#HeaMedUASBsdMedGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#HeaMedUASBsdMedGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'PH AUTHORIZATIONS':
                            GridColumns = $("#AuthSummaryPH").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#AuthSummaryPH").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'PATIENT AUTHORIZATIONS':
                            GridColumns = $("#AuthSummary").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#AuthSummary").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'UM AUTH SUMMARY':
                            var PI = UmPatient_AuthInfo("", "");
                            GridColumns = $("#UmAuthSummary_" + PI.AuthNoId).data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#UmAuthSummary_" + PI.AuthNoId).data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'PRINT ARCHIVE':
                            GridColumns = $("#PrintArchive").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#PrintArchive").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'PREGNANCY':
                            GridColumns = $("#PregnancyDetailsGrid").data("kendoGrid").columns;
                            $.each(GridColumns, function (key1, item1) {
                                if (item1.title == item) {
                                    $("#PregnancyDetailsGrid").data("kendoGrid").hideColumn(key1);
                                }
                            });
                            break;
                        case 'UM DOCUMENTS':

                            if (hiddenColumnsList.length > 0 && hiddenColumnsList[0].length > 0) {
                                var UM_DOC_PI = UmPatient_AuthInfo('');
                                var UMDOCAccId = UM_DOC_PI.AuthDivId + " #Accordion_Group_5 #AuthInit_5_1";
                                var UMDOCindex = $(UMDOCAccId + " #AuthDocumentsGrid").find("th:contains(" + item + ")").index();
                                $("#AuthDocumentsGrid", UMDOCAccId).find("th:eq(" + UMDOCindex + ")").hide();
                                $(UMDOCAccId + " #AuthDocumentsGrid").find("table").find(".DataRow").each(function () {
                                    $(this).find("td:eq(" + UMDOCindex + ")").hide();
                                });
                            }
                            break;
                        case 'AG DOCUMENTS':
                            if (hiddenColumnsList.length > 0 && hiddenColumnsList[0].length > 0) {
                                var AG_DOC_PI = AgData.complaintInfo();
                                var AccId = AG_DOC_PI.complaintDivId;
                                var index = $(AccId + " #Grid_ComplaintDocument").find("th:contains(" + item + ")").index();
                                $("#Grid_ComplaintDocument", AccId).find("th:eq(" + index + ")").hide();
                                $(AccId + " #Grid_ComplaintDocument").find("table").find(".DataRow").each(
                                    function () {
                                        $(this).find("td:eq(" + index + ")").hide();
                                    });
                            }
                            break;
                        default:
                            break;
                    }
                });
            }
            loader(0);
        },
        error: function () {
            loader(0);
        }
    });
}

///**** Team Care Plan Scripts End ****///

///**** Team Care Plan ADD or EDIT  Scripts Start ****///

function ExCrTmEmailBtnShHd() {
    if ($.trim($('#ExCrTmFormId #ProviderName').val()) != "" || $.trim($('#ExCrTmFormId #txtExtFirstName').val() + " " + $('#ExCrTmFormId #txtExtCrTmLastName').val()) != "") {
        if ($.trim($('#ExCrTmFormId #txtExtCrTmEmail').val()) != "" && ValidateEmail($('#ExCrTmFormId #txtExtCrTmEmail').val())) {
            //$('#imgSendEmailComPorURL').hide();
        }
        else {
            // $('#imgSendEmailComPorURL').hide();
        }
    }
}

//UHC-4434
function logPatientMismatch(patientIdPassed, methodName, dataString, patientIdInSession) {
    if (isLogPatientMismatch == "1" && (patientIdPassed != $('#selectPatientAccessed').val() || (patientIdInSession != undefined && patientIdInSession != $('#selectPatientAccessed').val()))) {
        try {
            var patientMismatchLog = new Object();
            patientMismatchLog.Data = dataString;
            patientMismatchLog.PatientIdPassed = patientIdPassed;
            patientMismatchLog.patientIdInSession = patientIdInSession;
            patientMismatchLog.PatientIdInDropdown = $('#selectPatientAccessed').val();
            patientMismatchLog.CareStaffId = memberidval;
            patientMismatchLog.MethodName = methodName;
            if (typeof (patientMismatchLog.Data) == "object") {
                var dataStr = '';
                for (var count = 0; count < dataString.length; count++) {
                    if (dataStr != '') { dataStr += '&'; }
                    dataStr = dataStr + dataString[count].Name + "=" + dataString[count].Value;
                }
                patientMismatchLog.Data = dataStr;
            }
            if (patientIdPassed != 0 && patientIdInSession != 0) {
                $.ajax({
                    url: baseURL + "/Home/LogPatientMismatch",
                    type: "POST",
                    data: JSON.stringify(patientMismatchLog),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    async: true
                });
            }
        } catch (e) {
        }
    }
}
//UHC-4434

function showMandatoryTextValidationForControls(controlId, labelId, isKendo) {
    if (isKendo) {
        $('#' + controlId).closest('.k-state-default').attr('style', 'border: 1px solid #e02020 !important').addClass('valueRequired');
    } else {
        $('#' + controlId).attr('style', 'border: 1px solid #e02020 !important').addClass('valueRequired');
    }
    if ((!$("#" + controlId).is(':disabled'))) {
        $('#' + labelId).addClass('error_text');
    }
}

function valForCrPlFormTmCrPl(functionality, isFromUpdate, isCPOrphan) {
    var flag = true;
    if ($('#hdnEditSelectConditionId').val() === "" || $('#hdnEditSelectConditionId').val() === undefined
        || $('#selCrPlTmConditionId').val().length < 3 || $('#selCrPlTmConditionId').val() === "") {
        $('#spnSelCrPlTmConditionId').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("selCrPlTmConditionId", "lblConditionEdit", true);
        }
        flag = false;
    }
    else {
        $('#spnSelCrPlTmConditionId').hide();
    }
    if ($('#hdnEditSelectGoalGroupId').val() === "" || $('#hdnEditSelectGoalGroupId').val() === undefined
        || $('#selCrPlTmGoalGroupId').val().length < 3 || $('#selCrPlTmGoalGroupId').val() === "") {
        $('#spnSelCrPlTmGoalGroupId').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("selCrPlTmGoalGroupId", "lblGoalGroupEdit", true);
        }
        flag = false;
    }
    else {
        $('#spnSelCrPlTmGoalGroupId').hide();
    }
    if ($('#hdnEditSelectOpportunityId').val() === "" || $('#hdnEditSelectOpportunityId').val() === undefined
        || $('#selCrPlTmOppId').val().length < 3 || $('#selCrPlTmOppId').val() === "") {
        $('#spnSelCrPlTmOppId').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("selCrPlTmOppId", "lblOpportunityEdit", true);
        }
        flag = false;
    }
    else {
        $('#spnSelCrPlTmOppId').hide();
    }
    if ($('#txtCrPlTmGoal').is(':hidden')) {
        if ($('#hdnEditSelectGoalId').val() === "" || $('#hdnEditSelectGoalId').val() === undefined
            || $('#selCrPlTmGoalId').val().length < 3 || $('#selCrPlTmGoalId').val() === "") {
            $('#spnSelCrPlTmGoalId').show();
            if (isFromUpdate) {
                showMandatoryTextValidationForControls("selCrPlTmGoalId", "lblGoalEdit", true);
            }
            flag = false;
        }
        else {
            $('#spnSelCrPlTmGoalId').hide();
        }
    } else if ($('#txtCrPlTmGoal').val() === null || $('#txtCrPlTmGoal').val() === '') {
        $('#spnSelCrPlTmGoalId').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("selCrPlTmGoalId", "lblGoalEdit", true);
        }
        flag = false;
    }
    else {
        flag = true;
        $('#spnSelCrPlTmGoalId').hide();
    }

    if ($('#selCrPlTmStatusId').val() === undefined || $('#selCrPlTmStatusId').val() === '-1' || $('#selCrPlTmStatusId').val() === "") {
        $('#spnSelCrPlTmStatusId_0').show();
        if (isFromUpdate) {
            $('#selCrPlTmStatusId').parent().find('.k-state-default').attr('style', 'border: 1px solid #e02020 !important').addClass('valueRequired');
            $('#lblStatus').addClass('error_text');
        }
        flag = false;
    }
    else {
        $('#spnSelCrPlTmStatusId_0').hide();
    }
    //kuhg-746
    if (($('#txtCrPlTmIntervention').is(':hidden') || $('#txtCrPlTmIntervention').val() === null || $('#txtCrPlTmIntervention').val() === '')
        && ($('#InterventionIdAuto').val().length < 3 || $('#InterventionIdAuto').val() === '' || $('#formCrPlAddTmCrPl #InterventionId').val() === null || $('#formCrPlAddTmCrPl #InterventionId').val() === '')) {
        $('#spnCrPlTmInterAutoCmplt_0').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("InterventionIdAuto", "lblIntervention", true);
        }
        flag = false;
    }
    else {
        $('#spnCrPlTmInterAutoCmplt_0').hide();
    }
    if (functionality === 'ADD' && $('#selCrPlTmCLobId .clsRdoMemEligMini:checked').length === 0) {
        $('#selCrPlTmCLobId').closest('td').prepend('<span class="requiredfields" style="float: left;margin-top: 25px;"> *</span>');
        flag = false;
    }
    var startDt = $('#txtCrPlTmStartDate');
    var endDt = $('#txtCrPlTmEndDate');
    var date1 = new Date(startDt.val().trim());
    var date2 = new Date(endDt.val().trim());

    var inValidStartDt = startDt.hasClass('.invalidDate');
    var inValidEndDate = endDt.hasClass('.invalidDate');

    if (startDt.val() === "" || inValidStartDt) {
        $('#spnTxtCrPlTmStartDate_0').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("txtCrPlTmStartDate", "lblStartDate", true);
        }
        flag = false;
    }
    else {
        $('#spnTxtCrPlTmStartDate_0').hide();
    }
    if (endDt.val() === "" || inValidEndDate) {
        $('#spnTxtCrPlTmEndDate_0').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("txtCrPlTmEndDate", "lblTargetDate", true);
        }
        flag = false;
    }
    else {
        $('#spnTxtCrPlTmEndDate_0').hide();
    }
    if (!inValidStartDt && !inValidEndDate && date1 > date2) {
        $('#dateValMsg').show();
        if (isFromUpdate) {
            showMandatoryTextValidationForControls("txtCrPlTmStartDate", "lblStartDate", true);
        }
        flag = false;
    }
    else {
        $('#dateValMsg').hide();
    }

    //kuhg-746
    if (startDt.val()) {
        if (IsDate(startDt.val()) === false) {
            $('#spnTxtCrPlTmStartDate_0').show();
            flag = false;
        }
    }
    else {
        $('#spnTxtCrPlTmStartDate_0').hide();
    }
    if (endDt.val()) {
        if (IsDate(endDt.val()) === false) {
            $('#spnTxtCrPlTmEndDate_0').show();
            flag = false;
        }
    }
    else {
        $('#spnTxtCrPlTmEndDate_0').hide();
    }
    if (isCPOrphan === 'true' && $('#selCrPlTmLobId1 .memberEligibility.active').length === 0) {
        $('#spnSelCrPlTmLobId').show();
        if (isFromUpdate) {
            $('#lblPayor').addClass('error_text');
        }
        flag = false;
    } else {
        $('#spnSelCrPlTmLobId').hide();
    }

    return flag;
}

//kuhg-746 start

function onInterventionParamSearch() {
    return {
        intervention: $('#InterventionIdAuto').val()
    }
}
function onHealthGoalParamSearch() {
    return {
        goalName: $('#GoalIdAuto').val()
    }
}
function onInterventionSearchDropdownSelect(e) {
    if (e.item == null) {
        if (e.sender._prev == "") {
            $('#formCrPlAddTmCrPl #InterventionId').val('');
            $('#formCrPlAddTmCrPl #InterventionName').val('');
        }

    } else {
        var DataItem = this.dataItem(e.item.index());
        refreshSelectedHasCPAValue(DataItem);
        var interventionId = DataItem.InterventionId;
        var interventionName = DataItem.InterventionName;
        var dataStr = { interventionId: interventionId }
        $('#formCrPlAddTmCrPl #InterventionId').val(interventionId);
        $('#formCrPlAddTmCrPl #InterventionName').val(interventionName);
    }
}

function onInterventionDropdownDataBound(e) {
    if ($('#formCrPlAddTmCrPl #hdnTempInterventionId').val() == '') { $('#formCrPlAddTmCrPl #hdnTempInterventionId').val($('#formCrPlAddTmCrPl #InterventionId').val()); }
    $('#formCrPlAddTmCrPl #InterventionId').val('');
    if ($('#formCrPlAddTmCrPl #CarePlanId').val() == '') {
        $('#formCrPlAddTmCrPl #InterventionName').val('');
    }
    else {
        if ($.trim($('#formCrPlAddTmCrPl #InterventionName').val()) == $.trim($('#InterventionIdAuto').val())) {
            $('#formCrPlAddTmCrPl #InterventionId').val($('#formCrPlAddTmCrPl #hdnTempInterventionId').val());
        }
    }
    if (!isScrolledIntoView('#InterventionIdAuto', false)) {
        var popUp = $('#InterventionIdAuto').data("kendoAutoComplete");
        popUp.close();
    }
    else {
        showHideNoDataMessage(this);
        var totalRecCount = $("#InterventionIdAuto").data("kendoAutoComplete").dataSource.total();
        var loadBtnHtml = getPaginationBtnsHtml(totalRecCount);
        if (loadBtnHtml !== '') {
            var loadHtml = '<li tabindex="-1" role="option" unselectable="on" class="k-item">';
            loadHtml += '<div class="loadBtn is_flex">';
            loadHtml += loadBtnHtml + '</div><li>';
            $('#InterventionIdAuto-list #InterventionIdAuto_listbox').append(loadHtml);
            activeInterventionddlId = "#InterventionIdAuto";
        }
    }
}
//kuhg-746 end

//PROD-10965
function onEditProfileCareStaffSearch() {
    return {
        MemberId: memberidval,
        searchText: $('#OpenEditUserForm #AssignedToEditProfile').val()
    }
}

function onEditProfileAssignToDataBound(e) {
    var noItems = this.list.find(".noDataMessage");
    if (!this.dataSource.view()[0]) {
        noItems.show();
        this.popup.open();
    } else {
        noItems.hide();
    }
}

function onEditProfileAssignToDropdownSelect(e) {
    if (e.item == null) {
        if (e.sender._prev == "") {
            $('#OpenEditUserForm #AssignedTo').val('');
        }

    } else {
        var DataItem = this.dataItem(e.item.index());
        var memberId = DataItem.MemberId;
        $('#OpenEditUserForm #AssignedTo').val(memberId);
    }
}

function onEditProfileAssignToChange(e) {
    if (e.sender._prev == "") {
        $('#OpenEditUserForm #AssignedTo').val(null);
    }
}
//PROD-10965

///**** Team Care Plan ADD or EDIT  Scripts End ****///

function CheckProviderLOB() {

    var flag = false;
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/GetProviderLOBConfig",
        data: "",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        async: false,
        success: function (data) {
            if (data.success) {
                flag = data.IsProvider;
            }
        }
    });

    return flag;
}

//Script Related Changes SP
function CheckScriptChanges(scriptidval, patId, patientFollowUpId, formId, isCompletePendingActivity, sfId, servicePlanId, authNo) {

    var pardata = {};
    if (servicePlanId != '0' && servicePlanId != undefined) {
        pardata = { value: scriptidval, patId: patId, servicePlanId: servicePlanId, authNo: authNo };
    }
    else {
        pardata = { value: scriptidval, patId: patId };
    }
    $.ajax({
        url: baseURL + "/Home/CheckScriptMode",
        type: "POST",
        data: pardata,
        success: function (data, textStatus, jqXHR) {
            var datavalue = data.lastRanScriptMode.split('|');
            var scptredval = datavalue[0];//false - For New Script ,true- For pending Script
            var scptcheckval = parseInt(datavalue[1]);//4 - Single Screen,5 - Work Flow,3-Both,6-Form
            var scptlastrunScript = datavalue[2];//1 - For Singele Screen
            var formLastRunStatus = data.lastFormRunMode;
            var hasScriptForm = data.hasScriptForm;
            //Check whether any active script version is available at the time of performing a script activity.
            $.ajax({
                url: baseURL + "/Assessment/ChecKForActiveScriptVersion?ScriptId=" + scriptidval + "&patientId=" + patId,
                type: "GET",
                datatype: "JSON",
                success: function (data) {
                    if (data == "False") {
                        scriptPerformActivityData = undefined;
                        AlertShow('No active script version is available currently. Please contact your administrator.');
                        return false;
                    }
                    else {
                        funActiveScriptVersionFlow(scriptidval, patId, scptredval, scptcheckval, scptlastrunScript, formLastRunStatus, hasScriptForm, patientFollowUpId, formId, isCompletePendingActivity, sfId);
                    }
                },
                error: function () {
                    scriptPerformActivityData = undefined;
                    CustomAlert('Error occurred!');
                }
            });
        },
        error: function (jqXHR, textStatus, errorThrown) {
        }
    });
}

//To change bisibility of runscript link

//PH-ipad safari

function runScriptButtonVisibility(options) {
    var defaults = { visibility: 'block', text: '', object: $('ul.ah-menu.ah-menu-align-right #lnkRunScripts') };
    var newOptions = $.extend({}, defaults, options);
    newOptions.object.css({ display: newOptions.visibility });
    if (newOptions.text != '') {
        if (newOptions.object.innerHTML) {
            newOptions.object.innerHTML = newOptions.text;
        } else {
            newOptions.object.text(newOptions.text);
        }

        //ph-226 localstorage not working in ipad safari, alternate we use cookie
        if (GetCookie("SCRIPT_LINK_TEXT") != null && GetCookie("SCRIPT_LINK_TEXT") != "") {
            deleteCookie("SCRIPT_LINK_TEXT");
        }
        SetCookie("SCRIPT_LINK_TEXT", newOptions.text);

        //if (localStorage.getItem("SCRIPT_LINK_TEXT") != null) {
        //    
        //    localStorage.removeItem("SCRIPT_LINK_TEXT");
        //}
        //localStorage.setItem("SCRIPT_LINK_TEXT", newOptions.text);
    }
}

function GetCookie(name) {
    var result = document.cookie;
    return (result === null) ? null : result;
}

function deleteCalendarAct(module, actIds, isFrom, isExternalActivity, meetingGuid, patientId) {
    var url = "";
    var meetingId = $.fn.setValueOnUndefinedOrNull(meetingGuid, "");
    if (module == 'CM' && isExternalActivity == 'External') {
        url = baseURL + "/ActivityRecord/DeleteExtGeneralActivity?ProviderFollowupId=" + actIds + "&PatientId=" + patientId;
    }
    else {
        url = baseURL + "/Activity/DeletePendingActivites?module=" + module + "&careStaffId=" + getMemberId().MemberId + "&activityIds=" + actIds + "&meetingGuids=" + meetingId;
    }

    var confirmDelete = $('#btnCMDeleteActivity').is(':visible') ? true : (isFrom == "AgAct") ? CustomConfirm("Deleting activity would also delete the associated notes, Do you want to continue?") : CustomConfirm("Are you sure you want to delete this activity?");
    if (confirmDelete) {
        loader(1);
        $.ajax({
            type: "POST",
            url: url, //baseURL + "/Home/DeletePendingActivites?module=" + module + "&activityIds=" + actIds + ",",
            dataType: "json",
            success: function (data) {
                if (data.success) {
                    switch (isFrom) {
                        case "Calendar":
                            RefreshCalendarOnDelete();
                            break;
                        case "UmAct":
                            AuthActivity_Get(false);
                            break;
                        case "AgAct":
                            complaintActionDetailsGet(true);
                            break;
                        case "AgActDet":
                            ActionDetails_Get(true);
                            break;
                    }
                    $('#btnCMRecurringActivityCancel').trigger('click');
                    if (isFrom != "AgActDet" && isFrom != "AgAct")
                        CustomAlert('Activity deleted successfully.');
                    loader(0);
                } else { CustomAlert('error occurred while deleting record.'); loader(0); }
            },
            error: function () { CustomAlert("Error Encountered"); loader(0); }
        });
    }
}

function RefreshCalendarOnDelete() {
    var isScheduleVisibleDel = $('#popUpGlobalMySchedule').is(':visible');
    if (isScheduleVisibleDel) {
        var currentView = $('#popUpGlobalMySchedule').find("#scheduler").data("kendoScheduler").view().title;
        if (currentView == "Week") {
            $("#popUpGlobalMySchedule").find("#closePopUp").trigger('click');
            loadGlobalMySchedule();
        }
        else {
            $("#scheduler").data("kendoScheduler").dataSource.read();
        }
    }
    if (!isScheduleVisibleDel && $("#_myCalendarPartialViewContainer,#CalendarViewDiv").is(":visible")) {//PROD-1103 
        $("#_myCalendarPartialViewContainer,#CalendarViewDiv").load(baseURL + "/Dashboard/MyCalendar/", function () {
            onLoadMyCalendar();
        });
    }
}

function FormatMemberDetails(MemberData, CompletedOnDate, LogoImage, DownloadedOnDate, CreatedOn, ScriptStatus, memberDOB) {
    var sb = ""; var memberIdentifierLabel = ""; var memberIdentifierValue = "";
    if (MemberData.length > 0) {
        IS_12HRS_FORMAT = MemberData[0].IsAmpmFormat;
        var VarScriptScore = MemberData[0].TotalScriptScore == null ? 0 : MemberData[0].TotalScriptScore;
        var VarScriptScoreReceived = MemberData[0].ScriptScoreReceived == null ? 0 : MemberData[0].ScriptScoreReceived;
        if (VarScriptScore == 0) { VarScriptScoreReceived = 0; }

        var VarMemberDOB = memberDOB;

        if (MemberData[0].MemberIdentifierLabel === null && (MemberData[0].MemberIdentifierValue === null || MemberData[0].MemberIdentifierValue === "N/A")) {
            memberIdentifierLabel = $("#hdnSessionAltruistaLabel").val() === undefined ? GetHtmlDecode(GetHtmlDecode(altruistaIDLabelValue)) : $("#hdnSessionAltruistaLabel").val();
            memberIdentifierValue = MemberData[0].AltruistaId;
        }
        else {
            memberIdentifierLabel = MemberData[0].MemberIdentifierLabel;
            memberIdentifierValue = $.fn.isNullOrEmpty(MemberData[0].MemberIdentifierValue) ? "N/A" : MemberData[0].MemberIdentifierValue;

        }
        sb += '<table width="700px" border="0" cellspacing="0" cellpadding="3">';
        if (LogoImage != "")
            sb += '<thead><tr><td><img src="' + LogoImage + '" width="338" height="142"></td></tr></thead>';
        sb += '<tr><td align="center"><h3>' + MemberData[0].ScriptName + '</h3></td></tr>';
        sb += '<tr><td>';
        sb += '<table width="100%" border="0" cellspacing="0" cellpadding="0">';
        sb += '<tr><td width="60%">Total  Questions:' + MemberData[0].TotalQuestions + '</td><td>Total  Script Score:' + VarScriptScore + ' </td></tr>';
        sb += '<tr><td>Total  Responses: ' + MemberData[0].TotalResponse + '</td><td>Total  Score Received: ' + VarScriptScoreReceived + '</td></tr>';
        sb += '<tr><td width="60%">Completed By: ' + (MemberData[0].CompletedByName !== null && MemberData[0].CompletedByName !== "" ? MemberData[0].CompletedByName : "N/A") + '</td><td>Created On: ' + (CreatedOn !== null && CreatedOn !== "" ? $.fn.apply12To24hrFormat(CreatedOn) : "N/A") + ' </td></tr>';
        sb += '<tr><td width="60%">Script Status: ' + (ScriptStatus !== null && ScriptStatus !== "" ? ScriptStatus : "N/A") + '</td><td>Completed On: ' + (CompletedOnDate !== null && CompletedOnDate !== "" ? $.fn.apply12To24hrFormat(CompletedOnDate) : "N/A") + ' </td></tr>';
        if (typeof MemberData[0].Eligibility === 'undefined')
            sb += '<tr><td width="60%">Eligibility: ' + (MemberData[0].DataRootPath != null && MemberData[0].DataRootPath != "" ? MemberData[0].DataRootPath : "N/A") + '</td><td>Program Name: ' + (MemberData[0].ProgramName != null && MemberData[0].ProgramName != "" ? MemberData[0].ProgramName : "N/A") + ' </td></tr>';
        //uhg-3093
        if (MemberData[0].DownloadedByName != null && MemberData[0].DownloadedByName != "")
            sb += '<tr><td width="60%">Downloaded By: ' + MemberData[0].DownloadedByName + '</td><td>Downloaded On: ' + DownloadedOnDate + ' </td></tr>';
        //
        if (MemberData[0].IsQmActivity !== undefined && MemberData[0].IsQmActivity !== null && MemberData[0].IsQmActivity) {
            sb += '<tr><td width="60%">Quality Measure: ' + ((MemberData[0].QualityMeasureName !== null && MemberData[0].QualityMeasureName !== "") ? MemberData[0].QualityMeasureName : "N/A") + '</td><td>Quality Measure Status: ' + ((MemberData[0].QualityMeasureStatus !== null && MemberData[0].QualityMeasureStatus !== "") ? MemberData[0].QualityMeasureStatus : "N/A") + ' </td></tr>';
            if (MemberData[0].IdentifiedDate !== undefined && MemberData[0].IdentifiedDate !== null && MemberData[0].IdentifiedDate) {
                sb += '<tr><td width="60%">Identified Date: ' + ((MemberData[0].IdentifiedDate !== null && MemberData[0].IdentifiedDate !== "") ? new Date(MemberData[0].IdentifiedDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : "N/A") + ' </td></tr>';
            }
        }
        sb += '</table>';
        sb += '</td></tr>';
        sb += '<tr><td>&nbsp;</td></tr>';
        sb += '<tr><td style="border:1px solid #000; padding:5px;">';
        sb += '<table width="100%" border="0" cellspacing="0" cellpadding="3" style="border:1px solid #000;">';
        //sb += '<tr><td width="60%">Member  ID:' + MemberData[0].MemberId + ' </td><td>Community  Care ID:  ' + MemberData[0].AltruistaId + '</td></tr>';

        //sb += '<tr><td>Altruista ID:  ' + MemberData[0].AltruistaId + '</td><td>Member  Name: ' + MemberData[0].MemberName + '</td></tr>';
        sb += '<tr><td> ' + memberIdentifierLabel + ' : ' + memberIdentifierValue + '</td><td>Member  Name: ' + MemberData[0].MemberName + '</td></tr>';
        //sb += '<tr><td>Member  Name: ' + MemberData[0].MemberName + '</td><td>Member  DOB: ' + VarMemberDOB + '</td></tr>';
        //sb += '<tr><td>Altruista ID:  ' + MemberData[0].AltruistaId + '</td><td>Member  Name: ' + MemberData[0].MemberName + '</td></tr>';
        sb += '<tr><td colspan="2">Member  DOB: ' + VarMemberDOB + '</td></tr>';

        //var lblMemberDobVal = $('#ViewScriptActivitySummaryForm #lblMemberDOB').html();
        //var mebDob = (lblMemberDobVal == "" || lblMemberDobVal == undefined) ? VarMemberDOB : lblMemberDobVal;//KUHG-759
        //sb += '<tr><td>Member  DOB: ' + mebDob + '</td></tr>';

        sb += '</table>';
        sb += '</td></tr>';
        sb += '<tr><td>&nbsp;</td></tr>';
        sb += '</table>';
        sb += '<table width="700px" border="0" cellspacing="0" cellpadding="3">';
        sb += '<tr><td>{DynamicResponse Content}</td></tr>';
        sb += '</table>';
    }
    return sb;
}
function FormatScriptResponse(ScriptResponse, isExport = false) {
    var sb = "";
    if (ScriptResponse.length === 0) {
        return sb;
    }
    $.each(ScriptResponse, function (IndexM, DataItem) {
        var questText = '', MainAnswer = 'N/A', SubQuest = '', SubAnswer = '', Notes = '', RowNo = '';
        questText = DataItem.Question;
        Notes = DataItem.CareNotes;
        RowNo = DataItem.RowNo;
        sb += '<div style="max-width:700px; word-break: break-word;-ms-word-break: break-all;-ms-hyphens: auto;-moz-hyphens: auto;-webkit-hyphens: auto;hyphens: auto;white-space: pre-wrap;" >' + RowNo + '. ' + questText + '</br>Response :</br>';
        if (DataItem.Status) {
            var optionList = '';
            optionList = DataItem.ScptQuestionResponse != null ? DataItem.ScptQuestionResponse.split('|') : "";//kuhg-1290 fix
            if (optionList !== "") {
                $.each(optionList, function (IndexI, optionItem) {
                    sb += '<div style="width:100%;word-break:break-word;-ms-word-break:break-all;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;white-space:pre-wrap;">';
                    MainAnswer = optionItem;
                    if (optionItem.indexOf("Ñ") >= 0) {
                        var subOptList = optionItem.split('Ñ');
                        $.each(subOptList, function (IndexJ, subOptItem) {
                            if (IndexJ == 0) { MainAnswer = subOptItem; }
                            if (IndexJ == 1) {
                                if (subOptItem.split('~').length == 2) {
                                    SubQuest = subOptItem.split('~')[0];
                                    SubAnswer = subOptItem.split('~')[1];
                                }
                                else {
                                    SubQuest = subOptItem.split('~')[0];
                                    var subOptionval = subOptItem.split('~').splice(1);
                                    SubAnswer = subOptionval.join('~');
                                }
                            }
                        });
                    }
                    if (optionItem.indexOf("‡‡") >= 0) {
                        var subOptList = optionItem.split('‡‡');
                        $.each(subOptList, function (IndexJ, subOptItem) {
                            if (IndexJ == 0) { MainAnswer = subOptItem; }
                        });
                    }
                    sb += '<div style="width:100%; margin-bottom:10px; margin-left:30px;word-break:break-word;-ms-word-break:break-all;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;white-space:pre-wrap;">';
                    if (MainAnswer.indexOf("data:image") >= 0) {
                        sb += '<img style="height:50px;width:100px;" src=' + MainAnswer + '></img>';
                    }
                    else {
                        if (MainAnswer.indexOf("<table") >= 0 && MainAnswer.indexOf("clsTablePlaceholder") >= 0) {
                            sb += "<div class='div_diagsum'>" + MainAnswer.replace("border='0'", "border='1'").replace("clsTablePlaceholder", "clsTablePlaceholder' style='border: 1px solid #ccc!important;") + "</div>";
                        }
                        else if (MainAnswer.indexOf("<table") >= 0 && MainAnswer.indexOf("tblGrid") >= 0) {
                            sb += "<div class='div_diagsum'>" + MainAnswer.replace("border='0'", "border='1'").replace("tblGrid", "tblGrid' style='border: 1px solid #ccc!important;").replace("<tr>", "<tr style='background-color:darkgrey;font-weight:bold;'>") + "</div>";
                        }
                        else {
                            var modMainAnswer = MainAnswer.replace("border='0'", "border='1'").replace(/\[:Ä:]/g, '%').replace(/\n/g, '<br>') + ' ';
                            if (isExport) {
                                modMainAnswer = scriptResponseNewLines(modMainAnswer);
                            }
                            sb += "<b>" + modMainAnswer + "</b><br/>";
                        }
                    }
                    if (SubQuest != "" && SubAnswer != "") {
                        //UHC - 3063
                        if (SubAnswer.indexOf("data:image") >= 0)
                            sb += SubQuest + ': ' + '<img style="height:50px;width:100px;" src=' + SubAnswer + '></img>';
                        //UHC - 3063
                        else {
                            sb += SubQuest + ': ';
                            var modSubAnswer = SubAnswer.replace(/\[:Ä:]/g, '%').replace(/\n/g, '<br>') + ' ';
                            if (isExport) {
                                modSubAnswer = scriptResponseNewLines(modSubAnswer);
                            }
                            sb += "<br/><span style='padding-right:20px;'></span>" + modSubAnswer;
                        }
                    }
                    else if (SubQuest != "" && SubAnswer == "") {
                        sb += "<span style='padding-left:20px;'></span>" + SubQuest;
                    }
                    SubQuest = ""; SubAnswer = "";
                    if (optionItem.indexOf("‡‡") >= 0) {
                        var subOptList = optionItem.split('‡‡');
                        $.each(subOptList, function (IndexJ, subOptItem) {
                            if (IndexJ !== 1) {
                                return;
                            }
                            sb += "<div class=\"srpt-tile-container\">";
                            var dynRows = subOptItem.split('‡');
                            var Col = dynRows[0].split('±');
                            for (var count = 0; count < dynRows.length; count++) {
                                sb += "<table style=\"width:100%; border: 1px solid #cccccc;border-radius: 4px;margin-bottom:10px\">";
                                var itemVal = dynRows[count];
                                var items = itemVal.split('±');
                                var totalCols = Col.length;
                                for (var icountR = 0; icountR < totalCols; icountR += 3) {
                                    sb += "<tr>";
                                    for (var j = 0; j < 3; j++) {
                                        var idx = icountR + j;
                                        sb += scriptDataResponse(idx, totalCols, Col, items);
                                    }
                                    sb += "</tr>";
                                }
                                sb += "</table>";
                            }
                            sb += "</div>";
                        });
                    }
                    Notes = $.trim(Notes).replace(/&#10;/g, '<br>');
                    sb += "</div>";
                    sb += "</div>";
                });
            }
            if (Notes != "") {
                Notes = scriptResponseNewLines(Notes);
                sb += 'Notes :' + Notes;
                sb += '</br>';
            }
        }
        else { sb += MainAnswer; }
        sb += '</div> </br>';
    });
    return sb;
}
function scriptDataResponse(idx, totalCols, Col, items) {
    var sb = "";
    if (idx >= totalCols) {
        sb += "<td style='page-break-inside: avoid; width:33%'></td>";
        return sb;
    }
    var Colitem = Col[idx];
    sb += "<td style='page-break-inside: avoid; padding:5px; vertical-align:top; width:33%'>";
    if (Colitem !== "" && Colitem !== undefined) {
        sb += "<label style=\'font-weight:bold;'\>" + Colitem.split('†')[0] + "</label><br/>";
        var item = items[idx];
        if (item !== "" && item !== undefined) {
            var value = decodeURIComponent(item.split('†')[1]);
            value = value.replace(/€¶¦validate€¶¦/g, "1SI")
                .replace(/1Üî/g, "1Si")
                .replace(/1Ûï/g, "1sI")
                .replace(/1Ûî/g, "1si")
                .replace(/\[:Ä:]/g, '%');
            //UHC - 3063
            if (value.indexOf("data:image") >= 0) {
                value = "<img style=\"width:60px;\" src='" + value + "'/>";
            } else {
                value = value.replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;")
                    .replace(/\[:Ü:]/g, '|')
                    .replace(/\n/g, '<br>');

                if (value !== null && value !== "") {
                    value = scriptResponseNewLines(value);
                } else {
                    value = "N/A";
                }
            }
            sb += "<div class=\"srpt-field-data\" style=\"page-break-inside:avoid;display:block\">" + value + "</div>";
        } else {
            sb += "<div class=\"srpt-field-data\">N/A</div>";
        }
    }
    sb += "</td>";
    return sb;
}
function replaceAll(find, replace, str) {
    while (str.indexOf(find) > -1) {
        str = str.replace(find, replace);
    }
    return str;
}

function ToolTipsForActionsInPH(val) {
    $(document).off('mouseover', '.Not_Addressed').on('mouseover', '.Not_Addressed', function () {
        $(this).prop('title', 'Not Addressed')
    });
    $(document).off('mouseover', '.In_Progress ').on('mouseover', '.In_Progress ', function () {
        if (val == 0)
            $(this).prop('title', 'In Progress ')
        else
            $(this).prop('title', 'Care Transition In-Progress')
    });
    $(document).off('mouseover', '.Is_Compliant').on('mouseover', '.Is_Compliant', function () {
        $(this).prop('title', 'Is Compliant ')
    });
    $(document).off('mouseover', '.Complete  ').on('mouseover', '.Complete  ', function () {
        $(this).prop('title', 'Completed ')
    });
    $(document).off('mouseover', '.Completed').on('mouseover', '.Completed', function () {
        $(this).prop('title', 'Completed ')
    });
    $(document).off('mouseover', '.NotApplicable  ').on('mouseover', '.NotApplicable  ', function () {
        $(this).prop('title', 'Not Applicable ')
    });
    $(document).off('mouseover', '.Resolved').on('mouseover', '.Resolved', function () {
        $(this).prop('title', 'Resolved')
    });
    $(document).off('mouseover', '.Closed ').on('mouseover', '.Closed ', function () {
        $(this).prop('title', 'Closed')
    });
}

function PHRunScriptPopUpCloseFun() {
    $('#imgbtnHome').trigger('click');
    var ddlValue = $('#dBPanelArea #ddlPHIPNotifications').val();
    if (ddlValue == "ADT")
        $("#ADTrackingGrid").data("kendoGrid").dataSource.page(1);
    else
        $("#PHIPNotificationsGrid").data("kendoGrid").dataSource.page(1);
}
//-------------------------------------------------- END

function disableControl(obj) {
    obj.prop('disabled', true);
}
// Added for quicklinks ................... START..
function HealthVisitsFunt() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#divView').html('');
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + '/Health/MedicalVisitProfile/',
        onLoad: function () {
            loader(0);
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
        },
        popUpHeader: "Visits",
        popLevel: 0,
        closeButton: "#btnVisitClose"
    });
}

function TeamCarePlanFunt() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#TeamCarePlanParentDiv').html('');
    $('#popUpDialog1').css("width", "96%");
    $('#popUpDialog1').css("left", "2%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + '/CarePlan/TeamCarePlan/',
        onLoad: function () {
            loader(0);
            $('#teamCarePlanModalButtons').show();
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#teamCarePlanModalButtons').hide();
        },
        popUpHeader: "Team Care Plan",
        popLevel: 0,
        closeButton: "#btnTeamCarePlanClose"
    });
}
function ScriptActivityQuickLink() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#activitySummaryDiv').html('');
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + '/ActivityRecord/ActivitySummary/',
        onLoad: function () {
            $('#popUpDialog1').css("margin-left", "-10px");
            $('#popUpDialog1').css("width", "96%");
            $('#popUpDialog1').css("left", "2%");
            $('#popUpDialog1').css("right", "2%");
            loader(0);
            //$('#popUpDialog1').css("margin-left", "-50px");

            //PROD-42770 script activity not displaying            
            $('#divScriptSummary').attr('style', 'padding: 10px;');

            $('#btnShow,#btnShowAll,#actSummarySetAsDefaultDiv').hide();
            //$('#scriptSummaryGrid').attr('style', 'height:275px;');        

            $("#scriptSummaryGrid").data("kendoGrid").dataSource.read();
            $("#scriptSummaryGrid").attr('style', 'width: 100%; margin-bottom: 10px;');
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').html('');
            $('#lean_overlay_level_1').remove();
            // $('#popUpDialog1').css("margin-left", "0");
        },
        popUpHeader: "Script Activity",
        popLevel: 0
    });
}
function diagnosisQuickLink(module) {
    loader(1);
    $('#divContentMemSession').html('');
    $('#DiagnosisDivId').html('');
    $('#popUpDialog1').css("width", "90%");
    var PI;
    if (module === 'UM') {//on page refresh patient id is passing as 0 reassigning value of patientid
        PI = UmPatient_AuthInfo("", "");
        if (PI.PatientId > 0) {
            $('#selectPatientAccessed').val(PI.PatientId);
        }
    }
    else if (module === 'AG') {
        PI = AgData.complaintInfo();
        if (PI.patientId > 0) {
            $('#selectPatientAccessed').val(PI.patientId);
        }
    }
    else {
        //code will use for other module than UM and AG
    }
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + '/Health/Diagnosis/?module=' + module,
        onLoad: function () {
            $('#DiagnosisDivId').attr('style', 'overflow-y:scroll;max-height:500px; padding:10px;');
            loader(0);
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Diagnosis",
        popLevel: 0,
        closeButton: "#btnHeaDiaCloseDiaCode"
    });
}

function HealthIndicatorsQuickLink(module) {
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + '/Health/HealthIndicators/?module=' + module,
        onLoad: function () {
            loader(0);
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Health Indicators",
        popLevel: 0,
        closeButton: "#btnHeaDiaCloseDiaCode"
    });
};

function AdvanceDirectivesQuickLink() {
    loader(1);
    var isFromUM = $(".InAuthPage").is(":visible");
    var isFromAG = $(".InComplaintPage").is(":visible");
    $('#divContentMemSession').html('');
    $('#popUpDialog6').css("width", "90%");
    $('#popUpDialog6').CMNPopup({
        pvUrl: baseURL + '/CarePlan/AdvanceDirectives/' + "?isFromUM=" + isFromUM + "&isFromAG=" + isFromAG,
        onLoad: function () {
            $('#hdnIsFrmQuickLinks').val('1');
            loader(0);
            insertOverLay('popUpDialog6');
            applyFocusTrap('#popUpDialog6');
        },
        onClose: function () {
            $('#popUpDialog6').css("width", "");
            $('#lean_overlay_level_1').remove();
            $('#hdnIsFrmQuickLinks').val('');
        },
        popUpHeader: "Advance Directives",
        popLevel: 0
    });
};

function AppointmentsQuickLink() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog6').css("width", "90%");
    $('#popUpDialog6').CMNPopup({
        pvUrl: baseURL + '/Health/GetAppointmentGird/',
        onLoad: function () {
            $('#hdnIsFrmQuickLinks').val('1');
            loader(0);
            insertOverLay('popUpDialog6');
        },
        onClose: function () {
            $('#popUpDialog6').css("width", "");
            $('#lean_overlay_level_1').remove();
            $('#hdnIsFrmQuickLinks').val('');
        },
        popUpHeader: "Appointments",
        popLevel: 0
    });
};

function MemberDetailsQuickLink() {
    $('#hdnIsFrmQuickLinks').val('1');
    loader(1);
    if (!isQuickLinkPopup) {
        $('#divContentMemSession').html('');
    }
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/MemberDetails?patientId=" + $('#selectPatientAccessed').val() + "&careStaffId=" + getMemberId().MemberId,
        onLoad: function () {
            loader(0);
            insertOverLay('popUpDialog1');
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Member Details",
        popLevel: 0,
        closeButton: "#memberDetailBtnClose"
    });
};

function ProgramsQuickLink() {
    loader(1);
    isactivestatus = 1;
    $('#hdnIsFrmQuickLinks').val('1');
    $('#divContentMemSession').html('');
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/MemberPrograms/MemberPrograms",
        onLoad: function () {
            loader(0);
            insertOverLay('popUpDialog1');
            $('#programsModalButtons').show();
            $('#programsTabPanel').addClass('ah-modal-content no-blue-background');
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#programsTabPanel').removeClass('ah-modal-content no-blue-background');
            $('#lean_overlay_level_1').remove();
            $('#programsModalButtons').hide();
        },
        popUpHeader: "Programs",
        popLevel: 0,
        closeButton: "#programsBtnClose"
    });
};

function HealthNotesQuickLink(module) {
    loader(1);
    let myTriggerBtnId = 'lbtnCareNotes';
    if (module === "UM") {
        myTriggerBtnId = 'umQuickLinksMenuBtn';
    }
    $('#divContentMemSession').html('');
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/ActivityRecord/HealthNotes",
        onLoad: function () {
            loader(0);
            if (module === "UM") {
                var PI = UmPatient_AuthInfo("", "");
                if (PI.PatientId > 0) {
                    $('#selectPatientAccessed').val(PI.PatientId);
                }
                $('#tblHealthNotes').css("width", "100%");
                $('#healthNotesTabPanel').addClass('ah-modal-content no-blue-background').removeClass('ah-tabpanel is-visible').removeAttr('role aria-labelledby');
                $('#healthNotesModalButtons').show();
            }
            insertOverLay('popUpDialog1');
            A11yModal.recalculateTabStops('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Health Notes",
        popLevel: 0,
        closeButton: "#healthNotesBtnClose",
        triggerBtnId: myTriggerBtnId,
        modalWidth: MODAL_WIDTH.LARGE
    });
};

function CareOpportunitiesQuickLink() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CarePlan/GuidingOpportunities/",
        onLoad: function () {
            loader(0);
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Care Opportunity",
        popLevel: 0,
        closeButton: "#btnHeaDiaCloseDiaCode"
    });
};

function CareTeamQuickLink() {
    $('#hdnIsFrmQuickLinks').val('1');
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog1').css("width", "90%").css("height", "500px");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CareTeam/CareTeam/",
        onLoad: function () {
            $('#careTeamGrid').attr('style', 'width:1195px !important; padding: 10px;');
            loader(0);
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#hdnIsFrmQuickLinks').val('');
            $('#popUpDialog1').css("width", "").css("height", "");
            $('#popUpDialog1').html('');
            $('#lean_overlay_level_1').remove();
        },
        popUpHeader: "Care Team",
        popLevel: 0,
        closeButton: "#careTeamBtnClose"
    });
};

function CareGiversQuickLink() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/CareGiver/CareGivers/",
        onLoad: function () {
            loader(0);
        },
        onClose: function () {
            $('#popUpDialog1').css("width", "");
        },
        popUpHeader: "Caregivers",
        popLevel: 0,
        closeButton: "#careGiversBtnCloseScripts"
    });
};

function DocumentsQuickLink() {
    loader(1);
    var isFromUM = $(".InAuthPage").is(":visible");
    var isFromAG = $(".InComplaintPage").is(":visible");
    $('#divContentMemSession').html('');
    $('#popUpDialog6').css("width", "90%");
    $('#popUpDialog6').CMNPopup({
        pvUrl: baseURL + '/ActivityRecord/ElectronicDocuments/' + "?isFromUM=" + isFromUM + "&isFromAG=" + isFromAG,
        onLoad: function () {
            $('#hdnIsFrmQuickLinks').val('1');
            loader(0);
            insertOverLay('popUpDialog6');
        },
        onClose: function () {
            $('#popUpDialog6').css("width", "");
            $('#lean_overlay_level_1').remove();
            $('#hdnIsFrmQuickLinks').val('');
        },
        popUpHeader: "Documents",
        popLevel: 0
    });
};

function ReferMemberQuicklink() {
    $('#divAction').find('#ReferMemberId').trigger('click');
}
function btnEditPerfTimeCallDetailsClick(_isfromQuickUpdate) {
    $('#popUpDialog6').css("width", "90%");
    $('#popUpDialog6').CMNPopup({
        pvUrl: baseURL + "/Home/PreferredTimeToCall?patientId=" + $('#selectPatientAccessed').val() + "&sectionName=QUICK_UPDATES",
        popUpHeader: "Preferred Time to Call",
        popLevel: 0,
        onLoad: function () {
            A11yModal.trapFocusInModal('popUpDialog6');
            if (enableDomLogs) {
                DomUtils.logDomData('Member Info >> Member Details >> Preferred Time Of Call');
            }
        }
    });
}
function ConsentFormsQuickLink() {
    $('#popUpDialog1').css("width", "90%");
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/ActivityRecord/PatientConsenetForm/",
        popUpHeader: "Consent Forms",
        popLevel: 0,
        onLoad: function () {
            $('#divAddConsentForm').attr('style', 'overflow-y:auto; padding: 10px; max-height:400px;display:none;');
            $(".hdnConsentFormQuickLinks").val(1);
            $("#viewConsentFormHistory").css('width', "950px");
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#divAddConsentForm').removeAttr('style').css('display', 'block');
            $('#popUpDialog1').css("width", "");
            $("#viewConsentFormHistory").removeAttr('style');
            $('#popUpDialog1').html('');
            $('#lean_overlay_level_1').remove();
        }
    });
}

function BMICalculatorQuickLink() {
    loader(1);
    $('#divContentMemSession').html('');
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/QuickUpdates/Bmi/",
        onLoad: function () {
            loader(0);
        },
        popUpHeader: "BMI Calculator",
        popLevel: 0
    });
};
// Added for quicklinks ................... END..

//medication quick link
function ReferMedications() {
    var viewURL = "/Health/MedicationDetails";
    if (viewUnifiedMedications) {
        viewURL = "/UnifiedMedication/UnifiedMedicationDetails";
    }
    $('#popUpDialog1').CMNPopupUM({
        pvUrl: baseURL + viewURL,
        popUpHeader: "Medications",
        popLevel: 0,
        onLoad: function () {
            $('#hdnUMQuickLink').val("1");
            $('#popUpDialog1').css({ "width": "90%", "margin-left": "", "left": "68.5px" });
            $('#MedicationParentDivId').attr('style', 'overflow-y: auto; padding: 10px; max-height:500px;');
            //$('#btnALLFID').attr('style', 'margin-left: 370px;');
            insertOverLay('popUpDialog1');
        },
        onClose: function () {
            $('#MedicationParentDivId').removeAttr('style');
            $('#popUpDialog1').css("width", "");
            $('#btnALLFID').css("margin-left", "");
            $('#popUpDialog1').html('');
            $('#hdnUMQuickLink').val("");
            $('#lean_overlay_level_1').remove();
        }
    });

};

//Search Functionality in MyMembers section in CP .....START.
//$('#selectMymbembersteam option').filter(function () {
//    if (buildctrl == "Index") {
//        $("#selectMymbembersteam").val(1);
//        return parseInt(this.value, 10) == 0;
//    }
//    else {
//        $("#selectMymbembersteam").val(2);
//        return parseInt(this.value, 10) == 1;
//    }
//}).remove();


function isValidDate(value) {
    var userFormat = 'mm/dd/yyyy';
    var delimiter = /[^mdy]/.exec(userFormat)[0];
    var theFormat = userFormat.split(delimiter);
    var theDate = value.split(delimiter);
    var isDate = function (date, format) {
        var m, d, y
        for (var i = 0, len = format.length; i < len; i++) {
            if (/m/.test(format[i])) m = date[i]
            if (/d/.test(format[i])) d = date[i]
            if (/y/.test(format[i])) y = date[i]
        }
        return (
            m > 0 && m < 13 && m.length <= 2 &&
            y && y.length === 4 &&
            d > 0 && d <= (new Date(y, m, 0)).getDate() && d.length <= 2
        )
    }

    return isDate(theDate, theFormat)
}

function doReplaceSingleQuote(objName) {
    if (objName != null && objName != 'null')
        return objName.replace(/'/g, "&#39;");
}

//Search Functionality in MyMembers section in CP .....END.

function ReplaceSpecialChars(objName) {
    return replaceAll1("<", "&#60", objName);
}

function replaceAll1(find, replace, str) {
    return str.replace(new RegExp(find, 'g'), replace);
}

function ServiceplanPrintfunct(List, dateOfPrint, imagePath) {
    var htm = "";
    htm += PatientDetailsHtml(List, false);

    htm += '<table border="1" id="SPDetails" cellpadding="0" cellspacing="0" width="98%" style="margin: 5px;font-family: Times !important;" class="DBGrid">';
    htm += '<tr><td colspan="12" style="width: 98%; background-color: #333; height: 20px; text-transform: uppercase; padding: 2px 2px 2px 2px; vertical-align: middle;">' +
        '<span style="vertical-align: top; font-size: 14px; font-weight: bold; color: White;">&nbsp;&nbsp; Service Plan </span>' +
        '</td></tr>';
    htm += '<tr style="font-weight:bold;text-align:center"><td>Service Description</td><td>From Date</td><td>To Date</td><td>Provider</td><td>Req. Units</td><td>App. Units</td><td>Unit Type</td><td>Frequency</td><td>Total Cost</td><td>Status</td><td>Decision Date</td></tr>';
    if (List[0].ServiceId != null) {
        $.each(List, function (key, item) {
            var VarFromDate = item.FromDate;
            if (VarFromDate != null) {
                if (VarFromDate.indexOf('/Date(') > -1) {
                    var s = VarFromDate.replace('/Date(', '').replace(')/', '');
                    var expDate = new Date(parseInt(s));
                    var date = new Date(Date.parse(expDate));
                    VarFromDate = formatDateWithoutTime(date);
                }
                else {
                    VarFromDate = formatDateWithoutTime(new Date(VarFromDate));
                }
            }
            else {
                VarFromDate = "N/A";
            }
            var VarToDate = item.ToDate;
            if (VarToDate != null) {
                if (VarToDate.indexOf('/Date(') > -1) {
                    var s = VarToDate.replace('/Date(', '').replace(')/', '');
                    var expDate = new Date(parseInt(s));
                    var date = new Date(Date.parse(expDate));
                    VarToDate = formatDateWithoutTime(date);

                } else {
                    VarToDate = formatDateWithoutTime(new Date(VarToDate));
                }
            }
            else {
                VarToDate = "N/A";
            }
            var VarApprovedDate = item.ApprovedDate;
            if (VarApprovedDate != null) {
                if (VarApprovedDate.indexOf('/Date(') > -1) {
                    var s = VarApprovedDate.replace('/Date(', '').replace(')/', '');
                    var expDate = new Date(parseInt(s));
                    var date = new Date(Date.parse(expDate));
                    VarApprovedDate = formatDateWithoutTime(date);
                } else {
                    VarApprovedDate = formatDateWithoutTime(new Date(VarApprovedDate));
                }
            }
            else {
                VarApprovedDate = "N/A";
            }
            htm += '<tr align="center">';
            htm += '<td style="width:9%">' + (item.Description != null && item.Description !== "" ? $.fn.replaceAndEscapeHtmlExt(item.Description) : "N/A") + '</td>';
            //htm += '<td style="width:15%">' + (item.Code != null && item.Code != "" ? item.Code : "N/A") + '</td>';
            htm += '<td style="width:9%">' + VarFromDate + '</td>';
            htm += '<td style="width:9%">' + VarToDate + '</td>';
            htm += '<td style="width:10%">' + (item.Provider != null && item.Provider !== "" ? $.fn.replaceAndEscapeHtmlExt(item.Provider) : "N/A") + '</td>';
            //htm += '<td style="width:10%">' + (item.Lob != null && item.Lob != "" ? item.Lob : "N/A") + '</td>';
            htm += '<td style="width:9%">' + (item.RequestedUnits != null && item.RequestedUnits !== "" ? item.RequestedUnits : "N/A") + '</td>';
            htm += '<td style="width:9%">' + (item.ApprovedUnits != null && item.ApprovedUnits !== "" ? item.ApprovedUnits : "N/A") + '</td>';

            htm += '<td style="width:9%">' + (item.UnitType != null && item.UnitType !== "" ? $.fn.replaceAndEscapeHtmlExt(item.UnitType) : "N/A") + '</td>';
            htm += '<td style="width:9%">' + (item.Frequency != null && item.Frequency !== "" ? $.fn.replaceAndEscapeHtmlExt(item.Frequency) : "N/A") + '</td>';
            htm += '<td style="width:9%">' + (item.TotalUnitCost != null && item.TotalUnitCost !== "" ? item.TotalUnitCost.toFixed(2) : "N/A") + '</td>';
            htm += '<td style="width:9%">' + (item.Status != null && item.Status !== "" ? $.fn.replaceAndEscapeHtmlExt(item.Status) : "N/A") + '</td>';
            htm += '<td style="width:9%">' + VarApprovedDate + '</td>';
            htm += '</tr>';
        });
    }
    else {
        htm += '<tr align="center"><td  colspan="12">';
        htm += 'No Records Found';
        htm += '</td></tr>';
    }
    htm += '</table>';

    htm += '<table width="98%"><tr ><td style="width:10%;height:50px;align:left;"><img id="imgSignServicePlanCS" src="" width="100px" height="50px" alt="" /></td><td style="text-align:right;width:10%;height:50px;align:right;"><img id="imgSignServicePlan" src="" width="100px" height="50px" alt="" /></td></tr>';
    htm += '<tr><td style="font-weight:bold;cursor:pointer;align:left;"><a style="color:black;" id="btnSignServicePlanCS">' + $.fn.replaceAndEscapeHtmlExt(UserFirstName) + ' ' + $.fn.replaceAndEscapeHtmlExt(UserLastName) + '</a></td><td style="text-align:right;font-weight:bold;cursor:pointer;align:right;"><a style="color:black;" id="btnSignServicePlan">Member Signature</a></td></tr>';
    if (dateOfPrint != null) {
        if (dateOfPrint.indexOf('/Date') > -1) {
            var s = dateOfPrint.replace('/Date(', '').replace(')/', '');
            var expDate = new Date(parseInt(s));
            var date = new Date(Date.parse(expDate));
            dateOfPrint = formatDateWithoutTime(date);
        } else {
            dateOfPrint = formatDateWithoutTime(new Date(dateOfPrint));
        }
        htm += '<tr><td style="font-weight:bold;cursor:pointer;align:left;">Date: ' + dateOfPrint + '</td><td style="text-align:right;font-weight:bold;cursor:pointer;align:right;">Date: ' + dateOfPrint + '</td></tr>';
    }
    htm += '</table>';
    return htm;
}

function PatientDetailsHtml(List, BudgetStartEndDateVisible) {
    var htm = "";
    if (BudgetStartEndDateVisible != true) {
        htm += '<span style="margin: 5px;font-family: Times !important;" ><h2 align="center">Service Plan</h2></span>';
    }
    htm += '<table border="0" id="SPPatientDetails" cellpadding="5" cellspacing="0" width="98%" style="margin: 5px;font-family: Times !important;font-size:12px;" class="">';
    htm += '<tr><td colspan="4" style="width: 98%; background-color: #333; height: 20px; text-transform: uppercase; padding: 2px 2px 2px 2px; vertical-align: middle;">' +
        '<span style="vertical-align: top; font-size: 14px; font-weight: bold; color: White;">&nbsp;&nbsp;Member Primary Information </span>' +
        '</td></tr>';
    htm += '<tr><td align="right" style="font-weight:bold;float:right;">Name : </td><td>' + (List[0].MemberName != null && List[0].MemberName !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].MemberName) : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Gender :</td><td>' + (List[0].Gender != null && List[0].Gender !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].Gender) : "N/A") + '</td></tr>';
    htm += '<tr class="altRow"><td align="right" style="font-weight:bold;float:right;">DOB : </td><td>' + (List[0].MemberDob != null && List[0].MemberDob !== "" ? List[0].MemberDob : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Age :</td><td>' + (List[0].Age != null && List[0].Age !== "" ? List[0].Age : "N/A") + '</td></tr>';
    htm += '<tr><td align="right" style="font-weight:bold;float:right;">E-Mail : </td><td>' + (List[0].MemberEmail != null && List[0].MemberEmail !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].MemberEmail) : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Contact No : </td><td>' + (List[0].ContactNo != null && List[0].ContactNo !== "" ? List[0].ContactNo : "N/A") + '</td></tr>';
    htm += '<tr class="altRow"><td align="right" style="font-weight:bold;float:right;">Care Manager : </td><td>' + (List[0].CareStaff != null && List[0].CareStaff !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].CareStaff) : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Address :</td><td>' + (List[0].MemberAddress != null && List[0].MemberAddress !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].MemberAddress) : "N/A") + '</td></tr>';
    htm += '<tr><td align="right" style="font-weight:bold;float:right;">Altruista ID :</td><td>' + (List[0].AltruistaId != null && List[0].AltruistaId !== "" ? List[0].AltruistaId : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Care Manager E-mail : </td><td>' + (List[0].CareStaffEmail != null && List[0].CareStaffEmail !== "" ? $.fn.replaceAndEscapeHtmlExt(List[0].CareStaffEmail) : "N/A") + '</td></tr>';
    if (BudgetStartEndDateVisible == true) {
        htm += '<tr class="altRow"><td align="right" style="font-weight:bold;float:right;">Budget Start Date/Plan Enrollment Date :</td><td>' + (List[0].BudgetStartDate != null && List[0].BudgetStartDate !== "" ? List[0].BudgetStartDate : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Budget End Date : </td><td>' + (List[0].BudgetEndDate != null && List[0].BudgetEndDate !== "" ? List[0].BudgetEndDate : "N/A") + '</td></tr>';
    }
    if (List[0].DonScore != null && List[0].ServiceCostMaximum == null) {
        htm += '<tr class=' + (BudgetStartEndDateVisible == true ? "" : "altRow") + '><td align="right" colspan="2" style="font-weight:bold;float:right;">DON Score :</td><td>' + (List[0].DonScore != "" ? List[0].DonScore : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;"></td><td></td></tr>';
    }
    else if (List[0].DonScore == null && List[0].ServiceCostMaximum != null) {
        htm += '<tr class=' + (BudgetStartEndDateVisible == true ? "" : "altRow") + '><td align="right" colspan="2" style="font-weight:bold;float:right;">Service Cost Maximum :</td><td>' + (List[0].ServiceCostMaximum != "" && List[0].ServiceCostMaximum != "N/A" ? "$" + List[0].ServiceCostMaximum : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;"></td><td></td></tr>';
    }
    else if (List[0].DonScore != null && List[0].ServiceCostMaximum != null) {
        htm += '<tr class=' + (BudgetStartEndDateVisible == true ? "" : "altRow") + '><td align="right" style="font-weight:bold;float:right;">DON Score :</td><td>' + (List[0].DonScore != "" ? List[0].DonScore : "N/A") + '</td><td align="right" style="font-weight:bold;float:right;">Service Cost Maximum : </td><td>' + (List[0].ServiceCostMaximum != "" && List[0].ServiceCostMaximum != "N/A" ? "$" + List[0].ServiceCostMaximum : "N/A") + '</td></tr>';
    }

    return htm += '</table>';
}

function signatureSave(isSigantureMandatory = true) {
    $("#addSignatureMsg").html('');
    var canvas = document.getElementById("Sign_Canvas");
    var dataURL = canvas.toDataURL("image/png");
    var image = dataURL.replace('data:image/png;base64,', '');
    var id = $('#controlIdForSignature').val();
    if (id === "") {
        if ($('#CarePlanStatus').is(':visible')) {
            if (validationForSignatureDetails(isSigantureMandatory)) {
                var title = $.trim($("#ddlSignatureTitle option:selected").text());
                var careStaffName = $.trim($("#ddlTitleName option:selected").text());
                var enteredDate = $.trim($("#txtEnteredDate").val());

                if (enteredDate == '') {
                    var confirmation = confirm("Are you sure you want to proceed without an entered date?");
                    if (!confirmation) {
                        return true;
                    }
                }
                if (title !== 'Select' && careStaffName !== 'Select' && !SignatureClientSave(dataURL)) {
                    return false;
                }
            }
        }
        else {
            if ($('#hdnSection').val() === 'CareStaff_Signature_Serviceplan') {
                $('#imgSignServicePlanCS').attr('src', dataURL);
            }
            else {
                $('#imgSignServicePlan').attr('src', dataURL);
            }
            signatureClear();
            $('#btnSignClose').trigger('click');
            return true;
        }
    }
    else {
        var id = $('#controlIdForSignature').val();
        var idEve = $('#controlSignatureEvent').val();
        if (idEve == "Clear" || idEve == "") { dataURL = ""; }
        if (id.indexOf('RebQue') >= 0) {
            if ($("#id1frame").length > 0 && $("#id1frame").contents().find('#' + id).length > 0) {
                $("#id1frame").contents().find('#' + id).attr('src', dataURL);
                if (dataURL === "") {
                    $("#id1frame").contents().find("#TR_Que_Row_" + id.split('€').pop()).removeClass("Answered").addClass("UnAnswered");
                }
            }
            else if ($("#IframeDesGuideLine").length > 0 && $("#IframeDesGuideLine").contents().find('#' + id).length > 0)
                $("#IframeDesGuideLine").contents().find('#' + id).attr('src', dataURL);
            else if ($("#IframeUMRunScript").length > 0 && $("#IframeUMRunScript").contents().find('#' + id).length > 0)
                $("#IframeUMRunScript").contents().find('#' + id).attr('src', dataURL);
        }
        else {
            $('#' + id).attr('src', dataURL);
            //UHC-3918
            if ($("#hdnMandatoryReq").length > 0) {
                if ($('#' + id).attr('src') == "" && ($('#' + id).attr('data-ismandate') == "yes" || $('#' + id).attr('data-isdynmandate') == "yes")) {
                    $('#' + id).addClass('mandateBorder');
                }
                else {
                    if ($('#' + id).attr('data-ismandate') == "yes" || $('#' + id).attr('data-isdynmandate') == "yes") {
                        $('#' + id).removeClass('mandateBorder');
                        funRemoveMandatorySymbols($('#' + id));
                    }
                }
            }
            //
        }
        signatureClear();
        $('#btnSignClose').trigger('click');
    }
    return true;
}

function validationForSignatureDetails(isSigantureMandatory) {
    let isValid = true;
    A11yForms.clearFormFieldValidation();
    isValid &= A11yForms.validateFormField('ddlSignatureTitle', null, [A11yForms.VALIDATIONS.REQUIRED]);
    isValid &= A11yForms.validateFormField('ddlTitleName', null, [A11yForms.VALIDATIONS.REQUIRED]);

    if ($("#trAgeementReason").is(":visible") && !$('#txtAgreementReason').val()) {
        isValid &= A11yForms.validateFormField('txtAgreementReason', null, [A11yForms.VALIDATIONS.REQUIRED]);
    }
    var enteredDate = $.trim($("#txtEnteredDate").val()) || '';

    if (enteredDate !== '' && new Date(enteredDate).ToDateWithoutTime() > new Date().ToDateWithoutTime()) {
        A11yForms.showFormFieldError('txtEnteredDate', 'Future date is not allowed for Entered Date');
        isValid = false;
    }
    if (enteredDate !== '' && !(date_regex.test(enteredDate))) {
        A11yForms.showFormFieldError('txtEnteredDate', 'Entered Date is not in a valid format');
        isValid = false;
    }
    if (isSigantureMandatory && $("#signHereCanvas").is(":visible") && $("#controlSignatureEvent").val() === "Clear") {
        A11yForms.showFormFieldError('signHereCanvas', A11yForms.ERROR_MESSAGES.REQUIRED);
        $("#signHereRequired").addClass('ah-required ah-label-error');
        isValid = false;
    }
    if (!isValid) {
        A11yAlerts.createErrorAlert('#addSignatureMsg', null, true);
    } else {
        clearSignatureValidation();
    }
    return isValid;
}

function clearSignatureValidation() {
    A11yForms.clearFormFieldValidation();
    A11yAlerts.remove('addSignatureMsg');
}

//validating record exist or not.
function Validation(title, carestaffname) {
    var result = true;
    arrSignature.forEach(function (item) {
        if (item.ParticipantTitleName == title && item.ParticipantName == carestaffname) { result = false; }

    });
    return result;
}

//Html code for grid layout.
function SignatureGridBind() {
    var htm = '';
    htm += '<table style="border-collapse: collapse;width: 100%;">' +
        '<tr>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Title</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Name</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Role</th>' + //UHC-4647
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Credentials</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Signature</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Care Plan Participation</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Care Plan Agreement</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Reason(s)</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Entered Date</th>' +
        '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;">Created On</th>';
    htm += '<th style="border: 1px solid #dddddd;text-align: left;padding: 8px;background-color:#c5c5c5;"  class="printrmoveclass"><button class="addMenu add_icon" id="AddClick"> </button></th>';
    htm += '</tr>';
    if (arrSignature.length > 0) {
        var i = 1;
        arrSignature.forEach(function (item) {
            item.SignatureRemarks = item.SignatureRemarks ? item.SignatureRemarks : "N/A";
            item.MemberParticipatedFlag = item.MemberParticipatedFlag ? item.MemberParticipatedFlag : "N/A";
            item.MemberAgreedFlag = item.MemberAgreedFlag ? item.MemberAgreedFlag : "N/A";
            htm += '<tr>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + item.ParticipantTitleName + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + $.fn.replaceAndEscapeHtmlExt(item.ParticipantName) + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + $.fn.replaceAndEscapeHtmlExt(item.RoleName) + '</td>' +//UHC-4647
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + $.fn.replaceAndEscapeHtmlExt(item.Credentials) + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;"><img id="imgSignServicePlan' + i + '" src="' + item.Signature + '" alt="" width="100px" height="30px"></td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + item.MemberParticipatedFlag + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + item.MemberAgreedFlag + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px; word-wrap: break-word;">' + $.fn.replaceAndEscapeHtmlExt(item.SignatureRemarks) + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + item.EnteredDate + '</td>' +
                '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;">' + GetCurrentDateByUserTimeZone() + '</td>';
            if (print != 1) {
                if ($('#hdnIsFullCarePlanSection').val() === "1") {
                    htm += '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;" class="printrmoveclass"><button class="GridSubNew RemoveClickCls" id="RemoveClick' + item.CarePlanSignatureId + '"  data-careplansignatureid="' + item.CarePlanSignatureId + '" data-title="' + item.ParticipantTitleName + '" data-carestaffname="' + $.fn.replaceAndEscapeHtmlExt(item.ParticipantName) + '" data-entereddate="' + item.EnteredDate + '" ></button></td>';
                }
                else {
                    htm += '<td style="border: 1px solid #dddddd;text-align: left;padding: 8px;" class="printrmoveclass"><button class="GridSubNew RemoveClickCls" id="RemoveClick' + item.CarePlanSignatureId + '"  data-title="' + item.ParticipantTitleName + '" data-carestaffname="' + $.fn.replaceAndEscapeHtmlExt(item.ParticipantName) + '" data-entereddate="' + item.EnteredDate + '" ></button></td>';
                }
            }
            htm += '</tr>';
            i = i + 1;

        });
        htm += '</table>';
    }
    else {
        htm += '<tr style="border: 1px solid #dddddd;height:25px;"></tr>';
        htm += '</table>';
    }

    $('#signatureData').html(htm);
    gridNotAvailableCustomColor('signatureData');
    A11yGrid.enhanceKendoGridForA11y('signatureData', 1);

}

function SignatureGridPrint() {
    var htm = '';
    htm += '<table border="0" cellpadding="4" cellspacing="0" width="600" class="CH-gridbrd">' +
        '<tr><td colspan="8" class="MnHeadName Print_BgBlueCH"><span>Signature</span></td></tr>' +
        '<tr><td width="8%" align="center" class="TxtBlueclr"><span><strong>SNO</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Title</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Name</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Role</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Credentials</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Signature</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Care Plan Participation</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Care Plan Agreement</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Reason(s)</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Entered Date</strong></span></td>' +
        '<td width="8%" align="center" class="TxtBlueclr"><span><strong>Created On</strong></span></td></tr>';

    if (arrSignature.length > 0) {
        var i = 1;
        arrSignature.forEach(function (item) {
            item.SignatureRemarks = item.SignatureRemarks ? item.SignatureRemarks : "N/A";
            item.MemberParticipatedFlag = item.MemberParticipatedFlag ? item.MemberParticipatedFlag : "N/A";
            item.MemberAgreedFlag = item.MemberAgreedFlag ? item.MemberAgreedFlag : "N/A";
            htm += '<tr>' +
                '<td class="Word-Brk"><span>' + i + '</span> </td>' +
                '<td class="Word-Brk"><span>' + item.ParticipantTitleName + '</span> </td>' +
                '<td class="Word-Brk"><span>' + $.fn.replaceAndEscapeHtmlExt(item.ParticipantName) + '</span> </td>' +
                '<td class="Word-Brk"><span>' + $.fn.replaceAndEscapeHtmlExt(item.RoleName) + '</span> </td>' +
                '<td class="Word-Brk"><span>' + $.fn.replaceAndEscapeHtmlExt(item.Credentials) + '</span> </td>' +
                '<td class="Word-Brk"><img id="imgSignServicePlan' + i + '" src="' + item.Signature + '" alt="" height="50" width="100"> </td>' +
                '<td class="Word-Brk"><span>' + item.MemberParticipatedFlag + '</span> </td>' +
                '<td class="Word-Brk"><span>' + item.MemberAgreedFlag + '</span> </td>' +
                '<td class="Word-Brk"><span>' + $.fn.replaceAndEscapeHtmlExt(item.SignatureRemarks) + '</span> </td>' +
                '<td class="Word-Brk"><span>' + item.EnteredDate + '</span> </td>' +
                '<td class="Word-Brk"><span>' + GetCurrentDateByUserTimeZone() + '</span> </td></tr>';
            i = i + 1;

        });
        htm += '</table>';
    }
    else {
        htm += '<tr><td align="center" colspan="8" class="pt10 pb10 Word-Brk"><span><b>No Records</b></span></td></tr>';
        htm += '</table>';
    }

    return htm;

}

function htmlSave() {
    var result = '';
    var dataStr = {
        HtmlData: SignatureGridPrint()
    };
    $.ajax({
        type: "POST",
        url: baseURL + "/Common/HtmlFullCarePlanSignature",
        data: dataStr,
        dataType: "json",
        async: false,
        success: function (data) {
            result = data.CareplanTemplateContentId;
        }
    });
    return result;
}

function signatureClear() {
    var canvas = document.getElementById("Sign_Canvas");
    canvas.style.position = null;
    $('#Sign_Canvas').css('pointer-events', '');
    var context = canvas.getContext("2d");
    context.setTransform(1, 0, 0, 1, 0, 0);
    context.clearRect(0, 0, canvas.width, canvas.height);
    if ($("#controlSignatureEvent").length > 0) {
        $("#controlSignatureEvent").val('Clear');
    }
    context.restore();
    $('#signHereCanvas').css('pointer-events', '');
    //As per the ticket PROD-115065
    //if ($('#CarePlanStatus').is(':visible')) {
    //    $("#ddlSignatureTitle").val('-1');
    //    $("#ddlTitleName").find('option').not(':first').remove();
    //    $("#trCredentials").hide();
    //}

}

function ReadTemplateHTML() {
    var templateHTML = $('#ServicePlanDivContent').html();

    $("#hdnCNSTTemplateHTML").val(templateHTML[0].innerHTML.replace(/"/g, '\''));
    var images = templateHTML.find('img[id*="saveSignature"]');
    var imageData = "";
    images.each(function () {
        if ($(this)[0].src != null) {
            imageData += $(this)[0].src + "§";
        }
    });
    imageData = imageData.substring(0, imageData.length - 1);
    $("#hdnImageData").val(imageData);
}

function DurationFormat(obj) {
    var varDuration = obj;
    if (isNaN(obj) || obj == 0) {
        varDuration = "00";
    }
    else if ((obj > 0) && (obj < 10)) {
        varDuration = "0" + obj;
    }
    return varDuration;
}

function AllowNumericsFunc(e) {
    // need to allow Shift and Tab for a11y
    if (e.ctrlKey || e.altKey) {
        e.preventDefault();
    } else {
        let key = e.keyCode;
        if (!((key === A11yUtil.KEYCODES.backspace) || (key === A11yUtil.KEYCODES.tab) || (key === A11yUtil.KEYCODES.delete) ||
            (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105) || (key === A11yUtil.KEYCODES.dash) ||
            (key === A11yUtil.KEYCODES.subtract) || (key === A11yUtil.KEYCODES.minus))) {
            e.preventDefault();
        }
    }
}

function onCareStaffParm() {
    return {
        CareStaffName: $("#ACAllCareStaff").val(),
        IsInactiveCareStaff: $('#chkInactiveCS').is(':checked'),
        ModuleId: $("#selectPAModule").val()
    };
}

function onManagerStaffParm() {
    return {
        CareStaffName: $("#ACManagersCareStaff").val(),
        IsInactiveCareStaff: $('#chkInactiveCS').is(':checked'),
        ModuleId: $("#selectPAModule").val()
    };
}

function onReferCareStaffParm() {
    $("#hdnCareStaffId").val('');
    return {
        CareStaffName: $("#ACReferAllCareStaff").val(),
        ModuleId: $("#selectPAModule").val(),
        PatientID: $("#hdnselectedActPatientID").val()
    };
}

function onManagerParm() {
    return {
        CareStaffName: $("#ACManager").val(),
        IsManager: true
    };
}

function onSelPenActModule(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var moduleId = DataItem.ModuleId;
    $("#chkInactiveCS").attr('checked', false);
    if (moduleId != 1) {
        $("#chkInactiveCS").hide();
    }
    else {
        $("#chkInactiveCS").show();
    }
    $("#hdnCareStaffId").val('');
    $("#ACManagersCareStaff").val('');
    $("#ACAllCareStaff").val('');

    if ($('#chkViewAll').is(':checked')) {
        if (moduleId == 2) {
            $('#ddlMSAssignedTo').show();
            $('#ddlMSAssignedTo').closest('span').show();
            $('#ACAllCareStaff').hide();
            $('#ACAllCareStaff').closest('span').hide();
        }
        else {
            $('#ddlMSAssignedTo').val('');
            $('#hdnMSAssignedTo').val('');
            $('#ddlMSAssignedTo').hide();
            $('#ddlMSAssignedTo').closest('span').hide();
            $('#ACAllCareStaff').show();
            $('#ACAllCareStaff').closest('span').show();
        }
        $('#ACManagersCareStaff').hide();
        $('#ACManagersCareStaff').closest('span').hide();
    }
    else {
        $('#ddlMSAssignedTo').hide();
        $('#ddlMSAssignedTo').closest('span').hide();
        $('#ACAllCareStaff').hide();
        $('#ACAllCareStaff').closest('span').hide();
        $('#ACManagersCareStaff').show();
        $('#ACManagersCareStaff').closest('span').show();
    }


}

function onSelCareStaff(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var CareStaffId = DataItem.MemberId;
    $("#hdnCareStaffId").val(CareStaffId);
    $("#hdnCareStaffIdReferFrom").val(CareStaffId);
    $("#ACManager").val('');
}

function onSelManager(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var managerId = DataItem.MemberId;
    $("#hdnManagerId").val(managerId);

    $("#ACManagersCareStaff").val('');
    $("#ACAllCareStaff").val('');

}

function AssignOrUnassignMemberToCareStaff(inactivateCM) {
    $("#btnInactCMConfYesAC").prop("disabled", true);
    var patientIds = $("#hdnPatientIdsAC").val();
    var staffId = '';
    var patientAccessed = $("#selectPatientAccessed").val();
    if ($('#chkIsPreferences').is(':checked')) {
        staffId = $('#ddlSingleCareStaff').val();
    }
    else {
        staffId = $('#hdnSelectAssignCareStaffName').val();
    }
    DevUtils.logDebug('AssignOrUnassignMemberToCareStaff: staffId=' + staffId);
    if ($("#hdnIsFromAC").val() == "A") {
        var dataInput = {
            careStaffId: staffId,
            patientIDs: patientIds,
            inactivateCM: inactivateCM,
            isActTransfer: $("#chkIsActTransferAC").is(":checked")
        }
        var AUrl = baseURL + "/AssignCareStaff/AssignMemberToCareStaff";
        $.ajax({
            type: "POST",
            url: AUrl,
            data: dataInput,
            dataType: "json",
            asyns: false,
            success: function (data) {
                loader(0);
                if (data.success) {
                    $("#chkIsActTransferAC").attr('checked', false);
                    CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Success');
                    $('#ddlCareStaff').val('');
                    $('#hdnSelectAssignCareStaffName').val('');
                    $("#hdnPatientIdsAC").val('');
                    $("#hdnIsFromAC").val('');
                    $("#AssignCareStaffGrid").data("kendoGrid").dataSource.read();

                    $('#chkIsCareStaff').click();  // Reset radio button - default to Assign to care staff

                    if (patientAccessed != "" && checkSearchValueInCollection(patientIds, patientAccessed)) {
                        refreshCareManager();
                    }
                }
                else {
                    CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Error');
                }
                $("#btnInactCMConfYesAC").prop("disabled", false);
                $("#closePopUp").trigger('click');
            },
            error: function () {
                loader(0);
                $("#btnInactCMConfYesAC").prop("disabled", false);
                $("#closePopUp").trigger('click');
            }
        });
    }
    else {
        var dataInput = {
            careStaffId: staffId,
            patientIDs: patientIds,
            inactivateCM: inactivateCM
        }
        var AUrl = baseURL + "/AssignCareStaff/UnAssignMemberToCareStaff";
        $.ajax({
            type: "POST",
            url: AUrl,
            data: dataInput,
            dataType: "json",
            asyns: false,
            success: function (data) {
                loader(0);
                if (data.success) {
                    CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Success');
                    $('#ddlCareStaff').val(''); $('#hdnSelectAssignCareStaffName').val(''); $("#hdnPatientIdsAC").val(''); $("#hdnIsFromAC").val('');
                    $("#AssignCareStaffGrid").data("kendoGrid").dataSource.read();

                    $('#chkIsCareStaff').click();  // Reset radio button - default to Assign to care staff

                    if (patientAccessed != "" && checkSearchValueInCollection(patientIds, patientAccessed)) {
                        refreshCareManager();
                    }
                }
                else {
                    CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Error');
                }
                $("#btnInactCMConfYesAC").prop("disabled", false);
                $("#closePopUp").trigger('click');
            },
            error: function () {
                loader(0);
                $("#btnInactCMConfYesAC").prop("disabled", false);
                $("#closePopUp").trigger('click');
            }
        });
    }
}

function AssignMemberToCareStaffPHBulk(inactivateCM) {
    var actionType = $("#hdnPHSection").val();
    var notestr = $("#txtCMPHBulkAssignNotes").val();
    var staffId = $("#hdnstaffIdBulkPH").val()
    $("#btnInactCMConfYesAC").prop("disabled", true);
    var patientIds = $("#hdnChkBulkPatientIds").val();
    DevUtils.logDebug('AssignMemberToCareStaffPHBulk: staffId=' + staffId);
    loader(1);
    var dataInput = {
        careStaffId: staffId,
        patientIDs: patientIds,
        inactivateCM: inactivateCM,
        notestr: notestr,
        isPH: true,
        isActTransfer: $("#chkIsActTransferACPhBulk").is(":checked"),
        isPrimary: !$("#rdIsSecondaryCareStaffBulk").is(":checked")
    };
    var data = AjaxAssignMemberToCareStaffSync(dataInput);
    loader(0);
    if (data && data.success) {
        A11yAlerts.createSuccessAlert(alertSelector, "Assigned Succesfully");
    } else if (data) {
        A11yAlerts.createErrorAlert(alertSelector, data.statusMsg);
    } else {
        // generic error already logged in AjaxAssignMemberToCareStaffSync
        A11yAlerts.createErrorAlert(alertSelector, "An error occurred while assigning care staff.");
    }
    $('#divPHBulkCareStaffSelect #closePopUp').trigger('click');
    if (actionType === 'QM') {
        setTimeout(function () {
            GetJsonOpportunitiesDataSource($("#optCategories option:selected").val(), 1, 0, 0, 25, null, null, "", () => {
                CloseLoading();
            });
        }, 5000);
    }
    else if (actionType === 'ADT') {
        setTimeout(function () {
            $("#ADTrackingGrid").data("kendoGrid").dataSource.read();
        }, 5000);
    }
    else if (actionType === 'MyMem') {
        setTimeout(function () {
            $("#MyMembersGridNew").data("kendoGrid").dataSource.read();
        }, 5000);
    }
}

function AssignCareStaffCareTeamAssign(patientIds) {
    var listCareStaff = smartSearch.value("DdlDefaultStaff");
    var dataInput = {
        staffIds: listCareStaff,
        patientIDs: patientIds,
        cTToDate: $('#txtCTToDate').val(),
        cTFromDate: $('#txtCTFromDate').val()
    }
    $.ajax({
        type: "POST",
        url: baseURL + "/AssignCareStaff/CareTeamAssign",
        data: dataInput,
        dataType: "json",
        async: false,
        success: function (data) {
            if (data.success) {
                loader(0);
                CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Success');
                $("#AssignCareStaffGrid").data("kendoGrid").dataSource.read();
            }
            else
                CmnStatusMessageDisp('validationMessageAssignCare', data.statusMsg, 'Error');
        },
        error: function () {
            loader(0);
        }
    });

}

function ShowHideSearch(obj) {
    if (obj == true) {
        $('#trMemberSearch').show();
        $('#trEnrollmentSearch').show();
        $('#trClinicalSearch').show();

        $('#trProviderSearch').show();
        $('#trAnalyticalSearch').show();
        $('#trSearchAllButton').show();
        $('#trFilter').show();
    }
    else {
        $('#trMemberSearch').hide();
        $('#trEnrollmentSearch').hide();
        $('#trClinicalSearch').hide();

        $('#trProviderSearch').hide();
        $('#trAnalyticalSearch').hide();
        $('#trSearchAllButton').hide();
        $('#trFilter').hide();
    }
}

function AssignCareMemberParameters() {
    $('.chooseGridColumns').show();

    // GCPROD-26469: Remove the following three lines after refactoring FindCareMemberBasic
    $('#ddlDynaColumnForAssignCareStaff').show();
    $('#btnShowDynamicCols').show();
    $('#spnConfLbl').show();
    return dataString;
}

function showHideAssignCareMemberForMTM() {
    if (isMTMval === true || isMTMval.toLowerCase() === 'true') {
        $('#chkIsBulkMailing,#chkTxtBlkMail,#chkIsPreferences,#chkTxtPreferences,#btnAddActivity,#trActTransfer').hide();
        $('#rdbCareTeam').attr('disabled', true);
    }
    else {
        $('#chkIsBulkMailing,#chkTxtBlkMail,#chkIsPreferences,#chkTxtPreferences,#btnAddActivity,#trActTransfer').show();
        $('#rdbCareTeam').removeAttr('disabled');
    }
}

function AssignCareStaffPlanParameters() {
    var stringName = $("#ddlPlanAC").data("kendoAutoComplete").value().split(',');
    return {
        planName: stringName[stringName.length - 1],
        planIds: $('#hdnddlPlanAC').val(),
        lobIds: $("#hdnLobOnClk").val()
    };
}

function AssignCareStaffProgramParameters() {
    var stringName = $("#ddlProgramAC").data("kendoAutoComplete").value().split(',');
    return {
        eligibilityLevelData: $('#hdntxtHierarchyLevelSearchValue').val(),
        programName: $.trim($('#ddlProgramAC').val()),
        programIds: $.trim($('#hdnddlProgramAC').val())
    };
}

function onCareStaffDropdownAddActivityChange(e) {
    $("#hdnCareStaffAddActivity").val('');
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var internalCareStaffId = DataItem.MemberId;
    var dataStr = { memberID: internalCareStaffId }
    $("#hdnCareStaffAddActivity").val(internalCareStaffId);
}

function onCareStaffDropdownOSActivityChange(e) {
    if (e.item == null) return;
    var DataItem = this.dataItem(e.item.index());
    var internalCareStaffId = DataItem.MemberId;
    var dataStr = { memberID: internalCareStaffId }
    $("#hdnOSActivityCareStaffId").val(internalCareStaffId);
}

function onCareStaffDropdownDataACMBound(e) {
    if (!$("#popUpDialog1").is(":visible")) {
        $("#hdnSelectAssignCareStaffSearchName").val('-1');
    }
    var noItems = this.list.find(".noDataMessage");

    if (!this.dataSource.view()[0]) {
        noItems.show();
        this.popup.open();
    } else {
        noItems.hide();
    }
}

function onCareStaffDropdownDataAddActivityBound(e) {
    var noItems = this.list.find(".noDataMessage");

    if (!this.dataSource.view()[0]) {
        noItems.show();
        this.popup.open();
    } else {
        noItems.hide();
    }
    $("#hdnCareStaffAddActivity").val('');
}

function onCareStaffDropdownDataOSActivityBound(e) {
    var noItems = this.list.find(".noDataMessage");

    if (!this.dataSource.view()[0]) {
        noItems.show();
        this.popup.open();
    } else {
        noItems.hide();
    }
}

function onMSCareStaffDetailsParamAddActivity() {
    $('#hdnCareStaffAddActivity').val("");
    return {
        staffName: $('#ddlMSCareStaffAddActivity').val(),
    }
}

function onCareStaffDetailsParamOSActivity() {
    $('#hdnOSActivityCareStaffId').val("");
    return {
        staffName: $('#ddlOSActivityCareStaff').val(),
    }
}

function hideContextMenuLinksBasedonIsSensitive(IsSensitive, memSumcontextMenu, createmsgcontextMenu, viewNotes, runscript = '', memAlerts = '') {
    if (IsSensitive != undefined && (IsSensitive == true || IsSensitive == 'true')) {
        $(memSumcontextMenu).hide();
        $(createmsgcontextMenu).hide();
        $(viewNotes).hide();
        $(runscript).hide();
        $(memAlerts).hide();
    }
    else {
        $(memSumcontextMenu).show();
        $(createmsgcontextMenu).show();
        $(viewNotes).show();
        $(runscript).show();
        $(memAlerts).show();
    }
}

function openSignaturePopup(id) {
    CallingIframeJsFunction(id);
    $("#hdnSignatureClock").val(id);
    var header = "";
    let windowWidth = $(window).width();
    if ($("#" + id).hasClass('clsSignatureClock')) { header = ""; }
    else { header = "ADD SIGNATURE"; }
    //$('#popUpDialog2').CMNPopup({
    //    pvUrl: baseURL + "/Home/ScriptSignature",
    //    onLoad: function () {
    //        $('#controlIdForSignature').val(id);
    //        drawImageOfSignature(id);
    //        // DrawSignOnCanvas(id);

    //    },
    //    popLevel: 1,
    //    closeButton: '#btnSignClose',
    //    popUpHeader: "SIGNATURE"
    //});
    $('#popUpDialog3').CMNPopup({
        pvUrl: baseURL + "/Common/GlobalSignature",
        onLoad: function () {
            $('#controlIdForSignature').val(id);
            DrawSignOnCanvas(id);
            let modalWidth = 645
            $("#popUpDialog3").css({ 'left': (windowWidth - modalWidth) / 2, 'width': modalWidth });
        },
        onClose: function () {
        },
        popLevel: 2,
        closeButton: '#btnSignClose',
        popUpHeader: header
        // popUpHeader: "SIGNATURE"
    });
}

//External Guiding Care Tooltip Code............End||||||| .r6412

function ViewSummaryToggleData(Source) {
    var rowdetails = $(Source).next().html();
    var dynRows = rowdetails.split('‡');
    var Class = "ImgPlus ImgMinus"; var $htm = "";
    $(Source).toggleClass(Class);
    if ($(Source).attr("class") == 'ImgMinus') {
        $htm += '<div  class="Hidetbl" style="width:930px;overflow-x:auto;margin-left: 20px;height: 100px;"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="border:1px solid #ccc !important;" class="DBGrid Hidetbl">';
        if (rowdetails != '' && rowdetails != null && rowdetails != 'null') {
            $htm += '<tr>';
            var Col = dynRows[0].split('±');
            for (var icountR = 0; icountR < Col.length; icountR++) {
                var Colitem = Col[icountR];
                if (Colitem != "" && Colitem != undefined) {
                    $htm += '<th>' + Colitem.split('†')[0] + '</th>';
                }
            }
            $htm += '</tr>';
            for (var count = 0; count < dynRows.length; count++) {
                $htm += '<tr>';
                var itemVal = dynRows[count];
                var items = itemVal.split('±');
                for (var icount = 0; icount < items.length; icount++) {
                    var item = items[icount];
                    if (item != "" && item != undefined) {
                        var value = decodeURIComponent(item.split('†')[1]);
                        value = value.replace(/€¶¦validate€¶¦/g, "1SI").replace(/1Üî/g, "1Si").replace(/1Ûï/g, "1sI").replace(/1Ûî/g, "1si");
                        //UHC-3063
                        if (value.indexOf("data:image") >= 0) {
                            value = "<img style='width:60px;' src='" + value + "'/>";
                        }
                        //
                        $htm += '<td>' + (value != null && value != "" ? value : "N/A") + '</td>';
                    }
                }
                $htm += '</tr>';
            }
        }
        else {
            $htm += '<tr><td>';
            $htm += 'No Records Found';
            $htm += '</td></tr>';
        }
        $htm += '</table></div>';
    }
    else {
        $(Source).closest("tr").next().remove();

    }
    var ParentTr = $(Source).closest("tr"); $(ParentTr).after($htm);


    //--- trst
}

function funisValidDate(dateCtrl, isReq) {
    var retval = true;
    try {

        var conVal = new Date(dateCtrl);
        if (conVal == 'Invalid Date') { retval = false; }
        if ((isReq == 0 && dateCtrl != "") || isReq == 1) {
            if (retval) {
                var splitVal = dateCtrl.split('/');
                var spldays = parseInt(splitVal[1]);
                var splmonths = parseInt(splitVal[0]);
                if (splmonths > 12) { retval = false; }
                if (splmonths === 4 || splmonths === 6 || splmonths === 9 || splmonths === 11) {
                    if (spldays > 30) { retval = false; }
                } else {
                    if (spldays > 31) { retval = false; }
                }
                if (retval) {
                    if (splmonths === 2 && spldays > 28) { retval = false; }
                    var yearPart = splitVal[2].split(' ')[0];
                    if (yearPart % 4 === 0 && splmonths === 2 && spldays <= 29) { retval = true; }
                }
            }
            return retval;
        }
        else
            return true;
    }
    catch (ex) {
        console.log(ex);
        return false;
    }
}

function onLogoUploadSuccess(e) {
    var fileName = e.response.LogoFileName;
    var imagData = e.response.ImageData;
    $('#hdnLogoUploadPath').val(fileName);
    $('#uploadedLogoImg').prop('src', imagData);
    $("#btnUploadAndUpdateLogo").attr('disabled', false);
}

function ValidateChangeCarePlanStatus() {
    $('.requiredfields').hide();
    if ($('#ddlManageStatus').val() == "-1") {
        $('.requiredfields').show();
        return false;
    }
    else {
        $('.requiredfields').hide();
        return true;
    }
}

function ShowCareOrganisationsfrmManageCareStaff(memberId, firstName) {
    var IsView = false;
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Common/ShowAllCareOrganisations?IsAuditsView=" + IsView,
        onLoad: function () {
            $("#hdnMemberId").val(memberId);
            if (firstName !== '') {
                $("#lblCOMemProfName").html($.fn.replaceAndEscapeHtmlExt(firstName) + ': ');
            }
            $("#CareOrganisationsGrid").data("kendoGrid").dataSource.page(1);
        },
        onClose: function () {
            $('#popUpDialog1').html('');
        },
        popUpHeader: "Care Organizations"
    });
}

function CareOrganisationsParams() {
    var memId = "";
    var memId = $("#hdnMemberId").val() != "" ? $("#hdnMemberId").val() : memberidval;
    return {
        ProfileId: $("#hdnProfileId").val(),
        MemberId: memId,
        CosearchType: $("#ddlCoSearchType option:selected").text(),
        CosearchValue: $('#txtSearchval').val(),
        ProfileValues: profileValues,
        DisplayCoporateName: DisplayCoporateName
    }
}

//End of QM-269

function logError(exception, errorCode, controllerAction) {
    var object = { exception: exception, errorCode: errorCode, action: controllerAction, carestaffID: memberidval, patientID: $("#selectPatientAccessed").val() };
    $.ajax({
        url: baseURL + "/Home/LogException",
        type: "Post",
        dataType: "json",
        data: object,
        success: function (data) {
        }
    });
}

//End My CareTeam Members MVC Convertion

//healthify //10_05_16
var hdnUUID = "";
var ProgramId = "";
var HltyStatus = true;
var InterventionName = "";
var CarePlanId = "";
var memberZipCode = "";

function NavigateToHealthifySite(val) {
    if (isSDOHEnabled == 'TRUE') {
        InterventionName = $(val).attr('data-intervention');//Default Values passing to  Healthify site search controls
        CarePlanId = $(val).attr('data-CarePlanID');
        $('#lnkCommunityReferralTab').click();
    } else {
        NavigateToHealthifyComProvSite(val)
    }
}

function NavigateToHealthifyComProvSite(val) {
    //<< REMOVED THE OLDER HEALTHIFY FLOW(< 8.14) FOR UHC AS PART OF PROD - 97154 >>
    if (clientName == 'UHC') { return; }
    IsFromAppointment = false;
    //step :1   //Open HealthifySite      
    //  alert(HealthifyNavigation + ' ' + HealthifyReferralCreate + ' ' + HealthifyProviderDetails + '' + HealthifyAuthorization + ' ' + HealthifyPostmanToken);
    InterventionName = $(val).attr('data-intervention');//Default Values passing to  Healthify site search controls
    CarePlanId = $(val).attr('data-CarePlanID');
    memberZipCode = $(val).attr('data-Zip');
    let hPatId = $(val).attr('data-patientid');
    if (memberZipCode == null || memberZipCode == "") {
        CustomAlert('Zip code for this member is not available. Please update the zip code and continue for social referral.');
        return false;
    }
    loader(1);

    //Auntbertha
    var auntBerthaDtls = { CareplanId: CarePlanId, InterventionName: InterventionName, MemberZipCode: memberZipCode }
    $.ajax({
        type: "GET",
        url: baseURL + "/CareTeam/GetHealthifyProviderHistDetails/",
        data: auntBerthaDtls,
        contentType: "application/json",
        success: function (data) {
            if (data.success) {
                var uuid = data.Uuid;
                hdnUUID = data.Uuid;
                var ProviderId = data.ProviderId;

                if ((uuid != null || uuid != "") && (ProviderId == null || ProviderId == "")) {//Not Connected provider from AuntBertha
                    $('#popUpDialog2').CMNPopup({
                        pvUrl: baseURL + "/CarePlan/AuntBerthaReferral/",
                        popUpHeader: "Social Provider Search",
                        popLevel: 1,
                        closeButton: '#btnCloseAuntBerthaUI'
                    });
                }
                else if ((uuid != null || uuid != "") && (ProviderId != null || ProviderId != "")) {//Provider Referred from AuntBertha,So need to open Appointment Directly                       
                    $('#popUpDialog1').CMNPopup({
                        pvUrl: baseURL + "/CommonDefaultSessionState/AddAppointment?CareplanId=" + CarePlanId,
                        popUpHeader: "Add Appointment",
                        closeButton: '#closebutton1',
                        onClose: function () {
                            ClearTableMenu('_myMemberPartialViewContainer', 'divMemberMenu');
                            if ($("#fromAppointment").length == 1)
                                $("#fromAppointment").remove();
                        }
                    });
                }
            }
            else {
                var responseData = { CareplanId: CarePlanId, InterventionName: InterventionName, MemberZipCode: memberZipCode, MemberId: hPatId }
                $.ajax({
                    type: "POST",
                    url: baseURL + "/CarePlan/SaveHealthifyProviderHistDetails/",
                    data: JSON.stringify({ model: responseData }),
                    contentType: "application/json",
                    success: function (data) {
                        if (data.success) {
                            hdnUUID = data.UniqueKey;
                            $('#popUpDialog2').CMNPopup({
                                pvUrl: baseURL + "/CarePlan/AuntBerthaReferral/",
                                popUpHeader: "Social Provider Search",
                                popLevel: 1,
                                closeButton: '#btnCloseAuntBerthaUI'
                            });
                        }
                    },
                    error: function (exception) {
                        console.log(exception); loader(0);
                    }
                });
            }
        }
    })
}

function FunFetchHealthifyProviderDetails(parUuid) {
    $.ajax({
        type: "POST",
        url: baseURL + "/Dashboard/FetchCareProviderDetails/",
        data: JSON.stringify({ Uuid: parUuid }),
        contentType: "application/json",
        success: function (data) {
            if (data != null && data.success && data.success == true) {
                var DataItemVal = data.val;
                if (DataItemVal != null && DataItemVal.length > 0) {
                    $('#PhysicianCode').val(DataItemVal[0].PhysicianCode);
                    if (DataItemVal[0].ProviderName != null)
                        $('#ProviderName').val(DataItemVal[0].ProviderName);
                    else
                        $('#ProviderName').val(DataItemVal[0].FirstName + ' ' + DataItemVal[0].LastName);
                    $('#ProviderType').val(DataItemVal[0].ProviderType);
                    $('#CellPhone').val(DataItemVal[0].WorkPhone);
                    var Address = DataItemVal[0].Address == null ? "" : DataItemVal[0].Address;
                    if (Address != "") {
                        $('#City').val(Address);
                    }
                    else {
                        var City = DataItemVal[0].City == null ? "" : DataItemVal[0].City;
                        var State = DataItemVal[0].State == null ? "" : DataItemVal[0].State;
                        var Zip = DataItemVal[0].Zip == null ? "" : DataItemVal[0].Zip;
                        $('#City').val(Address + ' ' + City + ' ' + State + ' ' + Zip);
                    }
                    $('#ProviderEmail').val(DataItemVal[0].Email);
                    $('#HealthifyId').val(DataItemVal[0].HealthifyId);
                    $('#IsPreferredProvider').val('');
                    $('#IsPreferredProvider').val(DataItemVal[0].IsPreferredProvider == null ? "" : DataItemVal[0].IsPreferredProvider);
                    $('#chkIsSentEmail').attr('disabled', 'disabled'); $('#chkIsSentEmail').prop('checked', true);
                    if (DataItemVal[0].HealthifyId == null || DataItemVal[0].HealthifyId == '') { $('#chkIsSentEmail').removeAttr('disabled'); }
                    else if (!DataItemVal[0].IsPreferredProvider) { $('#chkIsSentEmail').prop('checked', false); }
                    if (clientName != 'UHC') {
                        $('#chkIsSentEmail').attr('disabled', false); $('#chkIsSentEmail').prop('checked', true);
                    }
                    loader(0);
                }
            }
        },
        error: function (exception) {
            console.log(exception);
            loader(0);
        }
    });
}

function unSelectCheckBox(ctrl) {
    var lst = $('#' + $(ctrl).attr('Id') + 'hdn').val().split(',');
    if (lst.length > 7) {
        var SelectedCheckboxes = RemoveExtracolumn(lst, ctrl.value)
        $('#' + $(ctrl).attr('Id') + 'hdn').val(SelectedCheckboxes);
        $(ctrl).attr('checked', false);
        $("#" + $(ctrl).attr('Id') + "val").val("7 items Checked");
        CustomAlert('You cannot select more than 7 columns');
    }
}

//common funtion for manage aidSupplemental section to uncheck and check based on child checkbox
function ShowHideAidSuppBtnOnChkChnge(count, chkcount, addBtnId, editBtnId, chkAllId) {
    if (chkcount == 0) {
        $(addBtnId).show();
        $(editBtnId).show();
    }
    else if (chkcount == 1) {
        $(addBtnId).hide();
        $(editBtnId).show();
    }
    else if (chkcount > 1) {
        $(addBtnId).hide();
        $(editBtnId).hide();
    }
    if (chkcount < count)
        $(chkAllId).prop('checked', false);
    else if (chkcount == count) {
        $(chkAllId).prop('checked', true);
    }
}

function changeButtonsBasedOnStatus(ddlId, actInactBtnId) {
    if ($(ddlId).val() == 1) {
        $(actInactBtnId).show();
        $(actInactBtnId).val('InActivate');
        $(actInactBtnId).removeClass('gvVenueDetails_M Activate');
        $(actInactBtnId).addClass('gvVenueDetails_M InActivate');
    }
    else if ($(ddlId).val() == -1) {
        $(actInactBtnId).hide();
    }
    else {
        $(actInactBtnId).show();
        $(actInactBtnId).val('Activate');
        $(actInactBtnId).removeClass('gvVenueDetails_M InActivate');
        $(actInactBtnId).addClass('gvVenueDetails_M Activate');
    }
}

function reverseUnescapeHtml(text) {
    if (text != null) {
        return text.replace(/&#10;/g, "\n")
            .replace(/&apos;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/&#8211;/g, '–')
            .replace(/&amp;/g, '&');
    }
    else return "";
}

function escapeHtml(text) {
    if (text != null) {
        return text.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, "&apos;");
    }
    return "";

}

// Sanitize values used in DOM IDs to prevent XSS (CWE-79) and output encoding issues (CWE-116)
function sanitizeDomSelector(value) {
    value = String(value ?? '');
    if (value.startsWith('#')) {
        return '#' + value.substring(1).replace(/[^a-zA-Z0-9_]/g, '');
    } else if (value.startsWith('.')) {
        return '.' + value.substring(1).replace(/[^a-zA-Z0-9_]/g, '');
    }
    return value.replace(/[^a-zA-Z0-9_]/g, '');
}

function replaceNewLine(text) {
    text = text.replace(new RegExp("\\b" + "\r\n" + "\\b", "g"), '<br/>').replace(/\r\n/, '<br/>');
    text = text.replace(new RegExp("\\b" + "\n" + "\\b", "g"), '<br/>').replace(/\n/g, '<br/>');
    return text;
}

function EmailConfigApply(parameter) {
    var $selector;
    if (parameter.Id != undefined) {
        $selector = parameter.Id;
    }
    else if (parameter.ClassName != undefined) {
        $selector = parameter.ClassName;
    }
    if (emailCfgValues != null && emailCfgValues.length != 0) {
        var item = $.grep(emailCfgValues, function (ele, ind) { return ele.SectionName.toLowerCase() == parameter.SectionName.toLowerCase() });
        if (item != undefined && item.length > 0) {
            $('#hdnIsEmailConfig').val(item[0].IsConfigured);
            if (item[0].IsConfigured == false) {
                $($selector).hide();
            }
        }
    }
}

function ReplacespecialCharcs(strText) {
    return strText.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&apos;/g, "'").replace(/&amp;/g, "&");
}

function CurrentDate() {
    //Date format in MM/DD/YYYY===============START
    var varcurrentDate = "";
    var todaysDate = new Date(); var month = todaysDate.getMonth() + 1; var day = todaysDate.getDate();
    varcurrentDate = (('' + month).length < 2 ? '0' : '') + month + '/' + (('' + day).length < 2 ? '0' : '') + day + '/' + todaysDate.getFullYear();
    return varcurrentDate;
    //Date format in MM/DD/YYYY===============END
}

function AlertShow(message, poplev) {
    var ObjPopLevel = 1; ObjPopLevel = poplev == undefined ? 1 : poplev;
    $('#divAlert' + ObjPopLevel).CMNPopup({
        popUpHeader: "Alert",
        popLevel: ObjPopLevel,
        closeButton: "#btnAlertYes" + ObjPopLevel
    });
    $('#divAlertMessage' + ObjPopLevel).html(message);
}

// Multi Check with Select all Dropdownlist

function CreateMultiCheckDropdown(selectid, url, ddlid, tbid, cvalues, ischeckall, Value, Text) {
    jQuery.ajaxSetup({ async: false, cache: false });

    var width = $('#' + selectid).width();
    var urll = url.replace('/', '_');

    Value = Value || 'Value';
    Text = Text || 'Text';

    var htm = "";
    if (selectid === 'ddlMedView' || selectid === 'ddlCurrentMedIndicator') {
        htm = htm + "<input id='" + ddlid + "val' type='text' readOnly='readOnly' class='droptexthide f14' onclick='showdrop(this)' style='color:darkgrey; font-weight: normal; background-position: right -3159px !important; padding-right: 15px !important' onkeydown='A11yUtil.handleKeyboardClick(event, this)' value='Select' aria-controls='" + ddlid + "chk'/>";
    }
    else {
        htm = htm + "<input id='" + ddlid + "val' type='text' readOnly='readOnly' class='droptexthide' onclick='showdrop(this)' style='color:darkgrey;' onkeydown='A11yUtil.handleKeyboardClick(event, this)' value='Select'/>";
    }
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    if (selectid == 'selCrPlTmCrPlStatus') {
        htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none; width:" + (width + 35) + "px !important;' tabindex='" + tbid + "'>";
    }
    else if (selectid === 'ddlMedView' || selectid === 'ddlCurrentMedIndicator') {
        htm = htm + "<div id='" + ddlid + "chk' class='dropcheck f14' style='display:none;' tabindex='" + tbid + "'>";
    }
    else {
        htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none; width:" + width + "px !important;' tabindex='" + tbid + "'>";
    }
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1'  style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var acval = "";

    var cval = "";
    if (cvalues != null && cvalues !== "")
        cval = cvalues.toString().split(',');

    if (ischeckall != null)
        acval = ischeckall;

    $.getJSON(url, function (data) {
        var itmtxt = "";
        if (data.length > 0) {
            globalChkBoxLength = data.length;
            if (selectid === 'ddlMedView' || selectid === 'ddlCurrentMedIndicator') {
                htm += "<input type='checkbox' id='chkDDSelectAll' value='-1' class='clschkDDSelectAll' onchange='onChkMultiSelectClicked(this,0)'/><div onclick='onSpnMultiSelectClicked(this,0)' class='clschkDDSelectAllSpn' style='cursor:pointer; width: 60px !important;'>Select All</div>";
            }
            else {
                htm += "<input type='checkbox' id='chkDDSelectAll' value='-1' class='clschkDDSelectAll' onchange='onChkMultiSelectClicked(this,0)'/><div onclick='onSpnMultiSelectClicked(this,0)' class='clschkDDSelectAllSpn' style='cursor:pointer;'>Select All</div>";
            }
            $.each(data, function (key, val) {
                val[Text] = $.fn.replaceAndEscapeHtmlExt(val[Text]);
                let isInputChecked = false;
                if (selectid === 'ddlMedView' || selectid === 'ddlCurrentMedIndicator') {
                    if (jQuery.inArray(val[Value], cval) !== -1
                        || jQuery.inArray(val[Value], cvalues) !== -1 || jQuery.inArray(val[Text], cval) !== -1) {
                        htm += "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' checked='checked' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer; width: 60px !important;'>" + val[Text] + "</div><br/>";
                        isInputChecked = true;
                    }
                    else {
                        if (acval == "1") {
                            htm += "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' checked='checked' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer; width: 60px !important;'>" + val[Text] + "</div><br/>";
                            isInputChecked = true;
                        }
                        else {
                            htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer; width: 60px !important;'>" + val[Text] + "</div><br/>";
                        }
                    }
                }
                else {
                    if (jQuery.inArray(val[Value], cval) !== -1
                        || jQuery.inArray(val[Value], cvalues) !== -1 || jQuery.inArray(val[Text], cval) !== -1) {
                        htm += "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' checked='checked' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer;'>" + val[Text] + "</div><br/>";
                        isInputChecked = true;
                    }
                    else {
                        if (acval == "1") {
                            htm += "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' checked='checked' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer;'>" + val[Text] + "</div><br/>";
                            isInputChecked = true;
                        }
                        else {
                            htm = htm + "<input type='checkbox' id='" + ddlid + "' value='" + val[Value] + "' class='chkActivity' onchange='onChkMultiSelectClicked(this,0)' /><div id='" + ddlid + "spn' title='" + val[Text] + "' onclick='onSpnMultiSelectClicked(this,0)' style='curosr:pointer;'>" + val[Text] + "</div><br/>";
                        }
                    }
                }
                if (!isInputChecked) {
                    return;
                }
                if (itmtxt !== '') {
                    itmtxt = itmtxt + "," + val[Text];
                }
                else {
                    itmtxt = val[Text];
                }
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
        clickedbyprg(ddlid, 0);
        let checkCount = itmtxt ? itmtxt.split(',').length : 0;
        //to check the select all check box when all the check boxes are checked
        if (Number(globalChkBoxLength) === checkCount) {
            $("#" + ddlid + "chk").find('.clschkDDSelectAll').prop('checked', true);
        }
        //In case morethan 3 input checkboxes are checked
        if (checkCount > 3 || (checkCount > 2 && ddlid === "ddlCurrentMedIndicator")) {
            if (ddlid === "ddlMedView" || ddlid === "ddlCurrentMedIndicator") {
                $("#" + ddlid + "val").val("Select All");
            } else {
                $("#" + ddlid + "val").val(checkCount + " items Checked");
            }
        }
        else {
            $("#" + ddlid + "val").val(itmtxt !== '' ? itmtxt : 'Select');
        }
    });
    jQuery.ajaxSetup({ async: true, cache: false });

    if (ddlid === 'ddlMedView' || ddlid === 'ddlCurrentMedIndicator') {
        $("#" + ddlid + "val, #" + ddlid + "chk").off("click").on("click", function (event) {
            event.stopPropagation();
        });
        $(document).off("click.ddl" + ddlid).on("click.ddl" + ddlid, function (event) {
            if (!$(event.target).closest("#" + ddlid + "chk").length && !$(event.target).closest("#" + ddlid + "val").length) {
                $("#" + ddlid + "chk").hide();
            } else {
                $(".dropcheck").hide();
                $("#" + ddlid + "chk").toggle();
            }
        });
    }
}

//ipad related

//GCODE START
function RemoveLocalStorage(Obj) {
    if (Obj == undefined || Obj == 1) {
        if (Obj == 1) { $('.CMMenu').show(); $('.UmAgMenu').hide(); }
        if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
        if (localStorage.getItem("AUTH_DATA_AUTH_NO") != null) { localStorage.removeItem("AUTH_DATA_AUTH_NO"); }
        if ($("#MvcMainBody #MainAuth").length > 0) {
            $("#MvcMainBody #MainAuth").removeClass('InAuthPage');
            $("#MvcMainBody #MainAuth").addClass('OutAuthPage');
        }
        if (localStorage.getItem("COMPLAINT_DATA") != null) { localStorage.removeItem("COMPLAINT_DATA"); }
        if ($("#MvcMainBody #MainComplaint").length > 0) {
            $("#MvcMainBody #MainComplaint").removeClass('InComplaintPage');
            $("#MvcMainBody #MainComplaint").addClass('OutComplaintPage');
        }
    }
    else if (Obj == '2') {
        $("#MvcMainBody #MainAuth").removeClass('OutAuthPage');
        $("#MvcMainBody #MainAuth").addClass('InAuthPage');
        $('.CMMenu').hide(); $('.UmAgMenu').show();
        if (localStorage.getItem("COMPLAINT_DATA") != null) { localStorage.removeItem("COMPLAINT_DATA"); }
    }
    else if (Obj == '3') {
        $("#MvcMainBody #MainComplaint").removeClass('OutComplaintPage');
        $("#MvcMainBody #MainComplaint").addClass('InComplaintPage');
        $('.CMMenu').hide(); $('.UmAgMenu').show();
        if (localStorage.getItem("AUTH_DATA") != null) { localStorage.removeItem("AUTH_DATA"); }
        if (localStorage.getItem("AUTH_DATA_AUTH_NO") != null) { localStorage.removeItem("AUTH_DATA_AUTH_NO"); }
    }

}

function ClickFireAuthId(AuthId, PatientId, ActivityLogId, ActivityTypeName) {
    var PI = UmPatient_AuthInfo("", "");
    var retVal = true;
    clearPreAuthCache();
    if (isWfChatOpen && parseInt(PatientId) !== parseInt($("#selectPatientAccessed").val())) {
        postUnsentMessageState('postClickFireAuthId', { AuthId: AuthId, PatientId: PatientId }); //to alert the user if chat popup is opend and any unsent message.
    }
    else {
        if (!$.fn.isNullOrEmpty(ActivityLogId)) {
            var ActivityLogArr = ActivityLogId.split('|');
            var activityLogId = "";
            let parendtActLogId = "";
            if (ActivityLogArr.length >= 0) {
                activityLogId = ActivityLogArr[0];
            }
            $('#hdnMdrActivity').val(activityLogId);
            $('#hdnMdrParentActivity').val(parendtActLogId);
            if (ActivityLogArr.length > 0) {
                parendtActLogId = (ActivityLogArr[1] === "N/A" || ActivityLogArr[1] === "undefined") ? "" : ActivityLogArr[1];
            }
            $('#hdnMdrActivityLogId', PI.AuthTabId).val(activityLogId);
            $('#hdnMdrParentActivityLogId', PI.AuthTabId).val(parendtActLogId);
            $('#hdnMdrReturnActivity').val(parendtActLogId);
            if (!$.fn.isNullOrEmpty(parendtActLogId)) {
                if (ActivityTypeName.toLowerCase() === "additional information requested") {
                    IsFromAdditionalInfoReq = true;
                }
                isMDReviewCalendar = true;
                calendarUmMDRActivityLogId = activityLogId;
                if ($("#MvcMainBody .InAuthPage").length > 0) {
                    umLeftTabGet(true);
                    retVal = false;
                    return retVal;
                }
            } else {
                isMDReviewCalendar = false;
            }
            if (!$.fn.isNullOrEmpty(ActivityTypeName)) {
                $("#selectPatientAccessed").val(PatientId);
            }
            postClickFireAuthId(AuthId, PatientId, activityLogId);
        }
        else {

            $('#hdnMdrActivity').val("");
            postClickFireAuthId(AuthId, PatientId);
        }
    }
    return retVal;
}

function postClickFireAuthId(AuthId, PatientId, ActivityLogId) {
    if (checkUnsentMsgWfChatBox()) {
        flagChangesExistsInAccordion1 = flagChangesExistsInAccordion2 = flagChangesExistsInAccordion3 = flagChangesExistsInAccordion4 = flagChangesExistsInAccordion5 = flagChangesExistsInAccordion6 = flagChangesExistsInAccordion8 = false;
        initialDataForExpandAccordion1Global = initialDataForCollapseAccordion1Global = initialDataForExpandAccordion2Global = initialDataForCollapseAccordion2Global = initialDataForExpandAccordion3Global = initialDataForCollapseAccordion3Global = [];
        initialDataForExpandAccordion4Global = initialDataForCollapseAccordion4Global = initialDataForExpandAccordion5Global = initialDataForCollapseAccordion5Global = initialDataForExpandAccordion6Global = initialDataForCollapseAccordion6Global = [];
        initialDataForExpandAccordion8Global = initialDataForCollapseAccordion8Global = [];
        flagValidationInDiagProcedureSection = false;

        if (PatientId !== 0 && (IsAlertAcknowledgementRequired === 'True' && $('#selectPatientAccessed').val() !== PatientId)) {
            GetPatientAlertsAndAcknowledge(PatientId, AuthId, 0, 'auth', '');
        }
        else {
            clearPreAuthCache();
            GetAuthDetails('AUTH_ID', AuthId, ActivityLogId);
        }
    }
}

/*PROD-19169 === START  KP*/
function GetPatientAlertsAndAcknowledge(PatientId, AuthId, AuthNo, source, obj) {
    var patientData = { patientVal: PatientId };
    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: patientData,
        success: function (dataProfileConfig) {
            if (dataProfileConfig) {
                $.ajax({
                    type: "POST",
                    url: baseURL + "/Common/IndicatorAlertCountUpdate?patientId=" + PatientId,
                    dataType: "json",
                    success: function (data) {
                        if (data.success != 0) {
                            $("#hdnTotalAlertsCount").val(data.success);
                            $('#DivPatientAlerts').html('');//if alerts pop up is opened at member level and after if clicked on any member alerts grid is not binding
                            $('#popUpDialog3').CMNPopup({
                                pvUrl: baseURL + "/CommonDefaultSessionState/PatientAlerts?patientId=" + PatientId,
                                popUpHeader: "Alerts",
                                modalWidth: MODAL_WIDTH.MEDIUM,
                                popLevel: ($('#popUpDialog1').is(':visible')) ? 2 : 1,
                                onClose: function () {
                                    if ($('#hdnIsPatientAlertsPopup').length > 0) {
                                        if (($("#hdnAcknowledgedAlertCount").val() != '' && $("#hdnAcknowledgedAlertCount").val() == 0) || $("#hdnTotalAlertsCount").val() == '0') {
                                            navigToSourceFunction(source, PatientId, AuthId, obj, AuthNo)
                                        }
                                        else {
                                            A11yAlerts.createWarningAlert('#GCHomeAlertAckMandatory', 'Alert acknowledgement is mandatory to access a member.');
                                            if ($("#lbShowCriteria").is(':visible') && $("#lbShowCriteria").val() == 'Show') {
                                                $("#lbShowCriteria").trigger('click');
                                            }

                                            if (source == 'umrecentauths') {
                                                $('input[id*=RadioBtn_]').attr('checked', false);
                                            }
                                        }
                                        $("#hdnTotalAlertsCount").val('');
                                        $("#hdnAcknowledgedAlertCount").val('');
                                        $('#popUpDialog3').html('');
                                        acknowledgedAlertIds = [];
                                    }
                                }
                            });
                        }
                        else {
                            navigToSourceFunction(source, PatientId, AuthId, obj, AuthNo)
                        }
                    },
                    error: function () {
                        isFromUpdateAuth = false;
                        CustomAlert("Error Encountered");
                    }
                });
                $('#hdnIsDropdownChange').val('');
            }
            else {
                CustomAlert("You Can't Access this Patient");
            }
        },
        error: function (err) {
            console.log(err);
        }
    });

}
/*PROD-19169 === END*/

function navigToSourceFunction(source, PatientId, AuthId, obj, AuthNo) {
    clearPreAuthCache();
    if (source == 'auth') {
        GetAuthDetails('AUTH_ID', AuthId, 'AUTH_ID');
    }
    else if (source === 'umact') {
        isRedirectToAuthActivity = 1;
        PerformActivityAuthDetails(AuthNo, PatientId);
    }
    else if (source === 'quicksrchaddauth') {
        showAddAuthWindow();
    }
    else if (source === 'quicksrchviewauth') {
        showViewAuthWindow();
    }
    else if (source === 'bulkreferral') {
        window.top.SetAuthPatientData(obj);
    }
    else if (source === 'cntxmenu') {
        isFromUpdateAuth = true;
        SetAuthDatanew(PatientId, AuthId, obj, AuthNo);
    }
    else if (source === 'umauthaccept') {
        UMAuthAccept(obj, AuthNo); // here authno means listReferralId
    }
    else if (source === 'umauthacceptmal') {
        UMAuthAccept(obj, AuthNo, 'mal'); // here authno means listReferralId
    }
    else if (source === 'umrecentauths') {
        umTabShow(PatientId, obj, AuthNo, 0); // Here Obj means "AuthClassId"
        ModalClose();
        AllowPageScroll();
    }
    else if (source === 'phscriptform') {
        moveToScriptForm(obj);
    }
    else {
        //for sonar
    }
}
function moveToScriptForm(val) {
    assessmentProviderReviewId = $(val).attr('data-ReferenceId');
    careActivityTypeId = $(val).attr('data-CareActivityTypeId');
    var scriptFormId = $(val).attr('data-ScriptFormId');
    var scriptStatus = $(val).attr('data-ScriptStatus');
    var isFromPH = 1;
    var PatientId = $(val).attr('data-patientid');
    if (scriptStatus.toLowerCase() === 'pending') {
        $.ajax({
            type: "GET",
            url: baseURL + "/Home/CheckScptFormStatus?ScptFormId=" + scriptFormId + "&patientId=" + PatientId,
            dataType: "json",
            success: function (data) {
                if (data.success === true) {
                    SetFireMethodRes(PatientId);
                    setpatinfo(PatientId);
                    setactionitems();
                    loader(1);
                    (CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + "|" + 0 + "|" + "|" + 0, 0, 0, 0, 0, isFromPH), function (_AR) {
                        loader(0);
                    });
                }
            }
        });
    }
    else if (scriptStatus.toLowerCase() === 'completed') {
        var ScriptRunLogId = $(val).attr('data-ScriptRunLogId');
        var patientScriptFormId = $(val).attr('data-SfpId');
        if (patientScriptFormId === '0') {
            $.ajax({
                type: "GET",
                url: baseURL + "/ScriptForm/ScptFormPatientDataGenerate?scptFormId=" + scriptFormId + "&patientId=" + PatientId + "&scriptRunLogId=" + ScriptRunLogId,
                dataType: "json",
                success: function (spfId) {
                    patientScriptFormId = spfId;
                    SetFireMethodRes(PatientId);
                    setpatinfo(PatientId);
                    setactionitems();
                    loader(1);
                    (CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + patientScriptFormId + "|" + 1 + "|" + ScriptRunLogId, 0, 0, 0, 0, isFromPH), function (_AR) {
                        loader(0);
                    });
                }
            });
        }
        else {
            SetFireMethodRes(PatientId);
            setpatinfo(PatientId);
            setactionitems();
            loader(1);
            (CallAllCtrls(2, 21, "~/App_Pages/CM/Manage/ScriptForms.ascx", 0, '1200', scriptFormId + "|" + patientScriptFormId + "|" + 1 + "|" + ScriptRunLogId, 0, 0, 0, 0, isFromPH), function (_AR) {
                loader(0);
            });
        }

    }
    else {
        //for sonar
    }
}

function calendarAgMdrReturnActivity(ctrlId) {
    $('#closePopUp').trigger('click');
    var ParamArr = ctrlId.id.split('|');
    var actId = $(ctrlId).attr('data-actid');
    var actLevelId = $(ctrlId).attr('data-levelid');

    if (ParamArr.length > 4) {
        var ActivityLogId = actId != null ? actId : undefined;
        var ComplaintRecordId = ParamArr[1];
        var PatientId = ParamArr[0];
        var ActivityLogIdStr = '|' + ActivityLogId + '|' + actLevelId;
        isMDReviewCalendar = true;
        IsFromAdditionalInfoReq = false;
        $('#hdnMdrParentActivity').val(ActivityLogId);
        $('#hdnMdrParentActivity').attr('data-levelid', actLevelId);

        postClickFireComplaintId(ComplaintRecordId, PatientId, ActivityLogIdStr, 'MD Review Completed');
    }
}

//PROD-19172 - START
function ClickFireComplaintId(ComplaintId, PatientId, ActivityLogId, ActivityTypeName) {
    if (isWfChatOpen && parseInt(PatientId) !== parseInt($('#selectPatientAccessed').val())) {
        postUnsentMessageState('postClickFireComplaintId', { ComplaintId: ComplaintId, PatientId: PatientId }); //to alert the user if chat popup is opend and any unsent message.
    }
    else {

        if (!$.fn.isNullOrEmpty(ActivityLogId)) {
            var ActivityLogArr = ActivityLogId.split('|');
            var activityLogId = "";
            let parendtActLogId = "";
            if (ActivityLogArr.length > 0) {
                activityLogId = ActivityLogArr[0];
            }
            $('#hdnMdrActivity').val(activityLogId);
            $('#hdnMdrParentActivity').val(parendtActLogId);
            if (ActivityLogArr.length > 1) {
                parendtActLogId = (ActivityLogArr[1] === "N/A" || ActivityLogArr[1] === "undefined") ? "" : ActivityLogArr[1];
            }
            if (ActivityLogArr.length > 2 && !$.fn.isNullOrEmpty(ActivityLogArr[2]) && Number(ActivityLogArr[2]) > 0) {
                $('#hdnMdrActivityLevelId').val(ActivityLogArr[2]);
            }
            if (!$.fn.isNullOrEmpty(parendtActLogId)) {
                if (!$.fn.isNullOrEmpty(ActivityTypeName) && ActivityTypeName.toLowerCase() === "additional information requested") {
                    //Code for Adition Info Requested workflow
                    IsFromAdditionalInfoReq = true;
                }
                isMDReviewCalendar = true;
            } else {
                isMDReviewCalendar = false;
            }
            if (!$.fn.isNullOrEmpty(ActivityTypeName) && ActivityTypeName === "FromAirCalender") {
                IsFromAdditionalInfoReq = true;

            }

            postClickFireComplaintId(ComplaintId, PatientId, ActivityLogId, ActivityTypeName);
        }
        else {

            $('#hdnMdrActivity').val("");
            postClickFireComplaintId(ComplaintId, PatientId, ActivityLogId, ActivityTypeName);
        }
    }
}

function postClickFireComplaintId(ComplaintId, PatientId, activityLogId, activityTypeName) {
    if (checkUnsentMsgWfChatBox()) {
        if (IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != PatientId) {
            GetAGPatientAlertsAndAcknowledge(PatientId, ComplaintId, 0, 'complaint');
        }
        else {
            GetComplaintData(ComplaintId, undefined, activityLogId, activityTypeName);
        }
    }
}
function GetAGPatientAlertsAndAcknowledge(PatientId, ComplaintId, ComplaintTypeId, source, listReferralId, isFromWLM) {
    var patientData = { patientVal: PatientId };
    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: patientData,
        success: function (dataProfileConfig) {
            if (dataProfileConfig) {
                $.ajax({
                    type: "POST",
                    url: baseURL + "/Common/IndicatorAlertCountUpdate?patientId=" + PatientId,
                    dataType: "json",
                    success: function (data) {
                        if (data.success != 0) {
                            ModalClose(); //PROD-52478
                            $("#hdnTotalAlertsCount").val(data.success);
                            $('#DivPatientAlerts').html('');//if alerts pop up is opened at member level and after if clicked on any member alerts grid is not binding
                            $('#popUpDialog3').CMNPopup({
                                pvUrl: baseURL + "/CommonDefaultSessionState/PatientAlerts?patientId=" + PatientId,
                                popUpHeader: "Alerts",
                                modalWidth: MODAL_WIDTH.MEDIUM,
                                popLevel: 2,
                                onClose: function () {
                                    if ($('#hdnIsPatientAlertsPopup').length > 0) {
                                        if (($("#hdnAcknowledgedAlertCount").val() != '' && $("#hdnAcknowledgedAlertCount").val() == 0) || $("#hdnTotalAlertsCount").val() == '0') {
                                            if (source == 'complaint') {
                                                GetComplaintData(ComplaintId);
                                            }
                                            else if (source == 'complaintact') {
                                                isRedirectToComplaintActivity = 1;
                                                GetComplaintData(ComplaintId);
                                            }
                                            else if (source == 'complaint_update') {
                                                isFromOpenComplaintEdit = true;
                                                SetComplaintData(PatientId, ComplaintId, ComplaintTypeId, null, null, null);
                                            }
                                            else if (source == 'complaint_accept') {
                                                AcceptReqReceivedAGComplaint(listReferralId, ComplaintId, isFromWLM, PatientId);
                                            }
                                            else if (source == 'complaint_accept_MAL') {
                                                AcceptReqReceivedAGComplaint(listReferralId, ComplaintId, 'MAL', PatientId);
                                            }
                                            else if (source == 'view_Complaint') {
                                                showViewComplaintWindow();
                                            }
                                            else if (source == 'agrecentcomplaints') {
                                                GetComplaintData(ComplaintId);
                                                ModalClose();
                                                AllowPageScroll();
                                            }
                                            else if (source === 'view_pro_Complaint') {
                                                showComplaintData();
                                            }
                                            else {
                                                //sonar qube
                                            }
                                        }
                                        else {
                                            A11yAlerts.createWarningAlert('#GCHomeAlertAckMandatory', 'Alert acknowledgement is mandatory to access a member.');
                                            if (isFromWLM == '1') {
                                                $('.AGPendingComplaintsGridchildcheckbox').prop('checked', false);
                                                $('.AGPendingComplaintsGridparentcheckboxHead').prop('checked', false);
                                                ShowHideReferAcceptRejectBtns('AGPendingComplaintsGridchildcheckbox', 'clsAgComplaintRefer', 'btnAgComplaintAccept', 'btnAgComplaintReject');
                                            }
                                            else {
                                                $('.clsRefralChkMember').prop('checked', false);
                                            }
                                            if (source == 'agrecentcomplaints') {
                                                $('input[id*=RadioBtn_]').attr('checked', false);
                                            }
                                        }
                                        $("#hdnTotalAlertsCount").val('');
                                        $("#hdnAcknowledgedAlertCount").val('');
                                        $('#popUpDialog3').html('');
                                        acknowledgedAlertIds = [];
                                    }
                                }
                            });
                        }
                        else {
                            if (source == 'complaint') {
                                GetComplaintData(ComplaintId);
                            }
                            else if (source == 'complaintact') {
                                isRedirectToComplaintActivity = 1;
                                GetComplaintData(ComplaintId);
                            }
                            else if (source == 'complaint_update') {
                                isFromOpenComplaintEdit = true;
                                SetComplaintData(PatientId, ComplaintId, ComplaintTypeId, null, null, null);
                            }
                            else if (source == 'complaint_accept') {
                                AcceptReqReceivedAGComplaint(listReferralId, ComplaintId, isFromWLM, PatientId);
                            }
                            else if (source == 'complaint_accept_MAL') {
                                AcceptReqReceivedAGComplaint(listReferralId, ComplaintId, 'MAL', PatientId);
                            }
                            else if (source == 'view_Complaint') {
                                showViewComplaintWindow();
                            }
                            else if (source == 'agrecentcomplaints') {
                                GetComplaintData(ComplaintId);
                                ModalClose();
                                AllowPageScroll();
                            }
                            else if (source === 'view_pro_Complaint') {
                                showComplaintData();
                            }
                            else {
                                //sonar qube
                            }
                        }
                    },
                    error: function () {
                        CustomAlert("Error Encountered");
                    }
                });
                $('#hdnIsDropdownChange').val('');
            }
            else {
                CustomAlert("You Can't Access this Patient");
            }
        },
        error: function (err) {
            isFromOpenComplaintEdit = false;
            console.log(err);
        }
    });
}
//PROD-19172 - END
function RemoveSeconds(SourceObj) {
    return SourceObj.toLocaleString().replace(/:\d{2}\s/, ' ');
}

function OpenAuthorizationActivityTypeToolTipTemplate(data) {
    var html = '';
    var ActivityTypeName = '';
    if (data.ActivityTypeName != null && data.ActivityTypeName != '') {
        ActivityTypeName += "<ul>";
        ActivityTypeName += data.ActivityTypeName.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] });
        ActivityTypeName += " </ul> ";
    }
    else
        ActivityTypeName = "N/A";
    var nextActivityReviewDate = data.NextActivityReviewDate && data.NextActivityReviewDate != 'null' ? StandardTimeFormat(data.NextActivityReviewDate) : 'N/A';
    html = html + "<div class='hOverOpenAuthorization' style='width:100%;height:100%;cursor:pointer;' title='<span align=center style=font-weight:bold;text-decoration:underline;>Activity Type :</span><div> " + ActivityTypeName + " </div>'>" + nextActivityReviewDate + " </div>";
    return html;
}

/*Replace special CHAR with HTML and vice versa*/
if (typeof String.prototype.replaceSpecialChar !== 'function') {
    String.prototype.replaceSpecialChar = function (actualParams) {
        var defaults = { exceptionalChar: '', splitChar: ',', replaceCharType: 'HTML', actualCharType: 'CHR', replaceChars: [], actualChars: [] };
        var params = $.extend(defaults, actualParams);
        var replaceChar = [];
        var actualChar = [];
        var unRemovalChar = params.exceptionalChar === undefined ? '' : params.exceptionalChar.split((params.splitChar === undefined ? ',' : params.splitChar));
        if (params.replaceCharType === undefined) {
            params.replaceCharType = 'HTML';
        }
        if (params.actualCharType === undefined) {
            params.actualCharType = 'CHR';
        }

        if (params.replaceChars.length > 0) {
            replaceChar = params.replaceChars;
        }

        if (params.actualChars.length > 0) {
            actualChar = params.actualChars;
        }

        if (replaceChar.length == 0) {
            switch (params.replaceCharType) {
                case 'HTML':
                    replaceChar = ["&amp;", "&gt;", "&lt;", "&quot;", "&#039;", "@", "#", "$", "%", "^", "=", "+", "{", "[", "]", "}", ";", ":", ",", "/", "?", "`"];
                    break;
                case 'CHR':
                    replaceChar = ["&", ">", "<", '"', "'", "@", "#", "$", "%", "^", "=", "+", "{", "[", "]", "}", ";", ":", ",", "/", "?", "`"];
                case 'ESCAPE':
                    replaceChar = ["%26", "%3E", "%3C", '%22', "'", "%40", "%23", "%24", "%25", "%5E", "%3D", "%2B", "%7B", "%5B", "%5D", "%7D", "%3B", "%3A", "%2C", "%2F", "%3F", "%60"];
            }
        }

        if (actualChar.length == 0) {
            switch (params.actualCharType) {
                case 'CHR':
                    actualChar = [/&/g, />/g, /</g, /"/g, /'/g, /@/g, /#/g, /$/g, /%/g, /^/g, /=/g, '+', /{/g, '[', /]/g, /}/g, ';', /:/g, /,/g, "/", "?", /'/g];
                    break;
                case 'HTML':
                    actualChar = [/&amp;/g, /&gt;/g, /&lt;/g, /&quot;/g, /&#039;/g, /@/g, /#/g, /$/g, /%/g, /^/g, /=/g, '+', /{/g, '[', /]/g, /}/g, ';', /:/g, /,/g, "/", "?", "`"];
                    break;
                case 'ESCAPE':
                    actualChar = [/%26/g, /%3E/g, /%3C/g, /%22/g, /'/g, /%40/g, /%23/g, /%24/g, /%25/g, /%5E/g, /%3D/g, /%2B/g, /%7B/g, /%5B/g, /%5D/g, /%7D/g, /%3B/g, /%3A/g, /%2C/g, /%2F/g, /%3F/g, /%60/g];
            }
        }

        var str = this;
        if (str) {

            for (var index = 0, len = actualChar.length; index < len; index++) {
                if (unRemovalChar !== '' && unRemovalChar.indexOf(actualChar[index]) === -1) {
                    str = str.replace(actualChar[index], replaceChar[index]);
                }
            }
        }
        return str;
    }
}

function isFileLocked(messageId, divId, msgInfo, sentType, callback, isForArchive = false ) {
    loader(1);
    $.ajax({
        type: "GET",
        dataType: "json",
        async: false,
        contentType: "application/json; charset=utf-8",
        url: baseURL + "/RequestReceivedDashboard/GetFileLockInfo?messageId=" + messageId + "&isForArchive=" + isForArchive,
        success: function (data) {
            loader(0);
            let returnData = false;
            if (data !== null) {
                returnData = data.isLocked;
                if (!isForArchive && returnData && data.data != null) {
                    let html = "";
                    html = html + "<div class='gc_warning faxLockMsg'>";
                    html = html + "<span class = 'lblFaxLockvalidationMessage' class='float-left ItemPR20'>";
                    html = html + "The file is currently locked by " + escapeHtml(data.data[0].CareStaffName) + ", " + escapeHtml(data.data[0].RoleName) + ".";
                    html = html + "<button class='S_Plan_ML_50 ah-btn ah-btn-link Bold unlockFax' id='unlockFile' data-msginfo='" + msgInfo + "' data-senttype='" + sentType + "' onclick=updateFaxAccessData(" + messageId + ",false," + ((divId !== "#containerFaxLockMessage") ? 'this' : "'" + msgInfo + "'") + ")>Unlock Fax</button>";
                    html = html + '<button class="S_Plan_ML_50 ah-btn ah-btn-link Bold unlockFaxCancel" id="cancelUnlockFile" onclick="closeFileValidation(\'' + divId + '\',\'' + msgInfo + '\')">Cancel</button></span>';
                    html = html + "<div class='clear'></div></div>";
                    $(divId).html("").html(html);
                    $(divId).show();
                    if ($("#divRequestReceivedGrid").is(":visible")) {
                        $(window).scrollTop(0);
                    }
                    applyUnlockFaxRolePermissions('unlockFax');
                }
                else {
                    $(divId).html("").hide();
                }
            }
            if (callback && typeof (callback) == "function") {
                if (isForArchive) {
                    callback(data != null ? data : []);
                } else {
                    callback(returnData);
                }
            }
        },
        error: function () {
            loader(0);
            if (callback && typeof (callback) == "function") { callback(false); }
        }
    });
}

function closeFileValidation(divId, msgInfo) {
    if ($(divId).is(":visible")) {
        let prependText = divId === "#activityLogFaxLockMessage" ? "MAL_reqRecMsg_" : "reqRecMsg_";
        $(divId).html("").hide();
        if (divId === "#activityLogFaxLockMessage") {
            $(window).scrollTop($("#divRequestReceivedGrid").offset().top);
        }
        if (msgInfo !== null && msgInfo.indexOf("!") !== -1) {
            A11yUtil.setFocus(prependText + msgInfo.split('!')[1]);
        } else {
            A11yUtil.setFocus(msgInfo);
        }
    }
}

function updateFaxAccessData(messageId, lockFile, obj, releaseFile = false, patientid) {
    $.ajax({
        type: "POST",
        dataType: "json",
        data: { memberId: memberidval, messageId: messageId, lockFile: lockFile, releaseFile: releaseFile, patientId: patientid },
        url: baseURL + "/RequestReceivedDashboard/InsertUpdateFileAccessInfo",
        success: function (data) {
            $(".faxLockMsg").html("").hide();
            var status = isMAL ? $("#selMessageTypeRRcMAL").val() : $("#selMessageType").val();
            if (data.success && obj !== null && typeof (obj) !== 'string') {
                validateFaxFileNavigateToView(messageId, "Work on Fax", status);
            }
        }
    });
}

function applyUnlockFaxRolePermissions(cls) {
    var itemAgEntry = getSpecRoleItem("DASH_BOARD_REQ_REC_FAX_UNLOCK_PERMISSIONS", true);
    if (itemAgEntry != null && itemAgEntry.length > 0 && (itemAgEntry[0].IsAdd == false && itemAgEntry[0].IsView == true)) {
        $("." + cls).ApplyRoleConfig({ Id: cls, UniqueName: "DASH_BOARD_REQ_REC_FAX_UNLOCK_PERMISSIONS", IsFrom: "Add", CustTitle: "The role level permission is not configured for the user to unlock this fax." });
    }
    else {
        $("." + cls).ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_FAX_UNLOCK_PERMISSIONS", IsFrom: "Add", CustTitle: "The role level permission is not configured for the user to unlock this fax." });
    }
    A11yModal.trapFocusInModal('faxLockMessage', '#unlockFile,#cancelUnlockFile');
    A11yUtil.setFocus("unlockFile");
    if (!itemAgEntry[0].IsView) {
        $("." + cls).hide();
        A11yUtil.setFocus("cancelUnlockFile");
    }
}

function openFaxFile(obj) {
    loader(1);
    let spiltInfo = $(obj).attr('data-msginfo').split('!');
    if (spiltInfo.length >= 6) {
        var messageId = spiltInfo[1];
        var progId = spiltInfo[2];
        var msgType = $(obj).attr('data-SentType')
        var attachmentPath = spiltInfo[3];
        var attachmentCount = spiltInfo[4];
        var documentGuid = spiltInfo[5];
        if (attachmentCount == 1 && '@ViewBag.ReqRecIsPh' == 'True') {
            var res = attachmentPath.split(".");
            var len = res.length;
            var ext = res[len - 1];
            if (ext == 'xml') {
                $.ajax({
                    type: "GET",
                    async: true,
                    url: baseURL + "/Common/AttachmentFilesGet?messageId=" + messageId,
                    success: function (attachmentsData) {
                        var data = attachmentsData.Data[0];
                        $.ajax({
                            type: "GET",
                            async: true,
                            url: baseURL + "/download/tokenAsync?FileId=" + data.MpMemberMessageAttachmentsId + "&EntityType=CMMessageAttachment",
                            success: function (tokendata) {
                                $('#popUpDialog2').CMNPopup({
                                    pvUrl: baseURL + "/Common/ShowCcdaFiles?gc-fd-token=" + tokendata.token + "&is_CCDA=" + true,
                                    popUpHeader: "C-CDA File",
                                    popLevel: 2
                                });
                            },
                            error: function () {
                                loader(0);
                            }
                        });
                    },
                    error: function () {
                        loader(0);
                    }
                });
            }
            else {
                $('#popUpDialog1').CMNPopup({
                    pvUrl: baseURL + "/Common/ShowMsgAttachments?messageId=" + messageId,
                    popUpHeader: "Attachments",
                    popLevel: 1
                });
            }
        }
        else if (msgType == "Fax") {
            var PatientId = $(obj).attr('data-PatientId');
            if (PatientId != null && PatientId > 0) {
                var isRead = $("#selMessageType").val();
                if ($("#selMessageTypeRRcMAL").length > 0)
                    isRead = $("#selMessageTypeRRcMAL").val();
                validateFaxFileNavigateToView(messageId, "View", isRead);
            }
            else {
                validateFaxFileNavigateToView(messageId, "Attach");
            }
        } else {
            $('#popUpDialog1').CMNPopup({
                pvUrl: baseURL + "/Common/ShowMsgAttachments?messageId=" + messageId,
                popUpHeader: "Attachments",
                popLevel: 1
            });
        }
        loader(0);
    }
}

function validateFaxFileNavigateToView(messageId, type, isRead) {
    loader(1);
    $.ajax({
        type: "POST",
        url: baseURL + "/Home/ValidateFaxFiles?messageId=" + messageId,
        dataType: "json",
        success: function (data) {
            if (data.Msg && data.Msg != "") {
                if (data.Msg == "NoFile") {
                    loader(0);
                    CustomAlert('No File Found');
                    $("#divFaxResponsePopup").AhsSetHtml('No File Found');
                    $('#txtFaxFileRename').val('');
                    $('#hdnFaxFileName').val('');
                    $('#lblFileName').AhsSetHtml('No File Found');
                    $('#btnFileNameEdit').AhsSetAttr('disabled', true);
                }
                else if (data.Msg == "NoSupport") {
                    loader(0);
                    $('#txtFaxFileRename').val('');
                    $('#hdnFaxFileName').val('');
                    $('#lblFileName').AhsSetHtml('No File Found');
                    $('#btnFileNameEdit').AhsSetAttr('disabled', true);
                    CustomAlert('Selected file preview is not supported by the GuidingCare system.');
                }
                else if (data.Msg == "Valid") {
                    if ($.fn.isValidJSON(data.JsonData)) {
                        currentFaxId = messageId;
                        var cacheJsonData = cacheData("OcrJsonData_" + currentFaxId);
                        if (cacheJsonData === null) {
                            cacheData({ key: "OcrJsonData_" + currentFaxId, value: data.JsonData, maxage: 120 }, true);
                        }
                    }
                    if ($.fn.isValidJSON(data.JsonDataOriginal)) {
                        currentFaxId = messageId;
                        var cacheOriginalJsonData = cacheData("OcrJsonDataOriginal_" + currentFaxId);
                        if (cacheOriginalJsonData === null) {
                            cacheData({ key: "OcrJsonDataOriginal_" + currentFaxId, value: data.JsonDataOriginal, maxage: 120 }, true);
                        }
                    }
                    $('#txtFaxFileRename').val(data.FileName.split('.').slice(0, -1).join('.'));
                    $('#hdnFaxFileName').val(data.FileName.split('.').slice(0, -1).join('.'));
                    $('#btnFileNameEdit').removeAttr('disabled');
                    $('#lblFileName').AhsSetHtml(data.FileName);
                    if (localStorage.getItem("FAX_ATTACH_ID") != null) {
                        localStorage.removeItem("FAX_ATTACH_ID");
                    }
                    localStorage.setItem("FAX_ATTACH_ID", data.MpMemberMessageAttachmentsId);
                    localStorage.setItem("FAX_EXT", data.Extension);
                    loader(0);
                    var status = isMAL ? $("#selMessageTypeRRcMAL").val() : $("#selMessageType").val();
                    if (!(status !== 'true' && (type.toLowerCase() === 'view' || type.toLowerCase() === 'attach'))) {
                        updateFaxAccessData(messageId, true, null);
                    }
                    if (type.toLowerCase() === "view") {
                        var isPH = ((PHNavID == '' && buildctrl.toLowerCase() == 'cpindex') || (PHNavID == '1')) ? true : false;
                        $.ajax({
                            type: "GET",
                            async: true,
                            url: baseURL + "/download/tokenAsync?FileId=" + data.MpMemberMessageAttachmentsId + "&EntityType=CMMessageAttachment",
                            success: function (tokendata) {
                                $('#popUpDialog1').CMNPopup({
                                    pvUrl: baseURL + "/Home/FaxResponse?messageId=" + data.MessageId + '&fileName=' + data.FileName + '&fileExt=' + data.Extension + '&isRead=' + isRead + '&isPH=' + isPH + '&gc_fd_token=' + tokendata.token,
                                    onLoad: function () {
                                    },
                                    onClose: function () {
                                        if (isRead === "false") {
                                            $("#dvLoadReqRecGridData #ReqRecGrid").data("kendoGrid").dataSource.read();
                                        }
                                        updateFaxAccessData(data.MessageId, false, null, true);
                                    },
                                    popUpHeader: "View Message",
                                    closeButton: '#btnCancelViewFax'
                                });
                            },
                            error: function () {
                                loader(0);
                            }
                        });
                    }
                    else {
                        if (type.toLowerCase() === "work on fax" || type.toLowerCase() === "nextfax") {
                            $('#txtFaxFileRename').val(data.FileName.split('.').slice(0, -1).join('.'));
                            $('#hdnFaxFileName').val(data.FileName.split('.').slice(0, -1).join('.'));
                            $('#lblFileName').AhsSetHtml(data.FileName);
                            $('#btnFileNameEdit').removeAttr('disabled');
                            var faxOCRData;
                            if (isFaxOCREnabled) {
                                var cacheJsonOcrData = cacheData("OcrJsonData_" + currentFaxId);
                                if (cacheJsonOcrData && $.fn.isValidJSON(cacheJsonOcrData)) {
                                    faxOCRData = JSON.parse(cacheJsonOcrData);
                                }
                            }

                            $.ajax({
                                type: "GET",
                                async: true,
                                url: baseURL + "/download/tokenAsync?FileId=" + data.MpMemberMessageAttachmentsId + "&EntityType=CMMessageAttachment",
                                success: function (tokendata) {
                                    $.get(baseURL + "/Home/FaxMemberSearchAndLink?messageId=" + data.MessageId + '&fileName=' + data.FileName + '&fileExt=' + data.Extension + '&gc_fd_token=' + tokendata.token, null, function (result) {
                                        fnFaxPopUp(result, function () {
                                            if (!$.fn.isNullOrEmpty(faxOCRData)) {
                                                faxSearchHighlight(faxOCRData);
                                            } else {
                                                $('#FaxGridQuickSearch').data('kendoGrid').dataSource.fetch();
                                            }
                                            if (data.Extension.toLowerCase() === '.tif' || data.Extension.toLowerCase() === '.tiff') {
                                                $('.fax_container #viewerContainer').hide();
                                                $('.fax_container #iconContainer').hide();
                                                $('#linkFaxDetails').css("width", "100%", "important");
                                            }
                                            $("#divpdfdisplay").hide();
                                            $("#divFaxResponsePopup").AhsSetHtml("there are files");
                                            A11yModal.trapFocusInModal('faxMainDiv', "#faxMinimizeBtn,#faxMaximize");
                                            A11yUtil.setFocus('faxMinimizeBtn');
                                            loader(0);
                                        });
                                    });
                                },
                                error: function () {
                                    loader(0);
                                }
                            });
                        }
                        else {
                            $.ajax({
                                type: "GET",
                                async: true,
                                url: baseURL + "/download/tokenAsync?FileId=" + data.MpMemberMessageAttachmentsId + "&EntityType=CMMessageAttachment",
                                success: function (tokendata) {
                                    var response = 'Common/ShowFileV2?gc_fd_token=' + tokendata.token;
                                    window.open(response, (window.browserPopUpName || window.top.browserPopUpName), "width=600, height=400, scrollbars=yes");
                                }
                            });
                        }
                    }
                }
                else {
                    loader(0);
                }

            }
            else {
                loader(0);
            }
        },
        error: function () {
            loader(0);
        }
    });
}

function OpenAddActivty(patientId) {
    loader(1);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Home/EditActivity?patientId=" + patientId,
        onLoad: function () {
            onLoadEditActivity();
            ClearTableMenu('MyMembersGridNew', 'divMemberMenu');
            loader(0);
            A11yModal.trapFocusInModal('popUpDialog1');
        },
        onClose: function () {
            ClearActivityHdnCntrls();
        },
        popUpHeader: "Add Activity",
        modalWidth: MODAL_WIDTH.MEDIUM,
        closeButton: "#btnCloseEditActivityForm"
    });
}

function GetGroupActivityParticipants(module, queueId, sender, referType, patientId) {
    loader(1);
    if (queueId == null && sender.className != null) {
        if (sender != undefined && sender != null) { queueId = sender.className; }
    }

    var getURL = "", messageHeader = "Activity";

    if (referType == undefined || referType == "") { referType = requestReferTypeGlobal; }
    if (referType == "Member") { messageHeader = "Member"; }
    else if (referType == "UM Auth") { messageHeader = "Authorization"; }
    else if (referType == "AG Complaint") { messageHeader = "Complaint"; }
    else if (referType == "Activity") { messageHeader = "Activity"; }
    if (module === "CM" && referType === "Messages" || referType === "Faxes") {
        $('#popUpDialog1').CMNPopup({
            pvUrl: baseURL + "/Common/CMMessagesParticipantsDetails?messageId=" + queueId,
            popLevel: 0,
            popUpHeader: 'Work Queue Activity Participants',
            closeButton: '#closebutton',
            onClose: function () {
                $('#popUpDialog1').html('');
            }
        });

    }
    else {
        if (module === "CM") {
            getURL = baseURL + "/Home/GetGroupActivityParticipantsDetails?queueId=" + queueId + "&referType=" + referType + "&patientId=" + patientId;
        }
        else if (module == "UM") {
            getURL = baseURL + "/Authorization/GetUMGroupActivityParticipantsDetails?queueId=" + queueId + "&referType=" + referType;
        }
        else if (module == "AG") {
            getURL = baseURL + "/Common/GetAGGroupActivityParticipantsDetails?queueId=" + queueId + "&referType=" + referType;
        }

        $.ajax({
            type: "GET",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            url: getURL,
            success: function (data) {
                var strHtml = '';
                strHtml += '<div class="dasWqpopup" style="max-height:80vh;max-width:917px;min-width:400px;overflow-y:auto;padding:15px;"><table cellpadding="4" cellspacing="0" border="1" width="100%" class="ItemMB10">';
                strHtml += '<tr><td width="25%" style="background-color:#ddd;"><b>Participants</b></td><td width="60%" style="background-color:#ddd;"><b>Work Queues</b></td><td width="15%" style="background-color:#ddd;"><b>Status</b></td></tr>';
                if (queueId > 0 && ToValue(data, '') !== '') {
                    data.Data.forEach(function (val, ind) {
                        var splittedVals = data.Data[ind].split('|');
                        strHtml += '<tr><td style="word-break: break-word; word-break: break-all;overflow-wrap: break-word;">';
                        strHtml += escapeHtml(splittedVals[0]);
                        strHtml += '</td>';
                        strHtml += '<td style="word-break: break-word; word-break: break-all;overflow-wrap: break-word;">';
                        strHtml += escapeHtml(splittedVals[2]);
                        strHtml += '</td>';
                        if (splittedVals.length > 1 && splittedVals[1] == '1')
                            strHtml += "<td align='center'><img title='Accepted' src='StaticContents/images/ItemOk.png' /></td></tr>";
                        else if (splittedVals.length > 1 && splittedVals[1] == '2')
                            strHtml += "<td align='center'><img title='Rejected' src='StaticContents/images/delete-icon.png' style='height: 12px;width: 12px;margin-top: 4px;' /></td></tr>";
                        else
                            strHtml += "<td></td></tr>";
                    });
                }
                else {
                    strHtml += "<tr><td colspan='3' align='center'>No records found</td></tr>";
                }
                strHtml += '</table></div>';
                var PopupLevelId = '#popUpDialog1';
                if (!$.fn.isNullOrEmpty(sender) && $("#popUpDialog1").find(sender).length > 0) {
                    PopupLevelId = '#popUpDialog2';
                }
                $(PopupLevelId).html('').AhsAppend(strHtml);
                $(PopupLevelId).CMNPopup({
                    popUpHeader: "Work Queue " + messageHeader + " Participants",
                    modalWidth: MODAL_WIDTH.MEDIUM,
                    onLoad: function () {
                        setTimeout(function () {
                            $('.dasWqpopup').css('overflow-x', 'hidden');
                        }, 500);
                    },
                    popLevel: nextPopupLevel()
                });
                loader(0);
            },
            error: function () { loader(0); }
        });
    }

}
// Creating the Multi select dropdown list
function CreateMultiSelectDropDownList(selectid, url, ddlid, tbid, cvalues, onkeyupValue) {
    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    var urll = url.replace('/', '_');
    var htm = "<input id='" + ddlid + "val' type='text' class='droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var cval = "";
    if (cvalues != null && cvalues !== "") {
        cval = cvalues.toString().split(',');
    }
    var resData = '';
    $.getJSON(url, function (data) {
        resData = data.d;
        if (data.length > 0) {
            $.each(data, function (key, val) {
                if (jQuery.inArray(val.Value, cval) != '-1') {
                    htm = htm + "<input type='checkbox' class='" + ddlid + " dropDownItems'  id='" + ddlid + "' data-text='" + SecurityUtils.escapeHtml(val.Text) + "' value='" + SecurityUtils.escapeHtml(val.Value) + "' checked='checked' onchange='MultiSelectDropDownChkClicked(this,0)' /><div id='" + ddlid + "spn' title='" + SecurityUtils.escapeHtml(val.Text) + "' onclick='MultiSelectDropDownSpnClicked(this,0)' style='curosr:pointer;'>" + SecurityUtils.escapeHtml(val.Text) + "</div><br/>";
                }
                else {
                    htm = htm + "<input type='checkbox' class='" + ddlid + " dropDownItems'  id='" + ddlid + "' data-text='" + SecurityUtils.escapeHtml(val.Text) + "' value='" + SecurityUtils.escapeHtml(val.Value) + "' onchange='MultiSelectDropDownChkClicked(this,0)' /><div id='" + ddlid + "spn' title='" + SecurityUtils.escapeHtml(val.Text) + "' onclick='MultiSelectDropDownSpnClicked(this,0)' style='curosr:pointer;'>" + SecurityUtils.escapeHtml(val.Text) + "</div><br/>";
                }
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append($.parseHTML(htm));
        clickedbyprg(ddlid, 0);
    });
    if (resData == 'undefined' || resData == '')
        $("#" + selectid).append($.parseHTML("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/></div>"));
    jQuery.ajaxSetup({ async: true, cache: false });
}

// Checking the items in the multi select dropdown list by passing the salected values as an array
function CheckSelectedValuesOfMultiSelectDropDown(selectedValues, id, IsIdCompare) { // Here, the parameter "selectedValues" should be an array
    for (i = 0; i < selectedValues.length; i++) {
        var dropdownItems = $('#' + id + ' input#' + id);
        if (dropdownItems != null && dropdownItems != "") {
            for (j = 0; j < dropdownItems.length; j++) {
                var parameter = IsIdCompare == true ? ($('#' + id + ' input#' + id + ':eq(' + j + ')').val()) : ($('#' + id + ' input#' + id + ':eq(' + j + ')').data('text'));
                if (parameter == selectedValues[i]) {
                    MultiSelectDropDownChkTriggered($('#' + id + ' input#' + id + ':eq(' + j + ')'), 0);
                    break;
                }
            }
        }
    }
}

//GCODE END

// Manage Template Start
function ActionOnMessages(Child, Type, ValidationMsg, ConfirmMsg, divValCtrlId) {
    var Result = true;
    var attrType = (Type == 'Id') ? '#' : '.';
    var chkCount = $(attrType + Child + ":checked").length;
    if (chkCount == 0) { if (divValCtrlId != undefined) CmnStatusMessageDisp(divValCtrlId, ValidationMsg, 'Error'); else CustomAlert(ValidationMsg); Result = false; }
    else if (chkCount > 0 && ConfirmMsg != '') { Result = CustomConfirm(ConfirmMsg + chkCount + " item(s)?"); }
    return Result;
}

function ChnageStatus(Obj) {
    $('.Activate').show(); $('.InActivate').show();
    if (Obj == 1) { $('.Activate').hide(); } else { $('.InActivate').hide(); }
}

function BindEmptyDropDownList(selectid, ddlid, tbid) {
    var width = $('#' + selectid).width();
    var htm = "<input id='" + ddlid + "val' type='text' class='droptexthide' onclick='showdrop(this)' style='color:darkgrey;' value='Select' placeHolder='Select' />";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    htm = htm + "No Records";
    htm = htm + "</div>";
    $("#" + selectid).html('');
    $("#" + selectid).append(htm);
}

function loadLettersDropDown(remote_url, elementId, selectedValue, EmptyInsert, StartText, selectedText, ConditionalCallback, Value, Text) {
    var $select = $('#' + elementId);
    Value = Value || 'Value';
    Text = Text || 'Text';
    $.ajax({
        type: "GET",
        url: remote_url,
        async: false,
        success: function (data) {
            var optionsHtmlString = "";
            $select.html('');
            if (elementId == "ddlLOB" && data.length == 1) { /*GOLD-971*/
                optionsHtmlString = "";
            }
            else if (elementId == "ddlBenefitPlan" && data.length == 1) {
                optionsHtmlString = "";
            }
            else {
                if ((EmptyInsert == true || EmptyInsert == undefined) && (StartText == '' || StartText == undefined)) {
                    optionsHtmlString += '<option value="-1"> Select </option>';
                }
                if (StartText != '' && StartText != undefined) {
                    optionsHtmlString += '<option value="-1"> ' + StartText + ' </option>';
                }

            }
            if ($select.attr('multiple'))
                optionsHtmlString = "";
            if ($select.data('select'))
                optionsHtmlString = "";
            if ($select.data('all') == "ALL")
                optionsHtmlString = '<option value="-1"> All </option>';
            if ($select.hasClass('allowSelect') && data.length == 1)
                optionsHtmlString = "";
            var selectedVal;
            var lengthToShortenTo = 50;
            $.each(data, function (key, val) {
                var title = $.fn.replaceAndEscapeHtmlExt(val[Text]);

                if (val[Text] && val[Text].length > lengthToShortenTo) {

                    val[Text] = val[Text].substring(0, lengthToShortenTo) + '...';
                }

                val[Text] = $.fn.replaceAndEscapeHtmlExt(val[Text]);

                if (selectedValue) {
                    if (selectedValue == val[Value]) {
                        optionsHtmlString += '<option value="' + val[Value] + '" selected="selected" title="' + title + '">' + val[Text] + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[Value] + '" title="' + title + '">' + val[Text] + '</option>';
                    }
                }
                else {
                    if (val.Selected || selectedText == val[Text]) {
                        optionsHtmlString += '<option value="' + val[Value] + '" selected="selected" title="' + title + '">' + val[Text] + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[Value] + '" title="' + title + '">' + val[Text] + '</option>';

                    }
                }
            });
            var values = new Array();
            $select.append(optionsHtmlString);
            if ($select.attr('multiple')) {
                if ($select.multiselect != undefined) {
                    $select.multiselect({
                        close: function () {
                            var values = new Array();
                            $(this).multiselect("getChecked").each(function (index, item) {
                                values.push($(item).val());
                            });
                            $('#' + $select.data('valueid')).val(values.join(","));
                        }
                    })
                }
            }
            if (ConditionalCallback && typeof (ConditionalCallback) == "function") { ConditionalCallback(true); }
        }
    });
    if (ConditionalCallback && typeof (ConditionalCallback) == "function") { ConditionalCallback(true); }
}

// Manage template End

function downLoadBulkLetter(letterQueueId, DocumentId, IsRtl, Obj, fileName, thisElement) {
    loader(1); var fileExtention = fileName.substring(fileName.lastIndexOf('.')); var fileNameDwnld = fileName;
    if (IsSmartCommEnabled === "1") {
        downloadFileHandler(DocumentId, 0, thisElement);
    }
    else {
        //if (IsSmartCommEnabled === "1") { Obj = 1; }
        if (Obj == 0) { PrintQueue_Init('EXPDOC', 0, 0, 0, 0, DocumentId, 1); }
        else if (letterQueueId != null && letterQueueId != '' && fileExtention.toLowerCase() != '.doc' && IsSmartCommEnabled != "1") {
            var ActionType = 'EXPPDF'; if (fileExtention.toLowerCase() != '.pdf' && IsRtl == true) { ActionType = 'EXPDOC'; } PrintQueue_Init(ActionType, 0, 0, letterQueueId);
        }
        else {
            downloadDocumentFileHandler(DocumentId, 0, thisElement);
        }
    }
    loader(0);
    AuditLog(1, actionTypeEnum.Download, 'Documents', $("#selectPatientAccessed").val(), memberidval, fileNameDwnld);
    $('body').css('overflow', 'scroll');
}

function SendPriviewContent(objDocumentId, objPatientId, objDraftType, objIsReviewed, IsRtl) {
    var LetterType = "LTR";
    if (IsRtl == true) { LetterType = "RTL"; }
    var Review = 'VIEW';
    if (objDraftType == 0 && objIsReviewed == 0) {
        CustomAlert("Letter in draft.");
        Review = Review + '0';
    }
    else {
        Review = Review + '1';
    }

    if (IsSmartCommEnabled === "1") {
        if (objDraftType == 1 && objIsReviewed == 0) {
            Review = 'VIEW2';
        }
        //var moduleId = jQuery.grep(allModules_Data, function (a) { return a.Name == "CM"; })[0].Id;
        $('#LetterDiv').show(); LoadDraftLetter(gtModId("CM"), 0, 0, objDocumentId, Review);
    }
    else {
        OpenReviewer_Init($("#selectPatientAccessed").val(), objDocumentId, Review, 1, 0, 0, LetterType);
    }

}

function MvcAjaxWithCallBack(PostData, Url, ObjCallBack) {
    $.ajax({
        type: "POST", data: PostData, url: Url, dataType: "html",
        success: function (Result) { if (ObjCallBack && typeof (ObjCallBack) === "function") { ObjCallBack(Result); } }
    }).fail(MvcAjaxallBackFailed);

}
$.extend({
    greproleext: function (elems, validateCb) {
        var _allowRoleWhenMissingInXml = allowRoleWhenMissingInXml;
        var specRoleItem = $.grep(elems, validateCb);
        if (!_allowRoleWhenMissingInXml && (specRoleItem == null || specRoleItem.length === 0)) {
            specRoleItem.push({
                Description: '',
                IsAdd: false,
                IsDelete: false,
                IsEdit: false,
                IsEmail: false,
                IsExport: false,
                IsPrint: false,
                IsView: false,
                UniqueName: ''
            });
        }
        return specRoleItem;
    }
});
function getSpecRoleItem(uniqueName, isDefaultDisable) {
    if (roleConfig != null && roleConfig.length > 0) {
        var specRoleItem = $.greproleext(roleConfig, function (element, _index) {
            return element.UniqueName === uniqueName;
        });
        if (isDefaultDisable == true && (specRoleItem == null || specRoleItem.length == 0)) {
            specRoleItem.push({
                Description: uniqueName,
                IsAdd: false,
                IsDelete: false,
                IsEdit: false,
                IsEmail: false,
                IsExport: false,
                IsPrint: false,
                IsView: false,
                UniqueName: uniqueName
            });
        }
        return specRoleItem
    }
    else return null;
}

//GCODE END

function DisplayValidation1(gridId, defaultValidationMsg, customValidationMsg) {
    var ds = $("#" + gridId).data("kendoGrid").dataSource.data();
    $('#divValidationMessage').css("display", "none");
    if (ds == null || ds.length < 1 || ds[0].HasNoPatients == true) {
        $('#divValidationMessage').css("display", "block");
        if ($('.Left_Side_Bar').hasClass('Left_Side_Bar_Show')) {
            $('#divValidationMessage').html(isFilterApplied ? customValidationMsg : defaultValidationMsg);
        }
        else {
            $('#divValidationMessage').html(customValidationMsg);
        }
    }
    else
        $('#divValidationMessage').html('');
}

function DisplayValidation(gridId, defaultValidationMsg, customValidationMsg) {
    DevUtils.logDebug('gridId[' + gridId + '], defaultValidationMsg[' + defaultValidationMsg + '], customValidationMsg[' + customValidationMsg + ']', 'GCHomeCommon.DisplayValidation()');

    let message = customValidationMsg;

    if ($("#" + gridId).data("kendoGrid").dataSource.view().length == 0) {
        if ($('.Left_Side_Bar').hasClass('Left_Side_Bar_Show')) {
            message = isFilterApplied ? customValidationMsg : defaultValidationMsg;
        }

        DevUtils.logDebug('Making call to A11yAlerts with containerSelector[#divValidationMessage], alertMessage[' + message + ']', 'GCHomeCommon.DisplayValidation()');
        A11yAlerts.createWarningAlert('#alertValidationMessage', message);
    }
    else {
        A11yAlerts.remove('alertValidationMessage', true);
    }
}

//DGM-126

//Parameters for fetch all care plan barriers
function CrPlTmCrPlAllCarePlanBarrierParams() {
    var { fromDate, toDate } = getFilterDatesAndLob("Barriers");
    patientId = $.trim($('#selectPatientAccessed').val());
    return {
        patientId: patientId === undefined ? null : patientId,
        dateFrom: fromDate,
        dateTo: toDate,
        TimeDictionaryobj: timeZone
        //IsView: false
    }
}

/*Read values from controls for passing to kendo grid for fetching data from wep api */
function CarePlanStrengthParams() {
    patientId = $.trim($('#selectPatientAccessed').val());
    var { fromDate, toDate } = getFilterDatesAndLob("Strengths");
    return {
        patientId: patientId === undefined ? null : patientId,
        dateFrom: fromDate,
        dateTo: toDate,
        TimeDictionaryobj: timeZone
    }
}

function CarePlanStrengthParamsLevel() {
    var carePlan = $('#hdnCrPlTmCrPlHisCrPlId').val()
    return {
        patientId: 0,
        carePlanId: carePlan === undefined ? null : carePlan,
        TimeDictionaryobj: timeZone
    }

}


function loadDropDownCarePlan(url, elementId, selectedValue, selectedText, ConditionalCallback, async, dataValue, dataText, ObjCallBack) {
    if (typeof elementId === 'object')
        var $select = elementId;
    else
        var $select = $('#' + elementId);

    dataValue = dataValue || 'Value';
    dataText = dataText || 'Text';

    $.ajax({
        type: "GET",
        url: url,
        async: async,
        success: function (data) {
            var optionsHtmlString = "";
            $select.html('');
            if (elementId == "selCrPlMemLob") { optionsHtmlString += '<option value="-1"> Select LOB </option>'; }
            else {
                optionsHtmlString += '<option value="-1"> Select </option>';
            }
            if ($select.attr('multiple'))
                optionsHtmlString = "";
            if ($select.data('select'))
                optionsHtmlString = "";
            if ($select.data('all') == "ALL")
                optionsHtmlString = '<option value="-1"> All </option>';

            if ($select.hasClass("allowSelect") && data.length == 1)
                optionsHtmlString = "";
            var selectedVal, flag = 0;
            $.each(data, function (key, val) {
                if (selectedValue) {
                    if (selectedValue == val[dataValue]) {
                        flag = 1;
                        optionsHtmlString += '<option value="' + val[dataValue] + '" selected="selected" >' + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[dataValue] + '" >' + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + '</option>';

                    }
                }
                else {
                    if (val.Selected) {
                        flag = 1;
                        optionsHtmlString += '<option value="' + val[dataValue] + '" selected="selected" >' + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[dataValue] + '">' + $.fn.replaceAndEscapeHtmlExt(val[dataText]) + '</option>';
                    }
                }
            });
            if (flag != 1 && selectedValue) {
                if (elementId == 'selectRisk') {
                    optionsHtmlString += '<option value="' + selectedValue + '" selected="selected" >' + $.fn.replaceAndEscapeHtmlExt(selectedText) + '</option>';
                }
                else {
                    optionsHtmlString += '<option value="' + selectedValue + '" selected="selected" >' + selectedText + '</option>';
                }

            }
            var values = new Array();
            $select.append(optionsHtmlString);
            if (ConditionalCallback == "conditionCallbackMethod") { conditionCallbackMethod(); }
            else if (ConditionalCallback == "goalGroupCallbackMethod") { goalGroupCallbackMethod(); }
            else if (ConditionalCallback == "interventionCallbackMethod") { interventionCallbackMethod(); }
            else if (ConditionalCallback == "goalCallbackMethod") { goalCallbackMethod(); }
            else if (ConditionalCallback == "statusCallBackMethod") { statusCallBackMethod(); }
            else if (ConditionalCallback == "lobCallBackMethod") { lobCallBackMethod(); }
            else if (ConditionalCallback == "opportunityCallBackMethod") { opportunityCallBackMethod(); }
            else if (ConditionalCallback == "assignOwnerCallBackMethod") { assignOwnerCallbackMethod(); }
            else if (ConditionalCallback == "locCallBackMethod") { locCallBackMethod(); }
            else if (ConditionalCallback == "timeSpanCallbackMethod") { timeSpanCallbackMethod(); }
            else if (ConditionalCallback == "priorityCallback") { priorityCallback(); }
            if ($("#txtCrPlTmGoal").is(":visible")) { $("#selCrPlTmGoalId").parent().hide(); }
            if ($("#txtCrPlTmIntervention").is(":visible")) {
                //kuhg-746
                //$("#selCrPlTmInterventionId").parent().hide();
                $("#InterventionAutoCompletediv").hide();
            }
            if (ObjCallBack && typeof (ObjCallBack) === "function") { ObjCallBack(true); }
        },
        error: function () {
            if (ObjCallBack && typeof (ObjCallBack) === "function") { ObjCallBack(false); }
        }
    });
}

function DisableEnableAccordians(id) {
    var isMtmIntervention = false;
    if ($('#lnkMTMInterventionsTab').hasClass('select')) { isMtmIntervention = true; }
    var headingtext = "Category : " + globalCplCategory;
    if (id == 'btnTmCrPlNotesPrint') {
        return globalCplCategory;
    }
    else {
        getSelectedCrPlValues($('#hdnCrPlTmCrPlHisCrPlId').val());
        $('#divCplMultiViewHeading').AhsSetHtml(headingtext);
        $('#btnCplExpColAll').show();
        $('#divCplBarrierGridHeader').show();
        $('#divCplStrengthGridHeader').show();
        $('#divCplActHistoryGridHeader').show();
        $('#divCplNotesGridHeader').show();
        $('#divCplAppDetailsGridHeader').show();

        if ($('#btnCrPlTmCrPlAddBarrier').prop('disabled')) {
            $('#btnCplExpColAll').hide();
            $('#divCplBarrierGridHeader').hide();
        }
        if ($('#btnCrPlTmCrPlAddStrengths').prop('disabled')) {
            $('#btnCplExpColAll').hide();
            $('#divCplStrengthGridHeader').hide();
        }
        if ($('#btnCrPlTmCrPlActivityHistory').prop('disabled')) {
            $('#btnCplExpColAll').hide();
            $('#divCplActHistoryGridHeader').hide();
        }
        if ($('#btnCrPlTmCrPlNotes').prop('disabled')) {
            $('#btnCplExpColAll').hide();
            $('#divCplNotesGridHeader').hide();
        }
        if ($('#btnCrPlTmCrPlAppointmentDetails').prop('disabled')) {
            $('#btnCplExpColAll').hide();
            $('#divCplAppDetailsGridHeader').hide();
        }

        if (isMtmIntervention) { $('#divCplActHistoryGridHeader').hide(); $('#divCplAppDetailsGridHeader').hide(); }

        var barrierUniqueName = 'AHS_CM_BARRIERS'; var strengthUniqueName = "AHS_CM_STRENGTHS"; var notesUniqueName = "AHS_CM_CPL_NOTES";
        if (isFromUM === "True") {
            barrierUniqueName = strengthUniqueName = notesUniqueName = "AHS_UM_QUICK_LINKS_CARE_PLAN";
        }
        if (isMtmIntervention) { barrierUniqueName = "AHS_MTM_INTERVENTIONS_BARRIERS", strengthUniqueName = "AHS_MTM_INTERVENTIONS_STRENGTHS"; notesUniqueName = "AHS_MTM_INTERVENTIONS_NOTES"; }
        $("#divCplBarrierGridHeader").ApplyRoleConfig({ Id: "divCplBarrierGridHeader", UniqueName: barrierUniqueName, IsFrom: "View", IsRemoveElement: true });
        $("#divCplStrengthGridHeader").ApplyRoleConfig({ Id: "divCplStrengthGridHeader", UniqueName: strengthUniqueName, IsFrom: "View", IsRemoveElement: true });
        $("#divCplNotesGridHeader").ApplyRoleConfig({ Id: "divCplNotesGridHeader", UniqueName: notesUniqueName, IsFrom: "View", IsRemoveElement: true });
    }
}

function DefaultCplCatChecked() {
    if ($("#hdnIsMTMIntervention").val() === "1") {
        $('#chkCarePlandefault').prop('checked', false);
        if (carePlandefaultCheck === $('#selCrPlTmCrPlCat').val()) {
            $('#chkCarePlandefault').prop('checked', true);
        }
        if ($('#selCrPlTmCrPlCat').val() !== "") {
            $('#chkCarePlandefaultId').show();
        }
        else {
            $('#chkCarePlandefaultId').hide();
        }
    }
    //To enable assign owner based on selected category in need to enable in ,RECOMMENDED,CURRENT,SELECT
    var selectedCat = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected') : $('#selCrPlTmCrPlCat').data("kendoDropDownList");
    if (selectedCat !== undefined) {
        selectedCat = selectedCat.text().toUpperCase();
    } else {
        selectedCat = 'SELECT';
    }
    if (selectedCat === 'RECOMMENDED' || selectedCat === 'CURRENT' || $('#selCrPlTmCrPlCat').val() === '') {
        if (roleConfig != null && roleConfig.length != 0) {
            var assignOwnerIcon = $.greproleext(roleConfig, function (ele, _ind) {
                return ele.UniqueName === "AHS_CM_ASSIGN_OWNER";
            });
            if (assignOwnerIcon != undefined && assignOwnerIcon.length > 0) {
                if (assignOwnerIcon[0].IsView == true) {
                    $(".userIconNew").show();
                    if (assignOwnerIcon[0].IsAdd == false) {
                        $(".userIconNew").attr('title', 'You do not have access to assign owner');
                    }
                }
            }
            else {
                $(".userIconNew").show();
            }
        }

    }
    else {
        $('.userIconNew').hide();
    }

}

function opportunityTemplate(product) {
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase().trim() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase().trim();
    var val = '';
    var htm = '';
    var count = 0;
    var relaVentId = ''
    if (product.CategoryName && ($catName.toUpperCase() === 'RECOMMENDED' || $catName.toUpperCase() === 'SELECT' ||
        $catName.toUpperCase() === 'CURRENT')) {
        if (product.OppGroup) {
            product.OppGroup = product.OppGroup.indexOf("@") == 0 ? product.OppGroup.replace("@", "") : product.OppGroup;
            val = product.OppGroup.replaceSpecialChar({ replaceChars: ["&quot;", "&#039;"], actualChars: [/"/g, /'/g] }).split("@@");
        }

        if (product.CategoryName.toUpperCase() === 'RECOMMENDED' || product.CategoryName.toUpperCase() === 'CURRENT') {

            var status = 0;
            var MulLob = "";
            var MulGuidLineSource = "";
            var OppName = "";
            var OppStyle = "";
            $.each(val, function (index, value) {
                var hiddenValues = value.split('~~');
                OppName = hiddenValues[1];
                var dataRootName = hiddenValues[2];
                var GuidLineSource = hiddenValues[3];
                OppStyle = hiddenValues[4];

                MulLob = MulLob + dataRootName + ',';
                MulGuidLineSource = MulGuidLineSource + GuidLineSource + ',';
            });

            MulLob = MulLob.substring(0, MulLob.length - 1);
            MulGuidLineSource = MulGuidLineSource.substring(0, MulGuidLineSource.length - 1);

            htm = htm + "<div id='" + OppName + "spn' ><div class='" + OppStyle + " primaryFontColor'> " + OppName + "</div></div>";
        }
        return htm;
    }
    return htm;
}

/*set grid show or hide  according to selected category */
function gridShowHideCarePlan(isRefresh, isClear) {
    var $divRecAndCurCareplan = $('#divRecAndCurCareplan');
    var $divcareplan = $('#divcareplan');
    var $divuasscript = $('#divuasscript');
    var $divRecAndCurCareplanListView = $('#divRecAndCurCareplanListView');
    var $divCmpAndDelCareplanListView = $('#divCmpAndDelCareplanListView');
    $divcareplan.hide();
    $divuasscript.hide();
    $divRecAndCurCareplan.hide();
    $divRecAndCurCareplanListView.hide();
    $divCmpAndDelCareplanListView.hide();
    $('.cpExpandAll').hide();
    $('.cpCollapseAll').hide();
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase().trim() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase().trim();
    var gridId;
    if ($catName === 'SELECT' || ((globalTeamCPStatus !== '' && globalTeamCPStatus === '1') || $catName === 'RECOMMENDED') || ((globalTeamCPStatus !== '' && globalTeamCPStatus === '2') || $catName === 'CURRENT')) {
        if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
            $divRecAndCurCareplanListView.show();
        }
        else {
            $divRecAndCurCareplan.show();
        }
        var chk = $('#TmCrPlRecAndCurGroupGrid .clsChkCrPlTmCrPlGrid').not('.clsChkCPSignOff');
        var selectedChkBoxCount = $(".clsChkCrPlTmCrPlGrid:checked").not('.clsChkCPSignOff').length;
        if (chk && chk.length > 0) {
            $('#TmCrPlRecAndCurGroupGrid .clsChkCrPlTmCrPlGrid,.clsChkCrPlTmCrPlHead').not('.clsChkCPSignOff').prop('checked', false);
        }

        if ($catName === 'SELECT') {
            $('#SignOffText').html('Sign Off');
            $('.cntxtSignOff').val('Sign Off');
        }
        else if ($catName === 'RECOMMENDED') {
            $('#SignOffText').html('Sign Off');
            $('.cntxtSignOff').val('Sign Off');
        }
        else if ($catName === 'CURRENT') {
            $('#SignOffText').html('Undo Sign Off');
            $('.cntxtSignOff').val('Undo Sign Off');
        }

        gridId = (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) ? ["#TmCrPlRecAndCurGroupListView"] : ['#TmCrPlRecAndCurGroupGrid'];
        $(".clsCrPlTargetedFDate").show();

    } else if ((globalTeamCPStatus != '' && globalTeamCPStatus == '5') || $catName == 'UAS') {
        $("#selCrPlTmCrPlRole :input").attr("disabled", true);
        $divuasscript.show();
        gridId = ["#UASScript"];
        $(".clsCrPlTargetedFDate").hide();
    }
    else {
        var chkd = $('#TmCrPlCarePlanGrid .clsChkCrPlTmCrPlGrid').not('.clsChkCPSignOff');
        if (chkd && chkd.length > 0) {
            chkd.prop('checked', false);
        }
        if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
            $divCmpAndDelCareplanListView.show();
        }
        else {
            $divcareplan.show();
        }
        gridId = (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) ? ["#TmCrPlCmpAndDelGroupListView"] : ["#TmCrPlCarePlanGrid"];
        $(".clsCrPlTargetedFDate").hide();
    }
    if (isToggled === true) {
        togglegridRefresh(gridId);
    }
    else if (isRefresh) {
        gridRefresh1(gridId, undefined, selectedChkBoxCount);
    }
    else {
        //SONAR
    }
    globalTeamCPStatus = "";
}

/*Return checkbox object and grid id which have been checked*/
function chkChecked() {
    var chkBxChd;
    var grid;
    var $catName = $("#hdnIsMTMIntervention").val() === "1" ? $('#selCrPlTmCrPlCat option:selected').text().toUpperCase().trim() : $('#selCrPlTmCrPlCat').data("kendoDropDownList").text().toUpperCase().trim();
    if ($catName === 'SELECT' || $catName === 'CURRENT' || $catName === 'RECOMMENDED') {
        if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
            grid = ['#TmCrPlRecAndCurGroupListView'];
            chkBxChd = $("#TmCrPlRecAndCurGroupListView").find('input[type="checkbox"]:checked').not('.clsChkCrPlTmCrPlHead,.clsChkCPSignOff');
        }
        else {
            grid = ['#TmCrPlRecAndCurGroupGrid'];
            chkBxChd = $("#TmCrPlRecAndCurGroupGrid").find('input[type="checkbox"]:checked').not('.clsChkCrPlTmCrPlHead,.clsChkCPSignOff');
        }
    }
    else {
        if (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) {
            grid = ['#TmCrPlCmpAndDelGroupListView'];
            chkBxChd = $("#TmCrPlCmpAndDelGroupListView .clsChkCrPlTmCrPlGrid:checked").not('.clsChkCrPlTmCrPlHead,.clsChkCPSignOff');
        }
        else {
            chkBxChd = $("#TmCrPlCarePlanGrid .clsChkCrPlTmCrPlGrid:checked").not('.clsChkCrPlTmCrPlHead,.clsChkCPSignOff');
            grid = ['#TmCrPlCarePlanGrid'];
        }
    }

    return { checkBox: chkBxChd, gridObj: grid };
}

function GetCRPLGrid(category) {
    var gridId = "";
    if (category === 'SELECT' || category === 'RECOMMENDED' || category === 'CURRENT') {
        gridId = (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) ? "TmCrPlRecAndCurGroupListView" : "TmCrPlRecAndCurGroupGrid";
    }
    else if (category === 'UAS') {
        gridId = "UASScript"
    }
    else {
        gridId = (carePlanSelectedViewType === VIEW_MODE.LIST_VIEW) ? "TmCrPlCmpAndDelGroupListView" : "TmCrPlCarePlanGrid";
    }
    return gridId;
}

function setBottomLeftCurrentVal(id) {
    if (dashboardConfig != null && dashboardConfig.length > 0) {
        var alertsRank = $.grep(dashboardConfig, function (element, index) { return element.QuadrantId == 4 && element.QuadrantValueId == id });
        bottomLeftCurrentValue = alertsRank[0].Rank;
    }
}

function getCalendarURL() {
    var calendarURL = '';
    if (dashboardConfig != null && dashboardConfig.length == 0) {
        calendarURL = baseURL + "/Dashboard/MyCalendar/";
    }
    else {
        var calendarPnl = $.grep(dashboardConfig, function (element, index) { return element.QuadrantId == 2 && element.Rank == 1 });
        if (calendarPnl.length > 0) {
            if (calendarPnl[0].QuadrantValueId === 6) {
                calendarURL = baseURL + "/Dashboard/MyCalendar?IsShowFullDay=1";
            }
            else {
                calendarURL = baseURL + "/Dashboard/MyCalendar?IsShowFullDay=0";
            }
        }
    }
    return calendarURL;
}

//MCG Guideline
function MCGSummaryParameters() {
    var $patientId = $('#selectPatientAccessed').val();
    return {
        patientId: $patientId,
        TimeDictionaryobj: timeZone
    }
}

//My Activity Log
function TodayActivityLogParams() {
    return {
        loginUserId: memberidval,
        careStaffId: $('#hdnSelectCareStaffTCAL').val(),
        member: $('#txtTCALMemberMAL').val().trim(),
        altruId: $('#txtTCALAltruIdMAL').val().trim(),
        dateFrom: $('#txtTCALFromDateMAL').val(),
        dateTo: $('#txtTCALToDateMAL').val(),
        IsSensitiveApplicable: careStaffViewSensitive,

        IsView: $('#HdnIsViewTCALCM').val(),
        timeDictionaryobj: timeZone
    }
}

function archiveUnarchiveRolesMAL() {
    var currentValue = $('#selMessageTypeRRcMAL').val();
    $("#moveFaxToArchiveMAL").ApplyRoleConfig({ UniqueName: getUniqueFaxName(), Id: "moveFaxToArchiveMAL", IsFrom: "Edit", IsRemoveElement: true });
    $("#moveArchiveToUnArchiveMAL").ApplyRoleConfig({ UniqueName: getUniqueFaxName(), Id: "moveArchiveToUnArchiveMAL", IsFrom: "Edit", IsRemoveElement: true });
    if ($(".clsMoveFaxToArchiveMAL").prop("id") === "") {
        if (currentValue === 'true') {
            $('#selMessageTypeRRcMAL').val('true');
        } else {
            $('#selMessageTypeRRcMAL').val('false');
        }
        $("#opt_I_FaxArchiveMAL").hide();
        $(".clsMoveFaxToArchiveMAL").hide();
        $(".clsArchiveToUnArchiveMAL").hide();
    }
    $(".clsMoveFaxToArchiveMAL").attr('id', 'moveFaxToArchiveMAL');
    $("#moveFaxToArchiveMAL").on('click').removeAttr('title').attr('onclick', "fnMoveFaxToArchive('Archive', 'clsRefralChkMember', 'Class', 'Please select at least one record to archive', '');").css('opacity', '');
    $(".clsArchiveToUnArchiveMAL").attr('id', 'moveArchiveToUnArchiveMAL');
    $("#moveArchiveToUnArchiveMAL").on('click').removeAttr('title').attr('onclick', "fnMoveFaxToArchive('UnArchive', 'clsRefralChkMember', 'Class', 'Please select at least one record to restore', '');").css('opacity', '');

}

function BindRequestRecievedDataMAL(ReqType) {
    $('.clsTglSwHd').hide(); $('.clsRRProviderSearchMAL').hide();
    $("#dvLoadReqRecGridDataMAL").html('');
    $('#divTreatmentTypeReqRecUmFaxesMAL').hide();
    $('#divSaveTreatmentTypeReqRecUmFaxesMAL').hide();
    var referType = $('#selectRequestReceivedReferTypeMAL').data("kendoDropDownList").text();
    var modName = $('#selectRequestReceivedModuleMAL').data("kendoDropDownList").text();
    if (isMAL) {
        ContextMenuNActionButtonsLoad();
    }

    //K //if (referType == "Activity" || referType == "Member") {
    //    $('#btnRequestReceivedAcceptMAL').show();
    //    $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMActivitiesAndMembers/', { gridname: 'ReqRecGridMAL' }, function () {
    //        if (referType == "Member") {
    //            //K//$("#ReqRecGridMAL").data("kendoGrid").hideColumn("ActivityTypeName");
    //            //K//$("#ReqRecGridMAL").data("kendoGrid").hideColumn("Priority");
    //        }
    //        else if (referType == "Activity") {
    //            //K//$("#ReqRecGridMAL").data("kendoGrid").showColumn("ActivityTypeName");
    //            $("#ReqRecGridMAL").data("kendoGrid").hideColumn("ReferredToName");
    //        }

    //        loader(0);
    //    });
    //K //}
    $("#tdddlRequestReceivedWorkQueueMAL").show();
    if (referType == "Activity") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMActivities/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, function () {
            loader(0);
        });
    }
    else if (referType == "Member") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMMembers/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, function () {
            loader(0);
            $("#ReqRecGridMAL").data("kendoGrid").hideColumn(2);
        });
    }
    else if (referType == "Appointment") {
        $("#tdddlRequestReceivedWorkQueueMAL").hide();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMAppointments/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType == "Care Plan") {
        $('#btnRequestReceivedCareSignOffMAL').show();
        $("#tdddlRequestReceivedWorkQueueMAL").hide();
        $('#btnRequestReceivedCareRejectMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMCarePlan/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType == "Messages") {
        $("#tdddlRequestReceivedWorkQueueMAL").hide();
        $('#selMessageTypeRRcMAL').show();
        $('#divMessageTypeRRcMAL').show();
        if ($("#selMessageTypeRRcMAL").val() === '2') {
            $("#selMessageTypeRRcMAL").val('false');
        }
        $("#opt_I_FaxArchiveMAL").hide();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedCMMessages/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType === "Faxes") {
        $('#selMessageTypeRRcMAL').show();
        $('#divMessageTypeRRcMAL').show();
        $("#opt_I_FaxArchiveMAL").show();
        if ($("#selMessageTypeRRcMAL").val() === '2') {
            $("#moveArchiveToUnArchiveMAL").show();
        } else {
            $('#moveFaxToArchiveMAL').show();
        }
        REQ_REC_UM_FAX_TT.showHideDdl('ddlTreatmentTypeReqRecUmFaxesMAL', 'divSaveTreatmentTypeReqRecUmFaxesMAL', modName, referType);
        REQ_REC_UM_FAX_TT.useSavedFilter('ddlTreatmentTypeReqRecUmFaxesMAL', modName, referType);
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestReceivedCMFax/', { gridname: 'ReqRecGridMAL', moduleName: modName }, function () {
            archiveUnarchiveRolesMAL();
        });
    } else if (referType == "UM Activity") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedUMActivities/', { gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType == "UM Auth") {
        $('#btnRequestReceivedAcceptMAL').show(); $('.clsRRProviderSearchMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedUMAuth/', { gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType == "AG Complaint") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedAGComplaints/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, Unveil);
    } else if (referType == "AG Activity") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedAGActivities/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, Unveil);
    }
    else if (referType == "MS Activity") {
        $('#btnRequestReceivedAcceptMAL').show();
        $("#tdddlRequestReceivedWorkQueueMAL").hide();
        $("#dvLoadReqRecGridDataMAL").load(baseURL + '/RequestReceivedDashboard/RequestRecievedMSActivities/', { ReqRecIsPh: ReqType, gridname: 'ReqRecGridMAL' }, function () {
            loader(0);
        });
    }
}

function BindRequestRejectedDataMAL() {
    $('#divMemberMenuRejected_').hide();
    $('#divAppointmentMenuRejected_').hide(); $('.clsRequestRejectedProviderSearchMAL').hide();

    if (!$('#divMemberMenuAcceptRRjMAL_').hasClass('divClsMemberMenuRefer'))
        $('#divMemberMenuAcceptRRjMAL_').addClass('divClsMemberMenuRefer').css("opacity", "");

    if (!$('#divMemberMenuViewRRjMAL_').hasClass('divClsMemberMenuRejectView'))
        $('#divMemberMenuViewRRjMAL_').addClass('divClsMemberMenuRejectView').css("opacity", "");

    if (!$('#divMemberMenuRejectRRjMAL_').hasClass('divClsMemberMenuDelete'))
        $('#divMemberMenuRejectRRjMAL_').addClass('divClsMemberMenuDelete').css("opacity", "");

    ShowAcknowledgeButtonMAL(false);
    $("#dvLoadReqRejGridDataMAL").html('');
    var referType = $('#selectRequestRejectedReferTypeMAL').data("kendoDropDownList").text();
    if (referType == "Activity") {
        $("#tdddlRequestRejectedWorkQueueMAL").show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMActivities/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    }
    else if (referType == "Member") {
        $("#tdddlRequestRejectedWorkQueueMAL").show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMMembers/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    }
    else if (referType == "Appointment") {
        $("#tdddlRequestRejectedWorkQueueMAL").hide();
        ShowAcknowledgeButtonMAL(true);
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedCMAppointments/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    } else if (referType == "UM Activity") {
        $("#tdddlRequestRejectedWorkQueueMAL").show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedUMActivities/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            //Commenting the below line as it is blocking the pagination for request rejected UM Activity grid view.
            //$("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    } else if (referType == "UM Auth") {
        $("#tdddlRequestRejectedWorkQueueMAL").show(); $('.clsRequestRejectedProviderSearchMAL').show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedUMAuth/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    } else if (referType == "AG Complaint") {
        $("#tdddlRequestRejectedWorkQueueMAL").show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedAGComplaints/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    } else if (referType == "AG Activity") {
        $("#tdddlRequestRejectedWorkQueueMAL").show();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/RequestRejectedDashboard/RequestRejectedAGActivities/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    }
    else if (referType == "MS Activity") {
        $("#tdddlRequestRejectedWorkQueueMAL").hide();
        $("#dvLoadReqRejGridDataMAL").load(baseURL + '/MemberService/RequestRejectedMSActivities/', { gridname: 'ReqRejGridMAL' }, function () {
            loader(0);
            $("#ReqRejGridMAL").data("kendoGrid").bind("dataBound", onDataBoundRequestRejectGrid);
        });
    }
}


function onDataBoundRequestRejectGrid() {
    A11yGrid.enhanceKendoGridForA11y('ReqRejGridMAL', 1);
}

function ActvtPerfByOthersParameters() {
    return {
        careStaffId: $('#hdnSelectCareStaffActvtPerfByOthers').val(),
        altruId: $('#txtActvtPerfByOthersAltruIdMAL').val().trim(),
        dateFrom: $("#txtActvtPerfByOthersFormDateMAL").val(),
        dateTo: $("#txtActvtPerfByOthersToDateMAL").val(),
        careStaffViewSensitive: careStaffViewSensitive,
        TimeDictionaryobj: timeZone,
    }
}

function ClearAllContextMenu(SourceObj) {
    $('.MALDivContent').each(function () {
        if (SourceObj != $(this).attr('id') && $(this).is(':visible') == true) { $('.ContextChkMenu').hide(); $(this).find('input[type="checkbox"]').attr('checked', false); }
    });
}
function TodayActivityLogMSParams() {
    return {
        loginUserId: memberidval,
        careStaffId: $('#hdnSelectCareStaffTCAL').val(),
        member: $('#txtTCALMemberMAL').val().trim(),
        altruId: $('#txtTCALAltruIdMAL').val().trim(),
        dateFrom: $('#txtTCALFromDateMAL').val(),
        dateTo: $('#txtTCALToDateMAL').val(),
        IsView: $('#HdnIsViewTCALMS').val(),
        careStaffViewSensitive: careStaffViewSensitive,
        TimeDictionaryobj: timeZone
    }
}

function getAllFaxRoleNames() {
    return ['CM_REQUEST_RECEIVED_CM_FAXES', 'DASH_BOARD_REQUEST_RECEIVED_UM_FAXES', 'DASH_BOARD_REQUEST_RECEIVED_AG_FAXES'];
}

function getModuleFaxRoleName(module) {
    var res = '';
    if (module === 'CM') {
        res = 'CM_REQUEST_RECEIVED_CM_FAXES';
    }
    else if (module === 'UM') {
        res = 'DASH_BOARD_REQUEST_RECEIVED_UM_FAXES';
    }
    else if (module === 'AG') {
        res = 'DASH_BOARD_REQUEST_RECEIVED_AG_FAXES';
    }
    else {
        res = "CM_REQUEST_RECEIVED_CM_FAXES";
    }
    return res;
}

function getUniqueFaxName() {
    var modName = isMAL ? $('#selectRequestReceivedModuleMAL').data("kendoDropDownList").text() : $('#selectRequestReceivedModule').data("kendoDropDownList").text();
    return getModuleFaxRoleName(modName);
}

// IsFrom : Widget Number
function DashBoardWidgetRoles(IsFrom, WidgetName) {
    $('#moveFaxToArchive').hide();
    $('#moveArchiveToUnArchive').hide();
    if (IsFrom == 3) {
        $("#btnReqExpndClick").show(); $("#btnRequestReceivedCareSignOff").hide(); $("#btnRequestReceivedCareReject").hide(); $("#btnRequestReceivedAccept").hide(); $("#btnReqRejAck").hide();
    }
    if (IsFrom == 1 && WidgetName == 'MY_MEMBERS') {
        if (!(PHNavID == 1 || isProviderUser)) {
            $(".divClsMemberMenuAddActivity").ApplyRoleConfig({ className: "divClsMemberMenuAddActivity", UniqueName: "DASH_BOARD_MY_MEMBERS", IsFrom: "Add", IsRemoveElement: true });
            $(".divClsMemberMenuSendMsg").ApplyRoleConfig({ className: "divClsMemberMenuSendMsg", UniqueName: "DASH_BOARD_MY_MEMBERS", IsFrom: "Add", IsRemoveElement: true });
        }

        $("#btnMemexpndClick").ApplyRoleConfig({ Id: "btnMemexpndClick", UniqueName: "DASH_BOARD_MY_MEMBERS", IsFrom: "View", IsRemoveElement: true });
        $("#divMemberMenuMemberAlerts").ApplyRoleConfig({ Id: "divMemberMenuMemberAlerts", UniqueName: "AHS_CM_ACTIVITY_RECORD_MEMBER_ALERTS", IsFrom: "View", IsRemoveElement: false, DefaultHide: true });
    }
    else if (IsFrom == 1 && WidgetName == 'OPEN_AUTHS') {
        $(".divClsOpenAuthorizationMenuAddActivity").ApplyRoleConfig({ className: "divClsOpenAuthorizationMenuAddActivity", UniqueName: "DASH_BOARD_OPEN_AUTHORIZATIONS", IsFrom: "Add", IsRemoveElement: true });
        $(".divClsOpenAuthorizationMenuUpdateAuth").ApplyRoleConfig({ className: "divClsOpenAuthorizationMenuUpdateAuth", UniqueName: "DASH_BOARD_OPEN_AUTHORIZATIONS", IsFrom: "Edit", IsRemoveElement: true });

        $(".divClsOpenAuthorizationMALMenuAddActivity").ApplyRoleConfig({ className: "divClsOpenAuthorizationMALMenuAddActivity", UniqueName: "DASH_BOARD_OPEN_AUTHORIZATIONS", IsFrom: "Add", IsRemoveElement: true });
        $(".divClsOpenAuthorizationMALMenuUpdateAuth").ApplyRoleConfig({ className: "divClsOpenAuthorizationMALMenuUpdateAuth", UniqueName: "DASH_BOARD_OPEN_AUTHORIZATIONS", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 1 && WidgetName == 'OPEN_COMPLAINTS') {
        $(".divClsUpdateComplaint").ApplyRoleConfig({ UniqueName: "DASH_BOARD_OPEN_COMPLAINTS", className: "divClsUpdateComplaint", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsReAssignComplaint").ApplyRoleConfig({ UniqueName: "DASH_BOARD_OPEN_COMPLAINTS", className: "divClsReAssignComplaint", IsFrom: "Edit", IsRemoveElement: true });

        $(".divClsOpenComplaintsMALUpdateComplaint").ApplyRoleConfig({ UniqueName: "DASH_BOARD_OPEN_COMPLAINTS", className: "divClsOpenComplaintsMALUpdateComplaint", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsOpenComplaintsMALReAssignComplaint").ApplyRoleConfig({ UniqueName: "DASH_BOARD_OPEN_COMPLAINTS", className: "divClsOpenComplaintsMALReAssignComplaint", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 1 && WidgetName == 'PENDING_AUTH_ACTIVITIES') {
        var grdName = isMAL == true ? "PendingAuthActvtsMAL" : "PendingActivityGrid";
        $(".PARRun", "#" + grdName).ApplyRoleConfig({ UniqueName: "DASH_BOARD_PENDING_AUTH_ACTIVITIES", className: "PARRun", IsFrom: "Edit", IsRemoveElement: false });
    }
    else if (IsFrom == 1 && WidgetName == 'PENDING_COMPLAINT_ACTIVITIES') {

        var grdName = isMAL == true ? "PendingCompActvtsMAL" : "PendingComplaintActivities";
        $(".PARRun", "#" + grdName).ApplyRoleConfig({ UniqueName: "DASH_BOARD_PENDING_COMPLAINT_ACTIVITIES", className: "PARRun", IsFrom: "Edit", IsRemoveElement: false });
    }
    if (IsFrom == 1 && WidgetName == 'MY_CARE_MEMBERS') {

        $("#btndeletefilter").ApplyRoleConfig({ Id: "btndeletefilter", UniqueName: "DASH_BOARD_MY_CARE_MEMBERS", IsFrom: "Delete", IsRemoveElement: true });
        $("#btnAddActivity").ApplyRoleConfig({ Id: "btnAddActivity", UniqueName: "DASH_BOARD_MY_CARE_MEMBERS", IsFrom: "Add", IsRemoveElement: true });
        $("#btnUnassign").ApplyRoleConfig({ Id: "btnUnassign", UniqueName: "DASH_BOARD_MY_CARE_MEMBERS", IsFrom: "Edit", IsRemoveElement: true });
        $("#btnMembersExportExcel").ApplyRoleConfig({ Id: "btnMembersExportExcel", UniqueName: "DASH_BOARD_MY_CARE_MEMBERS", IsFrom: "Export", IsRemoveElement: true });

        if (!(PHNavID == 1 || isProviderUser)) {
            $("#btnSaveFilter").ApplyRoleConfig({ Id: "divClsMemberMenuSendMsg", UniqueName: "DASH_BOARD_MY_CARE_MEMBERS", IsFrom: "Add", IsRemoveElement: true });
        }

    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_CM_ACTIVITIES') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_ACTIVITIES", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_CM_APPOINTMENTS') {
        $("#divAppointmentMenuReject_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_APPOINTMENTS", Id: "divAppointmentMenuReject_", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_APPOINTMENTS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $("#divAppointmentMenuRejectMAL_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_APPOINTMENTS", Id: "divAppointmentMenuRejectMAL_", IsFrom: "Edit", IsRemoveElement: true });
    }

    else if (IsFrom == 3 && WidgetName == 'REQ_REC_CM_MESSAGES') {
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MESSAGES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom === 3 && WidgetName === 'REQ_REC_FAXES') {
        if (SetRoleAccessOnMALNavigation()) {
            $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: getUniqueFaxName(), Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true });
        }
        if ($('#selMessageType').val() !== "2") {
            $('#moveFaxToArchive').show();
        } else {
            $('#moveArchiveToUnArchive').show();
        }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_CM_MEMBERS') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_MEMBERS", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_CM_CARE_PLAN') {
        $("#btnRequestReceivedCareSignOff").show(); $("#btnRequestReceivedCareReject").show();
        $("#divCarePlanMenuSignOff_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", Id: "divCarePlanMenuSignOff_", IsFrom: "Edit", IsRemoveElement: true });
        $("#divCarePlanMenuReject_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", Id: "divCarePlanMenuReject_", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqrecSignOff").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", className: "ReqrecSignOff", IsFrom: "Edit", IsRemoveElement: true });
        $(".RecRecReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", className: "RecRecReject", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $("#divCarePlanMenuSignOffMAL_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", Id: "divCarePlanMenuSignOffMAL_", IsFrom: "Edit", IsRemoveElement: true });
        $("#divCarePlanMenuRejectMAL_").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", Id: "divCarePlanMenuRejectMAL_", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqrecSignOffMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", className: "ReqrecSignOffMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".RecRecRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_CM_CARE_PLAN", className: "RecRecRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_AG_ACTIVITIES') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_ACTIVITIES", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_AG_COMPLAINTS') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_AG_COMPLAINTS", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_UM_ACTIVITIES') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_ACTIVITIES", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_UM_AUTHORIZATIONS') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REC_MS_ACTIVITIES') {
        $("#btnRequestReceivedAccept").show();
        $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAccept").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "ReqRecAccept", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

        $(".divClsMemberMenuAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "divClsMemberMenuAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuRejectMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "divClsMemberMenuRejectMAL", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAcceptMAL").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REC_MS_ACTIVITIES", className: "ReqRecAcceptMAL", IsFrom: "Edit", IsRemoveElement: true });
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_CM_ACTIVITIES') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_ACTIVITIES", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_ACTIVITIES", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_CM_APPOINTMENTS') {
        $("#btnReqRejAck").show();
        $(".divClsAppointmentMenuAcknowledge").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_APPOINTMENTS", className: "divClsAppointmentMenuAcknowledge", IsFrom: "Edit", IsRemoveElement: true });
        $(".ReqRecAck").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_APPOINTMENTS", className: "ReqRecAck", IsFrom: "Edit", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_APPOINTMENTS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }

    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_CM_MEMBERS') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_MEMBERS", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_MEMBERS", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_CM_MEMBERS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_AG_ACTIVITIES') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_ACTIVITIES", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_ACTIVITIES", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_AG_COMPLAINTS') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_COMPLAINTS", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_COMPLAINTS", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_AG_COMPLAINTS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_UM_ACTIVITIES') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_ACTIVITIES", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_ACTIVITIES", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_UM_AUTHORIZATIONS') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_AUTHORIZATIONS", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_AUTHORIZATIONS", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_UM_AUTHORIZATIONS", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }
    else if (IsFrom == 3 && WidgetName == 'REQ_REJ_MS_ACTIVITIES') {
        $(".divClsMemberMenuRefer").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_MS_ACTIVITIES", className: "divClsMemberMenuRefer", IsFrom: "Edit", IsRemoveElement: true });
        $(".divClsMemberMenuDelete").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_MS_ACTIVITIES", className: "divClsMemberMenuDelete", IsFrom: "Delete", IsRemoveElement: true });
        if (SetRoleAccessOnMALNavigation()) { $("#btnReqExpndClick").ApplyRoleConfig({ UniqueName: "DASH_BOARD_REQ_REJ_MS_ACTIVITIES", Id: "btnReqExpndClick", IsFrom: "View", IsRemoveElement: true }); }
    }

}

function generateLastNameTooltipHtml(data) {    // NOSONAR (sonar complains that this method is not used and should be removed - which is not true)

    var html = '';
    if (data.IsSensitiveDiagnosis) {
        html = "You cannot access this member as this member has a sensitive diagnosis.";
    } else {
        var tdAge = isEmpty(data.Age) ? 'N/A' : data.Age;
        var tdHomePhone = isEmpty(data.HomePhone) ? 'N/A' : data.HomePhone;
        var tdRiskCategoryName = isEmpty(data.RiskCategoryName) ? 'N/A' : data.RiskCategoryName;
        var tdSex = isEmpty(data.Sex) ? 'N/A' : data.Sex;
        var tdComments = isEmpty(data.Comments) ? 'N/A' : escapeHtml(data.Comments);
        var tdAcceptComments = isEmpty(data.AcceptComments) ? 'N/A' : escapeHtml(data.AcceptComments);
        var tdVenue = isEmpty(data.Venue) ? 'N/A' : escapeHtml(data.Venue);
        var tdAssignedTo = isEmpty(data.AssignedTo) ? 'N/A' : (data.AssignedTo);
        var lblNotesType = isEmpty(data.NoteType) ? 'Comments ' : (data.NoteType + ' Notes ');
        tdComments = isEmpty(data.NoteType) ? tdAcceptComments : tdComments;
        html = "<div style='text-align: left !important;'>";
        html += '<b><u>Member Follow up Details</u></b>';
        html += '<br><b>Age: </b>' + tdAge;
        html += '<br><b>Phone: </b>' + tdHomePhone;
        html += '<br><b>Assigned Risk Level: </b>' + tdRiskCategoryName;
        html += '<br><b>Gender: </b>' + tdSex;
        html += '<br><b>Assigned To: </b>' + tdAssignedTo;
        html += '<br><b>' + lblNotesType + ' :</b>' + tdComments;
        html += '<br><b>Contact Type: </b>' + tdVenue;
        html += '</div>';
    }
    return html;
}

function isEmpty(val) {
    return typeof (val) === 'undefined' || val == null || val.length <= 0 || val == 'null';
}

//My Act Log END

function editDocumentAndNotesBasedOnProfile(HealthNoteOrDocumentId, IsEdit, IsNotesorDocument) {
    var resultDocumentandNotes = "";
    var patientId = 0;
    if (window.top.$(".InAuthPage").is(":visible") && window.top.UmPatient_AuthInfo("", "").AuthNo > 0) {
        patientId = window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    else if (window.top.$(".InComplaintPage").is(":visible") && window.top.AgData.complaintInfo().complaintNo > 0) {
        patientId = window.top.AgData.complaintInfo().patientId;
    }
    else {
        patientId = $('#selectPatientAccessedDdl').val();
    }
    if (patientId > 0) {
        $.ajax({
            type: "POST",
            url: baseURL + "/Activity/EditDocumentAndNotesBasedOnProfile?CareStaffId=" + getMemberId().MemberId + "&PatientId=" + patientId,
            data: { IsNotes: HealthNoteOrDocumentId, IsEdit: IsEdit, RecordID: IsNotesorDocument },
            async: false,
            success: function (data) {
                resultDocumentandNotes = data;
            }
        });
    }
    return resultDocumentandNotes;
}

function CreateDropCheckForServicePlan(sVal, parEle) {
    var htm = "<input id='ddlDaysval' type='text' class='droptexthide' data-id='ddlDays' autocomplete='off'  readonly='true'  onclick='showdropServicePlan(this)' placeHolder='0' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='ddlDayshdn' value=''/><input type='hidden' id='ddlDayNameshdn' value=''/>";
    htm = htm + "<div id='ddlDayschk' class='dropcheck' style='display:none;width:150px !important' tabindex='0'>";

    var AllDays = "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Weekly";
    AllDays = AllDays.split('|');
    if (sVal != "" && sVal != null && sVal != 'null')
        var SelectedDays = sVal.split('|');

    $.each(AllDays, function (key, allVal) {
        if (jQuery.inArray(allVal, SelectedDays) != '-1') {
            htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' checked='checked' onchange='clickedServicePlan(this,0)' /><div id='spnDays' title='" + allVal + "' onclick='spnclickedServicePlan(this)' style='cursor:pointer;'>" + allVal + "</div><br/>";
        } else
            htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedServicePlan(this,0)' /><div id='spnDays' title='" + allVal + "' onclick='spnclickedServicePlan(this)' style='cursor:pointer;'>" + allVal + "</div><br/>";
    });
    htm = htm + "</div>";
    $(parEle).find('#ddlDays').html('');
    $(parEle).find('#ddlDays').append(htm);
    clickedServicePlan(0, parEle);
}

//For UM Module
function CreateDropCheckForAuth(sVal, parEle, isEdit, isClear) {
    var width = $('#ddlDays').width();
    var htm = "<input id='ddlDaysval' type='text' class='ah-input droptexthide' data-id='ddlDays' autocomplete='off'  readonly='true'  onclick='showdropServicePlan(this,1)' placeHolder='0' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='ddlDayshdn' value=''/><input type='hidden' id='ddlDayNameshdn' value=''/><input type='hidden' id='ddlServiceDayshdn' value=''/>";
    htm = htm + "<div id='ddlDayschk' class='dropcheck' style='display:none;width:165px !important' tabindex='0' onmouseleave='checkDaysChanged(this);'>";

    var AllDays = "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Weekly";
    AllDays = AllDays.split('|');

    if (isEdit == "1") {
        $.each(AllDays, function (key, allVal) {
            if (sVal != null && sVal != "" && sVal.length > 0) {
                var OptText = sVal.substring(key, key + 1);
                if (OptText == "1") {
                    htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' checked='checked' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
                } else
                    htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
            }
            else
                htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
        });
    }
    else {
        $.each(AllDays, function (key, allVal) {
            if (sVal != null && sVal != "" && sVal.length > 0) {
                var SelectedDays = sVal.split('|');
                if (jQuery.inArray(allVal, SelectedDays) != '-1') {
                    htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' checked='checked' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
                } else
                    htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
            }
            else
                htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedServicePlan(this,0,1)' /><div id='chkDaysspn' title='" + allVal + "' onclick='spnclickedServicePlan(this,1)' style='cursor:pointer;'>" + allVal + "</div><br/>";
        });
    }

    htm = htm + "</div>";
    $(parEle).find("#ddlDays").html('');
    $(parEle).find("#ddlDays").append(htm);
    $(parEle).find("#ddlServiceDayshdn").val(sVal);
    $(document).off('mouseleave', '#ddlDays').on('mouseleave', '#ddlDays', function () {
        if ($(this).attr('type') != 'checkbox') {
            $(".dropcheck").hide();
        }
    });
    if (isClear == undefined) {
        clickedServicePlan(0, parEle, 1);
    }
    //$("#ddlDays").append("<div><input id='ddlDaysval' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");
}

function ReturnWorkQueueControlType() {
    var controlType = "checkbox";
    if (isWorkQueueSingle == 'S') { controlType = 'radio'; }
    return controlType;
}

function ShowCareStaffPendingReferences(careStaffId, memberName) {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/Admin/PendingCareStaffReferences",
        onLoad: function () {
            $("#hdnSelectedStaffId").val(careStaffId);
            $("#hdnSelectedStaffName").val(memberName);
            $('#PendingCareStaffReferences').data("kendoGrid").dataSource.read();
        },
        onClose: function () {
            var $CheckBoxsAll;
            var $HeaderCheckBox;
            var gridview = $("#id1frame").contents().find("#gvMangeCareStaff");
            $CheckBoxsAll = gridview.find("input:checkbox[id*=gvMangeCareStaff_CHK_Item]");
            $HeaderCheckBox = gridview.find("input:checkbox[id*=gvMangeCareStaff_CHK_Header]");
            $($CheckBoxsAll).attr('checked', false);
            $($HeaderCheckBox).attr('checked', false);
            $('#popUpDialog1').html('');
        },
        popUpHeader: "Care Staff References",
        closeButton: '#btnCancelPendRefs'
    });
}

function LoadWorkLogMgrCmActivities() {
    if ($("#CMPendingActivitiesGrid").data("kendoGrid") != null)
        $("#CMPendingActivitiesGrid").data("kendoGrid").dataSource.read();
}

function ViewOGGIAssociatedScripts(oggiLobId) {
    $('#hdnOggiLobId').val(oggiLobId);
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/ScriptConfig/ViewScriptsAssociatedToOggi",
        onLoad: function () {
        },
        popUpHeader: "Scripts associated to OGGI",
        popLevel: 0,
        closeButton: "#btnCloseEditActivityForm"
    });
}

function CheckIfActivityPerformed(moduleId, RefId, Obj) {//Obj param = Obj  for AG, , AuthNo for UM
    $.ajax({
        type: "GET",
        url: baseURL + "/Config/CheckIfActivityPerformed?moduleId=" + moduleId + "&refId=" + RefId,
        dataType: "json",
        success: function (data) {
            if (data.result == 1) {
                CustomAlert("Activity already been performed/ deleted.");
                if (moduleId == 5)
                    $("#AGPendingActivitiesGrid").data("kendoGrid").dataSource.page(1);
                else if (moduleId = 3)
                    $("#UMPendingActivitiesGrid").data("kendoGrid").dataSource.page(1);
                loader(0);
            }
            else {
                if (moduleId == 5)//AG
                    performComplaintActivity(RefId, Obj);
                else if (moduleId = 3)//UM
                    perform(RefId, Obj);
                loader(0);
            }
        }
    });
}

function ShowUMMillimanSummary(Source, Type) {
    var Details = $(Source).attr("data-details");
    var SplitData = Details.split('|');
    var ViewType = "";
    if (Type == 1) { ViewType = "Documentation"; } else { ViewType = "EpisodeSummary"; }
    var PatientId = SplitData[2];
    var MCGUrl = SplitData[0], ReviewCid = SplitData[1], AuthNo = SplitData[3], DecisionId = SplitData[4], InterqualUrl = SplitData[5];
    var SourceTypeId = SplitData[7];
    loader(0);
    var source = "";
    if (SourceTypeId === GuidelineTypesEnum.Interqual) {
        var paramsdata;
        if (InterqualUrl != 'N/A') {
            if (ViewType == "Documentation") {
                paramsdata = {
                    "AuthNO": AuthNo,
                    "ReviewID": ReviewCid,
                    "StaffID": memberidval,
                    "Module": "UM",
                    "PatientID": PatientId,
                    "DecisionID": DecisionId
                };
                source = baseURL + "/GCAuthentication/LaunchInterqual?route=" + encodeURI("home/index") + "&parameters=" + btoa(JSON.stringify(paramsdata));
                window.open(source, (window.browserPopUpName || window.top.browserPopUpName), "'status=no,toolbar=no,menubar=no,location=no,scrollbars=yes,left=50,height=650,width=1200'");
            }
            else {
                paramsdata = {
                    "Module": "UM",
                    "EpisodeID": ReviewCid,
                    "PatientID": PatientId,
                };

                source = baseURL + "/GCAuthentication/LaunchInterqual?route=ViewEpisodeSummary.aspx" + "&parameters=" + btoa(JSON.stringify(paramsdata));
                window.open(source, (window.browserPopUpName || window.top.browserPopUpName), "' status=no,toolbar=no,menubar=no,location=no, scrollbars=yes,left=200,height=650,width=1000'");
            }
        }
        else {
            //alert("InterQual Url is not configured");
            CustomAlert("Some error occurred, contact system administrator.");
        }
    }
    else {
        if (MCGUrl != "N/A") {
            var data = {
                "AuthNo": AuthNo,
                "RequestType": ViewType,
                "StaffId": memberidval,
                "Module": "UM",
                "EpisodeId": ReviewCid,
                "PatientId": PatientId,
                "DecisionId": DecisionId
            };
            source = baseURL + "/GCAuthentication/LaunchMcg?parameters=" + btoa(JSON.stringify(data));
            window.open(source, (window.browserPopUpName || window.top.browserPopUpName), "'height=750,width=1200,status=no,toolbar=no,menubar=no,location=no, scrollbars=yes'");
        }
        else {
            //alert("MCG Url is not configured");
            CustomAlert("Some error occurred, contact system administrator.");
        }
    }
}

//Refresh logic of MyActivityLog  ==== START
function RefreshGridOnActionPerformed(grdSection, module) {
    if (isMAL) {
        switch (grdSection) {
            case "TCAL":
                RefreshMyActLogGrid("btnTCALSearchMAL", "divTodayActivityLogGridHeader", module, "selectTCALModuleMAL");
                break;
            case "OPENAUTH":
                RefreshMyActLogGrid("btnOpenAuthorizationSearchMAL", "divOpenAuthGridHeader", module, '');
                break;
            case "OPENCOM":
                RefreshMyActLogGrid("divOpenCompGridHeader", "divOpenCompGridHeader");
                break;
            case "REQREC":
                RefreshMyActLogGrid("btnRequestReceivedSearchMAL", "divRequestReceivedGridHeader", module, "selectRequestReceivedModuleMAL");
                break;
            case "REQREJ":
                RefreshMyActLogGrid("btnRequestRejectedSearchMAL", "divRequestRejectedGridHeader", module, "selectRequestRejectedModuleMAL");
                break;
            case "PEROTHER":
                RefreshMyActLogGrid("divActvtPerfByOthersGridHeader", "divActvtPerfByOthersGridHeader");
                break;
        }
    }
}

function SetRoleAccessOnWizards(uniqueName) {
    var res = getSpecRoleItem(uniqueName);
    return (res != undefined && res != null && res.length > 0 && res[0].IsView == false)
}

function CheckMALPermission() {
    if (SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_CM_ACTIVITIES") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_CM_MEMBERS") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_CM_APPOINTMENTS") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_CM_CARE_PLAN") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_CM_MESSAGES") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_UM_ACTIVITIES") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_UM_AUTHORIZATIONS") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_AG_ACTIVITIES") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REC_AG_COMPLAINTS") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_CM_ACTIVITIES") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_CM_MEMBERS") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_CM_APPOINTMENTS") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_UM_ACTIVITIES") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_UM_AUTHORIZATIONS") && SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_AG_ACTIVITIES") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQ_REJ_AG_COMPLAINTS") && SetRoleAccessOnWizards("AHS_DASHBOARD_CALENDAR") && SetRoleAccessOnWizards("DASH_BOARD_OPEN_AUTHORIZATIONS") &&
        SetRoleAccessOnWizards("DASH_BOARD_OPEN_COMPLAINTS") && SetRoleAccessOnWizards("MY_ACT_LOG_PERFORMED_BY_OTHER_STAFF") && SetRoleAccessOnWizards("CM_REQUEST_RECEIVED_CM_FAXES") &&
        SetRoleAccessOnWizards("DASH_BOARD_REQUEST_RECEIVED_UM_FAXES") && SetRoleAccessOnWizards("DASH_BOARD_REQUEST_RECEIVED_AG_FAXES")) {
        return false;
    }
    return true;
}
//Refresh logic of MyActivityLog  ==== END

function getMemberId() {
    return {
        MemberId: memberidval
    }
}

function AutoSelectIfSingleValue(controlId) {
    var crtl = $('#' + controlId + '');
    var length = $(crtl).data("kendoDropDownList").dataSource.options.data.length;
    if (length == 2) {
        var dosageId = $(crtl).data("kendoDropDownList").dataSource.options.data[1].value;
        (crtl).data("kendoDropDownList").value(dosageId);
    }
}

function ValidateStartAndEndDatesRange(startDate, endDate) {
    if ((startDate != null && startDate != '' && startDate != 'undefined') && (endDate != null && endDate != '' && endDate != 'undefined')) {
        if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
            CustomAlert('From date should be less than To date.');
            return false;
        }
    }
    return true;
}
function deleteOverlay() {
    if ($(".InAuthPage").is(":visible")) {
        $('#lean_overlay_level_1').remove();
    }
}
function ViewReviewCarePlanDetails(val) {
    var patientId = $(val).attr('data-patientId');
    var status = $(val).attr('data-status');
    var carePlanProviderReviewId = $(val).attr('data-carePlanProviderReviewId');
    var isFrom = $(val).attr('data-isFrom');

    //selectedRCPAck --- patientId,carePlanProviderReviewId,isFrom,selectedCarePlanIds,status
    deleteOverlay();
    loader(1);
    selectedRCPAck = patientId + "~" + carePlanProviderReviewId + "~" + isFrom;
    $('#popUpDialog2').css('width', '75%');
    $('#popUpDialog2').html('').CMNPopup({
        pvUrl: baseURL + "/CarePlan/ViewCarePlanDetails",
        onLoad: function () {
            loader(1);
            var url = baseURL + '/PopulationHealth/FullCarePlanPrint?patientIds=' + patientId + '&carePlanReviewIds=' + selectedRCPAck.split('~')[1]
                + '&status=' + status + '&printSections=Conditions,Medications,Care Team,Targeted Interventions,Clinical Interventions,Care Plan Notes' + '&isFrom=' + isFrom + '&baseURL=' + baseURL;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                success: function (data) {
                    loader(0);
                    $("#divContent").AhsSetHtml(data.content);
                    selectedRCPAck = selectedRCPAck + '~' + data.selectedCarePlanIds + '~' + status;
                    if (CheckBrowser() == "FF" || CheckBrowser() == "IE") {
                        $('.carePlan-popup').css("padding", "15px 0px 65px");
                    }
                    $('#tblMain,#tblMemberDetails,#tblCareTeam,#tblConditions,#tblInterventions,#tblMedications,#tblTargetedInterventions').addClass('CH-gridbrd_fntJS').css('width', '100%');
                    $('#pageId').remove();
                    // Displayed in grey color when data is 'Not Available'
                    gridNotAvailableCustomColor('tblCareTeam', 'Not Available', 'tr td');
                    gridNotAvailableCustomColor('tblMemberDetails', 'Not Available', 'tr td');
                    gridNotAvailableCustomColor('tblConditions', 'Not Available', 'tr td');
                    gridNotAvailableCustomColor('tblMedications', 'Not Available', 'tr td');
                    gridNotAvailableCustomColor('tblTargetedInterventions', 'Not Available', 'tr td');
                    gridNotAvailableCustomColor('tblInterventions', 'Not Available', 'tr td');

                    if (isFrom == 'PH') {
                        $('#btnCarePlanReviewExport,#btnSingleCPRExportToXML').show();
                        var isExport = $.greproleext(roleConfig, function (ele, _ind) {
                            return ele.UniqueName === "PH_AHS_MEMBER_REQUEST_RECEIVED_CAREPLAN_REVIEW";
                        });
                        if (isExport != null && isExport.length > 0 && !isExport[0].IsExport)
                            $('#btnCarePlanReviewExport,#btnSingleCPRExportToXML').hide();
                    }
                    $("#spnTitle").css("vertical-align", "inherit");// && isFrom == 'PH'
                    if (status == 'Acknowledged' || status == 'Closed')
                        DisableCPRAcknowledgeButton();
                    if ($(".InAuthPage").is(":visible"))
                        $('#popUpDialog2').css("margin-left", "0px");
                    loader(0);
                }
            });
        },
        onClose: function () {
            $('#popUpDialog2').css('width', '');
        },
        popLevel: 2,
        popUpHeader: "View Care Plan",
        closeButton: '#btnReviewCarePlanCancel'
    });
}

function ViewTargetedInterventionDetails(val) {
    var patientId = $(val).attr('data-patientId');
    var status = $(val).attr('data-status');
    var carePlanProviderReviewId = $(val).attr('data-carePlanProviderReviewId');
    var isFrom = $(val).attr('data-isFrom');

    selectedRCPAck = patientId + "~" + carePlanProviderReviewId + "~" + isFrom;
    loader(1);
    $('#popUpDialog2').css('margin-left', '');
    $('#popUpDialog2').css('width', '75%');
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/CarePlan/ViewCarePlanDetails",
        onLoad: function () {
            $('.ftr-cr-pln').css({ 'display': 'none' });
            var url = baseURL + '/PopulationHealth/TargetedInterventionDetails?patientId=' + patientId + '&status=' + status + '&carePlanReviewIds=' + carePlanProviderReviewId;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                success: function (data) {
                    $("#divContent").AhsSetHtml(data.content);
                    $('#tblTargetedInterventions').css('width', '100%').addClass('CH-gridbrd_fntJS');
                    loader(0);
                }
            });
            if (enableDomLogs) {
                DomUtils.logDomData("Member Info>>Care Plan>>Care Plan Review>>View Targeted Intervention");
            }
        },
        onClose: function () {
            $('#popUpDialog2').css('width', '');
        },
        popLevel: 2,
        popUpHeader: "View Targeted Intervention"
    });
}

//To display validation message if letter template is not configured
function CheckIfLetterTemplateConfigured(lobbenid, templateName, languageId) {
    var dataString = '';
    dataString = { LobBenId: lobbenid, templateName: templateName, languageId: languageId };
    var isConfigured = false;
    $.ajax({
        type: "GET",
        url: baseURL + "/CommonDefaultSessionState/CheckIfLetterTemplateConfigured/",
        data: dataString,
        dataType: "json",
        async: false,
        success: function (data) {
            isConfigured = data.isTempConfigured;
        },
        error: function () { }
    });
    return isConfigured;
}
/*method toshow validation when running new script, if same script is already scheduled on the member*/
function showValidationIfScptScheduled() {
    var patientId = AppContextManager.PatientContext.getPatientId() !== "" ? AppContextManager.PatientContext.getPatientId() : $("#hdnPHRunScriptMemberId").val();
    var pardata = { patientId: patientId !== '' ? patientId : $('#selectPatientAccessed').val(), scriptId: $('#ddlScriptsmvc').val() };
    $.ajax({
        url: baseURL + "/Assessment/ShowMessageIfScriptActSchdld",
        type: "POST",
        data: pardata,
        async: false,
        success: function (data) {
            if (data.success) {
                if (data.pastDt != '' && data.futureDt != '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml('This Script was already scheduled on ' + data.pastDt + ' and also is scheduled on ' + data.futureDt + '.');
                }
                else if (data.futureDt != '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml('This Script is already scheduled on ' + data.futureDt + '.');
                }
                else if (data.pastDt != '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml('This Script was already scheduled on ' + data.pastDt + '.');
                }
                else { $('#spnShowValdMsgRQ').AhsSetHtml(''); }
            }
        }
    });
}

function CheckProviderAddConfiguration(type) {
    var unquieName = (type == "Provider") ? "AHS_CMN_MANAGE_PROVIDER" : "AHS_CMN_MANAGE_PROVIDER_ADDRESS";
    var providerRoleItem = getSpecRoleItem(unquieName);
    if (providerRoleItem != null && providerRoleItem.length != 0) {
        return providerRoleItem[0].IsAdd;
    }
    else
        return true;
}

function checkProvConfigForUMAG(type) {
    var unquieName = (type == "Provider") ? "AHS_CMN_MANAGE_PROVIDER" : "AHS_CMN_MANAGE_PROVIDER_ADDRESS";
    var providerRoleItem = getSpecRoleItem(unquieName);
    if (providerRoleItem != null && providerRoleItem.length != 0) {
        return { IsAdd: providerRoleItem[0].IsAdd, IsView: providerRoleItem[0].IsView };
    }
    else {
        return { IsAdd: false, IsView: false };
    }
}

//This function is common to disable provider fields when "provider loaded throgh loads" and "provider Role permissions"
function DisableFieldsForProvider(isFrom) {
    isFrom = (isFrom == undefined) ? 1 : isFrom;
    $('#selectAddProviderType').prop('disabled', true);
    $('#PhysicianCode').prop('disabled', true);
    $('#ProviderName').prop('disabled', true);
    $('#selectSpecialityType').attr('disabled', 'disabled');
    $('#selectSpecialityType :input').attr('disabled', 'disabled');

    $('#FirstName').prop('disabled', true);
    $('#LastName').prop('disabled', true);
    $('#ClinicName').prop('disabled', true);
    $('#ClinicId').prop('disabled', true);

    $('#loadLOBIDdrop').attr('disabled', 'disabled');
    $('#loadLOBIDdrop :input').prop('disabled', 'disabled');

    $('#selectLanguageType').attr('disabled', 'disabled');
    $('#selectLanguageType :input').attr('disabled', 'disabled');

    $('#selectProvGenderType').prop('disabled', true);
    $('#selectEthnicityType').prop('disabled', true);
    $('#CellPhone').prop('disabled', true);
    $('#Email').prop('disabled', true);
    $('#AlternatePhone').prop('disabled', true);
    $('#DirectEmail').prop('disabled', true);
    $('#ProviderNpi').prop('disabled', true);
    $('#ProviderTaxId').prop('disabled', true);
    $("#AddtionalInfoProviderDiv").children().find('.txtboxfield').attr("disabled", "disabled");
    if (isFrom != 0) {
        $('#btnProviderAddressAdd').prop('disabled', true).css('opacity', '0.6');
        $('#btnProviderAddressEdit').prop('disabled', true).css('opacity', '0.6');
        $('#btnProviderAddressDelete').prop('disabled', true).css('opacity', '0.6');
    }
}

//This function is common to disable provider fields when "provider loaded throgh loads" and "provider Role permissions"
function DisableFieldsForExternalCareTeam(isFrom) {
    isFrom = (isFrom == undefined) ? 1 : isFrom;
    //isFrom 1 means provider loaded throgh loads
    if (isFrom == 1) {
        $('#lblDataThroughLoad').show();
        $('#btnCareTeamAddressAdd').prop('disabled', true).css('opacity', '0.6');
        $('#btnCareTeamAddressEdit').prop('disabled', true).css('opacity', '0.6');
        $('#btnCareTeamAddressDelete').prop('disabled', true).css('opacity', '0.6');
    }
    else {
        $('#ExCrTmFormId #ddlExtCrTmRoleForMember').prop("disabled", true);
        $('#ExCrTmFormId #ExtCTConfidentialType').prop("disabled", true);
        $('#ExCrTmFormId #txtExtCrTmCareNotes').prop("disabled", true);
    }
    $('#ddlExtCrTmRole').prop('disabled', true);
    $('#ProviderName').prop('disabled', true);
    $('#PhysicianCode').prop('disabled', true);
    //$('#ddlExtCrTmRoleForMember').prop('disabled', true);
    $('#txtExtFirstName').prop('disabled', true);
    $('#txtExtCrTmLastName').prop('disabled', true);
    $('#selectExtSpecialityType').prop('disabled', true);
    $('#selectExtSpecialityType :input').prop('disabled', true);

    $('#Organization_Clinic').prop('disabled', true);
    $('#ClinicId').prop('disabled', true);

    //$('#ddlLOBExternalCrTm').attr('disabled', 'disabled');
    //$("#ddlLOBExternalCrTm :input").attr("disabled", 'disabled');

    $('#ddlExtCrTmGender').prop('disabled', true);

    $('#ddlExCrTmLanguage').prop('disabled', true);
    $('#ddlExCrTmLanguage :input').prop('disabled', true);
    $('#ddlExCrTmEthnicity').prop('disabled', true);
    $('#txtExtCrTmCPhone').prop('disabled', true);
    $('#txtExtCrTmAPhone').prop('disabled', true);

    $('#DirectEmail').prop('disabled', true);
    $('#txtExtCrTmEmail').prop('disabled', true);
}

/**
 * @description determine if an array contains one or more items from another array.
 * @param {array} haystack the array to search.
 * @param {array} needles the array providing items to check for in the haystack.
 * @return {boolean} true|false if haystack contains item in needles.
 */
var findNeedleInHaystack = function (haystack, needles) {
    var result = needles.filter(function (item) { return haystack.indexOf(item) > -1 });
    return (result.length > 0);
};

/*Config columns pop up in Advance search*/
function AdvProviderSearchConfigColumns() {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/Common/DinamicColumns?section=" + "ADVANCE PROVIDER SEARCH",
        popUpHeader: "Config Columns",
        popLevel: 1,
        closeButton: '#btnCancel'
    });
};

/*To audit Log different section actions from where user can print, email, export/ download*/
function AuditLog(moduleId, actionType, sectionName, patientId, carestaffId, fileName, authId, complaintId, printQueueXML) {
    if (window.top.EnableAuditLog.toLowerCase() != "false") {
        //Api calling by passing the parameters 
        var urlString = baseURL + "/Audit/UserAction";
        var dataobj = {
            ModuleId: moduleId,
            ActionType: actionType,
            SectionName: sectionName,
            PatientId: $.fn.setNumberOnUndefinedOrNull(patientId),
            CareStaffId: $.fn.setNumberOnUndefinedOrNull(carestaffId),
            FileName: fileName,
            AuthNo: $.fn.setNumberOnUndefinedOrNull(authId),
            ComplaintNo: $.fn.setNumberOnUndefinedOrNull(complaintId),
            PrintQueueXML: printQueueXML
        }
        $.ajax({
            type: "POST",
            url: urlString,
            data: JSON.stringify(dataobj),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            success: function (data) {
            },
            error: function (e) {
                console.log(e);
            }
        });
    }
}

function ApplyPrintRolesInScripts() {
    try {
        var UniqueNameVal = "AHS_CM_ACTION_RUN_SCRIPT", IsUMorAG = false;
        if (window.top.$(".InAuthPage").is(":visible")) { UniqueNameVal = "AHS_UM_AUTH_DECISIONS"; IsUMorAG = true; }
        else if (window.top.$(".InComplaintPage").is(":visible")) { UniqueNameVal = "AHS_AG_COMPLAINT_GUIDELINES"; IsUMorAG = true; }

        if (IsUMorAG) {
            $('iframe:not(#iframeSmartCOMMSSo)').contents().find('#btnViewScriptSummaryPrint').ApplyRoleConfig({ UniqueName: UniqueNameVal, Id: "btnViewScriptSummaryPrint", IsFrom: "Print" });
            $('iframe:not(#iframeSmartCOMMSSo)').contents().find('#btnViewScriptSummaryFlowLayoutPrint').ApplyRoleConfig({ UniqueName: UniqueNameVal, Id: "btnViewScriptSummaryFlowLayoutPrint", IsFrom: "Print" });
        }
        else {
            $("#btnViewScriptSummaryPrint").ApplyRoleConfig({ UniqueName: UniqueNameVal, Id: "btnViewScriptSummaryPrint", IsFrom: "Print" });
            $("#btnViewScriptSummaryFlowLayoutPrint").ApplyRoleConfig({ UniqueName: UniqueNameVal, Id: "btnViewScriptSummaryFlowLayoutPrint", IsFrom: "Print" });
        }
    } catch (ex) {
        loader(0);
        console.log(ex.message);
    }
}
function ShowAuthPendingReferrals(AuthNo) {
    var IsUm = AuthNo;
    HANDLER_URL = "api/Route/GetUMResult";
    if (AuthNo == null || AuthNo == undefined) AuthNo = UmPatient_AuthInfo("", "").AuthNo;
    ModalClose();
    AjaxContent("AUTH_REFERRALS_INIT", "UM/Content/Html/AuthReferralSummary.html", function (PageResult) {
        if (IsUm) {
            legacyAlertSetModalData({
                Title: "Referral Summary", Content: PageResult, Close: true
            });
            $('#CMModalPopupDivMessage').css({ width: 500, left: 450 });
            $("#CMModalPopupDivMessage").find('#BtnOkMessage').hide();
            $("#CMModalPopupDivMessage").find('#CMModalPopup_HeadCloseMessage').show();
        }
        else {
            SetModalData({ Title: "Referral Summary", Content: PageResult, Close: true });
            $("#ModalPopupDiv").css({ 'width': '50%', 'left': '27%', 'top': '30px' });
            $("#ModalPopup_Content").css({ 'max-height': '550px', 'overflow': 'auto', 'text-align': 'left' });
        }
        $('.GrpActStrip').css('pointer-events', 'none');
        var AuthReferralDetailsForm = $("#AuthReferralForm");
        $("#Grid_AuthReferralSummary", AuthReferralDetailsForm).DataGrid({
            PostData: { DATA_KEY: "GET_AUTH_REFERRAL_DETAILS", SP_VA_AUTH_NO: AuthNo }, GridId: "GridAuthAuditSummary", Loader: true, MaxHeight: 300, PageSize: 10,
            Columns: [
                { HeadStyle: "width:150px;", Title: "Referred By", ItemKey: "ReferredByName", ItemNull: "N/A", ItemSort: "Referred_By_Name" },
                { HeadStyle: "width:150px;", Title: "Referred To", ItemKey: "ReferredToName", ItemNull: "N/A", ItemSort: "Referred_To_Name" },
                { HeadStyle: "width:135px;", Title: "Referred On", ItemKey: "ReferredOn", ItemNull: "N/A", ItemSort: "Referred_On", DateColumns: "ReferredOn", HeadClass: "apply12-24hrFormat" }
            ]
        }, function () {
            $('#Grid_AuthReferralSummary table tr').applyDateFormat(false);
        });
    });

}

/*Parameters for Plan autocmplete in Member >> Externalcareteam and Provider sections*/
function ExtProviderSearchPlanParameters() {
    var stringName = $("#ddlBenefitPlan").data("kendoAutoComplete").value().split(',');
    return {
        planName: stringName[stringName.length - 1],
        planIds: $('#hdnddlBenefitPlan').val()
    }
}

function SetKendoDropDownValue(ctrl, value) {
    if ($(ctrl).data("kendoDropDownList") != undefined) {
        $(ctrl).data("kendoDropDownList").dataSource.filter("");
        var kendoDropDownListCtrl = $(ctrl).data("kendoDropDownList");
        kendoDropDownListCtrl.value(value);
    }
    else
        $(ctrl).val(value);
}

function ClearKendoDropDownValues(ctrlId, value, text) {
    $(ctrlId).find('option').remove().end();
    $(ctrlId).append($('<option></option>').val(value).html($.fn.replaceAndEscapeHtmlExt(text)));
    $(ctrlId).kendoDropDownList({
        filter: "contains",
        animation: false
    });
    SetKendoDropDownValue(ctrlId, value);
}

function EnableDisableKendoDropDownValue(ctrl, value) {
    if ($(ctrl).data("kendoDropDownList") != undefined) {
        var enable = (value == true) ? false : true;
        var dropdownlist = $(ctrl).data("kendoDropDownList");
        dropdownlist.enable(enable);

    } else
        $(ctrl).attr('disabled', value);
}

function bindKendoMultiSelect(remoteUrl, MutiSelectId, textField, textValue, _placeholderValue, maxItems, TextList, ValueList, TextSsCode, authNo, isTransportModifier, patientId) {
    var dataTextFieldName = "data." + textField;
    var dataTextFieldValue = "data." + textValue;
    var ProcCode = TextSsCode.val();
    isTransportModifier = $.fn.setFalseOnUndefinedOrNull(isTransportModifier);
    $(MutiSelectId).kendoMultiSelect({
        dataTextField: textField,
        dataValueField: textValue,
        noDataTemplate: 'No Data!',
        headerTemplate: '<table dropdown-header k-widget k-header"><tr><td style="width:70px;padding-left:6px;font-weight:bold;font-size:14px;"><p>Modifier</p></td><td style="font-weight:bold;font-size:14px;"><p>Description</p></td></tr><tr style="background-color: rgb(255, 255, 255);" class="noDataMessage"><td colspan="2"  class="noDataMessageContent">&nbsp&nbspNo results found</td><td></td></tr></table>',
        itemTemplate: '<table style="width:100%" class="k-state-default LineGrid" aria-label="#: ' + dataTextFieldValue + ' #. #: ' + dataTextFieldName + ' #"><tr><td style="width:70px;"><p>#: ' + dataTextFieldValue + ' #</p></td><td><p>#: ' + dataTextFieldName + ' #</p></td></tr></table>',
        tagTemplate: '<span class="kendoMultiButton" data-code="#: ' + dataTextFieldValue + ' #" data-title="#: ' + dataTextFieldName + ' #">#:' + dataTextFieldValue + '#</span>',
        change: function (e) {
            $(MutiSelectId).closest(".IconModifierInfo").hide();
            $('.kendoMultiButton').each(function () {
                $(this).parent().parent().attr('title', $(this).attr("data-title"));
                $(this).parent().parent().addClass('kendomultiSelect-Btnheight');

            });
            var ctrl = $(MutiSelectId).data("kendoMultiSelect");
            if (e.sender.value().length === 5) {
                ctrl.input.attr('readonly', 'true');
            } else {
                ctrl.input.removeAttr('readonly');
            }
        },
        dataSource: {
            type: "json",
            serverFiltering: true,
            transport: {
                read: {
                    type: "POST",
                    url: remoteUrl,
                    datatype: "html",
                    data: function () {
                        var stringName = "";
                        if ($(MutiSelectId).data("kendoMultiSelect") !== undefined) {
                            $(MutiSelectId).data("kendoMultiSelect").ul.closest(".k-animation-container").hide();
                            $(MutiSelectId).data("kendoMultiSelect").ul.closest(".k-list-container").hide();
                            stringName = $(MutiSelectId).data("kendoMultiSelect").input.val();
                        }
                        if (!$.fn.isNullOrEmpty(ValueList)) {
                            return {
                                SP_VA_CODE_MODIFIER: stringName, SP_VA_PROC_CODE: ProcCode, SP_VA_AUTH_NO: authNo, SP_VA_IS_TRANSPORT_MODIFIER: isTransportModifier, SP_VA_COPY_CODE_MODIFIER: ValueList, SD_VA_PATIENT_ID: patientId, COLUMN_PATIENT_ID: "INPUT_PATIENT_ID"
                            };
                        }
                        else {
                            return {
                                SP_VA_CODE_MODIFIER: stringName, SP_VA_PROC_CODE: ProcCode, SP_VA_AUTH_NO: authNo, SP_VA_IS_TRANSPORT_MODIFIER: isTransportModifier, SD_VA_PATIENT_ID: patientId, COLUMN_PATIENT_ID: "INPUT_PATIENT_ID"
                            };
                        }
                    }
                }
            }

        },
        dataBound: function (e) {
            //e.sender.ul.closest(".k-animation-container").hide();
            e.sender.ul.closest(".k-animation-container").addClass('KendoMultiSelectAutoComplete');
            if (!e.sender.dataSource.view()[0]) {
                e.sender.list.find(".noDataMessageContent").html("No results found");
                e.sender.list.find(".noDataMessage").show();
                e.sender.ul.css('height', '0px');
                e.sender.ul.closest(".k-list-container").css('height', '80px');
                e.sender.ul.closest(".k-list-container").show();
                e.sender.ul.closest(".k-animation-container").show();
            }
            else {
                e.sender.list.find(".noDataMessage").hide();
                $('.kendoMultiButton').each(function () {
                    var element = $(this).parent().parent();
                    element.attr('title', $(this).attr("data-title"));
                    element.addClass('kendomultiSelect-Btnheight');

                });
                if ($(MutiSelectId).data("kendoMultiSelect") != undefined && $(MutiSelectId).data("kendoMultiSelect").input != null && $(MutiSelectId).data("kendoMultiSelect").input.val().length > 0) {
                    if (e.sender.dataSource.view().length == 1) {
                        var currVal = $(MutiSelectId).data("kendoMultiSelect").input.val();
                        var selectedValues = $(MutiSelectId).data("kendoMultiSelect").value();
                        if (selectedValues != null && selectedValues.length > 0) {
                            for (var i = 0; i < currVal.length; i++) {
                                if (selectedValues[i] == currVal) {
                                    e.sender.list.find(".noDataMessageContent").html("Already selected");
                                    e.sender.list.find(".noDataMessage").show();
                                    e.sender.ul.css('height', '0px');
                                    e.sender.ul.closest(".k-list-container").css('height', '80px');
                                }
                            }
                        }
                    }
                    e.sender.ul.closest(".k-list-container").show();
                    e.sender.ul.closest(".k-animation-container").show();
                }

            }

        },
        height: 300
    });

    if (TextList === undefined || TextList === null || TextList === "") {
        TextList = 'N/A';
    }
    if (ValueList != undefined && ValueList != null && ValueList != "") {
        var arrText = TextList.split('‡');
        var arrValue = ValueList.split(',');
        var SavedList = [];
        var selectarr = [];
        for (var i = 0; i < arrValue.length; i++) {
            SavedList.push({ "ProcCodeModifierDescription": arrText[i], "ProcCodeModifier": arrValue[i] });
            selectarr.push(arrValue[i]);
        }
        $(MutiSelectId).data('kendoMultiSelect').dataSource.data(SavedList);
        $(MutiSelectId).data('kendoMultiSelect').value(selectarr);
        $('.kendoMultiButton').each(function () {
            $(this).parent().parent().attr('title', $(this).attr("data-title"));
            $(this).parent().parent().addClass('kendomultiSelect-Btnheight');
        });
        if (selectarr.length === 5) {
            $(MutiSelectId).data('kendoMultiSelect').input.attr('readonly', 'true');
        } else {
            $(MutiSelectId).data('kendoMultiSelect').input.removeAttr('readonly');
        }
    }

    var kendoMultiSelect = $(MutiSelectId).data("kendoMultiSelect");
    kendoMultiSelect.options.maxSelectedItems = maxItems;
    kendoMultiSelect.ul.addClass('show-selected');
    kendoMultiSelect.bind("open", function (e) {
        e.sender.list.closest(".k-list-container").addClass('kendoMultiSelect-width400');
        if (!e.sender.dataSource.view()[0]) {
            e.sender.ul.css('height', '0px');
            e.sender.ul.closest(".k-list-container").css('height', '80px');
        }
        e.sender.ul.find('li').each(function () {
            if ($(this).attr('aria-selected') === 'true') {
                $(this).hide();
            }
            else {
                $(this).show();
            }
        });
    });

    $('.k-multiselect').removeClass('TextModifier DIV_24_UF_CODES_SERVICE_MODI_CTRL UmCtrlRequired');
    $(".KendoMultiSelectAutoComplete").hide();

    A11yUtil.fixKendoAutoMultiSelectsForA11y(kendoMultiSelect);
}

function EnableDisableKendoMultiSelectValue(ctrl, value) {
    if ($(ctrl).data("kendoMultiSelect") != undefined) {
        var enable = (value == true) ? false : true;
        var dropdownlist = $(ctrl).data("kendoMultiSelect");
        dropdownlist.enable(enable);

    } else
        $(ctrl).attr('disabled', value);
}

//smart comm logic starts here
function CreateDropCheckSc(selectid, url, ddlid, tbid, cvalues, onkeyupValue, configvalue, placeHolder) {
    var controlType = "checkbox";
    if (configvalue == 'S') { controlType = 'radio'; }
    jQuery.ajaxSetup({ async: false, cache: false });
    var width = $('#' + selectid).width();
    $('#' + selectid).attr('data-ddlId', ddlid);
    if (url != null) {
        var urll = url.replace('/', '_');
    }
    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide selectedValColor' data-id='" + ddlid + "' data-ph='" + placeHolder + "' autocomplete='off' onclick='showdropSmartSc(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChangedSmart(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var cval = "";
    if (cvalues != null && cvalues !== "") {
        cval = cvalues.toString().split(',');
    }
    var resData = '';
    if (url != null) {
        $.getJSON(url, function (data) {
            resData = data.d;
            if (data.length > 0) {
                $.each(data, function (key, val) {
                    let displayText = (val.EncodedText === undefined) ? unescapeHtml(val.Text) : val.EncodedText;
                    if (jQuery.inArray(val.Value, cval) != '-1') {
                        if (ddlid == "ddlDynaColumnId") {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"clickedSmart(this,'" + controlType + "');unSelectCheckBox(this)\" /><div id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclickedSmart(this,'" + controlType + "')\" style='curosr:pointer;'>" + displayText + "</div><br/>";
                        }
                        else {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"clickedSmart(this,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclickedSmart(this,'" + controlType + "')\" style='curosr:pointer;'>" + displayText + "</div><br/>";
                        }
                    }
                    else {
                        if (ddlid == "ddlDynaColumnId") {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"clickedSmart(this,'" + controlType + "');unSelectCheckBox(this)\" /><div id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclickedSmart(this,'" + controlType + "')\" style='curosr:pointer;'>" + displayText + "</div><br/>";
                        }
                        else {
                            htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"clickedSmart(this,'" + controlType + "')\" /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + val.Text + "' onclick=\"spnclickedSmart(this,'" + controlType + "')\" style='curosr:pointer;'>" + displayText + "</div><br/>";
                        }
                    }
                });
            }
            //else {
            //    htm = htm + "No Records";
            //}
            htm = htm + "</div>";
            $("#" + selectid).html('');
            $("#" + selectid).append(htm);
        });
    }
    else {
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
    }
    if (url != null) {
        if (resData == 'undefined' || resData == '')
            $("#" + selectid).append("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");
    }
    jQuery.ajaxSetup({ async: true, cache: false });
    if (cvalues != undefined && cvalues != null && cvalues !== "")
        ddlcolumnselectedshowSmart(ddlid, controlType);

    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        if ($(this).attr('type') != 'checkbox') {
            $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
            $(".dropcheck").hide();
        }
    });
}

function ScLetterTemplateParams() {
    $('.UnManageLetterTemplateChkAll').prop('checked', false);
    $('#btnLetterEdit').show();
    return {
        searchValue: $("#ddlScSearchCriteria").val(),
        searchText: $('#txtScSearchText').val(),
        fromDate: $("#txtStDt").val(),
        toDate: $("#txtEdDt").val(),
        TimeDictionaryobj: timeZone
    }
}

//smart comm logic ends here
//**************Create Xdr C-CDA Message Start************************//
//Organizations dropdown filling

function GetXdrMessageSentDetails(SentFromDetailId) {
    loader(1);
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/XdrCcda/XdrMessageSentDetails?SentFromDetailId=" + SentFromDetailId,
        popUpHeader: "C-CDA Sent Details",
        popLevel: 1,
        onClose: function () {
            clearXdtCCDADetailsCheckbox('#popUpDialog2');
        }
    });
    loader(1);

}

function GetXdrAuditDetails(SentFromDetailId) {
    loader(1);
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/XdrCcda/XdrCCDAAuditDetails?SentFromDetailId=" + SentFromDetailId,
        popUpHeader: "C-CDA Audit Details",
        popLevel: 1,
        onClose: function () {
            clearXdtCCDADetailsCheckbox('#popUpDialog2');
        }
    });
    loader(1);

}

//Xdr C-CDA view 
function clsXdrCCDAAttachment(sentFromDetailId, obj) {

    var entityType = $(obj).attr('data-entitytype');
    $('#popUpDialogShowXdrCcdaFiles').CMNPopup({
        popUpHeader: "C-CDA File",
        popLevel: 2,
        onClose: function () {
            clearXdtCCDADetailsCheckbox('#popUpDialogShowXdrCcdaFiles');
        }
    });
    $.ajax({
        type: "GET",
        async: true,
        url: baseURL + "/download/tokenAsync?FileId=" + sentFromDetailId + "&EntityType=" + entityType,
        success: function (tokendata) {
            $('#iFrameShowXdrCcdaFiles').attr('src', baseURL + "/XdrCcda/ShowXdrCcdaFiles?gc-fd-token=" + tokendata.token);
        },
        error: function () {
            loader(0);
        }
    });
}
function clearXdtCCDADetailsCheckbox(popupName) {
    $(popupName).find('iframe').attr('src', '');
    $('.clsChkXDRCCDADetails').removeAttr("checked");
    $('.ContextChkMenu').hide();
}

// C-CDA Details Grid
function EnableDisableGridInnerButton() {
    var item = getSpecRoleItem("AHS_CM_ACTION_GENERATE_CCDA");
    if (item != undefined && item != null && item.length > 0) {
        if (item[0].IsExport == false) {
            $(".ccdaDownload").attr('disabled', 'disabled').attr('title', 'You do not have access to Download.');
        }
    }
    if ($('#XDRCCDAGrid').is(':visible')) {
        gridNotAvailableCustomColor('XDRCCDAGrid');
        A11yGrid.enhanceKendoGridForA11y('XDRCCDAGrid', 'SpecificationName');
    }
    if ($('#XDRCCDADetailsGrid').is(':visible')) {
        gridNotAvailableCustomColor('XDRCCDADetailsGrid');
    }

}

//********************************************Create Xdr C-CDA Message End**************************************************//


//********************************************DROP DROP WITH TEXTBOX======START********************************************************//


function CreateDropCheckWithTextbox(selectid, url, ddlid, tbid, textControl) {
    var controlType = "checkbox";
    var width = $('#' + selectid).width();
    $('#' + selectid).attr('data-ddlId', ddlid);
    var urll = url.replace('/', '_');
    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showdrop(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChanged(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck' style='display:none;width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var i = 0;
    var resData = '';
    $.getJSON(url, function (data) {
        resData = data.d;
        if (data.length > 0) {
            $.each(data, function (key, val) {
                if (key == 0) {
                    htm = htm + "<input type='" + controlType + "' class='TabHtmlMultiDropDown SelMode " + 'selectallid' + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + "-1" + "' onchange=\"ChkBoxWithTxtclicked(this,0,'" + controlType + "')\" /><div id='" + ddlid + "spn' title='" + "Select All" + "' class='ItemML10 divTabHtmlMultiDropDown' onclick=\"ChkBoxWithTxtclicked(this,0,'" + controlType + "')\" style='curosr:pointer;'>" + "Select All" + "</div>";
                }
                if (val.Status == true) {
                    if (val.IsEnabled == "1")
                        htm = htm + "<input data-ctrtype='" + textControl + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" onkeyup=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" data-updatdtext = '" + escapeHtml(val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown " + val.Fonttype + "' id='" + ddlid + "spn' title='" + unescapeHtml(val.Text) + "' style='curosr:pointer;float: left;width: 83% !important;'>" + unescapeHtml(val.Text) + "</div>";
                    else
                        htm = htm + "<input data-ctrtype='" + textControl + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' disabled type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" onkeyup=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" data-updatdtext = '" + escapeHtml(val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + unescapeHtml(val.Text) + "' style='curosr:pointer;float: left;width: 83% !important;'>" + unescapeHtml(val.Text) + "</div>";

                    if (textControl == 'R') {
                        if (val.IsDefault == true)
                            htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' checked='checked'/>";
                        else
                            htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' />";
                    }
                    else if (val.isHeader == false)
                        htm = htm + "<input type='text' id='" + ddlid + "txt' maxlength='50' style='float: left;width: 200px;' value='" + escapeHtml(val.UpdatedText) + "' data-val = '" + escapeHtml(val.Text) + "' onblur=\"BindTextValue(this)\"/>";
                }
                else {
                    if (val.IsEnabled == "1")
                        htm = htm + "<input data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" onkeyup=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" data-updatdtext = '" + escapeHtml(val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown " + val.Fonttype + "' id='" + ddlid + "spn' title='" + unescapeHtml(val.Text) + "' style='curosr:pointer;float: left;width: 83%;'>" + unescapeHtml(val.Text) + "</div>";
                    else
                        htm = htm + "<input data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' disabled type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" onkeyup=\"ChkBoxWithTxtclicked(this,0,'checkbox')\" data-updatdtext = '" + escapeHtml(val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + unescapeHtml(val.Text) + "' style='curosr:pointer;float: left;width: 83%;'>" + unescapeHtml(val.Text) + "</div>";

                    if (textControl == 'R')
                        htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' disabled='disabled' />";
                    else if (val.isHeader == false)
                        htm = htm + "<input type='text' id='" + ddlid + "txt' maxlength='50' style='float: left;width: 200px;' disabled='disabled' data-val = '" + escapeHtml(val.Text) + "' onblur=\"BindTextValue(this)\"/>";
                }
            });
        }
        else {
            htm = htm + "No Records";
        }
        htm = htm + "</div>";
        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
        clickedbyprg(ddlid, 0, 'checkbox');
    });
    if (resData == 'undefined' || resData == '')
        $("#" + selectid).append("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");

    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        if ($(this).attr('type') != 'checkbox') {
            $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
            var ctrlId = $(this).attr('data-ddlId');
            ddlcolumnselectedshow(ctrlId, 0, $(this).attr('type'));
            $(".dropcheck").hide();
        }
    });
}

function AllowOnlyNumericsFunc(e) {
    if (e.ctrlKey || e.altKey) {
        e.preventDefault();
    } else {
        var key = e.keyCode;
        //173 condition added because for Crome '-' kay code is 189 and for firefox it is 173
        if (key != 9 && !((key == 8) || (key == 46) || (key >= 35 && key <= 40) || (key >= 48 && key <= 57) || (key >= 96 && key <= 105))) {
            e.preventDefault();
        }
    }
}

//********************************************DROP DROP WITH TEXTBOX======Ends********************************************************//

function CheckNegativeNumberKeyup(obj, event) {
    var txtdata = $(obj).val();
    if (parseInt(txtdata) > 0) {
        $(obj).val("");
    }
}

function DisableCPRAcknowledgeButton() {
    $('#btnAcknowledge').css({ 'opacity': 0.5, 'cursor': 'default' });
    $('#btnAcknowledge').removeClass('sendAcknowledge');
}

//PROD-12202 -END

function LoadAssessmentProviderReviewPopup() {
    var hdnAssmntReview = 1;
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/ScriptForm/AssessmentReviewPopUp",
        onLoad: function () {
            loader(1);
            $.ajax({
                type: "POST",
                url: baseURL + '/CarePlan/GetReviewCarePlanAcknowledgeDetails',
                dataType: "json",
                data: { AssessmentProviderReviewId: assessmentProviderReviewId },
                success: function (data) {
                    if (data != null) {
                        var dataObj = JSON.parse(data.data)[0];
                        $('#lblAssessmentPCM').AhsSetHtml((dataObj.PRIMARY_CARE_MANAGER != null && dataObj.PRIMARY_CARE_MANAGER !== '') ? $.fn.replaceAndEscapeHtmlExt(dataObj.PRIMARY_CARE_MANAGER) : 'N/A');
                        $('#lblAssessmentRequestFrom').AhsSetHtml((dataObj.REQUEST_FROM != null && dataObj.REQUEST_FROM !== '') ? $.fn.replaceAndEscapeHtmlExt(dataObj.REQUEST_FROM) : 'N/A');
                        $('#lblAssessmentCareMember').AhsSetHtml((dataObj.CARE_MEMBER != null && dataObj.CARE_MEMBER !== '') ? $.fn.replaceAndEscapeHtmlExt(dataObj.CARE_MEMBER) : 'N/A');

                        loader(0);
                    }
                }, error: function () {
                    CustomAlert('Error Occured...');
                }
            });
        },
        closeButton: '#btnAssessmentAckClose',
        onClose: function () {
            if (hdnAssmntReview == 1) {
                hdnAssmntReview = 0;
                $("#btnPHSfAcknowledge").attr("disabled", false);
            }
        },
        popUpHeader: "Acknowledge Accessment",
    });
}

function gridNotAvailableCustomColor(gridId, opText, opFieldInside, isColorTr, isColorPrevCntrl, cntrlSelectorType, prevCntrl) {
    var curGridId = (cntrlSelectorType == 'class' ? '.' : '#') + gridId; //default :'#' , pass : 'class'
    opText = opText || 'N/A'; //default : N/A , pass : Not Available
    opFieldInside = opFieldInside || 'tr td'; // default: 'tr td', pass : span,etc..
    isColorTr = isColorTr || false; // default false : make it true for coloring closest tr
    isColorPrevCntrl = isColorPrevCntrl || false; //  default false : make it true for coloring pre td only
    prevCntrl = prevCntrl || 'td'; //default: 'td', pass : div or span ,etc..

    $(curGridId + ' ' + opFieldInside).each(function (e) {
        if ($(this).text().trim() == opText) {
            if (isColorTr) {
                $(this).closest('tr').addClass('ah-secondary-text');
            }
            else {
                $(this).addClass('ah-secondary-text');
                if (isColorPrevCntrl) {
                    $(this).prev(prevCntrl).addClass('ah-secondary-text');
                }
            }
        }
        if (gridId === "ReqRecGridMAL" && $(this).text().trim() === "Files" && $(this).find("a").hasClass("ccdalnkfiles")) {
            $(this).find("a").attr("id", "MAL_" + $(this).find("a").attr("id"));
        }
    });
}

function CheckloadMemberSummaryDetails(patientId, isRequiredReturnStatus) {
    var returnStatus = false;
    var pardata = { patientVal: patientId };
    $.ajax({
        url: baseURL + "/Home/GetProfileConfigureToPatient",
        type: "POST",
        datatype: "JSON",
        data: pardata,
        async: false,
        success: function (data) {
            if (data) {
                if (isRequiredReturnStatus) { returnStatus = true }
                else {
                    loadMemberSummaryDetails(patientId);
                }
            }
            else {
                if (isRequiredReturnStatus) { returnStatus = false }
                else {
                    CustomAlert("You Can't Access this Patient");
                }
            }
        },
        error: function (err) {
            console.log(err);
        }
    });

    if (isRequiredReturnStatus)
        return returnStatus;
}

//Applying gray class when data is empty ascx page
function griddatacolorchange(gridname) {
    $('#id1frame:not(#iframeSmartCOMMSSo)').contents().find("#" + gridname + " tr td").each(function () {
        if ($(this).text().trim() == 'N/A') { $(this).addClass('lightGrey'); }
    });
}

function loadDropDownPostApi(url, elementId, selectedValue, optinalText, dataValue, dataText, DdlTextLenght, KendoDropDown, selectedText, isasyncCall, dataObj, initCallBack, ctrlParentName, replaceSelectText) {
    ctrlParentName = $.fn.setStringOnUndefinedOrNull(ctrlParentName);
    var $select = null;
    if (typeof elementId === 'object') {
        $select = elementId;
    }
    else if (ctrlParentName != "") {
        $select = $.fn.getCntrlObject(ctrlParentName, "#" + elementId);
    }
    else {
        $select = $.fn.getCntrl(elementId);
    }
    dataValue = $.fn.setValueOnUndefinedOrNull(dataValue, 'Value');
    dataText = $.fn.setValueOnUndefinedOrNull(dataText, 'Text');
    var isasync = false;
    if (isasyncCall != undefined)
        isasync = isasyncCall;
    var settingsRef = {
        "async": isasync,
        "crossDomain": true,
        "crossOrigin": true,
        "url": url,
        "method": 'POST',
        "data": dataObj
    }
    $.ajax(settingsRef)
        .success(function (data) {
            //clear the current content of the select
            var optionsHtmlString = "";
            $select.HtmlEmpty();
            if (!(optinalText === false)) {
                replaceSelectText = $.fn.setValueOnUndefinedOrNull(replaceSelectText, 'Select');
                optionsHtmlString += '<option value="-1"> ' + replaceSelectText + ' </option>';
            }
            if ($select.attr('multiple'))
                optionsHtmlString = "";
            if ($select.data('select'))
                optionsHtmlString = "";
            if ($select.data('all') === "ALL")
                optionsHtmlString = '<option value="-1"> ALL </option>';
            var lengthToShortenTo = $.fn.setTrueOnUndefinedOrNull(DdlTextLenght) ? 50 : DdlTextLenght;
            var selectedValueexists = false;
            $.each(data, function (key, val) {
                var title = val[dataText];
                if (val[dataText] && val[dataText].length > lengthToShortenTo) {

                    val[dataText] = val[dataText].substring(0, lengthToShortenTo) + '...';
                }

                if (selectedValue) {

                    if (selectedValue === val[dataValue]) {
                        selectedValueexists = true;
                        optionsHtmlString += '<option value="' + val[dataValue] + '" selected="selected" title="' + title + '">' + val[dataText] + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[dataValue] + '" title="' + title + '">' + val[dataText] + '</option>';

                    }
                }
                else {
                    if (val.Selected || val.IsDefaultSelect || val.IsPrimary) {//gfid-815 to set default selected value
                        optionsHtmlString += '<option value="' + val[dataValue] + '" selected="selected" title="' + title + '">' + val[dataText] + '</option>';
                    }
                    else {
                        optionsHtmlString += '<option value="' + val[dataValue] + '" title="' + title + '">' + val[dataText] + '</option>';

                    }
                }
            });

            if (!selectedValueexists && $.fn.setNumberOnUndefinedOrNull(selectedValue) != 0 && $.fn.setStringOnUndefinedOrNull(selectedText) != '')
                optionsHtmlString += '<option value="' + selectedValue + '" selected="selected" title="' + selectedText + '">' + selectedText + '</option>';
            var values = new Array();

            $select.append(optionsHtmlString);
            if ($select.attr('multiple')) {
            }
            if (KendoDropDown != undefined && KendoDropDown === true) {
                $($select).kendoDropDownList({
                    filter: "contains",
                    animation: false
                });
            }

            if (initCallBack && typeof (initCallBack) === "function") { initCallBack(true); }
        });
}

function RedirectServicePlan() {
    $('#MvcMainBody').html(''); loader(1);
    SetMvcVisibility('ServicePlan', 'lnkServicePlanTab'); loader(0);
}

function ExtCareTeamProviderDetailsShow(SourObj) {
    var ProviderID = $(SourObj).closest("tr").find(".clschkCareTeam").data("phyid");
    var HasProvAlerts = $(SourObj).closest("tr").find(".clschkCareTeam").data("hasprovideralert");
    var careTeamType = $('#ddlSearchCareTeamType').val();
    $('#careTeamGrid .clschkCareTeam').prop('checked', false);
    $('#careTeamGrid .clschkCareTeamHead').prop('checked', false);
    ChkShowHideCrTmBut(careTeamType);
    GetProviderInformationCommonPopUp(ProviderID, HasProvAlerts);
}

function GetProviderInformationCommonPopUp(PhysicicanId, HasProvAlerts, providerAddressId) {
    if (HasProvAlerts == null || HasProvAlerts == undefined)
        HasProvAlerts = "";
    if (providerAddressId == null || providerAddressId == undefined)
        providerAddressId = "";
    $('#popUpDialog4').CMNPopupUM({
        pvUrl: baseURL + "/AdvanceProviderSearch/GetProviderInformationSummary?physicianId=" + PhysicicanId + "&HasProvAlerts=" + HasProvAlerts + "&providerAddressId=" + providerAddressId,
        onLoad: function () {
            loader(0);
            A11yModal.trapFocusInModal('popUpDialog4');
        },
        onClose: function () {
            if (IsDasPopupOpen) {
                setTimeout(function () {
                    var id = $('#popUpDialog1').is(':visible') ? 'popUpDialog1' : 'DasPopUpContainer';
                    A11yModal.trapFocusInModal(id);
                }, 0);
            }
        },
        popUpHeader: "Provider Information",
        popLevel: 5,
        closeButton: '#closeProviderSummary'
    });
}

/*Manage Provider Add Provider screen END*/

function fnLoadCustomField(ctrlId, sectionId, ActModeId, activityId, patientFollowupId, isActivityOutcome, callbackfn) {
    loader(1);
    patientFollowupId = patientFollowupId == "" || patientFollowupId == undefined ? 0 : patientFollowupId;
    if (activityId != undefined && activityId != '') {
        $.ajax({
            url: baseApiURL + "/ActivityRecordApi/GetCustomFieldsByActivityType",
            dataType: "json",
            data: { sectionId: sectionId, ActModeId: ActModeId, activityId: activityId, patientFollowupId: patientFollowupId },
            success: function (data) {
                if (data.Data != null) {
                    var ctrls = data.Data;
                    var htmlData = "";
                    $.each(ctrls, function (k, v) {
                        htmlData += CreateCustomFields(v.CustFieldDataTypeName, v.CustFieldId, escapeHtml(v.CustFieldName), escapeHtml(v.CstFieldValue), v.CustDataTypeValueIds, v.CustDataTypeValues, v.IsMandatory, v.PatientFollowupCfId);
                    });
                    if (isActivityOutcome == true) {
                        $("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#ActivityOutcomeCustomFieldUnique').AhsSetHtml(htmlData);
                        if ($("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#ActivityOutcomeCustomFieldUnique .cstcalendar').length > 0) {
                            $("iFrame:not(#iframeSmartCOMMSSo)").contents().find('#ActivityOutcomeCustomFieldUnique .cstcalendar').kendoDatePicker({
                                format: "MM/dd/yyyy"
                            });
                        }
                    }
                    else {
                        $("#" + ctrlId).AhsSetHtml(htmlData);
                    }

                    if ($("#" + ctrlId + " .cstcalendar").length > 0) {
                        $("#" + ctrlId + " .cstcalendar").kendoDatePicker({
                            format: "MM/dd/yyyy"
                        });
                    }
                }
                if (callbackfn) {
                    callbackfn();
                }
                loader(0);
            },
            error: function () {
                loader(0);
            }
        });
    }
}

function fnDisplayCustomField(ctrlId, sectionId, ActModeId, activityId, patientFollowupId) {
    DevUtils.logDebug('fnDisplayCustomField', 'ActivityOutcome', { 'ctrlId': ctrlId, 'sectionId': sectionId, 'ActModeId': ActModeId, 'activityId': activityId, 'patientFollowupId': patientFollowupId });

    if (activityId != '' && activityId != undefined) {
        loader(1);
        var Activityhtml = ''; var Outcomehtml = ''; var finalHtml = '';
        $.ajax({
            url: baseApiURL + "/ActivityRecordApi/GetCustomFieldsByActivityType",
            dataType: "json",
            async: false,
            data: { sectionId: sectionId, ActModeId: ActModeId, activityId: activityId, patientFollowupId: patientFollowupId },
            success: function (data) {
                if (data.Data != null) {
                    var ctrls = data.Data;
                    var htmlData = "";
                    $.each(ctrls, function (k, v) {
                        if (v.CustFieldDataTypeName != "Duration") {
                            Activityhtml += '<div class="float-left width20P ItemPB5">'
                                + '<label class="margin Bold" style="word-break: break-word;display: block;width: 97%;"> ' + escapeHtml(v.CustFieldName) + '</label>'
                                + ' <div class="width97P"> <span  style="word-break: break-word;">' + (v.CstDataValue.trim() === '' ? 'N/A' : escapeHtml(v.CstDataValue.trim().replace(/ØæŒ/g, ','))) + '</span>';
                            Activityhtml += '</div></div>';
                        }
                        else {
                            var arr = v.CstDataValue != "" && v.CstDataValue != null ? v.CstDataValue.split(' ') : '';
                            Activityhtml += '<div class="float-left width20P ItemPB5">'
                                + '<label class="margin Bold" > ' + escapeHtml(v.CustFieldName) + '</label>'
                                + ' <div class=""> <span>' + (arr.length > 0 ? arr[0] + ' Hrs ' + arr[1] + ' Mins' : 'N/A') + '</span>';
                            Activityhtml += '</div></div>';
                        }
                    });
                    if (Activityhtml != '') {
                        finalHtml += '<div style = "text-align: left; margin-top: 15px;" ><br>' + Activityhtml + '</div>';
                    }

                    if (finalHtml != '')
                        $("#" + ctrlId).AhsSetHtml(finalHtml);
                }


            },
            error: function () {
                loader(0);
            }
        });
    }
}

function AuthClassConfiguration(pageActionNo, parentID, isServicePlan, classId) {
    isServicePlan = $.fn.setFalseOnUndefinedOrNull(isServicePlan);
    var message = "you don't have permission to create the Authorization.";
    if (!isServicePlan) {
        $.fn.getCntrlObject(parentID, '.InPatient').ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.OutPatient').ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.Pharmacy').ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.HCServices').ToggleDisplay(true);

        $.fn.getCntrlObject(parentID, '.InPatient').parent().ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.OutPatient').parent().ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.Pharmacy').parent().ToggleDisplay(true);
        $.fn.getCntrlObject(parentID, '.HCServices').parent().ToggleDisplay(true);
    }
    else {
        $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').removeAttr('disabled');
        $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').removeAttr('title');
    }
    if (authClassConfig != null && authClassConfig.length > 0) {
        var objAuthClassConfig = $.grep(authClassConfig, function (ele, ind) { return ele.Type == pageActionNo; });
        for (var AC = 0; AC < objAuthClassConfig.length; AC++) {
            switch ((objAuthClassConfig[AC].ActionType || '').toLowerCase()) {
                case 'inpatient':
                    if (!objAuthClassConfig[AC].IsView) {
                        if (isServicePlan) {
                            var ctrl = $($(parentID).find('.ddlCrPlAddSrPlMembNAuthClassCls')[0]).attr('id');
                            $("#" + ctrl + " option[value='1']").remove();
                            if (classId == 1) {
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('disabled', 'disabled');
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('title', message);
                            }
                        }
                        else {
                            $.fn.getCntrlObject(parentID, '.InPatient').ToggleDisplay(false);
                        }
                    }
                    break;
                case 'outpatient':
                    if (!objAuthClassConfig[AC].IsView) {

                        if (isServicePlan) {
                            var ctrl = $($(parentID).find('.ddlCrPlAddSrPlMembNAuthClassCls')[0]).attr('id');
                            $("#" + ctrl + " option[value='2']").remove();
                            if (classId == 2) {
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('disabled', 'disabled');
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('title', message);
                            }
                        }
                        else {
                            $.fn.getCntrlObject(parentID, '.OutPatient').ToggleDisplay(false);
                        }
                    }
                    break;
                case 'pharmacy (rx)':
                    if (!objAuthClassConfig[AC].IsView) {
                        if (isServicePlan) {
                            var ctrl = $($(parentID).find('.ddlCrPlAddSrPlMembNAuthClassCls')[0]).attr('id');
                            $("#" + ctrl + " option[value='3']").remove();
                            if (classId == 3) {
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('disabled', 'disabled');
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('title', message);
                            }
                        }
                        else {
                            $.fn.getCntrlObject(parentID, '.Pharmacy').ToggleDisplay(false);
                        }
                    }
                    break;
                case 'home and community based services (hcbs)':
                    if (!objAuthClassConfig[AC].IsView) {
                        if (isServicePlan) {
                            var ctrl = $($(parentID).find('.ddlCrPlAddSrPlMembNAuthClassCls')[0]).attr('id');
                            $("#" + ctrl + " option[value='4']").remove();
                            if (classId == 4) {
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('disabled', 'disabled');
                                $.fn.getCntrlObject(parentID, '.clsbtnSpAuthClass').attr('title', message);
                            }
                        }
                        else {
                            $.fn.getCntrlObject(parentID, '.HCServices').ToggleDisplay(false);
                        }
                    }
                    break;

                default:
                    break;

            }
        }
    }

};

function ViewIconAsPerDocType() {
    $.each($(".UMDND_View"), function (k, v) {
        var path = $(this).data("doctype");
        $(this).attr("data-doctype", "");
        if (path.indexOf(".pdf") > -1 || path.indexOf(".xml") > -1 || path.indexOf(".png") > -1 || path.indexOf(".jpg") > -1 || path.indexOf(".jpeg") > -1 || path.indexOf(".txt") > -1 || path.indexOf(".gif") > -1
            || path.indexOf(".PDF") > -1 || path.indexOf(".XML") > -1 || path.indexOf(".PNG") > -1 || path.indexOf(".JPG") > -1 || path.indexOf(".JPEG") > -1 || path.indexOf(".TXT") > -1 || path.indexOf(".GIF") > -1) {
            $(this).show();
        }
    });
}

function fnBudgetSummaryPrint() {
    var episode = ($('#ddlSpEpisode').val() != "-1" ? $('#ddlSpEpisode option:selected').text() : "");
    var status = ($('#ddlSpStatus').val() != "-1" ? $('#ddlSpStatus option:selected').text() : "");
    var sDesc = ($('#divServiceDescIdhdntxt').val() != "" ? $('#divServiceDescIdhdntxt').val() : "");
    var sD = $('#txtSpStartDate').val(); var eD = $('#txtSpEndDate').val();
    var statusID = ($('#ddlSpStatus').val() != "-1" ? $('#ddlSpStatus').val() : "");
    var episodeId = ($("#ddlSpEpisode").val() != "-1" ? $('#ddlSpEpisode').val() : "");
    var liability = $PatientLiability
    var serviceIDs = $.trim($("#divServiceDescIdhdn").val());
    loader(1);
    $.getJSON(baseURL + "/CarePlan/ViewBudgetSummaryPrint?sdate=" + sD + "&edate=" + eD + "&episode=" + $.fn.replaceAndEscapeHtmlExt(episode) + "&statusText=" + $.fn.replaceAndEscapeHtmlExt(status) + "&serviceDesc=" + $.fn.replaceAndEscapeHtmlExt(sDesc) + "&PatientLiability=" + $.fn.replaceAndEscapeHtmlExt(liability) + "&status=" + statusID + "&serviceDescId=" + serviceIDs + "&episodeId=" + episodeId
    ).done(function (data) {
        loader(0);
        if (data.success) {
            if ($("#CMModalPopupDivMessage").length > 0) {
                setTimeout(function () {
                    legacyModalAlert("Message", "Budget Summary document is ready. <a href='javascript:void(0)' onclick=\"ClickFire('" + $.trim(data.patient) + "', 'Documents')\"> Click here</a> to view.", true, null, true);
                }, 4000);
            }
        }
        else
            CustomAlert("something went wrong while generating documentation");
    }).fail(function () {
        loader(0);
        CustomAlert("something went wrong");
    });
    if ($("#CMModalPopupDivMessage").length > 0)
        legacyModalAlert("Message", "The document is in progress, you will be notified with the destination once it is ready", true, null, true);
    loader(0);
}

//PacketLog Completion Alert
function PacketlogAlertMessage() {
    var hasComplaintPacketLogViewPermission = false;
    if (roleConfig !== null && roleConfig.length !== 0) {
        var complaintPacketLog = $.greproleext(roleConfig, function (ele, _ind) {
            return ele.UniqueName === "AHS_AG_COMPLAINT_PACKET_LOG";
        });
        if (complaintPacketLog !== undefined && complaintPacketLog.length > 0) {
            hasComplaintPacketLogViewPermission = complaintPacketLog[0].IsView;
        }
    }
    if (!hasComplaintPacketLogViewPermission) {
        return;
    }
    var PI = AgData.complaintInfo();
    var AccId = PI.complaintDivId;
    var isPacketLogPage = $('#divCompAddPacketContainer', AccId).is(':visible');
    GlobalPacketIds = [];
    var ProgressStatusUrl = baseApiURL + '/AgPacket/GetProgressStatus';
    $.ajax({
        type: "POST",
        url: ProgressStatusUrl,
        dataType: "json",
        success: function (data) {
            if (ToValue(data, "") !== "") {
                $.each(data, function (index, itemData) {
                    if (itemData.IsPending === true) {
                        GlobalPacketIds.push(itemData.AgPacketId);
                    }
                });
                if (!isCallintiated) {
                    isCallintiated = true;
                    setInterval(function () {
                        PacketAlert(isPacketLogPage);
                    }, 30000);
                }
            }
        },
        error: function () {
            console.log("Error occurred in PacketlogAlertMessage method.");
        }
    });
}

function UpdateAccessedByOtherUm() {
    var flag = setInterval(function () {
        var isExist = $("#MvcMainBody .InAuthPage").length > 0;
        if (!isExist) {
            if (isUmAccessed) {
                UnlockAuthAccssedByOtherUser(function () {
                    clearInterval(flag); isUmAccessed = false;
                    if (lockedUMInterval != null) {
                        clearInterval(lockedUMInterval);
                        lockedUMInterval = null;
                    }
                    if (tempUMInterval != null) {
                        clearInterval(tempUMInterval);
                        tempUMInterval = null;
                    }
                });
            }
        }
    }, 3000);
}

function UpdateAccessedByOtherAg() {
    var flag = setInterval(function () {
        var isExist = $("#MvcMainBody .InComplaintPage").length > 0;
        if (!isExist) {
            if (isAgAccessed) {
                UnlockComplaintAccssedByOtherUser(function () {
                    clearInterval(flag); isAgAccessed = false;
                    if (lockedAGInterval != null) {
                        clearInterval(lockedAGInterval);
                        lockedAGInterval = null;
                    }
                    if (tempAGInterval !== null) {
                        clearInterval(tempAGInterval);
                        tempAGInterval = null;
                    }
                });
            }
        }
    }, 3000);
}

function UnlockAuthAccssedByOtherUser(callback) {
    var isIE = !!document.documentMode;
    if (isIE) {
        ajaxRequestSync(baseApiURL + '/UMCommon/UpdateAuthDuplicateAccess', { COLUMN_PATIENT_ID: "PATIENT_ID", COLUMN_CARE_STAFF: "STAFF_ID", COLUMN_DATE_TIME: "LAST_ACCESSED_END_DATE" }, function (AR) {
            if (AR && AR !== 'NR') {
                var RD = AR.ToJson();
                if (RD.length > 0) {
                    if (callback && typeof (callback) === "function") {
                        callback();
                    }
                }
            }
        });
    }
    else {
        AjaxRequest(baseApiURL + '/UMCommon/UpdateAuthDuplicateAccess', { COLUMN_PATIENT_ID: "PATIENT_ID", COLUMN_CARE_STAFF: "STAFF_ID", COLUMN_DATE_TIME: "LAST_ACCESSED_END_DATE" }, function (AR) {
            if (AR && AR !== 'NR') {
                var RD = AR.ToJson();
                if (RD.length > 0) {
                    if (callback && typeof (callback) === "function") {
                        callback();
                    }
                }
            }
        });
    }
}

function UnlockComplaintAccssedByOtherUser(callback) {
    var isIE = !!document.documentMode;
    if (isIE) {
        AjaxInitSync({ DATA_KEY: "COMPLAINT_ACCESS_UPDATE", COLUMN_CARE_STAFF: "STAFF_ID", COLUMN_DATE_TIME: "LAST_ACCESSED_END_DATE" }, function (AR) {
            if (AR && AR !== 'NR') {
                var RD = AR.ToJson();
                if (RD.length > 0) {
                    if (callback && typeof (callback) === "function") {
                        callback();
                    }
                }
            }
        });
    }
    else {
        AjaxInit({ DATA_KEY: "COMPLAINT_ACCESS_UPDATE", COLUMN_CARE_STAFF: "STAFF_ID", COLUMN_DATE_TIME: "LAST_ACCESSED_END_DATE" }, function (AR) {
            if (AR && AR !== 'NR') {
                var RD = AR.ToJson();
                if (RD.length > 0) {
                    if (callback && typeof (callback) === "function") {
                        callback();
                    }
                }
            }
        });
    }
}

function BeforeUnloadLockUser() {
    if ($(".InComplaintPage").is(":visible")) {
        UnlockComplaintAccssedByOtherUser();
    }
    if ($(".InAuthPage").is(":visible")) {
        UnlockAuthAccssedByOtherUser();
    }
    if ($("#divAddServicePlanV2").is(":visible")) {
        UnlockSpAccssedByOtherUser();
    }
}
// Added the below lines of code as per PROD-79023 request.
function AGpacketshowwarninghomejs(page) {
    var isshown = false;
    var AccordianId = AgData.complaintInfo().complaintDivId;
    if ($('#divCompAddPacketContainer', AccordianId).is(':visible')) {
        agPacketNavigateAway.Selectionpage = true;
    }
    if ($('#divAgPackViewSummaryMain', AccordianId).is(':visible')) {
        agPacketNavigateAway.Summarypage = true;
    }
    if (agPacketNavigateAway.Selectionpage || agPacketNavigateAway.Summarypage) {
        isshown = AgPacketWarningShow(agPacketNavigateAway.Selectionpage, agPacketNavigateAway.Summarypage, '0', '0', page);
        return isshown;
    }
}
//End

// PROD-83754
function StandardTimeFormat(date) {
    return (date == '' || date == null) ? 'N/A' : kendo.toString(date, "MM/dd/yyyy hh:mm:ss tt");
}
// END
function generateJSGUID() {
    function _genJSGUID(s) {
        var p = (Math.random().toString(16) + "000000000").substr(2, 8);
        return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
    }
    jsGuid = _genJSGUID() + _genJSGUID(true) + _genJSGUID(true) + _genJSGUID();
}
function getLoggerHeader() {
    var header = { 'JSGuid': jsGuid };
    return header;
}

//24to12
function convert24to12HourFormat(dateTime) {
    if (checkExistsAndNullAndUndefinedCondition(dateTime) && dateTime.trim().split(' ').length == 2) {
        var time = dateTime.split(' ')[1];
        var splittedTime = time.split(':');
        var hours = Number(splittedTime[0]);
        var minutes = Number(splittedTime[1]);
        var seconds = Number(splittedTime[2]);
        var AmOrPm = (hours >= 12) ? 'PM' : 'AM';
        hours = (hours % 12) || 12;
        if (hours < 10 && hours.toString().length == 1) { hours = "0" + hours; }
        if (minutes < 10 && minutes.toString().length == 1) { minutes = "0" + minutes; }
        if (seconds < 10 && seconds.toString().length == 1) { seconds = "0" + seconds; }
        var finalDateTime = dateTime.split(' ')[0] + " " + hours + ":" + minutes + ":" + seconds + " " + AmOrPm;
        return finalDateTime;
    }
    else {
        return dateTime;
    }
}

//12to24
function convert12to24HourFormat(dateTime) {
    if (checkExistsAndNullAndUndefinedCondition(dateTime) && dateTime.split(' ').length == 3) {
        var modifiedDate = dateTime.split(' ')[0];
        var modifiedTime = dateTime.split(' ')[1];
        var AMPM = dateTime.split(' ')[2]
        var hours = Number(modifiedTime.split(':')[0])
        var minutes = Number(modifiedTime.split(':')[1])
        var seconds = Number(modifiedTime.split(':')[2])
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        if (hours < 10 && hours.toString().length == 1) hours = "0" + hours.toString();
        if (minutes < 10 && minutes.toString().length == 1) minutes = "0" + minutes.toString();
        if (seconds < 10 && seconds.toString().length == 1) seconds = "0" + seconds.toString();
        var result;
        if (isNaN(seconds)) {
            result = modifiedDate + " " + hours + ":" + minutes;
        }
        else {
            result = modifiedDate + " " + hours + ":" + minutes + ":" + seconds;
        }
        return result;
    }
    else {
        return dateTime;
    }
}


function convertTime12to24(time12h) {
    if (time12h) {
        let [time, modifier] = time12h.split(' ');

        let [hours, minutes] = time.split(':');

        // This the case where no space between AM/PM
        if (minutes.indexOf('PM') !== -1) {
            minutes = minutes.substring(0, minutes.indexOf('PM'));
            modifier = 'PM';
        }

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    }

    return time12h;
}

// END

//FULL CARE PLAN
function onTmCrPlFullCrPlDataBound1() {
    var objCode = $('.hOverCodeCls');
    $.each(objCode, function (key, itm) {
        var code = $(itm).data('code');
        var serviceCodes = [];
        if (typeof (code) !== "object" && (code || '') !== '')
            serviceCodes = code.toString().split(',');
        else
            serviceCodes.push(code);
        var htmlStr = "";
        htmlStr += '<span style=font-weight:bold;>Code</span>';
        $.each(serviceCodes, function (key, item) {
            htmlStr += '<div>' + (key + 1) + '.' + item + '</div>';
        });
        $(itm).attr('title', htmlStr);
    });
    $('div.hOverCodeCls').aToolTip();
    gridNotAvailableCustomColor('GridIdFullCarePlanASO');
    A11yGrid.enhanceKendoGridForA11y('GridIdFullCarePlanASO', 1);
    // creating the tooltip for the Code column.
    $("#GridIdFullCarePlanASO .k-master-row").each(function (index, value) {
        let rowId = value.dataset.uid;  // unique row id that's kendo generated
        let code = $("#codeValueToolTip_" + rowId).html();  // gets the code contained in the hidden span using the row id
        let codeToolTipConfig = {
            tooltipText: '<b>Code:</b> ' + code,  // set the tooltip text with the code
            pointerDirection: TOOLTIP_POINTER_DIRECTION.LEFT,
            width: TOOLTIP_WIDTH.SMALL
        };
        new A11yTooltipInstance('codeToolTip_' + rowId, 'code tooltip', codeToolTipConfig);  // NOSONAR report says this is not being used, but the function is called from the databound event of a grid
    });
}

function FullCarePlanASOParameters() {
    var { fromDate, toDate, lob } = getFilterDatesAndLob("Approved Service Opportunities");
    return {
        patientId: $('#hdnFullCarePlanPatientId').val(),
        dateFrom: fromDate,
        dateTo: toDate,
        lobBenId: lob,
        TimeDictionaryobj: timeZone
    }
}
function mergeBarrierGridRows() {

    var $gridId = $('#grdAllFullCarePlanBarrier');

    var tContent = $gridId.find('.k-grid-content table tbody tr');
    var $prevArray = [];
    var $currentArray = [];

    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 2; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            //$($currentTd).addClass('brdCommon');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;

            });
            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;
                });
            }
            if ($prevTd && $prevTd.length > 0) {

                if ($prevArray[2] == $currentArray[2]) {   // if Goal Names are matched in both, then we are merging the two.
                    $.each($currentArray, function (index2, value) {
                        if (index2 != 0) {
                            if ($prevArray[index2] == $currentArray[index2]) {
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                $($currentTd[index2]).addClass('brdAll');
                            } else {
                                $prevArray[index2] = value;
                            }
                        }
                    });
                } else {
                    //$(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, td) {
                        $prevArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;
                    });
                }
            }

        }
    }

    uncheckCarePlanBarriersCheckBoxItems();
    gridNotAvailableCustomColor('grdAllFullCarePlanBarrier');
    A11yGrid.enhanceKendoGridForA11y('grdAllFullCarePlanBarrier', 3, 0);
}

function mergeStrengthGridRows() {

    var $gridId = $('#FCrPlStrengthGrid');
    var tContent = $gridId.find('.k-grid-content table tbody tr');
    var $prevArray = [];
    var $currentArray = [];

    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows - 2; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;
            });
            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length == 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;
                });
            }
            if ($prevTd && $prevTd.length > 0) {

                if ($prevArray[2] == $currentArray[2]) {
                    $.each($currentArray, function (index2, value) {
                        if (index2 != 0) {
                            if ($prevArray[index2] == $currentArray[index2]) {
                                $($prevTd[index2]).remove();
                                $($currentTd[index2]).attr('rowspan', typeof $($prevTd[index2]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[index2]).attr('rowspan')) + 1);
                                $($currentTd[index2]).addClass('brdAll');
                            } else {
                                $prevArray[index2] = value;
                            }
                        }
                    });
                } else {
                    //$(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, td) {
                        $prevArray[index] = td.innerText == undefined ? td.innerHTML : td.innerText;
                    });
                }
            }

        }
    }
    uncheckCarePlanStrengthsCheckBoxItems();
    gridNotAvailableCustomColor('FCrPlStrengthGrid');
    A11yGrid.enhanceKendoGridForA11y('FCrPlStrengthGrid', 3, 0);
}
function FullCarePlanParameters() {
    var { fromDate, toDate, lob } = getFilterDatesAndLob("Clinical Interventions");
    return {
        patientId: $('#hdnFullCarePlanPatientId').val(),
        CategoryID: $('#hdnselectSearchCategory').val(),
        statusIds: $('#selectSearchStatusIdhdn').val(),
        dateFrom: fromDate,
        dateTo: toDate,
        Txt_FullCPLobSearch: $('#TxtFullCPLobSearch').val(),
        SearchCriteriaCarePlan: $('#selectSearchCriteriaCarePlan').val(),
        dateCriteria: 3,
        TimeDictionaryobj: timeZone,
        lobBenId: lob
    }
}

function RedirecttoComplaintActivity(ComplaintNo, PatientId) {
    if (IsAlertAcknowledgementRequired == 'True' && $('#selectPatientAccessed').val() != PatientId) {
        GetAGPatientAlertsAndAcknowledge(PatientId, ComplaintNo, 0, 'complaintact', '');
    }
    else {
        isRedirectToComplaintActivity = 1;
        GetComplaintData(ComplaintNo);
    }
}
function ConfirmOnAutoDraftWhileExit(page, AuthNoId, ActivityId) {
    var isshown = false;
    var PI = UmPatient_AuthInfo("", "");
    var AccordianId = PI.AuthDivId + " #Accordion_Group_2";

    if ($(".Content", AccordianId).length > 0) {
        isshown = umAutoDraftWarningShow(page, AuthNoId, ActivityId);
        return isshown;
    }
}

function draftTabsWithOutMouse() {
    const PI = UmPatient_AuthInfo("", "");
    const accId = `${PI.AuthDivId} #Accordion_Group_2`;
    $('.Accordion', accId).each(function () {
        const selector = $(this);
        const isNotAuthInit = selector.attr('id') !== 'AuthInit_2_1';
        const isAccOpen = selector.find('.ah-accordion-btn').hasClass('AccOpen');

        if (isNotAuthInit && isAccOpen) {
            selector.trigger('mouseleave');
        }
    });
    if (typeof umPreAuthInjectedDraft !== "undefined" && umPreAuthInjectedDraft && typeof UmPreAuth_ArmDraftIconsOnAuthExit === 'function') {
        UmPreAuth_ArmDraftIconsOnAuthExit();
    }
}
function onDataboundRequestReceivedModuleType() {
    if (isNavigateToUnReadMessages || isNavigateToUnReadFaxes) {
        var selectRequestReceivedModuleVal = 0;
        if ($('#selectRequestReceivedModule').data("kendoDropDownList") !== undefined) {
            if (isNavigateToUnReadFaxes) {
                $.each($('#selectRequestReceivedModule').data("kendoDropDownList").dataSource.data(), function (_v, k) {
                    if ($.trim(k.ModuleName) === selectedFaxModuleName) {
                        selectRequestReceivedModuleVal = k.ModuleId;
                    }
                });
            } else {
                $.each($('#selectRequestReceivedModule').data("kendoDropDownList").dataSource.data(), function (v, k) {
                    if ($.trim(k.ModuleName) === "CM") {
                        selectRequestReceivedModuleVal = k.ModuleId;
                    }
                });
            }
            if (selectRequestReceivedModuleVal !== 0 && selectRequestReceivedModuleVal !== $('#selectRequestReceivedModule').data("kendoDropDownList").value()) {
                $('#selectRequestReceivedModule').data("kendoDropDownList").value(selectRequestReceivedModuleVal);
            }
        }
    } else {
        $("#selectRequestReceivedModule").data("kendoDropDownList").value(loggedInUserModuleId);
    }

    if (($("#selectRequestReceivedModule").data("kendoDropDownList").text() === "CM")) {
        $("#btnRequestReceivedRiskFilter").show();
    } else {
        $("#btnRequestReceivedRiskFilter").hide();
    }

    if ($('#requestHeaderName').html() === "Request Received") {
        $('#hdnModeType').val('Received');
    } else if ($('#requestHeaderName').html() === "Request Rejected") {
        $('#hdnModeType').val('Rejected');
    } else {
        // do nothing (this is here for Sonar)
    }

    if ($("#selectRequestReceivedReferType").data("kendoDropDownList") !== null) {
        $("#selectRequestReceivedReferType").data("kendoDropDownList").dataSource.read();
    }

    $("span[aria-owns='selectRequestReceivedModule_listbox']").attr("aria-label", "request module").attr("aria-describedby", "srElementChangeMessage");
    $("span[aria-owns='selectRequestReceivedReferType_listbox']").attr("aria-label", "request refer type").attr("aria-describedby", "srElementChangeMessage");
}

function loadRequestReceivedReferType() {
    $("#selectRequestReceivedReferType").data("kendoDropDownList").select(0);

    requestReferTypeGlobal = $('#selectRequestReceivedReferType').data("kendoDropDownList").text();
    requestModuleNameGlobal = $('#selectRequestReceivedModule').data("kendoDropDownList").text();
    loadDropDown(baseURL + '/Master/BindWorkQueues?careStaffId=' + memberidval, 'ddlRequestReceivedWorkQueue', null, null, 'DepartmentId', 'DepartmentName');
    if ($('#hdnModeType').val() == "Rejected") {
        DBReqRejLoad(1, "thirdViewrow");
        //loadDropDown(baseURL + '/Home/BindWorkQueues', 'ddlRequestReceivedWorkQueue');
    }
    else {
        if (isNavigateToUnReadMessages || isNavigateToUnReadFaxes) {
            var selectRequestReceivedReferTypeVal = "";
            if (isNavigateToUnReadFaxes) {
                requestReferTypeGlobal = "Faxes";
                $.each($('#selectRequestReceivedReferType').data("kendoDropDownList").dataSource.data(), function (_v, k) {
                    if ($.trim(k.ReferType) === "Faxes") {
                        selectRequestReceivedReferTypeVal = k.ReferTypeId;
                        return false;
                    }
                });
            } else {
                requestModuleNameGlobal = "CM";
                requestReferTypeGlobal = "Messages";
                $.each($('#selectRequestReceivedReferType').data("kendoDropDownList").dataSource.data(), function (v, k) {
                    if ($.trim(k.ReferType) == "Messages") { selectRequestReceivedReferTypeVal = k.ReferTypeId; return false; }
                });
            }

            if (selectRequestReceivedReferTypeVal !== "" && $('#selectRequestReceivedReferType').data("kendoDropDownList") !== undefined && $('#selectRequestReceivedReferType').data("kendoDropDownList").value() !== selectRequestReceivedReferTypeVal.toString()) {
                $('#selectRequestReceivedReferType').data("kendoDropDownList").value(selectRequestReceivedReferTypeVal);
            }

            //Resetting Sent From text box, From Date and To Date
            $("#txtRequestReceivedRRMember").val("");
            $("#txtRequestReceivedFormDate").val("");
            $("#txtRequestReceivedToDate").val("");

            if ($("#selMessageType").val() != "false") {
                $("#selMessageType").val("false");
                $("#selMessageType").trigger("change");
            }
            isNavigateToUnReadMessages = false;
            isNavigateToUnReadFaxes = false;
        }
        DBReqRecLoad(1, "thirdViewrow");
        //loadDropDown(baseURL + '/Home/BindWorkQueues?careStaffId=' + memberidval, 'ddlRequestReceivedWorkQueue');
        if (($("#selectRequestReceivedReferType").data("kendoDropDownList").text().toLowerCase() != "messages") && ($("#selectRequestReceivedModule").data("kendoDropDownList").text()) == "CM")
            $("#btnRequestReceivedRiskFilter").show();
        else
            $("#btnRequestReceivedRiskFilter").hide();
        if (requestReferTypeGlobal === "Faxes") {
            $("#RequestReceivedRRMemberFields").hide();
            REQ_REC_UM_FAX_TT.useSavedFilter('ddlTreatmentTypeReqRecUmFaxes', requestModuleNameGlobal, requestReferTypeGlobal);
        }
        else {
            $("#RequestReceivedRRMemberFields").show();
        }
    }
    SetArrowsReq();
    ShowHideWorkQueueDDL(requestReferTypeGlobal, requestModuleNameGlobal);
}

/*Manage Provider Add Provider screen*/
function AddProviderPopUpinManageProvider() {
    $('#popUpDialog1').CMNPopup({
        pvUrl: baseURL + "/PatientCareTeam/AddProvider?isConfigAddProvider=" + true + "&patientId=" + $('#selectPatientAccessed').val(),
        onLoad: function () {
            $('#AddProviderForm #btnProviderCTProvSearch').remove();
        },
        popUpHeader: "Add Provider",
        popLevel: 0,
        closeButton: "#closebutton",
        onClose: function () {
            $('#popUpDialog1').html('');
        },
        triggerBtnId: 'btnMPAdd',
        modalWidth: MODAL_WIDTH.LARGE
    });
}
function EditProviderPopUpinManageProvider(physicianId) {
    $('#popUpDialog2').CMNPopup({
        pvUrl: baseURL + "/PatientCareTeam/AddProvider?PhysicianId=" + physicianId + "&isConfigAddProvider=" + true + "&patientId=" + $('#selectPatientAccessed').val(),
        popUpHeader: "Edit Provider",
        onLoad: function () {
            $('#trProviderMultipleAddress').show();
            $('#trAddAddressAddProvider').hide();
            $("#ProviderMultipleAddress").data("kendoGrid").dataSource.read();
            $('#ProviderMultipleAddress .k-grid-content').css({ "height": "81px" });
            $('#btnProvSave').val('Update');
            var varSpecialityId = $('#AddProviderForm #SpecialityIds').val();
            var varPrimaryLanguage = $('#AddProviderForm #LanguageIds').val();
            CreateDropCheck('selectSpecialityType', baseURL + '/Master/BindSpecialityType/', 'selectSpecialityTypeId', 0, varSpecialityId, null, null, 'Speciality', 'SpecialityId');
            CreateDropCheck('selectLanguageType', baseURL + '/Home/BindLanguageType/', 'selectLanguageTypeId', 0, varPrimaryLanguage);
            if ($('#hdnddlStatusForLoadData').val() != undefined && $('#hdnddlStatusForLoadData').val() == 1)
                DisableFieldsForProvider();
            $('#AddProviderForm #btnProviderCTProvSearch').remove();
            $('#AddProviderForm #PhysicianCode').removeClass('width80P').addClass('width90P');

        },
        popLevel: 1,
        closeButton: "#closebutton",
        onClose: function () {
            if ($("#hdnIsMiles").val() != "") { isMiles = false; $("#hdnIsMiles").val(''); }
            $('#popUpDialog2').html('');
            var provideriFrame = document.getElementById('id1frame').contentWindow.document.body;
            $(provideriFrame).find(".Portalgrid input[type='checkbox']").removeAttr("checked");
        },
        triggerBtnId: 'btnMPEdit',
        modalWidth: MODAL_WIDTH.LARGE
    });
}
function runFromToolTip() {
    $('.k-tooltip-closable:visible').hide();
    $('div.k-animation-container').removeAttr('style');
    $(toolTiptargetEle).closest('tr').next().find('div.cal-iconBtn').find('.' + runBtnClsName).trigger('click');
}
function editFromToolTip() {
    $('.k-tooltip-closable:visible').hide();
    $('div.k-animation-container').removeAttr('style');
    $(toolTiptargetEle).closest('tr').next().find('div.cal-iconBtn').find('.' + editBtnClsName).trigger('click');
}
function deleteFromToolTip() {
    $('.k-tooltip-closable:visible').hide();
    $('div.k-animation-container').removeAttr('style');
    $(toolTiptargetEle).closest('tr').next().find('div.cal-iconBtn').find('[class*=ActDelete]:visible').trigger('click');
}
function displayFromToolTip() {
    $('.k-tooltip-closable:visible').hide();
    $('div.k-animation-container').removeAttr('style');
    $(toolTiptargetEle).closest('tr').next().find('div.cal-iconBtn').find('.' + viewBtnClsName).trigger('click');
}
function memInfoToolTip(e) {
    var displayEdit, displayRun, displayDelete, displayView = false;
    var disableEdit, disableRun, disableDelete, disableView = '';
    toolTiptargetEle = $(e.target);
    if ($(e.target).closest('tr').next().find('div.cal-iconBtn').length > 0) {
        var elements = $(e.target).closest('tr').next().find('div.cal-iconBtn').children(':visible');
        for (var i = 0; i < elements.length; i++) {
            if ($(elements[i]).attr('class').indexOf('Run') > -1) {
                displayRun = true;
                disableRun = $(elements[i]).attr('disabled') == 'disabled' ? 'disabled' : '';
                runBtnClsName = $(elements[i]).attr('class');
            }
            else if ($(elements[i]).attr('class').indexOf('Edit') > -1) {
                displayEdit = true;
                disableEdit = $(elements[i]).attr('disabled') == 'disabled' ? 'disabled' : '';
                editBtnClsName = $(elements[i]).attr('class');
            }
            else if ($(elements[i]).attr('class').indexOf('ActDelete') > -1) {
                displayDelete = true;
                disableDelete = $(elements[i]).attr('disabled') == 'disabled' ? 'disabled' : '';
            }
            else if ($(elements[i]).hasClass('RView') || $(elements[i]).hasClass('AGRed') || $(elements[i]).hasClass('URed')) {
                displayView = true;
                disableView = $(elements[i]).attr('disabled') == 'disabled' ? 'disabled' : '';
                viewBtnClsName = $(elements[i]).hasClass('RView') ? 'RView' : $(elements[i]).hasClass('AGRed') ? 'AGRed' : $(elements[i]).hasClass('URed') ? 'URed' : '';
            }
        }
    }
    var hoverinfo = $(e.target).data('hoverinfo');
    var patientfulladdress = $(e.target).data('patientfulladdress');
    var isOrphan = $(e.target).data('isorphan');
    var timeFormat = $(e.target).data('timeformat');
    var isadditionalinfoactivity = $(e.target).data('isadditionalinfoactivity');
    hoverinfo.replace(/&#39;/, "'");
    var values = hoverinfo.split('‡');
    var title = '<table  role="presentation">';
    var Comments = values[6];
    var isLockNote = values[8];
    IS_12HRS_FORMAT = timeFormat !== '24hrs';
    var standardTime = StandardTimeFormat(changeTimeZone(values[7], "1"));
    var dueDate = standardTime !== 'N/A' ? $.fn.apply12To24hrFormat(standardTime) : standardTime;
    dueDate = dueDate == null ? standardTime : dueDate;
    if (Comments != null && Comments.length > 200)
        Comments = Comments.substring(0, 200) + "...";
    if ($(e.target).closest('tr').next().find('.RActivity').length > 0) {
        title += '<tr><td class="alignL ItemPR10"><i class="fas fa-calendar-alt" aria-hidden="true"></i></td><td class="alignL"> <span class="bold ItemPR5">Due Date</span>' + dueDate + '<span style="color:#444444;" class="ItemPL5 ItemML5 f12"><i class="far fa-redo" style="margin-right:5px;"> </i> Recurring</span></td></tr>';
    }
    else {
        title += '<tr><td class="alignL ItemPR10"><i class="fas fa-calendar-alt" aria-hidden="true"></i></td><td class="alignL"> <span class="bold ItemPR5">Due Date</span>' + dueDate + '</span></td></tr>';
    }
    title += '<tr><td class="alignL"><i class="fas fa-user" aria-hidden="true"></i></td><td class="alignL bold f16">' + values[0] + '</td></tr>';
    title += '<tr><td class="alignL"></td><td class="alignL">' + values[2] + '&nbsp;' + values[1] + '</td></tr>';
    title += '<tr><td class="alignL"></td><td class="alignL">' + values[3] + '</td></tr>';
    title += '<tr><td class="alignL"><i class="fas fa-phone-alt" aria-hidden="true"></i><span class="sr-only">Phone</span></td><td class="alignL">' + values[4] + '</td></tr>';
    if (isLockNote === "1") {
        title += '<tr><td class="alignL" valign="top"><i class="fas fa-sticky-note" aria-hidden="true"></i></td><td class="alignL" valign="top"><b>' + values[5] + '</b> <span><i class="fa fa-lock"></i> Confidential notes</span></td></tr>';
    }
    else {
        title += '<tr><td class="alignL" valign="top"><i class="fas fa-sticky-note" aria-hidden="true"></i></td><td class="alignL" valign="top"><b>' + values[5] + '</b> <span class="ItemPL5" style="clear:both;word-wrap: break-word;">' + Comments + '</span></td></tr>';
    }
    title += '<tr><td class="alignL" valign="top"><i class="fas fa-map-marker-alt" aria-hidden="true"></i></td><td class="alignL">' + $.fn.replaceAndEscapeHtmlExt(patientfulladdress) + '</td></tr>';
    title += '</table>';
    title += '<div class="ItemMT10" style="padding-left: 5px; height: 40px;"><ul>';
    if (isOrphan === true) {
        title += "<span class='ItemMR5 f16 red' title='Eligibility has an issue.'><i class='fas fa-exclamation-triangle' aria-hidden='true'></i></span>";
    }
    if (displayRun) {
        var className = "BtnPrimary";
        if (isOrphan === true) {
            className = "BtnSecondary";
        }
        title += '<li><button class="' + className + ' ItemMR5" onclick="runFromToolTip()"' + disableRun + '><span class=""><i class="fas fa-thumbs-up" aria-hidden="true"></i></span> Perform</button></li>';
    }
    if (!isadditionalinfoactivity) {
        if (displayEdit) {
            title += '<li><button class="BtnSecondary ItemMR5" onclick="editFromToolTip()"' + disableEdit + '><span class="ItemMR5"><i class="fas fa-pencil-alt" aria-hidden="true"></i></span> Edit</button></li>';
        }
        if (displayDelete) {
            title += '<li><button class="BtnSecondary ItemMR5" onclick="deleteFromToolTip()"' + disableDelete + '><span class="ItemMR5"><i class="far fa-times" aria-hidden="true"></i></span> Delete</button></li>';
        }
        if (displayView) {
            title += '<li><button class="BtnSecondary" onclick="displayFromToolTip()" style="width:110px !important"' + disableView + '><span class="ItemMR5"><i class="fas fa-thumbs-up" aria-hidden="true"></i></span> View Activity</button></li>';
        }
    }
    title += '</ul></div>';
    return title;
}
//Clearing Eligibility search values on change of Eligibility level ddl
$(document).off('change', '#ddlHierarchyLevelSearch').on('change', '#ddlHierarchyLevelSearch', function () {
    $("#txtHierarchyLevelSearchValue").val('');
    $("#txtHierarchyLevelSearchValue").attr('placeholder', 'Eligibility Level Value');
    $("#hdntxtHierarchyLevelSearchValue").val('');

    if ($('#ddlHierarchyLevelSearch').parents('.clsWorkLogManagerEligibilitySearch').length >= 1) {
        $("#ddlWLMProgramAC").val('');
        $("#ddlWLMProgramAC").attr('placeholder', 'Type and Select Program Name');
        $("#hdnddlWLMProgramAC").val('');
        $("#UmDdAGComplaintType").data("kendoDropDownList").value('00');
        ClearKendoDropDownValues($("#UmDdAGComplaintClass"), '00', "Select");
        ClearKendoDropDownValues($("#UmDdAGComplaintCategory"), '00', "Select");
        EnableDisableKendoDropDownValue($("#UmDdAGComplaintClass"), true);
        EnableDisableKendoDropDownValue($("#UmDdAGComplaintCategory"), true);
    }
});
$(document).off('click', '#divMPGVMASKSD,#divPAEMASKSD,#divMPMASKSD').on('click', '#divMPGVMASKSD,#divPAEMASKSD,#divMPMASKSD', function () {
    var element = $(this).attr('id');
    var content = "Changing the start date of the program will impact turnaround times, reporting, and already completed activities. Do you wish to continue?"
    $().ConfirmationBox({ Title: 'Edit program start date confirmation', Content: content, Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }], ButtonAlign: 'center' }, function (response) {
        if (response) {
            $('#' + element).remove();
        }
    });
});
//END
function getAuthTreatmentDetails(authNo) {
    var treatmentTypeExists = false;
    $.ajax({
        type: "GET",
        url: baseURL + "/Authorizations/GetAuthTreatmentDetails?authNo=" + authNo + "&PatientId=" + AppContextManager.PatientContext.getPatientId(),
        dataType: "json",
        async: false,
        success: function (data) {
            if (data != null) {
                if (data.TreatmentTypeExists) {
                    treatmentTypeExists = true;
                }
            }
            loader(0);
        },
        error: function () {
            loader(0);
        }
    });
    return treatmentTypeExists;
}

$(document).off('click', '#divMPGVMASKSD,#divPAEMASKSD,#divMPMASKSD').on('click', '#divMPGVMASKSD,#divPAEMASKSD,#divMPMASKSD', function () {
    var element = $(this).attr('id');
    var content = "Changing the start date of the program will impact turnaround times, reporting, and already completed activities. Do you wish to continue?"
    $().ConfirmationBox({ Title: 'Edit program start date confirmation', Content: content, Buttons: [{ Title: 'Yes', Value: true }, { Title: 'No', Value: false }], ButtonAlign: 'center' }, function (response) {
        if (response) {
            $('#' + element).remove();
        }
    });
});

$(document).off('click', '#spanSwitchtoCalendar').on('click', '#spanSwitchtoCalendar', function () {
    calPatientId = 0;
    calAuthnum = 0;
    calComplaintnum = 0;
    $('#hdnPHCalMemberName').val('');
    myCalendarMemberName = "";
    $('#spanMyCalendarHeaderName').html('').append('My Calendar');

    $('#divMyCalendarRightButtons span,#spanMyCalendarPatientName span').remove();

    // Rebuild the care activity log item if it doesn't exist
    if ($('#divMyCalendarRightButtons .ah-widget-link-container').length === 0) {
        const careActivityHTML = `
            <li>
                <span class="ah-widget-link-container" style="top: 2px;">
                    <a href="#" id="btnCalexpndClick" class="DbImgPopOut ah-widget-link" style="display:none;" onclick="CalClick()" title="Care Activity Log" aria-label="care activity log">
                        <i class="far fa-external-link-square" aria-hidden="true"></i>
                        <span id="careActivityLogText"> Care Activity Log</span>
                    </a>
                </span>
            </li>
        `;
        $('#divMyCalendarRightButtons ul.float-right').prepend(careActivityHTML);
    }
    else {
        // Just show the span if it already exists
        $('#careActivityLogText').show();
        $('#divMyCalendarRightButtons .ah-widget-link-container').removeClass('compact');
    }
    var hasAccess = getSpecRoleItem("AHS_CM_MYACTIVITY_LOG");
    if (hasAccess && hasAccess.length > 0 && hasAccess[0].IsView) {
        $("#btnCalexpndClick").show();
    }
    else {
        $("#btnCalexpndClick").remove();
    }
    const calDiv = $("#_myCalendarPartialViewContainer").length > 0 ? $("#_myCalendarPartialViewContainer") : $("#CalendarViewDiv");
    if (calDiv.length > 0) {
        calDiv.load(baseURL + "/Dashboard/MyCalendar/", function () {
            onLoadMyCalendar();
        });
    }
});
$(document).off('click', '.GLB-LeftToggle').on('click', '.GLB-LeftToggle', function () {
    $('.GLB-AsideLeft').toggleClass('active');
    //For Add manual Team Care Plan - Left panel expand mode
    if ($('.cp-add-field-container').length === 1) {
        $('.cp-add-field-container').toggleClass('cpExt');
    }
    //For PH Epsdt - Left panel expand mode
    else if ($('#pagePHEpsdt').length === 1) {
        $('#pagePHEpsdt').toggleClass('leftExt');
        if ($('#rdEPSDTVisits').is(':checked')) {
            $("#gridEPSDT").data("kendoGrid").dataSource.trigger('change');
        }
        else if ($('#rdEPSDTImmunizations').is(':checked')) {
            $("#gridEPSDTImmunizations").data("kendoGrid").dataSource.trigger('change');
        }
        else {
            $("#gridEPSDTServices").data('kendoGrid').dataSource.trigger('change');
        }
    }
    else {
        //
    }
});

var iconMsgTimer;
function commonIconStyleStatusMsgDisplay(ctrlId, Message, Timeout, divId) {
    if (divId !== undefined) {
        var pos = $(divId).position().top;
        $(window).scrollTop(pos);
    }
    else {
        $(window).scrollTop(0);
    }
    if ($('#TeamCarePlanParentDiv').is(':visible')) {
        $('#TeamCarePlanParentDiv').scrollTop(0);
    }

    $('#div' + ctrlId).show();
    $('#lbl' + ctrlId).html(Message);
}

//To check whether element is present in visible screen view
function isScrolledIntoView(element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();
    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
    }
    else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
}

function getTruncatedStringWithEllipsis(data, startIndex, length) {
    if (data && data.length > length) {
        return data.substring(startIndex, length) + "...";
    }
    return data;
}

function textChangedAgConfig(ctrl) {
    var eleid = ctrl.id;
    var elements = $(ctrl);
    var str = elements.data("id");
    $("#" + str + "chk").show();

    $("." + str).each(function () {
        var e1 = $(this).next();
        var patt = new RegExp(elements.val().toLowerCase());
        var res = patt.test(e1.text().toLowerCase());
        if (res) {
            $(this).closest('.clsChildDropcheck').show();
        }
        else {
            $(this).closest('.clsChildDropcheck').hide();
        }
    });

    eleid = eleid.replace('val', '');
    var chkboxes = $("#" + eleid + "chk").find("." + eleid + ':checked:visible').not('.selectallid');
    var totalchkboxes = $("#" + eleid + "chk").find("." + eleid + ':visible').not('.selectallid');
    if ($('.selectallid', "#" + eleid + "chk").length) {
        if (chkboxes.length === totalchkboxes.length && totalchkboxes.length !== 0) {
            $('.selectallid', "#" + eleid + "chk").prop('checked', true);
        } else {
            $('.selectallid', "#" + eleid + "chk").prop('checked', false);
        }
    }
}

function showDropAgConfig(ctrl) {
    textChangedAgConfig(ctrl);
    var eleid = ctrl.id;
    var eleclass = $(ctrl).parent()[0].className;
    var setOffsetTop = /insideSelect/i.test(eleclass);
    var parenteleid = eleid.replace("Idval", "");
    var widthList = $('#' + parenteleid).attr('data-CtrlListWidth');
    var width = $('#' + parenteleid).width();
    if (widthList !== undefined) {
        width = widthList;
    }
    eleid = eleid.replace("val", "");
    $("#" + eleid + "chk").attr('style', 'width:' + width + 'px !important;');
    $("#" + eleid + "chk").show();
    if ($("#" + eleid + "val").val() === "") {
        $("#" + eleid + "chk").children().show();
    }
    if ($(ctrl).val() === "Select") {
        $(ctrl).val('');
    }

    var chkboxes = $("#" + eleid + "chk").find("." + eleid + ':visible:checked').not('.selectallid');
    var totalchkboxes = $("#" + eleid + "chk").find("." + eleid + ':visible').not('.selectallid');
    if ($('.selectallid', "#" + eleid + "chk").length) {
        if (chkboxes.length === totalchkboxes.length && totalchkboxes.length !== 0) {
            $('.selectallid', "#" + eleid + "chk").prop('checked', true);
        }
        else {
            $('.selectallid', "#" + eleid + "chk").prop('checked', false);
        }
    }

    if (setOffsetTop) {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 37) });
    }
    else {
        $('#' + eleid + "chk").offset({ top: ($(ctrl).offset().top + 22) });
    }
}

function ddlShowColumnSelectedAgConfig(eleid, iscount, fromCmpltType) {
    $("#" + eleid + "chk").find("." + eleid + ":visible");
    var itmArray = [];
    var chkboxes = $("#" + eleid + "chk").find("." + eleid + ":checked").not(".selectallid, .AuditCheckbx");
    var totalchkboxes = $("#" + eleid + "chk").find("." + eleid).not(".selectallid, .AuditCheckbx");
    var totalchkboxesVisible = $("#" + eleid + "chk").find("." + eleid + ":visible").not('.selectallid, .AuditCheckbx');
    var chkboxesVisible = $("#" + eleid + "chk").find('.' + eleid + ':checked:visible').not('.selectallid, .AuditCheckbx');
    if (chkboxes.length > 0) {

        if (eleid === "ddlCareorganization") {
            if ($('#ddlSearchBy option:selected').text() !== "TIN") {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').show();
            } else {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').hide();
            }

        }

        if ($("#" + eleid + "CheckAll").length) {
            if (chkboxes.length === totalchkboxes.length) {
                $("#" + eleid + "CheckAll").prop('checked', true);
            }
            else {
                $("#" + eleid + "CheckAll").prop('checked', false);
            }
        }

        if ($('.selectallid', "#" + eleid).length) {
            if (chkboxesVisible.length === totalchkboxesVisible.length) {
                $('.selectallid', "#" + eleid).prop('checked', true);
            }
            else {
                $('.selectallid', "#" + eleid).prop('checked', false);
            }
        }
        var selectedIds = "";
        var selectedVals = "";
        $("#" + eleid + "chk").find('.' + eleid + ':checked').not('.selectallid, .AuditCheckbx').each(function () {
            itmArray = onOptionCheck($(this), eleid, fromCmpltType);
            selectedIds = selectedIds === "" ? itmArray[0] : selectedIds + "," + itmArray[0];
            selectedVals = selectedVals === "" ? itmArray[1] : selectedVals + "," + itmArray[1];
        });
        $("#" + eleid + "hdn").val(selectedIds);
        $("#" + eleid + "hdntxt").val(selectedVals);
        if ($('.selectallid', "#" + eleid).length === 0) {//to handle for multicheckboxes without select all option in CM section
            $("#" + eleid + "val").val("");
        }
        if (iscount) {
            $("#" + eleid + "val").attr('placeholder', selectedIds);
        }
        else {
            if (chkboxes.length >= 1 && chkboxes.length <= 3) {
                if (selectedIds === "Empty") {
                    selectedVals = "  ";
                }
                $("#" + eleid + "val").attr('placeholder', selectedVals);
            }
            else {
                $("#" + eleid + "val").attr('placeholder', chkboxes.length + " items Checked");
            }
            if (eleid === "ddlMaxOpportunityCount" && chkboxes.length >= 2) {
                $("#" + eleid + "val").attr('placeholder', chkboxes.length + " items Checked");
            }
        }
    }
    else {
        if (eleid === "ddlCareorganization") {
            if ($('#ddlSearchBy option:selected').text() !== "TIN") {
                $('#btnHideCareOrg').show();
                $('#btnGoCareOrg').hide();
            }
            else {
                $('#btnHideCareOrg').hide();
                $('#btnGoCareOrg').hide();
            }
            if ($('#dvServiceLoc').is(":visible") && $('#ddlSearchBy option:selected').text() !== "TIN") {
                CreateDropCheck('ddlServiceLocations', baseURL + '/PopulationHealth/BindServiceLocations?OrgFilterIdval=', 'ddlServiceLocations', 0);
            }
            if ($('#dvNPI').is(":visible") && $('#ddlSearchBy option:selected').text() !== "TIN") {
                CreateDropCheck('ddlGlobalSearchNpi', baseURL + '/PopulationHealth/BindNpi?OrgFilterIdval=', 'ddlGlobalSearchNpi', 0);
            }
        }

        if ($("#" + eleid + "CheckAll").length) {
            $("#" + eleid + "CheckAll").prop('checked', false);
        }

        $("#" + eleid + "val").attr('placeholder', 'Select');
        $("#" + eleid + "hdn").val('');
        $("#" + eleid + "hdntxt").val('');
    }
}

function clickedbyprgAgConfig(ctrlid, iscount, FromCmpltType) {
    var eleid = ctrlid;
    var itmAry = [];
    var chkboxes = $("#" + eleid + "chk").find("." + eleid + ':checked').not('.selectallid');
    var selectedIds = "";
    var selectedVals = "";
    if (chkboxes.length > 0) {
        $("#" + eleid + "chk").find("." + eleid + ':checked').not('.selectallid').each(function () {
            itmAry = onOptionCheck($(this), eleid, FromCmpltType);
            selectedIds = ToValue(selectedIds, "") === "" ? itmAry[0] : selectedIds + "," + itmAry[0];
            selectedVals = ToValue(selectedVals, "") === "" ? itmAry[1] : selectedVals + "," + itmAry[1];
        });
        $("#" + eleid + "hdn").val(selectedIds);
        $("#" + eleid + "hdntxt").val(selectedVals);
        if (iscount) {
            $("#" + eleid + "val").attr("value", selectedIds);
        }
        else {
            if (chkboxes.length >= 1 && chkboxes.length <= 3) {
                if (selectedIds === "Empty") {
                    selectedVals = "  ";
                }
                $("#" + eleid + "val").attr("placeholder", selectedVals);
            }
            else {
                $("#" + eleid + "val").val("");
                $("#" + eleid + "val").attr("placeholder", chkboxes.length + " Items Checked");
            }
            if (eleid === "ddlMaxOpportunityCount" && chkboxes.length >= 2) {
                $("#" + eleid + "val").attr("placeholder", chkboxes.length + " Items Checked");
            }
        }
    }
    else {
        $("#" + eleid + "val").attr("placeholder", "Select");
    }
}

function onOptionCheck(obj, eleid, fromCmpltType = "") {
    var itm = "";
    var itmtxt = "";
    var arry = itm.split(',');
    var valaaa = jQuery.inArray(obj.val(), arry);
    if (valaaa === -1) {
        if (itm.length > 0) {
            itm = itm + "," + obj.val();
            itmtxt = itmtxt + "," + unescapeHtml(obj.next("#" + eleid + "spn").text());
        }
        else {
            itm = obj.val();
            if (fromCmpltType === "1") {
                itmtxt = unescapeHtml(obj.closest('div').parent().find("#" + eleid + "spn").text());
            } else if (eleid === "ddlCareActivityTypeId" || "ddlActivityType" || "ddlCareActivitymportId") {
                itmtxt = (obj.next("#" + eleid + "spn").text());
            }
            else {
                itmtxt = unescapeHtml(obj.next("#" + eleid + "spn").text());
            }
        }
    }
    return [itm, itmtxt];
}

function createAGDropCheckWithTextbox(selectid, url, ddlid, tbid, textControl, headertext) {
    var controlType = "checkbox";
    var width = $('#' + selectid).width();
    $('#' + selectid).attr('data-ddlId', ddlid);
    var htm = "<input id='" + ddlid + "val' type='text' class='TabHtmlMultiDropDown droptexthide' data-id='" + ddlid + "' autocomplete='off' onclick='showDropAgConfig(this)' style='color:darkgrey;' placeHolder='Select' onkeyup='textChangedAgConfig(this)'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdn' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdntxt' value=''/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnurl' value='" + url + "'/>";
    htm = htm + "<input type='hidden' id='" + ddlid + "hdnlist' value=''/>";
    htm = htm + "<div id='" + ddlid + "chk' class='dropcheck agdropcheck' style='display:none; width:" + width + "px !important' tabindex='" + tbid + "'>";
    htm = htm + "<div id='" + ddlid + "chkchk'  class='dropcheck1' style='display:none;' tabindex='" + tbid + "'></div>";
    var resData = '';
    $.getJSON(url, function (data) {
        resData = data.d;
        if (data.length > 0) {
            htm = htm + "<div class='dropdown-header k-widget k-header is_flex dropHead' style='width: 100% !important; margin-left: -3px;font-weight: 600;'><div class='Tb130Px' style='background-color: #f5f5f5!important;padding-left:5px;' title='" + headertext + "'>" + headertext + "</div><div class='Tb130Px' style='background-color: #f5f5f5!important;' title='Optional Custom Label'>Optional Custom Label</div><div class='maxWid_260' style='background-color: #f5f5f5!important;'  title='Optional Custom Label'>Select Levels</div></div>";
            htm = htm + "<div class='DDHgt' style='width: 100% !important;'>";
            $.each(data, function (key, val) {
                if (key === 0) {
                    htm = htm + "<div class='brdBottom_dark' style='padding:2px 0px; width: 100% !important;'><input type='" + controlType + "' style='margin-left:6px;' class='TabHtmlMultiDropDown SelMode " + 'selectallid' + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + "-1" + "' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" /><div id='" + ddlid + "spn' title='" + "Select All" + "' class='ItemML10 divTabHtmlMultiDropDown' onclick=\"chkBoxWithTxtclickedAgConfig(this,0)\" style='curosr:pointer;'>" + "Select All" + "</div></div>";
                }
                htm = htm + "<div class='is_flex brdBottom_dark clsChildDropcheck' style='padding:2px 0px; width: 100% !important;'>";
                if (val.Status) {
                    if (val.IsEnabled === "1" && !(val.IsControlMandate)) {
                        htm = htm + "<div class='maxWid_400'><input data-iscontrolmandate='" + val.IsControlMandate + "' data-islevelsmandate='" + val.IsAllLevelsMandate + "' data-ctrtype='" + textControl + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" onkeyup=\"chkBoxWithTxtclickedAgConfig(this,0)\" data-updatdtext = '" + (val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown " + val.Fonttype + "' id='" + ddlid + "spn' title='" + (val.Text) + "' style='curosr:pointer;float: left;width: 77% !important;'>" + val.Text + "</div></div>";
                    } else {
                        htm = htm + "<div class='maxWid_400'><input data-iscontrolmandate='" + val.IsControlMandate + "' data-islevelsmandate='" + val.IsAllLevelsMandate + "' data-ctrtype='" + textControl + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' disabled type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' checked='checked' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" onkeyup=\"chkBoxWithTxtclickedAgConfig(this,0)\" data-updatdtext = '" + (val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + (val.Text) + "' style='curosr:pointer;float: left;width: 77% !important;'>" + val.Text + "</div></div>";
                    }

                    if (textControl === 'R') {
                        if (val.IsDefault) {
                            htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' checked='checked'/>";
                        } else {
                            htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' />";
                        }
                    }
                    else if (!val.isHeader) {
                        htm = htm + "<div class='Tb180Px'><input type='text' id='" + ddlid + "txt' maxlength='50' style='float: left;width: 180px;' value='" + (val.UpdatedText) + "' data-val = '" + (val.Text) + "' onblur=\"BindTextValue(this)\"/></div>";
                    }
                    else {
                        htm = htm + "<div class='Tb130Px'></div>";
                    }

                    var LevelData = val.LevelData.ToJson();

                    htm = htm + "<div class='is_flex maxWid_260 clsLevelChkContent'>";
                    if (val.IsAllLevelsMandate !== true || val.IsControlMandate !== false) {
                        htm = htm + "<div class='Tb50Px" + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' checked='checked' >All</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1'  checked='checked' >1</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2'  checked='checked' >2</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3'  checked='checked' >3</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4'  checked='checked' >4</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5'  checked='checked' >5</div>";
                    }
                    else {
                        if (LevelData.LevelAll && LevelData.Level1 && LevelData.Level2 && LevelData.Level3 && LevelData.Level4 && LevelData.Level5) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' disabled='disabled' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' checked='checked' >All</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' checked='checked' >All</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' >All</div>";
                        }
                        if (LevelData.Level1) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1'  checked='checked' >1</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1'  checked='checked' >1</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1' >1</div>";
                        }
                        if (LevelData.Level2) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled'  data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2'  checked='checked' >2</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2'  checked='checked' >2</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2' >2</div>";
                        }
                        if (LevelData.Level3) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3'  checked='checked' >3</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3'  checked='checked' >3</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3' >3</div>";
                        }
                        if (LevelData.Level4) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4'  checked='checked' >4</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4'  checked='checked' >4</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4' >4</div>";
                        }
                        if (LevelData.Level5) {
                            if (val.displayType === 'GF') {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5'  checked='checked' >5</div>";
                            }
                            else {
                                htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5'  checked='checked' >5</div>";
                            }
                        }
                        else {
                            htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5' >5</div>";
                        }
                    }
                    htm = htm + "</div>";
                }
                else {
                    if (val.IsEnabled === "1" && !val.IsControlMandate) {
                        htm = htm + "<div class='maxWid_400'><input data-iscontrolmandate='" + val.IsControlMandate + "' data-islevelsmandate='" + val.IsAllLevelsMandate + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" onkeyup=\"chkBoxWithTxtclickedAgConfig(this,0)\" data-updatdtext = '" + (val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown " + val.Fonttype + "' id='" + ddlid + "spn' title='" + (val.Text) + "' style='curosr:pointer;float: left;width: 77% !important;'>" + val.Text + "</div></div>";
                    } else if (val.IsControlMandate) {
                        htm = htm + "<div class='Tb130Px'><input data-iscontrolmandate='" + val.IsControlMandate + "' data-islevelsmandate='" + val.IsAllLevelsMandate + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' disabled checked='checked' type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" onkeyup=\"chkBoxWithTxtclickedAgConfig(this,0)\" data-updatdtext = '" + (val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + (val.Text) + "' style='curosr:pointer;float: left;width: 77% !important;'>" + val.Text + "</div></div>";
                    }
                    else {
                        htm = htm + "<div class='Tb130Px'><input data-iscontrolmandate='" + val.IsControlMandate + "' data-islevelsmandate='" + val.IsAllLevelsMandate + "' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' disabled type='checkbox' class='TabHtmlMultiDropDown SelMode " + ddlid + "' name='" + ddlid + "'  id='" + ddlid + "' value='" + val.Value + "' onchange=\"chkBoxWithTxtclickedAgConfig(this,0)\" onkeyup=\"chkBoxWithTxtclickedAgConfig(this,0)\" data-updatdtext = '" + (val.UpdatedText) + "' style='margin-right: 15px;' /><div class='divTabHtmlMultiDropDown' id='" + ddlid + "spn' title='" + (val.Text) + "' style='curosr:pointer;float: left;width: 77% !important;'>" + val.Text + "</div></div>";
                    }


                    if (textControl === 'R') {
                        htm = htm + "<input type='radio' id='" + ddlid + "rdo' style='clear: inherit !important;float: left;' name='radio' data-accfieldid = '" + val.Value + "' disabled='disabled' />";
                    }
                    if (!val.isHeader && !val.IsControlMandate) {
                        htm = htm + "<div class='Tb180Px'><input type='text' id='" + ddlid + "txt' maxlength='50' style='float: left;width: 180px;' disabled='disabled' data-val = '" + (val.Text) + "' onblur=\"BindTextValue(this)\"/></div>";
                    }
                    else if (!val.isHeader && val.IsControlMandate) {
                        htm = htm + "<div class='Tb180Px'><input type='text' id='" + ddlid + "txt' maxlength='50' style='float: left;width: 180px;' value='" + (val.Text) + "' data-val = '" + (val.Text) + "' onblur=\"BindTextValue(this)\"/></div>";
                    }
                    else {
                        htm = htm + "<div class='Tb130Px'></div>";
                    }
                    if (val.IsControlMandate) {
                        htm = htm + "<div class='is_flex maxWid_260 clsLevelChkContent'>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' checked='checked' >All</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1'  checked='checked' >1</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2'  checked='checked' >2</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3'  checked='checked' >3</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4'  checked='checked' >4</div>";
                        htm = htm + "<div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5'  checked='checked' >5</div>";
                        htm = htm + "</div>";
                    }
                    else {
                        htm = htm + "<div class='is_flex maxWid_260 clsLevelChkContent'><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelAll' >All</div><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel1' >1</div><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel2' >2</div><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel3' >3</div><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel4' >4</div><div class='mrgn_rht_5 noEllipsis " + val.Fonttype + "'><input type='checkbox' data-parentctrl='" + ddlid + "' disabled='disabled' data-child='" + val.accChildCode + "' data-displaytype = '" + val.displayType + "' class='clsLevelChk clsLevel5' >5</div></div>";
                    }

                }
                htm = htm + "</div>";
            });

            htm = htm + "</div>";
        }
        else {
            htm = htm + "No Records";
        }

        $("#" + selectid).html('');
        $("#" + selectid).append(htm);
        clickedbyprgAgConfig(ddlid, 0);
    });
    if (resData === 'undefined' || resData === '') {
        $("#" + selectid).append("<div><input id='" + ddlid + "val' type='text' class='droptexthide' style='color:darkgrey;' value='Select'/>" + "</div>");
    }

    $(document).off('mouseleave', '#' + selectid).on('mouseleave', '#' + selectid, function () {
        if ($(this).attr('type') !== 'checkbox') {
            $('.divTabHtmlMultiDropDown').removeClass('color-MultiSelectDdl');
            var ctrlId = $(this).attr('data-ddlId');
            $('#' + ctrlId + 'val').val('');
            ddlShowColumnSelectedAgConfig(ctrlId, 0);
            $(".dropcheck").hide();
        }
    });
}

function clearDropCheck(selectid, ddlid) {
    $("input[type='checkbox']", "#" + selectid).prop("checked", false);
    $("#" + ddlid + "hdn").val("");
    $("#" + ddlid + "hdntxt").val("");
    $("#" + ddlid + "val").attr("placeholder", "Select");
    $("#" + ddlid + "val").val("");
}

function mergeGridRows(tContent, colIndex, mergeRow) {
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.textContent;
            });

            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length === 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {
                if ($prevArray[mergeRow] === $currentArray[mergeRow] && ($.trim($prevArray[mergeRow]) !== 'N/A' && $.trim($currentArray[mergeRow]) !== 'N/A')) {
                    $.each($currentArray, function (index2, value) {
                        if (index2 === mergeRow) {
                            $.each(colIndex, function (key, columnIndex) {
                                $($prevTd[columnIndex]).remove();
                                $($currentTd[columnIndex]).attr('rowspan', typeof $($prevTd[columnIndex]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[columnIndex]).attr('rowspan'), 10) + 1);
                                $($currentTd[columnIndex]).addClass('brdAll');
                            });
                        } else {
                            $prevArray[index2] = value;

                        }
                    });
                } else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
        }
    }
}
function childGrid($currentRow, gridId) {

    if ($currentRow.hasClass('brdAll')) {
        var rowSpan = parseInt($currentRow.attr('rowspan'), 10);
        var $parentRow = $currentRow.parent();
        $parentRow.closest('tr').next('tr.k-detail-row').hide();

        var siblings = $parentRow.nextAll('tr.k-master-row');
        var current = siblings[rowSpan - 2];

        if ($currentRow.find('a.k-icon').hasClass('k-plus')) {
            // DOM XSS Fix: Escape attribute value for safe selector construction
            $(gridId + " table tr[data-uid='" + SecurityUtils.escapeHtml($(current).attr('data-uid')) + "']").next().hide();
        }
        if ($currentRow.find('a.k-icon').hasClass('k-minus')) {
            $(gridId + "  table tr[data-uid='" + SecurityUtils.escapeHtml($(current).attr('data-uid')) + "']").next().show();
        }
    }
}
function onAuthExternalGuidelinesDataBound(e) {
    this.expandRow(this.tbody.find("tr.k-master-row"));
    this.collapseRow(this.tbody.find("tr.k-master-row"));
    var gridId = e.sender.element[0].id;
    var columnIndex = getKendoGridColumnIndex(e.sender.columns, ["Episode ID", "View Documentation", "View Episode Summary"]);
    if (columnIndex) {
        columnIndex.push(0);
    }
    var tContent = $('#' + gridId).find('.k-grid-content table tbody tr.k-master-row');
    mergeGridRows(tContent, columnIndex, 2);
    $('#' + gridId + ' td.k-hierarchy-cell').off('click').on('click', function () {
        var $this = $(this);
        setTimeout(childGrid, 1, $this, '#' + gridId);
    });
    $('#' + gridId).find('div[data-role="pager"]').removeClass('k-pager-sm');
}
function getKendoGridColumnIndex(columns, columnNames) {
    var columnIndex = [];
    if (columns.length && columnNames.length) {
        $.each(columnNames, function (key, value) {
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].title === value) {
                    columnIndex.push(i + 1);
                }
            }
        });
    }
    return columnIndex;
}
function dateValidation(date) {
    if (isDate(date) || (date.indexOf('t') === 0 && date.match(/t/g).length === 1)) {
        var dateExp = /^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d$/;
        var maxDate = new Date("12/31/2099");
        var minDate = new Date("01/01/1900");
        if (!date.match(dateExp) || new Date(date) < minDate || new Date(date) > maxDate) {
            return false;
        }
    } else {
        return false;
    }
    return true;
}
function isDate(TxtDate, SplitChar) {
    var AoDate, MS, MM, DD, YY;
    if (SplitChar === undefined) {
        SplitChar = '/';
    }
    AoDate = TxtDate.split(SplitChar);
    if (AoDate.length !== 3) {
        return false;
    }
    MM = AoDate[0] - 1;
    DD = AoDate[1] - 0;
    YY = AoDate[2] - 0;
    MS = (new Date(YY, MM, DD)).getTime();
    AoDate = new Date();
    AoDate.setTime(MS);
    if ((AoDate.getFullYear() !== YY && AoDate.getFullYear().toLocaleString().length !== 4) || AoDate.getMonth() !== MM || AoDate.getDate() !== DD) {
        return false;
    }
    return true;
}
function getSCAConfiguration() {
    var response = false;
    $.ajax({
        type: "GET",
        url: baseURL + "Home/ScaConfigValue",
        dataType: "json",
        async: false,
        success: function (data) {
            if (ToValue(data, null) !== null) {
                response = data === "Enable" ? true : false;
            }
        }
    });
    return response;
}
function loadGridOnPagerMode(gridId) {
    if (gridPagerMode && !((PHNavID === '' && buildctrl.toLowerCase() === 'cpindex') || (PHNavID === '1'))) {
        gridPagination.fetchGridData(gridId);
    }
}
function EPSDTVisitParametersPh(patientId) {
    return {
        PatientId: patientId
    };
}

function onclsCrPlSrPlDataBoundEPSDTVisitPh() {
    var epsdtVisitGridId = $('.EpsdtVisits:visible').attr('id');
    if ($('.EpsdtVisits:visible').length > 0 && epsdtVisitGridId !== undefined) {
        gridNotAvailableCustomColor(epsdtVisitGridId);
    }

}


function mergeGridRows(tContent, colIndex, mergeRow) {
    var $prevArray = [];
    var $currentArray = [];
    var noOfRows = tContent.length;
    if (tContent && noOfRows > 0) {
        for (var row = noOfRows; row >= 0; row--) {
            var $currentTd = $(tContent[row]).find('td');
            $.each($currentTd, function (index, td) {
                $currentArray[index] = td.textContent;
            });

            var $prevTd = $(tContent[row + 1]).find('td');
            if ($prevArray && $prevArray.length === 0) {
                $.each($prevTd, function (index, td) {
                    $prevArray[index] = td.textContent;
                });
            }
            if ($prevTd && $prevTd.length > 0) {
                if ($prevArray[mergeRow] === $currentArray[mergeRow] && ($.trim($prevArray[mergeRow]) !== 'N/A' && $.trim($currentArray[mergeRow]) !== 'N/A')) {
                    $.each($currentArray, function (index2, value) {
                        if (index2 === mergeRow) {
                            $.each(colIndex, function (key, columnIndex) {
                                $($prevTd[columnIndex]).remove();
                                $($currentTd[columnIndex]).attr('rowspan', typeof $($prevTd[columnIndex]).attr('rowspan') == "undefined" ? 2 : parseInt($($prevTd[columnIndex]).attr('rowspan'), 10) + 1);
                                $($currentTd[columnIndex]).addClass('brdAll');
                            });
                        } else {
                            $prevArray[index2] = value;

                        }
                    });
                } else {
                    $(tContent[row + 1]).addClass('brdTop');
                    $.each($currentTd, function (index, value) {
                        $prevArray[index] = value.textContent;
                    });
                }
            }
        }
    }
}
function childGrid($currentRow, gridId) {

    if ($currentRow.hasClass('brdAll')) {
        var rowSpan = parseInt($currentRow.attr('rowspan'), 10);
        var $parentRow = $currentRow.parent();
        var detailRow = $parentRow.closest('tr').next('tr.k-detail-row');
        detailRow.hide();

        var siblings = $parentRow.nextAll('tr.k-master-row');
        var current = siblings[rowSpan - 2];

        if ($currentRow.find('a.k-icon').hasClass('k-plus')) {
            // DOM XSS Fix: Escape attribute value for safe selector construction
            $(gridId + " table tr[data-uid='" + SecurityUtils.escapeHtml($(current).attr('data-uid')) + "']").next().hide();
        }
        if ($currentRow.find('a.k-icon').hasClass('k-minus')) {
            $(gridId + "  table tr[data-uid='" + SecurityUtils.escapeHtml($(current).attr('data-uid')) + "']").next().show();
        }
        detailRow.remove();
        if ($currentRow.find('a.k-icon').hasClass('k-i-collapse')) {
            if ($(current).next('.k-detail-row').length === 0) {
                $(current).after(detailRow);
            }
            $parentRow.nextAll('tr.k-detail-row').first().css('display', 'table-row');
        } else {
            $parentRow.nextAll('tr.k-detail-row').first().css('display', 'none');
        }
    }
}
function onAuthExternalGuidelinesDataBound(e) {
    setTimeout((grid) => {
        var rows = grid.tbody.find("tr.k-master-row");
        var kGrid = $(grid).data("kendoGrid");
        if (kGrid) {
            for (var i = 0; i < rows.length; i++) {
                kGrid.expandRow(rows[i]);
                kGrid.collapseRow(rows[i]);
            }
        }

    }, 1, this);
    var gridId = e.sender.element[0].id;
    var columnIndex = getKendoGridColumnIndex(e.sender.columns, ["Episode ID", "View Documentation", "View Episode Summary"]);
    if (columnIndex) {
        columnIndex.push(0);
    }
    var tContent = $('#' + gridId).find('.k-grid-content table tbody tr.k-master-row');
    mergeGridRows(tContent, columnIndex, 2);
    $('#' + gridId + ' td.k-hierarchy-cell').off('click').on('click', function () {
        var $this = $(this);
        setTimeout(childGrid, 1, $this, '#' + gridId);
    });
    $('#' + gridId).find('div[data-role="pager"]').removeClass('k-pager-sm');
}
function getKendoGridColumnIndex(columns, columnNames) {
    var columnIndex = [];
    if (columns.length && columnNames.length) {
        $.each(columnNames, function (key, value) {
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].title === value) {
                    columnIndex.push(i + 1);
                }
            }
        });
    }
    return columnIndex;
}

function generateKeyVal(inputArr) {
    return inputArr.reduce((ele, item) => {
        if (item.FIELD_NAME && item.REASON_FOR_CHANGE) {
            ele[item.FIELD_NAME] = item.REASON_FOR_CHANGE;
        }
        return ele;
    }, []);
}

function compareAuditRecords(logAction, auditRecords) {
    let auditRecordDiffs = [];
    let auditRecordsArray = auditRecords[0];
    let reasonRecord = auditRecords[1];
    let sortedFieldReason = generateKeyVal(reasonRecord);
    let oldAuditRecord = auditRecordsArray[1] || {};
    let currentAuditRecord = auditRecordsArray[0];
    let currentRecordColKeys = Object.keys(currentAuditRecord);
    currentRecordColKeys.forEach(function (key) {
        if (logAction === "UPDATE" || logAction === "ACTIVITY UPDATED") {
            if (oldAuditRecord[key] !== currentAuditRecord[key]) {
                if (key === "IS_PRIMARY") {
                    var isPrimarykey = key + " (" + currentAuditRecord.AUTH_CODE_REF_ID + ")";
                    auditRecordDiffs.push({ ColumnName: isPrimarykey, OldValue: oldAuditRecord[key], NewValue: currentAuditRecord[key], ChangeReason: sortedFieldReason[key] });

                }
                else {
                    auditRecordDiffs.push({ ColumnName: key, OldValue: oldAuditRecord[key], NewValue: currentAuditRecord[key], ChangeReason: sortedFieldReason[key] });

                }
            }

            if (logAction === "ACTIVITY UPDATED" && oldAuditRecord[key] === currentAuditRecord[key] && (key === "ACTIVITY_PRIORITY" || key === "ACTIVITY_TYPE_NAME")) {
                auditRecordDiffs.push({ ColumnName: key, OldValue: oldAuditRecord[key], NewValue: currentAuditRecord[key], ChangeReason: sortedFieldReason[key] });
            }
        } else {
            if (currentAuditRecord[key] === null) {
                return;
            }
            let oldValue = currentAuditRecord[key];
            let newValue = oldValue;
            if (logAction === 'INSERT') {
                oldValue = "";
            }
            else {
                newValue = "";
            }
            auditRecordDiffs.push({ ColumnName: key, OldValue: oldValue, NewValue: newValue });
        }
    });
    return auditRecordDiffs.sort(function (oldarr, newarr) {
        return oldarr["ColumnName"].localeCompare(newarr["ColumnName"]);
    });
}

function authAuditDetailDataBound(e) {
    var grid = e.sender;
    if (grid.dataSource.total() === 0) {
        var colCount = grid.columns.length;
        $(e.sender.wrapper)
            .find('tbody')
            .append('<tr class="kendo-data-row"><td colspan="' + colCount + '" class="no-data">No Records</td></tr>');
    }
}

function checkAndConvert(OldData) {
    if (OldData === null || OldData === undefined) {
        return OldData;
    }
    var oldDataStr = OldData.toString();
    return isValidDate(oldDataStr) ? $.fn.apply12To24hrFormat(oldDataStr) : $.fn.replaceSpclCharsUnEscapeHtmlExt(oldDataStr);
}

function loadAuthAuditDetailDataGrid(e) {
    var modifiedAuditData = [];
    var tableName = e.data['TableName'];
    var tableLogId = e.data['TableLogId'];
    var previousTableLogId = e.data['PreviousTableLogId'];
    var logAction = e.data['AuditAction'];
    var PatientId = 0;
    if ($('#hdnIsForDasPopup').val() === "1") {
        PatientId = $('#hdnDasPopupPatientID').val();
    }
    AjaxRequest(baseApiURL + '/UMCommon/GetAuthAuditDetailData', { SP_VA_TABLE_NAME: tableName, SP_VA_TABLE_LOG_ID: tableLogId, SP_VA_PREVIOUS_TABLE_LOG_ID: previousTableLogId, PASCAL_KEYS: false, SD_VA_PATIENT_ID: PatientId }, function (auditData) {
        if (auditData) {
            var jsonResult = JSON.parse(auditData);
            modifiedAuditData = compareAuditRecords(logAction, jsonResult);
            modifiedAuditData.forEach(function (ele) {
                ele.OldValue = ele.OldValue !== null ? checkAndConvert(ele.OldValue.toString()) : "";
                ele.NewValue = ele.NewValue !== null ? checkAndConvert(ele.NewValue.toString()) : "";
            });
        }
        e.detailRow.find(".clsDivAuthAuditDetailData").kendoGrid({
            dataSource: {
                data: modifiedAuditData,
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
            },
            dataBound: authAuditDetailDataBound,
            scrollable: false,
            filterable: false,
            sortable: false,
            pageable: false,
            autoBind: true,
            columns: [{
                field: "ColumnName",
                title: "Column Name"
            },
            {
                field: "OldValue",
                title: "Old Value"

            }, {
                field: "NewValue",
                title: "New Value"
            },
            {
                field: "ChangeReason",
                title: "Reason For Change"
            }
            ]
        });

    });
}

function changeDateFormat(dateInput) {
    return IS_12HRS_FORMAT ? convert24to12HourFormat(dateInput) : convert12to24HourFormat(dateInput);
}
function phPrimaryStaffParameters() {
    return {
        careStaffName: $('#ddlPrimaryCareStaff').val(),
        isPrimary: true,
        selectedIds: $('#hdnddlPrimaryCareStaff').val()
    };
}
function phSecondaryStaffParameters() {
    return {
        careStaffName: $('#ddlSecondaryCareStaff').val(),
        isPrimary: false,
        selectedIds: $('#hdnddlSecondaryCareStaff').val()
    };
}
function trimUnSuppportedChars(event) {
    try {
        if (regExpUnSupportedChars === null) {
            return;
        }
        var target = event.target;
        var targetText = $(target).val();
        $(target).val(targetText.replace(regExpUnSupportedChars, ""));
    } catch (e) {
        console.error("trimUnSuppportedChars:", e);
    }
}
function initUnsupportedCharsValidation() {
    $("input[data-trim-unsupportedchars], textarea[data-trim-unsupportedchars]")
        .off('keypress keyup blur', trimUnSuppportedChars)
        .on('keypress keyup blur', trimUnSuppportedChars);
}

function enableDisableApplyButton(isFromClone) {
    if ((isFromClone && checkNullDropDownValues($("#ddlCSUser").val()) !== null) || ToValue($("#ddlCSMapUserIdhdn").val(), "") !== "") {
        $(".clsApply").attr("disabled", false);
        $(".clsClear").attr("disabled", false);
    }
    else {
        $(".clsApply").attr("disabled", true);
        $(".clsClear").attr("disabled", true);
    }
}
function resetBtnvValues(id) {
    var deptId = $.fn.getCntrl('ddlCSWQIdhdn').val();
    var roleId = $.fn.getCntrl('ddlCSRoleIdhdn').val();
    var btnId = $('#FormViewAdd');
    if (id !== 'ddlCSExeUserId' && $(btnId).text() === 'Update') {
        $(btnId).text('Search');
        clearDropCheckItems('ddlMapUser');
        clearDropCheckItems('ddlMapUserId');
        $('#divMapUser').hide();
        if ($(btnId).prop('disabled')) {
            $(btnId).attr("disabled", true);
        }
        if (!$(btnId).prop('disabled')) {
            $(btnId).attr("disabled", false);
        }
    }
    else if (id === 'ddlCSExeUserId' && $(btnId).text() === 'Update') {
        $(btnId).text('Search');
        clearDropCheckItems('ddlMapUser');
        clearDropCheckItems('ddlMapUserId');
        $('#divMapUser').hide();
        $(btnId).attr("disabled", false);
        $(".clsClear").attr("disabled", false);
    }
    else {
        //no code
    }
    if ((deptId !== '' && checkNullDropDownValues($("#ddlSourceUser").val()) === null) || (roleId !== '' && checkNullDropDownValues($("#ddlSourceUser").val()) === null)) {
        $(btnId).attr("disabled", true);
        $(".clsClear").attr("disabled", false);
    }
}
function checkNullDropDownValues(value) {
    if (value === '00' || value === '-1') {
        return null;
    }
    else {
        return value;
    }
}

function clearDropCheckItems(id) {
    $('#' + id + ' :checkbox').attr('checked', false);
    $('#' + id + 'Idval').attr('placeholder', 'Select');
    $('#' + id + 'val').val("");
    $('#' + id + 'hdn').val('');
    $('#' + id + 'hdntxt').val('');
}
function enableDisableSearchButton() {
    var deptId = $.fn.getCntrl('ddlCSWQIdhdn').val();
    var roleId = $.fn.getCntrl('ddlCSRoleIdhdn').val();
    var btnId = $('#FormViewAdd');
    if ((deptId !== '' && checkNullDropDownValues($("#ddlSourceUser").val()) !== null) || (roleId !== '' && checkNullDropDownValues($("#ddlSourceUser").val()) !== null)) {
        if ($(btnId).text() === 'Update' && ToValue($.fn.getCntrl('ddlMapUserIdhdn').val(), null) === null) {
            $(".clsSearch").attr("disabled", true);

        }
        else {
            $(".clsSearch").attr("disabled", false);
            $(".clsClear").attr("disabled", false);
        }
    }
    else if ($(btnId).text() === 'Update') {
        $(".clsSearch").attr("disabled", true);
    }
    else if (checkNullDropDownValues($("#ddlSourceUser").val()) !== null) {
        $(".clsSearch").attr("disabled", true);
        $(".clsClear").attr("disabled", false);
    }
    else if (checkNullDropDownValues($("#ddlSourceUser").val()) === null && $(btnId).text() !== 'Update' && deptId === "" && roleId === "") {
        $(".clsSearch").attr("disabled", true);
        $(".clsClear").attr("disabled", true);
    }
    else if (checkNullDropDownValues($("#ddlSourceUser").val()) === null && $(btnId).text() !== 'Update') {
        $(".clsSearch").attr("disabled", true);
        $(".clsClear").attr("disabled", false);
    }
    else {
        $(".clsSearch").attr("disabled", true);
        $(".clsClear").attr("disabled", true);
    }
}
function loadExistingUsers(id) {
    var deptId = $.fn.getCntrl('ddlCSWQIdhdn').val();
    var roleId = $.fn.getCntrl('ddlCSRoleIdhdn').val();
    if (id === "ddlCSWQId" && deptId !== '') {
        $('#divExeUser').show();
        $("#ddlCSRoleIdval").attr("disabled", true);
        CreateDropCheckAll('ddlCSExeUser', baseURL + '/UMConfig/GetExistingUsersByWqOrRole?careStaffId=' + memberidval + '&departmentId=' + deptId, 'ddlCSExeUserId', 0, undefined, undefined, undefined, "Username", "MemberId",);
        resetBtnvValues();
    }
    else if ((id === "ddlCSWQId" && deptId === '') || (id === "ddlCSRoleId" && roleId === '')) {
        $('#divExeUser').hide();
        $("#ddlCSWQIdval").attr("disabled", false);
        $("#ddlCSRoleIdval").attr("disabled", false);
        clearDropCheckItems('ddlCSExeUser');
        clearDropCheckItems('ddlCSExeUserId');
        resetBtnvValues();
    }
    else if (id === "ddlCSRoleId" && roleId !== '') {
        $('#divExeUser').show();
        $("#ddlCSWQIdval").attr("disabled", true);
        CreateDropCheckAll('ddlCSExeUser', baseURL + '/UMConfig/GetExistingUsersByWqOrRole?careStaffId=' + memberidval + '&roleId=' + roleId, 'ddlCSExeUserId', 0, undefined, undefined, undefined, "Username", "MemberId",);
        resetBtnvValues();
    }
    else {
        //no code logic required in this block
    }
    enableDisableSearchButton();
}

function smartSearchProcedureCodeDescription(Category, SourObj, IsDecAcc) {
    var procCode = $("#TextVisitProcCode").val();
    var procDesc = $("#TextVisitProcDesc").val();
    Category = Category.replace(", ", ",");
    if (procCode.length > 2 || procDesc.length > 2) {
        var GridOptData = {
            DataUrl: baseURL + '/MemberVisit/GetProcedureCodeSmartSearch?code=' + procCode + '&category=' + Category + '&description=' + procDesc,
            Columns: [
                { HeadStyle: "width:20px;", ItemTemplate: "<input type='radio' id='RadioBtn_{^RowNo+1^}' name='RadioBtn_{^GridKey^}' value='{{DiagProcId}}' onclick=" + Dq + "smartSearchVisitsProcCodeDescSelect(this,'{{DiagProcId}}|{{DiagProcCode}}|{{DiagProcDesc}}|{{CatName}}|{{IsActive}}|{{ProcCodeCategory}}|{{CodeStart}}|{{CodeEnd}}');" + Dq + "/>" },
                { HeadStyle: "width:80px;", Title: "Code", ItemKey: "DiagProcCode", ItemNull: "N/A", ItemSort: "DiagProcCode" },
                { HeadStyle: "width:80px;", Title: "Category", ItemKey: "ProcCodeCategory", ItemNull: "N/A", ItemSort: "ProcCodeCategory" },
                { HeadStyle: "width:250px;", Title: "Description", ItemKey: "DiagProcDesc", ItemNull: "N/A", ItemSort: "DiagProcDesc" }
            ]
        };

        SmartSearch_Grid(SourObj, GridOptData, null, null, function () {
            $('.DataGridInner', '.SmartSearchIn').css({ "font-weight": "normal" });
            $('.GlbGrid tr td', '.SmartSearchIn').css({ "white-space": "normal" });
            $('.DataGrid .slimScrollDiv .SlimScroll', '.SmartSearchIn').css("overflow", "");
            if ($("input[id^='RadioBtn_']").length === 0) {
                $("#TextVisitProcCode", "#TextVisitProcDesc").blur("smartSearchGridClose()");
            }

        });
    }
    if (IsDecAcc === 1) {
        $("#TextVisitProcDesc", ParentDiv).val('');
        $("#TextVisitProcCode", ParentDiv).val('');
    }
}

function smartSearchVisitsProcCodeDescSelect(CurrObj, DataValues) {
    var SplitData = DataValues.split("|");
    $("#TextVisitProcCode").val(SplitData[1]);
    $("#TextVisitProcDesc").val(SplitData[2]);
    smartSearchGridClose();
}

function smartSearchGridClose() {
    $("#SmartSearch").hide();
}

function clearSmartSearchForProcCodesDesc() {
    if (($("#TextVisitProcCode").val() === "" || $("#TextVisitProcCode") === null) && $("#TextVisitProcDesc").val() !== null && $("#TextVisitProcDesc").val() !== "") {
        $("#TextVisitProcDesc").val('');
    }
    if (($("#TextVisitProcDesc").val() === "" || $("#TextVisitProcDesc") === null) && $("#TextVisitProcCode").val() !== null && $("#TextVisitProcCode").val() !== "") {
        $("#TextVisitProcCode").val('');
    }
}

// Binding Radio button list
function bindConfidentialTypeRadioButton(rdoContainer, remoteUrl, selectedValue, isSetCache, parentDiv = null, callBack) {
    isSetCache = isSetCache || false;
    var _cachekey = remoteUrl.replace(baseURL + "/", "");
    var _data = (isSetCache && cacheData(_cachekey)) || null;
    if (_data === null) {
        $.ajax({
            type: "GET",
            url: remoteUrl,
            async: false,
            success: function (data) {
                buildConfidentialTypeHtml(data, selectedValue, rdoContainer, parentDiv);
                if (callBack && typeof (callBack) === "function") {
                    callBack();
                }
                if (isSetCache) {
                    cacheData({ key: _cachekey, value: data, maxage: 120 }, true);
                }
                noteConfidentialTypeId = data.find(x => x.ConfidentialTypeName === "All Users")?.ConfidentialTypeId || 0;
                internalUserNoteConfidentialTypeId = data.find(x => x.ConfidentialTypeName === "Internal Users Only")?.ConfidentialTypeId || 0;
            }
        });
    }
    else {
        buildConfidentialTypeHtml(_data, selectedValue, rdoContainer, parentDiv);
        if (callBack && typeof (callBack) === "function") {
            callBack();
        }
        noteConfidentialTypeId = _data.find(x => x.ConfidentialTypeName === "All Users")?.ConfidentialTypeId || 0;
        internalUserNoteConfidentialTypeId = _data.find(x => x.ConfidentialTypeName === "Internal Users Only")?.ConfidentialTypeId || 0;
    }
}

//Building html for Confidential Type radio buttons
function buildConfidentialTypeHtml(data, selectedValue, rdoContainer, parentDiv = null) {
    var optionsHtmlString = "";
    var rdoName = `rdo${rdoContainer}`;
    if (rdoContainer === 'dvConfidentialType') {
        rdoName = 'NoteConfidentialTypeId';
    }
    $.each(data, function (key, val) {
        if (selectedValue) {
            if (selectedValue === val.ConfidentialTypeId) {
                optionsHtmlString += `<span class="nowrap"><input id='${rdoContainer}_${val.ConfidentialTypeId}' type='radio' name='${rdoName}' value="${val.ConfidentialTypeId}" checked='checked' /><label class='ItemMR20 nowrap font-normal ItemML5' for='${rdoContainer}_${val.ConfidentialTypeId}'>${val.ConfidentialTypeName}</label></span>`;
            }
            else {
                optionsHtmlString += `<span class="nowrap"><input id= '${rdoContainer}_${val.ConfidentialTypeId}' type='radio' name='${rdoName}' value="${val.ConfidentialTypeId}" /><label class='font-normal ItemML5 ItemMR10' for='${rdoContainer}_${val.ConfidentialTypeId}'> ${val.ConfidentialTypeName} </label></span>`;
            }
        }
        else {
            if (val.ConfidentialTypeId === 2) {
                optionsHtmlString += `<span class="nowrap"><input id='${rdoContainer}_${val.ConfidentialTypeId}' type='radio' name='${rdoName}' value="${val.ConfidentialTypeId}" checked='checked' /><label class='ItemMR20 nowrap font-normal ItemML5' for='${rdoContainer}_${val.ConfidentialTypeId}'>${val.ConfidentialTypeName}</label></span>`;
            } else {
                optionsHtmlString += `<span class="nowrap"><input id='${rdoContainer}_${val.ConfidentialTypeId}' type='radio' name='${rdoName}' value="${val.ConfidentialTypeId}" /><label class='font-normal ItemML5 ItemMR10' for='${rdoContainer}_${val.ConfidentialTypeId}'>${val.ConfidentialTypeName}</label></span>`;
            }
        }
    });
    if (parentDiv === null) {
        $("#" + rdoContainer).AhsAppend(optionsHtmlString);
    } else {
        $("#" + rdoContainer, parentDiv).html("");
        $("#" + rdoContainer, parentDiv).AhsAppend(optionsHtmlString);
    }
}

function resetActivityCntrlsReqActClinicalPrograms() {
    if ($("#hdnIsClinicalReqActivity").length > 0 && $("#hdnIsClinicalReqActivity").val() === '1') { //Clinical Programs
        if ($("#CareActivityTypeId").length > 0) {
            $("#CareActivityTypeId").remove();
        }
        if ($("#ClinicalRequiredWorkflowId").length > 0) {
            $("#ClinicalRequiredWorkflowId").val('');
        }
        $('#AddActFor').show();
        $('#selectScript').show();
        $('#divScript #lblAAScriptName').hide();
        $('#selectScheduledType').attr('disabled', false);
        $("#rdoEAExternal").attr("disabled", false);
        $('#divDueDate #DueDate').data("kendoDateTimePicker").enable(true);
    }
}
function fnScriptFormGeneratePdf(docprint, objPrint, isFromTryAgain, topMargin) {
    $('#hdnIsGeneratePdf').val("");
    var htmlString = "";
    var cssBaseUrl = "";
    if (!isFromTryAgain) {
        $('input:checkbox:checked', objPrint).each(function () {
            $(this).attr("checked", "checked");
        });
        $('input:radio:checked', objPrint).each(function () {
            $(this).attr("checked", "checked");
        });
        $('input:checkbox,input:radio', objPrint).attr("disabled", "disabled");
        cssBaseUrl = $("#hdnSfBaseUrl").val();
        htmlString = docprint.document.documentElement.innerHTML;
        htmlString = htmlString.replace(cssBaseUrl, '');
        setTimeout(function () {
            docprint.close();
        }, 500);
    }

    var postData = {
        HtmlData: htmlString,
        ScriptName: $('#hdnScriptName').val(),
        ScriptRunLogId: $('#hdnScriptRunLogId', '#htmlTableScptForm').val(),
        isFromTryAgain: isFromTryAgain,
        topMargin: topMargin
    };
    $.ajax({
        type: "POST",
        async: true,
        url: baseURL + "/ActivityRecord/ScriptFormGeneratePdf",
        data: postData,
        success: function (data) {
            if (data.success) {
                setTimeout(function () {
                    legacyModalAlert("Message", "Script Form PDF document is ready. <a href='javascript:void(0)' onclick=\"ClickFire('" + $.trim(data.PatientId) + "', 'Documents')\"> Click here</a> to view.", true, null, true);
                }, 4000);
            }
            else {
                legacyModalAlert("Message", "PDF generation unsuccessful.Please  <a href='javascript:void(0)' onclick=\"fnScriptFormGeneratePdf(null,null,true)\"> Try agian</a>", true, null, true);
            }
        },
        error: function (err) {
            loader(0);
            if (err.status === 504 && err.statusText === "error") {
                legacyModalAlert("Message", 'The PDF is in progress, it will be available in the Documents section shortly.', true, null, true);
            }
            else {
                legacyModalAlert("Message", 'PDF generation unsuccessful', true, null, true);
            }
        }
    });
    legacyModalAlert("Message", "The Pdf is in progress, you will be notified with the destination once it is ready", true, null, true);
}

// Binding Radio button list - This is used in GlobalSignature.cshtml
function bindRadioButton(rdoContainer, remoteUrl, isSetCache) {
    isSetCache = isSetCache || false;
    var _cachekey = remoteUrl.replace(baseURL + "/", "");
    var _data = (isSetCache && cacheData(_cachekey)) || null;
    if (_data === null) {
        $.ajax({
            type: "GET",
            url: remoteUrl,
            async: false,
            success: function (data) {
                buildRadioButtonHtml(data, rdoContainer);
                if (isSetCache) {
                    cacheData({ key: _cachekey, value: data, maxage: 120 }, true);
                }
            }
        });
    }
    else {
        buildRadioButtonHtml(_data, rdoContainer);
    }
}

//Building html for radio buttons
function buildRadioButtonHtml(data, rdoContainer) {
    var optionsHtmlString = "";
    var rdoName = `rdo${rdoContainer}`;
    $.each(data, function (key, val) {
        optionsHtmlString += `<span class="nowrap"><input id='${rdoContainer}_${val.Value}' type='radio' name='${rdoName}' value="${val.Value}"/><label class='ItemMR20 nowrap font-normal ItemML5' for='${rdoContainer}_${val.Value}'>${val.Text}</label></span>`;
    });
    $("#" + rdoContainer).AhsAppend(optionsHtmlString);
}

function articleDescription(description, title) {
    var result = null;
    if (description != null && description.length > 50) {
        result = description.slice(0, 50).concat('... ');
        return result + "<a href = 'javascript:;' id='viewMoreArticle' data-description='" + escapeHtml(description) + "' data-title='" + escapeHtml(title) + "' onclick = 'viewMoreDescription(this);' >view more</a>";
    }
    else {
        result = (description === null || description === '') ? 'N/A' : escapeHtml(description);
        return result;
    }
}

function viewMoreDescription(obj) {
    var description = $(obj).data('description');
    var title = $(obj).data('title');
    $("#articleTitle").text(title);
    $('#articleDescription').text(description);
    $('#memArticleViewDescriptionDiv').CMNPopup({
        popLevel: 1,
        popUpHeader: "Article Description",
    });
}
function showHideTimetypeData(mainDiv, isEdit) {
    var selectID = "";
    var timetypediv = "";
    var timetype = "";
    var exchldy = "";

    if (isEdit) {
        selectID = mainDiv.find('.editclsduespan').attr('id');
        timetypediv = mainDiv.find('.clsEditReqTmType').attr('id');
        timetype = mainDiv.find('.editclsreqtimetype').attr('id');
        exchldy = mainDiv.find('.editclsChkHldy').attr('id');
    }
    else {
        selectID = mainDiv.find('.clsduespan').attr('id');
        timetypediv = mainDiv.find('.clsReqTmType').attr('id');
        timetype = mainDiv.find('.clsreqtimetype').attr('id');
        exchldy = mainDiv.find('.clsChkHldy').attr('id');
    }
    var dueSpan = $('#' + selectID).find("option:selected").text();
    if (dueSpan.toLowerCase() === 'day') {
        $('#' + timetypediv).show();
        $('#' + timetype + ' option:first').prop('selected', true);
        $('#' + exchldy).prop('checked', false);
    }
    else {
        $('#' + timetypediv).hide();
    }
}
function memberDetailsGridReload(fetchUpdatedInfo = false) {
    const memberDetailsTabVisible = $('#MemberDetailsTab').is(':visible');
    const isFromQuickLinks = $('#hdnIsFrmQuickLinks').val() === '1';
    if (memberDetailsTabVisible && !isFromQuickLinks) {
        $('#lnkMemberInfo').trigger('click');
    }
    else if (window.top.$(".InAuthPage").is(":visible")) {
        window.top.UMMemberDetailsQuickLink();
    }
    else if (window.top.$(".InComplaintPage").is(":visible")) {
        if (!fetchUpdatedInfo) {
            window.top.agMemberDetailsQuickLink();
        } else {
            window.top.agMemberDetailsQuickLink(undefined, true);
        }
    }
    else if (isFromQuickLinks) {
        $("#hdnIsFromMemIcon").val("1");
        LoadMemberSummaryMenu(null, null);
        window.top.cmMemberDetailsQuickLink();
    }
    else {
        $("#hdnIsFromMemIcon").val("1");
        LoadMemberSummaryMenu(null, null);
        window.top.MemberDetailsQuickLink();
    }
}
function showCostIconInfo(obj) {
    var str = 'Enter a whole number with decimals limited to 2 places. Limit 15 characters.';
    ContextMenu_Show(obj, "", "#ServiceCostInfo", true);
    var offSet = $(obj).offset();
    var soLeft = parseInt(offSet['left']);
    if (soLeft > 900) {
        $("#ContextMenu .ContextMenuIn").attr('style', 'width: 250px !important; overflow: auto; white-space: normal !important;');
    }
    else {
        $("#ContextMenu .ContextMenuIn").attr('style', 'width: 450px !important; overflow: auto; white-space: normal !important;');
    }
    $("#ContextMenu").css({ bottom: "15px" });
    $('#spnServiceCostInfo', "#ContextMenu").text(str);
    A11yUtil.setFocus('btnCloseServiceCostPopup', 100);
    A11yModal.trapFocusInModal('ContextMenuIn');
}
function showFaxRecDateInfo(obj) {
    var str = 'Fax received date & time has been applied as the notification timestamp based on your selection.';
    ContextMenu_Show(obj, "", "#FaxReceivedDateInfo", true);
    var offSet = $(obj).offset();
    var soLeft = parseInt(offSet['left']);
    if (soLeft > 900) {
        $("#ContextMenu .ContextMenuIn").attr('style', 'width: 250px !important; overflow: auto; white-space: normal !important;');
    }
    else {
        $("#ContextMenu .ContextMenuIn").attr('style', 'width: 450px !important; overflow: auto; white-space: normal !important;');
    }
    $('#spnFaxReceivedDateInfo', "#ContextMenu").text(str);
    A11yUtil.setFocus('btnCloseFaxInfoPopup', 100);
    A11yModal.trapFocusInModal('ContextMenuIn');
}
function checkServiceCostValidation(AccId, ServiceCostId, FromDecision = false) {
    var result = true;
    let val = true;
    var serviceCost = null;
    if (!FromDecision) {
        $(AccId + " .CptCodes .DiagProcCode").each(function () {
            var codeDiv = $(this).closest('.DiagProcCode');
            serviceCost = $(ServiceCostId, codeDiv).val();
            if (!$.fn.isNullOrEmpty(serviceCost)) {
                val = validateServiceCostData(serviceCost);
                if (!val) {
                    result = false;
                    $(ServiceCostId, codeDiv).addClass("serviceCostValidate");
                }
                else {
                    $(ServiceCostId, codeDiv).removeClass("serviceCostValidate");
                }
            }
            else {
                //no code
            }
        });
    }
    else {
        serviceCost = $(ServiceCostId, AccId).val();
        if (!$.fn.isNullOrEmpty(serviceCost)) {
            val = validateServiceCostData(serviceCost);
            if (!val) {
                result = false;
            }
        }
    }
    return result;
}
function validateServiceCostData(serviceCost) {
    let result = '';
    let valSplit = serviceCost.split('.');
    if (valSplit.length > 2 || $.fn.isNullOrEmpty(valSplit[0])) {
        result = false;
    }
    else if (valSplit[0].length > 12) {
        result = false;
    }
    else if (valSplit.length > 1 && ($.fn.isNullOrEmpty(valSplit[1]) || valSplit[1].length > 2)) {
        result = false;
    }
    else {
        result = true;
    }
    return result;
}

function getDateRangeBetween1to180andCustomDays(dateRangeCase, fromDate, toDate) {
    let tempDate = new Date();
    let resDateRange = {
        fromDate: '',
        toDate: CurrentDate()
    };
    switch (dateRangeCase) {
        case "-2":
            tempDate.setDate(tempDate.getDate() - 1); //1 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "-1":
            tempDate.setDate(tempDate.getDate() - 6); //7 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "1":
            tempDate.setDate(tempDate.getDate() - 29); //30 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "2":
            tempDate.setDate(tempDate.getDate() - 59); //60 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "3":
            tempDate.setDate(tempDate.getDate() - 89); //90 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "4":
            tempDate.setDate(tempDate.getDate() - 179); //180 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "5":
            resDateRange.fromDate = fromDate;//Custom Date
            resDateRange.toDate = toDate;
            break;
        case "6":
            tempDate.setDate(tempDate.getDate() - 547); //547 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        case "7":
            tempDate.setDate(tempDate.getDate() - 729); //729 Days
            resDateRange.fromDate = Dateconvert(tempDate);
            break;
        default:
            break;
    }
    return resDateRange;
}
function createDynamicAddUniqueRadioIdHtml(ParentDiv, radioClass, radioIdPrefix, radioIdRegex, AddHtml, uniqueGrpId) {
    var radioIdsObj = $.fn.setStringOnUndefinedOrNull(uniqueGrpId) !== '' ? $(ParentDiv).find("[name =" + uniqueGrpId + "]") : $(ParentDiv).find(radioClass);
    var radioIds = [];
    var suffix = 1;
    if (radioIdsObj.length > 0) {
        radioIdsObj.each(function (ele) {
            $.fn.setStringOnUndefinedOrNull(uniqueGrpId) !== '' ? radioIds.push(parseInt(radioIdsObj[ele].id.split('_')[2])) : radioIds.push(parseInt(radioIdsObj[ele].id.split('_')[1]));
        });
        suffix = Math.max(...radioIds);
        suffix++;
    }
    AddHtml = AddHtml.replace(radioIdRegex, radioIdPrefix + suffix);
    AddHtml = AddHtml.replace('checked=""', '');
    return AddHtml;
}
function removeInternalCareTeamDdlCache() {
    var url = baseURL + '/PatientCareTeam/LoadCareTeamDdl?activityPatientID=' + $('#selectPatientAccessed').val() + '&isInternalExternal=False';
    var _cachekey = url.replace(baseURL + "/", "");
    var _data = cacheData(_cachekey) || null;
    if (_data !== null) {
        delete cacheData[_cachekey];
        cacheData({ key: _cachekey, value: null }, true);
    }
}
function getTextAreaCount(textBoxId, maxValue, spanIdForMessage, fromTxServices = false) {
    var textLength = 0;
    if (!$.fn.isNullOrEmpty(textBoxId.val())) {
        textLength = textBoxId.val().length;
    }
    var textRemaining = maxValue - textLength;
    if (!fromTxServices) {
        spanIdForMessage.text(textRemaining + ' characters remaining');
    } else {
        spanIdForMessage.text(textLength + '/2000');
    }
}

function postCalenderFlagUmAuthClick(ScriptId) {
    if (checkUnsentMsgWfChatBox()) {
        var AuthNo = ScriptId.split('|')[3];
        var PatientFName = ScriptId.split('|')[4];
        var PatientLName = ScriptId.split('|')[5];
        var AuthId = ScriptId.split('|')[1];
        var PatientId = ScriptId.split('|')[0];
        var AuthClassId = ScriptId.split('|')[2];
        isRedirectToAuthActivity = 1;

        if (IsAlertAcknowledgementRequired === 'True' && $('#selectPatientAccessed').val() !== PatientId) {
            GetPatientAlertsAndAcknowledge(PatientId, 0, AuthNo, 'umact', '');
        }
        else {
            SetAuthDatanew(PatientId, AuthId, AuthClassId, AuthNo, PatientFName, PatientLName);
        }
    }
    return false;
}

function showHideColumnsBasedOnModeandConfig(gridId, isExpandMode, isMACEnabled, columnName) {
    if (isExpandMode) {
        $.fn.getCntrl(gridId).data("kendoGrid").hideColumn(columnName);
        switch (columnName.toLowerCase()) {
            case 'eligibilitylevel':
            case 'complaintstatus':
                $.fn.getCntrl(gridId).data("kendoGrid").showColumn(columnName);
                break;
            case 'complaintclass':
            case 'treatmenttypename':
            case 'authdatenoted':
                if (isMACEnabled) {
                    $.fn.getCntrl(gridId).data("kendoGrid").showColumn(columnName);
                }
                break;
            case 'authtypename':
                $.fn.getCntrl(gridId).data("kendoGrid").showColumn(columnName);
                break;
            default:
                $.fn.getCntrl(gridId).data("kendoGrid").hideColumn(columnName);
                break;
        }
    }
    else {
        $.fn.getCntrl(gridId).data("kendoGrid").hideColumn(columnName);
    }
}
/*method toshow validation when running new script form, if same script is already scheduled on the member*/
function showValidationIfSfScheduled(sptId, sptName) {
    var patientId = $('#selectPatientAccessed').val() !== "" ? $('#selectPatientAccessed').val() : $("#hdnPHRunScriptMemberId").val();
    var pardata = { patientId: patientId, scriptId: sptId };
    $.ajax({
        url: baseURL + "/Assessment/ShowMessageIfScriptActSchdld",
        type: "POST",
        data: pardata,
        async: false,
        success: function (data) {
            if (data.success) {
                if (data.pastDt !== '' && data.futureDt !== '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml($.fn.replaceAndEscapeHtmlExt(sptName) + ' Script was already scheduled on ' + data.pastDt + ' and also is scheduled on ' + data.futureDt + '.');
                }
                else if (data.futureDt !== '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml($.fn.replaceAndEscapeHtmlExt(sptName) + ' Script is already scheduled on ' + data.futureDt + '.');
                }
                else if (data.pastDt !== '') {
                    $('#spnShowValdMsgRQ').AhsSetHtml($.fn.replaceAndEscapeHtmlExt(sptName) + ' Script was already scheduled on ' + data.pastDt + '.');
                }
                else {
                    $('#spnShowValdMsgRQ').AhsSetHtml('');
                }
            }
        },
        error: function () { CustomAlert("Error Encountered"); }
    });
}
//Get complaint current level
function getComplaintCurrentLevelByComplaintId(complaintId, patientId) {
    var currentLevel = 0;
    $.ajax({
        type: "GET",
        url: baseURL + "/Complaint/ComplaintCurrentLevel?ComplaintId=" + complaintId + "&patientID=" + patientId,
        dataType: "json",
        async: false,
        success: function (complaintLevel) {
            loader(0);
            currentLevel = complaintLevel;
        },
        error: function () {
        }
    });
    return currentLevel;
}
function loadDefaultfilter() {
    $.ajax({
        url: baseURL + "/PopulationHealth/GetdefaultfilterMyMember",
        type: "Post",
        dataType: "json",
        success: function (data) {
            if (data.success) {
                if (data.value.length > 0) {
                    $('#ddlSavedfiltersMyMember').val(data.value[0].FilterId);
                    checkDefaultValueMyMem();
                    checkColumnsForSelectedFilterMyMem();
                }
                else {
                    $('#ddlSavedfiltersMyMember').val(-1);
                    checkDefaultValueMyMem();
                    checkColumnsForSelectedFilterMyMem();
                    //firoza
                }
            }
        },
        error: function () {
            CustomAlert("Error Encountered");
        }
    });
}
function checkColumnsForSelectedFilterMyMem() {
    uncheckColumnsMyMem();
    var filterid = $("#ddlSavedfiltersMyMember option:selected").val();
    if (filterid !== -1) {
        $.ajax({
            url: baseURL + "/PopulationHealth/GetColumnsForFilterMyMembers/",
            data: { FilterId: filterid },
            type: "GET",
            success: function (data) {
                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        var obj = data[i];
                        var chkbox = $("input:checkbox.ddlFilterMyMemberSelection[value=" + obj.Value + "]");
                        if (chkbox) {
                            chkbox.prop("checked", true);
                            chkbox.closest('li').attr('aria-selected', true);
                        }
                    }
                    A11yDropcheck.dropcheckColumnSelectedShow('ddlFilterMyMemberSelection', 0);
                }
            }
        });
    }
}
function checkDefaultValueMyMem() {
    uncheckColumnsMyMem();
    var filterid = $("#ddlSavedfiltersMyMember option:selected").val() || -1;
    if (filterid !== -1) {
        $.ajax({
            url: baseURL + "/PopulationHealth/GetDefaultValueMyMembers/",
            data: { FilterId: filterid },
            type: "Post",
            dataType: "json",
            success: function (data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].IsDefault) {
                        $('#chkDefaultfilter').prop('checked', true);
                        MyMemDefault = data[i].PrMemberDdlId;
                    }
                }
            }
        });
    }
}
function uncheckColumnsMyMem() {
    var checkedboxes = $("#ddlFilterMyMemberSelectionchk").find('input[type="checkbox"]:checked');
    if (checkedboxes.length > 0) {
        $(checkedboxes).each(function () {
            $(this).attr('checked', false);
            $(this).closest('li').attr('aria-selected', false);
        });
        $("#ddlFilterMyMemberSelectionval").val("Select");
        $('#ddlFilterMyMemberSelectionhdn').val('');
    }
}

function nextPopupLevel() {
    let maxPopLevel = -1;

    $('.ah-modal:visible').each(function () {
        let $popUp = $(this);

        let popupZIndex = parseInt($popUp.css('zIndex'));
        if (isNaN(popupZIndex)) {
            console.log("Pop Up z-index is not a number, skipping...");
            return;
        }

        let currentPopLevel = (popupZIndex - 9003) / 1000;
        if (!Number.isInteger(currentPopLevel)) {
            console.log("Pop Level derivation from z-index failed, skipping...");
            return;
        }

        if (currentPopLevel > maxPopLevel) {
            maxPopLevel = currentPopLevel;
        }
    });

    return maxPopLevel + 1;
}

function getInterqualReviewData(authNo, patientId, decisionIds, successCallback) {
    let clientId = "";
    let state = "";
    let fromDate = "";
    $.ajax({
        type: "GET",
        url: baseURL + "/Authorization/GetAuthDataForInterqualReview?authNo=" + authNo + "&patientID=" + patientId + "&decisionID=" + decisionIds,
        dataType: "json",
        async: false,
        success: function (ReviewData) {
            if (!$.fn.isNullOrEmpty(ReviewData)) {
                clientId = ReviewData.ClientPatientId;
                state = ReviewData.ProviderState === null ? '' : ReviewData.ProviderState;
                fromDate = ReviewData.ServiceFromDate === null ? '' : ReviewData.ServiceFromDate;
            }
            successCallback(clientId, state, fromDate);
        }
    });
}

function renderConnectedAppsMenuUmAg(module) {
    const connectedAppsMenuContainer = $(module);
    var memberClientId = $("#hdnMemberSumClientId").val();
    if (memberClientId && connectedAppsMenuContainer.length > 0) {
        var menus = $(connectedAppsMenuContainer).children("span");
        var hiddenMenusCount = 0;
        if (menus.length > 0) {
            var hasAccess = false;
            var clients = '';
            for (var i = 0; i < menus.length; i++) {
                hasAccess = false;
                clients = $(menus[i]).data('clients').toString();
                if (clients && clients !== '') {
                    var mappedClients = clients.split(',');
                    hasAccess = mappedClients.includes("-1") ? true : mappedClients.includes(memberClientId);
                }

                if (!hasAccess) {
                    hiddenMenusCount++;
                }

                $(menus[i]).toggle(hasAccess);

                clients = '';
            }
            $(connectedAppsMenuContainer).toggle(menus.length !== hiddenMenusCount);
        }
    }
}
function generateWeeklyPlannerTooltipHtml(freqJson) {
    let html = '<div id="hMenGdUV"><div class="is_flex nowrap width100P"></div><div class="line_blue ItemMB5 width100P"></div>';
    html += '<div>';

    if (freqJson !== undefined && freqJson !== "" && freqJson.pervisit) {
        const hasDaywiseVal = freqJson.pervisit.some(item =>
            item.day !== "any" && item.val !== null && item.val !== ""
        );

        html += '<table class="clsWeeklyPlannerTbl" style="width:auto;">';
        html += '<tr role="row">';

        if (hasDaywiseVal) {
            const dayOrder = ["sun", "mon", "tue", "wed", "thr", "fri", "sat"];
            dayOrder.forEach(day => {
                html += `<td>${day.charAt(0).toUpperCase() + day.slice(1)}</td>`;
            });
            html += '</tr><tr role="row">';
            dayOrder.forEach(day => {
                const match = freqJson.pervisit.find(item => item.day === day);
                html += `<td>${match ? match.val : ""}</td>`;
            });
        } else {
            html += '<td>Any day</td></tr><tr role="row">';
            const anyEntry = freqJson.pervisit.find(item => item.day === "any");
            html += `<td>${anyEntry?.val || ""}</td>`;
        }

        html += '</tr></table>';
    }

    html += '</div></div>';
    DevUtils.logDebug('html=' + html, 'generateWeeklyPlannerTooltipHtml', { freqJson: freqJson });
    return html;
}

function generateMonthlyPlannerTooltipHtml(freqJson, isFromDecision) {
    let html = '<div>';
    if (isFromDecision !== 'undefined' && isFromDecision) {
        html += "<span style='font-size:13px;'> Units per Visit: <b>" + ToValue(freqJson.previsit, freqJson.pervisit) + "</b></br></span>";
    }
    var selectedday = '';
    var weekday = '';
    if (freqJson.monthly !== 'undefined' && freqJson.monthly.radioMonth !== 'undefined') {
        if (freqJson.monthly.radioMonth === "1") {
            html += "<span style='font-size:13px;'> Day <b>" + freqJson.monthly.day + "</b> of every <b>" + freqJson.monthly.month + "</b> month(s) </span>";
        }
        else if (freqJson.monthly.radioMonth === "2") {
            switch (freqJson.monthly.selectedday) {
                case "1":
                    selectedday = 'First';
                    break;
                case "2":
                    selectedday = 'Second';
                    break;
                case "3":
                    selectedday = 'Third';
                    break;
                case "4":
                    selectedday = 'Fourth';
                    break;
                case "5":
                    selectedday = 'Last';
                    break;
                default:
                    break;
            }
            switch (freqJson.monthly.weekday) {
                case "-2":
                    weekday = 'Weekday';
                    break;
                case "-1":
                    weekday = 'Week-end day';
                    break;
                case "0":
                    weekday = 'Sunday';
                    break;
                case "1":
                    weekday = 'Monday';
                    break;
                case "2":
                    weekday = 'Tuesday';
                    break;
                case "3":
                    weekday = 'Wednesday';
                    break;
                case "4":
                    weekday = 'Thursday';
                    break;
                case "5":
                    weekday = 'Friday';
                    break;
                case "6":
                    weekday = 'Saturday';
                    break;
                default:
                    break;
            }
            html += "<span style='font-size:13px;'><b>" + selectedday + "</b> <b>" + weekday + " </b> of every <b> " + freqJson.monthly.month + " </b> month(s) </span>";
        }
        else {
            html += "<span style='font-size:13px;'> Any day of every <b>" + freqJson.monthly.month + " </b> month(s) </span>";
        }
    }
    html += '</div>';
    DevUtils.logDebug('html=' + html, 'generateWeeklyPlannerTooltipHtml', { freqJson: freqJson });
    return html;
}
function showdropPrefTimeDays(ctrl, _isUM) {
    var parEle = $(ctrl).closest('.memPrefEditColumn');
    var isExpand = true;
    if (isExpand) {
        var childCtrl = $(parEle).find('#SelectPrefDayschk');
        $(childCtrl).show();
        $(childCtrl).children().show();
        $(childCtrl).offset({ top: ($(ctrl).offset().top + 42), left: $(childCtrl).offset().left });
    }
}
function spnclickedPrefTimeCall(ctrl, isUM) {
    var parEle = "";
    parEle = $(ctrl).closest('#SelectPrefDayschk').closest('.memPrefEditColumn');
    var ele = $(ctrl).prev("input[type='checkbox']");
    if (ele.is(':checked')) {
        ele.prop('checked', false);
    } else {
        ele.prop('checked', true);
    }
    clickedPrefTimeCall(ele, parEle, isUM);
}
function createDropCheckForPrefTimeCall(sVal, parEle, dropDownId) {
    var newdropDownId = dropDownId.replace('#', "");
    newdropDownId = newdropDownId.trim();
    var htm = "<input id='" + newdropDownId + "val' type='text' class='droptexthide' data-id='" + newdropDownId + "' autocomplete='off'  readonly='true'  onclick='showdropPrefTimeDays(this)'  onkeyup='textChanged(this)'   />";
    htm = htm + "<input type='hidden' id='" + newdropDownId + "hdn' value=''/><input type='hidden' id='ddlDayNameshdn' value=''/>";
    htm = htm + "<div id='" + newdropDownId + "chk' class='dropcheck' style='display:none;width:188px !important' tabindex='0'>";

    var AllDays = "Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Weekend|Any Weekday|No Preference";
    AllDays = AllDays.split('|');
    var SelectedDays = null;
    if (sVal !== "" && sVal !== null && sVal !== 'null') {
        SelectedDays = sVal.split(',');
    }
    $.each(AllDays, function (_key, allVal) {
        if (jQuery.inArray(allVal, SelectedDays) !== -1) {
            htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' checked='checked' onchange='clickedPrefTimeCall(this,0)' /><div id='spnDays' title='" + allVal + "' onclick='spnclickedPrefTimeCall(this)' style='cursor:pointer;'>" + allVal + "</div><br/>";
        } else {
            htm = htm + "<input type='checkbox' class='chkDays'  id='chkDays' value='" + allVal + "' onchange='clickedPrefTimeCall(this,0)' /><div id='spnDays' title='" + allVal + "' onclick='spnclickedPrefTimeCall(this)' style='cursor:pointer;'>" + allVal + "</div><br/>";
        }
    });
    htm = htm + "</div>";
    $(parEle).find(dropDownId).html('');
    $(parEle).find(dropDownId).append(htm);
    clickedPrefTimeCall(0, parEle);
}
function clickedPrefTimeCall(chkCtrl, parEle, _isUM) {
    var chkboxes = "";
    if (chkCtrl !== 0) {
        parEle = $(chkCtrl).closest('#SelectPrefDayschk').closest('.memPrefEditColumn');
    }
    chkboxes = $(parEle).find('#SelectPrefDayschk').find('input[type="checkbox"]:checked');
    if (chkboxes.length > 0) {
        var outPutString = "";
        var dayNamesString = [];
        $(parEle).find('#SelectPrefDayschk').find('input[type="checkbox"]').each(function () {
            if ($(this).val() === "Select") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Select");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Weekend") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Weekend");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Any Weekday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Any Weekday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "No Preference") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("No Preference");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Sunday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Sunday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Monday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Monday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Tuesday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Tuesday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Wednesday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Wednesday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Thursday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Thursday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Friday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Friday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
            if ($(this).val() === "Saturday") {
                if ($(this).is(':checked')) {
                    outPutString = outPutString + '1';
                    dayNamesString.push("Saturday");
                }
                else {
                    outPutString = outPutString + '0';
                }
            }
        });
        $(parEle).find("#SelectPrefDayshdn").val(outPutString);
        $(parEle).find("#SelectPrefDaysval").val(dayNamesString.join(', '));
        $(parEle).find("#SelectPrefDaysval").attr('title', unescapeHtml(dayNamesString.join(',')));
        $(parEle).find("#ddlDayNameshdn").val(dayNamesString);
    }
    else {
        $(parEle).find("#SelectPrefDayshdn").val("00000000");
        $(parEle).find("#SelectPrefDayshdn").val("");
        $(parEle).find("#SelectPrefDaysval").val('Select');
        $(parEle).find('#SelectPrefDayschk').find('input[type="checkbox"]').each(function () {
            $(this).removeAttr('disabled');
        });
        $(parEle).find('#SelectPrefDayschk').find('div').each(function () {

            $(this).attr('onclick', 'spnclickedPrefTimeCall(this,0)');
        });
    }
}
function createPrefTimeCall(ActObj, ParentDiv, ChildDiv, PrefTimeData) {
    var PrefTimeCallsDiv = $(ActObj).closest(ParentDiv);
    var PrefTimeCallDiv = $(ActObj).closest(ChildDiv);
    var PrefTimeCallNextDiv = null;
    if ($(ChildDiv, PrefTimeCallsDiv).length < 3) {
        preftimecallRowCount++;
        var AddHtml = "<div class='" + ChildDiv.replace(".", "") + "' id='divEditPrefTimeOfCall_" + preftimecallRowCount + "'>" + $(PrefTimeCallDiv).html() + "</div>";
        $(PrefTimeCallDiv).after(AddHtml);
        PrefTimeCallNextDiv = $(PrefTimeCallDiv).next();
        if (PrefTimeData != null) {
            createDropCheckForPrefTimeCall(PrefTimeData.Day[0], PrefTimeCallNextDiv, '#SelectPrefDays');
            loadDropDown(baseURL + 'Member/BindPreferredTime', $('#SelectPrefTime', PrefTimeCallNextDiv), PrefTimeData.Time, null, "Value", "Text", null, null, null, null, null);
            loadDropDown(baseURL + 'Member/BindTime?selectedTime=' + PrefTimeData.Time, $('#SelectPrefStartTime', PrefTimeCallNextDiv), PrefTimeData.StartTime, null, "Value", "Text", null, null, null, null, null);
            loadDropDown(baseURL + 'Member/BindTime?selectedTime=' + PrefTimeData.Time, $('#SelectPrefEndTime', PrefTimeCallNextDiv), PrefTimeData.EndTime, null, "Value", "Text", null, null, null, null, null);
            if (PrefTimeData.Time === '-1') {
                $('#SelectPrefStartTime', PrefTimeCallNextDiv).prop('disabled', true);
                $('#SelectPrefEndTime', PrefTimeCallNextDiv).prop('disabled', true);
            }
            else {
                $('#SelectPrefStartTime', PrefTimeCallNextDiv).prop('disabled', false);
                $('#SelectPrefEndTime', PrefTimeCallNextDiv).prop('disabled', false);

            }
        }
        else {
            createDropCheckForPrefTimeCall("Select", PrefTimeCallNextDiv, '#SelectPrefDays');
            $('#SelectPrefDays', PrefTimeCallNextDiv).val('');
            $("#SelectPrefTime", PrefTimeCallNextDiv).val('');
            $("#SelectPrefStartTime", PrefTimeCallNextDiv).val('');
            $("#SelectPrefEndTime", PrefTimeCallNextDiv).val('');
            $("#SelectPrefStartTime", PrefTimeCallNextDiv).prop('disabled', true);
            $("#SelectPrefEndTime", PrefTimeCallNextDiv).prop('disabled', true);
        }
        $('#BtnRemovePrefTime', PrefTimeCallNextDiv).css('display', '');
        if ($(ChildDiv, PrefTimeCallsDiv).length > 2) {
            $('#BtnAddPrefTime', ChildDiv).last().css('display', 'none');
        }
    }
}
function onChangeClickEmail() {
    let id = "#selectCareteamSecureEmail";
    if ($(id).val() === "-1") {
        $('#txtMsgSentToSecure').val("");
    }
    else {
        var res = $(id).val();
        var email = res.split(",");
        $('#txtMsgSentToSecure').val(email[0]);
    }
}
function PhRequestReceivedActivityRoles() {
    $(".divClsMemberMenuAccept").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_ACTIVITES", className: "divClsMemberMenuAccept", IsFrom: "Edit", IsRemoveElement: true });
    $(".divClsMemberMenuReject").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_ACTIVITES", className: "divClsMemberMenuReject", IsFrom: "Edit", IsRemoveElement: true });
    $("#btnRequestReceivedAccept").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_ACTIVITES", Id: "btnRequestReceivedAccept", IsFrom: "Edit", IsRemoveElement: true });
}
function phRequestReceivedCarePlanRoles() {
    $("#btnRequestReceivedCareSignOff").show(); $("#btnRequestReceivedCareReject").show();
    $("#divCarePlanMenuSignOff_").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_CAREPLAN", Id: "divCarePlanMenuSignOff_", IsFrom: "Edit", IsRemoveElement: true });
    $("#divCarePlanMenuReject_").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_CAREPLAN", Id: "divCarePlanMenuReject_", IsFrom: "Edit", IsRemoveElement: true });
    $("#btnRequestReceivedCareSignOff").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_CAREPLAN", Id: "btnRequestReceivedCareSignOff", IsFrom: "Edit", IsRemoveElement: true });
    $("#btnRequestReceivedCareReject").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_CAREPLAN", Id: "btnRequestReceivedCareReject", IsFrom: "Edit", IsRemoveElement: true });
}
function resetPrefTimeCall(ActObj, ParentDiv, ChildDiv) {
    var CodesDiv = $(ActObj).closest(ParentDiv);
    var CodeDiv = $(ActObj).closest(ChildDiv);
    if ($(ChildDiv, CodesDiv).length > 1) {
        $(CodeDiv).remove();
    }
    $('#BtnAddPrefTime', ChildDiv).last().css('display', '');
}
function PhRequestReceivedRolls() {
    $("#divAppointmentMenuReject_").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_APPOINTMENT", Id: "divAppointmentMenuReject_", IsFrom: "Edit", IsRemoveElement: true });
    if (SetRoleAccessOnMALNavigation()) {
        $("#btnReqExpndClick").ApplyRoleConfig({
            UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_APPOINTMENT",
            Id: "btnReqExpndClick",
            IsFrom: "View",
            IsRemoveElement: true
        });
    }
    $("#divAppointmentMenuRejectMAL_").ApplyRoleConfig({ UniqueName: "PH_AHS_MEMBER_REQUEST_RECEIVED_APPOINTMENT", Id: "divAppointmentMenuRejectMAL_", IsFrom: "Edit", IsRemoveElement: true });

}

function getDefaultViewOfSection(sectionName, callback) {
    sectionName = sectionName || '';
    if (sectionName.length === 0) {
        if (callback && typeof (callback) === "function") {
            callback({ status: false });
        }
        return;
    }
    var cachekey = sectionName.replace(/ /g, '_') + memberidval;
    let defaultviewCached = cacheData(cachekey);
    if (defaultviewCached === null) {
        $.ajax({
            type: "GET",
            url: baseURL + "/Master/GetDefaultViewMode?sectionName=" + sectionName,
            dataType: "json",
            success: function (data) {
                cacheData({ key: cachekey, value: data.defaultView, maxage: 120 }, true);
                if (callback && typeof (callback) === "function") {
                    callback({ status: true, defaultView: data.defaultView });
                }
            },
            error: function () {
                if (callback && typeof (callback) === "function") {
                    callback({ status: false });
                }
            }
        });
    }
    else {
        if (callback && typeof (callback) === "function") {
            callback({ status: true, defaultView: defaultviewCached });
        }
    }
}
function setDefaultViewOfSection(defaultView, sectionName, callback) {
    sectionName = sectionName || '';
    defaultView = defaultView || '';
    if (defaultView.length === 0 || sectionName.length === 0) {
        if (callback && typeof (callback) === "function") {
            callback({ status: false });
        }
        return;
    }
    $.ajax({
        type: "POST",
        url: baseURL + "/Master/SetDefaultViewMode?defaultView=" + defaultView + "&section=" + sectionName,
        dataType: "json",
        success: function (status) {
            if (status) {
                let cachekey = sectionName.replace(/ /g, '_') + memberidval;
                cacheData({ key: cachekey, value: defaultView, maxage: 120 }, true);
                callback({ status: true });
            }
        },
        error: function () {
            if (callback && typeof (callback) === "function") {
                callback({ status: false });
            }
        }
    });
}
class HttpRequestHelpers {
    static JsonToQueryString = (payload) => {
        const keyValuePairs = [];
        for (const key in payload) {
            if (payload.hasOwnProperty(key)) {
                const value = payload[key];
                const encodedKey = encodeURIComponent(key);
                const encodedValue = encodeURIComponent(value);
                keyValuePairs.push(`${encodedKey}=${encodedValue}`);
            }
        }
        return keyValuePairs.join('&');
    };
}
class HttpBrowserClient {
    static async getResource(url, payload, headers) {
        try {
            if (payload) {
                url = `${url}?${HttpRequestHelpers.JsonToQueryString(payload)}`;
            }
            const response = await fetch(url, { headers });
            if (!response.ok) {
                throw new Error('Something went wrong');
            }
            return await response.json();
        } catch (error) {
            throw new Error('There was a problem while fetching data:', error);
        }
    }
}
class SecureBrowserFileDownload {
    static Download = (baseUrl, action, payload, headers, callback) => {
        let qParameters = HttpRequestHelpers.JsonToQueryString(payload);
        let tokenUrl = `${baseUrl}/download/tokenasync`;
        HttpBrowserClient.getResource(tokenUrl, { FileId: payload.fileId, EntityType: payload.entityType }, headers)
            .then(data => {
                var win = window.open(`${baseUrl}/download/${action}?gc-fd-token=${data.token}&${qParameters}`, (window.browserPopUpName || window.top.browserPopUpName));
                if (win && win.focus) {
                    win.focus();
                }

                if (callback && typeof (callback) === "function") {
                    callback();
                }
            });
    };
    static DownloadDocument = (baseUrl, action, payload, headers, callback) => {
        let qParameters = HttpRequestHelpers.JsonToQueryString(payload);
        let tokenUrl = `${baseUrl}/download/generatedocumenttoken`;
        HttpBrowserClient.getResource(tokenUrl, { fileId: payload.fileId, entityType: payload.entityType, patientId: payload.patientId }, headers)
            .then(data => {
                var win = window.open(`${baseUrl}/download/${action}?gc-fd-token=${data.token}&${qParameters}`, (window.browserPopUpName || window.top.browserPopUpName));
                if (win && win.focus) {
                    win.focus();
                }

                if (callback && typeof (callback) === "function") {
                    callback();
                }
            });
    };
    static DownloadFile = (baseUrl, payload, downloadAction, token, callback) => {
        let qParameters = HttpRequestHelpers.JsonToQueryString(payload);
        var win = window.open(`${baseUrl}/download/${downloadAction}?gc-fd-token=${token}&${qParameters}`, (window.browserPopUpName || window.top.browserPopUpName));
        if (win && win.focus) {
            win.focus();
        }
        if (callback && typeof (callback) === "function") {
            callback();
        }
    };
}
function requestReceviedUmAIRActivity(authredirect, activityId, IsPerform) {
    var ParamArr = authredirect.split('|');
    isPerformMDRActivity = Boolean(IsPerform === "true");

    if (ParamArr.length > 4) {
        var AuthNo = ParamArr[3];
        var ActivityLogId = activityId != null ? activityId : undefined;
        var AuthId = ParamArr[1];
        var PatientId = ParamArr[0];
        var AuthClassId = ParamArr[2];
        isMDReviewCalendar = true;
        IsFromAdditionalInfoReq = true;
        $('#hdnMdrParentActivity').val('0');
        calendarUmMDRActivityLogId = ActivityLogId;
        SetAuthDatanew(PatientId, AuthId, AuthClassId, AuthNo, ActivityLogId);
    }
}
function calendarUmMDRReturnActivity(ctrlId) {
    $('#closePopUp').trigger('click');
    var ParamArr = ctrlId.id.split('|');
    var acttype = $(ctrlId).attr('data-acttype');
    var actid = $(ctrlId).attr('data-actid');
    var Parentactid = $(ctrlId).attr('data-Parentactid');
    isPerformMDRActivity = Boolean($(ctrlId).attr('data-isperform') === "true");


    if (ParamArr.length > 4) {
        var AuthNo = ParamArr[3];
        var ActivityLogId = actid != null ? actid : undefined;
        var AuthId = ParamArr[1];
        var PatientId = ParamArr[0];
        var AuthClassId = ParamArr[2];
        isMDReviewCalendar = true;
        if (acttype) {
            IsFromAdditionalInfoReq = true;
        }
        if (isMDReviewCalendar || IsFromAdditionalInfoReq) {
            $('#hdnMdrParentActivity').val('0');
        }
        $('#hdnMdrReturnActivity').val(Parentactid);
        calendarUmMDRActivityLogId = ActivityLogId;
        SetAuthDatanew(PatientId, AuthId, AuthClassId, AuthNo, ActivityLogId);
    }
}

function getFilterDatesAndLob(section) {
    var checkedSections = getCheckedSections();
    var fromDate = "", toDate = "", lob = "";
    if (checkedSections.includes(section)) {
        fromDate = $('#txtFullCarePlanStartDate').val();
        toDate = $('#txtFullCarePlanEndDate').val();
        if (section !== "Barriers" && section !== "Strengths" && section !== "Care Team") {
            lob = $('#clinicalInterventionCLob .clsRdoMemEligMini:checked').data('lobbenid');
        }
    }
    return { fromDate, toDate, lob };
}

function getCheckedSections() {
    var checkboxes = $("#ApplyFilterToDropdown").find("ul.items input[type='checkbox']");
    var checkedSections = [];
    checkboxes.each(function () {
        if ($(this).is(":checked")) {
            var sectionText = $(this).closest("label").text().trim();
            checkedSections.push(sectionText);
        }
    });
    return checkedSections;
}

function CareTeamGridParameters() {
    var { fromDate, toDate } = getFilterDatesAndLob("Care Team");
    return {
        patientId: $('#hdnFullCarePlanPatientId').val(),
        dateFrom: fromDate,
        dateTo: toDate,
        TimeDictionaryobj: timeZone
    };
}
function validateAuthDocId(SearchOptionValue, SearchVal) {
    if (isNaN(SearchVal)) {
        CustomAlert("No records found");
        return false;
    }
    clearPreAuthCache();
    return GetAuthDetails(SearchOptionValue, SearchVal);
}

function copyLinkHref(url) {
    if ($.fn.isNullOrEmpty(url) || url === "N/A") {
        return "#";
    }
    const regex = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;
    if (regex.test(url)) {
        return url;
    }
    else {
        return "https://" + url;
    }
}

function generateValidHref(className) {
    $(className).each(function () {
        var url = $(this).data("url");
        if (!$.fn.isNullOrEmpty(url) && url !== "N/A") {
            var href = copyLinkHref(url);
            $(this).attr("href", href);
        }
    });
}
$(document).off('change', '#ddlScCategory').on('change', '#ddlScCategory', function () {
    hideShowConfigSpeedyChkbox($('#ddlScCategory :selected').val());
    $('#chkIsConfigDispatch').attr('checked', false);
});
function hideShowConfigSpeedyChkbox(ddlScCategory) {
    if (ddlScCategory === "1") {
        $('#chkboxConfigDispatch').show();
        return true;
    }
    else {
        $('#chkboxConfigDispatch').hide();
        return false;
    }
}
function getCareGiverType(flag) {
    switch (flag) {
        case 0:
            return CareGiverTypeEnum.Informal;
        case 1:
            return CareGiverTypeEnum.Formal;
        case 2:
            return CareGiverTypeEnum.FormalAndSupport;
        default:
            return "N/A";
    }
}
function bindCareGiverTypeSelection(isformal) {
    if (isformal === '0') {
        $('#rdo_Formal').prop("checked", false);
        $('#rdo_Informal').prop("checked", true);
    }
    else if (isformal === '1') {
        $('#rdo_Formal').prop("checked", true);
        $('#rdo_Informal').prop("checked", false);
    }
    else if (isformal === '2') {
        $('#rdo_Formal').prop("checked", false);
        $('#rdo_Informal').prop("checked", false);
        $('#rdo_FormalNatural').prop("checked", true);
    }
    else {
        // no logic
    }
}
function closeNotesSummary() {
    $(".ai-summary, .fax_overlay, .summarize_FloatNotes").hide();
    $('body').css('overflow', '');
    $("#ai-notes-summary, .summarize_FloatNotes").hide();
    $("#ai-notes-summary").removeClass('ai-summary-focus');
    if ($('.ah-modal:visible').length) {
        $('.ah-modal:visible .ah-btn-close-modal').focus();
    }
    else {
        $('#btnCmNotesAiSmrz').focus();
    }
}

function reloadFaxCount() {
    if (faxRolePermissions()) {
        $.ajax({
            type: 'GET',
            url: baseURL + '/Dashboard/GetFaxCount',
            dataType: 'json',
            success: function (res) {
                for (let i = 0; i < res.length; i++) {
                    $('.faxModuleCount', '#module_' + res[i].ModuleId).text(res[i].Count);
                }
                updateOverAllFaxCount();
            }
        });
    }
}

function faxRolePermissions() {
    var permis = [];
    var roleNameArr = getAllFaxRoleNames();
    if (roleConfig !== null && roleConfig.length !== 0) {
        permis = $.greproleext(roleConfig, function (ele) {
            return (roleNameArr.indexOf(ele.UniqueName) > -1 && ele.IsView);
        });
    }
    return permis[0] && permis[0].IsView;
}
function updateOverAllFaxCount() {
    var totalCount = 0;
    $('#headerFaxMenu ul li.faxModule').each(function () {
        let num = parseInt($(this).find('.faxModuleCount').text());
        if (num >= 0) {
            totalCount += num;
            return true;
        }
        else {
            $('#faxOverallCount').hide();
            return false;
        }
    });
    $('#faxOverallCount').val(totalCount);
}

function getCurrentPatientId() {
    if ($(".InAuthPage").is(":visible")) {
        return window.top.UmPatient_AuthInfo("", "").PatientId;
    }
    else if ($(".InComplaintPage").is(":visible")) {
        return window.top.AgData.complaintInfo().patientId;
    }
    else {
        return $('#selectPatientAccessed').val();
    }
}


function applyFocusTrap(selector) {
    const $p = $(selector);
    if ($p.length === 0) return;

    $p.attr('tabindex', '-1').focus();

    $p.off('keydown.focusTrap').on('keydown.focusTrap', e => {
        if (e.key !== 'Tab') return;

        const f = $p.find('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')
            .filter(':visible');

        if (f.length === 0) return;

        const first = f.first()[0];
        const last = f.last()[0];

        if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
        }
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
        }
    });
}

// Connected App logic starts here
function launchConnectedApp(appCode, gcModuleName) {
    var environmentName = window.location.hostname;
    $.ajax({
        url: baseURL + "/ConnectedApps/GetConnectedAppDetails",
        type: "GET",
        data: {
            appCode: appCode,
            gcModuleName: gcModuleName,
            environmentName: environmentName
        },
        dataType: "json",
        success: function (res) {
            if (!res || res.success !== true) {
                const baseMessage = "Unable to launch the application.";
                const message = res?.message
                    ? `${res.message} - ${baseMessage}`
                    : baseMessage;

                CustomAlert(message);
                return;
            }

            let finalUrl = null;
            
            try {
                // urlConfig may arrive as string or object
                const urlConfig = res.urlConfig
                    ? (typeof res.urlConfig === "string"
                        ? JSON.parse(res.urlConfig)
                        : res.urlConfig)
                    : null;

                if (urlConfig?.LaunchMode === "DYNAMIC") {

                    getDynamicLaunchUrl(urlConfig, function (res) {

                        if (!res.success) {
                            CustomAlert(res.msg || "Unable to launch due to an error.");
                            return;
                        }

                        if (!res.url) {
                            CustomAlert("Final URL is empty");
                            return;
                        }

                        if (!isSafeUrl(res.url)) {
                            CustomAlert("Unsafe URL detected. Cannot launch application.");
                            return;
                        }

                        const win = window.open(res.url, appCode, "width=800,height=600");
                        if (win?.focus) win.focus();
                    });

                    return;
                }
                else if (urlConfig?.UrlTemplate) {
                    finalUrl = buildFinalUrl(urlConfig, res.parameters);
                }
                else if (res.url) {
                    // fallback: treat raw url as template
                    finalUrl = buildFinalUrl({ UrlTemplate: res.url }, res.parameters);
                }
                else {
                    throw new Error("No URL or UrlTemplate provided");
                }

                if (!finalUrl) {
                    throw new Error("Final URL is empty");
                }

                if (!isSafeUrl(finalUrl)) {
                    CustomAlert("Unsafe URL detected. Cannot launch application.");
                    return;
                }

                var windowOptions = "width=800px; height=600px;";
                const win = window.open(finalUrl, appCode, windowOptions);
                if (win && win.focus) win.focus();

            } catch (e) {
                const baseMessage = "Unable to launch due to an error.";
                const message = e?.message
                    ? `${e.message} - ${baseMessage}`
                    : baseMessage;

                CustomAlert(message);
            }
        },
        error: function (xhr) {
            const backendMessage = xhr?.responseJSON?.message || xhr?.responseText;
            const baseMessage = "Failed to load configuration.";
            const message = backendMessage
                ? `${backendMessage} - ${baseMessage}`
                : baseMessage;

            CustomAlert(message);
        }
    });
}

function buildFinalUrl(urlConfigJson, parameters) {
    return resolveUrlTemplate(urlConfigJson, parameters);
}

function resolveUrlTemplate(urlConfigJson, parameters) {
    const config = typeof urlConfigJson === "string"
        ? JSON.parse(urlConfigJson)
        : urlConfigJson;

    if (!config?.UrlTemplate) {
        throw new Error("UrlTemplate missing");
    }

    let url = config.UrlTemplate;

    // fix html encoding
    while (url.includes("&amp;")) {
        url = url.replace(/&amp;/gi, "&");
    }

    const paramMap = new Map();

    if (parameters) {
        parameters.forEach(p => {
            const cfg = JSON.parse(p.parameterConfig || "{}");
            paramMap.set(p.parameterName, cfg);
        });
    }

    let result = "";
    let currentIndex = 0;

    // resolve {} tokens
    while (currentIndex < url.length) {

        if (url[currentIndex] !== "{") {
            result += url[currentIndex++];
            continue;
        }

        let tokenStartIndex = currentIndex;
        let braceDepth = 0;
        let scanIndex = currentIndex;

        while (scanIndex < url.length) {
            if (url[scanIndex] === "{") braceDepth++;
            else if (url[scanIndex] === "}") braceDepth--;
            if (braceDepth === 0) break;
            scanIndex++;
        }

        if (braceDepth !== 0) {
            result += url[currentIndex++];
            continue;
        }

        const innerText = url.substring(tokenStartIndex + 1, scanIndex).trim();

        let matchedCfg = null;
        let tokenPattern = null;

        for (const [, cfg] of paramMap.entries()) {
            if (!cfg.ReplaceToken) continue;

            const pattern = new RegExp("\\{" + cfg.ReplaceToken + "\\}");
            if (pattern.test(innerText)) {
                matchedCfg = cfg;
                tokenPattern = pattern;
                break;
            }
        }

        if (!matchedCfg) {
            currentIndex = scanIndex + 1;
            continue;
        }

        const value = resolveParameterValue(matchedCfg);
        if (value === undefined || value === null) {
            currentIndex = scanIndex + 1;
            continue;
        }

        let finalValue = value;

        // encode only value
        if (matchedCfg.Encoding?.Mode === "VALUE" &&
            matchedCfg.Encoding?.Algorithm === "BASE64") {
            finalValue = btoa(value);
        }

        const resolvedInner = innerText.replace(tokenPattern, finalValue);

        // encode full pair
        if (matchedCfg.Encoding?.Mode === "BLOCK" &&
            matchedCfg.Encoding?.Algorithm === "BASE64") {
            result += btoa(resolvedInner);
        } else {
            result += resolvedInner;
        }

        currentIndex = scanIndex + 1;
    }

    // cleanup
    result = result
        .replace(/\?&+/g, "?")
        .replace(/&+/g, "&")
        .replace(/\?$/, "")
        .replace(/&$/, "");

    // handle [ ] query groups
    result = applyBracketQueryEncoding(result, paramMap);

    return result;
}

function applyBracketQueryEncoding(url, paramMap) {
    return url.replace(/\[(.*?)\]/g, (_, content) => {
        if (!content) return "";

        let shouldEncode = false;

        for (const [, cfg] of paramMap.entries()) {
            if (cfg.Encoding?.Mode === "QUERY") {
                shouldEncode = true;
                break;
            }
        }

        // if not query, just unwrap
        if (!shouldEncode) return content;

        return btoa(content);
    });
}

function resolveParameterValue(config) {

    if (!config || !config.Resolver) {
        return null;
    }
    const r = config.Resolver;

    switch (r.Type) {

        case "UI_VALUE":
            return $("#" + CSS.escape(r.Target)).val();

        case "UI_TEXT":
            return $("#" + CSS.escape(r.Target)).text();

        case "UI_ATTR":
            return $("#" + CSS.escape(r.Target)).attr(r.Args);

        case "JS_VARIABLE":
            return window
                ? window[r.Target]
                : null;

        case "STATIC":
            return r.Target;

        default:
            return null;
    }
}

function getDynamicLaunchUrl(config, callback) {
    let payload = {};

    if (config?.PayloadResolvers) {
        Object.entries(config.PayloadResolvers).forEach(([key, resolver]) => {
            const value = resolveParameterValue({ Resolver: resolver });
            if (value !== null && value !== undefined) {
                payload[key] = value;
            }
        });
    }

    $.ajax({
        type: config.LaunchMethod,
        async: true,
        url: baseURL + config.LaunchApiPath,
        data: payload,
        dataType: "json",
        success: function (res) {
            callback(res);
        },
        error: function () {
            callback({ success: false, url: "", msg: "API call failed" });
        }
    });
}


function isSafeUrl(url) {
    try {
        const parsed = new URL(url, window.location.origin);
        // Only allow http and https protocols
        return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
        return false;
    }
}
// Connected App logic ends here
function convertDateToYMD(dateStr) {
    if (!dateStr) return "";

    // Accept both "/" and "-" as separators
    let parts = dateStr.includes("/") ? dateStr.split("/") : dateStr.split("-");
    if (parts.length !== 3) return dateStr; // return as-is if invalid

    const [month, day, year] = parts;

    // Ensure two-digit month and day
    const mm = month.padStart(2, "0");
    const dd = day.padStart(2, "0");

    return `${year}-${mm}-${dd}`;
}

function isValidDocumentUrl(url) {
    try {
        if (!url || !url.trim().toLowerCase().startsWith('https://')) {
            return false;
        }
        const parsed = new URL(url.trim());
        return parsed.protocol === 'https:';
    } catch {
        return false;
    }
}

function displayDocumentUrls(AccId, urlArray, removeFunctionName) {
    var containerSelector = AccId + " #urlDocListDisplay";
    var $container = $(containerSelector);
    $container.empty();
    var removeFn = window[removeFunctionName];

    $.each(urlArray, function (index, url) {
        var displayUrl = url.length > 50 ? url.substring(0, 50) + '...' : url;

        var $li = $('<li>').attr('title', url).css({ border: '1px solid #ddd', 'background-color': '#f6f6f6', padding: '10px 40px 10px 20px', 'font-size': '12px', display: 'block', 'margin-bottom': '5px', overflow: 'hidden', 'white-space': 'nowrap', 'text-overflow': 'ellipsis', position: 'relative', float: 'none' });
        var $span = $('<span>').text(displayUrl);
        var $btn = $('<button>').attr('type', 'button').addClass('Close').css({ cursor: 'pointer', position: 'absolute', top: '50%', right: '5px', transform: 'translate(0%, -50%)', 'font-size': '16px', padding: '5px', border: 'none', 'background-color': 'transparent', width: '20px', height: '20px' });

        if (typeof removeFn === 'function') {
            $btn.on('click', function () {
                removeFn(index);
            });
        }

        $li.append($span).append($btn);
        $container.append($li);
    });
}

function getHostnameFromUrl(url) {
    try {
        var normalized = url.includes('://') ? url : 'https://' + url;
        return new URL(normalized).hostname;
    } catch (e) {
        return null;
    }
}

async function attachDocumentUrl(inputSelector, urlArray, isEditMode, maxUrls, removeFunctionName, module) {
    var urlInput = $(inputSelector + " #txtDocUrl");
    var urlValue = $.trim(urlInput.val());
    var buttonSelector = $(inputSelector + " #btnUrlDocAttach");

    if (urlValue.length > 2000) {
        CustomAlert('URL cannot exceed 2000 characters.');
        urlInput.val('');
        return false;
    }

    if (!isValidDocumentUrl(urlValue)) {
        CustomAlert('Please enter a valid URL');
        return false;
    }

    if (isEditMode && urlArray.length >= 1) {
        CustomAlert("Only one URL can be attached in edit mode.");
        return false;
    }

    if (!isEditMode && urlArray.length >= maxUrls) {
        CustomAlert("A maximum of " + maxUrls + " URLs can be attached.");
        return false;
    }

    if (jQuery.inArray(urlValue, urlArray) !== -1) {
        CustomAlert('This URL has already been attached.');
        return false;
    }

    var hostname = getHostnameFromUrl(urlValue);

    if (!hostname) {
        CustomAlert('Please enter a valid URL.');
        return false;
    }

    var status = await validateDocumentHostname(urlValue);

    if (status === 'INACTIVE' || status === 'NOT_CONFIGURED') {
        CustomAlert("The selected hostname is either inactive or not configured. Please activate it, add it, or contact the administrator.");
        return false;
    }
    if (status === 'VALID') {

        urlArray.push(urlValue);

        if (module && (module === "CM" || module === "PH")) {
            return true;
        }

        displayDocumentUrls(inputSelector, urlArray, removeFunctionName);
        urlInput.val('');

        if (isEditMode && urlArray.length >= 1 && buttonSelector) {
            urlInput.hide();
            $(buttonSelector).hide();
        }
        return true;
    }

    return false;
}
function validateDocumentHostname(documentUrl) {
    return $.ajax({
        type: "POST",
        url: WebApiUrl + "/ConfigGrid/ValidateDocumentHostname/",
        data: JSON.stringify({ stringParam: documentUrl }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        async: true
    }).then(
        function (data) {
        return (data && data.HostnameStatus) ? data.HostnameStatus : "";
        },
        function (error) {
        console.error('Error validating document hostname:', error);
        return "";
        }
    );
}

//function to check if a string is a URL
function isDocumentUrl(value) {
    if (!value || typeof value !== 'string') {
        return false;
    }
    var lowerValue = value.toLowerCase().trim();
    return lowerValue.indexOf('https://') === 0;
}

function escapeHtmlAttr(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
function setClientSuffix(dataStr) {
    memberSumClientSuffix = "";
    $.ajax({
        type: "POST",
        url: baseURL + "/Admin/GetAdminClientEditView",
        dataType: "json",
        async: false,
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(dataStr),
        success: function (data) {
            if (data && data.list && data.list.length > 0 && data.list[0].ClientSuffix) {
                memberSumClientSuffix = data.list[0].ClientSuffix;
            }
        },
    });
}
function setMemberAdditionalDetails(dataStr) {
    memberAdditionalDetails = "";
    if (dataStr.patient_id > 0) {
        $.ajax({
            type: "GET",
            url: baseURL + "/Member/GetMemberAdditionalDetail",
            dataType: "json",
            async: false,
            data: dataStr,
            success: function (data) {
                if (data.success && !$.fn.isNullOrEmpty(data.result) && data.result.split("-").length > 5) {
                    memberAdditionalDetails = data.result.split("-")[5];
                }
            },
        });
    }
}
